
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("2WNCY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("f2M3o")).VersionDetailSpa);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $f2M3o = parcelRequire("f2M3o");

});
parcelRegister("f2M3o", function(module, exports) {

$parcel$export(module.exports, "VersionDetailSpa", () => $fe2055dca29e8a0e$export$4232c14770c47725);

var $5uXOq = parcelRequire("5uXOq");

var $c2D8L = parcelRequire("c2D8L");

var $gEFwt = parcelRequire("gEFwt");

var $7CMCs = parcelRequire("7CMCs");

var $koVbs = parcelRequire("koVbs");

var $dAfqg = parcelRequire("dAfqg");

var $ao2h1 = parcelRequire("ao2h1");

var $kt0pG = parcelRequire("kt0pG");

var $ciNdQ = parcelRequire("ciNdQ");

var $9id9B = parcelRequire("9id9B");

var $9dbF6 = parcelRequire("9dbF6");

var $9NiTW = parcelRequire("9NiTW");

var $doZTA = parcelRequire("doZTA");

var $b6w0L = parcelRequire("b6w0L");

var $49dAD = parcelRequire("49dAD");
const $fe2055dca29e8a0e$export$4232c14770c47725 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ match: match }] = (0, $doZTA.useRouter)();
    const projectKey = match.params.projectKey ?? '';
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const onExperienceFail = (0, $ciNdQ.useViewVersionDetailsPageExperienceFail)();
    const { queryReference: queryReference } = (0, $ao2h1.useRelayResource)((0, $kt0pG.versionDetailsRelayResourceCustom));
    const releasesHomeUrl = `/projects/${projectKey}?selectedItem=com.atlassian.jira.jira-projects-plugin%3Arelease-page`;
    // Note: "the no Software license" case is handled by a redirect within `VersionDetailPage`
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ciNdQ.VersionDetailsPageExperienceStart), {
        experienceId: projectKey
    }), queryReference === null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "pageContent",
        packageName: "jiraSpaAppsSoftwareReleasesVersionDetails",
        teamName: "nova",
        extraEventData: {
            isSimplifiedProject: projectContext?.simplified ?? false
        },
        onError: (location, error)=>{
            onExperienceFail(location, error, {
                isNetworkError: (0, $49dAD.isNetworkError)(error)
            });
        },
        attributes: (error)=>({
                isNetworkError: (0, $49dAD.isNetworkError)(error),
                isSimplifiedProject: projectContext?.simplified ?? false
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "software"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEFwt.default), {
        baseUrl: "",
        projectKey: projectKey,
        projectName: projectContext?.projectName ?? ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            text: formatMessage((0, $b6w0L.default).releases),
            href: releasesHomeUrl
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9id9B.VersionDetail), {
        queryReference: queryReference
    }))))));
};

});
parcelRegister("ciNdQ", function(module, exports) {

$parcel$export(module.exports, "VersionDetailsPageExperienceStart", () => $95ce09624273b9e6$export$87a9bc4e7a50039a);
$parcel$export(module.exports, "useViewVersionDetailsPageExperienceFail", () => $95ce09624273b9e6$export$f9fb921f60393679);
$parcel$export(module.exports, "ViewVersionDetailsPageExpectedErrorExperienceSuccessTracker", () => $95ce09624273b9e6$export$c2bfafdc422ffc0a);

var $5uXOq = parcelRequire("5uXOq");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $efvDm = parcelRequire("efvDm");

var $k9JTq = parcelRequire("k9JTq");

var $kL4o0 = parcelRequire("kL4o0");
const $95ce09624273b9e6$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME = 'viewVersionDetailsPage';
const $95ce09624273b9e6$export$87a9bc4e7a50039a = ({ experienceId: experienceId })=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kaHBi.ExperienceStart), {
        experienceId: experienceId,
        experience: $95ce09624273b9e6$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME,
        analyticsSource: "versionDetails",
        edition: appEditions.software,
        application: (0, $efvDm.JIRA_SOFTWARE)
    });
};
const $95ce09624273b9e6$export$f9fb921f60393679 = ()=>(0, $93jKl.useExperienceFail)({
        experience: $95ce09624273b9e6$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME
    });
const $95ce09624273b9e6$export$1a84e8ad118354e4 = ()=>(0, $3bQtK.useExperienceSuccess)({
        experience: $95ce09624273b9e6$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME
    });
const $95ce09624273b9e6$export$c2bfafdc422ffc0a = ({ reason: reason })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: $95ce09624273b9e6$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME,
        attributes: {
            reason: reason
        }
    });
const $95ce09624273b9e6$export$ab0e4c71ad46eacd = ()=>{
    const projectInfo = (0, $kL4o0.useProjectAnalyticsAttributes)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: $95ce09624273b9e6$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME,
        attributes: {
            ...projectInfo
        }
    });
};

});
parcelRegister("kL4o0", function(module, exports) {

$parcel$export(module.exports, "useProjectContextResource", () => $1b87a11fa464d7a3$export$a3138047c831fa4e);
$parcel$export(module.exports, "useProjectContext", () => $1b87a11fa464d7a3$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useProjectAnalyticsAttributes", () => $1b87a11fa464d7a3$export$b6a91b2d78273787);

var $kUACW = parcelRequire("kUACW");

var $dxCvy = parcelRequire("dxCvy");

var $g5X3G = parcelRequire("g5X3G");

var $2YP9W = parcelRequire("2YP9W");
const $1b87a11fa464d7a3$export$a3138047c831fa4e = (0, $kUACW.withSuspense)(()=>(0, $2YP9W.useResource)((0, $dxCvy.projectContextResource)));
const $1b87a11fa464d7a3$export$8f31c2503e1efa93 = ()=>{
    const { data: data, error: error } = $1b87a11fa464d7a3$export$a3138047c831fa4e();
    if (data == null) throw new Error(`data of useProjectContext via withSuspense shouldn't be null. If projectContext is null, this means an invalid project key was provided and the page should return a 404 and useProjectContext should never be called. error: ${error !== null ? error.message : 'null'}`);
    return {
        ...data,
        projectKey: (0, $g5X3G.toProjectKey)(data.projectKey),
        projectId: (0, $g5X3G.toProjectId)(data.projectId.toString())
    };
};
const $1b87a11fa464d7a3$export$b6a91b2d78273787 = ()=>{
    const { projectId: projectId, isProjectAdmin: isProjectAdmin, simplified: simplified } = $1b87a11fa464d7a3$export$8f31c2503e1efa93();
    return {
        isSimplified: simplified,
        isProjectAdmin: isProjectAdmin,
        projectId: projectId
    };
};

});
parcelRegister("kUACW", function(module, exports) {

$parcel$export(module.exports, "withSuspense", () => $4c5a941fc6e9229e$export$a3bce93d4fb4eda6);
const $4c5a941fc6e9229e$var$isDataEmpty = (data)=>data == null;
function $4c5a941fc6e9229e$export$a3bce93d4fb4eda6(theHook) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (...args)=>{
        const result = theHook(...args);
        if (!false && $4c5a941fc6e9229e$var$isDataEmpty(result.data) && result.loading) throw result.promise;
        return result;
    };
}

});



parcelRegister("9id9B", function(module, exports) {

$parcel$export(module.exports, "VersionDetail", () => $971a1d1547e83ef9$export$7ef104a5ca9287b8);

var $fl8Ey = parcelRequire("fl8Ey");

var $kCzfF = parcelRequire("kCzfF");

var $eRSB5 = parcelRequire("eRSB5");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $gwIPs = parcelRequire("gwIPs");

var $beRD7 = parcelRequire("beRD7");

var $jcw0u = parcelRequire("jcw0u");

var $id7K0 = parcelRequire("id7K0");

var $koVbs = parcelRequire("koVbs");

var $1othz = parcelRequire("1othz");

var $lfTZh = parcelRequire("lfTZh");

var $dXq4S = parcelRequire("dXq4S");

var $jDrwg = parcelRequire("jDrwg");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $btxzI = parcelRequire("btxzI");

var $ajHh6 = parcelRequire("ajHh6");

var $4UYYD = parcelRequire("4UYYD");

var $8qTNX = parcelRequire("8qTNX");

var $kfztd = parcelRequire("kfztd");

var $93kRE = parcelRequire("93kRE");

var $jX1s1 = parcelRequire("jX1s1");

var $ip4R1 = parcelRequire("ip4R1");

var $4c6NH = parcelRequire("4c6NH");

var $2vbty = parcelRequire("2vbty");

var $906xX = parcelRequire("906xX");

var $bUxbm = parcelRequire("bUxbm");

var $3hn4w = parcelRequire("3hn4w");

var $20fNh = parcelRequire("20fNh");

var $dLRv1 = parcelRequire("dLRv1");

var $kKpgF = parcelRequire("kKpgF");

var $fWb7u = parcelRequire("fWb7u");

var $4MIM1 = parcelRequire("4MIM1");

var $cXbjp = parcelRequire("cXbjp");

var $iMhWR = parcelRequire("iMhWR");

var $koeKL = parcelRequire("koeKL");

var $g3ebu = parcelRequire("g3ebu");

var $fCXaV = parcelRequire("fCXaV");

var $gpsfL = parcelRequire("gpsfL");

var $lODMY = parcelRequire("lODMY");
var $bmKPg = parcelRequire("bmKPg");

var $3HwlS = parcelRequire("3HwlS");

var $kHzKl = parcelRequire("kHzKl");

var $gl1Tm = parcelRequire("gl1Tm");

var $47ffb = parcelRequire("47ffb");

var $ciNdQ = parcelRequire("ciNdQ");

var $kL4o0 = parcelRequire("kL4o0");

var $lryuo = parcelRequire("lryuo");

var $jpznh = parcelRequire("jpznh");

var $fs1tp = parcelRequire("fs1tp");

var $6rc5u = parcelRequire("6rc5u");

var $dcsLh = parcelRequire("dcsLh");
const $971a1d1547e83ef9$var$getVersionIdState = (versionId)=>{
    const correctedVersionId = versionId.replace(/\D/g, ''); // non-numeric version id is invalid
    if (correctedVersionId.length === 0) return {
        state: 'INVALID'
    };
     // numeric version id that has been pruned of non-numeric characters
    if (correctedVersionId.length !== versionId.length) return {
        state: 'CORRECTED',
        correctedVersionId: correctedVersionId
    };
    return {
        state: 'VALID'
    };
};
const $971a1d1547e83ef9$export$d5910e6123a77411 = ({ jiraVersion: jiraVersion, devOps: devOps })=>{
    const [state] = (0, $2vbty.useSidebarStore)();
    const cloudId = (0, $koeKL.useCloudId)();
    const [designQueryRef, loadDesignQuery] = (0, $8Uumt.useQueryLoader)((0, $4UYYD.default));
    const [relatedWorkQueryRef, loadRelatedWorkQuery] = (0, $8Uumt.useQueryLoader)((0, $ajHh6.default));
    const [versionProgressQueryRef, loadVersionProgressQuery] = (0, $8Uumt.useQueryLoader)((0, $btxzI.default));
    const onViewRelatedWorkExperienceFail = (0, $fWb7u.useViewVersionRelatedWorkExperienceFail)();
    const onLaunchCardExperienceFail = (0, $bUxbm.useLaunchCardExperienceFail)();
    const onVersionApproversCardExperienceFail = (0, $ip4R1.useVersionApproversCardExperienceFail)();
    const onIssueAssociatedDesignsExperienceFail = (0, $g3ebu.useIssueAssociatedDesignsExperienceFail)();
    const { currentTabId: currentTabId } = (0, $47ffb.useCurrentTab)();
    const devOpsData = (0, $8Uumt.useFragment)((0, $eRSB5.default), devOps);
    const [version, refetch] = (0, $8Uumt.useRefetchableFragment)((0, $kCzfF.default), jiraVersion);
    const designProviderLength = (devOpsData?.providers?.designProviders ?? []).length; // Designs and its associated issues query is expensive, so we load it lazily not as a part of initial query.
    // Likewise with related work items (which the progress section also accesses).
    (0, $5uXOq.useEffect)(()=>{
        if (designProviderLength > 0 && designQueryRef == null) {
            loadDesignQuery({
                versionAri: version.id,
                cloudAri: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira',
                    resourceType: 'site',
                    resourceId: cloudId
                })
            });
            loadRelatedWorkQuery({
                versionAri: version.id,
                isDevopsFeatureDisabledInFedRamp: (0, $kfztd.isDevopsFeatureDisabledInFedRamp)()
            });
            loadVersionProgressQuery({
                versionAri: version.id,
                isDevopsFeatureDisabledInFedRamp: (0, $kfztd.isDevopsFeatureDisabledInFedRamp)()
            });
        }
    }, [
        cloudId,
        designProviderLength,
        designQueryRef,
        loadDesignQuery,
        loadRelatedWorkQuery,
        loadVersionProgressQuery,
        version.id
    ]);
    const { filters: filters, sortBy: sortBy } = (0, $20fNh.useVersionIssuesGraphQLVariables)();
    const [suspenselessRefetch, isRefetchLoading] = (0, $1othz.useSuspenselessRefetch)((0, $8qTNX.default), refetch, {
        fetchPolicy: 'network-only'
    });
    const [debouncedRefetchVersion] = (0, $jDrwg.default)(()=>{
        suspenselessRefetch({
            id: version.id,
            isDevopsFeatureDisabledInFedRamp: (0, $kfztd.isDevopsFeatureDisabledInFedRamp)(),
            shouldIncludeDevOpsFieldsViaAgs: !(0, $kfztd.isDevopsFeatureDisabledInFedRamp)(),
            ...(0, $gl1Tm.convertTabToQueryVariables)(currentTabId),
            filters: filters,
            sortBy: sortBy
        });
    }, 500); // From spa-routes, cannot import the original const due to cyclical imports
    const ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_EMBED = 'software-version-detail-embed';
    const isEmbedRoute = (0, $lODMY.useIsActiveRoute)(ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_EMBED);
    const isIssueClosed = state.status === 'CLOSED';
    const isIssueSectionCollapsed = (version.collapsedUis ?? []).includes('ISSUES');
    const issueListFooterRef = (0, $5uXOq.useRef)(null);
    const [isIssueListFooterPinned, setIsIssueListFooterPinned] = (0, $5uXOq.useState)(false);
    const handleScroll = ()=>{
        const issueListFooter = issueListFooterRef.current;
        if (issueListFooter) {
            const footerRect = issueListFooter.getBoundingClientRect(); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            setIsIssueListFooterPinned(footerRect.top + footerRect.height >= window.innerHeight);
        }
    };
    const issueListContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($971a1d1547e83ef9$var$IssueListMinHeightContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dLRv1.IssueListWithHeaderWithErrorBoundary), {
        jiraVersion: version
    }), !isIssueSectionCollapsed && version?.canAddAndRemoveIssues && version?.allIssues?.totalCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kHzKl.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "addIssuesToVersion"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($971a1d1547e83ef9$var$IssueListFooterContentWrapper, {
        isPinned: isIssueListFooterPinned,
        ref: issueListFooterRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jX1s1.AddIssuesToVersion), {
        appearance: "subtle",
        isIssueListFooterButton: true,
        jiraVersion: version,
        showIcon: true
    }))) : null);
    const shouldRenderDesignSection = !(0, $kfztd.isDevopsFeatureDisabledInFedRamp)() && designProviderLength > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($971a1d1547e83ef9$var$VersionDetailsWrapper, {
        isIssueClosed: isIssueClosed,
        onScroll: handleScroll
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kKpgF.RefetchContext).Provider, {
        value: {
            isLoading: isRefetchLoading,
            refetch: debouncedRefetchVersion
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUxbm.LaunchCardExperienceStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($971a1d1547e83ef9$var$ContainerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            (0, $3HwlS.getWillShowNav4)() ? "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9gktf _19bv1tcg _u5f31tcg _1reo15vq _18m91wug" : "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9gktf _19bvzwfg _u5f31tcg _1reo15vq _18m91wug"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fs1tp.Header), {
        jiraVersion: version,
        shouldShowBreadcrumbs: !isEmbedRoute,
        shouldShowAutomationButton: !isEmbedRoute,
        shouldShowFeedbackButton: !isEmbedRoute,
        shouldShowGraphButton: !isEmbedRoute
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kHzKl.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "richTextSection"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMhWR.AsyncVersionRichTextSection), {
        jiraVersion: version
    })), !(0, $kfztd.isDevopsFeatureDisabledInFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kHzKl.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "relatedWork",
        onError: onViewRelatedWorkExperienceFail
    }, relatedWorkQueryRef == null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cXbjp.RelatedWorkLoadingSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jira-releases-version-details-related-work",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cXbjp.RelatedWorkLoadingSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4MIM1.RelatedWork), {
        queryRef: relatedWorkQueryRef
    }))), shouldRenderDesignSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kHzKl.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "issueAssociatedDesigns",
        onError: onIssueAssociatedDesignsExperienceFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g3ebu.IssueAssociatedDesignsExperienceStart), null), designQueryRef == null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fCXaV.DesignSectionSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jira-releases-version-details-designs",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fCXaV.DesignSectionSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fCXaV.IssueAssociatedDesigns), {
        queryRef: designQueryRef
    }))), issueListContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dcsLh.RightSidebar), {
        jiraVersion: version
    }, isIssueClosed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kHzKl.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "launchCard",
        onError: onLaunchCardExperienceFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($971a1d1547e83ef9$var$SidebarCard, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3hn4w.LaunchCard), {
        jiraVersion: version
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kHzKl.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "approversCard",
        onError: onVersionApproversCardExperienceFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ip4R1.VersionApproversCardExperienceStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($971a1d1547e83ef9$var$SidebarCard, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4c6NH.Approvers), {
        jiraVersion: version
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kHzKl.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "progressCard"
    }, versionProgressQueryRef != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($971a1d1547e83ef9$var$SidebarCard, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jira-releases-version-details-progress-indicator",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gpsfL.VersionProgress), {
        queryRef: versionProgressQueryRef
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kHzKl.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "issueSidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $906xX.IssueSidebar), null))))));
};
const $971a1d1547e83ef9$export$7ef104a5ca9287b8 = ({ queryReference: queryReference })=>{
    const hasFiredErrorAnalytics = (0, $5uXOq.useRef)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: projectContext } = (0, $kL4o0.useProjectContextResource)();
    const { jira: jira, devOps: devOps } = (0, $8Uumt.usePreloadedQuery)((0, $fl8Ey.default), queryReference);
    const [versionId, setVersionId] = (0, $bmKPg.usePathParam)('versionId'); // replaces invalid non-numeric version ids from the url params.
    // the query data is still valid as the same regex is applied in the versionDetailsResource.
    // if the version id is invalid then fire off an error analytic.
    (0, $5uXOq.useEffect)(()=>{
        if (versionId != null) {
            const versionIdState = $971a1d1547e83ef9$var$getVersionIdState(versionId);
            if (versionIdState.state === 'CORRECTED') setVersionId(versionIdState.correctedVersionId, 'replace');
            if (versionIdState.state === 'INVALID' && !hasFiredErrorAnalytics.current) {
                (0, $jcw0u.default)({
                    meta: {
                        id: 'jira.releases.version.detail.invalid.version.id',
                        packageName: 'jiraSoftwareReleasesVersionDetail',
                        teamName: 'nova'
                    },
                    error: Error(`Invalid version id in path param. Version id: ${String(versionId)}`),
                    sendToPrivacyUnsafeSplunk: true
                });
                hasFiredErrorAnalytics.current = true;
            }
        }
    }, [
        setVersionId,
        versionId
    ]); // missing project context means invalid project key in path param
    if (projectContext == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.NotFoundErrorPageAsync), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ciNdQ.ViewVersionDetailsPageExpectedErrorExperienceSuccessTracker), {
        reason: "No Project found"
    }));
     // missing jira value due to invalid non-digit version id in path param
    // causing relay to skip query to avoid invalid ari error in AGG
    if (!jira && versionId != null && $971a1d1547e83ef9$var$getVersionIdState(versionId).state === 'INVALID') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.NotFoundErrorPageAsync), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ciNdQ.ViewVersionDetailsPageExpectedErrorExperienceSuccessTracker), {
        reason: "No Version found"
    }));
     // unknown error
    if (!jira) throw Error("Relay: Missing @required value at path 'jira' in 'uiVersionDetailsQuery'"); // mimics the Relay @required directive
    const { version: version } = jira; // received query error graphql type
    // e.g. permissions error or version not found error
    if (version.__typename !== 'JiraVersion') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.NotFoundErrorPageAsync), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ciNdQ.ViewVersionDetailsPageExpectedErrorExperienceSuccessTracker), {
        reason: "No Version found"
    }));
    const { simplified: simplified, isProjectAdmin: isProjectAdmin, projectId: projectId, projectKey: projectKey, projectName: projectName } = projectContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jpznh.AccessCheck), {
        jiraVersion: version
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            simplified: simplified,
            isProjectAdmin: isProjectAdmin,
            projectId: projectId,
            versionStatus: version.status
        },
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "versionDetails"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lryuo.PerformanceTracker), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fWb7u.VersionRelatedWorkExperienceStart), {
        experienceId: projectKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $93kRE.ViewFeatureFlagsEmptyStateExperienceExperienceStart), {
        experienceId: projectKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($971a1d1547e83ef9$export$d5910e6123a77411, {
        jiraVersion: version,
        devOps: devOps ?? null
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $6rc5u.default).browserTitle, {
            projectName: projectName,
            versionName: version.name
        })
    })));
};
const $971a1d1547e83ef9$var$ISSUE_HEADER_AND_FILTERS_SECTION_OFFSET = (0, $gwIPs.gridSize) * 14.75;
const $971a1d1547e83ef9$var$LEFT_CONTAINER_MIN_WIDTH = 20; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $971a1d1547e83ef9$var$ContainerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _kqswh2mm _1reo15vq _c71l1osq _4t3i1osq _18m915vq",
            __cmplp.className
        ])
    });
});
const $971a1d1547e83ef9$var$mainContentContainerStylesOld = null;
const $971a1d1547e83ef9$var$mainContentContainerStylesNew = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $971a1d1547e83ef9$var$IssueListMinHeightContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1tke1aj4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $971a1d1547e83ef9$var$VersionDetailsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isIssueClosed: isIssueClosed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_c71l1osq _4t3i1osq _1e0c1txw _2lx21bp4",
            __cmplp.isIssueClosed ? "_1reo1wug _18m91wug" : "_1reoewfl _18m9ewfl",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $971a1d1547e83ef9$var$SidebarCard = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _189et94y _1dqonqa1 _1h6dmuej",
            __cmplp.className
        ])
    });
});
const $971a1d1547e83ef9$var$IssueListFooterContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isPinned: isPinned, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhk5w2r _94n5idpf _1e0c1txw _2lx21bp4 _4t3it9kd _1bah1h6o _kqsw1if8 _1bsb1osq",
            __cmplp.isPinned ? "_x3dozgxb" : "_x3doglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fl8Ey", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dc798c18cd35135$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<55bb5ec3216ef79e9953390af5e61552>>
 * @relayHash 3c2963a896f9ac591f5fb2936c1ded83
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 351c38d4204be4347504920dc67489a9b231b37872183d43398f22a7a61e6236

var $eiowN = parcelRequire("eiowN");
const $2dc798c18cd35135$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filters"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDevopsFeatureDisabledInFedRamp"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldIncludeDevOpsFieldsViaAgs"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skip"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionAri"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionAri"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "status"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "kind": "ScalarField",
        "name": "collapsedUis"
    }, v13 = {
        "kind": "Literal",
        "name": "filter",
        "value": "ALL"
    }, v14 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v15 = [
        v14 /*: any*/ 
    ], v16 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v17 = {
        "kind": "ScalarField",
        "name": "key"
    }, v18 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v19 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v20 = {
        "kind": "ScalarField",
        "name": "description"
    }, v21 = [
        v13 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        {
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy"
        }
    ], v22 = {
        "kind": "ScalarField",
        "name": "count"
    }, v23 = {
        "kind": "ScalarField",
        "name": "state"
    }, v24 = {
        "concreteType": "DevOpsSummarisedBuildState",
        "kind": "LinkedField",
        "name": "buildStates",
        "plural": true,
        "selections": [
            v23 /*: any*/ ,
            v22 /*: any*/ 
        ]
    }, v25 = [
        v22 /*: any*/ 
    ], v26 = {
        "kind": "ScalarField",
        "name": "title"
    }, v27 = [
        v22 /*: any*/ ,
        v11 /*: any*/ 
    ], v28 = {
        "concreteType": "DevOpsSummarisedDeployments",
        "kind": "LinkedField",
        "name": "summarisedDeployments",
        "plural": false,
        "selections": v27 /*: any*/ 
    }, v29 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v30 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v31 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v32 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiVersionDetailsQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_devOps"
                        }
                    ]
                },
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v7 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion"
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "accessCheck_softwareReleasesVersionDetail"
                                                        }
                                                    ],
                                                    "type": "JiraVersion"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.version"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiVersionDetailsQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isDevopsFeatureDisabledInFedRamp",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "cloudAri"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "providerTypes",
                                            "value": [
                                                "DESIGN"
                                            ]
                                        }
                                    ],
                                    "concreteType": "DevOpsProviders",
                                    "kind": "LinkedField",
                                    "name": "providers",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "DevOpsDesignProvider",
                                            "kind": "LinkedField",
                                            "name": "designProviders",
                                            "plural": true,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v7 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canAddAndRemoveIssues"
                                                },
                                                v12 /*: any*/ ,
                                                {
                                                    "alias": "allIssues",
                                                    "args": [
                                                        v13 /*: any*/ 
                                                    ],
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": v15 /*: any*/ ,
                                                    "storageKey": "issues(filter:\"ALL\")"
                                                },
                                                v16 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "releaseDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "versionId"
                                                },
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cloudId"
                                                        },
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "filter",
                                                                    "value": {
                                                                        "maxHierarchyLevel": 1,
                                                                        "minHierarchyLevel": 1
                                                                    }
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueTypeConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypes",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueTypeEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "hierarchy",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v9 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v11 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "issueTypes(filter:{\"maxHierarchyLevel\":1,\"minHierarchyLevel\":1})"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectStyle"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraVersionDriverResult",
                                                    "kind": "LinkedField",
                                                    "name": "driverData",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "driver",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                v18 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                v19 /*: any*/ ,
                                                                v11 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "QueryError",
                                                            "kind": "LinkedField",
                                                            "name": "queryError",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "message"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v20 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraVersionWarningConfig",
                                                    "kind": "LinkedField",
                                                    "name": "warningConfig",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "openPullRequest"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "openReview"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "unreviewedCode"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "failingBuild"
                                                        },
                                                        v16 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraVersionConnectAddonIframeData",
                                                    "kind": "LinkedField",
                                                    "name": "connectAddonIframeData",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "appKey"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "moduleKey"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "appName"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "location"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "options"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canViewDevTools"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "versionIssueTableHiddenColumns"
                                                },
                                                {
                                                    "alias": "issuesForList",
                                                    "args": v21 /*: any*/ ,
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "jql"
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "ids",
                                                                                    "value": [
                                                                                        "priority",
                                                                                        "summary",
                                                                                        "assignee",
                                                                                        "status",
                                                                                        "issuetype"
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldsById",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v8 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "fieldId"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatus",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "status",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "statusCategory",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "statusCategoryId"
                                                                                                                        },
                                                                                                                        v11 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v11 /*: any*/ ,
                                                                                                                v9 /*: any*/ ,
                                                                                                                v20 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraStatusField"
                                                                                                },
                                                                                                v11 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "user",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v8 /*: any*/ ,
                                                                                                                v19 /*: any*/ ,
                                                                                                                v9 /*: any*/ ,
                                                                                                                v11 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "text"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v9 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "avatar",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "xsmall"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v11 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraPriority",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "priority",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v9 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "iconUrl"
                                                                                                                },
                                                                                                                v11 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraPriorityField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "issueId"
                                                                        },
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedFeatureFlags",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedFeatureFlags",
                                                                            "plural": false,
                                                                            "selections": v15 /*: any*/ 
                                                                        },
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "condition": "isDevopsFeatureDisabledInFedRamp",
                                                                            "kind": "Condition",
                                                                            "passingValue": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedEntities",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "devOpsSummarisedEntities",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "DevOpsSummarisedDeployments",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "summarisedDeployments",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v22 /*: any*/ ,
                                                                                                v11 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "deploymentState"
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "DevOpsEnvironment",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "deploymentEnvironment",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "category"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "DevOpsSummarisedBuilds",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "summarisedBuilds",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v22 /*: any*/ ,
                                                                                                v11 /*: any*/ ,
                                                                                                v24 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueDevSummaryResult",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "devSummaryCache",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "devSummary",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "pullrequest",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssuePullRequestDevSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "overall",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                v23 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "branch",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueBranchDevSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "overall",
                                                                                                            "plural": false,
                                                                                                            "selections": v25 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "review",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueReviewDevSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "overall",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                v23 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "lastUpdated"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "stateCount"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueDevSummaryByProvider",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "summaryByProvider",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "providerId"
                                                                                                                },
                                                                                                                v9 /*: any*/ ,
                                                                                                                v22 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "commit",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueCommitDevSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "overall",
                                                                                                            "plural": false,
                                                                                                            "selections": v25 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "build",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueBuildDevSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "overall",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "failedBuildCount"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "successfulBuildCount"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "unknownBuildCount"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "deploymentEnvironments",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "overall",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueDeploymentEnvironment",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "topEnvironments",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedFeatureFlags",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "summarisedFeatureFlags",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "mostRelevantDisplayName"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "mostRelevantEnabled"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "mostRelevantRolloutPercentage"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        v28 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "DevOpsSummarisedBuilds",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "summarisedBuilds",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v24 /*: any*/ ,
                                                                                                v22 /*: any*/ ,
                                                                                                v11 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                v28 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedBuilds",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "summarisedBuilds",
                                                                                    "plural": false,
                                                                                    "selections": v27 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v29 /*: any*/ 
                                                            ]
                                                        },
                                                        v30 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "alias": "issuesForList",
                                                    "args": v21 /*: any*/ ,
                                                    "filters": [
                                                        "filter",
                                                        "sortBy",
                                                        "filters"
                                                    ],
                                                    "handle": "connection",
                                                    "key": "ListVersion_issuesForList",
                                                    "kind": "LinkedHandle",
                                                    "name": "issues"
                                                },
                                                {
                                                    "alias": "allIssuesRedesignTemp",
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": v15 /*: any*/ 
                                                },
                                                v12 /*: any*/ ,
                                                {
                                                    "args": v31 /*: any*/ ,
                                                    "concreteType": "JiraVersionApproverConnection",
                                                    "kind": "LinkedField",
                                                    "name": "approvers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersionApproverEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersionApprover",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "user",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "AtlassianAccountUserExtendedProfile",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "extendedProfile",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "jobTitle"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "AtlassianAccountUser"
                                                                                },
                                                                                v11 /*: any*/ ,
                                                                                v18 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v10 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "declineReason"
                                                                        },
                                                                        v20 /*: any*/ ,
                                                                        v32 /*: any*/ ,
                                                                        v8 /*: any*/ 
                                                                    ]
                                                                },
                                                                v29 /*: any*/ 
                                                            ]
                                                        },
                                                        v30 /*: any*/ 
                                                    ],
                                                    "storageKey": "approvers(first:100)"
                                                },
                                                {
                                                    "args": v31 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "version_approvers",
                                                    "kind": "LinkedHandle",
                                                    "name": "approvers"
                                                },
                                                {
                                                    "concreteType": "JiraVersionRichTextSection",
                                                    "kind": "LinkedField",
                                                    "name": "richTextSection",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraADF",
                                                            "kind": "LinkedField",
                                                            "name": "content",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "json"
                                                                }
                                                            ]
                                                        },
                                                        v26 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canViewVersionDetailsPage"
                                                },
                                                {
                                                    "condition": "isDevopsFeatureDisabledInFedRamp",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsSummarisedEntities",
                                                            "kind": "LinkedField",
                                                            "name": "devOpsSummarisedEntities",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsProviders",
                                                                    "kind": "LinkedField",
                                                                    "name": "providers",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "DevOpsFeatureFlagProvider",
                                                                            "kind": "LinkedField",
                                                                            "name": "featureFlagProviders",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                v11 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "createFeatureFlagTemplateUrl"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "connectFeatureFlagTemplateUrl"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "logoUrl"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v32 /*: any*/ 
                                            ],
                                            "type": "JiraVersion"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v11 /*: any*/ 
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "351c38d4204be4347504920dc67489a9b231b37872183d43398f22a7a61e6236",
            "metadata": {},
            "name": "uiVersionDetailsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2dc798c18cd35135$var$node.hash = "ecff0899e38f1db871d5c88fd51da16f";
(0, $eiowN.PreloadableQueryRegistry).set($2dc798c18cd35135$var$node.params.id, $2dc798c18cd35135$var$node);
var $2dc798c18cd35135$export$2e2bcd8739ae039 = $2dc798c18cd35135$var$node;

});

parcelRegister("kCzfF", function(module, exports) {

$parcel$export(module.exports, "default", () => $27d857720731a78f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a5b2271b293581a9e8bb11c08ccddb87>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $8qTNX = parcelRequire("8qTNX");
const $27d857720731a78f$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "filters"
        },
        {
            "kind": "RootArgument",
            "name": "isDevopsFeatureDisabledInFedRamp"
        },
        {
            "kind": "RootArgument",
            "name": "shouldIncludeDevOpsFieldsViaAgs"
        },
        {
            "kind": "RootArgument",
            "name": "sortBy"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [
                "node"
            ],
            "operation": (0, $8qTNX.default),
            "identifierInfo": {
                "identifierField": "id",
                "identifierQueryVariableName": "id"
            }
        }
    },
    "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "canAddAndRemoveIssues"
        },
        {
            "kind": "ScalarField",
            "name": "collapsedUis"
        },
        {
            "alias": "allIssues",
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": "ALL"
                }
            ],
            "concreteType": "JiraIssueConnection",
            "kind": "LinkedField",
            "name": "issues",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                }
            ],
            "storageKey": "issues(filter:\"ALL\")"
        },
        {
            "kind": "FragmentSpread",
            "name": "async_softwareReleasesLaunchCard_LaunchCard"
        },
        {
            "kind": "FragmentSpread",
            "name": "header_softwareReleasesVersionDetail"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesAddIssuesToVersion_AddIssuesToVersion"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionDetailIssueList_IssueListWithHeaderWithErrorBoundary_jiraVersion"
        },
        {
            "kind": "FragmentSpread",
            "name": "async_softwareReleasesApprovers_Approvers"
        },
        {
            "kind": "FragmentSpread",
            "name": "rightSidebar_softwareReleasesVersionDetail"
        },
        {
            "kind": "FragmentSpread",
            "name": "async_softwareReleasesVersionRichTextSection_AsyncVersionRichTextSection"
        }
    ],
    "type": "JiraVersion"
};
$27d857720731a78f$var$node.hash = "18efada2730a05c083b285addf6cb338";
var $27d857720731a78f$export$2e2bcd8739ae039 = $27d857720731a78f$var$node;

});
parcelRegister("8qTNX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b84c6917019bd5ee$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dc04afb2ebee1b66ffe31f8b148311f3>>
 * @relayHash d9893edf8caf7d2d1b2b041b4885bd6d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7138bebed4e5923528c4c74087e0a2be85d0fcb4905c03b118ddd4d71d2ea482
const $b84c6917019bd5ee$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filters"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDevopsFeatureDisabledInFedRamp"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldIncludeDevOpsFieldsViaAgs"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "collapsedUis"
    }, v9 = {
        "kind": "Literal",
        "name": "filter",
        "value": "ALL"
    }, v10 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v11 = [
        v10 /*: any*/ 
    ], v12 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v13 = {
        "kind": "ScalarField",
        "name": "status"
    }, v14 = {
        "kind": "ScalarField",
        "name": "key"
    }, v15 = {
        "kind": "ScalarField",
        "name": "name"
    }, v16 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v17 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v18 = {
        "kind": "ScalarField",
        "name": "description"
    }, v19 = [
        v9 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        {
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy"
        }
    ], v20 = {
        "kind": "ScalarField",
        "name": "count"
    }, v21 = {
        "kind": "ScalarField",
        "name": "state"
    }, v22 = {
        "concreteType": "DevOpsSummarisedBuildState",
        "kind": "LinkedField",
        "name": "buildStates",
        "plural": true,
        "selections": [
            v21 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v23 = [
        v20 /*: any*/ 
    ], v24 = {
        "kind": "ScalarField",
        "name": "title"
    }, v25 = [
        v20 /*: any*/ ,
        v7 /*: any*/ 
    ], v26 = {
        "concreteType": "DevOpsSummarisedDeployments",
        "kind": "LinkedField",
        "name": "summarisedDeployments",
        "plural": false,
        "selections": v25 /*: any*/ 
    }, v27 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v28 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v29 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v30 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "versionDetailPageRefetchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "versionDetailPageRefetchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddAndRemoveIssues"
                                },
                                v8 /*: any*/ ,
                                {
                                    "alias": "allIssues",
                                    "args": [
                                        v9 /*: any*/ 
                                    ],
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": v11 /*: any*/ ,
                                    "storageKey": "issues(filter:\"ALL\")"
                                },
                                v12 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "startDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "releaseDate"
                                },
                                v13 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "versionId"
                                },
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "project",
                                    "plural": false,
                                    "selections": [
                                        v14 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cloudId"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "maxHierarchyLevel": 1,
                                                        "minHierarchyLevel": 1
                                                    }
                                                }
                                            ],
                                            "concreteType": "JiraIssueTypeConnection",
                                            "kind": "LinkedField",
                                            "name": "issueTypes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueTypeEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                    "kind": "LinkedField",
                                                                    "name": "hierarchy",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v15 /*: any*/ 
                                                                    ]
                                                                },
                                                                v7 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "issueTypes(filter:{\"maxHierarchyLevel\":1,\"minHierarchyLevel\":1})"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectStyle"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraVersionDriverResult",
                                    "kind": "LinkedField",
                                    "name": "driverData",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "driver",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "QueryError",
                                            "kind": "LinkedField",
                                            "name": "queryError",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "message"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v18 /*: any*/ ,
                                v15 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersionWarningConfig",
                                    "kind": "LinkedField",
                                    "name": "warningConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "openPullRequest"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "openReview"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "unreviewedCode"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "failingBuild"
                                        },
                                        v12 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "JiraVersionConnectAddonIframeData",
                                    "kind": "LinkedField",
                                    "name": "connectAddonIframeData",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "appKey"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "moduleKey"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "appName"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "location"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "options"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canViewDevTools"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "versionIssueTableHiddenColumns"
                                },
                                {
                                    "alias": "issuesForList",
                                    "args": v19 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "ids",
                                                                    "value": [
                                                                        "priority",
                                                                        "summary",
                                                                        "assignee",
                                                                        "status",
                                                                        "issuetype"
                                                                    ]
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v6 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "fieldId"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraStatus",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "status",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "statusCategoryId"
                                                                                                        },
                                                                                                        v7 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v7 /*: any*/ ,
                                                                                                v15 /*: any*/ ,
                                                                                                v18 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraStatusField"
                                                                                },
                                                                                v7 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v6 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v15 /*: any*/ ,
                                                                                                v7 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "text"
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraSingleLineTextField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v15 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraAvatar",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "avatar",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "xsmall"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v7 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueTypeField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraPriority",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "priority",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v15 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                },
                                                                                                v7 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraPriorityField"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "issueId"
                                                        },
                                                        {
                                                            "concreteType": "DevOpsSummarisedFeatureFlags",
                                                            "kind": "LinkedField",
                                                            "name": "summarisedFeatureFlags",
                                                            "plural": false,
                                                            "selections": v11 /*: any*/ 
                                                        },
                                                        v6 /*: any*/ ,
                                                        {
                                                            "condition": "isDevopsFeatureDisabledInFedRamp",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsSummarisedEntities",
                                                                    "kind": "LinkedField",
                                                                    "name": "devOpsSummarisedEntities",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedDeployments",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedDeployments",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v20 /*: any*/ ,
                                                                                v7 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "deploymentState"
                                                                                },
                                                                                {
                                                                                    "concreteType": "DevOpsEnvironment",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "deploymentEnvironment",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "category"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedBuilds",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedBuilds",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v20 /*: any*/ ,
                                                                                v7 /*: any*/ ,
                                                                                v22 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraIssueDevSummaryResult",
                                                                    "kind": "LinkedField",
                                                                    "name": "devSummaryCache",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueDevSummary",
                                                                            "kind": "LinkedField",
                                                                            "name": "devSummary",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "pullrequest",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssuePullRequestDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v20 /*: any*/ ,
                                                                                                v21 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "branch",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueBranchDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": v23 /*: any*/ 
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "review",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueReviewDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v20 /*: any*/ ,
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "lastUpdated"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "stateCount"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueDevSummaryByProvider",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "summaryByProvider",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "providerId"
                                                                                                },
                                                                                                v15 /*: any*/ ,
                                                                                                v20 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "commit",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueCommitDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": v23 /*: any*/ 
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "build",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueBuildDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v20 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "failedBuildCount"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "successfulBuildCount"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "unknownBuildCount"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "deploymentEnvironments",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueDeploymentEnvironment",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "topEnvironments",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ ,
                                                                                                        v24 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "DevOpsSummarisedFeatureFlags",
                                                                    "kind": "LinkedField",
                                                                    "name": "summarisedFeatureFlags",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "mostRelevantDisplayName"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "mostRelevantEnabled"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "mostRelevantRolloutPercentage"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        v26 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedBuilds",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedBuilds",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v22 /*: any*/ ,
                                                                                v20 /*: any*/ ,
                                                                                v7 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v26 /*: any*/ ,
                                                                {
                                                                    "concreteType": "DevOpsSummarisedBuilds",
                                                                    "kind": "LinkedField",
                                                                    "name": "summarisedBuilds",
                                                                    "plural": false,
                                                                    "selections": v25 /*: any*/ 
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v27 /*: any*/ 
                                            ]
                                        },
                                        v28 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "issuesForList",
                                    "args": v19 /*: any*/ ,
                                    "filters": [
                                        "filter",
                                        "sortBy",
                                        "filters"
                                    ],
                                    "handle": "connection",
                                    "key": "ListVersion_issuesForList",
                                    "kind": "LinkedHandle",
                                    "name": "issues"
                                },
                                {
                                    "alias": "allIssuesRedesignTemp",
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": v11 /*: any*/ 
                                },
                                v8 /*: any*/ ,
                                {
                                    "args": v29 /*: any*/ ,
                                    "concreteType": "JiraVersionApproverConnection",
                                    "kind": "LinkedField",
                                    "name": "approvers",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersionApproverEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraVersionApprover",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v15 /*: any*/ ,
                                                                v17 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "AtlassianAccountUserExtendedProfile",
                                                                            "kind": "LinkedField",
                                                                            "name": "extendedProfile",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "jobTitle"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "AtlassianAccountUser"
                                                                },
                                                                v7 /*: any*/ ,
                                                                v16 /*: any*/ 
                                                            ]
                                                        },
                                                        v13 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "declineReason"
                                                        },
                                                        v18 /*: any*/ ,
                                                        v30 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                },
                                                v27 /*: any*/ 
                                            ]
                                        },
                                        v28 /*: any*/ 
                                    ],
                                    "storageKey": "approvers(first:100)"
                                },
                                {
                                    "args": v29 /*: any*/ ,
                                    "handle": "connection",
                                    "key": "version_approvers",
                                    "kind": "LinkedHandle",
                                    "name": "approvers"
                                },
                                {
                                    "concreteType": "JiraVersionRichTextSection",
                                    "kind": "LinkedField",
                                    "name": "richTextSection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraADF",
                                            "kind": "LinkedField",
                                            "name": "content",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "json"
                                                }
                                            ]
                                        },
                                        v24 /*: any*/ 
                                    ]
                                },
                                {
                                    "condition": "isDevopsFeatureDisabledInFedRamp",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "concreteType": "DevOpsSummarisedEntities",
                                            "kind": "LinkedField",
                                            "name": "devOpsSummarisedEntities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "DevOpsProviders",
                                                    "kind": "LinkedField",
                                                    "name": "providers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsFeatureFlagProvider",
                                                            "kind": "LinkedField",
                                                            "name": "featureFlagProviders",
                                                            "plural": true,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v15 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "createFeatureFlagTemplateUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "connectFeatureFlagTemplateUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "logoUrl"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v30 /*: any*/ 
                            ],
                            "type": "JiraVersion"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7138bebed4e5923528c4c74087e0a2be85d0fcb4905c03b118ddd4d71d2ea482",
            "metadata": {},
            "name": "versionDetailPageRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b84c6917019bd5ee$var$node.hash = "18efada2730a05c083b285addf6cb338";
var $b84c6917019bd5ee$export$2e2bcd8739ae039 = $b84c6917019bd5ee$var$node;

});


parcelRegister("eRSB5", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c680c4cc86913a8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<575aa0ac902f70ccf49448d3df147e43>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6c680c4cc86913a8$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudAri"
        },
        {
            "kind": "RootArgument",
            "name": "isDevopsFeatureDisabledInFedRamp"
        }
    ],
    "kind": "Fragment",
    "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_devOps",
    "selections": [
        {
            "condition": "isDevopsFeatureDisabledInFedRamp",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "cloudAri"
                        },
                        {
                            "kind": "Literal",
                            "name": "providerTypes",
                            "value": [
                                "DESIGN"
                            ]
                        }
                    ],
                    "concreteType": "DevOpsProviders",
                    "kind": "LinkedField",
                    "name": "providers",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "DevOpsDesignProvider",
                            "kind": "LinkedField",
                            "name": "designProviders",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "DevOps"
};
$6c680c4cc86913a8$var$node.hash = "72d5936bbd25e3ba21b829d9fbc1ac05";
var $6c680c4cc86913a8$export$2e2bcd8739ae039 = $6c680c4cc86913a8$var$node;

});

parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});

parcelRegister("1othz", function(module, exports) {

$parcel$export(module.exports, "useSuspenselessRefetchStateless", () => $7714fce489d6815b$export$ae1adabf094b2244);
$parcel$export(module.exports, "useSuspenselessRefetch", () => $7714fce489d6815b$export$c7ce5f64dc007896);
// eslint-disable-next-line jira/restricted/react-18

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $biQrn = parcelRequire("biQrn");

var $c1haS = parcelRequire("c1haS");
const $7714fce489d6815b$var$useInFlightRequests = ({ setIsLoading: setIsLoading })=>{
    const inFlightRequestsRef = (0, $5uXOq.useRef)([]);
    return (0, $5uXOq.useMemo)(()=>({
            onNewRequest: (request)=>{
                inFlightRequestsRef.current.push(request);
            },
            onRequestFinish: (request, /**
				 * Called only if the request hasn't been superceded by a more recent request's success / failure
				 */ onIfRequestIsRelevant)=>{
                // find the first occurrence of this request
                const inFlightRequestIndex = inFlightRequestsRef.current.indexOf(request);
                // If the current request is still considered "in flight"
                if (inFlightRequestIndex !== -1) {
                    onIfRequestIsRelevant?.();
                    // Cut out the current and all proceeding requests from the in-flight queue
                    inFlightRequestsRef.current = inFlightRequestsRef.current.slice(inFlightRequestIndex + 1);
                    // Update isLoading to reflect the current number of in-flight requests
                    setIsLoading?.(!!inFlightRequestsRef.current.length);
                }
            }
        }), [
        setIsLoading
    ]);
};
const $7714fce489d6815b$var$useTransitionNoop = ()=>[
        null,
        null
    ];
const $7714fce489d6815b$export$ae1adabf094b2244 = (// Relay-generated query from the @refetchable annotation in a useRefetchableFragment
// or usePaginationFragment
query, // Refetch function from a useRefetchableFragment or usePaginationFragment
// (which ordinarily would trigger suspense)
refetch, { setIsLoading: setIsLoading, setLastFetchError: setLastFetchError, fetchPolicy: fetchPolicy = 'store-or-network', networkCacheConfig: networkCacheConfig } = {})=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const isMounted = (0, $biQrn.useIsMounted)();
    const { onNewRequest: onNewRequest, onRequestFinish: onRequestFinish } = $7714fce489d6815b$var$useInFlightRequests({
        setIsLoading: setIsLoading
    });
    const useTransitionFG = // eslint-disable-next-line react-hooks/react-compiler
    (0, $c1haS.getIsConcurrentEnabled)() ? (0, $5uXOq.useTransition) : $7714fce489d6815b$var$useTransitionNoop;
    // eslint-disable-next-line react-hooks/react-compiler
    const [_, startTransition] = useTransitionFG();
    return (0, $5uXOq.useCallback)((variables)=>{
        if (isMounted.current) setIsLoading?.(true);
        onNewRequest(variables);
        return (0, $8Uumt.fetchQuery)(environment, query, variables, {
            fetchPolicy: fetchPolicy,
            networkCacheConfig: networkCacheConfig
        }).subscribe({
            complete () {
                if (isMounted.current) {
                    if (startTransition && (0, $c1haS.getIsConcurrentEnabled)()) // we need concurrent mode for useTransition to work
                    startTransition(()=>{
                        setLastFetchError?.(null);
                        onRequestFinish(variables, ()=>{
                            refetch(variables, {
                                fetchPolicy: 'store-only'
                            });
                        });
                    });
                    else {
                        setLastFetchError?.(null);
                        onRequestFinish(variables, ()=>{
                            refetch(variables, {
                                fetchPolicy: 'store-only'
                            });
                        });
                    }
                }
            },
            error (e) {
                if (isMounted.current) onRequestFinish(variables, ()=>setLastFetchError?.(e));
            }
        });
    }, [
        environment,
        fetchPolicy,
        isMounted,
        networkCacheConfig,
        onNewRequest,
        onRequestFinish,
        query,
        refetch,
        setIsLoading,
        setLastFetchError,
        startTransition
    ]);
};
const $7714fce489d6815b$export$c7ce5f64dc007896 = (query, refetch, options)=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [lastFetchError, setLastFetchError] = (0, $5uXOq.useState)(null);
    const refetchFunction = $7714fce489d6815b$export$ae1adabf094b2244(query, refetch, {
        ...options,
        setIsLoading: setIsLoading,
        setLastFetchError: setLastFetchError
    });
    return [
        refetchFunction,
        isLoading,
        lastFetchError
    ];
};

});
parcelRegister("biQrn", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", () => $c6adaed2787020bf$export$80c2a3957bcb42ea);

var $5uXOq = parcelRequire("5uXOq");
const $c6adaed2787020bf$export$80c2a3957bcb42ea = ()=>{
    const isMounted = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, [
        isMounted
    ]);
    return isMounted;
};

});


parcelRegister("jDrwg", function(module, exports) {

$parcel$export(module.exports, "default", () => $049f084810e3e7c4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");
function $049f084810e3e7c4$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $5uXOq.useRef)(options);
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const callbackRef = (0, $5uXOq.useRef)((...args)=>{
        callback(...args);
    });
    callbackRef.current = callback;
    const debouncedCallBack = (0, $5uXOq.useMemo)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $5uXOq.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});

// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("btxzI", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b5b47d858c9ff0d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7d21dec31d2b5e4e7378c4ddf12f3680>>
 * @relayHash b4bb4da349d8fe7b41a55b67a641db72
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 913fbb0382cf9cf095f853f6b818d4e8a47f615cd232275e0519fc5ae4eb57f1
const $1b5b47d858c9ff0d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDevopsFeatureDisabledInFedRamp"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "ScalarField",
            "name": "totalCount"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v7 = [
        {
            "kind": "ScalarField",
            "name": "url"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ui_softwareReleasesVersionProgressQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_versionProgress_VersionProgress"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.version"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ui_softwareReleasesVersionProgressQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": "doneIssuesRedesignTemp",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "filters",
                                                    "value": {
                                                        "statusCategories": [
                                                            "DONE"
                                                        ]
                                                    }
                                                }
                                            ],
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": v4 /*: any*/ ,
                                            "storageKey": "issues(filters:{\"statusCategories\":[\"DONE\"]})"
                                        },
                                        {
                                            "alias": "inProgressIssuesRedesignTemp",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "filters",
                                                    "value": {
                                                        "statusCategories": [
                                                            "IN_PROGRESS"
                                                        ]
                                                    }
                                                }
                                            ],
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": v4 /*: any*/ ,
                                            "storageKey": "issues(filters:{\"statusCategories\":[\"IN_PROGRESS\"]})"
                                        },
                                        {
                                            "alias": "todoIssuesRedesignTemp",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "filters",
                                                    "value": {
                                                        "statusCategories": [
                                                            "TODO"
                                                        ]
                                                    }
                                                }
                                            ],
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": v4 /*: any*/ ,
                                            "storageKey": "issues(filters:{\"statusCategories\":[\"TODO\"]})"
                                        },
                                        {
                                            "concreteType": "JiraVersionWarningConfig",
                                            "kind": "LinkedField",
                                            "name": "warningConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "failingBuild"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "openPullRequest"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "openReview"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "unreviewedCode"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "warningsCount"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "collapsedUis"
                                        },
                                        v5 /*: any*/ ,
                                        {
                                            "condition": "isDevopsFeatureDisabledInFedRamp",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "concreteType": "JiraVersionRelatedWorkV2Connection",
                                                    "kind": "LinkedField",
                                                    "name": "relatedWorkV2",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersionRelatedWorkV2Edge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v3 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v7 /*: any*/ ,
                                                                            "type": "JiraVersionRelatedWorkGenericLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v7 /*: any*/ ,
                                                                            "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "cursor"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "PageInfo",
                                                            "kind": "LinkedField",
                                                            "name": "pageInfo",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "endCursor"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "hasNextPage"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "relatedWorkV2(first:100)"
                                                },
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "version_relatedWorkV2",
                                                    "kind": "LinkedHandle",
                                                    "name": "relatedWorkV2"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraVersion"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "913fbb0382cf9cf095f853f6b818d4e8a47f615cd232275e0519fc5ae4eb57f1",
            "metadata": {},
            "name": "ui_softwareReleasesVersionProgressQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1b5b47d858c9ff0d$var$node.hash = "67f2e201e7debdeea53f08cb0f8bb7b1";
var $1b5b47d858c9ff0d$export$2e2bcd8739ae039 = $1b5b47d858c9ff0d$var$node;

});

parcelRegister("ajHh6", function(module, exports) {

$parcel$export(module.exports, "default", () => $65583ade615fc325$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9675730f6f3a5344ac7a44fad40a564f>>
 * @relayHash b86ff13b09f7eb5a0f8fabff1e5ee762
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9db46cbf2997d3ea44fe2ed14a797a64a0c1e3fb3cc94655c212c7e3245cef16
const $65583ade615fc325$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDevopsFeatureDisabledInFedRamp"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "url"
    }, v7 = {
        "kind": "ScalarField",
        "name": "relatedWorkId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "title"
    }, v9 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "ids",
                        "value": [
                            "assignee",
                            "status"
                        ]
                    }
                ],
                "concreteType": "JiraIssueFieldConnection",
                "kind": "LinkedField",
                "name": "fieldsById",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v3 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v9 /*: any*/ ,
                                            {
                                                "concreteType": "JiraStatus",
                                                "kind": "LinkedField",
                                                "name": "status",
                                                "plural": false,
                                                "selections": [
                                                    v10 /*: any*/ ,
                                                    {
                                                        "concreteType": "JiraStatusCategory",
                                                        "kind": "LinkedField",
                                                        "name": "statusCategory",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "statusCategoryId"
                                                            },
                                                            v5 /*: any*/ 
                                                        ]
                                                    },
                                                    v5 /*: any*/ 
                                                ]
                                            }
                                        ],
                                        "type": "JiraStatusField"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v9 /*: any*/ ,
                                            {
                                                "kind": "LinkedField",
                                                "name": "user",
                                                "plural": false,
                                                "selections": [
                                                    v3 /*: any*/ ,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "picture"
                                                    },
                                                    v10 /*: any*/ ,
                                                    v5 /*: any*/ 
                                                ]
                                            }
                                        ],
                                        "type": "JiraSingleSelectUserPickerField"
                                    },
                                    v5 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "fieldsById(ids:[\"assignee\",\"status\"])"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v13 = {
        "kind": "ClientExtension",
        "selections": [
            v12 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isSaving"
            }
        ]
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            v12 /*: any*/ 
        ]
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            v14 /*: any*/ 
        ],
        "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            v11 /*: any*/ ,
            v15 /*: any*/ ,
            v13 /*: any*/ 
        ],
        "type": "JiraVersionRelatedWorkV2",
        "abstractKey": "__isJiraVersionRelatedWorkV2"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ui_softwareReleasesVersionRelatedWork_RelatedWorkQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isDevopsFeatureDisabledInFedRamp",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "ui_softwareReleasesVersionRelatedWork_RelatedWork"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.version"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ui_softwareReleasesVersionRelatedWork_RelatedWorkQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "condition": "isDevopsFeatureDisabledInFedRamp",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "args": v4 /*: any*/ ,
                                                    "concreteType": "JiraVersionRelatedWorkV2Connection",
                                                    "kind": "LinkedField",
                                                    "name": "relatedWorkV2",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersionRelatedWorkV2Edge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v3 /*: any*/ ,
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isJiraVersionRelatedWorkV2"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "category"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraIssue",
                                                                            "kind": "LinkedField",
                                                                            "name": "issue",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v6 /*: any*/ ,
                                                                                v7 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v11 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraVersionRelatedWorkV2",
                                                                                                    "abstractKey": "__isJiraVersionRelatedWorkV2"
                                                                                                },
                                                                                                v14 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraVersionRelatedWorkGenericLink"
                                                                                        },
                                                                                        v15 /*: any*/ ,
                                                                                        v13 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraVersionRelatedWorkV2",
                                                                                    "abstractKey": "__isJiraVersionRelatedWorkV2"
                                                                                },
                                                                                v14 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraVersionRelatedWorkGenericLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                v6 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v16 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                v16 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraVersionRelatedWorkNativeReleaseNotes"
                                                                        },
                                                                        v14 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "cursor"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "PageInfo",
                                                            "kind": "LinkedField",
                                                            "name": "pageInfo",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "endCursor"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "hasNextPage"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "relatedWorkV2(first:100)"
                                                },
                                                {
                                                    "args": v4 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "version_relatedWorkV2",
                                                    "kind": "LinkedHandle",
                                                    "name": "relatedWorkV2"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "status"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canEditRelatedWork"
                                                },
                                                {
                                                    "alias": "allIssues",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filter",
                                                            "value": "ALL"
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "totalCount"
                                                        }
                                                    ],
                                                    "storageKey": "issues(filter:\"ALL\")"
                                                },
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "versionId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "collapsedUis"
                                                },
                                                v14 /*: any*/ 
                                            ],
                                            "type": "JiraVersion"
                                        }
                                    ]
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9db46cbf2997d3ea44fe2ed14a797a64a0c1e3fb3cc94655c212c7e3245cef16",
            "metadata": {},
            "name": "ui_softwareReleasesVersionRelatedWork_RelatedWorkQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$65583ade615fc325$var$node.hash = "d8d66158505126260b0811b2a2af5336";
var $65583ade615fc325$export$2e2bcd8739ae039 = $65583ade615fc325$var$node;

});

parcelRegister("4UYYD", function(module, exports) {

$parcel$export(module.exports, "default", () => $79c5edf8588bba6e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3ae3efdf5ff1633f61a5fb1f56aa7df2>>
 * @relayHash b89922858b2af773f5745e807572963f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ad0719c42dbb9679eb14945f0da1b989acf96db76cad39643540ecdce4c84b0c
const $79c5edf8588bba6e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 6
        },
        {
            "kind": "Literal",
            "name": "sort",
            "value": {
                "createdAt": {
                    "direction": "DESC",
                    "priority": 1
                }
            }
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_versionIssueAssociatedDesigns_IssueAssociatedDesignsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "designCarousel_versionIssueAssociatedDesigns"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "args": v3 /*: any*/ ,
                                                        "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignConnection",
                                                        "kind": "LinkedField",
                                                        "name": "issueAssociatedDesigns",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "jira.version.issueAssociatedDesigns.totalCount"
                                                            }
                                                        ],
                                                        "storageKey": "issueAssociatedDesigns(first:6,sort:{\"createdAt\":{\"direction\":\"DESC\",\"priority\":1}})"
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.version.issueAssociatedDesigns"
                                                }
                                            ],
                                            "type": "JiraVersion"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.version"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_versionIssueAssociatedDesigns_IssueAssociatedDesignsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "collapsedUis"
                                        },
                                        v5 /*: any*/ ,
                                        {
                                            "args": v3 /*: any*/ ,
                                            "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignConnection",
                                            "kind": "LinkedField",
                                            "name": "issueAssociatedDesigns",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v2 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "displayName"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "lastUpdated"
                                                                        },
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Variable",
                                                                                    "name": "id",
                                                                                    "variableName": "cloudAri"
                                                                                }
                                                                            ],
                                                                            "kind": "LinkedField",
                                                                            "name": "provider",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v2 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "logoUrl"
                                                                                },
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "first",
                                                                                    "value": 2
                                                                                }
                                                                            ],
                                                                            "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "associatedIssues",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v5 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "key"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "webUrl"
                                                                                                        },
                                                                                                        {
                                                                                                            "args": [
                                                                                                                {
                                                                                                                    "kind": "Literal",
                                                                                                                    "name": "idsOrAliases",
                                                                                                                    "value": [
                                                                                                                        "issuetype",
                                                                                                                        "summary"
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "Literal",
                                                                                                                    "name": "ignoreMissingFields",
                                                                                                                    "value": true
                                                                                                                }
                                                                                                            ],
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldsByIdOrAlias",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                v2 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "name"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "avatar",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "xsmall"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v5 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraIssueTypeField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "text"
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                },
                                                                                                                v5 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"issuetype\",\"summary\"],ignoreMissingFields:true)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssue"
                                                                                                },
                                                                                                v2 /*: any*/ ,
                                                                                                v6 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v5 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "associatedIssues(first:2)"
                                                                        }
                                                                    ],
                                                                    "type": "DevOpsDesign"
                                                                },
                                                                v6 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        },
                                                        v5 /*: any*/ 
                                                    ]
                                                },
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "issueAssociatedDesigns(first:6,sort:{\"createdAt\":{\"direction\":\"DESC\",\"priority\":1}})"
                                        },
                                        {
                                            "args": v3 /*: any*/ ,
                                            "filters": [
                                                "sort"
                                            ],
                                            "handle": "connection",
                                            "key": "DesignSlider_issueAssociatedDesigns",
                                            "kind": "LinkedHandle",
                                            "name": "issueAssociatedDesigns"
                                        },
                                        {
                                            "args": v3 /*: any*/ ,
                                            "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignConnection",
                                            "kind": "LinkedField",
                                            "name": "issueAssociatedDesigns",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ],
                                            "storageKey": "issueAssociatedDesigns(first:6,sort:{\"createdAt\":{\"direction\":\"DESC\",\"priority\":1}})"
                                        }
                                    ],
                                    "type": "JiraVersion"
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ad0719c42dbb9679eb14945f0da1b989acf96db76cad39643540ecdce4c84b0c",
            "metadata": {},
            "name": "ui_versionIssueAssociatedDesigns_IssueAssociatedDesignsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$79c5edf8588bba6e$var$node.hash = "6385dc34956a666103b9e7e3b549a2e3";
var $79c5edf8588bba6e$export$2e2bcd8739ae039 = $79c5edf8588bba6e$var$node;

});

parcelRegister("93kRE", function(module, exports) {

$parcel$export(module.exports, "ViewFeatureFlagsEmptyStateExperienceExperienceStart", () => $76212686d9cece5d$export$dba6cce392699a2b);
$parcel$export(module.exports, "useViewFeatureFlagsEmptyStateExperienceExperienceFail", () => $76212686d9cece5d$export$b0017a8c5a092f54);
$parcel$export(module.exports, "ViewFeatureFlagsEmptyStateExperienceExperienceSuccessTracker", () => $76212686d9cece5d$export$c49eaa8e4e389a94);

var $5uXOq = parcelRequire("5uXOq");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $dAfqg = parcelRequire("dAfqg");

var $efvDm = parcelRequire("efvDm");

var $k9JTq = parcelRequire("k9JTq");
const $76212686d9cece5d$var$EXPERIENCE_NAME = 'viewFeatureFlagsEmptyStateExperience';
const $76212686d9cece5d$export$dba6cce392699a2b = ({ experienceId: experienceId })=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kaHBi.ExperienceStart), {
        experienceId: experienceId,
        experience: $76212686d9cece5d$var$EXPERIENCE_NAME,
        analyticsSource: "featureFlagsEmptyStateExperience",
        edition: appEditions.software,
        application: (0, $efvDm.JIRA_SOFTWARE)
    });
};
const $76212686d9cece5d$export$b0017a8c5a092f54 = ()=>(0, $93jKl.useExperienceFail)({
        experience: $76212686d9cece5d$var$EXPERIENCE_NAME
    });
const $76212686d9cece5d$export$c49eaa8e4e389a94 = ()=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: $76212686d9cece5d$var$EXPERIENCE_NAME,
        attributes: projectContext != null ? {
            projectId: projectContext.projectId,
            isProjectAdmin: projectContext.isProjectAdmin,
            simplified: projectContext.simplified
        } : undefined
    });
};

});

parcelRegister("jX1s1", function(module, exports) {

$parcel$export(module.exports, "AddIssuesToVersion", () => $fe3599186565f7a3$export$bae9d11b7896e3f7);
/* async.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $99M5v = parcelRequire("99M5v");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $fO0qz = parcelRequire("fO0qz");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $fe3599186565f7a3$var$LazyAddIssuesToVersion = (0, $kxZPA.lazy)(()=>(parcelRequire("dO9WF")).then((module)=>module.AddIssuesToVersion), {
    moduleId: "./src/packages/releases/add-issues-to-version/src/ui/index.tsx"
});
const $fe3599186565f7a3$export$bae9d11b7896e3f7 = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const PlaceholderButton = props.isIssueListFooterButton ? $fe3599186565f7a3$var$IssueListFooterButton : (0, $fVnbM.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "add-issues-to-version",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(PlaceholderButton, {
            onClick: undefined,
            appearance: props.appearance,
            type: "button",
            iconBefore: props.showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
                label: "",
                LEGACY_size: "small"
            }) : undefined
        }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $fO0qz.default).addButtonIssueTerminologyRefreshM4 : (0, $fO0qz.default).addButton))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fe3599186565f7a3$var$LazyAddIssuesToVersion, props));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fe3599186565f7a3$var$IssueListFooterButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1kba1h6o _btpd1osq _1n7d1ylp _14741e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("99M5v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::739edc58ca910533dbcf168239dfad1b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6aaa418e9a366cd8$var$_react = $6aaa418e9a366cd8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6aaa418e9a366cd8$var$_add = $6aaa418e9a366cd8$var$_interopRequireDefault((parcelRequire("dZbEw")));

var $6aaa418e9a366cd8$var$_add2 = $6aaa418e9a366cd8$var$_interopRequireDefault((parcelRequire("7ymNM")));
function $6aaa418e9a366cd8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AddIcon.
 * This component is AddIcon, with `UNSAFE_fallbackIcon` set to "AddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6aaa418e9a366cd8$var$AddIcon = (props)=>/*#__PURE__*/ $6aaa418e9a366cd8$var$_react.default.createElement($6aaa418e9a366cd8$var$_add.default, Object.assign({
        LEGACY_fallbackIcon: $6aaa418e9a366cd8$var$_add2.default
    }, props));
$6aaa418e9a366cd8$var$AddIcon.Name = 'AddIconMigration';
var $6aaa418e9a366cd8$var$_default = module.exports.default = $6aaa418e9a366cd8$var$AddIcon;

});
parcelRegister("7ymNM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $57fd655943aa23fe$var$_react = $57fd655943aa23fe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $57fd655943aa23fe$var$_add = $57fd655943aa23fe$var$_interopRequireDefault((parcelRequire("dZbEw")));
function $57fd655943aa23fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $57fd655943aa23fe$var$AddIcon = (props)=>/*#__PURE__*/ $57fd655943aa23fe$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V3.993A.997.997 0 0 0 12 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 0 0 3 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0 0 21 12c0-.556-.445-1-.993-1z"/></svg>`
    }, props, {
        newIcon: $57fd655943aa23fe$var$_add.default
    }));
$57fd655943aa23fe$var$AddIcon.displayName = 'AddIcon';
var $57fd655943aa23fe$var$_default = module.exports.default = $57fd655943aa23fe$var$AddIcon;

});


parcelRegister("fO0qz", function(module, exports) {

$parcel$export(module.exports, "default", () => $89135d3517433fff$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $89135d3517433fff$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addButton: {
        "id": "software-releases-add-issues-to-version.add-button",
        "defaultMessage": "Add issues"
    },
    errorFlagTitle: {
        "id": "software-releases-add-issues-to-version.error-flag-title",
        "defaultMessage": "Can't add {totalCount, plural, one {issue} other {# issues}} to version"
    },
    errorFlagDescription: {
        "id": "software-releases-add-issues-to-version.error-flag-description",
        "defaultMessage": "Something went wrong. Please try again or contact your administrator if the problem persists."
    },
    successFlagDescription: {
        "id": "software-releases-add-issues-to-version.success-flag-description",
        "defaultMessage": "{issueCount, plural, one {# issue has been added} other {# issues have been added}}."
    },
    partialIssueFailureFlagTitle: {
        "id": "software-releases-add-issues-to-version.partial-issue-failure-flag-title",
        "defaultMessage": "{failedIssueCount} out of {totalCount} issues not added to version."
    },
    singleIssueMissingResolvePermFlagDescription: {
        "id": "software-releases-add-issues-to-version.single-issue-missing-resolve-perm-flag-description",
        "defaultMessage": "You don't have permission to resolve {issueKey}, so it wasn't added."
    },
    singleIssueMissingEditPermFlagDescription: {
        "id": "software-releases-add-issues-to-version.single-issue-missing-edit-perm-flag-description",
        "defaultMessage": "You don't have permission to edit {issueKey}, so it wasn't added."
    },
    singleIssueMissingPermsFlagDescription: {
        "id": "software-releases-add-issues-to-version.single-issue-missing-perms-flag-description",
        "defaultMessage": "You don't have permission to edit or resolve {issueKey}, so it wasn't added."
    },
    twoIssuesMissingResolvePermFlagDescription: {
        "id": "software-releases-add-issues-to-version.two-issues-missing-resolve-perm-flag-description",
        "defaultMessage": "You don't have permission to resolve {issueKey1} and {issueKey2}, so they weren't added."
    },
    twoIssuesMissingEditPermFlagDescription: {
        "id": "software-releases-add-issues-to-version.two-issues-missing-edit-perm-flag-description",
        "defaultMessage": "You don't have permission to edit {issueKey1} and {issueKey2}, so they weren't added."
    },
    twoIssuesMissingPermsFlagDescription: {
        "id": "software-releases-add-issues-to-version.two-issues-missing-perms-flag-description",
        "defaultMessage": "You don't have permission to edit or resolve {issueKey1} and {issueKey2}, so they weren't added."
    },
    multipleIssuesMissingResolvePermFlagDescription: {
        "id": "software-releases-add-issues-to-version.multiple-issues-missing-resolve-perm-flag-description",
        "defaultMessage": "You don't have permission to resolve {failedCount, plural, one {issue} other {# issues}}, so they weren't added."
    },
    multipleIssuesMissingEditPermFlagDescription: {
        "id": "software-releases-add-issues-to-version.multiple-issues-missing-edit-perm-flag-description",
        "defaultMessage": "You don't have permission to edit {failedCount, plural, one {issue} other {# issues}}, so they weren't added."
    },
    multipleIssuesMissingPermsFlagDescription: {
        "id": "software-releases-add-issues-to-version.multiple-issues-missing-perms-flag-description",
        "defaultMessage": "You don't have permission to edit or resolve {failedCount, plural, one {issue} other {# issues}}, so they weren't added."
    },
    addButtonIssueTerminologyRefreshM4: {
        "id": "software-releases-add-issues-to-version.add-button-issue-terminology-refresh-m4",
        "defaultMessage": "Add work items"
    },
    errorFlagTitleIssueTerminologyRefreshM4: {
        "id": "software-releases-add-issues-to-version.error-flag-title-issue-terminology-refresh-m4",
        "defaultMessage": "Can't add {totalCount, plural, one {work item} other {# work items}} to version"
    },
    successFlagDescriptionIssueTerminologyRefreshM4: {
        "id": "software-releases-add-issues-to-version.success-flag-description-issue-terminology-refresh-m4",
        "defaultMessage": "{issueCount, plural, one {# work item has been added} other {# work items have been added}}."
    },
    partialIssueFailureFlagTitleIssueTerminologyRefreshM4: {
        "id": "software-releases-add-issues-to-version.partial-issue-failure-flag-title-issue-terminology-refresh-m4",
        "defaultMessage": "{failedIssueCount} out of {totalCount} work items not added to version."
    },
    multipleIssuesMissingResolvePermFlagDescriptionIssueTerminologyRefreshM4: {
        "id": "software-releases-add-issues-to-version.multiple-issues-missing-resolve-perm-flag-description-issue-terminology-refresh-m4",
        "defaultMessage": "You don't have permission to resolve {failedCount, plural, one {work item} other {# work items}}, so they weren't added."
    },
    multipleIssuesMissingEditPermFlagDescriptionIssueTerminologyRefreshM4: {
        "id": "software-releases-add-issues-to-version.multiple-issues-missing-edit-perm-flag-description-issue-terminology-refresh-m4",
        "defaultMessage": "You don't have permission to edit {failedCount, plural, one {work item} other {# work items}}, so they weren't added."
    },
    multipleIssuesMissingPermsFlagDescriptionIssueTerminologyRefreshM4: {
        "id": "software-releases-add-issues-to-version.multiple-issues-missing-perms-flag-description-issue-terminology-refresh-m4",
        "defaultMessage": "You don't have permission to edit or resolve {failedCount, plural, one {work item} other {# work items}}, so they weren't added."
    }
});

});

parcelRegister("dO9WF", function(module, exports) {

let $a0d7a8c8d3eb9434$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a0d7a8c8d3eb9434$var$load("2uWy3").then(()=>parcelRequire('bZwwy'));

});


parcelRegister("ip4R1", function(module, exports) {

$parcel$export(module.exports, "VersionApproversCardExperienceStart", () => $05562b4fc63e3e20$export$e45410483a7f75f3);
$parcel$export(module.exports, "VersionApproversCardExperienceSuccess", () => $05562b4fc63e3e20$export$664bc979971dec26);
$parcel$export(module.exports, "useVersionApproversCardExperienceFail", () => $05562b4fc63e3e20$export$3edb8e7637e1d4cc);

var $5uXOq = parcelRequire("5uXOq");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $efvDm = parcelRequire("efvDm");

var $k9JTq = parcelRequire("k9JTq");
const $05562b4fc63e3e20$export$52919046b94109dc = 'jiraVersionApproversCard';
const $05562b4fc63e3e20$var$ANALYTICS_SOURCE = 'versionDetails';
const $05562b4fc63e3e20$export$e45410483a7f75f3 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kaHBi.ExperienceStart), {
        experienceId: `${Date.now()}`,
        experience: $05562b4fc63e3e20$export$52919046b94109dc,
        analyticsSource: $05562b4fc63e3e20$var$ANALYTICS_SOURCE,
        edition: appEditions.software,
        application: (0, $efvDm.JIRA_SOFTWARE)
    });
};
const $05562b4fc63e3e20$export$664bc979971dec26 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: $05562b4fc63e3e20$export$52919046b94109dc
    });
const $05562b4fc63e3e20$export$3edb8e7637e1d4cc = ()=>(0, $93jKl.useExperienceFail)({
        experience: $05562b4fc63e3e20$export$52919046b94109dc
    });

});

parcelRegister("4c6NH", function(module, exports) {

$parcel$export(module.exports, "Approvers", () => $f0127c9f5b8d1b62$export$52f716ccfb37fc43);

var $hdVaF = parcelRequire("hdVaF");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");

var $99M5v = parcelRequire("99M5v");

var $iwwXK = parcelRequire("iwwXK");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");
var $j7rCb = parcelRequire("j7rCb");


var $krCkj = parcelRequire("krCkj");
const $f0127c9f5b8d1b62$var$PADDING_SIZE = (0, $gwIPs.gridSize) * 3;
const $f0127c9f5b8d1b62$var$BORDER_SIZE = 1;
const $f0127c9f5b8d1b62$var$WIDTH_OFFSET = ($f0127c9f5b8d1b62$var$PADDING_SIZE + $f0127c9f5b8d1b62$var$BORDER_SIZE) * 2;

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f0127c9f5b8d1b62$var$LazyApprovers = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("9Uf42")).then((module)=>module.Approvers), {
    ssr: false,
    moduleId: "./src/packages/releases/approvers/src/ui/index.tsx"
});
const $f0127c9f5b8d1b62$export$52f716ccfb37fc43 = ({ jiraVersion: jiraVersion })=>{
    const { startNextPhase: startNextPhase } = (0, $j7rCb.useLazyPhase)();
    (0, $5uXOq.useEffect)(()=>{
        startNextPhase();
    }, [
        startNextPhase
    ]);
    const version = (0, $8Uumt.useFragment)((0, $hdVaF.default), jiraVersion);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const numberOfApproversToShow = (0, $06faf2097c277710$export$ab69ec32c8e056d0);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "releases-approvers",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f0127c9f5b8d1b62$var$ApproversCardWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f0127c9f5b8d1b62$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f0127c9f5b8d1b62$var$ApproversTitle, null, formatMessage((0, $krCkj.default).approversTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
                LEGACY_size: "small",
                label: ""
            }),
            appearance: "subtle"
        })), [
            ...Array(numberOfApproversToShow).keys()
        ].map((i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
                key: i,
                isShimmering: true,
                hasAvatar: true
            })))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f0127c9f5b8d1b62$var$LazyApprovers, {
        jiraVersion: version
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $f0127c9f5b8d1b62$var$ApproversTitle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c1txw _4cvr1h6o _k48p1pd9 _syaz1fxt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $f0127c9f5b8d1b62$var$Header = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $f0127c9f5b8d1b62$var$ApproversCardWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulppxbi _1reo1wug _18m91wug _p12fpjzf _c71l842n _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hdVaF", function(module, exports) {

$parcel$export(module.exports, "default", () => $6754aa24323dee89$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d9002c0d697d345d76c64fe0f6d5cbf8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6754aa24323dee89$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "async_softwareReleasesApprovers_Approvers",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesApprovers_Approvers"
        }
    ],
    "type": "JiraVersion"
};
$6754aa24323dee89$var$node.hash = "b54447a983203e9751ad03d69a14f12e";
var $6754aa24323dee89$export$2e2bcd8739ae039 = $6754aa24323dee89$var$node;

});

const $06faf2097c277710$export$ab69ec32c8e056d0 = 5;

parcelRegister("krCkj", function(module, exports) {

$parcel$export(module.exports, "default", () => $919b5d8330f71df6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $919b5d8330f71df6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    approversTitle: {
        "id": "software-releases-approvers.approvers-title",
        "defaultMessage": "Approvers"
    },
    noApproversMessage: {
        "id": "software-releases-approvers.no-approvers-message",
        "defaultMessage": "No approvers have been added"
    },
    showMore: {
        "id": "software-releases-approvers.show-more",
        "defaultMessage": "Show all approvers"
    },
    showLess: {
        "id": "software-releases-approvers.show-less",
        "defaultMessage": "Show less"
    },
    addApproversAriaLabel: {
        "id": "software-releases-approvers.add-approvers-aria-label",
        "defaultMessage": "Add approvers"
    }
});

});

parcelRegister("9Uf42", function(module, exports) {

let $73650772f970c0f6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $73650772f970c0f6$var$load("8RVgZ").then(()=>parcelRequire('84x8K'));

});


parcelRegister("2vbty", function(module, exports) {

$parcel$export(module.exports, "useSidebarStore", () => $a9dfbd5d9e01d206$export$118f45a8309a4356);
$parcel$export(module.exports, "useSidebarActions", () => $a9dfbd5d9e01d206$export$685a45ff9d61633f);

var $dp66m = parcelRequire("dp66m");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const { CLOSED: $a9dfbd5d9e01d206$var$CLOSED, SHOWING_ISSUE: $a9dfbd5d9e01d206$var$SHOWING_ISSUE } = (0, $dp66m.SidebarStatuses);
const $a9dfbd5d9e01d206$var$initialState = {
    state: {
        status: $a9dfbd5d9e01d206$var$CLOSED
    }
};
const $a9dfbd5d9e01d206$export$e324594224ef24da = {
    close: ()=>({ setState: setState })=>setState({
                state: {
                    status: $a9dfbd5d9e01d206$var$CLOSED
                }
            }),
    showIssue: (issueKey)=>({ setState: setState })=>setState({
                state: {
                    status: $a9dfbd5d9e01d206$var$SHOWING_ISSUE,
                    issueKey: issueKey
                }
            })
};
const $a9dfbd5d9e01d206$var$Store = (0, $iXqE5.createStore)({
    name: 'versionDetailsSidebarStore',
    initialState: $a9dfbd5d9e01d206$var$initialState,
    actions: $a9dfbd5d9e01d206$export$e324594224ef24da
});
const $a9dfbd5d9e01d206$var$useStore = (0, $3sQ5x.createHook)($a9dfbd5d9e01d206$var$Store);
const $a9dfbd5d9e01d206$export$118f45a8309a4356 = ()=>{
    const [{ state: state }, sidebarActions] = $a9dfbd5d9e01d206$var$useStore();
    return [
        state,
        sidebarActions
    ];
};
const $a9dfbd5d9e01d206$var$useSidebarWithoutState = (0, $3sQ5x.createHook)($a9dfbd5d9e01d206$var$Store, {
    selector: null
});
const $a9dfbd5d9e01d206$export$685a45ff9d61633f = ()=>{
    const [, sidebarActions] = $a9dfbd5d9e01d206$var$useSidebarWithoutState();
    return sidebarActions;
};

});
parcelRegister("dp66m", function(module, exports) {

$parcel$export(module.exports, "SidebarStatuses", () => $7e7556a6438b4b2c$export$a4b0bca2b71ad188);
const $7e7556a6438b4b2c$var$CLOSED = 'CLOSED';
const $7e7556a6438b4b2c$var$SHOWING_ISSUE = 'SHOWING_ISSUE';
const $7e7556a6438b4b2c$export$a4b0bca2b71ad188 = {
    CLOSED: $7e7556a6438b4b2c$var$CLOSED,
    SHOWING_ISSUE: $7e7556a6438b4b2c$var$SHOWING_ISSUE
};

});


parcelRegister("906xX", function(module, exports) {

$parcel$export(module.exports, "IssueSidebar", () => $4b6483d8ade7dea1$export$cd07ab049c87f027);
/* IssueSidebar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dp66m = parcelRequire("dp66m");

var $2vbty = parcelRequire("2vbty");

var $foqcF = parcelRequire("foqcF");
const $4b6483d8ade7dea1$export$cd07ab049c87f027 = ()=>{
    const [sidebarState] = (0, $2vbty.useSidebarStore)();
    const isOpen = sidebarState.status !== (0, $dp66m.SidebarStatuses).CLOSED;
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4b6483d8ade7dea1$var$IssueSidebarContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $foqcF.SidebarContent), null)) : null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4b6483d8ade7dea1$var$IssueSidebarContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _kqswh2mm _ca0qidpf _u5f3idpf _n3tdpxbi _19bvidpf _vchhusvi _bfhk1w7a _1bsblti4 _p12flti4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("foqcF", function(module, exports) {

$parcel$export(module.exports, "SidebarContent", () => $8dfad703a5d13e1d$export$49e8f7b58a4df4ea);

var $5uXOq = parcelRequire("5uXOq");

var $dp66m = parcelRequire("dp66m");

var $2vbty = parcelRequire("2vbty");

var $aYjcO = parcelRequire("aYjcO");
const $8dfad703a5d13e1d$export$49e8f7b58a4df4ea = ()=>{
    const [sidebarState, sidebarActions] = (0, $2vbty.useSidebarStore)();
    const onClose = sidebarActions.close;
    switch(sidebarState.status){
        case (0, $dp66m.SidebarStatuses).CLOSED:
            return null;
        case (0, $dp66m.SidebarStatuses).SHOWING_ISSUE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYjcO.Issue), {
                issueKey: sidebarState.issueKey,
                onClose: onClose
            });
        default:
            // prettier-ignore
            // @ts-expect-error - TS2339 - Property 'status' does not exist on type 'never'.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            sidebarState.status;
            throw Error('Unhandled sidebar status');
    }
};

});
parcelRegister("aYjcO", function(module, exports) {

$parcel$export(module.exports, "Issue", () => $ef71174f682e4944$export$c175600e334513b4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $lfTZh = parcelRequire("lfTZh");

var $iXVV6 = parcelRequire("iXVV6");

var $kKpgF = parcelRequire("kKpgF");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef71174f682e4944$var$IssueApp = (0, $kxZPA.lazy)(()=>(parcelRequire("fvKUo")), {
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});
const $ef71174f682e4944$export$c175600e334513b4 = ({ issueKey: issueKey, onClose: onClose })=>{
    const { refetch: refetch } = (0, $kKpgF.useRefetchContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "versionDetailsIssue"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef71174f682e4944$var$DetailsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-app",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef71174f682e4944$var$IssueApp, {
        viewModeOptions: {
            viewMode: 'SIDEBAR'
        },
        issueKey: issueKey,
        shouldSetInitialFocus: true,
        shouldShowCloseButton: true // TODO: Once all fields used in the issue link component and the version
        ,
        // details issue list have been migrated to use Relay, we should be able to
        // remove the onChange callback used here, since the data will sync to the
        // Relay store without having to call "refetch" here
        onChange: (event)=>{
            if (event.type === 'FIELD_CHANGED') refetch();
        },
        onIssueDeleteSuccess: refetch,
        onClose: onClose,
        isLoadedWithPage: false,
        isSpaEnabled: false,
        analyticsSource: (0, $fcf97b7a09088940$export$5b73d694a6048002)
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ef71174f682e4944$var$DetailsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _1reo15vq",
            __cmplp.className
        ])
    });
});

});
const $fcf97b7a09088940$export$53d41ff2666118e1 = 'agility-backlog';
const $fcf97b7a09088940$export$7552fe2669628499 = 'bitbucket-issue';
const $fcf97b7a09088940$export$41a718da0a8636f4 = 'connect-issue';
const $fcf97b7a09088940$export$cebf0bc8b2ccaf57 = 'core-issue';
const $fcf97b7a09088940$export$5e91e17726e54450 = 'jiraCalendar';
const $fcf97b7a09088940$export$2dac1950892123f5 = 'jiraTimeline';
const $fcf97b7a09088940$export$82540942fb014b0a = 'business-calendar';
const $fcf97b7a09088940$export$7ca28938a07e0c33 = 'business-list';
const $fcf97b7a09088940$export$f6cf06aaaeb58a54 = 'business-timeline';
const $fcf97b7a09088940$export$b2c0462ff17aa26e = 'business-board';
const $fcf97b7a09088940$export$a607850ebccd28ac = 'business-approvals';
const $fcf97b7a09088940$export$1da6cede3561048f = 'business-files';
const $fcf97b7a09088940$export$b19f949fb9713614 = 'full-issue';
const $fcf97b7a09088940$export$a5132300c5214280 = 'embed-issue';
const $fcf97b7a09088940$export$710114090a811b37 = 'global-issue-navigator-issue';
const $fcf97b7a09088940$export$ce88447986394f2d = 'mobile-issue';
const $fcf97b7a09088940$export$6a90d9196d330040 = 'project-issue-navigator';
const $fcf97b7a09088940$export$2247c9059c171db1 = 'roadmap-issue';
const $fcf97b7a09088940$export$cd16d39c55c569d0 = 'simple-software-board';
const $fcf97b7a09088940$export$f72626bf0d75dfad = 'software-backlog-issue';
const $fcf97b7a09088940$export$778b4609e784cb27 = 'software-deployments-issue';
const $fcf97b7a09088940$export$5b73d694a6048002 = 'version-detail-issue';
const $fcf97b7a09088940$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $fcf97b7a09088940$export$21b5b7189add7861 = 'software-incidents-issue';
const $fcf97b7a09088940$export$9c5d81b901471b27 = 'software-issue';
const $fcf97b7a09088940$export$1735f6ad917dc411 = 'change-calendar';
const $fcf97b7a09088940$export$7063ee6d0035a982 = 'queues-issue-view';
const $fcf97b7a09088940$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $fcf97b7a09088940$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $fcf97b7a09088940$export$14a8072f422804fd = 'issue-navigator-next';
const $fcf97b7a09088940$export$5f3c20fe2ff6c0a2 = 'staffing-issue';

parcelRegister("kKpgF", function(module, exports) {

$parcel$export(module.exports, "RefetchContext", () => $9e925a1cf010fb08$export$9943e630ea9ac16a);
$parcel$export(module.exports, "useRefetchContext", () => $9e925a1cf010fb08$export$947d5554caab689a);

var $5uXOq = parcelRequire("5uXOq");
const $9e925a1cf010fb08$export$9943e630ea9ac16a = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $9e925a1cf010fb08$export$947d5554caab689a = ()=>{
    const refetchContext = (0, $5uXOq.useContext)($9e925a1cf010fb08$export$9943e630ea9ac16a);
    if (refetchContext == null) throw new Error('Version details refetch provider was not found');
    return refetchContext;
};

});

parcelRegister("fvKUo", function(module, exports) {

let $b4ae2354afeda4a9$var$load = (parcelRequire("28QjX"))(4);































module.exports = Promise.all([
    (parcelRequire("avM1e"))('thor_add_taskabort_events_for_core_experiences', function() {
        return Promise.all([
            $b4ae2354afeda4a9$var$load("kweCQ")
        ]);
    }, function() {
        return Promise.all([
            $b4ae2354afeda4a9$var$load("1f7yF")
        ]);
    }),
    (parcelRequire("avM1e"))('memo_fix_issue_field_remounts_2', function() {
        return Promise.all([
            $b4ae2354afeda4a9$var$load("1oP3P")
        ]);
    }, function() {
        return Promise.all([
            $b4ae2354afeda4a9$var$load("9ev6R")
        ]);
    }),
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $b4ae2354afeda4a9$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $b4ae2354afeda4a9$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('jirt-convert-class-to-functional-component', function() {
        return Promise.all([
            $b4ae2354afeda4a9$var$load("1ls92")
        ]);
    }, function() {
        return Promise.all([
            $b4ae2354afeda4a9$var$load("kLeYK")
        ]);
    }),
    (parcelRequire("avM1e"))('redaction_onboarding_iv_llc', function() {
        return Promise.all([
            $b4ae2354afeda4a9$var$load("czPin")
        ]);
    }, function() {
        return Promise.all([
            $b4ae2354afeda4a9$var$load("iGvP4")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $b4ae2354afeda4a9$var$load("czifk")
        ]);
    }, function() {
        return Promise.all([
            $b4ae2354afeda4a9$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('jiv-20591-renderer-rerenders-fix-refactor', function() {
        return Promise.all([
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-card-nodes', function() {
                return Promise.all([
                    $b4ae2354afeda4a9$var$load("lh7CA"),
                    $b4ae2354afeda4a9$var$load("kNFvF"),
                    $b4ae2354afeda4a9$var$load("kvRbA"),
                    $b4ae2354afeda4a9$var$load("ffQaD"),
                    $b4ae2354afeda4a9$var$load("l253H"),
                    $b4ae2354afeda4a9$var$load("76n7a"),
                    $b4ae2354afeda4a9$var$load("fliVL")
                ]);
            }, function() {
                return Promise.all([
                    $b4ae2354afeda4a9$var$load("jrRVX")
                ]);
            }),
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-media-nodes', function() {
                return Promise.all([
                    $b4ae2354afeda4a9$var$load("gXEyJ"),
                    $b4ae2354afeda4a9$var$load("kvRbA"),
                    $b4ae2354afeda4a9$var$load("ffQaD"),
                    $b4ae2354afeda4a9$var$load("l253H"),
                    $b4ae2354afeda4a9$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $b4ae2354afeda4a9$var$load("hy7ba")
                ]);
            }),
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-small-nodes', function() {
                return Promise.all([
                    $b4ae2354afeda4a9$var$load("d5z58"),
                    $b4ae2354afeda4a9$var$load("kvRbA"),
                    $b4ae2354afeda4a9$var$load("ffQaD"),
                    $b4ae2354afeda4a9$var$load("l253H"),
                    $b4ae2354afeda4a9$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $b4ae2354afeda4a9$var$load("f771T")
                ]);
            }),
            $b4ae2354afeda4a9$var$load("gDexj")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-card-nodes', function() {
                return Promise.all([
                    $b4ae2354afeda4a9$var$load("lh7CA"),
                    $b4ae2354afeda4a9$var$load("kNFvF"),
                    $b4ae2354afeda4a9$var$load("kvRbA"),
                    $b4ae2354afeda4a9$var$load("ffQaD"),
                    $b4ae2354afeda4a9$var$load("l253H"),
                    $b4ae2354afeda4a9$var$load("76n7a"),
                    $b4ae2354afeda4a9$var$load("fliVL")
                ]);
            }, function() {
                return Promise.all([
                    $b4ae2354afeda4a9$var$load("jrRVX")
                ]);
            }),
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-media-nodes', function() {
                return Promise.all([
                    $b4ae2354afeda4a9$var$load("gXEyJ"),
                    $b4ae2354afeda4a9$var$load("kvRbA"),
                    $b4ae2354afeda4a9$var$load("ffQaD"),
                    $b4ae2354afeda4a9$var$load("l253H"),
                    $b4ae2354afeda4a9$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $b4ae2354afeda4a9$var$load("hy7ba")
                ]);
            }),
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-small-nodes', function() {
                return Promise.all([
                    $b4ae2354afeda4a9$var$load("d5z58"),
                    $b4ae2354afeda4a9$var$load("kvRbA"),
                    $b4ae2354afeda4a9$var$load("ffQaD"),
                    $b4ae2354afeda4a9$var$load("l253H"),
                    $b4ae2354afeda4a9$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $b4ae2354afeda4a9$var$load("f771T")
                ]);
            }),
            $b4ae2354afeda4a9$var$load("hyyp4")
        ]);
    }),
    (parcelRequire("avM1e"))('jira_amplitude_sr', function() {
        return Promise.all([
            $b4ae2354afeda4a9$var$load("8EtZR"),
            $b4ae2354afeda4a9$var$load("kVX56")
        ]);
    }, function() {
        return Promise.all([
            $b4ae2354afeda4a9$var$load("6jOz3")
        ]);
    }),
    (parcelRequire("avM1e"))('jiv-20455-dev-panel-to-sync', function() {
        return Promise.all([
            (parcelRequire("avM1e"))('jiv-20508-remove-height-animation-dev-panel', function() {
                return Promise.all([
                    $b4ae2354afeda4a9$var$load("hm756")
                ]);
            }, function() {
                return Promise.all([]);
            }),
            (parcelRequire("avM1e"))('create-branch-dropdown-iv-llc-dev-panel', function() {
                return Promise.all([
                    $b4ae2354afeda4a9$var$load("46Z1D")
                ]);
            }, function() {
                return Promise.all([
                    $b4ae2354afeda4a9$var$load("3DKoG")
                ]);
            }),
            (parcelRequire("avM1e"))('create-commit-dropdown-iv-llc-dev-panel', function() {
                return Promise.all([
                    $b4ae2354afeda4a9$var$load("cNRxo")
                ]);
            }, function() {
                return Promise.all([
                    $b4ae2354afeda4a9$var$load("i8oWy")
                ]);
            }),
            (parcelRequire("avM1e"))('create_pullrequest_dropdown_iv_llc_dev_panel', function() {
                return Promise.all([
                    $b4ae2354afeda4a9$var$load("63C5i")
                ]);
            }, function() {
                return Promise.all([
                    $b4ae2354afeda4a9$var$load("lbT1q")
                ]);
            }),
            (parcelRequire("avM1e"))('create_pullrequest_dropdown_iv_llc_dev_panel', function() {
                return Promise.all([
                    $b4ae2354afeda4a9$var$load("63C5i")
                ]);
            }, function() {
                return Promise.all([
                    $b4ae2354afeda4a9$var$load("lbT1q")
                ]);
            }),
            (parcelRequire("avM1e"))('ff-action-dropdown-simple-iv-llc-dev-panel', function() {
                return Promise.all([
                    $b4ae2354afeda4a9$var$load("lIp00")
                ]);
            }, function() {
                return Promise.all([
                    $b4ae2354afeda4a9$var$load("cZoU9")
                ]);
            }),
            (parcelRequire("avM1e"))('ff-action-dropdown-simple-iv-llc-dev-panel', function() {
                return Promise.all([
                    $b4ae2354afeda4a9$var$load("lIp00")
                ]);
            }, function() {
                return Promise.all([
                    $b4ae2354afeda4a9$var$load("cZoU9")
                ]);
            }),
            (parcelRequire("avM1e"))('vulnerability-dropdown-iv-llc-dev-panel', function() {
                return Promise.all([
                    $b4ae2354afeda4a9$var$load("dsjsy")
                ]);
            }, function() {
                return Promise.all([
                    $b4ae2354afeda4a9$var$load("QeZ1l")
                ]);
            }),
            $b4ae2354afeda4a9$var$load("ckYFZ"),
            $b4ae2354afeda4a9$var$load("kvRbA"),
            $b4ae2354afeda4a9$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $b4ae2354afeda4a9$var$load("etgJj")
        ]);
    }),
    (parcelRequire("avM1e"))('details_loader_to_entrypoint_iv_llc_dev_panel', function() {
        return Promise.all([
            $b4ae2354afeda4a9$var$load("84z1X")
        ]);
    }, function() {
        return Promise.all([]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $b4ae2354afeda4a9$var$load("cTJTG"),
            $b4ae2354afeda4a9$var$load("l253H"),
            $b4ae2354afeda4a9$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $b4ae2354afeda4a9$var$load("4Qxp7")
        ]);
    }),
    (parcelRequire("avM1e"))('fix_versions_component_perf_improvement_vc90', function() {
        return Promise.all([
            $b4ae2354afeda4a9$var$load("6TXdv")
        ]);
    }, function() {
        return Promise.all([
            $b4ae2354afeda4a9$var$load("4t8fr")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $b4ae2354afeda4a9$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $b4ae2354afeda4a9$var$load("7B2gt")
        ]);
    }),
    (parcelRequire("avM1e"))('improve_issue_automation_button_iv_llc', function() {
        return Promise.all([
            $b4ae2354afeda4a9$var$load("5VTmG")
        ]);
    }, function() {
        return Promise.all([
            $b4ae2354afeda4a9$var$load("6mU2N"),
            $b4ae2354afeda4a9$var$load("kvRbA"),
            $b4ae2354afeda4a9$var$load("ffQaD")
        ]);
    }),
    (parcelRequire("avM1e"))('improve_issue_view_comment_ai', function() {
        return Promise.all([
            $b4ae2354afeda4a9$var$load("egvYO")
        ]);
    }, function() {
        return Promise.all([
            $b4ae2354afeda4a9$var$load("hkt2G")
        ]);
    }),
    (parcelRequire("avM1e"))('issue_comment_reply_list_sync_import', function() {
        return Promise.all([
            $b4ae2354afeda4a9$var$load("eZWUu")
        ]);
    }, function() {
        return Promise.all([
            $b4ae2354afeda4a9$var$load("aWylw")
        ]);
    }),
    (parcelRequire("avM1e"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $b4ae2354afeda4a9$var$load("7ClEP")
        ]);
    }),
    $b4ae2354afeda4a9$var$load("5BNUw"),
    $b4ae2354afeda4a9$var$load("kGAgW"),
    $b4ae2354afeda4a9$var$load("3yAl4"),
    $b4ae2354afeda4a9$var$load("fliVL"),
    $b4ae2354afeda4a9$var$load("7mIf9"),
    $b4ae2354afeda4a9$var$load("jXweD"),
    $b4ae2354afeda4a9$var$load("jbxE1"),
    $b4ae2354afeda4a9$var$load("7imUH"),
    $b4ae2354afeda4a9$var$load("ffQaD"),
    $b4ae2354afeda4a9$var$load("kvRbA"),
    $b4ae2354afeda4a9$var$load("kVX56"),
    $b4ae2354afeda4a9$var$load("kNFvF"),
    $b4ae2354afeda4a9$var$load("76n7a"),
    $b4ae2354afeda4a9$var$load("l253H"),
    $b4ae2354afeda4a9$var$load("gaip1")
]).then(()=>parcelRequire('6qbjz'));

});
parcelRegister("avM1e", function(module, exports) {
"use strict";
module.exports = function(cond, ifTrue, ifFalse) {
    return globalThis.__MCOND && globalThis.__MCOND(cond) ? ifTrue() : ifFalse();
};

});





parcelRegister("bUxbm", function(module, exports) {

$parcel$export(module.exports, "LaunchCardExperienceStart", () => $fb82eac9bfcd697e$export$5715f82a8f696e44);
$parcel$export(module.exports, "LaunchCardExperienceSuccess", () => $fb82eac9bfcd697e$export$8e01269c24812c16);
$parcel$export(module.exports, "useLaunchCardExperienceFail", () => $fb82eac9bfcd697e$export$207918c16c60fcae);

var $5uXOq = parcelRequire("5uXOq");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $efvDm = parcelRequire("efvDm");

var $k9JTq = parcelRequire("k9JTq");
const $fb82eac9bfcd697e$export$52919046b94109dc = 'launchCard';
const $fb82eac9bfcd697e$var$ANALYTICS_SOURCE = 'versionDetails';
const $fb82eac9bfcd697e$export$5715f82a8f696e44 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kaHBi.ExperienceStart), {
        experienceId: `${Date.now()}`,
        experience: $fb82eac9bfcd697e$export$52919046b94109dc,
        analyticsSource: $fb82eac9bfcd697e$var$ANALYTICS_SOURCE,
        edition: appEditions.software,
        application: (0, $efvDm.JIRA_SOFTWARE)
    });
};
const $fb82eac9bfcd697e$export$8e01269c24812c16 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: $fb82eac9bfcd697e$export$52919046b94109dc
    });
const $fb82eac9bfcd697e$export$207918c16c60fcae = ()=>(0, $93jKl.useExperienceFail)({
        experience: $fb82eac9bfcd697e$export$52919046b94109dc
    });

});

parcelRegister("3hn4w", function(module, exports) {

$parcel$export(module.exports, "LaunchCard", () => $2aeba785f1edbf18$export$1c9fa03e23146e86);

var $iQkgm = parcelRequire("iQkgm");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");
var $j7rCb = parcelRequire("j7rCb");

var $dOfO1 = parcelRequire("dOfO1");

var $oH05V = parcelRequire("oH05V");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2aeba785f1edbf18$var$LazyLaunchCard = (0, $kxZPA.lazyAfterPaint)(()=>Promise.resolve((parcelRequire("dOfO1"))).then((module)=>module.LaunchCard), {
    ssr: false,
    moduleId: "./src/packages/releases/launch-card/src/ui/index.tsx"
});
const $2aeba785f1edbf18$export$669f6ea7d267feaf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $oH05V.LoadingWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dOfO1.BaseWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dOfO1.MainContentWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $oH05V.StatusLoading), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $oH05V.TwoColumnFieldWrapper), {
        height: 63
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $oH05V.FieldLoadingWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $oH05V.FieldLabelLoading), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $oH05V.FieldContentLoading), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $oH05V.FieldLoadingWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $oH05V.FieldLabelLoading), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $oH05V.FieldContentLoading), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $oH05V.TwoColumnFieldWrapper), {
        height: 52
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $oH05V.FieldLoadingWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $oH05V.FieldLabelLoading), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $oH05V.FieldContentLoading), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $oH05V.FieldLoadingWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $oH05V.FieldLabelLoading), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $oH05V.FieldContentLoading), null))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $oH05V.LatestDeploymentLoading), null));
const $2aeba785f1edbf18$export$1c9fa03e23146e86 = ({ jiraVersion: jiraVersion })=>{
    const { startNextPhase: startNextPhase } = (0, $j7rCb.useLazyPhase)();
    (0, $5uXOq.useEffect)(()=>{
        startNextPhase();
    }, [
        startNextPhase
    ]);
    const version = (0, $8Uumt.useFragment)((0, $iQkgm.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "version-detail-launch-card",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2aeba785f1edbf18$export$669f6ea7d267feaf, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2aeba785f1edbf18$var$LazyLaunchCard, {
        jiraVersion: version
    }));
};

});
parcelRegister("iQkgm", function(module, exports) {

$parcel$export(module.exports, "default", () => $55a744d530504a92$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f0fe1a4283ec3216e0228279fe31b9ed>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $55a744d530504a92$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "async_softwareReleasesLaunchCard_LaunchCard",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesLaunchCard_LaunchCard"
        }
    ],
    "type": "JiraVersion"
};
$55a744d530504a92$var$node.hash = "ed744d145282aafc0de30b038a930975";
var $55a744d530504a92$export$2e2bcd8739ae039 = $55a744d530504a92$var$node;

});

parcelRegister("dOfO1", function(module, exports) {

$parcel$export(module.exports, "LaunchCard", () => $47690f766058ef99$export$1c9fa03e23146e86);
$parcel$export(module.exports, "BaseWrapper", () => $47690f766058ef99$export$c07bd9612bb2b971);
$parcel$export(module.exports, "MainContentWrapper", () => $47690f766058ef99$export$7f55214bcae58e5d);

var $84BNJ = parcelRequire("84BNJ");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $lfTZh = parcelRequire("lfTZh");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $5ZT5S = parcelRequire("5ZT5S");

var $UvyUC = parcelRequire("UvyUC");

var $kfztd = parcelRequire("kfztd");

var $j4AZh = parcelRequire("j4AZh");

var $g08V3 = parcelRequire("g08V3");

var $cbARR = parcelRequire("cbARR");

var $bUxbm = parcelRequire("bUxbm");

var $gl90z = parcelRequire("gl90z");

var $aRLM0 = parcelRequire("aRLM0");

var $gPH8i = parcelRequire("gPH8i");

var $lFoXK = parcelRequire("lFoXK");
const $47690f766058ef99$export$1c9fa03e23146e86 = ({ jiraVersion: jiraVersion })=>{
    const version = (0, $8Uumt.useFragment)((0, $84BNJ.default), jiraVersion);
    const [contributorsQueryRef, loadContributorsQuery] = (0, $8Uumt.useQueryLoader)((0, $5ZT5S.default));
    const [preconditionQueryRef, loadPreconditionQuery] = (0, $8Uumt.useQueryLoader)((0, $UvyUC.default));
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $kfztd.isDevopsFeatureDisabledInFedRamp)()) {
            loadContributorsQuery({
                versionId: version.id
            });
            loadPreconditionQuery({
                cloudId: version.project.cloudId,
                projectKey: version.project.key
            });
        }
    }, [
        loadPreconditionQuery,
        loadContributorsQuery,
        version.project.cloudId,
        version.project.key,
        version.id
    ]);
    const hasDriver = version.driverData?.driver?.id;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "launchCard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            hasDriver: Boolean(hasDriver),
            versionAri: version.id
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47690f766058ef99$export$c07bd9612bb2b971, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUxbm.LaunchCardExperienceSuccess), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47690f766058ef99$export$7f55214bcae58e5d, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lFoXK.AsyncVersionStatus), {
        jiraVersion: version
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gPH8i.VersionDates), {
        jiraVersion: version
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47690f766058ef99$var$UserFieldsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47690f766058ef99$var$FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cbARR.NonCriticalErrorBoundary), {
        eventLocation: "launchCardDriverField",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j4AZh.DriverField), {
        id: "jira-version-driver-field",
        jiraVersion: version,
        isDisabled: !version.canEdit
    }))), !(0, $kfztd.isDevopsFeatureDisabledInFedRamp)() && contributorsQueryRef && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cbARR.NonCriticalErrorBoundary), {
        eventLocation: "launchCardContributorsField",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "version-contributors-section",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRLM0.VersionContributorsSectionSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRLM0.AsyncVersionContributors), {
        queryRef: contributorsQueryRef
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g08V3.VersionSummaryDescription), {
        jiraVersion: version
    })), !(0, $kfztd.isDevopsFeatureDisabledInFedRamp)() && preconditionQueryRef && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cbARR.NonCriticalErrorBoundary), {
        eventLocation: "launchCardLatestDeployment",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "latest-deployment",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gl90z.LatestDeployment), {
        jiraVersion: version,
        preconditionQueryRef: preconditionQueryRef
    })))));
};
const $47690f766058ef99$export$c07bd9612bb2b971 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _1tke18pt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $47690f766058ef99$export$7f55214bcae58e5d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulppxbi _1e0c1txw _2lx21bp4 _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $47690f766058ef99$var$UserFieldsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $47690f766058ef99$var$FieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _prventd2",
            __cmplp.className
        ])
    });
});

});
parcelRegister("84BNJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b6ca2060ba85a7a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f96eb60322e20c3737f125a0da9e9580>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2b6ca2060ba85a7a$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "isDevopsFeatureDisabledInFedRamp"
            }
        ],
        "kind": "Fragment",
        "name": "ui_softwareReleasesLaunchCard_LaunchCard",
        "selections": [
            {
                "condition": "isDevopsFeatureDisabledInFedRamp",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "latestDeployment_softwareReleasesLaunchCard_jiraVersion"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "versionDates_softwareReleasesLaunchCard"
            },
            {
                "kind": "FragmentSpread",
                "name": "async_softwareReleasesLaunchCard_AsyncVersionStatus"
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesVersionDriverField_DriverField"
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesVersionSummaryDescription_VersionSummaryDescription"
            },
            {
                "kind": "RequiredField",
                "field": v0 /*: any*/ ,
                "action": "THROW",
                "path": "id"
            },
            {
                "concreteType": "JiraVersionDriverResult",
                "kind": "LinkedField",
                "name": "driverData",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "driver",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "canEdit"
                },
                "action": "THROW",
                "path": "canEdit"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "cloudId"
                            },
                            "action": "THROW",
                            "path": "project.cloudId"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            "action": "THROW",
                            "path": "project.key"
                        }
                    ]
                },
                "action": "THROW",
                "path": "project"
            }
        ],
        "type": "JiraVersion"
    };
}();
$2b6ca2060ba85a7a$var$node.hash = "d06ed52a13ffedc171f425ef28503077";
var $2b6ca2060ba85a7a$export$2e2bcd8739ae039 = $2b6ca2060ba85a7a$var$node;

});

parcelRegister("5ZT5S", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ad75b9326d93548$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c60b4cdcb35ffcf99e9dac7ab120eb4d>>
 * @relayHash 25bb212fb9dcb165ca802d31818fab42
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b199f8523e8b333f650adf93ec0ebc73c3b0927f50a3fec2c9c3769918fbeb9b
const $0ad75b9326d93548$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "async_softwareReleasesVersionContributorsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "async_softwareReleasesLaunchCard_AsyncVersionContributors"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.version"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "async_softwareReleasesVersionContributorsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersionContributorConnection",
                                            "kind": "LinkedField",
                                            "name": "contributors",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraVersionContributorEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v2 /*: any*/ ,
                                                                v3 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "name"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "picture"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "AtlassianAccountUserExtendedProfile",
                                                                            "kind": "LinkedField",
                                                                            "name": "extendedProfile",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "jobTitle"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "AtlassianAccountUser"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraVersion"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b199f8523e8b333f650adf93ec0ebc73c3b0927f50a3fec2c9c3769918fbeb9b",
            "metadata": {},
            "name": "async_softwareReleasesVersionContributorsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0ad75b9326d93548$var$node.hash = "0dd2c9bd66e5b70949d165995607196b";
var $0ad75b9326d93548$export$2e2bcd8739ae039 = $0ad75b9326d93548$var$node;

});

parcelRegister("UvyUC", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4dcda02f1d11bab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<404f0936c589f2bac5fc9b25c6f0c25c>>
 * @relayHash 6139c5ac9eede3cb4cb45119f82b6c42
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 73bb0607fa286f014e98ee150a452d0808aff2ce4aa135ef04b8f21d5ea34326
const $e4dcda02f1d11bab$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }
    ], v1 = {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    },
                    {
                        "kind": "Variable",
                        "name": "projectKey",
                        "variableName": "projectKey"
                    }
                ],
                "kind": "ScalarField",
                "name": "deploymentsFeaturePreconditionByProjectKey"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "latestDeploymentForVersionPreconditionQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": v1 /*: any*/ ,
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "latestDeploymentForVersionPreconditionQuery",
            "selections": [
                v1 /*: any*/ 
            ]
        },
        "params": {
            "id": "73bb0607fa286f014e98ee150a452d0808aff2ce4aa135ef04b8f21d5ea34326",
            "metadata": {},
            "name": "latestDeploymentForVersionPreconditionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e4dcda02f1d11bab$var$node.hash = "af15b08c11e01f89f1bd0ec84b873d12";
var $e4dcda02f1d11bab$export$2e2bcd8739ae039 = $e4dcda02f1d11bab$var$node;

});

parcelRegister("j4AZh", function(module, exports) {

$parcel$export(module.exports, "DriverFieldStateless", () => $03e02fffe7dd8b75$export$9ede53742ae13d69);
$parcel$export(module.exports, "DriverField", () => $03e02fffe7dd8b75$export$4de1488fc0a2d937);

var $ikYP0 = parcelRequire("ikYP0");

var $5U9u0 = parcelRequire("5U9u0");

var $iZZEz = parcelRequire("iZZEz");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $dS3PR = parcelRequire("dS3PR");

var $cr0SA = parcelRequire("cr0SA");

var $gwIPs = parcelRequire("gwIPs");

var $jcw0u = parcelRequire("jcw0u");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");

var $4bzfE = parcelRequire("4bzfE");

var $arKXI = parcelRequire("arKXI");
const $03e02fffe7dd8b75$var$isOptionData = (val)=>val != null && typeof val.name === 'string' && typeof val.id === 'string';
const $03e02fffe7dd8b75$var$createLoadQueryFunc = (environment, cloudId, projectAri)=>(searchText)=>(0, $8Uumt.fetchQuery)(environment, (0, $iZZEz.default), {
            projectAri: projectAri,
            searchText: searchText
        }, {
            fetchPolicy: 'store-or-network'
        }).toPromise().then(// @ts-expect-error - TS2345 - Argument of type '(response: Response) => void' is not assignable to parameter of type '(value: unknown) => void | PromiseLike<void>'.
        (response)=>{
            const edges = response.jira.jiraProject.suggestedDriversForJiraVersion?.edges ?? [];
            return edges.filter(Boolean).map((edge)=>edge?.node).map((user)=>user == null ? null : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                    avatarUrl: user.picture,
                    name: user.name,
                    id: user.accountId,
                    byline: user?.extendedProfile?.jobTitle ?? '',
                    type: 'user'
                }).filter($03e02fffe7dd8b75$var$isOptionData);
        }).catch((error)=>{
            (0, $jcw0u.default)({
                meta: {
                    id: 'ui_versionDriverFieldQuery',
                    packageName: 'jiraSoftwareReleasesVersionDriverField'
                },
                error: error
            }); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return [];
        });
const $03e02fffe7dd8b75$export$9ede53742ae13d69 = ({ width: width, id: id, projectId: projectId, initialDriverValue: initialDriverValue, onChange: onChange, isDisplayLabel: isDisplayLabel = true, isRenderedInModal: isRenderedInModal = false, menuPortalTargetRef: menuPortalTargetRef, isDisabled: isDisabled = false, isDisplayBorder: isDisplayBorder = false, ariaLabelledBy: ariaLabelledBy })=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const menuPortalTarget = menuPortalTargetRef && menuPortalTargetRef.current;
    const loadOptions = $03e02fffe7dd8b75$var$createLoadQueryFunc(environment, cloudId, `ari:cloud:jira:${cloudId}:project/${projectId}`);
    const experienceStart = (0, $4bzfE.useUpdateDriverExperienceStart)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03e02fffe7dd8b75$var$Wrapper, null, isDisplayLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        size: "UNSAFE_small",
        weight: "bold",
        color: "color.text.subtle",
        as: "p"
    }, formatMessage((0, $arKXI.default).fieldLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03e02fffe7dd8b75$var$PlacholderStyleOverrider, {
        isDisplayBorder: isDisplayBorder
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cr0SA.UserPicker), {
        fieldId: "jiraVersionDriver",
        inputId: id,
        ariaLabelledBy: ariaLabelledBy,
        loadOptions: loadOptions,
        isDisabled: isDisabled,
        width: width,
        menuPortalTarget: isRenderedInModal ? menuPortalTarget || document.body : undefined,
        styles: isRenderedInModal && !menuPortalTarget ? {
            menuPortal: (base)=>({
                    ...base,
                    zIndex: 9999
                })
        } : undefined,
        menuMinWidth: 33 * (0, $gwIPs.gridSize),
        defaultValue: initialDriverValue,
        placeholder: formatMessage((0, $arKXI.default).unassigned),
        onChange: (value)=>{
            // it is single select, so it should never be an array
            if (Array.isArray(value)) return;
            onChange?.(value == null ? null : value);
        },
        onFocus: ()=>experienceStart(),
        onClear: ()=>experienceStart()
    })));
};
const $03e02fffe7dd8b75$export$4de1488fc0a2d937 = ({ jiraVersion: jiraVersion, width: width, onChange: onChange, isDisplayLabel: isDisplayLabel = true, isRenderedInModal: isRenderedInModal = false, isDisabled: isDisabled = false, isDisplayBorder: isDisplayBorder = false, ariaLabelledBy: ariaLabelledBy, id: id })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const experienceFail = (0, $4bzfE.useUpdateDriverExperienceFail)();
    const experienceSuccess = (0, $4bzfE.useUpdateDriverExperienceSuccess)();
    const version = (0, $8Uumt.useFragment)((0, $5U9u0.default), jiraVersion);
    const versionAri = version.id;
    const { projectId: projectId } = version.project;
    const onMutationError = (error)=>{
        experienceFail('graphql error', error);
        (0, $jcw0u.default)({
            meta: {
                id: 'jira.releases.release-modals-relay.create-release-modal',
                packageName: 'jiraSoftwareReleasesVersionDriverField',
                teamName: 'nova'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        showFlag({
            title: formatMessage((0, $arKXI.default).genericErrorFlagTitle),
            description: formatMessage((0, $arKXI.default).genericErrorFlagDescription),
            type: 'error',
            messageId: 'software-releases-version-driver-field.ui.show-flag.error',
            messageType: 'transactional'
        });
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const analyticEvent = createAnalyticsEvent({
        action: 'updated',
        actionSubject: 'versionDriver'
    });
    const [updateDriverOnVersion] = (0, $8Uumt.useMutation)((0, $ikYP0.default));
    const driverError = version.driverData?.queryError?.message;
    if (driverError != null) throw new Error('Received QueryError when fetching driver');
    const driver = version?.driverData?.driver;
    const currentlySetDriver = driver == null ? undefined : {
        avatarUrl: driver.picture,
        name: driver.name,
        id: driver.accountId
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03e02fffe7dd8b75$export$9ede53742ae13d69, {
        id: id,
        width: width,
        ariaLabelledBy: ariaLabelledBy,
        projectId: projectId,
        initialDriverValue: currentlySetDriver,
        isDisplayLabel: isDisplayLabel,
        isRenderedInModal: isRenderedInModal,
        isDisabled: isDisabled,
        isDisplayBorder: isDisplayBorder,
        onChange: (newDriver)=>{
            updateDriverOnVersion({
                variables: {
                    input: {
                        id: versionAri,
                        driver: newDriver?.id
                    }
                },
                onCompleted: (data)=>{
                    if (data.jira?.updateJiraVersionDriver?.success !== true) {
                        const responseErrors = data?.jira?.updateJiraVersionDriver?.errors;
                        const errorMessage = responseErrors?.[0]?.message ?? 'updateJiraVersionDriver graphql mutation failed';
                        onMutationError(new Error(errorMessage));
                        return;
                    }
                    experienceSuccess();
                    (0, $8zOmE.fireTrackAnalytics)(analyticEvent, 'versionDriver updated', {
                        isDriverSet: Boolean(newDriver?.id)
                    });
                },
                onError: (error)=>{
                    onMutationError(error);
                }
            });
            onChange?.(newDriver);
        }
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $03e02fffe7dd8b75$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _1e0c1txw _2lx21bp4 _4cvr1fhb",
            __cmplp.className
        ])
    });
});
const $03e02fffe7dd8b75$var$PlacholderStyleOverrider = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisplayBorder: isDisplayBorder, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1owr16oo _1q5411p5 _16vph2mm _14od1wug _1etn1wug _1ospglyw _djrp1mxx",
            !__cmplp.isDisplayBorder && "_18u0196n _hfmuglyw _16daglyw _wadh1d5g",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ikYP0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7805576ba101a14b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ba9e18fc7e4b7dc6d70a6d3ca1bcf0ee>>
 * @relayHash 1f0e21f625d813fb1281d39baff3148c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3cad693b4ea2b82d83662a6f0beed697af820a42940984a0b7163b2529d57855
const $7805576ba101a14b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_updateDriverMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateJiraVersionDriver",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_updateDriverMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateJiraVersionDriver",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        },
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3cad693b4ea2b82d83662a6f0beed697af820a42940984a0b7163b2529d57855",
            "metadata": {},
            "name": "ui_updateDriverMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$7805576ba101a14b$var$node.hash = "08128527381c648c0856caf35f97d544";
var $7805576ba101a14b$export$2e2bcd8739ae039 = $7805576ba101a14b$var$node;

});

parcelRegister("5U9u0", function(module, exports) {

$parcel$export(module.exports, "default", () => $365e59b576a32814$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b301f0c56f2e8ec78c0ba5c963f8e2bd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $365e59b576a32814$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_softwareReleasesVersionDriverField_DriverField",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "projectId"
                        },
                        "action": "THROW",
                        "path": "project.projectId"
                    }
                ]
            },
            "action": "THROW",
            "path": "project"
        },
        {
            "concreteType": "JiraVersionDriverResult",
            "kind": "LinkedField",
            "name": "driverData",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "driver",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "accountId"
                            },
                            "action": "THROW",
                            "path": "driverData.driver.accountId"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "name"
                            },
                            "action": "THROW",
                            "path": "driverData.driver.name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "picture"
                        }
                    ]
                },
                {
                    "concreteType": "QueryError",
                    "kind": "LinkedField",
                    "name": "queryError",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraVersion"
};
$365e59b576a32814$var$node.hash = "699193bd41c7f6c4d596a3dd505592df";
var $365e59b576a32814$export$2e2bcd8739ae039 = $365e59b576a32814$var$node;

});

parcelRegister("iZZEz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cc7275cef8e6e23$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4ce245015522b195c8b0a32bd953b6ff>>
 * @relayHash 1cc363ec0a8878a3883c74210aec4e75
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5e4bfaa8a1dd598e42c24a483ee126347ef0d95303b3b6ad086a329116bc4bfc
const $6cc7275cef8e6e23$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "searchText"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectAri"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "searchText",
            "variableName": "searchText"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "AtlassianAccountUserExtendedProfile",
                "kind": "LinkedField",
                "name": "extendedProfile",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jobTitle"
                    }
                ]
            }
        ],
        "type": "AtlassianAccountUser"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_versionDriverFieldQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v2 /*: any*/ ,
                                            "concreteType": "JiraVersionDriverConnection",
                                            "kind": "LinkedField",
                                            "name": "suggestedDriversForJiraVersion",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraVersionDriverEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v3 /*: any*/ ,
                                                                        "action": "THROW",
                                                                        "path": "jira.jiraProject.suggestedDriversForJiraVersion.edges.node.accountId"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v4 /*: any*/ ,
                                                                        "action": "THROW",
                                                                        "path": "jira.jiraProject.suggestedDriversForJiraVersion.edges.node.name"
                                                                    },
                                                                    v5 /*: any*/ ,
                                                                    v6 /*: any*/ 
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "jira.jiraProject.suggestedDriversForJiraVersion.edges.node"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProject"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_versionDriverFieldQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProject",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraVersionDriverConnection",
                                    "kind": "LinkedField",
                                    "name": "suggestedDriversForJiraVersion",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersionDriverEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5e4bfaa8a1dd598e42c24a483ee126347ef0d95303b3b6ad086a329116bc4bfc",
            "metadata": {},
            "name": "ui_versionDriverFieldQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6cc7275cef8e6e23$var$node.hash = "43d45f30b77d193c46e6ddd3e1cb725a";
var $6cc7275cef8e6e23$export$2e2bcd8739ae039 = $6cc7275cef8e6e23$var$node;

});

parcelRegister("cr0SA", function(module, exports) {

$parcel$export(module.exports, "UserPicker", () => $ee13645786fb45b4$export$83e0c73b09b3a9cd);
/* UserPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $cb25w = parcelRequire("cb25w");

var $iOwNT = parcelRequire("iOwNT");
var $7K5PP = parcelRequire("7K5PP");

var $jZA09 = parcelRequire("jZA09");

var $5uXOq = parcelRequire("5uXOq");

var $d3gzD = parcelRequire("d3gzD");

var $2wgOn = parcelRequire("2wgOn");

var $dyegP = parcelRequire("dyegP");

var $fuG1P = parcelRequire("fuG1P");

var $hcX3V = parcelRequire("hcX3V");

var $hrO1B = parcelRequire("hrO1B");

var $2vFqP = parcelRequire("2vFqP");

var $pk97C = parcelRequire("pk97C");

var $7Jxgt = parcelRequire("7Jxgt");

var $VSDnB = parcelRequire("VSDnB");
class $ee13645786fb45b4$export$164f4d95e5d7e2f5 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.ufoId = (0, $7Jxgt.v4)();
        const experienceForId = (0, $pk97C.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        if (![
            (0, $jZA09.UFOExperienceState).IN_PROGRESS.id,
            (0, $jZA09.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.start();
    }
    static{
        this.defaultProps = {
            width: 350,
            isMulti: false
        };
    }
    componentDidMount() {
        const experienceForId = (0, $pk97C.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        // Send UFO success if the experience is still in progress i.e. hasn't failed
        if ([
            (0, $jZA09.UFOExperienceState).IN_PROGRESS.id,
            (0, $jZA09.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.success();
    }
    render() {
        const { emailLabel: emailLabel, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, isMulti: isMulti, isValidEmail: isValidEmail, anchor: anchor, menuPortalTarget: menuPortalTarget, menuPosition: menuPosition, menuShouldBlockScroll: menuShouldBlockScroll, captureMenuScroll: captureMenuScroll, closeMenuOnScroll: closeMenuOnScroll, loadUserSource: loadUserSource, required: required = false, showClearIndicator: showClearIndicator = false } = this.props;
        const width = this.props.width;
        const SelectComponent = allowEmail ? (0, $iOwNT.default) : (0, $7K5PP.default);
        const creatableProps = suggestEmailsForDomain ? (0, $hcX3V.getCreatableSuggestedEmailProps)(suggestEmailsForDomain, isValidEmail) : (0, $fuG1P.getCreatableProps)(isValidEmail);
        const defaultPickerProps = {
            closeMenuOnScroll: closeMenuOnScroll,
            menuPortalTarget: menuPortalTarget,
            menuPosition: menuPosition,
            menuShouldBlockScroll: menuShouldBlockScroll,
            captureMenuScroll: captureMenuScroll,
            required: required
        };
        const pickerProps = allowEmail ? {
            ...defaultPickerProps,
            ...creatableProps,
            emailLabel: emailLabel
        } : {
            ...defaultPickerProps
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $pk97C.UfoErrorBoundary), {
            id: this.ufoId,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hrO1B.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2vFqP.ExusUserSourceProvider), {
                    fetchUserSource: loadUserSource,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d3gzD.BaseUserPickerWithoutAnalytics), {
                        ...this.props,
                        forwardedRef: this.props.forwardedRef,
                        width: width,
                        SelectComponent: SelectComponent,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        styles: (0, $2wgOn.getStyles)(width, isMulti, this.props.appearance === 'compact', this.props.styles, this.props.isInvalid, // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                        (0, $VSDnB.fg)('platform-component-visual-refresh')),
                        components: (0, $dyegP.getComponents)(isMulti, anchor, showClearIndicator, this.props?.components ? this.props.components : {}),
                        pickerProps: pickerProps
                    })
                })
            })
        });
    }
}
const $ee13645786fb45b4$export$83e0c73b09b3a9cd = (0, $cb25w.default)()($ee13645786fb45b4$export$164f4d95e5d7e2f5);

});
parcelRegister("iOwNT", function(module, exports) {

$parcel$export(module.exports, "default", () => $59b6485f0cb008dd$export$2e2bcd8739ae039);

var $9OU1i = parcelRequire("9OU1i");

var $3c98u = parcelRequire("3c98u");
const $59b6485f0cb008dd$var$CreatableSelect = (0, $3c98u.default)((0, $9OU1i.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$59b6485f0cb008dd$export$2e2bcd8739ae039 = $59b6485f0cb008dd$var$CreatableSelect;

});
parcelRegister("9OU1i", function(module, exports) {

$parcel$export(module.exports, "default", () => $b29f1caecd9c7d5a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useCreatable", () => (parcelRequire("2HH7Y")).default);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2QhWf = parcelRequire("2QhWf");

var $2HH7Y = parcelRequire("2HH7Y");

var $9uJ4X = parcelRequire("9uJ4X");
const $b29f1caecd9c7d5a$var$CreatableSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const creatableProps = (0, $9uJ4X.default)(props);
    const selectProps = (0, $2HH7Y.default)(creatableProps);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2QhWf.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b29f1caecd9c7d5a$export$2e2bcd8739ae039 = $b29f1caecd9c7d5a$var$CreatableSelect;

});
parcelRegister("2HH7Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $994aeb783b6f955a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eEtcC = parcelRequire("eEtcC");

var $gyjU7 = parcelRequire("gyjU7");
const $994aeb783b6f955a$var$compareOption = (inputValue = '', option, accessors)=>{
    const candidate = String(inputValue).toLowerCase();
    const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
const $994aeb783b6f955a$var$builtins = {
    formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
    isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$994aeb783b6f955a$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$994aeb783b6f955a$var$compareOption(inputValue, option, accessors))),
    getNewOptionData: (inputValue, optionLabel)=>({
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        })
};
function $994aeb783b6f955a$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $994aeb783b6f955a$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $994aeb783b6f955a$var$builtins.isValidNewOption, getNewOptionData: //@ts-ignore
getNewOptionData = $994aeb783b6f955a$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
    const { getOptionValue: getOptionValue = (0, $eEtcC.getOptionValue), getOptionLabel: getOptionLabel = (0, $eEtcC.getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
    const newOption = (0, $5uXOq.useMemo)(()=>isValidNewOption(inputValue, (0, $gyjU7.cleanValue)(value), propsOptions, {
            getOptionValue: getOptionValue,
            getOptionLabel: getOptionLabel
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel,
        getOptionValue,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    const options = (0, $5uXOq.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption,
            ...propsOptions
        ] : [
            ...propsOptions,
            newOption
        ] : propsOptions, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    const onChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        const valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                const newOptionData = getNewOptionData(inputValue, inputValue);
                const newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $gyjU7.valueTernary)(isMulti, [
                    ...(0, $gyjU7.cleanValue)(value),
                    newOptionData
                ], newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return {
        ...restSelectProps,
        options: options,
        onChange: onChange
    };
}

});



parcelRegister("d3gzD", function(module, exports) {

$parcel$export(module.exports, "BaseUserPickerWithoutAnalytics", () => $d045e9522a427a64$export$b4ff48c8d43b18c3);

var $2OMIu = parcelRequire("2OMIu");

var $cb25w = parcelRequire("cb25w");

var $VSDnB = parcelRequire("VSDnB");

var $jZA09 = parcelRequire("jZA09");

var $lFKmC = parcelRequire("lFKmC");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $7Jxgt = parcelRequire("7Jxgt");

var $fUmMr = parcelRequire("fUmMr");

var $78Gdn = parcelRequire("78Gdn");

var $8fG8p = parcelRequire("8fG8p");

var $3smIt = parcelRequire("3smIt");

var $01LKK = parcelRequire("01LKK");

var $pk97C = parcelRequire("pk97C");
const $d045e9522a427a64$var$loadingMessage = ()=>null;
const $d045e9522a427a64$var$classNamePrefix = 'fabric-user-picker';
class $d045e9522a427a64$export$b4ff48c8d43b18c3 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isMulti: false,
            subtle: false,
            noBorder: false,
            textFieldBackgroundColor: false,
            isClearable: true,
            loadOptionsErrorMessage: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $8fG8p.messages).errorMessage
                }),
            openMenuOnClick: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const derivedState = {};
        if (nextProps.isDisabled || nextProps.disableInput) derivedState.menuIsOpen = false;
        if (nextProps.open !== undefined) derivedState.menuIsOpen = nextProps.open;
        if (nextProps.value !== undefined) derivedState.value = (0, $3smIt.optionToSelectableOptions)(nextProps.value);
        else if ((0, $3smIt.isDefaultValuePopulated)(nextProps.defaultValue) && !prevState.isDefaultSet) {
            derivedState.value = (0, $3smIt.optionToSelectableOptions)(nextProps.defaultValue);
            derivedState.isDefaultSet = true;
        }
        if (nextProps.search !== undefined && nextProps.search !== prevState.inputValue) derivedState.inputValue = nextProps.search;
        if (nextProps.options !== undefined) derivedState.options = nextProps.options;
        return derivedState;
    }
    constructor(props){
        super(props), this.getSessionId = ()=>this.session && this.session.id ? this.session.id : undefined, this.withSelectRef = (callback)=>()=>{
                if (this.selectRef) callback(this.selectRef);
            }, this.nextOption = this.withSelectRef((select)=>select.focusOption('down')), this.previousOption = this.withSelectRef((select)=>select.focusOption('up')), this.focus = ()=>{
            if (this.selectRef && this.selectRef.focus) this.selectRef.focus();
        }, this.blur = ()=>{
            if (this.selectRef && this.selectRef.blur) this.selectRef.blur();
        }, this.selectOption = this.withSelectRef((select)=>{
            const focusedOption = select.state.focusedOption;
            select.selectOption(focusedOption);
        }), // value = null if user deletes the last item in the user picker
        this.handleChange = (value, { action: action, removedValue: removedValue, option: option })=>{
            if (removedValue && removedValue.data.fixed) return;
            this.resetInputState();
            const { onChange: onChange, onSelection: onSelection, onClear: onClear, isMulti: isMulti } = this.props;
            (0, $3smIt.callCallback)(onChange, (0, $3smIt.extractOptionValue)(value), action);
            switch(action){
                case 'select-option':
                    if (value) (0, $3smIt.callCallback)(onSelection, (0, $3smIt.extractOptionValue)(value), this.getSessionId(), this);
                    this.fireEvent((0, $fUmMr.selectEvent), isMulti ? option : value);
                    this.session = isMulti ? (0, $fUmMr.startSession)() : undefined;
                    break;
                case 'clear':
                    (0, $3smIt.callCallback)(onClear);
                    this.fireEvent((0, $fUmMr.clearEvent));
                    break;
                case 'remove-value':
                case 'pop-value':
                    if (removedValue) this.fireEvent((0, $fUmMr.deleteEvent), removedValue.data);
                    break;
            }
            this.fireEvent((0, $fUmMr.searchedEvent));
            if (removedValue && this.state.value && Array.isArray(this.state.value)) {
                const remainingValues = this.state.value.filter((val)=>val.data.id !== removedValue.data.id);
                this.setState({
                    value: remainingValues ? remainingValues : [],
                    menuIsOpen: true
                });
            }
            if (!this.props.value) this.setState({
                value: value ? value : []
            });
        }, this.handleSelectRef = (ref)=>{
            this.selectRef = ref;
        }, this.addOptions = (0, $78Gdn.batchByKey)((request, newOptions)=>{
            const { resolving: resolving } = this.state;
            this.setState(({ inflightRequest: inflightRequest, options: options, count: count })=>{
                if (inflightRequest.toString() === request) return {
                    options: (resolving ? options : []).concat(newOptions.reduce((nextOptions, item)=>Array.isArray(item) ? nextOptions.concat(item[0]) : nextOptions.concat(item), [])),
                    count: count - newOptions.length,
                    resolving: count - newOptions.length !== 0
                };
                return null;
            });
        }), this.handleLoadOptionsError = ()=>{
            const { count: count } = this.state;
            const newCount = count - 1;
            const resolving = newCount !== 0;
            let showError = false;
            if (!resolving) showError = true;
            this.setState({
                count: newCount,
                resolving: resolving,
                showError: showError
            });
            this.fireEvent((0, $fUmMr.failedEvent));
        }, this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) {
                const inflightRequest = this.state.inflightRequest + 1;
                const result = this.session && this.session.id ? loadOptions(search, this.session.id) : loadOptions(search);
                const addOptions = this.addOptions.bind(this, inflightRequest.toString());
                let count = 0;
                if ((0, $3smIt.isIterable)(result)) for (const value of result){
                    Promise.resolve(value).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                else {
                    Promise.resolve(result).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                this.setState({
                    inflightRequest: inflightRequest,
                    count: count,
                    resolving: count !== 0,
                    options: []
                });
            }
        }, 200), this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $jZA09.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        }, this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        }, this.executeLoadOptions = (search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) this.setState({
                resolving: true,
                showError: false
            }, ()=>this.debouncedLoadOptions(search));
        }, this.handleFocus = (event)=>{
            const { value: value, menuIsOpen: menuIsOpen } = this.state;
            if (!menuIsOpen || !this.session) this.startSession();
            this.startOptionsShownUfoExperience();
            (0, $3smIt.callCallback)(this.props.onFocus, this.getSessionId());
            if (!this.isMenuOpenOnClickForSingleSelect) {
                this.setState({
                    menuIsOpen: true
                });
                if (!this.props.isMulti && (0, $3smIt.isSingleValue)(value)) {
                    const input = event.target;
                    this.setState({
                        inputValue: value.label
                    }, ()=>{
                        if (input instanceof HTMLInputElement) input.setSelectionRange(0, value.label.length);
                    });
                }
            }
        }, this.resetInputState = ()=>{
            // Prevent filter if query typed, then blurred with no selection
            this.setState({
                inputValue: ''
            });
            (0, $3smIt.callCallback)(this.props.onInputChange, '', this.getSessionId());
        }, this.handleBlur = ()=>{
            (0, $3smIt.callCallback)(this.props.onBlur, this.getSessionId());
            if ((0, $3smIt.isPopupUserPickerByComponent)(this.props.SelectComponent)) return;
            this.resetInputState();
            this.abortOptionsShownUfoExperience();
            this.setState({
                menuIsOpen: false,
                initialFocusHandled: false,
                options: []
            });
        }, this.handleOpen = ()=>{
            (0, $3smIt.callCallback)(this.props.onOpen, this.getSessionId());
            this.setState({
                menuIsOpen: true
            });
        }, this.handleClose = ()=>{
            this.resetInputState();
            (0, $3smIt.callCallback)(this.props.onClose, this.getSessionId());
            this.setState({
                menuIsOpen: false,
                options: []
            });
        }, this.handleInputChange = (search, { action: action })=>{
            if (action === 'input-change' || action === 'set-value') {
                (0, $3smIt.callCallback)(this.props.onInputChange, search, this.getSessionId());
                this.setState({
                    inputValue: search
                });
                this.startOptionsShownUfoExperience();
            }
        }, this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $fUmMr.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, this.session, this.journeyId, ...args))(createAnalyticsEvent);
        }, this.startSession = ()=>{
            this.session = (0, $fUmMr.startSession)();
            this.journeyId = this.getSessionId();
            this.fireEvent((0, $fUmMr.focusEvent));
        }, this.handleKeyDown = (event)=>{
            if (!this.isMenuOpenOnClickForSingleSelect) {
                // Escape
                if (event.keyCode === 27) this.blur();
                // Space
                if (event.keyCode === 32 && !this.state.inputValue) {
                    event.preventDefault();
                    !this.props.disableInput && this.setState({
                        inputValue: ' '
                    });
                }
            }
            if (this.session) {
                this.session.lastKey = event.keyCode;
                switch(event.keyCode){
                    // KeyUp 38
                    case 38:
                        this.session.upCount++;
                        break;
                    // KeyDown 40
                    case 40:
                        this.session.downCount++;
                        break;
                }
            }
            this.props.onKeyDown && this.props.onKeyDown(event);
        }, this.handleClearIndicatorHover = (hoveringClearIndicator)=>{
            this.setState({
                hoveringClearIndicator: hoveringClearIndicator
            });
        }, this.getOptions = ()=>{
            const options = (0, $3smIt.getOptions)(this.state.options) || [];
            const { maxOptions: maxOptions, isMulti: isMulti, groupByTypeOrder: groupByTypeOrder } = this.props;
            if (maxOptions === 0) return [];
            if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
                const { value: value } = this.state;
                let filteredOptions = options;
                // Filter out previously selected options
                if (isMulti && Array.isArray(value)) {
                    const valueIds = value.map((item)=>item.data.id);
                    filteredOptions = options.filter((option)=>valueIds.indexOf(option.data.id) === -1);
                }
                return groupByTypeOrder && (0, $VSDnB.fg)('support_group_by_type_for_user_picker') ? (0, $01LKK.groupOptionsByType)(filteredOptions.slice(0, maxOptions), groupByTypeOrder) : filteredOptions.slice(0, maxOptions);
            }
            return groupByTypeOrder && (0, $VSDnB.fg)('support_group_by_type_for_user_picker') ? (0, $01LKK.groupOptionsByType)(options, groupByTypeOrder) : options;
        }, this.getAppearance = ()=>this.props.appearance ? this.props.appearance : 'normal', this.handleClickDraggableParentComponent = ()=>{
            if (this.state.initialFocusHandled) {
                // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                if (this.state.menuIsOpen) this.handleClose();
                else this.handleOpen();
            } else if (!this.state.menuIsOpen && !this.isMenuOpenOnClickForSingleSelect) {
                // Trigger focus state when ValueContainer is clicked for the first time
                // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                // to manage the state of the dropdown menu
                this.focus();
                this.setState(()=>({
                        initialFocusHandled: true
                    }));
            }
        };
        this.state = {
            options: [],
            isDefaultSet: false,
            inflightRequest: 0,
            count: 0,
            hoveringClearIndicator: false,
            menuIsOpen: !!this.props.open,
            inputValue: props.search || '',
            resolving: false,
            showError: false,
            initialFocusHandled: false
        };
        this.optionsShownUfoExperienceInstance = (0, $pk97C.userPickerOptionsShownUfoExperience).getInstance((0, $7Jxgt.v4)());
        if (this.props.forwardedRef) {
            const refValue = {
                focus: this.focus,
                blur: this.blur
            };
            if (typeof this.props.forwardedRef === 'function') this.props.forwardedRef(refValue);
            else this.props.forwardedRef.current = refValue;
        }
    }
    get isMenuOpenOnClickForSingleSelect() {
        return this.props.openMenuOnClick && !this.props.isMulti;
    }
    componentDidMount() {
        const { open: open, search: search } = this.props;
        // load options when the picker open
        if (open) {
            if (!this.session) this.startSession();
            this.executeLoadOptions(search);
        }
    }
    componentDidUpdate(_, prevState) {
        const { menuIsOpen: menuIsOpen, options: options, resolving: resolving, count: count, inputValue: inputValue } = this.state;
        // Create a new session when the menu is opened and there is no session
        if (menuIsOpen && !prevState.menuIsOpen && !this.session) this.startSession();
        // Load options when user picker opens or when input value changes
        if (menuIsOpen && !prevState.menuIsOpen || inputValue !== prevState.inputValue) this.executeLoadOptions(inputValue);
        if (!menuIsOpen && prevState.menuIsOpen && this.session) {
            this.fireEvent((0, $fUmMr.cancelEvent), prevState);
            this.session = undefined;
        }
        if (menuIsOpen && (!prevState.menuIsOpen && options.length > 0 || options.length !== prevState.options.length)) this.fireEvent((0, $fUmMr.searchedEvent));
        if (this.state.inputValue !== prevState.inputValue) {
            if (this.session) this.session.inputChangeTime = Date.now();
        }
        if (menuIsOpen && (!_.loadOptions || prevState.menuIsOpen) && count === 0 && !resolving && [
            (0, $jZA09.UFOExperienceState).STARTED.id,
            (0, $jZA09.UFOExperienceState).IN_PROGRESS.id
        ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success();
    }
    get ariaProps() {
        const ariaLabels = Object.keys(this.props).filter((key)=>key.startsWith('aria-'));
        const props = {
            ...this.props
        };
        return ariaLabels.reduce((obj, key)=>({
                ...obj,
                [key]: props[key]
            }), {});
    }
    render() {
        const { isMulti: isMulti, isLoading: isLoading, subtle: subtle, noBorder: noBorder, placeholder: placeholder, isClearable: isClearable, isDisabled: isDisabled, isInvalid: isInvalid, clearValueLabel: clearValueLabel, menuMinWidth: menuMinWidth, menuPortalTarget: menuPortalTarget, loadOptionsErrorMessage: loadOptionsErrorMessage, addMoreMessage: addMoreMessage, noOptionsMessage: noOptionsMessage, footer: footer, disableInput: disableInput, components: components, pickerProps: pickerProps, SelectComponent: SelectComponent, styles: styles, autoFocus: autoFocus, fieldId: fieldId, inputId: inputId, maxPickerHeight: maxPickerHeight, textFieldBackgroundColor: textFieldBackgroundColor, ariaLabelledBy: ariaLabelledBy, ariaDescribedBy: ariaDescribedBy, ariaLive: ariaLive, ariaLabel: ariaLabel, name: name, header: header, required: required, UNSAFE_hasDraggableParentComponent: UNSAFE_hasDraggableParentComponent, placeholderAvatar: placeholderAvatar } = this.props;
        const { count: count, hoveringClearIndicator: hoveringClearIndicator, menuIsOpen: menuIsOpen, value: value, inputValue: inputValue, resolving: resolving, showError: showError } = this.state;
        const appearance = this.getAppearance();
        // these props override the default select menu open and close
        const menuOpenDeciderProps = {
            ...!this.isMenuOpenOnClickForSingleSelect && {
                menuIsOpen: menuIsOpen,
                blurInputOnSelect: !isMulti,
                openMenuOnFocus: true
            }
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)(SelectComponent, {
            name: name,
            value: value,
            autoFocus: autoFocus !== undefined ? autoFocus : menuIsOpen,
            "aria-labelledby": ariaLabelledBy,
            "aria-describedby": ariaDescribedBy,
            "aria-live": ariaLive,
            "aria-required": required,
            required: required,
            ref: this.handleSelectRef,
            isMulti: isMulti,
            options: this.getOptions(),
            styles: styles,
            enableAnimation: isMulti,
            components: components,
            inputValue: inputValue,
            isLoading: count > 0 || resolving || isLoading,
            loadingMessage: $d045e9522a427a64$var$loadingMessage,
            menuPlacement: "auto",
            placeholder: placeholder ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $8fG8p.messages).placeholder
            }),
            label: ariaLabel,
            addMoreMessage: addMoreMessage,
            classNamePrefix: $d045e9522a427a64$var$classNamePrefix,
            hoveringClearIndicator: hoveringClearIndicator,
            appearance: appearance,
            isClearable: isClearable,
            noBorder: noBorder,
            subtle: subtle,
            closeMenuOnSelect: !isMulti,
            noOptionsMessage: showError ? loadOptionsErrorMessage : typeof noOptionsMessage === 'function' ? noOptionsMessage : ()=>noOptionsMessage,
            footer: footer,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            isFocused: menuIsOpen,
            backspaceRemovesValue: isMulti,
            filterOption: null,
            clearValueLabel: clearValueLabel,
            menuMinWidth: menuMinWidth,
            menuPortalTarget: menuPortalTarget,
            disableInput: disableInput || isDisabled,
            instanceId: fieldId,
            inputId: inputId,
            onChange: this.handleChange,
            onMenuOpen: this.handleOpen,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onMenuClose: this.handleClose,
            onInputChange: this.handleInputChange,
            onClearIndicatorHover: this.handleClearIndicatorHover,
            onKeyDown: this.handleKeyDown,
            maxPickerHeight: maxPickerHeight,
            textFieldBackgroundColor: textFieldBackgroundColor,
            header: header,
            placeholderAvatar: placeholderAvatar,
            ...this.ariaProps,
            ...pickerProps,
            ...UNSAFE_hasDraggableParentComponent && {
                onValueContainerClick: this.handleClickDraggableParentComponent
            },
            ...menuOpenDeciderProps
        });
    }
}
const $d045e9522a427a64$export$d099ade7b4f4d2a4 = (0, $cb25w.default)()($d045e9522a427a64$export$b4ff48c8d43b18c3);

});
parcelRegister("fUmMr", function(module, exports) {

$parcel$export(module.exports, "startSession", () => $e345c0b18a65d683$export$c0d84948cecf78d8);
$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $e345c0b18a65d683$export$53eef0dcd9611650);
$parcel$export(module.exports, "focusEvent", () => $e345c0b18a65d683$export$e7818c470f37c4bd);
$parcel$export(module.exports, "clearEvent", () => $e345c0b18a65d683$export$7b5800e732182efb);
$parcel$export(module.exports, "deleteEvent", () => $e345c0b18a65d683$export$95711ec6c6227e9a);
$parcel$export(module.exports, "cancelEvent", () => $e345c0b18a65d683$export$e9caaaecfee38128);
$parcel$export(module.exports, "selectEvent", () => $e345c0b18a65d683$export$48143d759475d90f);
$parcel$export(module.exports, "searchedEvent", () => $e345c0b18a65d683$export$911fb7184b6037eb);
$parcel$export(module.exports, "failedEvent", () => $e345c0b18a65d683$export$c2aec355fef65c9c);
$parcel$export(module.exports, "userInfoEvent", () => $e345c0b18a65d683$export$f541f04954b0c11e);

var $gB4mS = parcelRequire("gB4mS");

var $7Jxgt = parcelRequire("7Jxgt");

var $3smIt = parcelRequire("3smIt");
const $e345c0b18a65d683$var$packageName = "platform-pkg";
const $e345c0b18a65d683$var$packageVersion = "0.0.0-use.local";
const $e345c0b18a65d683$var$UUID_REGEXP_TEAMS_GROUPS = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $e345c0b18a65d683$var$UUID_REGEXP_OLD_AAID = /^[a-fA-F0-9]{1,8}:[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $e345c0b18a65d683$var$UUID_REGEXP_NEW_AAID = /^[a-fA-F0-9]{24,24}$/;
const $e345c0b18a65d683$export$c0d84948cecf78d8 = ()=>({
        id: (0, $7Jxgt.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $e345c0b18a65d683$export$53eef0dcd9611650 = (0, $gB4mS.default)('fabric-elements');
const $e345c0b18a65d683$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $e345c0b18a65d683$var$packageName,
            packageVersion: $e345c0b18a65d683$var$packageVersion,
            ...attributes
        }
    });
const $e345c0b18a65d683$var$checkValidId = (id)=>{
    return $e345c0b18a65d683$var$UUID_REGEXP_NEW_AAID.test(id) || $e345c0b18a65d683$var$UUID_REGEXP_OLD_AAID.test(id) || $e345c0b18a65d683$var$UUID_REGEXP_TEAMS_GROUPS.test(id);
};
const $e345c0b18a65d683$var$optionData2Analytics = (option)=>{
    const { id: id, type: type } = option;
    // id's of email types are emails which is PII
    const validatedData = {
        id: $e345c0b18a65d683$var$checkValidId(id) ? id : null,
        type: type || null
    };
    if ((0, $3smIt.isExternalUser)(option)) return {
        ...validatedData,
        type: 'external_user',
        sources: option.sources,
        externalUserType: option.externalUserType
    };
    if ((0, $3smIt.isCustom)(option) && option.analyticsType) return {
        ...validatedData,
        type: option.analyticsType
    };
    return validatedData;
};
const $e345c0b18a65d683$var$buildValueForAnalytics = (value)=>{
    if (value) {
        const valueToConvert = Array.isArray(value) ? value : [
            value
        ];
        return valueToConvert.map(({ data: data })=>$e345c0b18a65d683$var$optionData2Analytics(data));
    }
    return [];
};
const $e345c0b18a65d683$var$createDefaultPickerAttributes = (props, session, journeyId)=>({
        context: props.fieldId,
        sessionId: $e345c0b18a65d683$var$sessionId(session),
        pickerType: $e345c0b18a65d683$var$pickerType(props),
        journeyId: journeyId
    });
const $e345c0b18a65d683$export$e7818c470f37c4bd = (props, state, session, journeyId)=>$e345c0b18a65d683$var$createEvent('ui', 'focused', 'userPicker', {
        ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
        values: $e345c0b18a65d683$var$buildValueForAnalytics(state.value)
    });
const $e345c0b18a65d683$export$7b5800e732182efb = (props, state, session, journeyId)=>$e345c0b18a65d683$var$createEvent('ui', 'cleared', 'userPicker', {
        ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
        pickerOpen: state.menuIsOpen,
        values: $e345c0b18a65d683$var$values(state)
    });
const $e345c0b18a65d683$export$95711ec6c6227e9a = (props, state, session, journeyId, ...args)=>$e345c0b18a65d683$var$createEvent('ui', 'deleted', 'userPickerItem', {
        context: props.fieldId,
        sessionId: $e345c0b18a65d683$var$sessionId(session),
        journeyId: journeyId,
        value: $e345c0b18a65d683$var$optionData2Analytics(args[0]),
        pickerOpen: state.menuIsOpen
    });
const $e345c0b18a65d683$export$e9caaaecfee38128 = (props, _, session, journeyId, ...args)=>$e345c0b18a65d683$var$createEvent('ui', 'cancelled', 'userPicker', {
        ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $e345c0b18a65d683$var$sessionDuration(session),
        queryLength: $e345c0b18a65d683$var$queryLength(args[0]),
        spaceInQuery: $e345c0b18a65d683$var$spaceInQuery(args[0]),
        upKeyCount: $e345c0b18a65d683$var$upKeyCount(session),
        downKeyCount: $e345c0b18a65d683$var$downKeyCount(session)
    });
const $e345c0b18a65d683$export$48143d759475d90f = (props, state, session, journeyId, ...args)=>{
    return $e345c0b18a65d683$var$createEvent('ui', $e345c0b18a65d683$var$selectEventType(session), 'userPicker', {
        ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $e345c0b18a65d683$var$sessionDuration(session),
        position: $e345c0b18a65d683$var$position(state, args[0]),
        queryLength: $e345c0b18a65d683$var$queryLength(state),
        spaceInQuery: $e345c0b18a65d683$var$spaceInQuery(state),
        upKeyCount: $e345c0b18a65d683$var$upKeyCount(session),
        downKeyCount: $e345c0b18a65d683$var$downKeyCount(session),
        result: $e345c0b18a65d683$var$result(args[0]),
        numberOfResults: $e345c0b18a65d683$var$numberOfResults(state)
    });
};
const $e345c0b18a65d683$export$911fb7184b6037eb = (props, state, session, journeyId)=>{
    const searchResults = $e345c0b18a65d683$var$results(state);
    return $e345c0b18a65d683$var$createEvent('operational', 'searched', 'userPicker', {
        ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $e345c0b18a65d683$var$sessionDuration(session),
        durationSinceInputChange: $e345c0b18a65d683$var$durationSinceInputChange(session),
        queryLength: $e345c0b18a65d683$var$queryLength(state),
        isLoading: $e345c0b18a65d683$var$isLoading(props, state),
        results: searchResults,
        numberOfResults: searchResults.length
    });
};
const $e345c0b18a65d683$export$c2aec355fef65c9c = (props, _, session, journeyId)=>$e345c0b18a65d683$var$createEvent('operational', 'failed', 'userPicker', {
        ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId)
    });
const $e345c0b18a65d683$export$f541f04954b0c11e = (sources, accountId)=>$e345c0b18a65d683$var$createEvent('ui', 'displayed', 'userInfo', {
        sources: sources,
        // accountId can be PII if it is an email so check that it's an AAID first
        accountId: $e345c0b18a65d683$var$checkValidId(accountId) ? accountId : null
    });
function $e345c0b18a65d683$var$queryLength(state) {
    return state.inputValue.length;
}
function $e345c0b18a65d683$var$selectEventType(session) {
    return session && session.lastKey === 13 ? 'pressed' : 'clicked';
}
function $e345c0b18a65d683$var$upKeyCount(session) {
    return session ? session.upCount : null;
}
function $e345c0b18a65d683$var$downKeyCount(session) {
    return session ? session.downCount : null;
}
function $e345c0b18a65d683$var$spaceInQuery(state) {
    return state.inputValue.indexOf(' ') !== -1;
}
function $e345c0b18a65d683$var$sessionDuration(session) {
    return session ? Date.now() - session.start : null;
}
function $e345c0b18a65d683$var$durationSinceInputChange(session) {
    return session ? Date.now() - session.inputChangeTime : null;
}
function $e345c0b18a65d683$var$sessionId(session) {
    return session && session.id;
}
function $e345c0b18a65d683$var$position(state, value) {
    return value ? state.options.findIndex((option)=>option === value.data) : -1;
}
function $e345c0b18a65d683$var$pickerType(props) {
    return props.isMulti ? 'multi' : 'single';
}
function $e345c0b18a65d683$var$result(option) {
    return option ? $e345c0b18a65d683$var$optionData2Analytics(option.data) : null;
}
function $e345c0b18a65d683$var$results(state) {
    return (state.options || []).map($e345c0b18a65d683$var$optionData2Analytics);
}
function $e345c0b18a65d683$var$isLoading(props, state) {
    return state.count > 0 || props.isLoading;
}
function $e345c0b18a65d683$var$values(state) {
    return state.value ? Array.isArray(state.value) ? state.value.map((option)=>$e345c0b18a65d683$var$optionData2Analytics(option.data)) : [
        $e345c0b18a65d683$var$optionData2Analytics(state.value.data)
    ] : [];
}
function $e345c0b18a65d683$var$numberOfResults(state) {
    return (state.options || []).length;
}

});

parcelRegister("78Gdn", function(module, exports) {

$parcel$export(module.exports, "batchByKey", () => $2e9cc1cdc768945e$export$da86c38211c1c0a8);
function $2e9cc1cdc768945e$export$da86c38211c1c0a8(callback) {
    const calls = {};
    return (key, ...args)=>{
        if (!calls[key]) {
            window.setTimeout(()=>{
                callback(key, calls[key]);
                delete calls[key];
            });
            calls[key] = [];
        }
        calls[key].push(args);
    };
}

});

parcelRegister("8fG8p", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7b21650c04984462$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7b21650c04984462$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    placeholder: {
        id: 'fabric.elements.user-picker.placeholder',
        defaultMessage: 'Enter people or teams...',
        description: 'Placeholder description for empty user/team/email select field.'
    },
    addMore: {
        id: 'fabric.elements.user-picker.placeholder.add-more',
        defaultMessage: 'add more people...',
        description: 'Placeholder for multi user picker when the field is not empty.'
    },
    remove: {
        id: 'fabric.elements.user-picker.multi.remove-item',
        defaultMessage: 'Remove',
        description: 'Tooltip for the single item remove button in a multi user select field.'
    },
    clear: {
        id: 'fabric.elements.user-picker.single.clear',
        defaultMessage: 'Clear',
        description: 'Tooltip for clear button in the single user select field.'
    },
    errorMessage: {
        id: 'fabric.elements.user-picker.error.message',
        defaultMessage: 'Something went wrong',
        description: 'Error message to display when options fail to load.'
    },
    memberCountWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.count',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
        description: 'Byline to show the number of members in the team when the current user is not a member of the team'
    },
    memberCountWithYou: {
        id: 'fabric.elements.user-picker.team.member.count.including.you',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
        description: 'Byline to show the number of members in the team when the current user is also a member of the team'
    },
    plus50MembersWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.50plus',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the number of members in the team when the number exceeds 50'
    },
    plus50MembersWithYou: {
        id: 'fabric.elements.user-picker.team.member.50plus.including.you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
    },
    addEmail: {
        id: 'fabric.elements.user-picker.email.add',
        defaultMessage: 'Add user',
        description: 'Byline for valid email option.'
    },
    selectToAddEmail: {
        id: 'fabric.elements.user-picker.email.select.to.add',
        defaultMessage: 'Select an email address',
        description: 'Byline for valid email option.'
    },
    continueToAddEmail: {
        id: 'fabric.elements.user-picker.email.add.potential',
        defaultMessage: 'Enter an email address',
        description: 'Byline for a potentially valid email option.'
    },
    groupByline: {
        id: 'fabric.elements.user-picker.group.byline',
        defaultMessage: 'Admin-managed group',
        description: 'Byline for admin-managed groups'
    },
    externalUserSourcesHeading: {
        id: 'fabric.elements.user-picker.external.sourced.from',
        defaultMessage: 'Found in:',
        description: 'From where the external user is coming'
    },
    externalUserSourcesError: {
        id: 'fabric.elements.user-picker.external.sourced.error',
        defaultMessage: "We can't connect you right now.",
        description: "Error message when we can't fetch a user's import sources"
    },
    slackProvider: {
        id: 'fabric.elements.user-picker.slack.provider',
        defaultMessage: 'Slack',
        description: 'This external user is sourced from Slack provider'
    },
    googleProvider: {
        id: 'fabric.elements.user-picker.google.provider',
        defaultMessage: 'Google',
        description: 'This external user is sourced from Google provider'
    },
    microsoftProvider: {
        id: 'fabric.elements.user-picker.microsoft.provider',
        defaultMessage: 'Microsoft',
        description: 'This external user is sourced from Microsoft provider'
    },
    gitHubProvider: {
        id: 'fabric.elements.user-picker.github.provider',
        defaultMessage: 'GitHub',
        description: 'This external user is sourced from GitHub provider'
    },
    jiraSource: {
        id: 'fabric.elements.user-picker.source.jira',
        defaultMessage: 'Jira',
        description: 'This external user is sourced from Jira'
    },
    confluenceSource: {
        id: 'fabric.elements.user-picker.source.confluence',
        defaultMessage: 'Confluence',
        description: 'This external user is sourced from Confluence'
    },
    otherAtlassianSource: {
        id: 'fabric.elements.user-picker.source.other-atlassian',
        defaultMessage: 'Other Atlassian products',
        description: 'This external user is sourced from Atlassian products other than Jira and Confluence'
    },
    memberLozengeText: {
        id: 'fabric.elements.user-picker.member.lozenge.text',
        defaultMessage: 'MEMBER',
        description: 'Text within the Lozenge when the user is a workspace member'
    },
    guestLozengeText: {
        id: 'fabric.elements.user-picker.guest.lozenge.text',
        defaultMessage: 'GUEST',
        description: 'Text within the lozenge when the user is a guest of confluence'
    },
    guestUserLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.user',
        defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for guest lozenge showing that a user is a guest in Confluence'
    },
    guestGroupLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.group',
        defaultMessage: 'Guest groups can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for lozenge showing that a group is for guests in Confluence'
    },
    userTypeLabel: {
        id: 'fabric.elements.user-picker.user.type.label',
        defaultMessage: 'People',
        description: 'Label for user type'
    },
    teamTypeLabel: {
        id: 'fabric.elements.user-picker.team.type.label',
        defaultMessage: 'Teams',
        description: 'Label for team type'
    },
    emailTypeLabel: {
        id: 'fabric.elements.user-picker.email.type.label',
        defaultMessage: 'Emails',
        description: 'Label for email type'
    },
    groupTypeLabel: {
        id: 'fabric.elements.user-picker.group.type.label',
        defaultMessage: 'Groups',
        description: 'Label for group type'
    },
    externalUserTypeLabel: {
        id: 'fabric.elements.user-picker.external.user.type.label',
        defaultMessage: 'External Users',
        description: 'Label for external user type'
    },
    customTypeLabel: {
        id: 'fabric.elements.user-picker.custom.type.label',
        defaultMessage: 'Customs',
        description: 'Label for custom type'
    },
    otherTypeLabel: {
        id: 'fabric.elements.user-picker.other.type.label',
        defaultMessage: 'Others',
        description: 'Label for other type'
    }
});

});

parcelRegister("01LKK", function(module, exports) {

$parcel$export(module.exports, "groupOptionsByType", () => $846290178b7bfe5f$export$393a985f7dd07cfe);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $8QpSo = parcelRequire("8QpSo");

var $8fG8p = parcelRequire("8fG8p");
const $846290178b7bfe5f$var$getLabelForType = (type)=>{
    switch(type){
        case 'user':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $8fG8p.messages).userTypeLabel
            });
        case 'team':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $8fG8p.messages).teamTypeLabel
            });
        case 'group':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $8fG8p.messages).groupTypeLabel
            });
        case 'custom':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $8fG8p.messages).customTypeLabel
            });
        case 'external_user':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $8fG8p.messages).externalUserTypeLabel
            });
        default:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $8fG8p.messages).otherTypeLabel
            });
    }
};
const $846290178b7bfe5f$export$393a985f7dd07cfe = (0, $8QpSo.default)((options, groupByTypeOrder)=>{
    // If groupByTypeOrder is empty, just return the original options
    if (groupByTypeOrder.length === 0) return options;
    const groupedMap = new Map();
    options.forEach((option)=>{
        const type = option.data.type || 'other';
        if (!groupedMap.has(type)) groupedMap.set(type, []);
        groupedMap.get(type).push(option);
    });
    const result = [];
    // add groups in the specified order
    // type is not in groupByTypeOrder, don't add it to the result
    groupByTypeOrder.forEach((type)=>{
        if (groupedMap.has(type)) {
            result.push({
                label: $846290178b7bfe5f$var$getLabelForType(type),
                options: groupedMap.get(type)
            });
            groupedMap.delete(type);
        }
    });
    return result;
});

});

parcelRegister("pk97C", function(module, exports) {

$parcel$export(module.exports, "userPickerRenderedUfoExperience", () => $06ebadcdd7d5e231$export$b49757166e1acfc2);
$parcel$export(module.exports, "userPickerOptionsShownUfoExperience", () => $06ebadcdd7d5e231$export$135a264e0da507ae);
$parcel$export(module.exports, "UfoErrorBoundary", () => $06ebadcdd7d5e231$export$5ef1c2550074a375);

var $5uXOq = parcelRequire("5uXOq");

var $cBycP = parcelRequire("cBycP");
var $7Zbvr = parcelRequire("7Zbvr");
var $jZA09 = parcelRequire("jZA09");
const $06ebadcdd7d5e231$export$b49757166e1acfc2 = new (0, $cBycP.ConcurrentExperience)('user-picker-rendered', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $7Zbvr.ExperienceTypes).Load,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).PageSegmentLoad
});
const $06ebadcdd7d5e231$export$135a264e0da507ae = new (0, $cBycP.ConcurrentExperience)('user-picker-options-shown', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $7Zbvr.ExperienceTypes).Operation,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult
});
class $06ebadcdd7d5e231$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch() {
        const instance = $06ebadcdd7d5e231$export$b49757166e1acfc2.getInstance(this.props.id);
        if (instance.state.id !== (0, $jZA09.UFOExperienceState).FAILED.id) instance.failure();
    }
    render() {
        return this.props.children;
    }
}

});
parcelRegister("cBycP", function(module, exports) {

$parcel$export(module.exports, "ConcurrentExperience", () => $d4c0ab33dd6972cc$export$ac1cddfee07ba6ac);

var $dCAsn = parcelRequire("dCAsn");

var $boHLC = parcelRequire("boHLC");
class $d4c0ab33dd6972cc$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $boHLC.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $dCAsn.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});



parcelRegister("2wgOn", function(module, exports) {

$parcel$export(module.exports, "getStyles", () => $01bdbab7be42e070$export$ffd58b7f6f099a57);
$parcel$export(module.exports, "getPopupStyles", () => $01bdbab7be42e070$export$4e983f376ad8a3af);


var $8QpSo = parcelRequire("8QpSo");

var $7VXAu = parcelRequire("7VXAu");
const $01bdbab7be42e070$export$59c188914e58c94b = "var(--ds-space-075, 6px)";
const $01bdbab7be42e070$export$53937c04f7dfc2ae = 6;
const $01bdbab7be42e070$export$2c62ba763e976c54 = 39;
const $01bdbab7be42e070$export$ffd58b7f6f099a57 = (0, $8QpSo.default)((width, isMulti, isCompact, overrideStyles, isInvalid, isVisualRefresh, isPopupStyles)=>{
    let styles = {
        menu: (css, state)=>({
                ...css,
                width: width,
                minWidth: state.selectProps.menuMinWidth,
                zIndex: '400'
            }),
        menuList: (css)=>({
                ...css,
                zIndex: '400'
            }),
        control: (css, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                width: width,
                borderColor: isInvalid ? `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})` : state.isFocused ? `var(--ds-border-focused, ${css.borderColor})` : state.selectProps.subtle || state.selectProps.noBorder ? 'transparent' : `var(--ds-border-input, ${0, $829f609a65d26a98$export$7c87d337fb91a97d})`,
                backgroundColor: state.isFocused ? `var(--ds-background-input, ${css['backgroundColor']})` : state.selectProps.subtle ? 'transparent' : state.selectProps.textFieldBackgroundColor ? `var(--ds-background-input, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`,
                '&:hover .fabric-user-picker__clear-indicator': {
                    opacity: 1
                },
                ':hover': {
                    ...css[':hover'],
                    borderColor: isInvalid ? `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})` : state.isFocused ? css[':hover'] ? `var(--ds-border-focused, ${css[':hover'].borderColor})` : `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : state.selectProps.subtle ? 'transparent' : `var(--ds-border-input, ${0, $829f609a65d26a98$export$7c87d337fb91a97d})`,
                    backgroundColor: state.selectProps.subtle && state.selectProps.hoveringClearIndicator ? `var(--ds-background-danger, ${0, $829f609a65d26a98$export$4b84fd0e2c617bd})` : state.isFocused ? css[':hover'] ? `var(--ds-background-input, ${css[':hover'].backgroundColor})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : state.isDisabled ? `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`
                },
                padding: 0,
                minHeight: isCompact ? 'none' : 44,
                /* IE 11 needs to set height explicitly to be vertical align when being in not compact mode */ height: isCompact || isMulti ? '100%' : 44,
                maxWidth: '100%'
            };
        },
        clearIndicator: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, paddingLeft: paddingLeft, paddingRight: paddingRight, ...css })=>({
                ...css,
                // By default show clear indicator, except for on devices where "hover" is supported.
                // This means mobile devices (which do not support hover) will be able to see the clear indicator.
                opacity: 1,
                '@media (hover: hover) and (pointer: fine)': {
                    opacity: 0
                },
                transition: css.transition + ', opacity 150ms',
                paddingTop: 0,
                padding: 0,
                ':hover': {
                    color: `var(--ds-icon-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`
                }
            }),
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        valueContainer: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, position: position, ...css }, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                gridTemplateColumns: 'auto 1fr',
                paddingTop: isCompact ? 0 : $01bdbab7be42e070$export$59c188914e58c94b,
                paddingBottom: isCompact ? 0 : $01bdbab7be42e070$export$59c188914e58c94b,
                paddingLeft: isMulti ? $01bdbab7be42e070$export$59c188914e58c94b : 0,
                overflowX: 'hidden',
                overflowY: 'auto',
                scrollbarWidth: 'none',
                maxHeight: state.selectProps.maxPickerHeight || '100%',
                '::-webkit-scrollbar': {
                    width: 0,
                    background: 'transparent'
                }
            };
        },
        multiValue: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'default'
            }),
        multiValueLabel: (css)=>({
                ...css,
                display: 'flex'
            }),
        multiValueRemove: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'pointer'
            }),
        placeholder: (css, state)=>{
            // fix styling in IE 11: when the position is absolute and `left` prop is not defined,
            // IE and other browsers auto calculate value of "left" prop differently,
            // so we want to explicitly set value for the `left` property
            if (css.position === 'absolute' && !css.left) css.left = `${$01bdbab7be42e070$export$59c188914e58c94b}px`;
            return {
                ...css,
                gridArea: '1/2/2/3',
                paddingLeft: state.selectProps.isMulti ? 0 : $01bdbab7be42e070$export$59c188914e58c94b,
                /* Margin left right of 2px set by default */ // margin: `0 ${BORDER_PADDING}px`,
                margin: 0,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            };
        },
        option: (css)=>{
            if (isVisualRefresh) return {
                ...css,
                overflow: 'hidden',
                paddingLeft: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)",
                paddingRight: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)"
            };
            return {
                ...css,
                overflow: 'hidden'
            };
        },
        input: (css, state)=>({
                ...css,
                gridArea: '1/2/2/3',
                gridTemplateColumns: isMulti && state.placeholder ? '0 123px' : css.gridTemplateColumns,
                /* Necessary to make input height and tag height the same. */ margin: `${"var(--ds-space-050, 4px)"} 0`,
                /* Padding top and bottom of 2 is set by default. */ paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: state.selectProps.isMulti ? 0 : $01bdbab7be42e070$export$59c188914e58c94b,
                '& input::placeholder': {
                    /* Chrome, Firefox, Opera, Safari 10.1+ */ color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$d6447c357493214f})`,
                    opacity: 1 /* Firefox */ 
                },
                '& input:-ms-input-placeholder': {
                    /* Internet Explorer 10-11 */ color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$d6447c357493214f})`
                }
            }),
        singleValue: (css)=>({
                ...css,
                margin: 0,
                gridArea: '1/2/2/3'
            })
    };
    return overrideStyles ? (0, $7VXAu.mergeStyles)(styles, overrideStyles) : styles;
});
const $01bdbab7be42e070$export$4e983f376ad8a3af = (0, $8QpSo.default)((width, isMulti, overrideStyles, isVisualRefresh)=>({
        ...$01bdbab7be42e070$export$ffd58b7f6f099a57(width, isMulti, false, overrideStyles, false, isVisualRefresh, true)
    }));

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';


parcelRegister("dyegP", function(module, exports) {

$parcel$export(module.exports, "getComponents", () => $27e51ea041192381$export$4e811121b221213b);
$parcel$export(module.exports, "getPopupComponents", () => $27e51ea041192381$export$19205fd341a6bb08);

var $8QpSo = parcelRequire("8QpSo");

var $dqbw8 = parcelRequire("dqbw8");

var $8Y8Qe = parcelRequire("8Y8Qe");

var $fIpmY = parcelRequire("fIpmY");

var $3QONt = parcelRequire("3QONt");

var $6Kkci = parcelRequire("6Kkci");

var $OxpB4 = parcelRequire("OxpB4");

var $ee8bl = parcelRequire("ee8bl");

var $h3ej5 = parcelRequire("h3ej5");

var $6Ks8i = parcelRequire("6Ks8i");

var $lYehz = parcelRequire("lYehz");

var $7mofJ = parcelRequire("7mofJ");
const $27e51ea041192381$export$4e811121b221213b = (0, $8QpSo.default)((multi, anchor, showClearIndicator, customComponents)=>{
    if (anchor) return {
        Control: anchor,
        Option: $3QONt.Option
    };
    else return {
        MultiValue: $8Y8Qe.MultiValue,
        DropdownIndicator: null,
        SingleValue: $6Kkci.SingleValue,
        ClearIndicator: showClearIndicator || !multi ? (0, $dqbw8.ClearIndicator) : null,
        Option: $3QONt.Option,
        ValueContainer: multi ? (0, $fIpmY.MultiValueContainer) : (0, $ee8bl.SingleValueContainer),
        Input: $OxpB4.Input,
        Menu: $lYehz.Menu,
        Control: $7mofJ.default,
        ...customComponents ? customComponents : {}
    };
});
const $27e51ea041192381$export$19205fd341a6bb08 = (0, $8QpSo.default)((hasPopupTitle)=>{
    const baseProps = {
        DropdownIndicator: null,
        SingleValue: $6Kkci.SingleValue,
        ClearIndicator: $dqbw8.ClearIndicator,
        Option: $3QONt.Option,
        ValueContainer: (0, $ee8bl.SingleValueContainer),
        Input: (0, $h3ej5.PopupInput)
    };
    if (hasPopupTitle) return {
        ...baseProps,
        Control: (0, $6Ks8i.PopupControl)
    };
    return baseProps;
});

});
parcelRegister("dqbw8", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $11bf495008933d24$export$ecf9cf59142dd54a);
/* ClearIndicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");

const $11bf495008933d24$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("7LtDy")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $11bf495008933d24$var$clearIndicatorStyles = {
    root: "_v5641ppt _tzy4kb7n _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _30l3s4qr _1mhjgrf3"
};
class $11bf495008933d24$export$ecf9cf59142dd54a extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { clearValueLabel: clearValueLabel } } = this.props;
        const Indicator = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).ClearIndicator, {
            ...this.props,
            innerProps: {
                ...this.props.innerProps,
                onMouseDown: this.handleMouseDown
            },
            xcss: $11bf495008933d24$var$clearIndicatorStyles.root
        });
        return clearValueLabel ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Suspense, {
            fallback: Indicator,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($11bf495008933d24$var$AsyncTooltip, {
                content: clearValueLabel,
                children: Indicator
            })
        }) : Indicator;
    }
    constructor(...args){
        super(...args), this.handleMouseDown = (event)=>{
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            // Prevent focus when clear on blurred state
            const { clearValue: clearValue, selectProps: selectProps } = this.props;
            clearValue();
            //@ts-ignore react-select unsupported props
            if (selectProps && !selectProps.isFocused) event.stopPropagation();
        };
    }
}

});
parcelRegister("7LtDy", function(module, exports) {

let $5a73e97eb510a942$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5a73e97eb510a942$var$load("9EQz0").then(()=>parcelRequire('8hfZh'));

});


parcelRegister("8Y8Qe", function(module, exports) {

$parcel$export(module.exports, "MultiValue", () => $65368b71d1856c3a$export$419cdf50db8b579);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dW8NE = parcelRequire("dW8NE");

var $5pJx4 = parcelRequire("5pJx4");

var $3smIt = parcelRequire("3smIt");

var $4hqZ5 = parcelRequire("4hqZ5");

var $fuhQD = parcelRequire("fuhQD");
function $65368b71d1856c3a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $65368b71d1856c3a$export$118122ebc1e626fa = (valueContainer, control)=>{
    const { top: top, height: height } = valueContainer.getBoundingClientRect();
    const { height: controlHeight } = control.getBoundingClientRect();
    if (top - height < 0) valueContainer.scrollIntoView();
    if (top + height > controlHeight) valueContainer.scrollIntoView(false);
};
const $65368b71d1856c3a$var$groupTagContainer = (0, $8CUq3.xcss)({
    paddingLeft: 'space.025',
    marginTop: 'space.025'
});
const $65368b71d1856c3a$var$nameWrapper = {
    name: "1ebbz80",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px)"
};
class $65368b71d1856c3a$export$419cdf50db8b579 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props), this.getElemBefore = ()=>{
            const { data: { data: data } } = this.props;
            if ((0, $3smIt.isEmail)(data)) // This element is a decorative icon and does not require a label
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dW8NE.AddOptionAvatar), {
                isLozenge: true
            });
            if ((0, $3smIt.isGroup)(data)) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
                xcss: $65368b71d1856c3a$var$groupTagContainer
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4hqZ5))), {
                LEGACY_margin: "-2px 0 0 0",
                color: "currentColor",
                label: "" // This element is a decorative icon and does not require a label
                ,
                LEGACY_size: "small"
            }));
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5pJx4.SizeableAvatar), {
                appearance: "multi",
                src: (0, $3smIt.getAvatarUrl)(data),
                type: (0, $3smIt.isTeam)(data) ? 'team' : 'person'
            });
        }, this.getElemAfter = ()=>{
            const { data: { data: data } } = this.props;
            if ((0, $3smIt.isTeam)(data) && data.verified) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fuhQD.VerifiedTeamIcon), null);
            return null;
        };
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef();
    }
    componentDidUpdate() {
        const { isFocused: isFocused } = this.props;
        if (isFocused && this.containerRef.current && this.containerRef.current.parentElement && this.containerRef.current.parentElement.parentElement) $65368b71d1856c3a$export$118122ebc1e626fa(this.containerRef.current, this.containerRef.current.parentElement.parentElement);
    }
    shouldComponentUpdate(nextProps) {
        const { data: { label: label, data: data }, innerProps: innerProps, isFocused: isFocused } = this.props;
        const { data: { label: nextLabel, data: nextData }, innerProps: nextInnerProps, isFocused: nextIsFocused } = nextProps;
        // We can ignore onRemove here because it is an anonymous function
        // that will be recreated every time but with the same implementation.
        return data !== nextData || label !== nextLabel || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
    }
    render() {
        const { children: children, innerProps: innerProps, ...rest } = this.props;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bChGW.components).MultiValue, {
            ...rest,
            innerProps: {
                ref: this.containerRef
            },
            cropWithEllipsis: false
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f5TWP.default), {
            alignBlock: "center"
        }, this.getElemBefore(), " ", /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $65368b71d1856c3a$var$nameWrapper
        }, children), this.getElemAfter()));
    }
}

});
parcelRegister("dW8NE", function(module, exports) {

$parcel$export(module.exports, "AddOptionAvatar", () => $f3236d5a67f7ff1f$export$df396db45e491922);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $aVnO1 = parcelRequire("aVnO1");


var $f8Sb3 = parcelRequire("f8Sb3");
parcelRequire("5uXOq");
const $f3236d5a67f7ff1f$var$getEmailAvatarWrapperStyle = (isLozenge)=>{
    const padding = isLozenge ? `${"var(--ds-space-0, 0px)"}` : `${"var(--ds-space-050, 4px)"}`;
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: padding,
        backgroundColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        marginLeft: "var(--ds-space-025, 2px)"
    });
};
const $f3236d5a67f7ff1f$export$df396db45e491922 = ({ isLozenge: isLozenge, label: label })=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $f3236d5a67f7ff1f$var$getEmailAvatarWrapperStyle(isLozenge)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aVnO1))), {
        testId: "add-option-avatar-email-icon",
        label: label || '',
        LEGACY_size: isLozenge ? 'small' : 'medium',
        LEGACY_margin: "0 0 0 -2px",
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
    })));
};

});
parcelRegister("aVnO1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b2014ecb862bd114df9c4eca3bb7d0c3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f41b19bed4136e0$var$_react = $7f41b19bed4136e0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7f41b19bed4136e0$var$_email = $7f41b19bed4136e0$var$_interopRequireDefault((parcelRequire("eRB05")));

var $7f41b19bed4136e0$var$_email2 = $7f41b19bed4136e0$var$_interopRequireDefault((parcelRequire("5bEkJ")));
function $7f41b19bed4136e0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EmailIcon.
 * This component is EmailIcon, with `UNSAFE_fallbackIcon` set to "EmailIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7f41b19bed4136e0$var$EmailIcon = (props)=>/*#__PURE__*/ $7f41b19bed4136e0$var$_react.default.createElement($7f41b19bed4136e0$var$_email.default, Object.assign({
        LEGACY_fallbackIcon: $7f41b19bed4136e0$var$_email2.default
    }, props));
$7f41b19bed4136e0$var$EmailIcon.Name = 'EmailIconMigration';
var $7f41b19bed4136e0$var$_default = module.exports.default = $7f41b19bed4136e0$var$EmailIcon;

});
parcelRegister("eRB05", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19440c8dd0e3db5766add744ad314d45>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ad22b76beceec928$var$_react = $ad22b76beceec928$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ad22b76beceec928$var$_baseNew = $ad22b76beceec928$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ad22b76beceec928$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Email".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ad22b76beceec928$var$EmailIcon = (props)=>/*#__PURE__*/ $ad22b76beceec928$var$_react.default.createElement($ad22b76beceec928$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v.529L8 8.128l6.5-3.6V4a.5.5 0 0 0-.5-.5zm12.5 2.743L8.363 9.641a.75.75 0 0 1-.726 0L1.5 6.243V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$ad22b76beceec928$var$EmailIcon.displayName = 'EmailIcon';
var $ad22b76beceec928$var$_default = module.exports.default = $ad22b76beceec928$var$EmailIcon;

});

parcelRegister("5bEkJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3c6d443366bf8cbb$var$_react = $3c6d443366bf8cbb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $3c6d443366bf8cbb$var$_email = $3c6d443366bf8cbb$var$_interopRequireDefault((parcelRequire("eRB05")));
function $3c6d443366bf8cbb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3c6d443366bf8cbb$var$EmailIcon = (props)=>/*#__PURE__*/ $3c6d443366bf8cbb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 7v10h14V7zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.12 1.12 0 0 1-1.583 0z"/></g></svg>`
    }, props, {
        newIcon: $3c6d443366bf8cbb$var$_email.default
    }));
$3c6d443366bf8cbb$var$EmailIcon.displayName = 'EmailIcon';
var $3c6d443366bf8cbb$var$_default = module.exports.default = $3c6d443366bf8cbb$var$EmailIcon;

});



parcelRegister("5pJx4", function(module, exports) {

$parcel$export(module.exports, "SizeableAvatar", () => $50cd04ab4dcbd6e5$export$44d81a88129649da);

var $2OMIu = parcelRequire("2OMIu");

var $ujWmd = parcelRequire("ujWmd");

var $fwSAz = parcelRequire("fwSAz");

var $5uXOq = parcelRequire("5uXOq");

var $3smIt = parcelRequire("3smIt");
class $50cd04ab4dcbd6e5$export$44d81a88129649da extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const { src: src, presence: presence, appearance: appearance, type: type = 'person' } = this.props;
        const props = {
            size: (0, $3smIt.getAvatarSize)(appearance),
            src: src,
            borderColor: 'transparent',
            presence: presence
        };
        return type === 'team' ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fwSAz.default), {
            ...props
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ujWmd.default), {
            ...props
        });
    }
}

});
parcelRegister("fwSAz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cdf5ede1a400c9d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");


var $2w1D3 = parcelRequire("2w1D3");

var $ggnNZ = parcelRequire("ggnNZ");
const $6cdf5ede1a400c9d$export$ebe0b8fe8b6acbfd = `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
const $6cdf5ede1a400c9d$export$72502e51aebdd94e = `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;
function $6cdf5ede1a400c9d$export$2e2bcd8739ae039({ testId: testId, src: src, size: size = 'medium', ...props }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ujWmd.default), {
        appearance: (0, $ggnNZ.isSquareIcon)(src) ? 'square' : 'circle',
        ...props,
        size: size,
        src: src,
        testId: `${testId}-team-avatar`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2w1D3.TeamAvatarImage), {
            src: src,
            size: size,
            testId: testId
        })
    });
}

});
parcelRegister("2w1D3", function(module, exports) {

$parcel$export(module.exports, "TeamAvatarImage", () => $7d2527153712d181$export$ac3673635a5387be);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $vIiRg = parcelRequire("vIiRg");
var $cEPfF = parcelRequire("cEPfF");

var $fptva = parcelRequire("fptva");

var $h8cgU = parcelRequire("h8cgU");

var $VSDnB = parcelRequire("VSDnB");


var $4jyNe = parcelRequire("4jyNe");

var $3WiFt = parcelRequire("3WiFt");
function $7d2527153712d181$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7d2527153712d181$var$ICON_BACKGROUND = `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
const $7d2527153712d181$var$ICON_COLOR = `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;
// used in a size calculation so can't be a token. Without this the avatar looks very squished
const $7d2527153712d181$var$ICON_PADDING = 4;
const $7d2527153712d181$var$avatarDefaultIconStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    backgroundColor: $7d2527153712d181$var$ICON_COLOR,
    borderRadius: '50%',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center'
});
const $7d2527153712d181$var$SIZES = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $7d2527153712d181$var$nestedAvatarStyles = Object.entries((0, $vIiRg.AVATAR_SIZES)).reduce((styles, [key, size])=>{
    return {
        ...styles,
        [key]: /*#__PURE__*/ (0, $f8Sb3.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${size}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${size}px`,
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '& svg': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: `${size - $7d2527153712d181$var$ICON_PADDING}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: `${size - $7d2527153712d181$var$ICON_PADDING}px`
            }
        })
    };
}, {});
const $7d2527153712d181$var$avatarImageStyles = {
    name: "n68006",
    styles: "display:flex;flex:1 1 100%;width:100%;height:100%"
};
const $7d2527153712d181$export$9cfabd93718c0a2e = ({ alt: alt = '', src: src, size: size, testId: testId })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $5uXOq.useState)(false);
    // If src changes, reset state
    (0, $5uXOq.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) {
        if ((0, $VSDnB.fg)('enable-team-avatar-switch')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4jyNe.FallbackAvatar), {
            "aria-label": alt,
            width: $7d2527153712d181$var$SIZES[size],
            height: $7d2527153712d181$var$SIZES[size],
            "data-testid": testId
        });
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            css: [
                $7d2527153712d181$var$avatarDefaultIconStyles,
                $7d2527153712d181$var$nestedAvatarStyles[size]
            ]
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fptva))), {
            label: alt,
            color: $7d2527153712d181$var$ICON_BACKGROUND,
            LEGACY_secondaryColor: $7d2527153712d181$var$ICON_COLOR,
            testId: testId && `${testId}--team`,
            spacing: "spacious",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($h8cgU)))
        }));
    }
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cEPfF.AvatarContent), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        css: $7d2527153712d181$var$avatarImageStyles,
        onError: ()=>setHasImageErrored(true)
    }));
};
const $7d2527153712d181$export$ac3673635a5387be = (props)=>{
    if ((0, $VSDnB.fg)('team-avatar-radii')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3WiFt.TeamAvatarImage), props);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($7d2527153712d181$export$9cfabd93718c0a2e, props);
};

});
parcelRegister("h8cgU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c78cb3eb85357720$var$_react = $c78cb3eb85357720$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c78cb3eb85357720$var$_peopleGroup = $c78cb3eb85357720$var$_interopRequireDefault((parcelRequire("fptva")));
function $c78cb3eb85357720$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c78cb3eb85357720$var$PeopleIcon = (props)=>/*#__PURE__*/ $c78cb3eb85357720$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
    }, props, {
        newIcon: $c78cb3eb85357720$var$_peopleGroup.default
    }));
$c78cb3eb85357720$var$PeopleIcon.displayName = 'PeopleIcon';
var $c78cb3eb85357720$var$_default = module.exports.default = $c78cb3eb85357720$var$PeopleIcon;

});

parcelRegister("4jyNe", function(module, exports) {

$parcel$export(module.exports, "FallbackAvatar", () => $c800ab58c4d12cbb$export$eb63dcc490f6bbcd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $c800ab58c4d12cbb$var$styles = {
    wrapper: "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o"
};
function $c800ab58c4d12cbb$export$eb63dcc490f6bbcd(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $c800ab58c4d12cbb$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                    clipPath: "url(#clip0_2032_552)",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "#DCDFE4"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                            fill: "#44546F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                        id: "clip0_2032_552",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
}

});

parcelRegister("3WiFt", function(module, exports) {

$parcel$export(module.exports, "TeamAvatarImage", () => $ed1385df3f8966b5$export$ac3673635a5387be);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $a9yTd = parcelRequire("a9yTd");
const $ed1385df3f8966b5$var$boxShadowCssVar = '--avatar-box-shadow';
const $ed1385df3f8966b5$var$bgColorCssVar = '--avatar-bg-color';
/**
 * We need to maintan the container styles manually until Avatar provides the correct border radius.
 * After that we can return to wrapping in <AvatarContent> rather than span
 */ const $ed1385df3f8966b5$var$containerStyles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk18uv _aetrf705 _1peqidpf _11fnglyw",
    circle: "_2rko1q5u _14mj1q5u",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peqs237"
};
const $ed1385df3f8966b5$var$unboundStyles = {
    root: "_vchh18uv _bfhkcxp3 _16qs1nhn",
    interactive: "_80omtlke _4tpuw83z _ez1ykb7n _gcm11et6 _eeh8kb7n _jlxit94y"
};
const $ed1385df3f8966b5$var$avatarImageStyles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq"
};
const $ed1385df3f8966b5$var$SIZES = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $ed1385df3f8966b5$var$borderRadiusMap = {
    xsmall: "_2rko1y44",
    small: "_2rkoi2wt",
    medium: "_2rkoftgi",
    large: "_2rko19bv",
    xlarge: "_2rko1tcg",
    xxlarge: "_2rkozwfg"
};
const $ed1385df3f8966b5$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $ed1385df3f8966b5$export$ac3673635a5387be = ({ alt: alt = '', src: src, size: size, testId: testId })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $5uXOq.useState)(false);
    // If src changes, reset state
    (0, $5uXOq.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a9yTd.FallbackAvatar), {
        "aria-label": alt,
        width: $ed1385df3f8966b5$var$SIZES[size],
        height: $ed1385df3f8966b5$var$SIZES[size],
        "data-testid": testId
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        "aria-label": alt,
        className: (0, $bwpsq.default)([
            $ed1385df3f8966b5$var$unboundStyles.root,
            $ed1385df3f8966b5$var$containerStyles.root,
            $ed1385df3f8966b5$var$borderRadiusMap[size],
            $ed1385df3f8966b5$var$widthHeightMap[size]
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
            src: src,
            alt: alt,
            "data-testId": testId && `${testId}--image`,
            onError: ()=>setHasImageErrored(true),
            className: (0, $bwpsq.default)([
                $ed1385df3f8966b5$var$avatarImageStyles.image
            ])
        })
    });
};

});
parcelRegister("a9yTd", function(module, exports) {

$parcel$export(module.exports, "FallbackAvatar", () => $dc76f912cc56de65$export$eb63dcc490f6bbcd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $dc76f912cc56de65$var$styles = {
    wrapper: "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o"
};
function $dc76f912cc56de65$export$eb63dcc490f6bbcd(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $dc76f912cc56de65$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                    clipPath: "url(#clip0_2032_552)",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "#DCDFE4"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                            fill: "#44546F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                        id: "clip0_2032_552",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
}

});



parcelRegister("ggnNZ", function(module, exports) {

$parcel$export(module.exports, "isSquareIcon", () => $cf7e4fad001aa258$export$d5a05ffb65695bc0);

var $VSDnB = parcelRequire("VSDnB");
function $cf7e4fad001aa258$export$d5a05ffb65695bc0(src) {
    if (!src) return false;
    try {
        const url = new URL(src);
        const host = url.host;
        const path = url.pathname;
        if ((host.startsWith('ptc-directory-sited-static') || host.startsWith('teams-directory-frontend')) && path.includes('teams/avatars/v4') && (0, $VSDnB.fg)('enable-team-avatar-switch')) return true;
    } catch  {
    // The src wasn't a URL, so it's obviously not the refreshed avatar.
    }
    return false;
}

});



parcelRegister("4hqZ5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ff23a711b4b109cded01cd0a5945034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $31ddae7439c341a9$var$_react = $31ddae7439c341a9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $31ddae7439c341a9$var$_peopleGroup = $31ddae7439c341a9$var$_interopRequireDefault((parcelRequire("fptva")));

var $31ddae7439c341a9$var$_people = $31ddae7439c341a9$var$_interopRequireDefault((parcelRequire("h8cgU")));
function $31ddae7439c341a9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $31ddae7439c341a9$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $31ddae7439c341a9$var$_react.default.createElement($31ddae7439c341a9$var$_peopleGroup.default, Object.assign({
        LEGACY_fallbackIcon: $31ddae7439c341a9$var$_people.default
    }, props));
$31ddae7439c341a9$var$PeopleGroupIcon.Name = 'PeopleGroupIconMigration';
var $31ddae7439c341a9$var$_default = module.exports.default = $31ddae7439c341a9$var$PeopleGroupIcon;

});

parcelRegister("fuhQD", function(module, exports) {

$parcel$export(module.exports, "VerifiedTeamIcon", () => $a137cc376204c926$export$d7949f68d31e5edd);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $gqGjQ = parcelRequire("gqGjQ");

var $fGmbh = parcelRequire("fGmbh");

var $3bDjY = parcelRequire("3bDjY");

var $27dJz = parcelRequire("27dJz");
const $a137cc376204c926$export$d7949f68d31e5edd = ({ label: label = 'Verified Team', showTooltip: showTooltip, customTooltipContent: customTooltipContent })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const tooltipContent = showTooltip ? customTooltipContent || formatMessage((0, $27dJz.messages).verifiedIconDefaultTooltip) : undefined;
    return tooltipContent ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
            tabIndex: 0,
            role: "button",
            "data-testid": "verified-team-icon",
            children: [
                ' ',
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gqGjQ))), {
                    color: "var(--ds-icon-accent-blue, #1D7AFC)",
                    LEGACY_size: "medium",
                    label: tooltipContent,
                    spacing: "spacious",
                    LEGACY_fallbackIcon: (0, $fGmbh.default)
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gqGjQ))), {
        color: "var(--ds-icon-accent-blue, #1D7AFC)",
        LEGACY_size: "medium",
        spacing: "spacious",
        label: label,
        LEGACY_fallbackIcon: (0, $fGmbh.default)
    });
};

});
parcelRegister("gqGjQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e3a26defb7fafbfaa404238ab66b0242>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bf5fe6b7538334be$var$_react = $bf5fe6b7538334be$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bf5fe6b7538334be$var$_baseNew = $bf5fe6b7538334be$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $bf5fe6b7538334be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusVerified".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing verified content.
Filled status icons provide higher visual contrast draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bf5fe6b7538334be$var$StatusVerifiedIcon = (props)=>/*#__PURE__*/ $bf5fe6b7538334be$var$_react.default.createElement($bf5fe6b7538334be$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.85.444a1.713 1.713 0 0 1 2.301 0L10.3 1.486a.2.2 0 0 0 .15.055L12 1.48a1.71 1.71 0 0 1 1.762 1.479l.21 1.537a.2.2 0 0 0 .081.139l1.226.95c.696.54.87 1.52.4 2.266l-.828 1.312a.2.2 0 0 0-.027.158l.328 1.516a1.713 1.713 0 0 1-1.151 1.993l-1.477.474a.2.2 0 0 0-.123.103l-.723 1.372a1.713 1.713 0 0 1-2.162.787l-1.435-.587a.2.2 0 0 0-.161 0l-1.436.587a1.713 1.713 0 0 1-2.162-.787l-.723-1.372a.22.22 0 0 0-.124-.103L2 12.83a1.713 1.713 0 0 1-1.15-1.993l.327-1.516a.2.2 0 0 0-.027-.158L.322 7.852a1.713 1.713 0 0 1 .4-2.266l1.225-.95a.2.2 0 0 0 .081-.14l.21-1.536a1.71 1.71 0 0 1 1.763-1.48l1.55.06a.2.2 0 0 0 .15-.055zm-.1 9.384L4.826 7.519l-1.152.961 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$bf5fe6b7538334be$var$StatusVerifiedIcon.displayName = 'StatusVerifiedIcon';
var $bf5fe6b7538334be$var$_default = module.exports.default = $bf5fe6b7538334be$var$StatusVerifiedIcon;

});

parcelRegister("fGmbh", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9bd2ad2ea16bb95$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $d9bd2ad2ea16bb95$var$VerifiedIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "33",
        height: "32",
        viewBox: "0 0 33 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.6666 6.65507C17.7592 4.89362 15.2407 4.89362 14.3332 6.65507C13.7879 7.7135 12.5577 8.22306 11.4237 7.86022C9.53648 7.25639 7.75565 9.03721 8.35949 10.9244C8.72232 12.0584 8.21276 13.2886 7.15434 13.8339C5.39289 14.7414 5.39289 17.2599 7.15434 18.1674C8.21276 18.7127 8.72232 19.9429 8.35949 21.0769C7.75565 22.9641 9.53648 24.7449 11.4237 24.1411C12.5577 23.7783 13.7879 24.2878 14.3332 25.3462C15.2407 27.1077 17.7592 27.1077 18.6666 25.3462C19.212 24.2878 20.4421 23.7783 21.5761 24.1411C23.4634 24.7449 25.2442 22.9641 24.6404 21.0769C24.2775 19.9429 24.7871 18.7127 25.8455 18.1674C27.607 17.2599 27.607 14.7414 25.8455 13.8339C24.7871 13.2886 24.2775 12.0584 24.6404 10.9244C25.2442 9.03721 23.4634 7.25639 21.5761 7.86022C20.4421 8.22306 19.212 7.7135 18.6666 6.65507ZM20.7898 12.7002L20.8932 12.7923C21.323 13.2221 21.3537 13.8998 20.9853 14.365L20.8932 14.4684L16.1524 19.2091C15.7226 19.6389 15.0449 19.6696 14.5797 19.3012L14.4764 19.2091L12.106 16.8388C11.6431 16.3759 11.6431 15.6255 12.106 15.1627C12.5358 14.7329 13.2135 14.7022 13.6787 15.0706L13.7821 15.1627L15.3146 16.6944L19.2171 12.7923C19.6469 12.3625 20.3246 12.3318 20.7898 12.7002Z",
            fill: "currentColor"
        })
    });
/**
 * __VerifiedIcon__
 */ const $d9bd2ad2ea16bb95$var$VerifiedIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $d9bd2ad2ea16bb95$var$VerifiedIconGlyph
    });
var $d9bd2ad2ea16bb95$export$2e2bcd8739ae039 = $d9bd2ad2ea16bb95$var$VerifiedIcon;

});

parcelRegister("27dJz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $952fb45ddff9712a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $952fb45ddff9712a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    verifiedIconDefaultTooltip: {
        id: 'ptc-directory.team-profile-page.team-name.verified-team.icon.tooltip',
        defaultMessage: 'Managed teams are verified because they can only be changed by an admin.',
        description: 'Tooltip text for the verified team icon'
    }
});

});



parcelRegister("fIpmY", function(module, exports) {

$parcel$export(module.exports, "MultiValueContainer", () => $0a44bca42d442dd9$export$cf9cf2a30a59265c);
/* MultiValueContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bChGW = parcelRequire("bChGW");

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $ousew = parcelRequire("ousew");

var $8fG8p = parcelRequire("8fG8p");

var $3smIt = parcelRequire("3smIt");

var $jNYXM = parcelRequire("jNYXM");
const $0a44bca42d442dd9$var$valueContainerStyles = {
    root: "_yv0e5bpd _ca0q12x7 _n3td12x7 _19bv12x7 _1reo15vq _18m91wug _1fjgglyw _c71l1osq _1suq18uv _1ke8idpf"
};
class $0a44bca42d442dd9$export$cf9cf2a30a59265c extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            valueSize: nextProps.getValue ? nextProps.getValue().length : 0,
            previousValueSize: prevState.valueSize
        };
    }
    constructor(props){
        super(props), this.timeoutId = null, this.scrollToBottom = ()=>{
            this.timeoutId = window.setTimeout(()=>{
                const { ref: { current: current } } = this.valueContainerInnerProps;
                if (current !== null) {
                    const container = (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).findDOMNode(current);
                    if (container instanceof HTMLDivElement) container.scrollTop = container.scrollHeight;
                }
                this.timeoutId = null;
            });
        }, this.showPlaceholder = ()=>{
            const { selectProps: { value: value } } = this.props;
            return value && value.length > 0;
        }, this.addPlaceholder = (placeholder)=>{
            const children = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(this.props.children, (child)=>(0, $3smIt.isChildInput)(child) && this.showPlaceholder() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                    placeholder: placeholder
                }) : child);
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                children: children
            });
        }, this.renderChildren = ()=>{
            const { //@ts-ignore react-select unsupported props
            selectProps: { addMoreMessage: addMoreMessage, isDisabled: isDisabled } } = this.props;
            // Do not render "Add more..." message if picker is disabled
            if (isDisabled) return this.props.children;
            if (addMoreMessage === undefined) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $8fG8p.messages).addMore,
                children: (addMore)=>{
                    let addMoreMessages = addMore;
                    if (addMore && typeof addMore === 'string') addMoreMessages = [
                        addMore
                    ];
                    const placeholder = addMoreMessages?.join('') ?? '';
                    return this.addPlaceholder(placeholder);
                }
            });
            return this.addPlaceholder(addMoreMessage);
        }, //@ts-ignore react-select unsupported props
        this.onValueContainerClick = this.props.selectProps.onValueContainerClick;
        this.state = {
            valueSize: 0,
            previousValueSize: 0
        };
        this.valueContainerInnerProps = {
            ref: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef()
        };
    }
    componentDidUpdate() {
        const { previousValueSize: previousValueSize, valueSize: valueSize } = this.state;
        //@ts-ignore react-select unsupported props
        const { isFocused: isFocused } = this.props.selectProps;
        if (valueSize > previousValueSize && isFocused) {
            if (this.timeoutId) {
                window.clearTimeout(this.timeoutId);
                this.timeoutId = null;
            }
            this.scrollToBottom();
        }
    }
    componentWillUnmount() {
        if (this.timeoutId) window.clearTimeout(this.timeoutId);
    }
    render() {
        const { children: children, innerProps: innerProps, ...valueContainerProps } = this.props;
        const props = {
            ...valueContainerProps,
            innerProps: this.valueContainerInnerProps
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jNYXM.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).ValueContainer, {
                ...props,
                xcss: $0a44bca42d442dd9$var$valueContainerStyles.root,
                children: this.renderChildren()
            })
        });
    }
}

});
parcelRegister("jNYXM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4661c12157fe2c0e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $4661c12157fe2c0e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Conditional wrapper for the ValueContainer in Select. Provides a workaround
 * for issues using react-select on react-beautiful-dnd Draggable elements.
 * @returns
 */ var $4661c12157fe2c0e$var$_ref = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
const $4661c12157fe2c0e$var$ValueContainerWrapper = ({ children: children, isEnabled: isEnabled, onMouseDown: onMouseDown })=>{
    return isEnabled ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, jsx-a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $4661c12157fe2c0e$var$_ref,
        onMouseDown: onMouseDown
    }, children) : children;
};
var $4661c12157fe2c0e$export$2e2bcd8739ae039 = $4661c12157fe2c0e$var$ValueContainerWrapper;

});


parcelRegister("3QONt", function(module, exports) {

$parcel$export(module.exports, "Option", () => $99bbff5d4b124ec0$export$36d18380658d5d20);

var $2OMIu = parcelRequire("2OMIu");

var $MHKc7 = parcelRequire("MHKc7");

var $bChGW = parcelRequire("bChGW");

var $3bDjY = parcelRequire("3bDjY");

var $5uXOq = parcelRequire("5uXOq");

var $7SChb = parcelRequire("7SChb");

var $IMPHa = parcelRequire("IMPHa");

var $8QliZ = parcelRequire("8QliZ");

var $jC9IK = parcelRequire("jC9IK");

var $3SqqV = parcelRequire("3SqqV");

var $f4ndh = parcelRequire("f4ndh");

var $3smIt = parcelRequire("3smIt");

var $M0UM1 = parcelRequire("M0UM1");
const $99bbff5d4b124ec0$var$defaultOption = ({ data: { data: data }, isSelected: isSelected, status: status })=>// @ts-expect-error - <UserOption> expects `data` to be of User interface, but data is OptionData interface by default. Check if the `user` props in UserOption should also accept OptionData or refactor this file to accept generics
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7SChb.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
const $99bbff5d4b124ec0$var$dataOption = ({ data: { data: data }, isSelected: isSelected, status: status, selectProps: selectProps })=>{
    if ((0, $3smIt.isExternalUser)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $IMPHa.default), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $3smIt.isUser)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7SChb.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $3smIt.isEmail)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3SqqV.default), {
        email: data,
        emailValidity: (0, $M0UM1.isValidEmail)(data.id),
        isSelected: isSelected,
        label: selectProps.emailLabel
    });
    if ((0, $3smIt.isTeam)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8QliZ.default), {
        team: data,
        isSelected: isSelected
    });
    if ((0, $3smIt.isGroup)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jC9IK.default), {
        group: data,
        isSelected: isSelected
    });
    if ((0, $3smIt.isCustom)(data)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4ndh.default), {
        data: data,
        isSelected: isSelected
    });
    return null;
};
const $99bbff5d4b124ec0$var$dataOptionWithTooltip = (props)=>{
    if (props.data?.data?.tooltip) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: props.data?.data?.tooltip,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                ...tooltipProps,
                children: $99bbff5d4b124ec0$var$dataOption(props)
            })
    });
    return $99bbff5d4b124ec0$var$dataOption(props);
};
const $99bbff5d4b124ec0$export$36d18380658d5d20 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).Option, {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Suspense, {
            fallback: $99bbff5d4b124ec0$var$defaultOption(props),
            children: $99bbff5d4b124ec0$var$dataOptionWithTooltip(props)
        })
    });

});
parcelRegister("7SChb", function(module, exports) {

$parcel$export(module.exports, "UserOption", () => $f97ab606ddc0972b$export$8e59f78010871662);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");

var $bfXHv = parcelRequire("bfXHv");

var $1Y8bw = parcelRequire("1Y8bw");

var $5pJx4 = parcelRequire("5pJx4");

var $3smIt = parcelRequire("3smIt");

var $VSDnB = parcelRequire("VSDnB");
class $f97ab606ddc0972b$export$8e59f78010871662 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bfXHv.AvatarItemOption), {
            avatar: this.renderAvatar(),
            lozenge: this.getLozengeProps(),
            isDisabled: this.props.user.isDisabled,
            primaryText: this.getPrimaryText(),
            secondaryText: this.renderSecondaryText()
        });
    }
    constructor(...args){
        super(...args), this.getPrimaryText = ()=>{
            const { user: { name: name, publicName: publicName, highlight: highlight } } = this.props;
            const result = [
                /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                    key: "name",
                    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    css: (0, $bfXHv.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-text, ${0, $829f609a65d26a98$export$7d61b15e0da132af})`)
                }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1Y8bw.HighlightText), {
                    highlights: highlight && highlight.name
                }, name))
            ];
            if ((0, $3smIt.hasValue)(publicName) && name.trim() !== publicName.trim()) result.push(/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
                key: "publicName"
            }, ' ', /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $bfXHv.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`)
            }, "(", /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1Y8bw.HighlightText), {
                highlights: highlight && highlight.publicName
            }, publicName), ")")));
            return result;
        }, this.renderSecondaryText = ()=>this.props.user.byline ? /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $bfXHv.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`)
            }, this.props.user.byline) : undefined, this.renderAvatar = ()=>{
            const { user: { avatarUrl: avatarUrl }, status: status } = this.props;
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5pJx4.SizeableAvatar), {
                appearance: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $VSDnB.fg)('platform-component-visual-refresh') ? 'medium' : 'big',
                src: avatarUrl,
                presence: status
            });
        }, this.getLozengeProps = ()=>typeof this.props.user.lozenge === 'string' ? {
                text: this.props.user.lozenge
            } : this.props.user.lozenge;
    }
}

});
parcelRegister("bfXHv", function(module, exports) {

$parcel$export(module.exports, "textWrapper", () => $9d51fec62de0f8e9$export$aa6223da92b253dd);
$parcel$export(module.exports, "AvatarItemOption", () => $9d51fec62de0f8e9$export$164a9d9b3b86dd0c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $aYAc3 = parcelRequire("aYAc3");

var $3smIt = parcelRequire("3smIt");
function $9d51fec62de0f8e9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

const $9d51fec62de0f8e9$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("7LtDy")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $9d51fec62de0f8e9$var$wrapper = (isDisabled)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1,
        outline: 'none',
        margin: 0,
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: isDisabled ? "var(--ds-opacity-disabled, 0.4)" : undefined
    });
const $9d51fec62de0f8e9$var$optionWrapper = {
    name: "13552d7",
    styles: "max-width:100%;min-width:0;line-height:1.4;padding-left:var(--ds-space-100, 8px)"
};
const $9d51fec62de0f8e9$var$getTextStyle = (isSecondary)=>{
    const secondaryCssArgs = isSecondary ? {
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
    } : {};
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        margin: 0,
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...secondaryCssArgs
    });
};
const $9d51fec62de0f8e9$var$additionalInfo = {
    name: "1hvgowa",
    styles: "float:right;margin-left:var(--ds-space-100, 8px)"
};
const $9d51fec62de0f8e9$export$aa6223da92b253dd = (color)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'inline',
        color: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color
    });
const $9d51fec62de0f8e9$export$164a9d9b3b86dd0c = ({ avatar: avatar, isDisabled: isDisabled, lozenge: lozenge, primaryText: primaryText, secondaryText: secondaryText })=>{
    const renderLozenge = ()=>{
        if ((0, $3smIt.isLozengeText)(lozenge)) {
            if (lozenge?.tooltip) // Note that entire Lozenge must be wrapped in the Tooltip (rather than just the
            // Lozenge text) or tooltip won't work
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Suspense, {
                fallback: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aYAc3.default), lozenge, lozenge.text)
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)($9d51fec62de0f8e9$var$AsyncTooltip, {
                content: lozenge.tooltip
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aYAc3.default), lozenge, lozenge.text)));
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aYAc3.default), lozenge, lozenge.text);
        }
        return lozenge;
    };
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $9d51fec62de0f8e9$var$wrapper(isDisabled)
    }, avatar, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $9d51fec62de0f8e9$var$optionWrapper
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $9d51fec62de0f8e9$var$getTextStyle()
    }, primaryText), secondaryText && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $9d51fec62de0f8e9$var$getTextStyle(true)
    }, secondaryText))), lozenge && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $9d51fec62de0f8e9$var$additionalInfo
    }, renderLozenge())));
};

});

parcelRegister("1Y8bw", function(module, exports) {

$parcel$export(module.exports, "HighlightText", () => $dbc13bb98bfc2c59$export$bb02e7bc6e1a7119);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
class $dbc13bb98bfc2c59$export$bb02e7bc6e1a7119 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const { children: children, highlights: highlights } = this.props;
        const parts = [];
        let lastIndex = 0;
        if (highlights) highlights.sort((a, b)=>a.start - b.start).reduce((highlights, highlight)=>{
            const lastHighlight = highlights[highlights.length - 1];
            if (!lastHighlight || highlight.start > lastHighlight.end + 1) return highlights.concat(highlight);
            if (highlight.end > lastHighlight.end) lastHighlight.end = highlight.end;
            return highlights;
        }, []).forEach((highlight)=>{
            const { start: start, end: end } = highlight;
            if (start >= end) return;
            if (start > lastIndex) parts.push({
                value: children.substring(lastIndex, start),
                matches: false
            });
            parts.push({
                value: children.substring(start, end + 1),
                matches: true
            });
            lastIndex = end + 1;
        });
        if (lastIndex < children.length) parts.push({
            value: children.substring(lastIndex, children.length),
            matches: false
        });
        return parts.map((part, index)=>{
            if (part.matches) return /*#__PURE__*/ (0, $2OMIu.jsx)("b", {
                children: part.value
            }, index);
            return part.value;
        });
    }
}

});


parcelRegister("IMPHa", function(module, exports) {

$parcel$export(module.exports, "default", () => $244ad38dc6a6e0e3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $244ad38dc6a6e0e3$var$AsyncExternalUserOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("gT7hv")).then((module)=>{
        return {
            default: module.ExternalUserOption
        };
    }));
var $244ad38dc6a6e0e3$export$2e2bcd8739ae039 = $244ad38dc6a6e0e3$var$AsyncExternalUserOption;

});
parcelRegister("gT7hv", function(module, exports) {

let $c4b76e5519d7804b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c4b76e5519d7804b$var$load("76n7a"),
    $c4b76e5519d7804b$var$load("l253H"),
    $c4b76e5519d7804b$var$load("ffQaD"),
    $c4b76e5519d7804b$var$load("kvRbA"),
    $c4b76e5519d7804b$var$load("5VpQx")
]).then(()=>parcelRequire('358Ik'));

});


parcelRegister("8QliZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e55a6473b89765e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $6e55a6473b89765e$var$AsyncTeamOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("g6gqU")).then((module)=>{
        return {
            default: module.TeamOption
        };
    }));
var $6e55a6473b89765e$export$2e2bcd8739ae039 = $6e55a6473b89765e$var$AsyncTeamOption;

});
parcelRegister("g6gqU", function(module, exports) {

let $bb89f424849bb75d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bb89f424849bb75d$var$load("k9jju").then(()=>parcelRequire('8Pt0F'));

});


parcelRegister("jC9IK", function(module, exports) {

$parcel$export(module.exports, "default", () => $d883d47691bcfd0f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $d883d47691bcfd0f$var$AsyncGroupOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("itjaq")).then((module)=>{
        return {
            default: module.GroupOption
        };
    }));
var $d883d47691bcfd0f$export$2e2bcd8739ae039 = $d883d47691bcfd0f$var$AsyncGroupOption;

});
parcelRegister("itjaq", function(module, exports) {

let $d729cda1eb2cfa2f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d729cda1eb2cfa2f$var$load("ioajZ").then(()=>parcelRequire('ctysX'));

});


parcelRegister("3SqqV", function(module, exports) {

$parcel$export(module.exports, "default", () => $120c09dc4c3dec5f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $120c09dc4c3dec5f$var$AsyncEmailOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("8Wiyo")).then((module)=>{
        return {
            default: module.EmailOption
        };
    }));
var $120c09dc4c3dec5f$export$2e2bcd8739ae039 = $120c09dc4c3dec5f$var$AsyncEmailOption;

});
parcelRegister("8Wiyo", function(module, exports) {

let $682221e12a9af171$var$load = (parcelRequire("28QjX"))(4);
module.exports = $682221e12a9af171$var$load("9zytF").then(()=>parcelRequire('4CChz'));

});


parcelRegister("f4ndh", function(module, exports) {

$parcel$export(module.exports, "default", () => $57cc7ffb924c0e65$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $57cc7ffb924c0e65$var$AsyncCustomOption = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("W94KR")).then((module)=>{
        return {
            default: module.CustomOption
        };
    }));
var $57cc7ffb924c0e65$export$2e2bcd8739ae039 = $57cc7ffb924c0e65$var$AsyncCustomOption;

});
parcelRegister("W94KR", function(module, exports) {

let $0aec75234bb4e828$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0aec75234bb4e828$var$load("bkE8d").then(()=>parcelRequire('iphiD'));

});


parcelRegister("M0UM1", function(module, exports) {

$parcel$export(module.exports, "isValidEmail", () => $8e40db00ccd032ac$export$371e338370561054);
const $8e40db00ccd032ac$var$validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const $8e40db00ccd032ac$var$potentialRegex = /^[^\s@]+@[^\s@]*$/i;
const $8e40db00ccd032ac$export$371e338370561054 = (inputText)=>{
    if (inputText.match($8e40db00ccd032ac$var$validRegex)) return 'VALID';
    if (inputText.match($8e40db00ccd032ac$var$potentialRegex)) return 'POTENTIAL';
    return 'INVALID';
};

});


parcelRegister("6Kkci", function(module, exports) {

$parcel$export(module.exports, "SingleValue", () => $667e1159563155af$export$1949dac661ba6e3a);
/* SingleValue.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bChGW = parcelRequire("bChGW");

var $5pJx4 = parcelRequire("5pJx4");

var $3smIt = parcelRequire("3smIt");

var $fuhQD = parcelRequire("fuhQD");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");
var $c0aEF = parcelRequire("c0aEF");
const $667e1159563155af$var$styles = {
    avatarItem: "_1reo15vq _18m915vq _4cvr1h6o _1ul953f4",
    avatarItemTextWrapper: "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _p12f1osq _bozgu2gc _vwz419ii",
    avatarItemText: "_syaz1fxt _1reo15vq _1bto1l2s _o5721q9c"
};
const $667e1159563155af$var$ElementAfter = (props)=>{
    const { data: { data: data } } = props;
    if ((0, $3smIt.isTeam)(data) && data.verified) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fuhQD.VerifiedTeamIcon), {});
    return null;
};
const $667e1159563155af$export$1949dac661ba6e3a = (props)=>{
    const { data: { label: label, data: data }, //@ts-ignore react-select unsupported props
    selectProps: { appearance: appearance, isFocused: isFocused } } = props;
    return !isFocused ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).SingleValue, {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bUmQV.default), {
            xcss: $667e1159563155af$var$styles.avatarItem,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5pJx4.SizeableAvatar), {
                    src: (0, $3smIt.getAvatarUrl)(data),
                    appearance: appearance,
                    type: (0, $3smIt.isTeam)(data) ? 'team' : 'person'
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: $667e1159563155af$var$styles.avatarItem,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            $667e1159563155af$var$styles.avatarItemTextWrapper
                        ]),
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: $667e1159563155af$var$styles.avatarItemText,
                            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                                alignBlock: "center",
                                children: [
                                    label,
                                    /*#__PURE__*/ (0, $2OMIu.jsx)($667e1159563155af$var$ElementAfter, {
                                        ...props
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    }) : null;
};

});

parcelRegister("OxpB4", function(module, exports) {

$parcel$export(module.exports, "Input", () => $98c53988263e2c5c$export$f5b8910cec6cf069);
/* Input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");
const $98c53988263e2c5c$var$inputStyles = {
    root: "_5ce6131l _1ir3kb7n _h5gq131l"
};
class $98c53988263e2c5c$export$f5b8910cec6cf069 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    /**
   * Overrides the default behaviour of react-select lib
   *
   * The getter is a workaround for original behaviour of the react-select lib.
   * Placeholder and Input are linked not via label, aria-label or aria-labeledby, but through aria-describedby.
   * Basically in the getter we reassign Placeholder ID from aria-describedby to aria-labelledby
   * {@link https://github.com/JedWatson/react-select/issues/5651#issue-1731353197 GitHub}
   */ get ariaLabelledBy() {
        return this.props['aria-labelledby'] ?? this.props['aria-describedby'];
    }
    get ariaDescribedBy() {
        return this.props.selectProps?.['aria-describedby'] ?? this.props['aria-describedby'];
    }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).Input, {
            ...this.props,
            "aria-labelledby": this.ariaLabelledBy,
            "aria-describedby": this.ariaDescribedBy,
            innerRef: this.props.innerRef,
            onKeyPress: this.handleKeyPress,
            xcss: $98c53988263e2c5c$var$inputStyles.root
        });
    }
    constructor(...args){
        super(...args), // onKeyPress is used instead as
        // react-select is using onKeyDown for capturing keyboard input
        this.handleKeyPress = (e)=>{
            if (e.key === 'Enter') e.preventDefault();
            //@ts-ignore react-select unsupported props
            if (this.props.selectProps?.disableInput) e.preventDefault();
        };
    }
}

});

parcelRegister("ee8bl", function(module, exports) {

$parcel$export(module.exports, "SingleValueContainer", () => $bd8914f05f01f9cc$export$afa5f855316c6a48);
/* SingleValueContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");

var $5pJx4 = parcelRequire("5pJx4");

var $jNYXM = parcelRequire("jNYXM");
const $bd8914f05f01f9cc$var$valueContainerStyles = {
    root: "_yv0e5bpd _ca0q12x7 _n3td12x7 _19bvze3t _1reo15vq _18m91wug _1fjgglyw _c71l1osq _1suq18uv _1ke8idpf"
};
const $bd8914f05f01f9cc$var$placeholderIconContainer = null;
const $bd8914f05f01f9cc$var$wrapperStyle = null;
const $bd8914f05f01f9cc$var$showUserAvatar = (inputValue, value)=>value && value.data && inputValue === value.label;
class $bd8914f05f01f9cc$export$afa5f855316c6a48 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { children: children, ...valueContainerProps } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jNYXM.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bChGW.components).ValueContainer, {
                ...valueContainerProps,
                xcss: $bd8914f05f01f9cc$var$valueContainerStyles.root,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            "_nd5l1kqh _19bv12x7 _vwz4idpf"
                        ]),
                        children: this.renderAvatar()
                    }),
                    children
                ]
            })
        });
    }
    constructor(...args){
        super(...args), this.renderAvatar = ()=>{
            const { hasValue: hasValue, //@ts-ignore react-select unsupported props
            selectProps: { appearance: appearance, isFocused: isFocused, inputValue: inputValue, value: value, placeholderAvatar: placeholderAvatar } } = this.props;
            if (isFocused || !hasValue) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5pJx4.SizeableAvatar), {
                appearance: appearance,
                type: placeholderAvatar,
                src: $bd8914f05f01f9cc$var$showUserAvatar(inputValue, value) ? value.data.avatarUrl : undefined
            });
            return null;
        }, //@ts-ignore react-select unsupported props
        this.onValueContainerClick = this.props.selectProps.onValueContainerClick, this.Wrapper = ({ children: children })=>{
            return this.onValueContainerClick ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                onMouseDown: this.onValueContainerClick,
                className: (0, $bwpsq.default)([
                    "_16jlkb7n"
                ]),
                children: children
            }) : children;
        };
    }
}

});

parcelRegister("h3ej5", function(module, exports) {

$parcel$export(module.exports, "PopupInput", () => $be92b88945d06137$export$d8edbfd510a7db82);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $OxpB4 = parcelRequire("OxpB4");
class $be92b88945d06137$export$d8edbfd510a7db82 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidMount() {
        if (this.ref) // @ts-ignore
        this.ref.select();
    }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $OxpB4.Input), {
            ...this.props,
            innerRef: this.handleInnerRef
        });
    }
    constructor(...args){
        super(...args), this.ref = null, this.handleInnerRef = (ref)=>{
            this.ref = ref;
            if (this.props.innerRef) this.props.innerRef(ref);
        };
    }
}

});

parcelRegister("6Ks8i", function(module, exports) {

$parcel$export(module.exports, "PopupControl", () => $77b9c0d4ebdf44c2$export$a0cb1b4352357fcc);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $7mofJ = parcelRequire("7mofJ");
const $77b9c0d4ebdf44c2$var$controlWrapper = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    flexDirection: 'column',
    padding: `0px ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
});
const $77b9c0d4ebdf44c2$var$labelStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    paddingBottom: "var(--ds-space-050, 4px)",
    paddingLeft: "var(--ds-space-0, 0px)",
    paddingRight: "var(--ds-space-0, 0px)",
    paddingTop: "var(--ds-space-250, 20px)"
});
class $77b9c0d4ebdf44c2$export$a0cb1b4352357fcc extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { popupTitle: popupTitle } } = this.props;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $77b9c0d4ebdf44c2$var$controlWrapper
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $77b9c0d4ebdf44c2$var$labelStyle
        }, popupTitle), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7mofJ.default), this.props));
    }
}

});
parcelRegister("7mofJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eb2a834f44e793b$export$2e2bcd8739ae039);
/* Control.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");

var $DEWI6 = parcelRequire("DEWI6");
const $6eb2a834f44e793b$var$controlStyles = {
    invalid: "_1h6d1bqt _4cvx1bqt",
    focused: "_1h6d1p6i _bfhk1j9a _4cvx1p6i _irr31j9a",
    disabled: "_irr3syzs",
    subtle: "_1h6d3acm _bfhk18uv _4cvx3acm _irr31gly",
    root: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1h6d1elr _bfhk1j9a _p12f1osq _14regrf3 _4cvx1elr _irr31d5g _1a98zg3v",
    compact: "_1tke1wug"
};
const $6eb2a834f44e793b$var$Control = (props)=>{
    const isCompact = props.appearance === 'compact';
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).Control, {
        ...props,
        xcss: (0, $DEWI6.cx)($6eb2a834f44e793b$var$controlStyles.root, isCompact && $6eb2a834f44e793b$var$controlStyles.compact, (props.selectProps.subtle || props.selectProps.noBorder) && $6eb2a834f44e793b$var$controlStyles.subtle, props.isFocused && $6eb2a834f44e793b$var$controlStyles.focused, props.isInvalid && $6eb2a834f44e793b$var$controlStyles.invalid, props.isDisabled && $6eb2a834f44e793b$var$controlStyles.disabled)
    });
};
var $6eb2a834f44e793b$export$2e2bcd8739ae039 = $6eb2a834f44e793b$var$Control;

});


parcelRegister("lYehz", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $9f291598157d275c$export$d9b273488cd8ce6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");

var $f8Sb3 = parcelRequire("f8Sb3");
const $9f291598157d275c$var$getFooterStyle = ()=>{
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
    });
};
class $9f291598157d275c$export$d9b273488cd8ce6f extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bChGW.components).Menu, this.props, this.props.selectProps.header, this.props.children, this.props.selectProps.footer && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $9f291598157d275c$var$getFooterStyle()
        }, this.props.selectProps.footer));
    }
}

});


parcelRegister("fuG1P", function(module, exports) {

$parcel$export(module.exports, "getCreatableProps", () => $3865687a924ab788$export$36f97d8afa97203d);

var $8QpSo = parcelRequire("8QpSo");


var $M0UM1 = parcelRequire("M0UM1");

var $3smIt = parcelRequire("3smIt");
const $3865687a924ab788$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $3865687a924ab788$var$isValidNewOption = (isValidEmail = (0, $M0UM1.isValidEmail))=>(inputValue)=>inputValue && $3865687a924ab788$var$validOption.includes(isValidEmail(inputValue));
const $3865687a924ab788$var$getNewOptionData = (inputValue)=>({
        label: inputValue,
        value: inputValue,
        data: {
            id: inputValue,
            name: inputValue,
            type: (0, $f93312f7d4958f08$export$6662b3461398ef8c)
        }
    });
const $3865687a924ab788$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
const $3865687a924ab788$var$isOptionDisabled = (isValidEmail = (0, $M0UM1.isValidEmail))=>(option)=>{
        if ((0, $3smIt.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
function $3865687a924ab788$var$creatableProps(isValidEmail) {
    return {
        allowCreateWhileLoading: true,
        createOptionPosition: 'first',
        isValidNewOption: $3865687a924ab788$var$isValidNewOption(isValidEmail),
        getNewOptionData: $3865687a924ab788$var$getNewOptionData,
        formatCreateLabel: $3865687a924ab788$var$formatCreateLabel,
        isOptionDisabled: $3865687a924ab788$var$isOptionDisabled(isValidEmail)
    };
}
const $3865687a924ab788$export$36f97d8afa97203d = (0, $8QpSo.default)($3865687a924ab788$var$creatableProps);

});
const $f93312f7d4958f08$export$8436e53e45ffe15b = 'user';
const $f93312f7d4958f08$export$50042ec1d2e00e63 = 'external_user';
const $f93312f7d4958f08$export$26bc40b960693765 = 'team';
const $f93312f7d4958f08$export$d460f747b73abb10 = 'group';
const $f93312f7d4958f08$export$6662b3461398ef8c = 'email';
const $f93312f7d4958f08$export$eafd0979afa5b224 = 'custom';


parcelRegister("hcX3V", function(module, exports) {

$parcel$export(module.exports, "getCreatableSuggestedEmailProps", () => $fd587de6edc26aae$export$34b9dd2dd6a225e5);

var $8QpSo = parcelRequire("8QpSo");


var $M0UM1 = parcelRequire("M0UM1");

var $3smIt = parcelRequire("3smIt");
const $fd587de6edc26aae$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $fd587de6edc26aae$var$isValidNewOption = (inputValue)=>inputValue && inputValue.length > 0;
// Generates suggested option data based on user input and validity of the input (if it is an email or not);
const $fd587de6edc26aae$var$getNewOptionData = (isValidEmail = (0, $M0UM1.isValidEmail), emailDomain)=>(inputValue)=>{
        if (!inputValue) return null;
        const isEmail = inputValue && $fd587de6edc26aae$var$validOption.includes(isValidEmail(inputValue));
        const value = isEmail ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${emailDomain}`;
        return {
            label: value,
            value: value,
            data: {
                id: value,
                name: value,
                type: (0, $f93312f7d4958f08$export$6662b3461398ef8c),
                suggestion: true
            }
        };
    };
const $fd587de6edc26aae$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
// Option will not be selectable until the email value is valid and can actually be invited
const $fd587de6edc26aae$var$isOptionDisabled = (isValidEmail = (0, $M0UM1.isValidEmail))=>(option)=>{
        if ((0, $3smIt.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
const $fd587de6edc26aae$export$34b9dd2dd6a225e5 = (0, $8QpSo.default)((emailDomain, isValidEmail)=>({
        allowCreateWhileLoading: true,
        createOptionPosition: 'last',
        isValidNewOption: $fd587de6edc26aae$var$isValidNewOption,
        getNewOptionData: $fd587de6edc26aae$var$getNewOptionData(isValidEmail, emailDomain),
        formatCreateLabel: $fd587de6edc26aae$var$formatCreateLabel,
        isOptionDisabled: $fd587de6edc26aae$var$isOptionDisabled(isValidEmail)
    }));

});

parcelRegister("hrO1B", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ce4a8fbf6631c4e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $55C8M = parcelRequire("55C8M");
const $9ce4a8fbf6631c4e$var$EMPTY = {};
const $9ce4a8fbf6631c4e$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState($9ce4a8fbf6631c4e$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        let aborted = false;
        setMessages($9ce4a8fbf6631c4e$var$EMPTY);
        (0, $55C8M.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $9ce4a8fbf6631c4e$var$MessagesIntlProvider = (props)=>{
    const intl = (0, $koVbs.default)();
    const { children: children } = props;
    const messages = $9ce4a8fbf6631c4e$var$useI18n(intl.locale);
    const mergedMessages = (0, $5uXOq.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: intl.locale,
        messages: mergedMessages,
        children: children
    });
};
var $9ce4a8fbf6631c4e$export$2e2bcd8739ae039 = $9ce4a8fbf6631c4e$var$MessagesIntlProvider;

});
parcelRegister("55C8M", function(module, exports) {

$parcel$export(module.exports, "getMessagesForLocale", () => $0d1c237fd5360db1$export$d0a3169680473b6c);
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 






























const $0d1c237fd5360db1$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("7TrNZ")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("3lWdn")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("gNYF5")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("jx20s")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("9aFUO")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("hcdBd")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("kaMOK")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("165FN")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("dvcHU")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("5pesY")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("eSVh1")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("8HbNS")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("Mrs7A")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("4ye7l")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("4I12K")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("aARxM")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("bxBuP")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("aQg55")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("htQcP")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("d5lg2")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("lXPIH")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("41gMk")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("9DVE4")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("8Jioj")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("2jTS5")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("9TVGV")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("6VgXS")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("lXFa5")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("3gRXd")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("ffFsD")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $0d1c237fd5360db1$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("jx20s")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("7TrNZ", function(module, exports) {

let $5bf33d009296abd9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5bf33d009296abd9$var$load("cv5rt").then(()=>parcelRequire('gXZJY'));

});

parcelRegister("3lWdn", function(module, exports) {

let $27107d7ab4c49873$var$load = (parcelRequire("28QjX"))(4);
module.exports = $27107d7ab4c49873$var$load("ONW5s").then(()=>parcelRequire('4a4Fm'));

});

parcelRegister("gNYF5", function(module, exports) {

let $c3c04714a27b2410$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c3c04714a27b2410$var$load("gkfia").then(()=>parcelRequire('l8jlf'));

});

parcelRegister("jx20s", function(module, exports) {

let $e382a7ce8bb2b99b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e382a7ce8bb2b99b$var$load("6hHYZ").then(()=>parcelRequire('8JpVG'));

});

parcelRegister("9aFUO", function(module, exports) {

let $6ad58fbedf6184c4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6ad58fbedf6184c4$var$load("eLwwW").then(()=>parcelRequire('e3biM'));

});

parcelRegister("hcdBd", function(module, exports) {

let $c84e1b2a445ef131$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c84e1b2a445ef131$var$load("6eYlN").then(()=>parcelRequire('dnuc7'));

});

parcelRegister("kaMOK", function(module, exports) {

let $eafa9bf48b2fac51$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eafa9bf48b2fac51$var$load("31PjN").then(()=>parcelRequire('l3vqz'));

});

parcelRegister("165FN", function(module, exports) {

let $0ccac092711a19a9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0ccac092711a19a9$var$load("8IqzF").then(()=>parcelRequire('4oZES'));

});

parcelRegister("dvcHU", function(module, exports) {

let $9d480705cbcaa25e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9d480705cbcaa25e$var$load("256dS").then(()=>parcelRequire('2WBzr'));

});

parcelRegister("5pesY", function(module, exports) {

let $3efa8242ee690e64$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3efa8242ee690e64$var$load("kDYdC").then(()=>parcelRequire('bfZBm'));

});

parcelRegister("eSVh1", function(module, exports) {

let $ad62892a05474011$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ad62892a05474011$var$load("lP2Aa").then(()=>parcelRequire('1tcJ6'));

});

parcelRegister("8HbNS", function(module, exports) {

let $654b7ed3d6586020$var$load = (parcelRequire("28QjX"))(4);
module.exports = $654b7ed3d6586020$var$load("ld26n").then(()=>parcelRequire('4duqz'));

});

parcelRegister("Mrs7A", function(module, exports) {

let $0919c7516734ef5d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0919c7516734ef5d$var$load("3q19A").then(()=>parcelRequire('dizwu'));

});

parcelRegister("4ye7l", function(module, exports) {

let $350549d1fd60171a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $350549d1fd60171a$var$load("helYz").then(()=>parcelRequire('9N5CX'));

});

parcelRegister("4I12K", function(module, exports) {

let $36dc14a553266047$var$load = (parcelRequire("28QjX"))(4);
module.exports = $36dc14a553266047$var$load("lGJ1k").then(()=>parcelRequire('aZBlm'));

});

parcelRegister("aARxM", function(module, exports) {

let $7b66ccdcda2149d7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7b66ccdcda2149d7$var$load("TA9hJ").then(()=>parcelRequire('fGwOM'));

});

parcelRegister("bxBuP", function(module, exports) {

let $866fdcbffc96f227$var$load = (parcelRequire("28QjX"))(4);
module.exports = $866fdcbffc96f227$var$load("9FIYu").then(()=>parcelRequire('NLRKB'));

});

parcelRegister("aQg55", function(module, exports) {

let $7e4b3c14f09d0c24$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7e4b3c14f09d0c24$var$load("9moVt").then(()=>parcelRequire('cHWkp'));

});

parcelRegister("htQcP", function(module, exports) {

let $cb9da419ae7374ca$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cb9da419ae7374ca$var$load("bIWCv").then(()=>parcelRequire('d6RJ6'));

});

parcelRegister("d5lg2", function(module, exports) {

let $986c3b57115de466$var$load = (parcelRequire("28QjX"))(4);
module.exports = $986c3b57115de466$var$load("fEUOy").then(()=>parcelRequire('bPIQC'));

});

parcelRegister("lXPIH", function(module, exports) {

let $ffd73a290ae80ed0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ffd73a290ae80ed0$var$load("j43ie").then(()=>parcelRequire('foWaf'));

});

parcelRegister("41gMk", function(module, exports) {

let $2ed4454a726f498f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2ed4454a726f498f$var$load("GRoHb").then(()=>parcelRequire('d41ym'));

});

parcelRegister("9DVE4", function(module, exports) {

let $705478ba40008bec$var$load = (parcelRequire("28QjX"))(4);
module.exports = $705478ba40008bec$var$load("7wDic").then(()=>parcelRequire('77rKe'));

});

parcelRegister("8Jioj", function(module, exports) {

let $65b0cac59b8f215e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $65b0cac59b8f215e$var$load("ik6sd").then(()=>parcelRequire('lwY85'));

});

parcelRegister("2jTS5", function(module, exports) {

let $1b08b2041f62e4db$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1b08b2041f62e4db$var$load("4vjX8").then(()=>parcelRequire('j3ZnO'));

});

parcelRegister("9TVGV", function(module, exports) {

let $7356006d07924f6b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7356006d07924f6b$var$load("jr7Jf").then(()=>parcelRequire('I9Pmk'));

});

parcelRegister("6VgXS", function(module, exports) {

let $50a539c60c886dd1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $50a539c60c886dd1$var$load("eQIEO").then(()=>parcelRequire('h4y14'));

});

parcelRegister("lXFa5", function(module, exports) {

let $ffcf0986a701d607$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ffcf0986a701d607$var$load("ex1MV").then(()=>parcelRequire('6gWmN'));

});

parcelRegister("3gRXd", function(module, exports) {

let $261cb7dfe9582ffc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $261cb7dfe9582ffc$var$load("kGDgz").then(()=>parcelRequire('haTkv'));

});

parcelRegister("ffFsD", function(module, exports) {

let $b1a86afc6c5e51e5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b1a86afc6c5e51e5$var$load("5JcYp").then(()=>parcelRequire('lbgbB'));

});



parcelRegister("2vFqP", function(module, exports) {

$parcel$export(module.exports, "ExusUserSourceProvider", () => $4629e0617f660bbc$export$bcd5c65b586ee3c3);
$parcel$export(module.exports, "useUserSource", () => $4629e0617f660bbc$export$c6c0c1a2bac363f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $4629e0617f660bbc$var$ExusUserSourceContext = /*#__PURE__*/ (0, $5uXOq.createContext)({});
const $4629e0617f660bbc$export$bcd5c65b586ee3c3 = ({ fetchUserSource: fetchUserSource, children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)($4629e0617f660bbc$var$ExusUserSourceContext.Provider, {
        value: {
            fetchUserSource: fetchUserSource
        },
        children: children
    });
const $4629e0617f660bbc$export$c6c0c1a2bac363f = (accountId, shouldFetchSources, existingSources)=>{
    const { fetchUserSource: fetchUserSource } = (0, $5uXOq.useContext)($4629e0617f660bbc$var$ExusUserSourceContext);
    const [externalSources, setExternalSources] = (0, $5uXOq.useState)([]);
    const [loading, setLoading] = (0, $5uXOq.useState)(true);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const abortController = (0, $5uXOq.useMemo)(()=>{
        if (typeof AbortController === 'undefined') return;
        return new AbortController();
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        let isMounted = true;
        const cleanup = ()=>{
            abortController?.abort();
            isMounted = false;
        };
        if (!fetchUserSource || !shouldFetchSources) {
            setLoading(false);
            return cleanup;
        }
        fetchUserSource(accountId, abortController?.signal).then((externalSources)=>{
            if (!isMounted) return;
            setLoading(false);
            const externalSourceTypes = externalSources.map((source)=>source.sourceType);
            setExternalSources(externalSourceTypes);
        }).catch((error)=>{
            if (!isMounted) return;
            setLoading(false);
            setError(error);
        });
        return cleanup;
    }, [
        fetchUserSource,
        accountId,
        abortController,
        shouldFetchSources
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            sources: Array.from(new Set([
                ...existingSources ?? [],
                ...externalSources
            ])),
            loading: loading,
            error: error
        }), [
        error,
        existingSources,
        externalSources,
        loading
    ]);
};

});


parcelRegister("4bzfE", function(module, exports) {

$parcel$export(module.exports, "useUpdateDriverExperienceStart", () => $2aae9539ba1b1e34$export$6e6b386771ff8a93);
$parcel$export(module.exports, "useUpdateDriverExperienceFail", () => $2aae9539ba1b1e34$export$a86702725d24ceba);
$parcel$export(module.exports, "useUpdateDriverExperienceSuccess", () => $2aae9539ba1b1e34$export$ce389ea9709547fd);

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $efvDm = parcelRequire("efvDm");

var $k9JTq = parcelRequire("k9JTq");
const $2aae9539ba1b1e34$var$EXPERIENCE_NAME = 'updateJiraVersionDriver';
const $2aae9539ba1b1e34$var$SOURCE = 'versionDetails';
const $2aae9539ba1b1e34$export$6e6b386771ff8a93 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    return (0, $kaHBi.useExperienceStart)({
        experience: $2aae9539ba1b1e34$var$EXPERIENCE_NAME,
        experienceId: `${Date.now()}`,
        analyticsSource: $2aae9539ba1b1e34$var$SOURCE,
        application: (0, $efvDm.JIRA_SOFTWARE),
        edition: appEditions.software
    });
};
const $2aae9539ba1b1e34$export$a86702725d24ceba = ()=>(0, $93jKl.useExperienceFail)({
        experience: $2aae9539ba1b1e34$var$EXPERIENCE_NAME
    });
const $2aae9539ba1b1e34$export$ce389ea9709547fd = ()=>(0, $3bQtK.useExperienceSuccess)({
        experience: $2aae9539ba1b1e34$var$EXPERIENCE_NAME
    });

});

parcelRegister("arKXI", function(module, exports) {

$parcel$export(module.exports, "default", () => $aed739763becd855$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $aed739763becd855$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    unassigned: {
        "id": "software-releases-version-driver-field.unassigned",
        "defaultMessage": "Unassigned"
    },
    fieldLabel: {
        "id": "software-releases-version-driver-field.field-label",
        "defaultMessage": "Driver"
    },
    genericErrorFlagTitle: {
        "id": "software-releases-version-driver-field.generic-error-flag-title",
        "defaultMessage": "We couldn't update the version driver."
    },
    genericErrorFlagDescription: {
        "id": "software-releases-version-driver-field.generic-error-flag-description",
        "defaultMessage": "Something went wrong. Please try again or contact your administrator if the problem persists."
    }
});

});


parcelRegister("g08V3", function(module, exports) {

$parcel$export(module.exports, "VersionSummaryDescription", () => $ad3aee83ecbc9ec8$export$e4174f5e9c00a5fc);

var $kGZk6 = parcelRequire("kGZk6");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $fstKw = parcelRequire("fstKw");

var $70dHp = parcelRequire("70dHp");
const $ad3aee83ecbc9ec8$export$e4174f5e9c00a5fc = ({ jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const version = (0, $8Uumt.useFragment)((0, $kGZk6.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ad3aee83ecbc9ec8$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $ad3aee83ecbc9ec8$var$headingStyles,
        as: "h2"
    }, formatMessage((0, $70dHp.default).descriptionHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ad3aee83ecbc9ec8$var$DescriptionContainer, {
        "data-testid": "software-releases-version-summary-description.ui.description-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $ad3aee83ecbc9ec8$var$inlinedEditOffsetStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fstKw.AsyncEditableVersionSummaryDescription), {
        jiraVersion: version,
        shouldTruncateText: true
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ad3aee83ecbc9ec8$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $ad3aee83ecbc9ec8$var$DescriptionContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $ad3aee83ecbc9ec8$var$inlinedEditOffsetStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.negative.100',
    marginLeft: 'space.negative.100'
});
const $ad3aee83ecbc9ec8$var$headingStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtle',
    font: 'font.body.small',
    fontWeight: 'font.weight.bold'
});

});
parcelRegister("kGZk6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b71e583f9b58616f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<590483254f3e5ae0689c5da4f6f780a8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b71e583f9b58616f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_softwareReleasesVersionSummaryDescription_VersionSummaryDescription",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "async_softwareReleasesVersionSummaryDescription_AsyncEditableVersionSummaryDescription"
        }
    ],
    "type": "JiraVersion"
};
$b71e583f9b58616f$var$node.hash = "ed1e590e92f538e88d28c5f6bba7c77c";
var $b71e583f9b58616f$export$2e2bcd8739ae039 = $b71e583f9b58616f$var$node;

});

parcelRegister("fstKw", function(module, exports) {

$parcel$export(module.exports, "AsyncEditableVersionSummaryDescription", () => $2938ef1a3508d069$export$6da629078e9c0cf3);

var $1kNEw = parcelRequire("1kNEw");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $koVbs = parcelRequire("koVbs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $4j9DO = parcelRequire("4j9DO");

var $bR45R = parcelRequire("bR45R");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2938ef1a3508d069$var$LazyEditableSummaryDescription = (0, $kxZPA.lazy)(()=>(parcelRequire("5diET")).then((module)=>module.EditableVersionSummaryDescription), {
    moduleId: "./src/packages/releases/version-summary-description/src/ui/editable-version-summary-description/index.tsx"
});
const $2938ef1a3508d069$export$6da629078e9c0cf3 = ({ jiraVersion: jiraVersion, shouldTruncateText: shouldTruncateText })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const version = (0, $8Uumt.useFragment)((0, $1kNEw.default), jiraVersion);
    const descriptionText = version.description !== '' ? version.description : formatMessage((0, $bR45R.default).descriptionPlaceholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "editable-description",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2938ef1a3508d069$var$InlineEditReadViewContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4j9DO.DescriptionContent), {
            descriptionText: descriptionText || '',
            isNonEmpty: !!version.description,
            shouldTruncateText: shouldTruncateText
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2938ef1a3508d069$var$LazyEditableSummaryDescription, {
        jiraVersion: version,
        shouldTruncateText: shouldTruncateText
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2938ef1a3508d069$var$InlineEditReadViewContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_189eyh40 _1dqonqa1 _1h6d3acm _vwz4kb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1kNEw", function(module, exports) {

$parcel$export(module.exports, "default", () => $d39e490f9b4c5620$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<61c524636ae7c6db90724329336f57a9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d39e490f9b4c5620$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "async_softwareReleasesVersionSummaryDescription_AsyncEditableVersionSummaryDescription",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "FragmentSpread",
            "name": "editableVersionSummaryDescription_softwareReleasesVersionSummaryDescription"
        }
    ],
    "type": "JiraVersion"
};
$d39e490f9b4c5620$var$node.hash = "2a90bb83f1ef52be3fdf77ad96c33404";
var $d39e490f9b4c5620$export$2e2bcd8739ae039 = $d39e490f9b4c5620$var$node;

});

parcelRegister("4j9DO", function(module, exports) {

$parcel$export(module.exports, "DescriptionContent", () => $eb130881a9bf3291$export$afe6a96ed909bf0f);
/* DescriptionContent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $h4EJ8 = parcelRequire("h4EJ8");
const $eb130881a9bf3291$var$TRUNCATE_TEXT_LENGTH = 300;
const $eb130881a9bf3291$export$afe6a96ed909bf0f = ({ isNonEmpty: isNonEmpty, shouldTruncateText: shouldTruncateText, descriptionText: descriptionText })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eb130881a9bf3291$var$DescriptionContentContainer, {
        isNonEmpty: isNonEmpty
    }, shouldTruncateText ? (0, (/*@__PURE__*/$parcel$interopDefault($h4EJ8)))(descriptionText, {
        length: $eb130881a9bf3291$var$TRUNCATE_TEXT_LENGTH,
        separator: ' '
    }) : descriptionText);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $eb130881a9bf3291$var$DescriptionContentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isNonEmpty: isNonEmpty, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qu2gc _u5f312x7 _n3tdu2gc _19bv12x7 _slp31hna _o5726vc6 _vwz4cjiy",
            __cmplp.isNonEmpty ? "_syaz1kw7" : "_syaz131l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("h4EJ8", function(module, exports) {

var $kHBB0 = parcelRequire("kHBB0");

var $gvFfr = parcelRequire("gvFfr");

var $axH2S = parcelRequire("axH2S");

var $k0qYG = parcelRequire("k0qYG");

var $cErmc = parcelRequire("cErmc");

var $ifYxh = parcelRequire("ifYxh");

var $jx6Tp = parcelRequire("jx6Tp");

var $kPZpS = parcelRequire("kPZpS");

var $jJVtR = parcelRequire("jJVtR");
/** Used as default options for `_.truncate`. */ var $c6e266ef199f8e9f$var$DEFAULT_TRUNC_LENGTH = 30, $c6e266ef199f8e9f$var$DEFAULT_TRUNC_OMISSION = '...';
/** Used to match `RegExp` flags from their coerced string values. */ var $c6e266ef199f8e9f$var$reFlags = /\w*$/;
/**
 * Truncates `string` if it's longer than the given maximum string length.
 * The last characters of the truncated string are replaced with the omission
 * string which defaults to "...".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to truncate.
 * @param {Object} [options={}] The options object.
 * @param {number} [options.length=30] The maximum string length.
 * @param {string} [options.omission='...'] The string to indicate text is omitted.
 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
 * @returns {string} Returns the truncated string.
 * @example
 *
 * _.truncate('hi-diddly-ho there, neighborino');
 * // => 'hi-diddly-ho there, neighbo...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': ' '
 * });
 * // => 'hi-diddly-ho there,...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': /,? +/
 * });
 * // => 'hi-diddly-ho there...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'omission': ' [...]'
 * });
 * // => 'hi-diddly-ho there, neig [...]'
 */ function $c6e266ef199f8e9f$var$truncate(string, options) {
    var length = $c6e266ef199f8e9f$var$DEFAULT_TRUNC_LENGTH, omission = $c6e266ef199f8e9f$var$DEFAULT_TRUNC_OMISSION;
    if ($k0qYG(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? $kPZpS(options.length) : length;
        omission = 'omission' in options ? $kHBB0(options.omission) : omission;
    }
    string = $jJVtR(string);
    var strLength = string.length;
    if ($axH2S(string)) {
        var strSymbols = $jx6Tp(string);
        strLength = strSymbols.length;
    }
    if (length >= strLength) return string;
    var end = length - $ifYxh(omission);
    if (end < 1) return omission;
    var result = strSymbols ? $gvFfr(strSymbols, 0, end).join('') : string.slice(0, end);
    if (separator === undefined) return result + omission;
    if (strSymbols) end += result.length - end;
    if ($cErmc(separator)) {
        if (string.slice(end).search(separator)) {
            var match, substring = result;
            if (!separator.global) separator = RegExp(separator.source, $jJVtR($c6e266ef199f8e9f$var$reFlags.exec(separator)) + 'g');
            separator.lastIndex = 0;
            while(match = separator.exec(substring))var newEnd = match.index;
            result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
    } else if (string.indexOf($kHBB0(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) result = result.slice(0, index);
    }
    return result + omission;
}
module.exports = $c6e266ef199f8e9f$var$truncate;

});
parcelRegister("cErmc", function(module, exports) {

var $3euyi = parcelRequire("3euyi");

var $cW28x = parcelRequire("cW28x");

var $lMQGH = parcelRequire("lMQGH");
/* Node.js helper references. */ var $935e70fe57caa939$var$nodeIsRegExp = $lMQGH && $lMQGH.isRegExp;
/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */ var $935e70fe57caa939$var$isRegExp = $935e70fe57caa939$var$nodeIsRegExp ? $cW28x($935e70fe57caa939$var$nodeIsRegExp) : $3euyi;
module.exports = $935e70fe57caa939$var$isRegExp;

});
parcelRegister("3euyi", function(module, exports) {

var $beQoo = parcelRequire("beQoo");

var $fC1Kz = parcelRequire("fC1Kz");
/** `Object#toString` result references. */ var $25aa60f3dfdc1028$var$regexpTag = '[object RegExp]';
/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */ function $25aa60f3dfdc1028$var$baseIsRegExp(value) {
    return $fC1Kz(value) && $beQoo(value) == $25aa60f3dfdc1028$var$regexpTag;
}
module.exports = $25aa60f3dfdc1028$var$baseIsRegExp;

});


parcelRegister("ifYxh", function(module, exports) {

var $dkmPN = parcelRequire("dkmPN");

var $axH2S = parcelRequire("axH2S");

var $61ekh = parcelRequire("61ekh");
/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */ function $d4a895dd16218f22$var$stringSize(string) {
    return $axH2S(string) ? $61ekh(string) : $dkmPN(string);
}
module.exports = $d4a895dd16218f22$var$stringSize;

});
parcelRegister("dkmPN", function(module, exports) {

var $8hdQS = parcelRequire("8hdQS");
/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ var $9b3edb0cff432526$var$asciiSize = $8hdQS('length');
module.exports = $9b3edb0cff432526$var$asciiSize;

});

parcelRegister("61ekh", function(module, exports) {
/** Used to compose unicode character classes. */ var $461df2ef275f3803$var$rsAstralRange = '\\ud800-\\udfff', $461df2ef275f3803$var$rsComboMarksRange = '\\u0300-\\u036f', $461df2ef275f3803$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $461df2ef275f3803$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $461df2ef275f3803$var$rsComboRange = $461df2ef275f3803$var$rsComboMarksRange + $461df2ef275f3803$var$reComboHalfMarksRange + $461df2ef275f3803$var$rsComboSymbolsRange, $461df2ef275f3803$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $461df2ef275f3803$var$rsAstral = '[' + $461df2ef275f3803$var$rsAstralRange + ']', $461df2ef275f3803$var$rsCombo = '[' + $461df2ef275f3803$var$rsComboRange + ']', $461df2ef275f3803$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $461df2ef275f3803$var$rsModifier = '(?:' + $461df2ef275f3803$var$rsCombo + '|' + $461df2ef275f3803$var$rsFitz + ')', $461df2ef275f3803$var$rsNonAstral = '[^' + $461df2ef275f3803$var$rsAstralRange + ']', $461df2ef275f3803$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $461df2ef275f3803$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $461df2ef275f3803$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $461df2ef275f3803$var$reOptMod = $461df2ef275f3803$var$rsModifier + '?', $461df2ef275f3803$var$rsOptVar = '[' + $461df2ef275f3803$var$rsVarRange + ']?', $461df2ef275f3803$var$rsOptJoin = '(?:' + $461df2ef275f3803$var$rsZWJ + '(?:' + [
    $461df2ef275f3803$var$rsNonAstral,
    $461df2ef275f3803$var$rsRegional,
    $461df2ef275f3803$var$rsSurrPair
].join('|') + ')' + $461df2ef275f3803$var$rsOptVar + $461df2ef275f3803$var$reOptMod + ')*', $461df2ef275f3803$var$rsSeq = $461df2ef275f3803$var$rsOptVar + $461df2ef275f3803$var$reOptMod + $461df2ef275f3803$var$rsOptJoin, $461df2ef275f3803$var$rsSymbol = '(?:' + [
    $461df2ef275f3803$var$rsNonAstral + $461df2ef275f3803$var$rsCombo + '?',
    $461df2ef275f3803$var$rsCombo,
    $461df2ef275f3803$var$rsRegional,
    $461df2ef275f3803$var$rsSurrPair,
    $461df2ef275f3803$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $461df2ef275f3803$var$reUnicode = RegExp($461df2ef275f3803$var$rsFitz + '(?=' + $461df2ef275f3803$var$rsFitz + ')|' + $461df2ef275f3803$var$rsSymbol + $461df2ef275f3803$var$rsSeq, 'g');
/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ function $461df2ef275f3803$var$unicodeSize(string) {
    var result = $461df2ef275f3803$var$reUnicode.lastIndex = 0;
    while($461df2ef275f3803$var$reUnicode.test(string))++result;
    return result;
}
module.exports = $461df2ef275f3803$var$unicodeSize;

});




parcelRegister("bR45R", function(module, exports) {

$parcel$export(module.exports, "default", () => $052fa8361354cd40$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $052fa8361354cd40$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    descriptionPlaceholder: {
        "id": "software-releases-version-summary-description.editable-version-summary-description.description-placeholder",
        "defaultMessage": "No description added yet."
    },
    errorFlagTitle: {
        "id": "software-releases-version-summary-description.editable-version-summary-description.error-flag-title",
        "defaultMessage": "We couldn't update the description"
    },
    errorFlagDescription: {
        "id": "software-releases-version-summary-description.editable-version-summary-description.error-flag-description",
        "defaultMessage": "Something went wrong. Please try again or contact your administrator if the problem persists."
    },
    maxDescriptionSizeExceededErrorMessage: {
        "id": "software-releases-version-summary-description.editable-version-summary-description.max-description-size-exceeded-error-message",
        "defaultMessage": "Maximum description size exceeded"
    }
});

});

parcelRegister("5diET", function(module, exports) {

let $3cbca3db785701f0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3cbca3db785701f0$var$load("VrQDy").then(()=>parcelRequire('dwy4h'));

});


parcelRegister("70dHp", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b29ed7df0af346b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5b29ed7df0af346b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    descriptionHeader: {
        "id": "software-releases-version-summary-description.description-header",
        "defaultMessage": "Description"
    }
});

});


parcelRegister("cbARR", function(module, exports) {

$parcel$export(module.exports, "NonCriticalErrorBoundary", () => $e630d865d8e41573$export$1625b7ea4c7a5a23);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");
const $e630d865d8e41573$export$1625b7ea4c7a5a23 = ({ fallback: fallback, eventLocation: eventLocation, children: children, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: fallback,
        packageName: "jiraSoftwareReleasesLaunchCard",
        teamName: "nova",
        id: eventLocation,
        onError: onError
    }, children);

});

parcelRegister("gl90z", function(module, exports) {

$parcel$export(module.exports, "LatestDeployment", () => $91f9e25791539622$export$4c54e4ee90dcb7e7);

var $UvyUC = parcelRequire("UvyUC");

var $geUds = parcelRequire("geUds");

var $4R3aq = parcelRequire("4R3aq");

var $klqAj = parcelRequire("klqAj");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $luuSM = parcelRequire("luuSM");
var $54a0z = parcelRequire("54a0z");

var $8Uumt = parcelRequire("8Uumt");

var $3bDjY = parcelRequire("3bDjY");
var $btzsC = parcelRequire("btzsC");

var $koVbs = parcelRequire("koVbs");

var $lfTZh = parcelRequire("lfTZh");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R3aq = parcelRequire("4R3aq");

var $hjSul = parcelRequire("hjSul");

var $gBkhv = parcelRequire("gBkhv");

var $03FyW = parcelRequire("03FyW");

var $dkZ1c = parcelRequire("dkZ1c");

var $65TnY = parcelRequire("65TnY");

var $ghVnF = parcelRequire("ghVnF");

var $dGKnO = parcelRequire("dGKnO");
const $91f9e25791539622$export$9fbf3675ff70ff0 = ({ jiraVersion: jiraVersion, queryReference: queryReference })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const deploymentsRoute = (0, $03FyW.useDeploymentsRoute)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const version = (0, $8Uumt.useFragment)((0, $klqAj.default), jiraVersion);
    const isMoreThanAWeekApart = (a, b)=>{
        const oneWeekInMilliseconds = 604800000;
        return (0, $luuSM.default)(a, b) > oneWeekInMilliseconds;
    };
    const data = (0, $8Uumt.usePreloadedQuery)((0, $4R3aq.default), queryReference);
    const deploymentNodes = data.devOps.ariGraph.relationships.edges.filter(Boolean).map((edge)=>edge.node);
    const renderLink = (content, hasNoRecentDeployments)=>hasNoRecentDeployments ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91f9e25791539622$var$StyledLink, {
            href: (0, $gBkhv.SUPPORT_DOCS_LINK_URL),
            onClick: ()=>{
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'link'
                }), 'latestDeploymentInVersion');
            },
            target: "_blank"
        }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91f9e25791539622$var$StyledLink, {
            onClick: ()=>{
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'link'
                }), 'latestDeploymentInVersion');
            },
            prefetch: "hover",
            params: {
                projectKey: version.project.key
            },
            query: {
                startDate: '-3m',
                endDate: 'now',
                fixVersions: version.name
            },
            to: deploymentsRoute
        }, content);
    const latestDeployment = deploymentNodes[0]?.to.data;
    const hasNoDeploymentInLastWeek = latestDeployment?.lastUpdated ? isMoreThanAWeekApart(new Date(), new Date(latestDeployment.lastUpdated)) : true;
    let linkContent = null;
    if (latestDeployment == null) linkContent = formatMessage((0, $ghVnF.default).noDeployments);
    else if (latestDeployment.lastUpdated !== undefined) {
        if (hasNoDeploymentInLastWeek) linkContent = formatMessage((0, $ghVnF.default).noDeployments);
        else linkContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $ghVnF.default).lastDeployment), (0, $54a0z.default)(new Date(latestDeployment.lastUpdated), new Date(), {
            addSuffix: true,
            roundingMethod: 'floor'
        }));
    }
    const [providersListQuery, loadProvidersListQuery] = (0, $dGKnO.useLoadProvidersListQuery)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default // @ts-expect-error - TS3233 - unsure why it doesn't like my tooltip :|
    ), {
        component: $91f9e25791539622$var$CustomTooltip,
        content: hasNoDeploymentInLastWeek && providersListQuery ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dGKnO.ProvidersList), {
            queryReference: providersListQuery
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dkZ1c.DeploymentTooltipContent), {
            jiraVersion: version,
            deployment: latestDeployment
        }),
        onShow: (analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, hasNoDeploymentInLastWeek && providersListQuery ? 'latestDeploymentInVersionProvidersTooltip' : 'latestDeploymentInVersionDetailsTooltip');
        }
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91f9e25791539622$var$Wrapper, {
            ...tooltipProps,
            onMouseOver: (event)=>{
                tooltipProps.onMouseOver(event);
                if (hasNoDeploymentInLastWeek) loadProvidersListQuery();
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $65TnY.PulseIcon), null), linkContent && renderLink(linkContent, latestDeployment == null || hasNoDeploymentInLastWeek)));
};
const $91f9e25791539622$export$4c54e4ee90dcb7e7 = ({ jiraVersion: jiraVersion, preconditionQueryRef: preconditionQueryRef })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const version = (0, $8Uumt.useFragment)((0, $geUds.default), jiraVersion);
    const { jira: { deploymentsFeaturePreconditionByProjectKey: deploymentsFeaturePreconditionByProjectKey } } = (0, $8Uumt.usePreloadedQuery)((0, $UvyUC.default), preconditionQueryRef);
    const [queryRef, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $4R3aq.default));
    (0, $5uXOq.useEffect)(()=>{
        if (deploymentsFeaturePreconditionByProjectKey === 'ALL_SATISFIED') loadQuery({
            from: version.id
        });
    }, [
        deploymentsFeaturePreconditionByProjectKey,
        version.id,
        loadQuery
    ]);
    return deploymentsFeaturePreconditionByProjectKey === 'ALL_SATISFIED' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "latest-deployment-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91f9e25791539622$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $65TnY.PulseIcon), null), formatMessage((0, $ghVnF.default).loading))
    }, queryRef && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($91f9e25791539622$export$9fbf3675ff70ff0, {
        jiraVersion: version,
        queryReference: queryRef
    })) : null;
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91f9e25791539622$var$StyledLink = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $hjSul.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1fxt _9h8h1fxt _f8pj1fxt _v0vw1fxt _30l31fxt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91f9e25791539622$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7m7j4 _zulpu2gc _4cvr1h6o _1e0c1txw _ca0qpxbi _u5f31ejb _n3tdpxbi _19bv1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91f9e25791539622$var$CustomTooltip = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $btzsC.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _16qsjdvv _vchh18uv _bfhkvuon",
            __cmplp.className
        ])
    });
});

});
parcelRegister("geUds", function(module, exports) {

$parcel$export(module.exports, "default", () => $033bc7b24a5f0035$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<77f1e70ec27936e5cf3f69a6a6c7a721>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $033bc7b24a5f0035$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "latestDeployment_softwareReleasesLaunchCard_jiraVersion",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "FragmentSpread",
            "name": "latestDeployment_softwareReleasesLaunchCard_LatestDeploymentContent_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$033bc7b24a5f0035$var$node.hash = "9635192fd480eb66a7ef3d1c281498c0";
var $033bc7b24a5f0035$export$2e2bcd8739ae039 = $033bc7b24a5f0035$var$node;

});

parcelRegister("4R3aq", function(module, exports) {

$parcel$export(module.exports, "default", () => $80ab4a8ad9cdb291$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a7f9c2f1ea316f7e75734d4856388ce4>>
 * @relayHash 4f907308c1893ca60c7291b087e6c39e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8a1ba70765de1a703c18b75e8458f6e0f02368ed62a9ae447ac07f43649ee583
const $80ab4a8ad9cdb291$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "from"
        }
    ], v1 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        },
        {
            "kind": "Variable",
            "name": "from",
            "variableName": "from"
        },
        {
            "kind": "Literal",
            "name": "sort",
            "value": {
                "lastUpdatedSortDirection": "DESC"
            }
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "version-associated-deployment"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "lastUpdated"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        v3 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "latestDeploymentForVersionQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "DevOps",
                        "kind": "LinkedField",
                        "name": "devOps",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "AriGraph",
                                    "kind": "LinkedField",
                                    "name": "ariGraph",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "args": v1 /*: any*/ ,
                                                "concreteType": "AriGraphRelationshipConnection",
                                                "kind": "LinkedField",
                                                "name": "relationships",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "AriGraphRelationshipEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "AriGraphRelationship",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": {
                                                                                    "concreteType": "AriGraphRelationshipNode",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "to",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "data",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "RequiredField",
                                                                                                                "field": v2 /*: any*/ ,
                                                                                                                "action": "THROW",
                                                                                                                "path": "devOps.ariGraph.relationships.edges.node.to.data.lastUpdated"
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "FragmentSpread",
                                                                                                                "name": "deploymentTooltipContent_softwareReleasesLaunchCard_deployment"
                                                                                                            }
                                                                                                        ],
                                                                                                        "type": "DeploymentSummary"
                                                                                                    }
                                                                                                ]
                                                                                            },
                                                                                            "action": "THROW",
                                                                                            "path": "devOps.ariGraph.relationships.edges.node.to.data"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                "action": "THROW",
                                                                                "path": "devOps.ariGraph.relationships.edges.node.to"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "devOps.ariGraph.relationships.edges.node"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "devOps.ariGraph.relationships.edges"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "devOps.ariGraph.relationships"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "devOps.ariGraph"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "devOps"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "latestDeploymentForVersionQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AriGraph",
                            "kind": "LinkedField",
                            "name": "ariGraph",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "relationships",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "AriGraphRelationshipEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "AriGraphRelationship",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AriGraphRelationshipNode",
                                                            "kind": "LinkedField",
                                                            "name": "to",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "__typename"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v2 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "state"
                                                                                },
                                                                                {
                                                                                    "concreteType": "DevOpsEnvironment",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "environment",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "displayName"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "category"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "issueIds"
                                                                                }
                                                                            ],
                                                                            "type": "DeploymentSummary"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "Node",
                                                                            "abstractKey": "__isNode"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "DevOpsFeatureFlag"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "DevOpsOperationsComponentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "DevOpsOperationsIncidentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "DevOpsOperationsPostIncidentReviewDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "DevOpsRepository"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "DevOpsSecurityVulnerabilityDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "JiraAutodevJob"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "JiraConfluenceRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "JiraCustomRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "JiraIssueRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v4 /*: any*/ ,
                                                                            "type": "JiraWebRemoteIssueLink"
                                                                        }
                                                                    ]
                                                                },
                                                                v3 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8a1ba70765de1a703c18b75e8458f6e0f02368ed62a9ae447ac07f43649ee583",
            "metadata": {},
            "name": "latestDeploymentForVersionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$80ab4a8ad9cdb291$var$node.hash = "804051e6b542c6dc7bf401419bdfe7f9";
var $80ab4a8ad9cdb291$export$2e2bcd8739ae039 = $80ab4a8ad9cdb291$var$node;

});

parcelRegister("klqAj", function(module, exports) {

$parcel$export(module.exports, "default", () => $117270fca72ec8b5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ebfd8958a9f620c0b5965b0317d16e8c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $117270fca72ec8b5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "latestDeployment_softwareReleasesLaunchCard_LatestDeploymentContent_jiraVersion",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        "action": "THROW",
                        "path": "project.key"
                    }
                ]
            },
            "action": "THROW",
            "path": "project"
        },
        {
            "kind": "FragmentSpread",
            "name": "deploymentTooltipContent_softwareReleasesLaunchCard_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$117270fca72ec8b5$var$node.hash = "636e16e48d5710e3c9d238bef208f75d";
var $117270fca72ec8b5$export$2e2bcd8739ae039 = $117270fca72ec8b5$var$node;

});

parcelRegister("gBkhv", function(module, exports) {

$parcel$export(module.exports, "ARCHIVED", () => $8aa3067a3c7cf7a5$export$c936349447a77fe0);
$parcel$export(module.exports, "RELEASED", () => $8aa3067a3c7cf7a5$export$b983f2cb1f658a55);
$parcel$export(module.exports, "UNARCHIVED", () => $8aa3067a3c7cf7a5$export$5813036ca984d7f3);
$parcel$export(module.exports, "UNRELEASED", () => $8aa3067a3c7cf7a5$export$cb459d726a8530a5);
$parcel$export(module.exports, "FIRST_COLUMN_MIN_WIDTH", () => $8aa3067a3c7cf7a5$export$f6fe47beb5520aca);
$parcel$export(module.exports, "SUPPORT_DOCS_LINK_URL", () => $8aa3067a3c7cf7a5$export$cfcb17c409b4e552);

var $gwIPs = parcelRequire("gwIPs");
const $8aa3067a3c7cf7a5$export$c936349447a77fe0 = 'ARCHIVED';
const $8aa3067a3c7cf7a5$export$b983f2cb1f658a55 = 'RELEASED';
const $8aa3067a3c7cf7a5$export$5813036ca984d7f3 = 'UNARCHIVED';
const $8aa3067a3c7cf7a5$export$cb459d726a8530a5 = 'UNRELEASED';
const $8aa3067a3c7cf7a5$export$f6fe47beb5520aca = (0, $gwIPs.gridSize) * 23;
const $8aa3067a3c7cf7a5$export$cfcb17c409b4e552 = 'https://support.atlassian.com/jira-software-cloud/docs/reference-issues-in-your-development-work/';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8aa3067a3c7cf7a5$export$2e2bcd8739ae039 = [
    $8aa3067a3c7cf7a5$export$c936349447a77fe0,
    $8aa3067a3c7cf7a5$export$b983f2cb1f658a55,
    $8aa3067a3c7cf7a5$export$cb459d726a8530a5,
    $8aa3067a3c7cf7a5$export$5813036ca984d7f3
];

});

parcelRegister("03FyW", function(module, exports) {

$parcel$export(module.exports, "useDeploymentsRoute", () => $4968c408415eacbe$export$7a17d870b2f984df);

var $6jY6G = parcelRequire("6jY6G");

var $dAfqg = parcelRequire("dAfqg");
const $4968c408415eacbe$export$7a17d870b2f984df = ()=>{
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const routeName = project?.simplified ? 'software-deployments' : 'software-deployments-classic';
    return (0, $6jY6G.useRouteByName)(routeName) ?? routeName;
};

});

parcelRegister("dkZ1c", function(module, exports) {

$parcel$export(module.exports, "DeploymentTooltipContent", () => $a763509018e8b0e4$export$c36a118f96728a11);

var $6XgBh = parcelRequire("6XgBh");

var $4zXYN = parcelRequire("4zXYN");

var $5uXOq = parcelRequire("5uXOq");

var $54a0z = parcelRequire("54a0z");

var $8Uumt = parcelRequire("8Uumt");

var $aYAc3 = parcelRequire("aYAc3");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $ifS9h = parcelRequire("ifS9h");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $gYpv9 = parcelRequire("gYpv9");

var $hjSul = parcelRequire("hjSul");

var $03FyW = parcelRequire("03FyW");

var $g2uF3 = parcelRequire("g2uF3");

var $e2lGD = parcelRequire("e2lGD");
const $a763509018e8b0e4$export$c36a118f96728a11 = ({ deployment: deployment, jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const version = (0, $8Uumt.useFragment)((0, $4zXYN.default), jiraVersion);
    const { lastUpdated: lastUpdated, environment: environment, state: state, issueIds: issueIds } = (0, $8Uumt.useFragment)((0, $6XgBh.default), deployment);
    const deploymentsRoute = (0, $03FyW.useDeploymentsRoute)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ifS9h.PopupContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ifS9h.PopupHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ifS9h.PopupTitle), null, formatMessage((0, $g2uF3.default).deploymentPopupTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $a763509018e8b0e4$var$headerStatusIconAndLozengeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $a763509018e8b0e4$var$headerStatusIconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gYpv9.DeploymentIcons), {
        deploymentState: (0, $e2lGD.mapDeploymentState)(state, environment.category),
        size: "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        appearance: (0, $e2lGD.mapStateToLozengeProp)(state)
    }, state))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ifS9h.LinkContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a763509018e8b0e4$var$environmentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p",
        weight: "bold"
    }, (0, $e2lGD.capitalizeOnlyFirstLetter)(environment.category), environment.displayName ? ` (${environment.displayName})` : ''))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $a763509018e8b0e4$var$environmentDetailStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, (0, $54a0z.default)(new Date(lastUpdated), new Date(), {
        addSuffix: true,
        roundingMethod: 'floor'
    })), issueIds == null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: $a763509018e8b0e4$var$environmentDetailBetweenMarginStyles
    }, "\u2022"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: $a763509018e8b0e4$var$environmentDetailBetweenMarginStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small"
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $g2uF3.default).issuesDeployedIssueTerminologyRefreshM4 : (0, $g2uF3.default).issuesDeployed, {
        issueCount: issueIds.length
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ifS9h.PopupOverflowSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ifS9h.PopupKeyline), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ifS9h.PopupOverflowButton), {
        component: (0, $hjSul.Link),
        appearance: "link",
        // @ts-expect-error - TS2322 - Problem with `Button` types, in practice this gets forwarded to the `Link`
        prefetch: "hover",
        params: {
            projectKey: version.project.key
        },
        query: {
            startDate: '-3m',
            endDate: 'now',
            fixVersions: version.name
        },
        to: deploymentsRoute,
        onClick: (_, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'latestDeploymentInVersionDetailsTooltipLink');
        }
    }, formatMessage((0, $g2uF3.default).viewAllDeployments))));
};
const $a763509018e8b0e4$var$headerStatusIconAndLozengeStyles = (0, $8CUq3.xcss)({
    flex: 1,
    justifyContent: 'end',
    alignItems: 'center'
});
const $a763509018e8b0e4$var$headerStatusIconStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.100',
    justifyContent: 'center',
    alignItems: 'center'
});
const $a763509018e8b0e4$var$environmentStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.100'
});
const $a763509018e8b0e4$var$environmentDetailStyles = (0, $8CUq3.xcss)({
    height: '16px',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    marginBottom: 'space.100',
    marginTop: 'space.0'
});
const $a763509018e8b0e4$var$environmentDetailBetweenMarginStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.050'
});

});
parcelRegister("6XgBh", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fd499661a3b0105$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<10c719c98390f5498900124b91a968f6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3fd499661a3b0105$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "deploymentTooltipContent_softwareReleasesLaunchCard_deployment",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "state"
            },
            "action": "THROW",
            "path": "state"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "DevOpsEnvironment",
                "kind": "LinkedField",
                "name": "environment",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "displayName"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        "action": "THROW",
                        "path": "environment.category"
                    }
                ]
            },
            "action": "THROW",
            "path": "environment"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "lastUpdated"
            },
            "action": "THROW",
            "path": "lastUpdated"
        },
        {
            "kind": "ScalarField",
            "name": "issueIds"
        }
    ],
    "type": "DeploymentSummary"
};
$3fd499661a3b0105$var$node.hash = "f474689f31fc91d3dfb760e1b811618d";
var $3fd499661a3b0105$export$2e2bcd8739ae039 = $3fd499661a3b0105$var$node;

});

parcelRegister("4zXYN", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba42f4c620d2cfe5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b2ef2fde713507dbf018acf99cdd24e5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ba42f4c620d2cfe5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "deploymentTooltipContent_softwareReleasesLaunchCard_jiraVersion",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        "action": "THROW",
                        "path": "project.key"
                    }
                ]
            },
            "action": "THROW",
            "path": "project"
        }
    ],
    "type": "JiraVersion"
};
$ba42f4c620d2cfe5$var$node.hash = "fc05ee90d6c0521ade9b87e6185e0b92";
var $ba42f4c620d2cfe5$export$2e2bcd8739ae039 = $ba42f4c620d2cfe5$var$node;

});

parcelRegister("ifS9h", function(module, exports) {

$parcel$export(module.exports, "PopupContainer", () => $88fc3594fd7e78a2$export$cca08eed9de89ba9);
$parcel$export(module.exports, "LinkContainer", () => $88fc3594fd7e78a2$export$af2ec3aa21d10ab7);
$parcel$export(module.exports, "PopupHeader", () => $88fc3594fd7e78a2$export$b11ea9d6e8111404);
$parcel$export(module.exports, "StyledDate", () => $88fc3594fd7e78a2$export$30301703d55848e7);
$parcel$export(module.exports, "RepositoryInfo", () => $88fc3594fd7e78a2$export$fde5e3d077213a6f);
$parcel$export(module.exports, "PopupTitle", () => $88fc3594fd7e78a2$export$b834616c6081368f);
$parcel$export(module.exports, "StyledLink", () => $88fc3594fd7e78a2$export$9048d548939551ee);
$parcel$export(module.exports, "PopupOverflowSection", () => $88fc3594fd7e78a2$export$9e3158dc6a3a0f92);
$parcel$export(module.exports, "PopupKeyline", () => $88fc3594fd7e78a2$export$a0765d4427758c62);
$parcel$export(module.exports, "PopupOverflowButton", () => $88fc3594fd7e78a2$export$aeb11758c9d29e5c);
$parcel$export(module.exports, "TimeDisplay", () => $88fc3594fd7e78a2$export$9b3df3d60caed5f9);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $41j30 = parcelRequire("41j30");
const $88fc3594fd7e78a2$export$cca08eed9de89ba9 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _1bsbnklw _1tkeys9h _vchhusvi",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$af2ec3aa21d10ab7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _otyr1b66",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$b11ea9d6e8111404 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$30301703d55848e7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz131l _otyridpf _1e0c1txw _o5724jg8",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$fde5e3d077213a6f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz131l _o5724jg8",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$80b51772092eddc0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz131l _1p1dangw _otyr1b66",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$b834616c6081368f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($88fc3594fd7e78a2$export$80b51772092eddc0, props));
const $88fc3594fd7e78a2$export$9048d548939551ee = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $41j30.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81ixg _k48pmoej _syaz14q2 _otyru2gc",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$9e3158dc6a3a0f92 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkpxbi",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$a0765d4427758c62 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3it94y _bfhkmuej _otyrutpp",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$aeb11758c9d29e5c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf _1yxxidpf _12r2i7a9",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$9b3df3d60caed5f9 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66 _80omtlke",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gYpv9", function(module, exports) {

$parcel$export(module.exports, "DeploymentIcons", () => $d467b0cdb29c9a92$export$5202eabf0ef214b4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $gtRBF = parcelRequire("gtRBF");

var $bnW55 = parcelRequire("bnW55");

var $8hIiD = parcelRequire("8hIiD");

var $bdG8F = parcelRequire("bdG8F");

var $huvAp = parcelRequire("huvAp");

var $lgFQN = parcelRequire("lgFQN");

var $6TrDT = parcelRequire("6TrDT");

var $5gD09 = parcelRequire("5gD09");

var $aH4Tr = parcelRequire("aH4Tr");
const $d467b0cdb29c9a92$export$16b26cd5e98d9100 = (state)=>{
    switch(state){
        case (0, $5gD09.DeploymentStateOptions).PENDING:
            return 0, $bdG8F.default;
        case (0, $5gD09.DeploymentStateOptions).IN_PROGRESS:
            return 0, $8hIiD.default;
        case (0, $5gD09.DeploymentStateOptions).SUCCESSFUL:
            return 0, $6TrDT.default;
        case (0, $5gD09.DeploymentStateOptions).SUCCESSFULNONPRODUCTION:
            return 0, $lgFQN.default;
        case (0, $5gD09.DeploymentStateOptions).CANCELLED:
            return 0, $gtRBF.default;
        case (0, $5gD09.DeploymentStateOptions).FAILED:
            return 0, $bnW55.default;
        case (0, $5gD09.DeploymentStateOptions).ROLLED_BACK:
            return 0, $huvAp.default;
        case (0, $5gD09.DeploymentStateOptions).UNKNOWN:
            return 0, $aH4Tr.default;
        default:
            throw Error(`Unhandled deployment state - ${state}`);
    }
};
const $d467b0cdb29c9a92$export$c7835fd8b8ca1d68 = {
    width: '20',
    height: '20',
    padding: '2'
};
const $d467b0cdb29c9a92$export$148e312beb132853 = {
    width: '16',
    height: '16',
    padding: '0'
};
const $d467b0cdb29c9a92$export$31b21d0167753bb4 = (state)=>{
    switch(state){
        case 'small':
            return $d467b0cdb29c9a92$export$148e312beb132853;
        case 'medium':
            return $d467b0cdb29c9a92$export$c7835fd8b8ca1d68;
        default:
            return $d467b0cdb29c9a92$export$148e312beb132853;
    }
};
const $d467b0cdb29c9a92$export$5202eabf0ef214b4 = ({ deploymentState: deploymentState, size: size })=>{
    const Icon = $d467b0cdb29c9a92$export$16b26cd5e98d9100(deploymentState);
    const iconSize = $d467b0cdb29c9a92$export$31b21d0167753bb4(size);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d467b0cdb29c9a92$var$Wrapper, {
        "data-testid": `software-deployments-icons-common.ui.wrapper-${deploymentState}`,
        width: iconSize.width,
        height: iconSize.height,
        padding: iconSize.padding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d467b0cdb29c9a92$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { padding: padding, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1gljcou": (0, $lD23V.default)(__cmplp.width, "px"),
            "--_8jvb0j": (0, $lD23V.default)(__cmplp.height, "px"),
            "--_fl6vf6": (0, $lD23V.default)(__cmplp.padding, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1wug _2hwxidpf _otyr1wug _18u0idpf _1yt4gesh _1bsb1rkg _4t3i1474",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gtRBF", function(module, exports) {

$parcel$export(module.exports, "default", () => $2518052977c9ef6c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $2518052977c9ef6c$var$cancelledIcon = "var(--ds-icon-warning, #E56910)";
const $2518052977c9ef6c$var$backgroundColor = "var(--ds-icon-inverse, #FFFFFF)";
const $2518052977c9ef6c$var$CancelledIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        r: "7",
        cx: "8",
        cy: "8",
        fill: $2518052977c9ef6c$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M4.184 9h8V7h-8v2zm11.367-4.102a8.039 8.039 0 0 0-1.703-2.546A8.122 8.122 0 0 0 11.293.641 7.769 7.769 0 0 0 8.184 0a7.789 7.789 0 0 0-3.102.633 8.043 8.043 0 0 0-2.547 1.703A8.11 8.11 0 0 0 .824 4.891 7.747 7.747 0 0 0 .184 8c0 1.083.211 2.117.632 3.102.422.984.99 1.833 1.704 2.546a8.084 8.084 0 0 0 2.554 1.711 7.766 7.766 0 0 0 3.11.641 7.788 7.788 0 0 0 3.101-.633 8.043 8.043 0 0 0 2.547-1.703 8.133 8.133 0 0 0 1.711-2.555A7.765 7.765 0 0 0 16.184 8a7.796 7.796 0 0 0-.633-3.102z",
        fill: $2518052977c9ef6c$var$cancelledIcon,
        fillRule: "evenodd"
    }));
$2518052977c9ef6c$var$CancelledIcon.displayName = 'CancelledIcon';
var $2518052977c9ef6c$export$2e2bcd8739ae039 = $2518052977c9ef6c$var$CancelledIcon;

});

parcelRegister("bnW55", function(module, exports) {

$parcel$export(module.exports, "default", () => $8632fcaa6429e476$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $8632fcaa6429e476$var$failedColor = "var(--ds-icon-danger, #C9372C)";
const $8632fcaa6429e476$var$backgroundColor = "var(--ds-icon-inverse, #FFFFFF)";
const $8632fcaa6429e476$var$FailedIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        r: "6",
        cx: "8",
        cy: "8",
        fill: $8632fcaa6429e476$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: $8632fcaa6429e476$var$failedColor,
        fillRule: "evenodd",
        d: "M.768 9.768a2.5 2.5 0 010-3.536L6.232.768a2.5 2.5 0 013.536 0l5.464 5.464a2.5 2.5 0 010 3.536l-5.464 5.464a2.5 2.5 0 01-3.536 0L.768 9.768zM7 4a1 1 0 112 0v4a1 1 0 01-2 0V4zm1 8a1 1 0 100-2 1 1 0 000 2z",
        clipRule: "evenodd"
    }));
$8632fcaa6429e476$var$FailedIcon.displayName = 'FailedIcon';
var $8632fcaa6429e476$export$2e2bcd8739ae039 = $8632fcaa6429e476$var$FailedIcon;

});

parcelRegister("8hIiD", function(module, exports) {

$parcel$export(module.exports, "default", () => $4327c88dccf550c9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $4327c88dccf550c9$var$inProgressColor = "var(--ds-icon-information, #1D7AFC)";
const $4327c88dccf550c9$var$backgroundColor = "var(--ds-icon-inverse, #FFFFFF)";
const $4327c88dccf550c9$var$InProgressIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4327c88dccf550c9$var$SpinningSvg, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        r: "7",
        cx: "8",
        cy: "8",
        fill: $4327c88dccf550c9$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: $4327c88dccf550c9$var$inProgressColor,
        d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 12.444A4.445 4.445 0 013.556 8a.889.889 0 111.777 0A2.667 2.667 0 008 10.667a.888.888 0 110 1.777zm3.556-3.555a.889.889 0 01-.89-.889A2.667 2.667 0 008 5.333a.889.889 0 010-1.777A4.445 4.445 0 0112.444 8a.888.888 0 01-.888.889z"
    }));
$4327c88dccf550c9$var$InProgressIcon.displayName = 'InProgressIcon';
var $4327c88dccf550c9$export$2e2bcd8739ae039 = $4327c88dccf550c9$var$InProgressIcon;
const $4327c88dccf550c9$var$spin = null;
// 1.5s matches the same animation on bitbucket for builds
const $4327c88dccf550c9$var$spinAnimation = `${$4327c88dccf550c9$var$spin} 1.5s linear infinite`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4327c88dccf550c9$var$SpinningSvg = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "svg", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1xz6pnn": (0, $lD23V.default)($4327c88dccf550c9$var$spinAnimation)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y44v1wf2",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bdG8F", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbbaafbb3b446ad9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $dbbaafbb3b446ad9$var$pendingColor = "var(--ds-icon-information, #1D7AFC)";
const $dbbaafbb3b446ad9$var$backgroundColor = "var(--ds-icon-inverse, #FFFFFF)";
const $dbbaafbb3b446ad9$var$PendingIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        r: "7",
        cx: "8",
        cy: "8",
        fill: $dbbaafbb3b446ad9$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: $dbbaafbb3b446ad9$var$pendingColor,
        d: "M13.657 2.343A8 8 0 102.343 13.657 8 8 0 0013.657 2.343zm-2.308 9.006a1 1 0 01-1.389.024L7.294 8.707a.988.988 0 01-.217-.325l.002.007-.005-.013.003.006A.993.993 0 017 8V4a1 1 0 012 0v3.587l2.373 2.373a1 1 0 01-.024 1.389z"
    }));
$dbbaafbb3b446ad9$var$PendingIcon.displayName = 'PendingIcon';
var $dbbaafbb3b446ad9$export$2e2bcd8739ae039 = $dbbaafbb3b446ad9$var$PendingIcon;

});

parcelRegister("huvAp", function(module, exports) {

$parcel$export(module.exports, "default", () => $73da12db542612ce$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $73da12db542612ce$var$rolledBackColor = "var(--ds-icon-warning, #E56910)";
const $73da12db542612ce$var$backgroundColor = "var(--ds-icon-inverse, #FFFFFF)";
const $73da12db542612ce$var$RolledBackIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        r: "7",
        cx: "8",
        cy: "8",
        fill: $73da12db542612ce$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: $73da12db542612ce$var$rolledBackColor,
        fillRule: "evenodd",
        d: "M16 8A8 8 0 110 8a8 8 0 0116 0zM7.707 3.293a1 1 0 010 1.414L7.414 5H8.6C10.516 5 12 6.606 12 8.5S10.516 12 8.6 12H7a1 1 0 110-2h1.6c.735 0 1.4-.633 1.4-1.5S9.335 7 8.6 7H7.414l.293.293a1 1 0 01-1.414 1.414l-2-2a1 1 0 010-1.414l2-2a1 1 0 011.414 0z",
        clipRule: "evenodd"
    }));
$73da12db542612ce$var$RolledBackIcon.displayName = 'RolledBackIcon';
var $73da12db542612ce$export$2e2bcd8739ae039 = $73da12db542612ce$var$RolledBackIcon;

});

parcelRegister("lgFQN", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a1792f365bbd0a4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $0a1792f365bbd0a4$var$successColor = "var(--ds-icon-success, #22A06B)";
const $0a1792f365bbd0a4$var$backgroundColor = "var(--ds-icon-inverse, #FFFFFF)";
const $0a1792f365bbd0a4$var$SuccessNonProductionIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        r: "7",
        cx: "8",
        cy: "8",
        fill: $0a1792f365bbd0a4$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: $0a1792f365bbd0a4$var$successColor,
        fillRule: "evenodd",
        d: "M14 8A6 6 0 112 8a6 6 0 0112 0zm2 0A8 8 0 110 8a8 8 0 0116 0zm-4.293-1.293a1 1 0 00-1.414-1.414L7 8.586 5.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
        clipRule: "evenodd"
    }));
$0a1792f365bbd0a4$var$SuccessNonProductionIcon.displayName = 'SuccessNonProductionIcon';
var $0a1792f365bbd0a4$export$2e2bcd8739ae039 = $0a1792f365bbd0a4$var$SuccessNonProductionIcon;

});

parcelRegister("6TrDT", function(module, exports) {

$parcel$export(module.exports, "default", () => $7eba88d22afe0554$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $7eba88d22afe0554$var$successColor = "var(--ds-icon-success, #22A06B)";
const $7eba88d22afe0554$var$backgroundColor = "var(--ds-icon-inverse, #FFFFFF)";
const $7eba88d22afe0554$var$SuccessProductionIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        r: "7",
        cx: "8",
        cy: "8",
        fill: $7eba88d22afe0554$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: $7eba88d22afe0554$var$successColor,
        fillRule: "evenodd",
        d: "M8 16A8 8 0 108 0a8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L7 8.586 5.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
        clipRule: "evenodd"
    }));
$7eba88d22afe0554$var$SuccessProductionIcon.displayName = 'SuccessProductionIcon';
var $7eba88d22afe0554$export$2e2bcd8739ae039 = $7eba88d22afe0554$var$SuccessProductionIcon;

});

parcelRegister("5gD09", function(module, exports) {

$parcel$export(module.exports, "DeploymentStateOptions", () => $fb6a7926b4820f28$export$a761da6c19e008f6);
const $fb6a7926b4820f28$var$PENDING = 'PENDING';
const $fb6a7926b4820f28$var$IN_PROGRESS = 'IN_PROGRESS';
const $fb6a7926b4820f28$var$SUCCESSFUL = 'SUCCESSFUL';
const $fb6a7926b4820f28$var$SUCCESSFULNONPRODUCTION = 'SUCCESSFULNONPRODUCTION';
const $fb6a7926b4820f28$var$CANCELLED = 'CANCELLED';
const $fb6a7926b4820f28$var$FAILED = 'FAILED';
const $fb6a7926b4820f28$var$ROLLED_BACK = 'ROLLED_BACK';
const $fb6a7926b4820f28$var$UNKNOWN = 'UNKNOWN';
const $fb6a7926b4820f28$export$a761da6c19e008f6 = {
    PENDING: $fb6a7926b4820f28$var$PENDING,
    IN_PROGRESS: $fb6a7926b4820f28$var$IN_PROGRESS,
    SUCCESSFUL: $fb6a7926b4820f28$var$SUCCESSFUL,
    SUCCESSFULNONPRODUCTION: $fb6a7926b4820f28$var$SUCCESSFULNONPRODUCTION,
    CANCELLED: $fb6a7926b4820f28$var$CANCELLED,
    FAILED: $fb6a7926b4820f28$var$FAILED,
    ROLLED_BACK: $fb6a7926b4820f28$var$ROLLED_BACK,
    UNKNOWN: $fb6a7926b4820f28$var$UNKNOWN
};

});

parcelRegister("aH4Tr", function(module, exports) {

$parcel$export(module.exports, "default", () => $88ff831a34167232$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $88ff831a34167232$var$unknownColor = "var(--ds-icon-success, #22A06B)";
const $88ff831a34167232$var$backgroundColor = "var(--ds-icon-inverse, #FFFFFF)";
const $88ff831a34167232$export$c8e691818f5132e2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        fill: $88ff831a34167232$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("mask", {
        id: "a",
        fill: $88ff831a34167232$var$backgroundColor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M15.4 4.9a8 8 0 0 0-1.7-2.5A8.1 8.1 0 0 0 11 .6 7.8 7.8 0 0 0 8 0a7.8 7.8 0 0 0-3.1.6 8 8 0 0 0-2.5 1.7A8.1 8.1 0 0 0 .6 5 7.7 7.7 0 0 0 0 8c0 1 .2 2.1.6 3.1a8 8 0 0 0 1.7 2.5A8.1 8.1 0 0 0 5 15.4 7.8 7.8 0 0 0 8 16a7.8 7.8 0 0 0 3.1-.6 8 8 0 0 0 2.5-1.7 8.2 8.2 0 0 0 1.8-2.6c.4-1 .6-2 .6-3.1a7.8 7.8 0 0 0-.6-3.1z",
        clipRule: "evenodd",
        fillRule: "evenodd"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: $88ff831a34167232$var$unknownColor,
        d: "m11.1.6.8-1.8-.8 1.8zM5 .6l.8 1.9L4.9.6zM.6 5l1.9.8-1.9-.8zm0 6.2-1.8.8L.6 11zm1.7 2.5 1.5-1.4-1.5 1.4zM5 15.4l.8-1.9-.8 1.9zm6.2 0 .8 1.8-.8-1.8zm2.5-1.7 1.5 1.4-1.5-1.4zm1.8-2.6 1.8.8-1.8-.8zm1.8-7A10 10 0 0 0 15.1 1l-2.8 2.9a6 6 0 0 1 1.2 1.9L17.2 4zM15.1 1a10.1 10.1 0 0 0-3.2-2l-1.6 3.6a6.1 6.1 0 0 1 2 1.3L15 .9zm-3.2-2A9.8 9.8 0 0 0 8-2v4c.8 0 1.6.2 2.3.5L12-1.2zM8-2a9.8 9.8 0 0 0-3.9.8l1.6 3.7A5.8 5.8 0 0 1 8 2v-4zm-3.9.8A10 10 0 0 0 1 .9l2.9 2.9a6 6 0 0 1 1.9-1.3L4-1.2zM1 .9a10.1 10.1 0 0 0-2.1 3.2l3.7 1.6a6.1 6.1 0 0 1 1.3-2L.9 1zm-2 3.2A9.7 9.7 0 0 0-2 8h4c0-.8.2-1.6.5-2.3L-1.2 4zM-2 8c0 1.4.3 2.7.8 3.9l3.7-1.6A5.8 5.8 0 0 1 2 8h-4zm.8 3.9A10 10 0 0 0 .9 15l2.8-2.9a6 6 0 0 1-1.2-1.9L-1.2 12zM.9 15a10.1 10.1 0 0 0 3.2 2.1l1.6-3.7a6.1 6.1 0 0 1-2-1.3L1 15.1zm3.2 2.1A9.8 9.8 0 0 0 8 18v-4a5.8 5.8 0 0 1-2.3-.5L4 17.2zM8 18c1.4 0 2.7-.3 3.9-.8l-1.6-3.7c-.7.3-1.5.5-2.3.5v4zm3.9-.8a10 10 0 0 0 3.2-2.1l-2.9-2.9a6 6 0 0 1-1.9 1.3l1.6 3.7zm3.2-2.1c.9-1 1.6-2 2.1-3.2l-3.7-1.6a6.2 6.2 0 0 1-1.3 2l2.9 2.8zm2.1-3.2A9.8 9.8 0 0 0 18 8h-4c0 .8-.2 1.6-.5 2.3l3.7 1.6zM18 8c0-1.4-.3-2.7-.8-3.9l-3.7 1.6c.3.7.5 1.5.5 2.3h4z",
        mask: "url(#a)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: $88ff831a34167232$var$unknownColor,
        d: "M5.4 6.4H7c0-.6.4-1 1-1s1 .4 1 1c0 .4-.2.7-.8 1-.8.5-1 1-1 1.9v.3h1.4v-.3c0-.5.2-.8 1-1.2.7-.5 1-1 1-1.8 0-1.3-1-2.1-2.5-2.1-1.6 0-2.6.9-2.6 2.2zM8 12.2c.6 0 1-.4 1-1 0-.5-.4-.8-1-.8s-1 .3-1 .9c0 .5.4.9 1 .9z"
    }));
$88ff831a34167232$export$c8e691818f5132e2.displayName = 'Unknown';
var $88ff831a34167232$export$2e2bcd8739ae039 = $88ff831a34167232$export$c8e691818f5132e2;

});


parcelRegister("g2uF3", function(module, exports) {

$parcel$export(module.exports, "default", () => $0476b58be30c776d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0476b58be30c776d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    deploymentPopupTitle: {
        "id": "software-releases-launch-card.latest-deployment.deployment-tooltip-content.deployment-popup-title",
        "defaultMessage": "Deployment"
    },
    viewAllDeployments: {
        "id": "software-releases-launch-card.latest-deployment.deployment-tooltip-content.view-all-deployments",
        "defaultMessage": "View all deployments"
    },
    issuesDeployed: {
        "id": "software-releases-launch-card.latest-deployment.deployment-tooltip-content.issues-deployed",
        "defaultMessage": "{issueCount} {issueCount, plural, one {issue} other {issues}} deployed"
    },
    issuesDeployedIssueTerminologyRefreshM4: {
        "id": "software-releases-launch-card.latest-deployment.deployment-tooltip-content.issues-deployed-issue-terminology-refresh-m4",
        "defaultMessage": "{issueCount} {issueCount, plural, one {work item} other {work items}} deployed"
    }
});

});

parcelRegister("e2lGD", function(module, exports) {

$parcel$export(module.exports, "capitalizeOnlyFirstLetter", () => $ec77f0c65895c94d$export$1f9f0c721cdd6cac);
$parcel$export(module.exports, "mapDeploymentState", () => $ec77f0c65895c94d$export$e46eedc73b6bf584);
$parcel$export(module.exports, "mapStateToLozengeProp", () => $ec77f0c65895c94d$export$bb72fc1de2630393);

var $iHvFq = parcelRequire("iHvFq");

var $9pctO = parcelRequire("9pctO");

var $5gD09 = parcelRequire("5gD09");
const $ec77f0c65895c94d$export$1f9f0c721cdd6cac = (str)=>(0, (/*@__PURE__*/$parcel$interopDefault($9pctO)))((0, (/*@__PURE__*/$parcel$interopDefault($iHvFq)))(str));
const $ec77f0c65895c94d$export$e46eedc73b6bf584 = (state, environmentCategory)=>{
    switch(state){
        case 'IN_PROGRESS':
        case 'PENDING':
        case 'ROLLED_BACK':
        case 'CANCELLED':
        case 'FAILED':
            return state;
        case 'SUCCESSFUL':
            if (environmentCategory !== 'PRODUCTION') return (0, $5gD09.DeploymentStateOptions).SUCCESSFULNONPRODUCTION;
            return state;
        default:
            return (0, $5gD09.DeploymentStateOptions).UNKNOWN;
    }
};
const $ec77f0c65895c94d$export$bb72fc1de2630393 = (state)=>{
    switch(state){
        case 'IN_PROGRESS':
        case 'PENDING':
            return 'inprogress';
        case 'ROLLED_BACK':
        case 'CANCELLED':
            return 'moved';
        case 'FAILED':
            return 'removed';
        case 'SUCCESSFUL':
        default:
            return 'success';
    }
};

});
parcelRegister("iHvFq", function(module, exports) {

var $gDRiW = parcelRequire("gDRiW");
/**
 * Converts `string`, as space separated words, to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the lower cased string.
 * @example
 *
 * _.lowerCase('--Foo-Bar--');
 * // => 'foo bar'
 *
 * _.lowerCase('fooBar');
 * // => 'foo bar'
 *
 * _.lowerCase('__FOO_BAR__');
 * // => 'foo bar'
 */ var $d9d4ce91007e2cba$var$lowerCase = $gDRiW(function(result, word, index) {
    return result + (index ? ' ' : '') + word.toLowerCase();
});
module.exports = $d9d4ce91007e2cba$var$lowerCase;

});



parcelRegister("65TnY", function(module, exports) {

$parcel$export(module.exports, "PulseIcon", () => $e263123445f07adb$export$821b06bbcfc0bc3c);
/* PulseIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5LWLA = parcelRequire("5LWLA");

var $gwIPs = parcelRequire("gwIPs");
const $e263123445f07adb$export$f27fc5fc552d177d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: (0, $gwIPs.gridSize) * 2,
        height: (0, $gwIPs.gridSize) * 2,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M2 8.70457H5.81067L7.7095 4L8.7403 12L10.5306 7.07724H14",
        stroke: "var(--ds-icon-subtle, #626F86)",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
const $e263123445f07adb$export$821b06bbcfc0bc3c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e263123445f07adb$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: $e263123445f07adb$export$f27fc5fc552d177d,
        size: "medium",
        label: ""
    }));
const $e263123445f07adb$export$be58b4326e23250f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("ghVnF", function(module, exports) {

$parcel$export(module.exports, "default", () => $12df77a1b19829dc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $12df77a1b19829dc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noDeployments: {
        "id": "software-releases-launch-card.latest-deployment.no-deployments",
        "defaultMessage": "No deployments for the last week"
    },
    lastDeployment: {
        "id": "software-releases-launch-card.latest-deployment.last-deployment",
        "defaultMessage": "Last deployment: "
    },
    loading: {
        "id": "software-releases-launch-card.latest-deployment.loading",
        "defaultMessage": "Loading..."
    }
});

});

parcelRegister("dGKnO", function(module, exports) {

$parcel$export(module.exports, "useLoadProvidersListQuery", () => $735230b5b4cedbec$export$8544c7d4cd7544c3);
$parcel$export(module.exports, "ProvidersList", () => $735230b5b4cedbec$export$82486456ea9f13cc);

var $4myeK = parcelRequire("4myeK");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $l1N8i = parcelRequire("l1N8i");

var $c2i4s = parcelRequire("c2i4s");

var $eZJjh = parcelRequire("eZJjh");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $lfTZh = parcelRequire("lfTZh");

var $dXq4S = parcelRequire("dXq4S");

var $4myeK = parcelRequire("4myeK");

var $koeKL = parcelRequire("koeKL");

var $gBkhv = parcelRequire("gBkhv");

var $1eX9X = parcelRequire("1eX9X");

var $dJzWW = parcelRequire("dJzWW");
const $735230b5b4cedbec$export$8544c7d4cd7544c3 = ()=>{
    const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $4myeK.default));
    const cloudId = (0, $koeKL.useCloudId)();
    const loadProvidersListQuery = ()=>{
        if (queryReference == null) loadQuery({
            cloudId: (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                resourceType: 'site',
                resourceId: cloudId
            })
        });
    };
    return [
        queryReference,
        loadProvidersListQuery
    ];
};
const $735230b5b4cedbec$export$6bc5a3de56260df3 = ({ queryReference: queryReference })=>{
    const { devOps: devOps } = (0, $8Uumt.usePreloadedQuery)((0, $4myeK.default), queryReference);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { deploymentProviders: deploymentProviders } = devOps.providers;
    const renderProvidersConnectedMessage = ()=>{
        switch(deploymentProviders.length){
            case 1:
                return formatMessage((0, $1eX9X.default).oneProviderIsConnected, {
                    providerName: deploymentProviders[0]?.name
                });
            case 2:
                return formatMessage((0, $1eX9X.default).twoProvidersAreConnected);
            default:
                return formatMessage((0, $1eX9X.default).threeOrMoreProvidersAreConnected);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($735230b5b4cedbec$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($735230b5b4cedbec$var$ProviderList, null, deploymentProviders.filter(Boolean).slice(0, 3).map((provider)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($735230b5b4cedbec$var$LogoContainer, {
            key: provider.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dJzWW.ProviderLogo), {
            provider: provider
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($735230b5b4cedbec$var$CheckIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
        spacing: "spacious",
        color: "var(--ds-icon-success, #22A06B)",
        label: ""
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall"
    }, renderProvidersConnectedMessage()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($735230b5b4cedbec$var$DetailText, null, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $1eX9X.default).setUpDeploymentsDetailIssueTerminologyRefreshM4 : (0, $1eX9X.default).setUpDeploymentsDetail)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($735230b5b4cedbec$var$LinkText, {
        href: (0, $gBkhv.SUPPORT_DOCS_LINK_URL),
        target: "_blank"
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $1eX9X.default).supportLinkTextIssueTerminologyRefreshM4 : (0, $1eX9X.default).supportLinkText)));
};
const $735230b5b4cedbec$export$82486456ea9f13cc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "providers-list-inner",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($735230b5b4cedbec$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), null))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($735230b5b4cedbec$export$6bc5a3de56260df3, {
        queryReference: props.queryReference
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $735230b5b4cedbec$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bsb1lze _vchhusvi _ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q _y3gn1h6o _syaz131l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $735230b5b4cedbec$var$ProviderList = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _2mzuglyw _otyrutpp _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $735230b5b4cedbec$var$LogoContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _79apxmi2",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $735230b5b4cedbec$var$DetailText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qu2gc _u5f3idpf _n3td1ejb _19bvidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $735230b5b4cedbec$var$CheckIconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1osq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _4cvr1h6o _1bah1h6o _kqswstnw _1bsb1tcg _4t3i1tcg _bfhkvuon _154ir5cr _1xi2r5cr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $735230b5b4cedbec$var$LinkText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz14q2",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4myeK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff46286f6c80ad0a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<484fd7fef369b6ade30fe6cb89abc829>>
 * @relayHash efe9f1db11e6de328e9f1549d3bf2dda
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 615b7ed663144eb1919951d271557951faf2fdb21681d222dc88fedad6aa9908
const $ff46286f6c80ad0a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "providerTypes",
            "value": [
                "DEPLOYMENT"
            ]
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "providersListTooltipContentQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "DevOps",
                        "kind": "LinkedField",
                        "name": "devOps",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "DevOpsProviders",
                                    "kind": "LinkedField",
                                    "name": "providers",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "DevOpsDeploymentProvider",
                                                "kind": "LinkedField",
                                                "name": "deploymentProviders",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v2 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "devOps.providers.deploymentProviders.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "devOps.providers.deploymentProviders.name"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "providerLogo_softwareReleasesLaunchCard"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "devOps.providers.deploymentProviders"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "devOps.providers"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "devOps"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "providersListTooltipContentQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "DevOpsProviders",
                            "kind": "LinkedField",
                            "name": "providers",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "DevOpsDeploymentProvider",
                                    "kind": "LinkedField",
                                    "name": "deploymentProviders",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "logoUrl"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "615b7ed663144eb1919951d271557951faf2fdb21681d222dc88fedad6aa9908",
            "metadata": {},
            "name": "providersListTooltipContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ff46286f6c80ad0a$var$node.hash = "2fb2dcefa503b43df945cc594382beab";
var $ff46286f6c80ad0a$export$2e2bcd8739ae039 = $ff46286f6c80ad0a$var$node;

});

parcelRegister("1eX9X", function(module, exports) {

$parcel$export(module.exports, "default", () => $12442aeae637d827$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $12442aeae637d827$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    oneProviderIsConnected: {
        "id": "software-releases-launch-card.latest-deployment.providers-list-tooltip-content.one-provider-is-connected",
        "defaultMessage": "{providerName} is installed"
    },
    twoProvidersAreConnected: {
        "id": "software-releases-launch-card.latest-deployment.providers-list-tooltip-content.two-providers-are-connected",
        "defaultMessage": "2 deployment tools installed"
    },
    threeOrMoreProvidersAreConnected: {
        "id": "software-releases-launch-card.latest-deployment.providers-list-tooltip-content.three-or-more-providers-are-connected",
        "defaultMessage": "3+ deployment tools installed"
    },
    setUpDeploymentsDetail: {
        "id": "software-releases-launch-card.latest-deployment.providers-list-tooltip-content.set-up-deployments-detail",
        "defaultMessage": "To track deployments in Jira, start linking your work to issues in this project."
    },
    supportLinkText: {
        "id": "software-releases-launch-card.latest-deployment.providers-list-tooltip-content.support-link-text",
        "defaultMessage": "Learn how to link development work to issues"
    },
    setUpDeploymentsDetailIssueTerminologyRefreshM4: {
        "id": "software-releases-launch-card.latest-deployment.providers-list-tooltip-content.set-up-deployments-detail-issue-terminology-refresh-m4",
        "defaultMessage": "To track deployments in Jira, start linking your work to work items in this project."
    },
    supportLinkTextIssueTerminologyRefreshM4: {
        "id": "software-releases-launch-card.latest-deployment.providers-list-tooltip-content.support-link-text-issue-terminology-refresh-m4",
        "defaultMessage": "Learn how to link development work to work items"
    }
});

});

parcelRegister("dJzWW", function(module, exports) {

$parcel$export(module.exports, "ProviderLogo", () => $d5a890bebf2b9254$export$a48c0a0510fd5b7a);

var $jmeDM = parcelRequire("jmeDM");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $h7YYF = parcelRequire("h7YYF");
const $d5a890bebf2b9254$export$a48c0a0510fd5b7a = ({ provider: provider })=>{
    const { name: name, logoUrl: logoUrl } = (0, $8Uumt.useFragment)((0, $jmeDM.default), provider);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d5a890bebf2b9254$export$e464f89b9068f431, {
        src: logoUrl ?? '',
        alt: name ?? '',
        title: name ?? '',
        onError: (e)=>{
            if (e.target instanceof HTMLImageElement) e.target.src = (0, (/*@__PURE__*/$parcel$interopDefault($h7YYF)));
        }
    });
};
const $d5a890bebf2b9254$export$e464f89b9068f431 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1osq _1bsbzwfg _4t3izwfg _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _16qsvjj6 _bfhku67f",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jmeDM", function(module, exports) {

$parcel$export(module.exports, "default", () => $119bf602319f2f60$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7752b05a0a8bdae34a7f01febb9a6714>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $119bf602319f2f60$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "providerLogo_softwareReleasesLaunchCard",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "logoUrl"
        }
    ],
    "type": "DevOpsDeploymentProvider"
};
$119bf602319f2f60$var$node.hash = "a69ed29281953f2d0dd2061c60855b1f";
var $119bf602319f2f60$export$2e2bcd8739ae039 = $119bf602319f2f60$var$node;

});

parcelRegister("h7YYF", function(module, exports) {
module.exports = new URL("addon.840ab9ef.svg", import.meta.url).toString();

});




parcelRegister("aRLM0", function(module, exports) {

$parcel$export(module.exports, "VersionContributorsSectionSkeleton", () => $9b7ba4f3787efd3d$export$9ffa065263e020b9);
$parcel$export(module.exports, "AsyncVersionContributors", () => $9b7ba4f3787efd3d$export$c80cf9cb5de0170f);

var $ifG8b = parcelRequire("ifG8b");

var $5ZT5S = parcelRequire("5ZT5S");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $dS3PR = parcelRequire("dS3PR");

var $koVbs = parcelRequire("koVbs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $6rFQR = parcelRequire("6rFQR");

var $dw99M = parcelRequire("dw99M");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9b7ba4f3787efd3d$var$LazyVersionContributors = (0, $kxZPA.lazy)(()=>(parcelRequire("fCVtH")).then((module)=>module.VersionContributors), {
    moduleId: "./src/packages/releases/launch-card/src/ui/version-contributors/index.tsx"
});
const $9b7ba4f3787efd3d$export$9ffa065263e020b9 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b7ba4f3787efd3d$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        size: "UNSAFE_small",
        weight: "bold",
        color: "color.text.subtle",
        as: "p"
    }, formatMessage((0, $dw99M.default).contributorsLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6rFQR.ContributorsSkeleton), {
        contributorCount: 4
    }));
};
const $9b7ba4f3787efd3d$export$c80cf9cb5de0170f = ({ queryRef: queryRef })=>{
    const { jira: jira } = (0, $8Uumt.usePreloadedQuery)((0, $5ZT5S.default), queryRef);
    const versionFrag = jira.version;
    const version = (0, $8Uumt.useFragment)((0, $ifG8b.default), versionFrag);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "version-contributors",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b7ba4f3787efd3d$export$9ffa065263e020b9, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b7ba4f3787efd3d$var$LazyVersionContributors, {
        jiraVersionContributors: version.contributors.edges.filter(Boolean)
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $9b7ba4f3787efd3d$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _1ul9ntd2",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ifG8b", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b697d536620ab70$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<df1174cc15a058925e75406b6d0ec4e2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3b697d536620ab70$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "async_softwareReleasesLaunchCard_AsyncVersionContributors",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraVersionContributorConnection",
                "kind": "LinkedField",
                "name": "contributors",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraVersionContributorEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "versionContributors_softwareReleasesLaunchCard"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "contributors.edges"
                    }
                ]
            },
            "action": "THROW",
            "path": "contributors"
        }
    ],
    "type": "JiraVersion"
};
$3b697d536620ab70$var$node.hash = "1c2f7736ef0703bba0e1b3081509e3ee";
var $3b697d536620ab70$export$2e2bcd8739ae039 = $3b697d536620ab70$var$node;

});

parcelRegister("6rFQR", function(module, exports) {

$parcel$export(module.exports, "ContributorsSkeleton", () => $ed9fcb17e1232246$export$bd943a9e5a9521c);
/* ContributorsSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $ed9fcb17e1232246$export$bd943a9e5a9521c = ({ contributorCount: contributorCount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed9fcb17e1232246$var$Container, null, [
        ...Array(contributorCount)
    ].map((_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed9fcb17e1232246$var$SkeletonGroup, {
            key: i
        })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ed9fcb17e1232246$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1p5aglyw _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $ed9fcb17e1232246$var$SkeletonGroup = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1ssb _189eyh40 _1dqonqa1 _1h6du67f _1bsb1tcg _4t3i1tcg _bfhkn82g _1e0c1o8l _79apxmi2",
            __cmplp.className
        ])
    });
});

});

parcelRegister("dw99M", function(module, exports) {

$parcel$export(module.exports, "default", () => $acb7838bd58c3890$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $acb7838bd58c3890$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    contributorsLabel: {
        "id": "software-releases-launch-card.version-contributors.contributors-label",
        "defaultMessage": "Contributors"
    }
});

});

parcelRegister("fCVtH", function(module, exports) {

let $b606fd93bd807890$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b606fd93bd807890$var$load("jRTTH").then(()=>parcelRequire('g2vqE'));

});


parcelRegister("gPH8i", function(module, exports) {

$parcel$export(module.exports, "VersionDates", () => $57776e2f2bdc42ed$export$2f6a5887195e56f4);

var $jPxD4 = parcelRequire("jPxD4");

var $guZiv = parcelRequire("guZiv");

var $8Gql5 = parcelRequire("8Gql5");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $1O7Kb = parcelRequire("1O7Kb");

var $75GNn = parcelRequire("75GNn");

var $16Op0 = parcelRequire("16Op0");

var $dyMGB = parcelRequire("dyMGB");

var $7RQHY = parcelRequire("7RQHY");
const $57776e2f2bdc42ed$var$BAD_START_RELEASE_DATE_ORDER_ERROR = 'BAD_START_RELEASE_DATE_ORDER';
const $57776e2f2bdc42ed$var$useFormattedDates = (startDate, releaseDate)=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $koVbs.default)();
    return {
        formattedStartDate: startDate === null ? formatMessage((0, $7RQHY.default).startDateNotSet) : formatDate(new Date(startDate), {
            timeZone: (0, $1O7Kb.VERSION_DATE_FORMAT_OPTION).timeZone,
            dateStyle: 'long'
        }),
        formattedReleaseDate: releaseDate === null ? formatMessage((0, $7RQHY.default).releaseDateNotSet) : formatDate(new Date(releaseDate), {
            timeZone: (0, $1O7Kb.VERSION_DATE_FORMAT_OPTION).timeZone,
            dateStyle: 'long'
        })
    };
};
const $57776e2f2bdc42ed$export$2f6a5887195e56f4 = ({ jiraVersion: jiraVersion })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const version = (0, $8Uumt.useFragment)((0, $8Gql5.default), jiraVersion);
    const [updateVersionStartDate] = (0, $8Uumt.useMutation)((0, $guZiv.default));
    const [updateVersionReleaseDate] = (0, $8Uumt.useMutation)((0, $jPxD4.default));
    const handleStartDateMutationError = (data)=>{
        const flagText = {
            title: (0, $7RQHY.default).startDateGenericErrorFlagTitle,
            description: (0, $7RQHY.default).genericErrorFlagDescription
        };
        if (data.jira?.updateVersionStartDate?.errors) {
            const { extensions: extensions } = data.jira.updateVersionStartDate.errors[0];
            if (extensions?.errorType === $57776e2f2bdc42ed$var$BAD_START_RELEASE_DATE_ORDER_ERROR) {
                flagText.title = (0, $7RQHY.default).badReleaseStartDateOrderErrorFlagTitle;
                flagText.description = (0, $7RQHY.default).badReleaseStartDateOrderErrorFlagDescription;
            }
        }
        showFlag({
            type: 'warning',
            ...flagText,
            messageId: 'software-releases-launch-card.ui.version-dates.show-flag.warning.handle-start-date-mutation-error.show-flag.warning',
            messageType: 'transactional'
        });
    };
    const handleStartDateChange = (startDate)=>{
        updateVersionStartDate({
            variables: {
                input: {
                    id: version.id,
                    startDate: startDate
                }
            },
            onCompleted: (data)=>{
                if (!data.jira?.updateVersionStartDate?.success) handleStartDateMutationError(data);
                else (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({
                    action: 'updated',
                    actionSubject: 'versionStartDate'
                }), 'versionStartDate updated');
            },
            onError: ()=>{
                (0, $75GNn.fireFieldUpdateErrorAnalytics)();
                showFlag({
                    type: 'error',
                    title: (0, $7RQHY.default).startDateGenericErrorFlagTitle,
                    description: (0, $7RQHY.default).genericErrorFlagDescription,
                    messageId: 'software-releases-launch-card.ui.version-dates.show-flag.error.on-error.show-flag.error',
                    messageType: 'transactional'
                });
            },
            optimisticResponse: {
                jira: {
                    updateVersionStartDate: {
                        success: true,
                        errors: [],
                        version: {
                            id: version.id,
                            startDate: startDate
                        }
                    }
                }
            }
        });
    };
    const handleReleaseDateChange = (releaseDate)=>{
        updateVersionReleaseDate({
            variables: {
                input: {
                    id: version.id,
                    releaseDate: releaseDate
                }
            },
            onCompleted: (data)=>{
                if (!data.jira?.updateVersionReleaseDate?.success) showFlag({
                    type: 'warning',
                    title: (0, $7RQHY.default).releaseDateErrorFlagTitle,
                    description: (0, $7RQHY.default).genericErrorFlagDescription,
                    messageId: 'software-releases-launch-card.ui.version-dates.show-flag.warning.on-completed.show-flag.warning',
                    messageType: 'transactional'
                });
                else (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({
                    action: 'updated',
                    actionSubject: 'versionReleaseDate'
                }), 'versionReleaseDate updated');
            },
            onError: ()=>{
                (0, $75GNn.fireFieldUpdateErrorAnalytics)();
                showFlag({
                    type: 'error',
                    title: (0, $7RQHY.default).releaseDateErrorFlagTitle,
                    description: (0, $7RQHY.default).genericErrorFlagDescription,
                    messageId: 'software-releases-launch-card.ui.version-dates.show-flag.error.on-error.show-flag.error.1',
                    messageType: 'transactional'
                });
            },
            optimisticResponse: {
                jira: {
                    updateVersionReleaseDate: {
                        success: true,
                        version: {
                            id: version.id,
                            releaseDate: releaseDate
                        }
                    }
                }
            }
        });
    };
    const { formattedStartDate: formattedStartDate, formattedReleaseDate: formattedReleaseDate } = $57776e2f2bdc42ed$var$useFormattedDates(// @ts-expect-error - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string | null'.
    version.startDate, version.releaseDate);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57776e2f2bdc42ed$var$DateContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16Op0.AsyncEditableDatePicker), {
        analyticsEventName: "versionStartDate" // @ts-expect-error - Type 'boolean | null | undefined' is not assignable to type 'boolean | null'.
        ,
        canEdit: version.canEdit,
        currentDate: version.startDate,
        displayDate: formattedStartDate,
        label: formatMessage((0, $7RQHY.default).startDateFieldLabel),
        maxDate: (0, $dyMGB.convertDatetimeToDate)(version.releaseDate),
        onUpdateDate: handleStartDateChange,
        testId: "software-releases-launch-card.ui.version-dates.start-date-editable-date-picker"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16Op0.AsyncEditableDatePicker), {
        analyticsEventName: "versionReleaseDate" // @ts-expect-error - Type 'boolean | null | undefined' is not assignable to type 'boolean | null'.
        ,
        canEdit: version.canEdit,
        currentDate: version.releaseDate,
        displayDate: formattedReleaseDate,
        label: formatMessage((0, $7RQHY.default).releaseDateFieldLabel),
        minDate: (0, $dyMGB.convertDatetimeToDate)(version.startDate),
        onUpdateDate: handleReleaseDateChange,
        testId: "software-releases-launch-card.ui.version-dates.release-date-editable-date-picker"
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $57776e2f2bdc42ed$var$DateContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jPxD4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f30c73b914cd8ec$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8537225dbdb3f656ce85fc0d4ec98947>>
 * @relayHash 76fcdda26d5cebfbc0bdbfc7500aaba8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 77cad9e713773fc9731f7546654bb6829a888de63c65c65ad0484a7d7526abb5
const $6f30c73b914cd8ec$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "releaseDate"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "versionDates_updateVersionReleaseDateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionReleaseDate",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "versionDates_updateVersionReleaseDateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionReleaseDate",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "77cad9e713773fc9731f7546654bb6829a888de63c65c65ad0484a7d7526abb5",
            "metadata": {},
            "name": "versionDates_updateVersionReleaseDateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$6f30c73b914cd8ec$var$node.hash = "0404a02cdc80d06adbaaf61ada39552b";
var $6f30c73b914cd8ec$export$2e2bcd8739ae039 = $6f30c73b914cd8ec$var$node;

});

parcelRegister("guZiv", function(module, exports) {

$parcel$export(module.exports, "default", () => $56cb5aa6900e43ce$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dc667416605c45f4e9fb29c8594b350e>>
 * @relayHash 0f9f8a79d54b7bf69bd4ddc3c65a57b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c21a1f19ee00080fdbd0fc4853475b9e944bd3f18e9b98d9d5314b5ca267906
const $56cb5aa6900e43ce$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "startDate"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "versionDates_updateVersionStartDateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionStartDate",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "versionDates_updateVersionStartDateMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionStartDate",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3c21a1f19ee00080fdbd0fc4853475b9e944bd3f18e9b98d9d5314b5ca267906",
            "metadata": {},
            "name": "versionDates_updateVersionStartDateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$56cb5aa6900e43ce$var$node.hash = "9222866e01fe4d9b93a39fe2c827a3b0";
var $56cb5aa6900e43ce$export$2e2bcd8739ae039 = $56cb5aa6900e43ce$var$node;

});

parcelRegister("8Gql5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c97a62a27014dc7b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a7c6c5dbd8eb08f103adecc53342a48c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c97a62a27014dc7b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "versionDates_softwareReleasesLaunchCard",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "canEdit"
        },
        {
            "kind": "ScalarField",
            "name": "startDate"
        },
        {
            "kind": "ScalarField",
            "name": "releaseDate"
        }
    ],
    "type": "JiraVersion"
};
$c97a62a27014dc7b$var$node.hash = "4dcf74d53cdeafe5bdc663fa3f4c36e4";
var $c97a62a27014dc7b$export$2e2bcd8739ae039 = $c97a62a27014dc7b$var$node;

});

parcelRegister("75GNn", function(module, exports) {

$parcel$export(module.exports, "fireFieldUpdateErrorAnalytics", () => $2a20f35766e48831$export$f84dee30e0e69629);

var $jcw0u = parcelRequire("jcw0u");
const $2a20f35766e48831$export$f84dee30e0e69629 = ()=>{
    (0, $jcw0u.default)({
        meta: {
            id: 'jira.releases.launch.card.update.version.field.mutation.error.id',
            packageName: 'jiraSoftwareReleasesLaunchCard',
            teamName: 'nova'
        },
        error: Error('Unable to update version'),
        sendToPrivacyUnsafeSplunk: true
    });
};

});

parcelRegister("16Op0", function(module, exports) {

$parcel$export(module.exports, "AsyncEditableDatePicker", () => $16268c5aa65eca45$export$e5d82c99aef790b1);
/* async.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2x3Cb = parcelRequire("2x3Cb");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $ebBt7 = parcelRequire("ebBt7");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $16268c5aa65eca45$var$LazyEditableDatePicker = (0, $kxZPA.lazy)(()=>(parcelRequire("eg6PE")).then((module)=>module.EditableDatePicker), {
    moduleId: "./src/packages/releases/launch-card/src/ui/version-dates/editable-date-picker/EditableDatePicker.tsx"
});
const $16268c5aa65eca45$export$e5d82c99aef790b1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "editable-date-picker",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($16268c5aa65eca45$export$66b8cea0c448285, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
            htmlFor: "version-details-editable-date-picker"
        }, props.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($16268c5aa65eca45$var$InlineEditReadViewContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ebBt7.DatePickerReadView), {
            displayDate: props.displayDate
        })))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($16268c5aa65eca45$var$LazyEditableDatePicker, props));
const $16268c5aa65eca45$export$66b8cea0c448285 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul91lit _otyru2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $16268c5aa65eca45$var$InlineEditReadViewContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_189eyh40 _1dqonqa1 _1h6d3acm _vwz4kb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ebBt7", function(module, exports) {

$parcel$export(module.exports, "DatePickerReadView", () => $65cc78a7ac340b41$export$e9b589e36300c388);
/* DatePickerReadView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $65cc78a7ac340b41$export$e9b589e36300c388 = ({ displayDate: displayDate, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($65cc78a7ac340b41$var$ReadViewContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($65cc78a7ac340b41$var$ReadViewItem, {
        "data-testid": testId
    }, displayDate));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $65cc78a7ac340b41$var$ReadViewContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _1ul91qr7 _ca0qu2gc _u5f3idpf _n3tdu2gc _19bvidpf",
            __cmplp.className
        ])
    });
});
const $65cc78a7ac340b41$var$ReadViewItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_u5f31b66",
            __cmplp.className
        ])
    });
});

});

parcelRegister("eg6PE", function(module, exports) {

let $a617dc0372f01a65$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a617dc0372f01a65$var$load("liNtV").then(()=>parcelRequire('395L3'));

});


parcelRegister("dyMGB", function(module, exports) {

$parcel$export(module.exports, "convertDatetimeToDate", () => $7dfd1c2586132c51$export$f2eb3c0da1d3f89e);

var $k7m40 = parcelRequire("k7m40");
var $jovBr = parcelRequire("jovBr");
const $7dfd1c2586132c51$export$f2eb3c0da1d3f89e = (startDate)=>startDate != null && (0, $jovBr.default)(new Date(startDate)) ? (0, $k7m40.default)(new Date(startDate), 'yyyy-MM-dd') : '';

});

parcelRegister("7RQHY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c45859eb177b61d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3c45859eb177b61d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    startDateNotSet: {
        "id": "software-releases-launch-card.version-dates.start-date-not-set",
        "defaultMessage": "Start date not set"
    },
    releaseDateNotSet: {
        "id": "software-releases-launch-card.version-dates.release-date-not-set",
        "defaultMessage": "Release date not set"
    },
    startDateFieldLabel: {
        "id": "software-releases-launch-card.version-dates.start-date-field-label",
        "defaultMessage": "Start date"
    },
    startDateGenericErrorFlagTitle: {
        "id": "software-releases-launch-card.version-dates.start-date-generic-error-flag-title",
        "defaultMessage": "We couldn't update the start date"
    },
    badReleaseStartDateOrderErrorFlagTitle: {
        "id": "software-releases-launch-card.version-dates.bad-release-start-date-order-error-flag-title",
        "defaultMessage": "The start date cannot be after the release date"
    },
    badReleaseStartDateOrderErrorFlagDescription: {
        "id": "software-releases-launch-card.version-dates.bad-release-start-date-order-error-flag-description",
        "defaultMessage": "Please select a different start date."
    },
    releaseDateFieldLabel: {
        "id": "software-releases-launch-card.version-dates.release-date-field-label",
        "defaultMessage": "Release date"
    },
    releaseDateErrorFlagTitle: {
        "id": "software-releases-launch-card.version-dates.release-date-error-flag-title",
        "defaultMessage": "We couldn't update the release date"
    },
    genericErrorFlagDescription: {
        "id": "software-releases-launch-card.version-dates.generic-error-flag-description",
        "defaultMessage": "Something went wrong. Please try again or contact your administrator if the problem persists."
    }
});

});


parcelRegister("lFoXK", function(module, exports) {

$parcel$export(module.exports, "AsyncVersionStatus", () => $7c7501660c6c65ae$export$f6bcf9d2a3221dfb);

var $eCweN = parcelRequire("eCweN");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $bT8J9 = parcelRequire("bT8J9");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7c7501660c6c65ae$var$LazyVersionStatus = (0, $kxZPA.lazy)(()=>Promise.resolve((parcelRequire("bT8J9"))).then((module)=>module.VersionStatus), {
    moduleId: "./src/packages/releases/launch-card/src/ui/version-status/index.tsx"
});
const $7c7501660c6c65ae$export$f6bcf9d2a3221dfb = ({ jiraVersion: jiraVersion })=>{
    const version = (0, $8Uumt.useFragment)((0, $eCweN.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "version-status",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c7501660c6c65ae$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), null, (0, $bT8J9.GetCurrentStatusLabel)(version.status)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c7501660c6c65ae$var$LazyVersionStatus, {
        jiraVersion: version
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c7501660c6c65ae$var$SkeletonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bsb1osq _4t3i1ylp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eCweN", function(module, exports) {

$parcel$export(module.exports, "default", () => $94edbaa1df4c3e8c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5ef6fed889609df73bcc4587dc5f0110>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $94edbaa1df4c3e8c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "async_softwareReleasesLaunchCard_AsyncVersionStatus",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "status"
            },
            "action": "THROW",
            "path": "status"
        },
        {
            "kind": "FragmentSpread",
            "name": "versionStatus_softwareReleasesLaunchCard"
        }
    ],
    "type": "JiraVersion"
};
$94edbaa1df4c3e8c$var$node.hash = "bbfb4743758d7a0f5d5885118b67b179";
var $94edbaa1df4c3e8c$export$2e2bcd8739ae039 = $94edbaa1df4c3e8c$var$node;

});

parcelRegister("bT8J9", function(module, exports) {

$parcel$export(module.exports, "GetCurrentStatusLabel", () => $7254dcd52a39f897$export$3e6be0c31593f3c4);
$parcel$export(module.exports, "VersionStatus", () => $7254dcd52a39f897$export$8c6e0f93bfb5c6a4);

var $7lDAS = parcelRequire("7lDAS");

var $1gEiV = parcelRequire("1gEiV");

var $35PYc = parcelRequire("35PYc");

var $joKO7 = parcelRequire("joKO7");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $kEVMo = parcelRequire("kEVMo");

var $2rqOp = parcelRequire("2rqOp");

var $ky7e4 = parcelRequire("ky7e4");

var $i8Qvm = parcelRequire("i8Qvm");

var $bChGW = parcelRequire("bChGW");
var $b9dFI = parcelRequire("b9dFI");

var $jcw0u = parcelRequire("jcw0u");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $lfTZh = parcelRequire("lfTZh");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $hlRDe = parcelRequire("hlRDe");

var $kfztd = parcelRequire("kfztd");

var $4i1Dv = parcelRequire("4i1Dv");

var $kKpgF = parcelRequire("kKpgF");

var $DVljb = parcelRequire("DVljb");

var $lqWUw = parcelRequire("lqWUw");

var $gBkhv = parcelRequire("gBkhv");

var $cbARR = parcelRequire("cbARR");

var $63h61 = parcelRequire("63h61");
const $7254dcd52a39f897$var$overrideComponents = {
    Option: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, {
            ...props,
            className: (0, $bwpsq.default)([
                "_1695idpf _1pnsidpf _vktqidpf _1byqidpf"
            ])
        })
};
const $7254dcd52a39f897$var$CustomOptionLabel = ({ label: label, value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7254dcd52a39f897$var$VersionStatusOptionLabel, {
        isArchiveOption: value === (0, $gBkhv.ARCHIVED)
    }, label);
const $7254dcd52a39f897$export$3e6be0c31593f3c4 = (currentStatusValue)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    switch(currentStatusValue){
        case 0, $gBkhv.ARCHIVED:
            return formatMessage((0, $63h61.default).archivedLabel);
        case 0, $gBkhv.RELEASED:
            return formatMessage((0, $63h61.default).releasedLabel);
        case 0, $gBkhv.UNRELEASED:
            return formatMessage((0, $63h61.default).unreleasedLabel);
        default:
            return formatMessage((0, $63h61.default).unreleasedLabel);
    }
};
const $7254dcd52a39f897$var$getHasReleaseNote = async (versionId, environment)=>{
    try {
        const data = await (0, $8Uumt.fetchQuery)(environment, (0, $joKO7.default), {
            versionId: versionId
        }).toPromise();
        return data?.jira?.version?.hasReleaseNote ?? false;
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'jiraLaunchCardHasReleaseNoteQuery',
                packageName: 'jiraVersionLaunchCard',
                teamName: 'nova'
            },
            error: new Error('Unable to get "hasReleaseNote" for "release version" modal')
        });
        return false;
    }
};
const $7254dcd52a39f897$var$useHasReleaseNote = (versionId, shouldLoadHasReleaseNote)=>{
    const [hasReleaseNote, setHasReleaseNote] = (0, $5uXOq.useState)(null);
    const environment = (0, $8Uumt.useRelayEnvironment)();
    (0, $5uXOq.useEffect)(()=>{
        if (shouldLoadHasReleaseNote) $7254dcd52a39f897$var$getHasReleaseNote(versionId, environment).then(setHasReleaseNote);
    }, [
        versionId,
        environment,
        shouldLoadHasReleaseNote
    ]);
    return hasReleaseNote;
};
const $7254dcd52a39f897$export$8c6e0f93bfb5c6a4 = ({ jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isReleasedModalOpen, setIsReleaseModalOpen] = (0, $5uXOq.useState)(false);
    const { refetch: refetch, isLoading: isRefetchLoading } = (0, $kKpgF.useRefetchContext)();
    const locale = (0, $DVljb.useLocale)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const [selectWidth, setSelectWidth] = (0, $5uXOq.useState)(undefined); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const selectRef = (0, $5uXOq.useRef)();
    const [isReleaseNotesModalOpen, setIsReleaseNotesModalOpen] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (selectRef.current) setSelectWidth(selectRef.current.offsetWidth);
    }, []);
    const version = (0, $8Uumt.useFragment)((0, $35PYc.default), jiraVersion);
    const hasReleaseNote = $7254dcd52a39f897$var$useHasReleaseNote(version.id, !(0, $kfztd.isDevopsFeatureDisabledInFedRamp)());
    const isVersionReleased = version.status === (0, $gBkhv.RELEASED);
    const [updateVersionReleased] = (0, $8Uumt.useMutation)((0, $1gEiV.default));
    const [updateVersionArchived, isUpdateArchivedLoading] = (0, $8Uumt.useMutation)((0, $7lDAS.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [releaseNotesQueryReference, loadReleaseNotesQuery] = (0, $8Uumt.useQueryLoader)((0, $hlRDe.default));
    const loadReleaseNoteModalResource = ()=>{
        loadReleaseNotesQuery({
            versionAri: version.id
        }, {
            fetchPolicy: 'store-and-network'
        });
    };
    const isLoading = isUpdateArchivedLoading || isRefetchLoading;
    const releaseOptions = [
        {
            label: formatMessage((0, $63h61.default).releaseOptionLabel),
            value: (0, $gBkhv.RELEASED)
        },
        {
            label: formatMessage((0, $63h61.default).unreleaseOptionLabel),
            value: (0, $gBkhv.UNRELEASED)
        },
        {
            label: formatMessage((0, $63h61.default).archiveOptionLabel),
            value: (0, $gBkhv.ARCHIVED)
        }
    ];
    const archiveOptions = [
        {
            label: formatMessage((0, $63h61.default).unarchiveOptionLabel),
            value: (0, $gBkhv.UNARCHIVED)
        }
    ];
    const currentOptions = version.status === (0, $gBkhv.ARCHIVED) ? archiveOptions : releaseOptions;
    const getCurrentValue = (currentStatusValue)=>[
            ...releaseOptions,
            ...archiveOptions
        ].find((option)=>option.value === currentStatusValue);
    const handleChange = (option)=>{
        if (option === null) return;
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'selected',
            actionSubject: 'option'
        }), option.value);
        switch(option.value){
            case 0, $gBkhv.RELEASED:
                setIsReleaseModalOpen(true);
                if (!(0, $kfztd.isDevopsFeatureDisabledInFedRamp)()) loadReleaseNoteModalResource();
                break;
            case 0, $gBkhv.UNRELEASED:
                updateVersionReleased({
                    variables: {
                        input: {
                            id: version.id,
                            isReleased: false
                        }
                    },
                    onError: ()=>{
                        (0, $jcw0u.default)({
                            meta: {
                                id: 'jira.releases.launch.card.update.released.mutation.error.id',
                                packageName: 'jiraSoftwareReleasesLaunchCard',
                                teamName: 'nova'
                            },
                            error: new Error('Unable to update version released status'),
                            sendToPrivacyUnsafeSplunk: true
                        });
                        showFlag({
                            type: 'error',
                            title: (0, $63h61.default).genericUpdateFailedFlagTitle,
                            description: (0, $63h61.default).releaseFailedFlagDescription,
                            messageId: 'software-releases-launch-card.ui.version-status.show-flag.error.unreleased.on-error.show-flag.error',
                            messageType: 'transactional'
                        });
                    },
                    optimisticResponse: {
                        jira: {
                            updateVersionReleasedStatus: {
                                success: true,
                                version: {
                                    id: version.id,
                                    status: option.value
                                }
                            }
                        }
                    }
                });
                break;
            case 0, $gBkhv.ARCHIVED:
            case 0, $gBkhv.UNARCHIVED:
                updateVersionArchived({
                    variables: {
                        input: {
                            id: version.id,
                            isArchived: option.value === (0, $gBkhv.ARCHIVED)
                        }
                    },
                    onError: ()=>{
                        (0, $jcw0u.default)({
                            meta: {
                                id: 'jira.releases.launch.card.update.archived.mutation.error.id',
                                packageName: 'jiraSoftwareReleasesLaunchCard',
                                teamName: 'nova'
                            },
                            error: new Error('Unable to update version archived status'),
                            sendToPrivacyUnsafeSplunk: true
                        });
                        showFlag({
                            type: 'error',
                            title: (0, $63h61.default).genericUpdateFailedFlagTitle,
                            description: (0, $63h61.default).archiveFailedFlagDescription,
                            messageId: 'software-releases-launch-card.ui.version-status.show-flag.error.unarchived.on-errorshow-flag.error',
                            messageType: 'transactional'
                        });
                    }
                });
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7254dcd52a39f897$var$Container, {
        ref: selectRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9dFI.default), {
        hideSelectedOptions: true,
        components: $7254dcd52a39f897$var$overrideComponents,
        formatOptionLabel: $7254dcd52a39f897$var$CustomOptionLabel,
        minMenuWidth: `${selectWidth}px`,
        onChange: handleChange,
        options: currentOptions,
        target: ({ isOpen: isOpen, ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7254dcd52a39f897$var$StyledLoadingButton, {
                ...triggerProps,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kEVMo))), {
                    spacing: "spacious",
                    label: formatMessage((0, $63h61.default).buttonLabel),
                    size: "small"
                }),
                isDisabled: !version.canEdit,
                isLoading: isLoading,
                isSelected: isOpen,
                ref: ref,
                released: isVersionReleased && !isOpen ? 1 : 0,
                shouldFitContainer: true,
                onClick: (_, analyticsEvent)=>(0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'versionStatusDropdown')
            }, isVersionReleased ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7254dcd52a39f897$var$ReleasedContentWrapper, null, $7254dcd52a39f897$export$3e6be0c31593f3c4(version.status), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7254dcd52a39f897$var$ReleaseSucceededIcon, null)) : $7254dcd52a39f897$export$3e6be0c31593f3c4(version.status)),
        value: getCurrentValue(version.status)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cbARR.NonCriticalErrorBoundary), {
        eventLocation: "releaseNotesModal",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "release-notes-modal",
        fallback: null
    }, isReleaseNotesModalOpen && releaseNotesQueryReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4i1Dv.ReleaseNotesModal), {
        queryReference: releaseNotesQueryReference,
        onClose: ()=>setIsReleaseNotesModalOpen(false)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isReleasedModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lqWUw.default // eslint-disable-next-line jira/deprecations/no-base-url
    ), {
        baseUrl: "" // @ts-expect-error - TS2322 - Type '{ locale: Locale; projectKey: string; versionId: string; onOpened: (...args: any[]) => void; onCancel: () => void; onSuccess: () => void; onError: () => void; }' is not assignable to type 'IntrinsicAttributes & StateProps & Handlers & { children?: ReactNode; }'.
        ,
        locale: locale,
        projectKey: version.project.key,
        versionId: version.versionId,
        onOpened: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onCancel: ()=>{
            setIsReleaseModalOpen(false);
        },
        onSuccess: (_updatedVersion, params)=>{
            refetch();
            setIsReleaseModalOpen(false);
            if (params && params.shouldRedirectToCreateReleaseNotes) setIsReleaseNotesModalOpen(true);
        },
        onError: ()=>{
            showFlag({
                type: 'error',
                title: formatMessage((0, $63h61.default).genericUpdateFailedFlagTitle),
                description: formatMessage((0, $63h61.default).releaseFailedFlagDescription),
                messageId: 'software-releases-launch-card.ui.version-status.show-flag.error.release-modal.on-error.show-flag.error',
                messageType: 'transactional'
            });
            (0, $jcw0u.default)({
                error: new Error('Failed to release the version'),
                meta: {
                    id: 'versionDetailsLaunchCardReleaseModal',
                    packageName: 'jiraSoftwareReleasesLaunchCard',
                    teamName: 'nova'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        },
        shouldShowCreateReleaseNotesOption: !(0, $kfztd.isDevopsFeatureDisabledInFedRamp)(),
        hasReleaseNote: hasReleaseNote ?? false
    })));
};
const $7254dcd52a39f897$var$ReleaseSucceededIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ky7e4))), {
        label: "",
        color: $7254dcd52a39f897$export$a7643b841a7da7eb,
        LEGACY_size: "small"
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
const $7254dcd52a39f897$var$styles = null;
const $7254dcd52a39f897$var$RELEASED_BACKGROUND_COLOR = "var(--ds-background-success, #DCFFF1)"; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7254dcd52a39f897$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7254dcd52a39f897$var$ReleasedContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _4cvr1h6o _1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $7254dcd52a39f897$export$a7643b841a7da7eb = "var(--ds-text, #172B4D)"; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7254dcd52a39f897$var$StyledLoadingButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $2rqOp.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_15s31ylp _1ilx1txw _ubnr1h6o",
            __cmplp.released && "_biklmv6i",
            __cmplp.released && "_1gty1fxt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7254dcd52a39f897$var$VersionStatusOptionLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isArchiveOption: isArchiveOption, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _80omtlke _1e0c1txw _ca0qu2gc _u5f31ejb _n3tdu2gc _19bv1ejb",
            __cmplp.isArchiveOption ? "_x3doudwz" : "_x3doglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7lDAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $850130315c77c46d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f27e7443d050ab4137264e6846e36fe6>>
 * @relayHash 340d4f5f070919a0755dcf2816c6e362
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c6513ea034d4c8ea62a2e9887bcaa685c8b2fcb46147be3044a62ff69effec49
const $850130315c77c46d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "status"
    }, v4 = {
        "kind": "ScalarField",
        "name": "canAddAndRemoveIssues"
    }, v5 = {
        "kind": "ScalarField",
        "name": "canEditRelatedWork"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "versionStatus_updateVersionArchivedMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionArchivedStatus",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "versionStatus_updateVersionArchivedMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionArchivedStatus",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c6513ea034d4c8ea62a2e9887bcaa685c8b2fcb46147be3044a62ff69effec49",
            "metadata": {},
            "name": "versionStatus_updateVersionArchivedMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$850130315c77c46d$var$node.hash = "3e4bee8708d54a5a32d8530c63b327c7";
var $850130315c77c46d$export$2e2bcd8739ae039 = $850130315c77c46d$var$node;

});

parcelRegister("1gEiV", function(module, exports) {

$parcel$export(module.exports, "default", () => $89bc4c47fdb74222$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d39098cd4aca8ffd1c5445682305611d>>
 * @relayHash 08bc9d2a69bd2c858ab39655b3facfa0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 71ceeb655014e9c61184f72a862fcc1e2ce71afe4bf7f9accabc37395bc9d079
const $89bc4c47fdb74222$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "status"
    }, v4 = {
        "kind": "ScalarField",
        "name": "canAddAndRemoveIssues"
    }, v5 = {
        "kind": "ScalarField",
        "name": "canEditRelatedWork"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "versionStatus_updateVersionReleasedMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionReleasedStatus",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "versionStatus_updateVersionReleasedMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionReleasedStatus",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "71ceeb655014e9c61184f72a862fcc1e2ce71afe4bf7f9accabc37395bc9d079",
            "metadata": {},
            "name": "versionStatus_updateVersionReleasedMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$89bc4c47fdb74222$var$node.hash = "0608e97fa861a9ec4da08bc961c0e4d0";
var $89bc4c47fdb74222$export$2e2bcd8739ae039 = $89bc4c47fdb74222$var$node;

});

parcelRegister("35PYc", function(module, exports) {

$parcel$export(module.exports, "default", () => $15ae054e75fb118a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<992a2c0fb5f90375a2f7cabfc8fc6822>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $15ae054e75fb118a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "versionStatus_softwareReleasesLaunchCard",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "versionId"
            },
            "action": "THROW",
            "path": "versionId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "status"
            },
            "action": "THROW",
            "path": "status"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        "action": "THROW",
                        "path": "project.key"
                    }
                ]
            },
            "action": "THROW",
            "path": "project"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "canEdit"
            },
            "action": "THROW",
            "path": "canEdit"
        }
    ],
    "type": "JiraVersion"
};
$15ae054e75fb118a$var$node.hash = "7085e7fbc51810607ae42a94bf5c14e4";
var $15ae054e75fb118a$export$2e2bcd8739ae039 = $15ae054e75fb118a$var$node;

});

parcelRegister("joKO7", function(module, exports) {

$parcel$export(module.exports, "default", () => $503f3f81f4b6660c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<458c3aa9108b357d04885dae908b4e3e>>
 * @relayHash c82d4bc74d3968b5677f2b4e7e151b40
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8d8191dfb21f183308ae9bfac528d60fcd67480a7ca1b48be8e339480044e138
const $503f3f81f4b6660c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionId"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasReleaseNote"
            }
        ],
        "type": "JiraVersion"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "versionStatus_versionHasReleaseNoteQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "versionStatus_versionHasReleaseNoteQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8d8191dfb21f183308ae9bfac528d60fcd67480a7ca1b48be8e339480044e138",
            "metadata": {},
            "name": "versionStatus_versionHasReleaseNoteQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$503f3f81f4b6660c$var$node.hash = "ac12222b76ff5150d612ed35c9605c2c";
var $503f3f81f4b6660c$export$2e2bcd8739ae039 = $503f3f81f4b6660c$var$node;

});

parcelRegister("ky7e4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4eca488eebd24f6b0c74ed2566069d9c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef5c96854bbf6178$var$_react = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ef5c96854bbf6178$var$_checkMark = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("bjo8S")));

var $ef5c96854bbf6178$var$_check = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("kbxJz")));
function $ef5c96854bbf6178$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "CheckIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ef5c96854bbf6178$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $ef5c96854bbf6178$var$_react.default.createElement($ef5c96854bbf6178$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $ef5c96854bbf6178$var$_check.default
    }, props));
$ef5c96854bbf6178$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $ef5c96854bbf6178$var$_default = module.exports.default = $ef5c96854bbf6178$var$CheckMarkIcon;

});
parcelRegister("bjo8S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $83c43234bc70a485$var$_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $83c43234bc70a485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83c43234bc70a485$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;

});

parcelRegister("kbxJz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb1f0098e5a023eb$var$_react = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $eb1f0098e5a023eb$var$_checkMark = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $eb1f0098e5a023eb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eb1f0098e5a023eb$var$CheckIcon = (props)=>/*#__PURE__*/ $eb1f0098e5a023eb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $eb1f0098e5a023eb$var$_checkMark.default
    }));
$eb1f0098e5a023eb$var$CheckIcon.displayName = 'CheckIcon';
var $eb1f0098e5a023eb$var$_default = module.exports.default = $eb1f0098e5a023eb$var$CheckIcon;

});


parcelRegister("hlRDe", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9a3cf061de648cd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eff6bbb8fd1c5cbef9a0b7352a9b5a38>>
 * @relayHash 1abf975667e0c9ee5b3f2be70e2c73a1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e7ac237c42a6f8772ca697f1e101e98fdbe98411d3c61d3395eb3afa396b6eb0
const $c9a3cf061de648cd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "releaseNoteConfiguration"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "canEditRelatedWork"
    }, v6 = {
        "kind": "ScalarField",
        "name": "releasesNotesPreferenceType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "issueKeyConfig"
    }, v8 = {
        "kind": "ScalarField",
        "name": "issueFieldIds"
    }, v9 = {
        "kind": "ScalarField",
        "name": "issueTypeIds"
    }, v10 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v11 = [
        {
            "kind": "Variable",
            "name": "releaseNoteConfiguration",
            "variableName": "releaseNoteConfiguration"
        }
    ], v12 = {
        "kind": "ScalarField",
        "name": "isSystem"
    }, v13 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v14 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    }, v15 = {
        "kind": "ScalarField",
        "name": "name"
    }, v16 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v17 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v18 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v19 = [
        {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                v18 /*: any*/ ,
                v17 /*: any*/ 
            ]
        },
        {
            "concreteType": "JiraIssueFieldEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v15 /*: any*/ 
                    ]
                },
                v16 /*: any*/ 
            ]
        }
    ], v20 = [
        "searchString"
    ], v21 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiReleaseNotesModalQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v4 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.version.id"
                                                },
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraReleaseNotesConfiguration",
                                                        "kind": "LinkedField",
                                                        "name": "releaseNotesConfiguration",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v7 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "jira.version.releaseNotesConfiguration.issueKeyConfig"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v8 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "jira.version.releaseNotesConfiguration.issueFieldIds"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v9 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "jira.version.releaseNotesConfiguration.issueTypeIds"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.version.releaseNotesConfiguration"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "args": v10 /*: any*/ ,
                                                        "concreteType": "JiraIssueTypeConnection",
                                                        "kind": "LinkedField",
                                                        "name": "releaseNotesOptionsIssueTypes",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "concreteType": "JiraIssueTypeEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "FragmentSpread",
                                                                            "name": "ui_softwareReleasesAddReleaseNotesModal_ReleaseNotesModal_jiraIssueTypeEdges"
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "THROW",
                                                                "path": "jira.version.releaseNotesOptionsIssueTypes.edges"
                                                            }
                                                        ],
                                                        "storageKey": "releaseNotesOptionsIssueTypes(first:100)"
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.version.releaseNotesOptionsIssueTypes"
                                                },
                                                {
                                                    "args": v11 /*: any*/ ,
                                                    "kind": "FragmentSpread",
                                                    "name": "ui_softwareReleasesAddReleaseNotesModal_ReleaseNotesModalContent_version"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "formattingOptions_softwareReleasesAddReleaseNotesModal"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "embeddedPageReleaseNotes_softwareReleasesAddReleaseNotesModal_EmbeddedPageReleaseNotesModal"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "analyticsContext_softwareReleasesAddReleaseNotesModal_ReleaseNotesModalAnalyticsContext"
                                                },
                                                {
                                                    "concreteType": "JiraReleaseNotesInConfluenceAvailableSitesConnection",
                                                    "kind": "LinkedField",
                                                    "name": "availableSites",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "JiraReleaseNotesInConfluenceAvailableSitesEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "concreteType": "JiraReleaseNotesInConfluenceAvailableSite",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v12 /*: any*/ ,
                                                                                    "action": "LOG",
                                                                                    "path": "jira.version.availableSites.edges.node.isSystem"
                                                                                }
                                                                            ]
                                                                        },
                                                                        "action": "LOG",
                                                                        "path": "jira.version.availableSites.edges.node"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "LOG",
                                                            "path": "jira.version.availableSites.edges"
                                                        }
                                                    ]
                                                },
                                                v13 /*: any*/ 
                                            ],
                                            "type": "JiraVersion"
                                        },
                                        v14 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.version"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiReleaseNotesModalQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "concreteType": "JiraReleaseNotesConfiguration",
                                            "kind": "LinkedField",
                                            "name": "releaseNotesConfiguration",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "JiraIssueTypeConnection",
                                            "kind": "LinkedField",
                                            "name": "releaseNotesOptionsIssueTypes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueTypeEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v15 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAvatar",
                                                                    "kind": "LinkedField",
                                                                    "name": "avatar",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "xsmall"
                                                                        }
                                                                    ]
                                                                },
                                                                v3 /*: any*/ 
                                                            ]
                                                        },
                                                        v16 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "releaseNotesOptionsIssueTypes(first:100)"
                                        },
                                        {
                                            "args": v10 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "issueTypeSelector_releaseNotesOptionsIssueTypes",
                                            "kind": "LinkedHandle",
                                            "name": "releaseNotesOptionsIssueTypes"
                                        },
                                        {
                                            "args": v11 /*: any*/ ,
                                            "concreteType": "JiraADF",
                                            "kind": "LinkedField",
                                            "name": "releaseNotes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "json"
                                                }
                                            ]
                                        },
                                        {
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldConnection",
                                            "kind": "LinkedField",
                                            "name": "releaseNotesOptionsIssueFields",
                                            "plural": false,
                                            "selections": v19 /*: any*/ ,
                                            "storageKey": "releaseNotesOptionsIssueFields(first:100)"
                                        },
                                        {
                                            "args": v10 /*: any*/ ,
                                            "filters": v20 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "issueFieldSelectors_releaseNotesOptionsIssueFields",
                                            "kind": "LinkedHandle",
                                            "name": "releaseNotesOptionsIssueFields"
                                        },
                                        {
                                            "args": v21 /*: any*/ ,
                                            "concreteType": "JiraIssueFieldConnection",
                                            "kind": "LinkedField",
                                            "name": "nativeReleaseNotesOptionsIssueFields",
                                            "plural": false,
                                            "selections": v19 /*: any*/ ,
                                            "storageKey": "nativeReleaseNotesOptionsIssueFields(first:10)"
                                        },
                                        {
                                            "args": v21 /*: any*/ ,
                                            "filters": v20 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "issueFieldSelectors_nativeReleaseNotesOptionsIssueFields",
                                            "kind": "LinkedHandle",
                                            "name": "nativeReleaseNotesOptionsIssueFields"
                                        },
                                        {
                                            "concreteType": "JiraReleaseNotesInConfluenceAvailableSitesConnection",
                                            "kind": "LinkedField",
                                            "name": "availableSites",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraReleaseNotesInConfluenceAvailableSitesEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraReleaseNotesInConfluenceAvailableSite",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v12 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v13 /*: any*/ 
                                    ],
                                    "type": "JiraVersion"
                                },
                                v14 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e7ac237c42a6f8772ca697f1e101e98fdbe98411d3c61d3395eb3afa396b6eb0",
            "metadata": {},
            "name": "uiReleaseNotesModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c9a3cf061de648cd$var$node.hash = "b8c5823683fa1dc8a3117a965fb8027e";
var $c9a3cf061de648cd$export$2e2bcd8739ae039 = $c9a3cf061de648cd$var$node;

});

parcelRegister("4i1Dv", function(module, exports) {

$parcel$export(module.exports, "ReleaseNotesModal", () => $4e0db3a273624333$export$d334132901e7fcb2);
/* async.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7QSqG = parcelRequire("7QSqG");

var $eZJjh = parcelRequire("eZJjh");

var $9fuVs = parcelRequire("9fuVs");

var $7NYq5 = parcelRequire("7NYq5");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4e0db3a273624333$var$LazyReleaseNotesModalContent = (0, $kxZPA.lazy)(()=>(parcelRequire("9urma")).then((module)=>module.ReleaseNotesModalContent), {
    moduleId: "./src/packages/releases/release-notes-modal/src/ui/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4e0db3a273624333$var$LazyEmbeddedPageReleaseNotesEditorModal = (0, $kxZPA.lazy)(()=>(parcelRequire("kOi0f")).then((module)=>module.EmbeddedPageReleaseNotesEditorModal), {
    moduleId: "./src/packages/releases/release-notes-modal/src/ui/embedded-page-release-notes-editor-modal/EmbeddedPageReleaseNotesEditorModal.tsx"
});
const $4e0db3a273624333$var$LoadingModalBody = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e0db3a273624333$export$43a792a870d28db2, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "large"
    })));
const $4e0db3a273624333$export$d334132901e7fcb2 = (props)=>{
    const [confluenceReleaseNotesDraftUrl, setConfluenceReleaseNotesDraftUrl] = (0, $5uXOq.useState)(null);
    const { onClose: onClose } = props;
    const onCreateConfluenceReleaseNotes = (0, $5uXOq.useCallback)((draftUrl)=>{
        setConfluenceReleaseNotesDraftUrl(draftUrl);
    }, []);
    const onCloseConfluenceReleaseNotes = (0, $5uXOq.useCallback)(()=>{
        setConfluenceReleaseNotesDraftUrl(null);
        onClose();
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, confluenceReleaseNotesDraftUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e0db3a273624333$var$LazyEmbeddedPageReleaseNotesEditorModal, {
        draftUrl: confluenceReleaseNotesDraftUrl,
        onClose: onCloseConfluenceReleaseNotes
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        width: "x-large",
        autoFocus: false,
        onClose: onClose,
        messageId: "software-releases-add-release-notes-modal.ui.modal-dialog",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "release-notes-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e0db3a273624333$var$LoadingModalBody, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e0db3a273624333$var$LazyReleaseNotesModalContent, {
        ...props,
        onCreateConfluenceReleaseNotes: onCreateConfluenceReleaseNotes
    }))));
};
const $4e0db3a273624333$export$43a792a870d28db2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1kdj",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9urma", function(module, exports) {

let $6e8c22d5341a7c72$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6e8c22d5341a7c72$var$load("7Vw8j").then(()=>parcelRequire('lk3mD'));

});

parcelRegister("kOi0f", function(module, exports) {

let $f2667127617cea2b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f2667127617cea2b$var$load("lUL6U").then(()=>parcelRequire('faw0e'));

});


parcelRegister("lqWUw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b15b9ab9c95e18c3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aB8eX = parcelRequire("aB8eX");

var $jD5no = parcelRequire("jD5no");

var $9pe79 = parcelRequire("9pe79");

var $bxJen = parcelRequire("bxJen");

var $3yLu1 = parcelRequire("3yLu1");

var $dGae8 = parcelRequire("dGae8");

var $6FZ5A = parcelRequire("6FZ5A");
class $b15b9ab9c95e18c3$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.store = (0, $dGae8.default)((0, $bxJen.default));
        this.setAppProps(this.props);
        this.store.dispatch((0, $3yLu1.initialRequest)(this.props.versionId));
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if ((0, $9pe79.default)(nextProps, this.props)) return;
        this.setAppProps(this.props);
    }
    setAppProps(props) {
        const { baseUrl: baseUrl, projectKey: projectKey, onOpened: onOpened, onError: onError, onSuccess: onSuccess, onCancel: onCancel, shouldShowCreateReleaseNotesOption: shouldShowCreateReleaseNotesOption = false, hasReleaseNote: hasReleaseNote = false } = props;
        this.store.dispatch((0, $aB8eX.batchActions)([
            (0, $3yLu1.setContext)({
                baseUrl: baseUrl,
                projectKey: projectKey
            }),
            (0, $3yLu1.setHandlers)({
                onOpened: onOpened,
                onError: onError,
                onSuccess: onSuccess,
                onCancel: onCancel
            }),
            (0, $3yLu1.setCreateReleaseNotesOptionConfig)({
                shouldShowCreateReleaseNotesOption: shouldShowCreateReleaseNotesOption,
                hasReleaseNote: hasReleaseNote
            })
        ]));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
            store: this.store,
            id: "versionReleaseModal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6FZ5A.default), null));
    }
}

});
parcelRegister("bxJen", function(module, exports) {

$parcel$export(module.exports, "default", () => $4baa4be00b04d5f9$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $5Lfyk = parcelRequire("5Lfyk");

var $cHY1X = parcelRequire("cHY1X");
var $4baa4be00b04d5f9$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $5Lfyk.initialRequestEpic), (0, $5Lfyk.fetchUnresolvedIssues), (0, $cHY1X.initialRequestSuccessEpic), (0, $5Lfyk.releaseVersionRequestEpic), (0, $cHY1X.releaseVersionRequestFailureEpic), (0, $cHY1X.releaseVersionRequestSuccessEpic));

});
parcelRegister("5Lfyk", function(module, exports) {

$parcel$export(module.exports, "initialRequestEpic", () => $45a7f90f7cc0949b$export$73dafa621a3e5eba);
$parcel$export(module.exports, "fetchUnresolvedIssues", () => $45a7f90f7cc0949b$export$5f5c175d78772606);
$parcel$export(module.exports, "releaseVersionRequestEpic", () => $45a7f90f7cc0949b$export$b327638b0f58ac49);
parcelRequire("fp4O3");
parcelRequire("9o0uh");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $gccSB = parcelRequire("gccSB");

var $fr1K2 = parcelRequire("fr1K2");

var $3NMrl = parcelRequire("3NMrl");

var $kVLXA = parcelRequire("kVLXA");

var $fsh9d = parcelRequire("fsh9d");


var $c42uT = parcelRequire("c42uT");

var $3yLu1 = parcelRequire("3yLu1");

var $ai3Yq = parcelRequire("ai3Yq");
const $45a7f90f7cc0949b$export$73dafa621a3e5eba = (action$, store)=>action$.ofType((0, $3yLu1.INITIAL_REQUEST)).mergeMap(({ payload: versionId })=>{
        const state = store.getState();
        const baseUrl = (0, $ai3Yq.getBaseUrl)(state);
        return (0, $kVLXA.Observable).fromPromise((0, $c42uT.getVersion)(baseUrl, versionId)).mergeMap((version)=>(0, $kVLXA.Observable).of((0, $3yLu1.initialRequestSuccess)(version))).catch((error)=>{
            (0, $fsh9d.logSafeErrorWithoutCustomerData)(error, 'project-directories.versions.release.ops.get.version', (0, $71a059cf91522abc$export$6c87c1302bf5163c));
            return (0, $kVLXA.Observable).of((0, $3yLu1.releaseVersionFailure)({
                id: versionId
            }));
        });
    });
const $45a7f90f7cc0949b$export$5f5c175d78772606 = (action$, store)=>action$.ofType((0, $3yLu1.INITIAL_REQUEST)).mergeMap(({ payload: versionId })=>{
        const state = store.getState();
        const baseUrl = (0, $ai3Yq.getBaseUrl)(state);
        return (0, $kVLXA.Observable).fromPromise((0, $c42uT.getUnresolvedIssues)(baseUrl, versionId)).mergeMap((unresolvedIssuesCount)=>(0, $kVLXA.Observable).of((0, $3yLu1.setUnreleasedIssuesCount)(unresolvedIssuesCount))).catch((error)=>{
            (0, $fsh9d.logSafeErrorWithoutCustomerData)(error, 'project-directories.versions.release.ops.get.getUnresolvedIssues', (0, $71a059cf91522abc$export$6c87c1302bf5163c));
            return (0, $kVLXA.Observable).empty();
        });
    });
const $45a7f90f7cc0949b$export$b327638b0f58ac49 = (action$, store)=>action$.ofType((0, $3yLu1.RELEASE_VERSION_REQUEST)).mergeMap(()=>{
        const state = store.getState();
        const baseUrl = (0, $ai3Yq.getBaseUrl)(state);
        const keepIssues = (0, $ai3Yq.isKeepingIssues)(state);
        const version = (0, $ai3Yq.getVersion)(state);
        const versionToRelease = keepIssues ? (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(version, 'moveUnfixedIssuesTo') : version;
        return (0, $kVLXA.Observable).fromPromise((0, $c42uT.releaseVersion)(baseUrl, versionToRelease)).mergeMap((releasedVersion)=>(0, $kVLXA.Observable).of((0, $3yLu1.releaseVersionSuccess)(releasedVersion)))// @ts-expect-error - TS2345 - Argument of type '(error: FetchError) => Observable<ReleaseVersionFailureAction> | Observable<ReleaseVersionValidationFailureAction>' is not assignable to parameter of type '(err: any, caught: Observable<ReleaseVersionSuccessAction>) => ObservableInput<ReleaseVersionFailureAction>'.
        .catch((error)=>{
            try {
                const errors = (0, (/*@__PURE__*/$parcel$interopDefault($3NMrl)))(JSON.parse(error.message).errors, [
                    'releaseDate',
                    'moveUnfixedIssuesTo'
                ]);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(errors)) return (0, $kVLXA.Observable).of((0, $3yLu1.releaseVersionValidationFailure)(errors));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
            /**/ }
            (0, $fsh9d.logSafeErrorWithoutCustomerData)(error, 'project-directories.versions.release.ops.release.version', (0, $71a059cf91522abc$export$6c87c1302bf5163c));
            // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            return (0, $kVLXA.Observable).of((0, $3yLu1.releaseVersionFailure)());
        });
    });

});
const $71a059cf91522abc$export$595d93fed3fb6b04 = 'jiraReleasesVersions';
const $71a059cf91522abc$export$6c87c1302bf5163c = 'directories.versions.error';

parcelRegister("c42uT", function(module, exports) {

$parcel$export(module.exports, "getVersion", () => $c81fe9e74b3610a0$export$c506eb22e615ba4a);
$parcel$export(module.exports, "getUnresolvedIssues", () => $c81fe9e74b3610a0$export$d98ed0fcfb679bfe);
$parcel$export(module.exports, "releaseVersion", () => $c81fe9e74b3610a0$export$b8e3d145af76ef26);
$parcel$export(module.exports, "useReleaseAutomationBanner", () => $c81fe9e74b3610a0$export$d9a4a1588da51f7c);

var $5uXOq = parcelRequire("5uXOq");

var $90yGq = parcelRequire("90yGq");

var $hhRBl = parcelRequire("hhRBl");

var $5Y6UB = parcelRequire("5Y6UB");

var $gCDZi = parcelRequire("gCDZi");

var $kMTMr = parcelRequire("kMTMr");

var $agk64 = parcelRequire("agk64");
const $c81fe9e74b3610a0$export$c506eb22e615ba4a = (baseUrl, versionId)=>(0, $hhRBl.getVersion)(baseUrl, versionId).then((0, $5Y6UB.transformVersion)).then((0, $kMTMr.addDefaultReleaseDate));
const $c81fe9e74b3610a0$export$d98ed0fcfb679bfe = (baseUrl, versionId)=>(0, $hhRBl.getUnresolvedIssuesCount)(baseUrl, versionId).then((0, $5Y6UB.transformUnresolvedIssuesCount));
const $c81fe9e74b3610a0$export$b8e3d145af76ef26 = (baseUrl, version)=>(0, $gCDZi.releaseVersion)(baseUrl, (0, $kMTMr.transformReleasableToRestVersion)(version)).then((0, $5Y6UB.transformVersion));
const $c81fe9e74b3610a0$export$d9a4a1588da51f7c = ()=>{
    const [showBanner, setShowBanner] = (0, $5uXOq.useState)(false);
    const accountId = (0, $90yGq.useAccountId)();
    (0, $5uXOq.useEffect)(()=>{
        if (accountId != null) (0, $agk64.getHasDismissedReleaseAutomationBanner)(accountId).then((hasDismissed)=>setShowBanner(!hasDismissed)).catch((0, $agk64.fireReleaseAutomationBannerError));
    }, [
        accountId
    ]);
    const dismissBanner = async ()=>{
        setShowBanner(false);
        if (accountId != null) await (0, $agk64.dismissReleaseAutomationBanner)(accountId).catch((0, $agk64.fireReleaseAutomationBannerError));
    };
    return {
        showBanner: showBanner,
        dismissBanner: dismissBanner
    };
};

});
parcelRegister("hhRBl", function(module, exports) {

$parcel$export(module.exports, "getVersionEndpointUrl", () => $8d02574a1b02ba22$export$9513b66f34c81f7d);
$parcel$export(module.exports, "getVersion", () => $8d02574a1b02ba22$export$c506eb22e615ba4a);
$parcel$export(module.exports, "getUnresolvedIssuesCount", () => $8d02574a1b02ba22$export$b7679bf23524baba);

var $7f4tk = parcelRequire("7f4tk");
const $8d02574a1b02ba22$export$9513b66f34c81f7d = (baseUrl, versionId)=>`/rest/api/2/version/${versionId}`;
const $8d02574a1b02ba22$export$18ba274da71f4912 = (baseUrl, versionId)=>`${$8d02574a1b02ba22$export$9513b66f34c81f7d(baseUrl, versionId)}?expand=issuesstatus`;
const $8d02574a1b02ba22$export$fdc7e642e6597237 = (baseUrl, versionId)=>`${$8d02574a1b02ba22$export$9513b66f34c81f7d(baseUrl, versionId)}/unresolvedIssueCount`;
const $8d02574a1b02ba22$export$c506eb22e615ba4a = (baseUrl, versionId)=>(0, $7f4tk.default)($8d02574a1b02ba22$export$18ba274da71f4912(baseUrl, versionId));
const $8d02574a1b02ba22$export$b7679bf23524baba = (baseUrl, versionId)=>(0, $7f4tk.default)($8d02574a1b02ba22$export$fdc7e642e6597237(baseUrl, versionId));

});

parcelRegister("5Y6UB", function(module, exports) {

$parcel$export(module.exports, "transformVersion", () => $62220a7fcc1eb582$export$390ab7123357e756);
$parcel$export(module.exports, "transformUnresolvedIssuesCount", () => $62220a7fcc1eb582$export$9c917bd1ad6cfd7f);

var $brjCS = parcelRequire("brjCS");
const $62220a7fcc1eb582$var$transformStatus = (archived, released)=>{
    if (archived) return 0, $brjCS.ARCHIVED;
    if (released) return 0, $brjCS.RELEASED;
    return 0, $brjCS.UNRELEASED;
};
const $62220a7fcc1eb582$var$transformIssuesStatus = ({ toDo: toDo, inProgress: inProgress, done: done })=>({
        toDo: toDo,
        inProgress: inProgress,
        done: done
    });
const $62220a7fcc1eb582$export$390ab7123357e756 = (restVersion)=>{
    const version = {
        id: restVersion.id,
        name: restVersion.name,
        description: restVersion.description ? restVersion.description : '',
        status: $62220a7fcc1eb582$var$transformStatus(restVersion.archived, restVersion.released),
        startDate: restVersion.startDate,
        releaseDate: restVersion.releaseDate,
        overdue: !!restVersion.overdue,
        projectId: restVersion.projectId
    };
    if (restVersion.issuesStatusForFixVersion) version.issuesStatus = $62220a7fcc1eb582$var$transformIssuesStatus(restVersion.issuesStatusForFixVersion);
    return version;
};
const $62220a7fcc1eb582$export$9c917bd1ad6cfd7f = (rest)=>rest.issuesUnresolvedCount;

});
parcelRegister("brjCS", function(module, exports) {

$parcel$export(module.exports, "RELEASED", () => $96a1491cb0f9d4eb$export$b983f2cb1f658a55);
$parcel$export(module.exports, "UNRELEASED", () => $96a1491cb0f9d4eb$export$cb459d726a8530a5);
$parcel$export(module.exports, "ARCHIVED", () => $96a1491cb0f9d4eb$export$c936349447a77fe0);
const $96a1491cb0f9d4eb$export$b983f2cb1f658a55 = 'RELEASED';
const $96a1491cb0f9d4eb$export$cb459d726a8530a5 = 'UNRELEASED';
const $96a1491cb0f9d4eb$export$c936349447a77fe0 = 'ARCHIVED';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$96a1491cb0f9d4eb$export$2e2bcd8739ae039 = [
    $96a1491cb0f9d4eb$export$b983f2cb1f658a55,
    $96a1491cb0f9d4eb$export$cb459d726a8530a5,
    $96a1491cb0f9d4eb$export$c936349447a77fe0
];

});


parcelRegister("gCDZi", function(module, exports) {

$parcel$export(module.exports, "releaseVersion", () => $24fa99d1c29a27de$export$b8e3d145af76ef26);

var $9RyXH = parcelRequire("9RyXH");

var $hhRBl = parcelRequire("hhRBl");
const $24fa99d1c29a27de$export$b8e3d145af76ef26 = (baseUrl, version)=>{
    const url = (0, $hhRBl.getVersionEndpointUrl)(baseUrl, version.id);
    return (0, $9RyXH.default)(url, {
        method: 'put',
        body: JSON.stringify({
            ...version
        })
    });
};

});
parcelRegister("9RyXH", function(module, exports) {

$parcel$export(module.exports, "default", () => $01c4a849d3703fe6$export$2e2bcd8739ae039);

var $jJZqs = parcelRequire("jJZqs");

var $5HnTq = parcelRequire("5HnTq");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$01c4a849d3703fe6$export$2e2bcd8739ae039 = (url, options = {})=>{
    const option = {
        ...(0, $5HnTq.getDefaultOptions)(url),
        ...options
    };
    return fetch(url, option).then((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                throw new (0, $jJZqs.default)(status, str);
            });
        }
        return response.json();
    });
};

});


parcelRegister("kMTMr", function(module, exports) {

$parcel$export(module.exports, "transformReleasableToRestVersion", () => $9820223a518af481$export$6c7ef87ae81a803f);
$parcel$export(module.exports, "addDefaultReleaseDate", () => $9820223a518af481$export$a3871b8272282d64);

var $fr1K2 = parcelRequire("fr1K2");

var $kMUwX = parcelRequire("kMUwX");
const $9820223a518af481$export$6c7ef87ae81a803f = (version)=>{
    const restVersion = (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(version, [
        'issuesStatus'
    ]);
    return {
        ...restVersion,
        released: true,
        // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'string | undefined'.
        releaseDate: (0, $kMUwX.atlasKitToServerDateFormat)(version.releaseDate)
    };
};
const $9820223a518af481$export$a3871b8272282d64 = (version)=>{
    const { id: id, name: name, releaseDate: releaseDate, issuesStatus: issuesStatus } = version;
    return {
        id: id,
        name: name,
        issuesStatus: issuesStatus,
        moveUnfixedIssuesTo: '',
        releaseDate: releaseDate ? (0, $kMUwX.ISOToAtlasKitDateFormat)(releaseDate) : (0, $kMUwX.todayToAtlasKitDateFormat)()
    };
};

});
parcelRegister("kMUwX", function(module, exports) {

$parcel$export(module.exports, "ISOToAtlasKitDateFormat", () => $013f23539a74f0d2$export$4df2a4adbb0e5391);
$parcel$export(module.exports, "todayToAtlasKitDateFormat", () => $013f23539a74f0d2$export$d9939b5b983bc908);
$parcel$export(module.exports, "atlasKitToServerDateFormat", () => $013f23539a74f0d2$export$bcd9d8ad44970e94);
// GOOD TO KNOW
// ------------
// Atlaskit DatePicker has two date formats:
// 1. YYYY/MM/DD which user sees on the screen
// 2. YYYY-MM-DD which DatePicker passes to the onChange callback (ISO format)
//
// Sometimes Atlaskit doesn't convert user-input date (YYYY/MM/DD) to the ISO format.
// It happens when some action gets dispatched before DatePicker receives blur event.
// So we fix it here by replacing `/` with `-`.

var $k7m40 = parcelRequire("k7m40");

var $b77vc = parcelRequire("b77vc");

var $jovBr = parcelRequire("jovBr");

var $eZDAP = parcelRequire("eZDAP");

var $htiPW = parcelRequire("htiPW");
const $013f23539a74f0d2$export$c9b0b9ddba618847 = (dateStr)=>{
    if (dateStr) {
        const date = (0, $eZDAP.default)(dateStr.replace(/\//g, '-'));
        if ((0, $jovBr.default)(date)) return (0, $k7m40.default)(new Date(date), 'yyyy-MM-dd');
    }
    return '';
};
const $013f23539a74f0d2$export$4df2a4adbb0e5391 = (dateStr)=>{
    if (dateStr) {
        const date = (0, $eZDAP.default)(dateStr);
        if ((0, $jovBr.default)(date)) return (0, $k7m40.default)(new Date(date), 'yyyy/MM/dd');
    }
    return '';
};
const $013f23539a74f0d2$export$d9939b5b983bc908 = ()=>(0, $k7m40.default)((0, $htiPW.default)(), 'yyyy/MM/dd');
const $013f23539a74f0d2$export$6350eb346dee22fe = (dateStr)=>{
    if (dateStr) return (0, $jovBr.default)((0, $eZDAP.default)(dateStr.replace(/\//g, '-')));
    return false;
};
const $013f23539a74f0d2$export$bcd9d8ad44970e94 = (dateStr)=>{
    let dateISO;
    if (dateStr && $013f23539a74f0d2$export$6350eb346dee22fe(dateStr)) dateISO = $013f23539a74f0d2$export$c9b0b9ddba618847(dateStr);
    return dateISO || null;
};
const $013f23539a74f0d2$export$e36c611b04695a2e = (dateStr)=>{
    const date = (0, $eZDAP.default)(dateStr);
    if ((0, $jovBr.default)(date)) return (0, $b77vc.default)(date);
    return undefined;
};
const $013f23539a74f0d2$export$8d60448f563c47a6 = {
    year: 'numeric',
    month: 'short',
    day: '2-digit'
};

});


parcelRegister("agk64", function(module, exports) {

$parcel$export(module.exports, "getHasDismissedReleaseAutomationBanner", () => $42933e7c8516f8fa$export$b8702a08258e1098);
$parcel$export(module.exports, "dismissReleaseAutomationBanner", () => $42933e7c8516f8fa$export$7f678873378110b8);
$parcel$export(module.exports, "fireReleaseAutomationBannerError", () => $42933e7c8516f8fa$export$76cf25de6ffb8030);

var $jcw0u = parcelRequire("jcw0u");

var $5HnTq = parcelRequire("5HnTq");
const $42933e7c8516f8fa$export$b8702a08258e1098 = async (accountId)=>{
    const url = `/rest/api/3/user/properties/hasDismissedReleaseAutomationBanner?accountId=${accountId}`;
    const fetchResponse = await fetch(url, (0, $5HnTq.getDefaultOptions)(url));
    // ok is true only when status code is 2xx.
    if (fetchResponse.ok) {
        const responseObj = await fetchResponse.json();
        return responseObj.value;
    }
    const { status: status } = fetchResponse;
    // 401: If credential is incorrect, the user is not authorised and should not see the banner
    if (status === 401) return true;
    // 404: API deliberately returns 404 if user property is not found, which implies the user has not dismissed the banner
    if (status === 404) return false;
    throw new Error(`Fetching hasDismisssedReleaseAutomationBanner user property failed. Status code: ${fetchResponse.status}`);
};
const $42933e7c8516f8fa$export$7f678873378110b8 = async (accountId)=>{
    const url = `/rest/api/3/user/properties/hasDismissedReleaseAutomationBanner?accountId=${accountId}`;
    const fetchResponse = await fetch(url, {
        ...(0, $5HnTq.getDefaultOptions)(url),
        method: 'PUT',
        body: JSON.stringify(true)
    });
    if (!fetchResponse.ok) throw Error('Failed to dismiss release automation banner via user properties.');
};
const $42933e7c8516f8fa$export$76cf25de6ffb8030 = (error)=>(0, $jcw0u.default)({
        meta: {
            id: 'versions.release.version.modal.release.automation.user.property',
            packageName: 'jiraVersionModals',
            teamName: 'nova'
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });

});


parcelRegister("3yLu1", function(module, exports) {

$parcel$export(module.exports, "SET_CONTEXT", () => $efa9dcf433ebc4c7$export$4bc4e62e7d72b94b);
$parcel$export(module.exports, "setContext", () => $efa9dcf433ebc4c7$export$2f04de43fe27971a);
$parcel$export(module.exports, "SET_HANDLERS", () => $efa9dcf433ebc4c7$export$bc2eae499d5e6cec);
$parcel$export(module.exports, "setHandlers", () => $efa9dcf433ebc4c7$export$241365d6eef6c169);
$parcel$export(module.exports, "INITIAL_REQUEST", () => $efa9dcf433ebc4c7$export$e1efaa8f406867bb);
$parcel$export(module.exports, "initialRequest", () => $efa9dcf433ebc4c7$export$3bccc812fdbc3954);
$parcel$export(module.exports, "INITIAL_REQUEST_SUCCESS", () => $efa9dcf433ebc4c7$export$37a4e72ae1c0a1b5);
$parcel$export(module.exports, "initialRequestSuccess", () => $efa9dcf433ebc4c7$export$fbef4e4c40c06dae);
$parcel$export(module.exports, "SET_VERSION_UNRESOLVED_ISSUES_COUNT", () => $efa9dcf433ebc4c7$export$a558394b02430fa);
$parcel$export(module.exports, "setUnreleasedIssuesCount", () => $efa9dcf433ebc4c7$export$521ad3c091ef9f4b);
$parcel$export(module.exports, "SWAP_ISSUES", () => $efa9dcf433ebc4c7$export$1e105c795f4df801);
$parcel$export(module.exports, "swapIssues", () => $efa9dcf433ebc4c7$export$f9d0b46042c1093d);
$parcel$export(module.exports, "RELEASE_VERSION_UPDATE", () => $efa9dcf433ebc4c7$export$a7943bb075347bd4);
$parcel$export(module.exports, "releaseVersionUpdate", () => $efa9dcf433ebc4c7$export$6e5a7b93aba64e1c);
$parcel$export(module.exports, "RELEASE_VERSION_REQUEST", () => $efa9dcf433ebc4c7$export$b482a6a2418379a4);
$parcel$export(module.exports, "releaseVersionRequest", () => $efa9dcf433ebc4c7$export$f25b64441359ac5d);
$parcel$export(module.exports, "RELEASE_VERSION_SUCCESS", () => $efa9dcf433ebc4c7$export$9f45f3d28614fd39);
$parcel$export(module.exports, "releaseVersionSuccess", () => $efa9dcf433ebc4c7$export$ef2ca233886223dd);
$parcel$export(module.exports, "RELEASE_VERSION_FAILURE", () => $efa9dcf433ebc4c7$export$f79008eab89d4f56);
$parcel$export(module.exports, "releaseVersionFailure", () => $efa9dcf433ebc4c7$export$f40837cd887e0e7d);
$parcel$export(module.exports, "RELEASE_VERSION_VALIDATION_FAILURE", () => $efa9dcf433ebc4c7$export$15feef518e3a0f72);
$parcel$export(module.exports, "releaseVersionValidationFailure", () => $efa9dcf433ebc4c7$export$d206bb816a78117c);
$parcel$export(module.exports, "CREATE_RELEASE_NOTES_OPTIONS", () => $efa9dcf433ebc4c7$export$95df9c1149c6615a);
$parcel$export(module.exports, "setCreateReleaseNotesOptionConfig", () => $efa9dcf433ebc4c7$export$778db09b7ef0e606);
$parcel$export(module.exports, "RELEASE_SET_REDIRECT_TO_CREATE_RELEASE_NOTES_STATUS", () => $efa9dcf433ebc4c7$export$95c8c0da90c589f);
$parcel$export(module.exports, "releaseRedirectToCreateReleaseNotesStatus", () => $efa9dcf433ebc4c7$export$bec051bc82fda7b3);
const $efa9dcf433ebc4c7$export$4bc4e62e7d72b94b = 'release-version-modal.state.SET_CONTEXT';
const $efa9dcf433ebc4c7$export$2f04de43fe27971a = (payload)=>({
        type: $efa9dcf433ebc4c7$export$4bc4e62e7d72b94b,
        payload: payload
    });
const $efa9dcf433ebc4c7$export$bc2eae499d5e6cec = 'release-version-modal.state.SET_HANDLERS';
const $efa9dcf433ebc4c7$export$241365d6eef6c169 = (payload)=>({
        type: $efa9dcf433ebc4c7$export$bc2eae499d5e6cec,
        payload: payload
    });
const $efa9dcf433ebc4c7$export$e1efaa8f406867bb = 'release-version-modal.state.INITIAL_REQUEST';
const $efa9dcf433ebc4c7$export$3bccc812fdbc3954 = (versionId)=>({
        type: $efa9dcf433ebc4c7$export$e1efaa8f406867bb,
        payload: versionId
    });
const $efa9dcf433ebc4c7$export$37a4e72ae1c0a1b5 = 'release-version-modal.state.INITIAL_REQUEST_SUCCESS';
const $efa9dcf433ebc4c7$export$fbef4e4c40c06dae = (version)=>({
        type: $efa9dcf433ebc4c7$export$37a4e72ae1c0a1b5,
        payload: version
    });
const $efa9dcf433ebc4c7$export$a558394b02430fa = 'release-version-modal.state.SET_VERSION_UNRESOLVED_ISSUES_COUNT';
const $efa9dcf433ebc4c7$export$521ad3c091ef9f4b = (payload)=>({
        type: $efa9dcf433ebc4c7$export$a558394b02430fa,
        payload: payload
    });
const $efa9dcf433ebc4c7$export$33d1af9ce619539e = 'release-version-modal.state.SET_VERSION';
const $efa9dcf433ebc4c7$export$f99c3c9c04cda7ae = (payload)=>({
        type: $efa9dcf433ebc4c7$export$33d1af9ce619539e,
        payload: payload
    });
const $efa9dcf433ebc4c7$export$1e105c795f4df801 = 'release-version-modal.state.SWAP_ISSUES';
const $efa9dcf433ebc4c7$export$f9d0b46042c1093d = (payload)=>({
        type: $efa9dcf433ebc4c7$export$1e105c795f4df801,
        payload: payload
    });
const $efa9dcf433ebc4c7$export$a7943bb075347bd4 = 'release-version-modal.state.RELEASE_VERSION_UPDATE';
const $efa9dcf433ebc4c7$export$6e5a7b93aba64e1c = (payload)=>({
        type: $efa9dcf433ebc4c7$export$a7943bb075347bd4,
        payload: payload
    });
const $efa9dcf433ebc4c7$export$b482a6a2418379a4 = 'release-version-modal.state.RELEASE_VERSION_REQUEST';
const $efa9dcf433ebc4c7$export$f25b64441359ac5d = ()=>({
        type: $efa9dcf433ebc4c7$export$b482a6a2418379a4
    });
const $efa9dcf433ebc4c7$export$9f45f3d28614fd39 = 'release-version-modal.state.RELEASE_VERSION_SUCCESS';
const $efa9dcf433ebc4c7$export$ef2ca233886223dd = (payload)=>({
        type: $efa9dcf433ebc4c7$export$9f45f3d28614fd39,
        payload: payload
    });
const $efa9dcf433ebc4c7$export$f79008eab89d4f56 = 'release-version-modal.state.RELEASE_VERSION_FAILURE';
const $efa9dcf433ebc4c7$export$f40837cd887e0e7d = (payload)=>({
        type: $efa9dcf433ebc4c7$export$f79008eab89d4f56,
        payload: payload
    });
const $efa9dcf433ebc4c7$export$15feef518e3a0f72 = 'release-version-modal.state.RELEASE_VERSION_VALIDATION_FAILURE';
const $efa9dcf433ebc4c7$export$d206bb816a78117c = (payload)=>({
        type: $efa9dcf433ebc4c7$export$15feef518e3a0f72,
        payload: payload
    });
const $efa9dcf433ebc4c7$export$95df9c1149c6615a = 'release-version-modal.state.CREATE_RELEASE_NOTES_OPTIONS';
const $efa9dcf433ebc4c7$export$778db09b7ef0e606 = (payload)=>({
        type: $efa9dcf433ebc4c7$export$95df9c1149c6615a,
        payload: payload
    });
const $efa9dcf433ebc4c7$export$95c8c0da90c589f = 'release-version-modal.state.RELEASE_SET_REDIRECT_TO_CREATE_RELEASE_NOTES_STATUS';
const $efa9dcf433ebc4c7$export$bec051bc82fda7b3 = (payload)=>({
        type: $efa9dcf433ebc4c7$export$95c8c0da90c589f,
        payload: payload
    });

});

parcelRegister("ai3Yq", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $9799cf0a53e1d000$export$f654b28f82155665);
$parcel$export(module.exports, "getProjectKey", () => $9799cf0a53e1d000$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getVersion", () => $9799cf0a53e1d000$export$c506eb22e615ba4a);
$parcel$export(module.exports, "getVersionId", () => $9799cf0a53e1d000$export$d0a84488c5034e2b);
$parcel$export(module.exports, "getTodoInProgressIssuesCount", () => $9799cf0a53e1d000$export$7c32856ef2a2cb6);
$parcel$export(module.exports, "getUnresolvedIssuesCount", () => $9799cf0a53e1d000$export$b7679bf23524baba);
$parcel$export(module.exports, "getResolvedIssuesCount", () => $9799cf0a53e1d000$export$96488947387acc21);
$parcel$export(module.exports, "getDoneIssuesCount", () => $9799cf0a53e1d000$export$51a75c074eb3f4d4);
$parcel$export(module.exports, "getName", () => $9799cf0a53e1d000$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getReleaseDate", () => $9799cf0a53e1d000$export$9664966f747b3c18);
$parcel$export(module.exports, "getErrors", () => $9799cf0a53e1d000$export$501239432719417d);
$parcel$export(module.exports, "isSwapSelected", () => $9799cf0a53e1d000$export$8fff49f07292ff94);
$parcel$export(module.exports, "isSaving", () => $9799cf0a53e1d000$export$3b51d1dcee070cea);
$parcel$export(module.exports, "isInitiating", () => $9799cf0a53e1d000$export$8b35c3a55e549a0d);
$parcel$export(module.exports, "getOnOpenedHandler", () => $9799cf0a53e1d000$export$9cb228195867c4ba);
$parcel$export(module.exports, "getOnErrorHandler", () => $9799cf0a53e1d000$export$1a207b7e599ecdc7);
$parcel$export(module.exports, "getOnSuccessHandler", () => $9799cf0a53e1d000$export$8fb55c0bc571e8e7);
$parcel$export(module.exports, "getOnCancelHandler", () => $9799cf0a53e1d000$export$e776433ed4e15cc4);
$parcel$export(module.exports, "getPropsForVersionPicker", () => $9799cf0a53e1d000$export$95a1217518b748b8);
$parcel$export(module.exports, "isReleaseDisabled", () => $9799cf0a53e1d000$export$2a2f3b8b22c4af1f);
$parcel$export(module.exports, "isKeepingIssues", () => $9799cf0a53e1d000$export$e783a0e680cad4ec);
$parcel$export(module.exports, "shouldShowCreateReleaseNotesOption", () => $9799cf0a53e1d000$export$37c3a3cc47342e65);
$parcel$export(module.exports, "shouldRedirectToCreateReleaseNotes", () => $9799cf0a53e1d000$export$24122e8f86a884b6);

var $dGvGJ = parcelRequire("dGvGJ");
const $9799cf0a53e1d000$export$f654b28f82155665 = (state)=>state.context.baseUrl;
const $9799cf0a53e1d000$export$667f2a0f99c75faa = (state)=>state.context.projectKey;
const $9799cf0a53e1d000$export$c506eb22e615ba4a = (state)=>state.version;
const $9799cf0a53e1d000$export$57294fc3393f82ae = (state)=>state.version.moveUnfixedIssuesTo;
const $9799cf0a53e1d000$export$d0a84488c5034e2b = (state)=>state.version.id;
const $9799cf0a53e1d000$export$7c32856ef2a2cb6 = (state)=>{
    if (state.version.issuesStatus) return state.version.issuesStatus.toDo + state.version.issuesStatus.inProgress;
    return 0;
};
const $9799cf0a53e1d000$export$b7679bf23524baba = (state)=>state.unresolvedIssuesCount;
const $9799cf0a53e1d000$export$36e4434605c3220 = (state)=>{
    if (state.version.issuesStatus) return state.version.issuesStatus.done + state.version.issuesStatus.toDo + state.version.issuesStatus.inProgress;
    return 0;
};
const $9799cf0a53e1d000$export$96488947387acc21 = (state)=>$9799cf0a53e1d000$export$36e4434605c3220(state) - $9799cf0a53e1d000$export$b7679bf23524baba(state);
const $9799cf0a53e1d000$export$51a75c074eb3f4d4 = (state)=>{
    if (state.version.issuesStatus) return state.version.issuesStatus.done;
    return 0;
};
const $9799cf0a53e1d000$export$7d9f7e9c1c02b41e = (state)=>$9799cf0a53e1d000$export$c506eb22e615ba4a(state).name || '';
const $9799cf0a53e1d000$export$9664966f747b3c18 = (state)=>$9799cf0a53e1d000$export$c506eb22e615ba4a(state).releaseDate || '';
const $9799cf0a53e1d000$export$501239432719417d = (0, $dGvGJ.createSelector)(// @ts-expect-error - TS2571 - Object is of type 'unknown'.
(state)=>state.errors, (errors)=>{
    const { releaseDate: releaseDate = '', moveUnfixedIssuesTo: moveUnfixedIssuesTo = '' } = errors || {};
    return {
        releaseDate: releaseDate,
        moveUnfixedIssuesTo: moveUnfixedIssuesTo
    };
});
const $9799cf0a53e1d000$export$8fff49f07292ff94 = (state)=>state.shouldSwapIssues;
const $9799cf0a53e1d000$export$3b51d1dcee070cea = (state)=>!!state.isSaving;
const $9799cf0a53e1d000$export$8b35c3a55e549a0d = (state)=>!!state.isInitiating;
const $9799cf0a53e1d000$export$9cb228195867c4ba = (state)=>state.handlers.onOpened;
const $9799cf0a53e1d000$export$1a207b7e599ecdc7 = (state)=>state.handlers.onError;
const $9799cf0a53e1d000$export$8fb55c0bc571e8e7 = (state)=>state.handlers.onSuccess;
const $9799cf0a53e1d000$export$e776433ed4e15cc4 = (state)=>state.handlers.onCancel;
const $9799cf0a53e1d000$export$95a1217518b748b8 = (state)=>({
        baseUrl: state.context.baseUrl,
        projectKey: state.context.projectKey,
        shouldSwapIssues: state.shouldSwapIssues,
        isSaving: state.isSaving,
        versionId: state.version.id
    });
const $9799cf0a53e1d000$var$hasTodoInProgressIssues = (state)=>$9799cf0a53e1d000$export$7c32856ef2a2cb6(state) > 0;
const $9799cf0a53e1d000$export$2a2f3b8b22c4af1f = (state)=>state.isSaving || $9799cf0a53e1d000$export$b7679bf23524baba(state) > 0 && state.shouldSwapIssues && !$9799cf0a53e1d000$export$57294fc3393f82ae(state);
const $9799cf0a53e1d000$export$e783a0e680cad4ec = (state)=>{
    if ($9799cf0a53e1d000$var$hasTodoInProgressIssues(state)) return state.shouldSwapIssues ? !$9799cf0a53e1d000$export$57294fc3393f82ae(state) : true;
    return true;
};
const $9799cf0a53e1d000$export$37c3a3cc47342e65 = (state)=>state.shouldShowCreateReleaseNotesOption;
const $9799cf0a53e1d000$export$24122e8f86a884b6 = (state)=>state.shouldRedirectToCreateReleaseNotes;

});


parcelRegister("cHY1X", function(module, exports) {

$parcel$export(module.exports, "initialRequestSuccessEpic", () => $d761eb56ba97a1cf$export$9d210f02e9fc914d);
$parcel$export(module.exports, "releaseVersionRequestSuccessEpic", () => $d761eb56ba97a1cf$export$77863bf7469abd8f);
$parcel$export(module.exports, "releaseVersionRequestFailureEpic", () => $d761eb56ba97a1cf$export$79de050f634d0345);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $3yLu1 = parcelRequire("3yLu1");

var $ai3Yq = parcelRequire("ai3Yq");
const $d761eb56ba97a1cf$export$9d210f02e9fc914d = (action$, store)=>action$.ofType((0, $3yLu1.INITIAL_REQUEST_SUCCESS)).mergeMap(()=>{
        const state = store.getState();
        const versionId = (0, $ai3Yq.getVersionId)(state);
        (0, $ai3Yq.getOnOpenedHandler)(state)({
            id: versionId
        });
        return (0, $kVLXA.Observable).empty();
    });
const $d761eb56ba97a1cf$export$77863bf7469abd8f = (action$, store)=>action$.ofType((0, $3yLu1.RELEASE_VERSION_SUCCESS)).mergeMap(({ payload: version })=>{
        const state = store.getState();
        (0, $ai3Yq.getOnSuccessHandler)(state)(version, {
            shouldRedirectToCreateReleaseNotes: (0, $ai3Yq.shouldRedirectToCreateReleaseNotes)(state)
        });
        return (0, $kVLXA.Observable).empty();
    });
const $d761eb56ba97a1cf$export$79de050f634d0345 = (action$, store)=>action$.ofType((0, $3yLu1.RELEASE_VERSION_FAILURE)).mergeMap(({ payload: id })=>{
        const state = store.getState();
        (0, $ai3Yq.getOnErrorHandler)(state)(id);
        return (0, $kVLXA.Observable).empty();
    });

});


parcelRegister("dGae8", function(module, exports) {

$parcel$export(module.exports, "default", () => $73fa150bafb032f5$export$2e2bcd8739ae039);

var $F2Mxm = parcelRequire("F2Mxm");

var $5lQMY = parcelRequire("5lQMY");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$73fa150bafb032f5$export$2e2bcd8739ae039 = (rootEpic)=>(0, $F2Mxm.default)({
        appName: 'release-version',
        rootReducer: $5lQMY.default,
        rootEpic: rootEpic
    });

});
parcelRegister("5lQMY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d40ac852e63d3642$export$2e2bcd8739ae039);

var $6Csk1 = parcelRequire("6Csk1");

var $1UikQ = parcelRequire("1UikQ");

var $8Rkzz = parcelRequire("8Rkzz");

var $fr1K2 = parcelRequire("fr1K2");

var $3yLu1 = parcelRequire("3yLu1");
const $d40ac852e63d3642$export$d4c72bab9d6cc13a = {
    context: {
        baseUrl: '',
        projectKey: ''
    },
    handlers: {
        onOpened: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onError: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    },
    version: {
        id: '0',
        name: ''
    },
    unresolvedIssuesCount: 0,
    shouldSwapIssues: true,
    isInitiating: true,
    isSaving: false,
    shouldShowCreateReleaseNotesOption: false,
    hasReleaseNote: false,
    shouldRedirectToCreateReleaseNotes: true
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d40ac852e63d3642$export$2e2bcd8739ae039 = (state = $d40ac852e63d3642$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $3yLu1.SET_CONTEXT:
            {
                const context = action.payload;
                // @ts-expect-error - TS2322 - Type 'SetContextPayload | undefined' is not assignable to type '{ readonly readonly projectKey: string; }'.
                return {
                    ...state,
                    context: context
                };
            }
        case 0, $3yLu1.SET_VERSION_UNRESOLVED_ISSUES_COUNT:
            {
                const unresolvedIssuesCount = action.payload;
                return {
                    ...state,
                    unresolvedIssuesCount: unresolvedIssuesCount || 0
                };
            }
        case 0, $3yLu1.SWAP_ISSUES:
            // @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
            return {
                ...state,
                shouldSwapIssues: action.payload
            };
        case 0, $3yLu1.SET_HANDLERS:
            {
                const handlers = action.payload;
                return {
                    ...state,
                    handlers: (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, state.handlers, handlers)
                };
            }
        case 0, $3yLu1.INITIAL_REQUEST_SUCCESS:
            {
                const version = action.payload;
                // @ts-expect-error - TS2322 - Type 'Pick<{ version: ReleasableVersion | undefined; context: { readonly readonly projectKey: string; }; handlers: Handlers; errors?: ReleaseVersionValidationErrors | undefined; isInitiating?: boolean | undefined; isSaving?: boolean | undefined; shouldSwapIssues: boolean; }, "version" | ... 4 more ... | "...' is not assignable to type 'State'.
                return (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))({
                    ...state,
                    version: version
                }, 'isInitiating');
            }
        case 0, $3yLu1.RELEASE_VERSION_UPDATE:
            {
                const prevVersion = state.version;
                const prevErrors = state.errors;
                const nextVersion = action.payload;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const errors = {};
                if (action.payload && action.payload.moveUnfixedIssuesTo) errors.moveUnfixedIssuesTo = '';
                if (action.payload && action.payload.releaseDate) errors.releaseDate = '';
                return {
                    ...state,
                    errors: (0, (/*@__PURE__*/$parcel$interopDefault($6Csk1)))({}, prevErrors, errors),
                    version: (0, (/*@__PURE__*/$parcel$interopDefault($6Csk1)))({}, prevVersion, nextVersion)
                };
            }
        case 0, $3yLu1.RELEASE_VERSION_VALIDATION_FAILURE:
            {
                const errors = action.payload;
                return (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))({
                    ...state,
                    errors: errors
                }, 'isSaving');
            }
        case 0, $3yLu1.RELEASE_VERSION_REQUEST:
            return {
                ...state,
                isSaving: true
            };
        case 0, $3yLu1.RELEASE_VERSION_SUCCESS:
        case 0, $3yLu1.RELEASE_VERSION_FAILURE:
            return (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(state, 'isSaving');
        case 0, $3yLu1.INITIAL_REQUEST:
            return state;
        case 0, $3yLu1.CREATE_RELEASE_NOTES_OPTIONS:
            return {
                ...state,
                ...action.payload,
                shouldRedirectToCreateReleaseNotes: !(action.payload?.hasReleaseNote ?? false)
            };
        case 0, $3yLu1.RELEASE_SET_REDIRECT_TO_CREATE_RELEASE_NOTES_STATUS:
            {
                const shouldRedirectToCreateReleaseNotes = action.payload !== undefined ? action.payload : false;
                return {
                    ...state,
                    shouldRedirectToCreateReleaseNotes: shouldRedirectToCreateReleaseNotes
                };
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});


parcelRegister("6FZ5A", function(module, exports) {

$parcel$export(module.exports, "default", () => $dba542cd4fb317a1$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $3yLu1 = parcelRequire("3yLu1");

var $ai3Yq = parcelRequire("ai3Yq");

var $gdGCZ = parcelRequire("gdGCZ");

var $eiujx = parcelRequire("eiujx");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $dba542cd4fb317a1$var$mapStateToProps = (state)=>({
        unresolvedIssuesCount: (0, $ai3Yq.getUnresolvedIssuesCount)(state),
        isReleaseDisabled: (0, $ai3Yq.isReleaseDisabled)(state),
        name: (0, $ai3Yq.getName)(state),
        isSaving: (0, $ai3Yq.isSaving)(state),
        isInitiating: (0, $ai3Yq.isInitiating)(state),
        onCancel: (0, $ai3Yq.getOnCancelHandler)(state),
        Content: $gdGCZ.default,
        shouldRedirectToCreateReleaseNotes: (0, $ai3Yq.shouldRedirectToCreateReleaseNotes)(state),
        shouldShowCreateReleaseNotesOption: (0, $ai3Yq.shouldShowCreateReleaseNotesOption)(state)
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $dba542cd4fb317a1$var$dispatcher = (dispatch)=>({
        onRelease: ()=>dispatch((0, $3yLu1.releaseVersionRequest)()),
        setRedirectToCreateReleaseNotesStatus: (value)=>dispatch((0, $3yLu1.releaseRedirectToCreateReleaseNotesStatus)(value))
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $dba542cd4fb317a1$var$mapDispatchToProps = (dispatch)=>$dba542cd4fb317a1$var$dispatcher(dispatch);
var $dba542cd4fb317a1$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($dba542cd4fb317a1$var$mapStateToProps, $dba542cd4fb317a1$var$mapDispatchToProps)((0, $eiujx.default));

});
parcelRegister("gdGCZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc6b5ee15f8b82ed$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $jC89g = parcelRequire("jC89g");

var $ai3Yq = parcelRequire("ai3Yq");

var $5BDcC = parcelRequire("5BDcC");

var $50qub = parcelRequire("50qub");

var $3nRuh = parcelRequire("3nRuh");

var $uKe1m = parcelRequire("uKe1m");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bc6b5ee15f8b82ed$var$mapStateToProps = (state)=>({
        SwapIssues: $3nRuh.default,
        ReleaseDate: $50qub.default,
        ReleaseAutomationBanner: $5BDcC.ReleaseAutomationBanner,
        doneIssues: (0, $ai3Yq.getDoneIssuesCount)(state),
        unresolvedIssuesCount: (0, $ai3Yq.getUnresolvedIssuesCount)(state),
        resolvedIssuesCount: (0, $ai3Yq.getResolvedIssuesCount)(state),
        unresolvedIssuesUrl: (0, $jC89g.getUnresolvedIssuesInVersionJql)((0, $ai3Yq.getProjectKey)(state), (0, $ai3Yq.getName)(state)),
        resolvedIssueUrl: (0, $jC89g.getResolvedIssuesInVersionJql)((0, $ai3Yq.getProjectKey)(state), (0, $ai3Yq.getName)(state))
    });
var $bc6b5ee15f8b82ed$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($bc6b5ee15f8b82ed$var$mapStateToProps, {})((0, $uKe1m.default));

});
parcelRegister("jC89g", function(module, exports) {

$parcel$export(module.exports, "getUnresolvedIssuesInVersionJql", () => $a27f6842930b4a90$export$6ec377b2fc8168c7);
$parcel$export(module.exports, "getResolvedIssuesInVersionJql", () => $a27f6842930b4a90$export$c14e075033246e76);

var $cIy4l = parcelRequire("cIy4l");
const $a27f6842930b4a90$export$6ec377b2fc8168c7 = (projectKey, versionName)=>{
    const jql = `project = ${(0, $cIy4l.toQuotedString)(projectKey)} AND fixVersion = ${(0, $cIy4l.toQuotedString)(versionName)} AND resolution is EMPTY`;
    return (0, $cIy4l.createIssuesUrl)(jql);
};
const $a27f6842930b4a90$export$c14e075033246e76 = (projectKey, versionName)=>(0, $cIy4l.createIssuesUrl)(`project = ${(0, $cIy4l.toQuotedString)(projectKey)} AND fixVersion = ${(0, $cIy4l.toQuotedString)(versionName)} AND resolution is NOT EMPTY`);

});
parcelRegister("cIy4l", function(module, exports) {

$parcel$export(module.exports, "toQuotedString", () => $ae91325110cc96a6$export$dbeab020a4aa404);
$parcel$export(module.exports, "createIssuesUrl", () => $ae91325110cc96a6$export$c623a4b2d8c439ab);
const $ae91325110cc96a6$var$ENCODE_MAP = {
    '\t': '\\t',
    '\n': '\\n',
    '\r': '\\r',
    '"': '\\"',
    "'": "\\'",
    '\\': '\\\\'
};
const $ae91325110cc96a6$export$946fe289c25510be = (character, ignoredCharacter)=>{
    if (character === ignoredCharacter) return character;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly '\t': "\\t"; readonly '\n': "\\n"; readonly '\r': "\\r"; readonly '"': "\\\""; readonly "'": "\\'"; readonly '\\': "\\\\"; }'.
    return $ae91325110cc96a6$var$ENCODE_MAP[character] || character;
};
const $ae91325110cc96a6$export$dbeab020a4aa404 = (parameter)=>{
    let escaped = '';
    for(let position = 0; position < parameter.length; position += 1)escaped += $ae91325110cc96a6$export$946fe289c25510be(parameter[position], "'");
    return `"${escaped}"`;
};
const $ae91325110cc96a6$export$c623a4b2d8c439ab = (jql)=>`/issues/?jql=${encodeURIComponent(jql)}`;

});


parcelRegister("5BDcC", function(module, exports) {

$parcel$export(module.exports, "ReleaseAutomationBanner", () => $26e8724edc621c65$export$45e1a2bd60e730ec);
/* ReleaseAutomationBanner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $itzrU = parcelRequire("itzrU");

var $fVnbM = parcelRequire("fVnbM");

var $1IoOM = parcelRequire("1IoOM");

var $gOS29 = parcelRequire("gOS29");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dAfqg = parcelRequire("dAfqg");

var $c42uT = parcelRequire("c42uT");

var $2aqLT = parcelRequire("2aqLT");

var $4eavD = parcelRequire("4eavD");
const $26e8724edc621c65$export$d6be0a6034032add = (projectProps)=>`${(0, $gOS29.getBaseAutomationUrl)(projectProps)}#rule/new?componentFilterCriteria=RELEASE_MANAGEMENT_TRIGGERS`;
const $26e8724edc621c65$export$45e1a2bd60e730ec = ({ isTransitionEnabled: isTransitionEnabled = true })=>{
    const { showBanner: showBanner, dismissBanner: dismissBanner } = (0, $c42uT.useReleaseAutomationBanner)();
    const { data: projectContext, loading: loading, error: error } = (0, $dAfqg.useProjectContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    if (loading) return null;
    if (error) throw error;
    if (projectContext == null) throw Error('Missing project context when rendering ReleaseAutomationBanner');
    const { simplified: isSimplified, projectKey: projectKey, projectType: projectType } = projectContext;
    const renderBannerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($26e8724edc621c65$var$Spacer, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($26e8724edc621c65$var$Section, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        width: 14,
        height: 16,
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2aqLT))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($26e8724edc621c65$var$CallToAction, {
        href: $26e8724edc621c65$export$d6be0a6034032add({
            isSimplified: isSimplified,
            projectKey: projectKey,
            projectType: projectType
        }),
        target: "_blank",
        rel: "noopener noreferrer",
        title: formatMessage((0, $4eavD.default).setupReleaseAutomation),
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'link'
            }), 'newRuleAutomationLink');
            dismissBanner();
        }
    }, formatMessage((0, $4eavD.default).setupReleaseAutomation)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($26e8724edc621c65$var$Dismiss, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        shouldFitContainer: true,
        appearance: "subtle" // eslint-disable-next-line jira/react-no-inline-function-prop
        ,
        onClick: (_, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'dismissButton');
            dismissBanner();
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1IoOM))), {
            label: formatMessage((0, $4eavD.default).dismiss),
            LEGACY_size: "small"
        })
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$238d30785c4bca84),
        sourceName: "releaseAutomationCallToAction"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), isTransitionEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($26e8724edc621c65$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $itzrU.default), {
        in: showBanner,
        timeout: $26e8724edc621c65$var$TRANSITION_DURATION,
        classNames: "release-automation-banner",
        unmountOnExit: true
    }, renderBannerContent)) : renderBannerContent);
};
const $26e8724edc621c65$var$BANNER_HEIGHT = 80;
const $26e8724edc621c65$var$TRANSITION_DURATION = 400; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $26e8724edc621c65$var$Section = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "section", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _zulppxbi _189eyh40 _1dqonqa1 _1h6dmuej _1e0c1txw _4cvr1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $26e8724edc621c65$var$CallToAction = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _16jlkb7n _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $26e8724edc621c65$var$Dismiss = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbzwfg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $26e8724edc621c65$var$Spacer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $26e8724edc621c65$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_lnbg15vq _11ok15vq _1k7uidpf _pmb0idpf _1sz115vq _iayz15vq _19q1o91y _lghnkb7n _3g9qys9h _1b0e15vq _19ci15vq _28jmkb7n _13e1ys9h _1g5d15vq _153n15vq _khvao91y _zsv0idpf _qigkidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1IoOM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::40d49d14e43276e4147396a05e9540f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $13fd26dab9ed6f93$var$_react = $13fd26dab9ed6f93$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $13fd26dab9ed6f93$var$_cross = $13fd26dab9ed6f93$var$_interopRequireDefault((parcelRequire("1EekA")));

var $13fd26dab9ed6f93$var$_cross2 = $13fd26dab9ed6f93$var$_interopRequireDefault((parcelRequire("lLLkM")));
function $13fd26dab9ed6f93$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $13fd26dab9ed6f93$var$CrossIcon = (props)=>/*#__PURE__*/ $13fd26dab9ed6f93$var$_react.default.createElement($13fd26dab9ed6f93$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $13fd26dab9ed6f93$var$_cross2.default
    }, props));
$13fd26dab9ed6f93$var$CrossIcon.Name = 'CrossIconMigration';
var $13fd26dab9ed6f93$var$_default = module.exports.default = $13fd26dab9ed6f93$var$CrossIcon;

});

parcelRegister("gOS29", function(module, exports) {

$parcel$export(module.exports, "getBaseAutomationUrl", () => $b61a7afc01657dc2$export$8e479e490e1e69bc);
const $b61a7afc01657dc2$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ if (projectType === 'service_desk') return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
    if (projectType === 'business') return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
};

});

parcelRegister("2aqLT", function(module, exports) {
module.exports = new URL("lightning.44c03a60.svg", import.meta.url).toString();

});

parcelRegister("4eavD", function(module, exports) {

$parcel$export(module.exports, "default", () => $428af210918cdaf9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $428af210918cdaf9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    setupReleaseAutomation: {
        "id": "project-directories.versions.release-version-modal.content.release-automation-banner.setup-release-automation",
        "defaultMessage": "Set up release automation"
    },
    dismiss: {
        "id": "project-directories.versions.release-version-modal.content.release-automation-banner.dismiss",
        "defaultMessage": "Dismiss"
    }
});

});


parcelRegister("50qub", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b98138cc474c021$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $3yLu1 = parcelRequire("3yLu1");

var $ai3Yq = parcelRequire("ai3Yq");

var $4oJgc = parcelRequire("4oJgc");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9b98138cc474c021$var$mapStateToProps = (state)=>({
        releaseDate: (0, $ai3Yq.getReleaseDate)(state),
        errors: (0, $ai3Yq.getErrors)(state),
        isSaving: (0, $ai3Yq.isSaving)(state)
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9b98138cc474c021$var$dispatcher = (dispatch)=>({
        // @ts-expect-error - TS7006 - Parameter 'version' implicitly has an 'any' type.
        onInputChange: (version)=>dispatch((0, $3yLu1.releaseVersionUpdate)(version))
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9b98138cc474c021$var$mapDispatchToProps = (dispatch)=>$9b98138cc474c021$var$dispatcher(dispatch);
var $9b98138cc474c021$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($9b98138cc474c021$var$mapStateToProps, $9b98138cc474c021$var$mapDispatchToProps)((0, $4oJgc.default));

});
parcelRegister("4oJgc", function(module, exports) {

$parcel$export(module.exports, "default", () => $5beb35f217cab24a$export$2e2bcd8739ae039);
/* ReleaseDatePicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jj52j = parcelRequire("jj52j");

var $cHapz = parcelRequire("cHapz");

var $7O4UO = parcelRequire("7O4UO");

var $8tAHc = parcelRequire("8tAHc");

var $az4zD = parcelRequire("az4zD");

var $2LuBw = parcelRequire("2LuBw");

var $lhpg4 = parcelRequire("lhpg4");
class $5beb35f217cab24a$export$55e7fadddcffb796 extends (0, $5uXOq.Component) {
    inputChange(update) {
        const { onInputChange: onInputChange } = this.props;
        onInputChange({
            releaseDate: update.releaseDate
        });
    }
    render() {
        const { intl: { formatMessage: formatMessage, locale: locale }, releaseDate: releaseDate, errors: errors, isSaving: isSaving } = this.props;
        const { releaseDate: releaseDateError } = errors;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            id: formatMessage((0, $lhpg4.default).releaseDate),
            name: "releaseDate",
            label: formatMessage((0, $lhpg4.default).releaseDate)
        }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5beb35f217cab24a$var$DatePickerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2LuBw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cHapz.default), {
                id: formatMessage((0, $lhpg4.default).releaseDate),
                isDisabled: isSaving,
                defaultValue: releaseDate !== '' ? (0, $jj52j.default)(new Date(releaseDate)) : releaseDate,
                onChange: this.onReleaseDateChange,
                placeholder: formatMessage((0, $8tAHc.default).placeholderDate),
                locale: locale,
                shouldShowCalendarButton: true
            })))), releaseDateError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5beb35f217cab24a$var$ValidationError, null, releaseDateError));
    }
    constructor(...args){
        super(...args), this.onReleaseDateChange = (releaseDate)=>{
            if (releaseDate) this.inputChange({
                releaseDate: releaseDate
            });
            else this.inputChange({
                releaseDate: ''
            });
        };
    }
}
var $5beb35f217cab24a$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $az4zD.injectIntlV2)($5beb35f217cab24a$export$55e7fadddcffb796);
const $5beb35f217cab24a$var$DatePickerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1ssb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5beb35f217cab24a$var$ValidationError = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc _syaz1tmw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cHapz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a844b50b385d50f7$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $cKsfY = parcelRequire("cKsfY");

var $2TI0z = parcelRequire("2TI0z");

var $jcbUF = parcelRequire("jcbUF");
const $a844b50b385d50f7$var$DatePicker = (0, $cKsfY.componentWithCondition)(()=>(0, $VSDnB.fg)('dst-date-picker-use-functional-component'), (0, $jcbUF.default), (0, $2TI0z.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a844b50b385d50f7$export$2e2bcd8739ae039 = $a844b50b385d50f7$var$DatePicker;

});
parcelRegister("cKsfY", function(module, exports) {

$parcel$export(module.exports, "componentWithCondition", () => $8f027f90da2b6bac$export$6e8ea24b15199873);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $8f027f90da2b6bac$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>condition() ? /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    return ComponentWithCondition;
}

});

parcelRegister("2TI0z", function(module, exports) {

$parcel$export(module.exports, "default", () => $19201d0a1f7d7d54$export$2e2bcd8739ae039);
/* date-picker-class.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $42CjB = parcelRequire("42CjB");

var $3JT92 = parcelRequire("3JT92");

var $9KnKW = parcelRequire("9KnKW");

var $acknU = parcelRequire("acknU");

var $7qZ1x = parcelRequire("7qZ1x");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $7K5PP = parcelRequire("7K5PP");
var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $5RLF6 = parcelRequire("5RLF6");

var $iaQLg = parcelRequire("iaQLg");

var $gtijU = parcelRequire("gtijU");

var $6AqCE = parcelRequire("6AqCE");

var $dBs4v = parcelRequire("dBs4v");
const $19201d0a1f7d7d54$var$packageName = "platform-pkg";
const $19201d0a1f7d7d54$var$packageVersion = "0.0.0-use.local";
const $19201d0a1f7d7d54$var$datePickerDefaultProps = {
    defaultIsOpen: false,
    defaultValue: '',
    disabled: [],
    disabledDateFilter: (_)=>false,
    locale: 'en-US',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{} /* eslint-enable @repo/internal/react/use-noop */ 
};
const $19201d0a1f7d7d54$var$styles = {
    pickerContainerStyles: "_kqswh2mm",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz131l _152tze3t _rjxpze3t _30l31gjq",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o"
}; // eslint-disable-next-line @repo/internal/react/no-class-components
class $19201d0a1f7d7d54$export$df43d21f5faca9f7 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = $19201d0a1f7d7d54$var$datePickerDefaultProps;
    }
    constructor(props){
        super(props), this.containerRef = null, this.calendarRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), this.calendarButtonRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), // correctly to allow controlled/uncontrolled usage.
        this.getValue = ()=>this.props.value ?? this.state.value, this.getIsOpen = ()=>this.props.isOpen ?? this.state.isOpen, this.onCalendarChange = ({ iso: iso })=>{
            this.setState({
                calendarValue: (0, $5RLF6.getParsedISO)({
                    iso: iso
                })
            });
        }, this.onCalendarSelect = ({ iso: iso })=>{
            this.setState({
                selectInputValue: '',
                isOpen: false,
                calendarValue: iso,
                value: iso,
                wasOpenedFromCalendarButton: false
            });
            this.props.onChange(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
            // on the inner input of Select itself, which would require a lot of
            // extra stuff in the Select component for only this one thing. While
            // this would be more "React-y", it doesn't seem to pose any other
            // benefits. Performance-wise, we are only searching within the
            // container, so it's quick.
            if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
            else {
                const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                innerCombobox?.focus();
            }
            this.setState({
                isOpen: false
            });
        }, this.onInputClick = ()=>{
            if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!this.containerRef?.contains(newlyFocusedElement)) {
                this.setState({
                    isOpen: false,
                    shouldSetFocusOnCurrentDay: false,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onBlur(event);
            }
        }, this.onContainerFocus = ()=>{
            this.setState({
                shouldSetFocusOnCurrentDay: false
            });
        }, this.onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (this.state.clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else if (!this.containerRef?.contains(newlyFocusedElement)) // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            this.setState({
                isOpen: false,
                isFocused: false,
                wasOpenedFromCalendarButton: false
            });
        }, this.onSelectFocus = (event)=>{
            const { clearingFromIcon: clearingFromIcon } = this.state;
            const value = this.getValue();
            if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                // Don't open when focused into via keyboard if the calendar button is present
                isOpen: !this.props.shouldShowCalendarButton,
                calendarValue: value,
                isFocused: true,
                wasOpenedFromCalendarButton: false
            });
            this.props.onFocus(event);
        }, this.onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, $5RLF6.parseDate)(inputValue, {
                    parseInputValue: this.props.parseInputValue,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                }); // Only try to set the date if we have month & day
                if (parsed && (0, $jovBr.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
                // this is the format expected by the @atlaskit/calendar component
                this.setState({
                    calendarValue: (0, $6AqCE.getShortISOString)(parsed)
                });
            }
            this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onInputKeyDown = (event)=>{
            const { calendarValue: calendarValue } = this.state;
            const value = this.getValue();
            const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
            if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
            switch(keyPressed){
                case 'escape':
                    // Yes, this is not ideal. The alternative is to be able to place a ref
                    // on the inner input of Select itself, which would require a lot of
                    // extra stuff in the Select component for only this one thing. While
                    // this would be more "React-y", it doesn't seem to pose any other
                    // benefits. Performance-wise, we are only searching within the
                    // container, so it's quick.
                    if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                    else {
                        const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                        innerCombobox?.focus();
                    }
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false,
                        wasOpenedFromCalendarButton: false
                    });
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) // If being cleared from keyboard, don't change behaviour
                        this.setState({
                            clearingFromIcon: false,
                            value: ''
                        });
                        break;
                    }
                case 'enter':
                    if (!this.state.isOpen) return;
                     // Prevent form submission when a date is selected
                    // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                    // for more details.
                    event.preventDefault();
                    if (!(0, $5RLF6.isDateDisabled)(calendarValue, {
                        disabled: this.props.disabled
                    })) {
                        // Get a safe `calendarValue` in case the value exceeds the maximum
                        // allowed by ISO 8601
                        const safeCalendarValue = (0, $6AqCE.getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        this.setState({
                            selectInputValue: '',
                            isOpen: false,
                            value: safeCalendarValue,
                            calendarValue: safeCalendarValue,
                            wasOpenedFromCalendarButton: false
                        });
                        if (valueChanged) this.props.onChange(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (!this.state.shouldSetFocusOnCurrentDay) this.setState({
                        isOpen: true,
                        shouldSetFocusOnCurrentDay: true
                    });
                    break;
                default:
                    break;
            }
        }, this.onCalendarButtonKeyDown = (e)=>{
            // Don't allow an arrow up or down to open the menu, since the input key
            // down handler is actually on the parent.
            if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
             // We want to stop this from triggering other keydown events, particularly
            // for space and enter presses. Otherwise, it opens and then closes
            // immediately.
            if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                e.stopPropagation();
                this.setState({
                    isKeyDown: true,
                    wasOpenedFromCalendarButton: true
                });
            }
        } // This event handler is triggered from both keydown and click. It's weird.
        , this.onCalendarButtonClick = (e)=>{
            this.setState({
                isOpen: !this.state.isOpen,
                wasOpenedFromCalendarButton: true
            }, ()=>{
                // We don't want the focus to move if this is a click event
                if (!this.state.isKeyDown) return;
                this.setState({
                    isKeyDown: false
                }); // Focus on the first button within the calendar
                this.calendarRef?.current?.querySelector('button')?.focus();
            });
            e.stopPropagation();
        }, this.onClear = ()=>{
            let changedState = {
                value: '',
                calendarValue: this.props.defaultValue || (0, $6AqCE.getShortISOString)(new Date())
            };
            if (!this.props.hideIcon) changedState = {
                ...changedState,
                clearingFromIcon: true
            };
            this.setState(changedState);
            this.props.onChange('');
        } // `unknown` is used because `value` is unused so it does not matter.
        , this.onSelectChange = (_value, action)=>{
            // Used for native clear event in React Select
            // Triggered when clicking ClearIndicator or backspace with no value
            if (action.action === 'clear') this.onClear();
        }, this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
            const onInputChange = this.props.selectProps?.onInputChange;
            if (onInputChange) onInputChange(selectInputValue, actionMeta);
            this.setState({
                selectInputValue: selectInputValue
            });
        }, this.getContainerRef = (ref)=>{
            const oldRef = this.containerRef;
            this.containerRef = ref; // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) this.forceUpdate();
        };
        this.state = {
            isKeyDown: false,
            isOpen: this.props.defaultIsOpen,
            isFocused: false,
            clearingFromIcon: false,
            selectInputValue: this.props.selectProps?.inputValue || '',
            value: this.props.value || this.props.defaultValue,
            calendarValue: this.props.value || this.props.defaultValue || (0, $6AqCE.getShortISOString)(new Date()),
            l10n: (0, $7qZ1x.createLocalizationProvider)(this.props.locale),
            locale: this.props.locale,
            shouldSetFocusOnCurrentDay: false,
            wasOpenedFromCalendarButton: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.locale !== prevState.locale) return {
            l10n: (0, $7qZ1x.createLocalizationProvider)(nextProps.locale),
            locale: nextProps.locale
        };
        else return null;
    }
    render() {
        const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', disabled: disabled, disabledDateFilter: disabledDateFilter, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($acknU))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
        const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
        const value = this.getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = this.getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
        let clearIndicator = Icon; // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $19201d0a1f7d7d54$var$styles.dropdownIndicatorStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                    ...props
                })
            });
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
        const SingleValue = (0, $dBs4v.makeSingleValue)({
            lang: this.props.locale
        });
        const selectComponents = {
            DropdownIndicator: shouldShowCalendarButton ? (0, $jHBnA.EmptyComponent) : dropDownIcon,
            // Only use this new container component if the calendar button is shown.
            // Otherwise, it throws errors downstream for some reason
            ...shouldShowCalendarButton ? {
                IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $iaQLg.IndicatorsContainer), {
                        ...props,
                        showClearIndicator: showClearIndicator
                    })
            } : {},
            Menu: $gtijU.Menu,
            SingleValue: SingleValue,
            ...!showClearIndicator && {
                ClearIndicator: (0, $jHBnA.EmptyComponent)
            },
            ...selectProps.components
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: this.containerRef,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarRef: this.calendarRef,
            calendarValue: value && (0, $6AqCE.getShortISOString)((0, $eZDAP.default)(value)),
            calendarView: calendarValue,
            onCalendarChange: this.onCalendarChange,
            onCalendarSelect: this.onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay,
            menuInnerWrapper: this.props.menuInnerWrapper
        }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
        const mergedStyles = (0, $7VXAu.mergeStyles)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    // ICON_PADDING = 2
                    paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
                })
        });
        const initialValue = value ? {
            label: (0, $5RLF6.formatDate)(value, {
                formatDisplayLabel: this.props.formatDisplayLabel,
                dateFormat: this.props.dateFormat,
                l10n: this.state.l10n
            }),
            value: value
        } : null; // `label` takes precedence of the `inputLabel`
        const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            ...innerProps,
            role: "presentation",
            onBlur: this.onContainerBlur,
            onFocus: this.onContainerFocus,
            onClick: this.onInputClick,
            onInput: this.onTextInput,
            onKeyDown: this.onInputKeyDown,
            ref: this.getContainerRef,
            "data-testid": testId && `${testId}--container`,
            className: (0, $bwpsq.default)([
                $19201d0a1f7d7d54$var$styles.pickerContainerStyles
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value,
                    "data-testid": testId && `${testId}--input`
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7K5PP.default), {
                    appearance: this.props.appearance,
                    "aria-describedby": ariaDescribedBy,
                    label: label || undefined,
                    autoFocus: autoFocus,
                    clearControlLabel: clearControlLabel,
                    closeMenuOnSelect: true,
                    enableAnimation: false,
                    inputId: id,
                    inputValue: actualSelectInputValue,
                    isDisabled: isDisabled,
                    isRequired: isRequired,
                    menuIsOpen: menuIsOpen,
                    onBlur: this.onSelectBlur,
                    onChange: this.onSelectChange,
                    onFocus: this.onSelectFocus,
                    onInputChange: this.handleSelectInputChange,
                    placeholder: (0, $5RLF6.getPlaceholder)({
                        placeholder: this.props.placeholder,
                        l10n: this.state.l10n
                    }),
                    styles: mergedStyles,
                    value: initialValue,
                    ...selectProps,
                    // up when you alter some of the properties in the `selectComponents`
                    // object. These errors are still present, and I suspect have always
                    // been present, without changing the unrelated code. Ignoring as the
                    // component still works as expected despite this error. And also
                    // because the select refresh team may solve it later.
                    components: selectComponents,
                    // selectProps or not and what wil be overwritten
                    isClearable: true,
                    isInvalid: isInvalid,
                    spacing: spacing,
                    testId: testId,
                    // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                    calendarContainerRef: calendarProps.calendarContainerRef,
                    calendarDisabled: calendarProps.calendarDisabled,
                    calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                    calendarLocale: calendarProps.calendarLocale,
                    calendarMaxDate: calendarProps.calendarMaxDate,
                    calendarMinDate: calendarProps.calendarMinDate,
                    calendarRef: calendarProps.calendarRef,
                    calendarValue: calendarProps.calendarValue,
                    calendarView: calendarProps.calendarView,
                    calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                    nextMonthLabel: nextMonthLabel,
                    onCalendarChange: calendarProps.onCalendarChange,
                    onCalendarSelect: calendarProps.onCalendarSelect,
                    previousMonthLabel: previousMonthLabel,
                    shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                    menuInnerWrapper: calendarProps.menuInnerWrapper
                }),
                shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9KnKW.IdProvider), {
                    prefix: "open-calendar-label--",
                    children: ({ id: openCalendarLabelId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: (0, $3JT92.cx)($19201d0a1f7d7d54$var$styles.iconContainerStyles, value && !hideIcon ? $19201d0a1f7d7d54$var$styles.iconSpacingWithClearButtonStyles : $19201d0a1f7d7d54$var$styles.iconSpacingWithoutClearButtonStyles),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                                appearance: "subtle",
                                label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                                "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                                id: openCalendarLabelId,
                                icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acknU))), {
                                        ...iconProps,
                                        color: "var(--ds-icon, #44546F)"
                                    }),
                                onClick: this.onCalendarButtonClick,
                                onKeyDown: this.onCalendarButtonKeyDown,
                                ref: this.calendarButtonRef,
                                testId: testId && `${testId}--open-calendar-button`
                            })
                        })
                }) : null
            ]
        });
    }
}
const $19201d0a1f7d7d54$var$DatePicker = (0, $994MI.default)({
    componentName: 'datePicker',
    packageName: $19201d0a1f7d7d54$var$packageName,
    packageVersion: $19201d0a1f7d7d54$var$packageVersion
})((0, $cb25w.default)({
    onChange: (0, $gB4mS.default)('atlaskit')({
        action: 'selectedDate',
        actionSubject: 'datePicker',
        attributes: {
            componentName: 'datePicker',
            packageName: $19201d0a1f7d7d54$var$packageName,
            packageVersion: $19201d0a1f7d7d54$var$packageVersion
        }
    })
})($19201d0a1f7d7d54$export$df43d21f5faca9f7));
var $19201d0a1f7d7d54$export$2e2bcd8739ae039 = $19201d0a1f7d7d54$var$DatePicker;

});
parcelRegister("acknU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9571ec76557171a7f54748c218c48225>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76cad653a4883392$var$_react = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $76cad653a4883392$var$_calendar = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("3fesp")));

var $76cad653a4883392$var$_calendar2 = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("cTemL")));
function $76cad653a4883392$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76cad653a4883392$var$CalendarIcon = (props)=>/*#__PURE__*/ $76cad653a4883392$var$_react.default.createElement($76cad653a4883392$var$_calendar.default, Object.assign({
        LEGACY_fallbackIcon: $76cad653a4883392$var$_calendar2.default
    }, props));
$76cad653a4883392$var$CalendarIcon.Name = 'CalendarIconMigration';
var $76cad653a4883392$var$_default = module.exports.default = $76cad653a4883392$var$CalendarIcon;

});
parcelRegister("3fesp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25cdfcb8bb836404$var$_react = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $25cdfcb8bb836404$var$_baseNew = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $25cdfcb8bb836404$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25cdfcb8bb836404$var$CalendarIcon = (props)=>/*#__PURE__*/ $25cdfcb8bb836404$var$_react.default.createElement($25cdfcb8bb836404$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$25cdfcb8bb836404$var$CalendarIcon.displayName = 'CalendarIcon';
var $25cdfcb8bb836404$var$_default = module.exports.default = $25cdfcb8bb836404$var$CalendarIcon;

});

parcelRegister("cTemL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9625c3edd02eaf26$var$_react = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $9625c3edd02eaf26$var$_calendar = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("3fesp")));
function $9625c3edd02eaf26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9625c3edd02eaf26$var$CalendarIcon = (props)=>/*#__PURE__*/ $9625c3edd02eaf26$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $9625c3edd02eaf26$var$_calendar.default
    }));
$9625c3edd02eaf26$var$CalendarIcon.displayName = 'CalendarIcon';
var $9625c3edd02eaf26$var$_default = module.exports.default = $9625c3edd02eaf26$var$CalendarIcon;

});


parcelRegister("7qZ1x", function(module, exports) {

$parcel$export(module.exports, "createLocalizationProvider", () => $71bdd27445bf5301$export$ea56ca58f08ffa52);

var $lCAti = parcelRequire("lCAti");

var $is0Fy = parcelRequire("is0Fy");

var $1cWOp = parcelRequire("1cWOp");
const $71bdd27445bf5301$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $lCAti.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $is0Fy.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $1cWOp.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $1cWOp.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("lCAti", function(module, exports) {

$parcel$export(module.exports, "normalizeLocale", () => $13af55a9724edafd$export$dca0327c9b9c6498);
const $13af55a9724edafd$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("is0Fy", function(module, exports) {

$parcel$export(module.exports, "createDateParser", () => $d8bb223589902df4$export$cfa2ef2687faeda2);

var $lCAti = parcelRequire("lCAti");

var $3wYKB = parcelRequire("3wYKB");
const $d8bb223589902df4$var$INVALID_DATE = new Date(NaN);
const $d8bb223589902df4$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $d8bb223589902df4$var$INVARIANT_DATE = (0, $3wYKB.toDate)($d8bb223589902df4$var$INVARIANT);
const $d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $d8bb223589902df4$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $d8bb223589902df4$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $d8bb223589902df4$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $d8bb223589902df4$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $lCAti.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($d8bb223589902df4$var$INVARIANT_DATE);
    const shortDate = $d8bb223589902df4$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $d8bb223589902df4$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $d8bb223589902df4$var$stripExtras(date).match($d8bb223589902df4$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $d8bb223589902df4$var$INVALID_DATE;
        const dateParts = $d8bb223589902df4$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $3wYKB.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $3wYKB.isValid)(normalizedDate)) return $d8bb223589902df4$var$INVALID_DATE;
        return (0, $3wYKB.toDate)(normalizedDate);
    };
};

});
parcelRegister("3wYKB", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $121d324fc62f760d$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $121d324fc62f760d$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $121d324fc62f760d$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $121d324fc62f760d$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $121d324fc62f760d$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $121d324fc62f760d$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $121d324fc62f760d$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $121d324fc62f760d$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $121d324fc62f760d$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $121d324fc62f760d$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $121d324fc62f760d$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = $121d324fc62f760d$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("1cWOp", function(module, exports) {

$parcel$export(module.exports, "toFormattedParts", () => $56bd04270448c035$export$9b7ca29af37c192);
const $56bd04270448c035$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("jHBnA", function(module, exports) {

$parcel$export(module.exports, "EmptyComponent", () => $91948b176ea23188$export$5e30e9a24d6c1203);
$parcel$export(module.exports, "placeholderDatetime", () => $91948b176ea23188$export$fff8babee5abe3e2);
$parcel$export(module.exports, "defaultTimes", () => $91948b176ea23188$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "defaultTimeFormat", () => $91948b176ea23188$export$9e6d8fcf62256b85);
$parcel$export(module.exports, "defaultDateFormat", () => $91948b176ea23188$export$75032c84f56650eb);
$parcel$export(module.exports, "padToTwo", () => $91948b176ea23188$export$a7de57e5b672ccdb);
$parcel$export(module.exports, "formatDateTimeZoneIntoIso", () => $91948b176ea23188$export$2eeb05a2ecc2ce0a);
/**
 * This component is used to hide portions of Select component.
 */ const $91948b176ea23188$export$5e30e9a24d6c1203 = ()=>null;
const $91948b176ea23188$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
const $91948b176ea23188$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
const $91948b176ea23188$export$9e6d8fcf62256b85 = 'h:mma';
const $91948b176ea23188$export$75032c84f56650eb = 'YYYY/MM/DD';
function $91948b176ea23188$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
function $91948b176ea23188$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}

});

parcelRegister("5RLF6", function(module, exports) {

$parcel$export(module.exports, "isDateDisabled", () => $e0db4b6edb7dbfac$export$d38e7e283938128c);
$parcel$export(module.exports, "getParsedISO", () => $e0db4b6edb7dbfac$export$38db26406d1a1ee2);
$parcel$export(module.exports, "parseDate", () => $e0db4b6edb7dbfac$export$6b862160d295c8e);
$parcel$export(module.exports, "formatDate", () => $e0db4b6edb7dbfac$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getPlaceholder", () => $e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0);
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ 
var $k7m40 = parcelRequire("k7m40");
var $5I2ju = parcelRequire("5I2ju");
var $eZDAP = parcelRequire("eZDAP");

var $2ucUe = parcelRequire("2ucUe");

var $jHBnA = parcelRequire("jHBnA");
const $e0db4b6edb7dbfac$export$d38e7e283938128c = (date, di)=>{
    const { disabled: disabled } = di;
    return disabled.indexOf(date) > -1;
};
const $e0db4b6edb7dbfac$export$38db26406d1a1ee2 = (di)=>{
    const { iso: iso } = di;
    const [year, month, date] = iso.split('-');
    let newIso = iso;
    const parsedDate = parseInt(date, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedYear = parseInt(year, 10);
    const lastDayInMonth = (0, $5I2ju.default)(new Date(parsedYear, parsedMonth - 1)).getDate();
    if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, $jHBnA.padToTwo)(parsedMonth)}-${(0, $jHBnA.padToTwo)(lastDayInMonth)}`;
    else newIso = `${parsedYear}-${(0, $jHBnA.padToTwo)(parsedMonth)}-${(0, $jHBnA.padToTwo)(parsedDate)}`;
    return newIso;
};
const $e0db4b6edb7dbfac$export$6b862160d295c8e = (date, di)=>{
    const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
    if (parseInputValue) return parseInputValue(date, dateFormat || (0, $jHBnA.defaultDateFormat));
    return l10n.parseDate(date);
};
const $e0db4b6edb7dbfac$export$3ae94a2503e890a1 = (value, di)=>{
    const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
    if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $jHBnA.defaultDateFormat));
    const date = (0, $eZDAP.default)(value);
    return dateFormat ? (0, $k7m40.default)(date, (0, $2ucUe.convertTokens)(dateFormat)) : l10n.formatDate(date);
};
const $e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0 = (di)=>{
    const { placeholder: placeholder, l10n: l10n } = di;
    return placeholder || l10n.formatDate((0, $jHBnA.placeholderDatetime));
};

});
parcelRegister("2ucUe", function(module, exports) {

$parcel$export(module.exports, "convertTokens", () => $ca6f20a476eda5dc$export$4d5430175be73d45);
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $ca6f20a476eda5dc$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $ca6f20a476eda5dc$var$v1tokens = Object.keys($ca6f20a476eda5dc$var$tokensMap).sort().reverse();
const $ca6f20a476eda5dc$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$ca6f20a476eda5dc$var$v1tokens.join('|') + '|.)', 'g');
function $ca6f20a476eda5dc$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($ca6f20a476eda5dc$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $ca6f20a476eda5dc$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}

});


parcelRegister("iaQLg", function(module, exports) {

$parcel$export(module.exports, "IndicatorsContainer", () => $d73476b891de3e0c$export$d0ffd7e649cab6f);
/* indicators-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bChGW = parcelRequire("bChGW");
const $d73476b891de3e0c$var$styles = {
    calendarButtonInclusionStyles: "_ahbqxy5q",
    calendarButtonOnlyInclusionStyles: "_ahbq1ejb"
};
const $d73476b891de3e0c$export$d0ffd7e649cab6f = ({ showClearIndicator: showClearIndicator, ...rest })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            showClearIndicator ? $d73476b891de3e0c$var$styles.calendarButtonInclusionStyles : $d73476b891de3e0c$var$styles.calendarButtonOnlyInclusionStyles
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).IndicatorsContainer, {
            ...rest
        })
    });

});

parcelRegister("gtijU", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $e800a879ee1613fc$export$d9b273488cd8ce6f);
/* menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $1f0Hs = parcelRequire("1f0Hs");

var $9MHPe = parcelRequire("9MHPe");

var $avHVh = parcelRequire("avHVh");
/**
 * @param isos A series of ISO dates.
 * @returns The last valid date within the array of ISO strings.
 */ function $e800a879ee1613fc$var$getValidDate(isos) {
    return isos.reduce((acc, iso)=>{
        const date = (0, $eZDAP.default)(iso);
        return (0, $jovBr.default)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
const $e800a879ee1613fc$var$menuStyles = null;
const $e800a879ee1613fc$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
    const { calendarValue: calendarValue, calendarView: calendarView, menuInnerWrapper: MenuInnerWrapper } = selectProps;
    const { day: day, month: month, year: year } = $e800a879ee1613fc$var$getValidDate([
        calendarValue,
        calendarView
    ]);
    const onMenuMouseDown = (event)=>{
        if (event.button !== 0) return;
        event.stopPropagation();
        event.preventDefault();
    };
    const Wrapper = typeof MenuInnerWrapper === 'function' ? MenuInnerWrapper : (0, $5uXOq.Fragment);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9MHPe.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $avHVh.default), {
            inputValue: selectProps.inputValue,
            containerRef: selectProps.calendarContainerRef,
            content: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ...innerProps,
                onMouseDown: onMenuMouseDown,
                className: (0, $bwpsq.default)([
                    "_2rkoglpi _1reo15vq _18m915vq _1pbyowjs _bfhk1bhr _16qs1cd0"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1f0Hs.default), {
                        day: day,
                        month: month,
                        year: year,
                        disabled: selectProps.calendarDisabled,
                        disabledDateFilter: selectProps.calendarDisabledDateFilter,
                        minDate: selectProps.calendarMinDate,
                        maxDate: selectProps.calendarMaxDate,
                        nextMonthLabel: selectProps.nextMonthLabel,
                        onChange: selectProps.onCalendarChange,
                        onSelect: selectProps.onCalendarSelect,
                        previousMonthLabel: selectProps.previousMonthLabel,
                        ref: selectProps.calendarRef,
                        selected: [
                            selectProps.calendarValue
                        ],
                        shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
                        locale: selectProps.calendarLocale,
                        testId: selectProps.testId && `${selectProps.testId}--calendar`,
                        weekStartDay: selectProps.calendarWeekStartDay
                    })
                })
            }),
            testId: selectProps.testId
        })
    });
};

});
parcelRegister("1f0Hs", function(module, exports) {

$parcel$export(module.exports, "default", () => $16abbcd9b9109722$export$2e2bcd8739ae039);
/* calendar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $MHKc7 = parcelRequire("MHKc7");
var $414Wj = parcelRequire("414Wj");

var $ePz3p = parcelRequire("ePz3p");

var $lJWdi = parcelRequire("lJWdi");

var $avO9B = parcelRequire("avO9B");

var $iioJV = parcelRequire("iioJV");

var $jihAA = parcelRequire("jihAA");

var $bbnGB = parcelRequire("bbnGB");

var $hbcve = parcelRequire("hbcve");

var $2TGJ3 = parcelRequire("2TGJ3");

var $f9D1v = parcelRequire("f9D1v");

var $9efze = parcelRequire("9efze");
const $16abbcd9b9109722$var$styles = {
    box: "_1e0c1o8l _uiztglyw"
};
const $16abbcd9b9109722$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $16abbcd9b9109722$var$InnerCalendar = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, $iioJV.blankStringArray), defaultSelected: defaultSelected = (0, $iioJV.blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $eGmKJ.default), onChange: onChange = (0, $eGmKJ.default), onFocus: onFocus = (0, $eGmKJ.default), onSelect: onSelect = (0, $eGmKJ.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $jihAA.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $5uXOq.useState)(false);
    const onChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$16abbcd9b9109722$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear } = (0, $2TGJ3.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$16abbcd9b9109722$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $f9D1v.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $bbnGB.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $9efze.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $hbcve.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextMonthHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getNextYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const nextYear = yearValue + 1;
        return `${monthsLong[thisMonth]} ${nextYear}`;
    };
    const getPreviousMonthHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const getPreviousYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const previousYear = yearValue - 1;
        return `${monthsLong[thisMonth]} ${previousYear}`;
    };
    const headerId = (0, $9KnKW.useId)();
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $2OMIu.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: $16abbcd9b9109722$var$styles.box,
            padding: "space.200",
            "aria-label": "calendar",
            testId: testId && `${testId}--calendar`,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ePz3p.default // The month number needs to be translated to index in the month
                    ), {
                        // name array e.g. 1 (January) -> 0
                        monthLongTitle: monthsLong[monthValue - 1],
                        year: yearValue,
                        nextMonthLabel: nextMonthLabel,
                        previousMonthLabel: previousMonthLabel,
                        nextMonthHeading: getNextMonthHeading(),
                        nextYearHeading: getNextYearHeading(),
                        previousMonthHeading: getPreviousMonthHeading(),
                        previousYearHeading: getPreviousYearHeading(),
                        handleClickNextMonth: handleClickNextMonth,
                        handleClickNextYear: handleClickNextYear,
                        handleClickPrevMonth: handleClickPrevMonth,
                        handleClickPrevYear: handleClickPrevYear,
                        headerId: headerId,
                        tabIndex: tabIndex,
                        testId: testId
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MHKc7.default), {
                        role: "grid",
                        onKeyDown: handleContainerKeyDown,
                        "aria-labelledby": headerId,
                        testId: testId && `${testId}--calendar-dates`,
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $avO9B.default), {
                                daysShort: daysShort,
                                testId: testId
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJWdi.default), {
                                weeks: weeks,
                                handleClickDay: handleClickDay,
                                monthsLong: monthsLong,
                                shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
                                tabIndex: tabIndex,
                                testId: testId
                            })
                        ]
                    })
                ]
            })
        })
    }));
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $16abbcd9b9109722$var$Calendar = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($16abbcd9b9109722$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$16abbcd9b9109722$var$Calendar.displayName = 'Calendar';
var $16abbcd9b9109722$export$2e2bcd8739ae039 = $16abbcd9b9109722$var$Calendar;

});
parcelRegister("ePz3p", function(module, exports) {

$parcel$export(module.exports, "default", () => $995afee12cb828f6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $9KnKW = parcelRequire("9KnKW");

var $l1N8i = parcelRequire("l1N8i");

var $gqS53 = parcelRequire("gqS53");

var $1a4Mo = parcelRequire("1a4Mo");

var $ks8FD = parcelRequire("ks8FD");

var $bpC55 = parcelRequire("bpC55");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
const $995afee12cb828f6$var$Header = /*#__PURE__*/ (0, $5uXOq.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousYearLabel: previousYearLabel = 'Previous year', previousMonthHeading: previousMonthHeading, previousYearHeading: previousYearHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextYearLabel: nextYearLabel = 'Next year', nextMonthHeading: nextMonthHeading, nextYearHeading: nextYearHeading, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $9KnKW.useId)();
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonthOrYear, setHasInteractedWithMonthOrYear] = (0, $5uXOq.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevMonth(e);
    };
    const handlePrevYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevYear(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextMonth(e);
    };
    const handleNextYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextYear(e);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            space: "space.0",
            alignBlock: "center",
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                    space: "space.100",
                    alignBlock: "start",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevYearInteraction,
                            testId: testId && `${testId}--previous-year`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gqS53))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${previousYearLabel}, ${previousYearHeading}`
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevMonthInteraction,
                            testId: testId && `${testId}--previous-month`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ks8FD))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${previousMonthLabel}, ${previousMonthHeading}`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    "aria-live": hasInteractedWithMonthOrYear ? 'polite' : undefined,
                    id: announceId,
                    testId: testId && `${testId}--current-month-year--container`,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                        size: "xsmall",
                        as: "h2",
                        id: headerId,
                        testId: testId && `${testId}--current-month-year`,
                        children: `${monthLongTitle} ${year}`
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                    space: "space.100",
                    alignBlock: "end",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextMonthInteraction,
                            testId: testId && `${testId}--next-month`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bpC55))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${nextMonthLabel}, ${nextMonthHeading}`
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextYearInteraction,
                            testId: testId && `${testId}--next-year`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1a4Mo))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${nextYearLabel}, ${nextYearHeading}`
                        })
                    ]
                })
            ]
        })
    });
});
$995afee12cb828f6$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$995afee12cb828f6$export$2e2bcd8739ae039 = $995afee12cb828f6$var$Header;

});
parcelRegister("gqS53", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::89a5ee1ee34f6c51127fc5be19fb8c41>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bf69065665122720$var$_react = $bf69065665122720$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bf69065665122720$var$_baseNew = $bf69065665122720$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $bf69065665122720$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Navigate to previous year in calendar/date picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bf69065665122720$var$ChevronDoubleLeftIcon = (props)=>/*#__PURE__*/ $bf69065665122720$var$_react.default.createElement($bf69065665122720$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m7.72 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L3.31 8l5.47-5.47z"/><path fill="currentcolor" d="m12.47 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L8.06 8l5.47-5.47z"/>`
    }, props));
$bf69065665122720$var$ChevronDoubleLeftIcon.displayName = 'ChevronDoubleLeftIcon';
var $bf69065665122720$var$_default = module.exports.default = $bf69065665122720$var$ChevronDoubleLeftIcon;

});

parcelRegister("1a4Mo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a70faad39a1700c3cb50a44f6bcc1a4e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d8a6ebd9b94ee9b$var$_react = $0d8a6ebd9b94ee9b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0d8a6ebd9b94ee9b$var$_baseNew = $0d8a6ebd9b94ee9b$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0d8a6ebd9b94ee9b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Navigate to next year in calendar/date picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0d8a6ebd9b94ee9b$var$ChevronDoubleRightIcon = (props)=>/*#__PURE__*/ $0d8a6ebd9b94ee9b$var$_react.default.createElement($0d8a6ebd9b94ee9b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m8.28 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L12.69 8 7.22 2.53z"/><path fill="currentcolor" d="m3.53 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L7.94 8 2.47 2.53z"/>`
    }, props));
$0d8a6ebd9b94ee9b$var$ChevronDoubleRightIcon.displayName = 'ChevronDoubleRightIcon';
var $0d8a6ebd9b94ee9b$var$_default = module.exports.default = $0d8a6ebd9b94ee9b$var$ChevronDoubleRightIcon;

});

parcelRegister("ks8FD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b851fec559156e1edca3c5f214f4a7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee3d25fb52825f26$var$_react = $ee3d25fb52825f26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ee3d25fb52825f26$var$_baseNew = $ee3d25fb52825f26$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ee3d25fb52825f26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ee3d25fb52825f26$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $ee3d25fb52825f26$var$_react.default.createElement($ee3d25fb52825f26$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$ee3d25fb52825f26$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $ee3d25fb52825f26$var$_default = module.exports.default = $ee3d25fb52825f26$var$ChevronLeftIcon;

});


parcelRegister("lJWdi", function(module, exports) {

$parcel$export(module.exports, "default", () => $43f22a52ec309eeb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");

var $1q4y8 = parcelRequire("1q4y8");

var $h581D = parcelRequire("h581D");
const $43f22a52ec309eeb$var$WeekDays = /*#__PURE__*/ (0, $5uXOq.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`,
        children: weeks.map((week, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $h581D.default), {
                testId: testId && `${testId}--week`,
                children: week.values.map((weekDay)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1q4y8.default), {
                        isDisabled: weekDay.isDisabled,
                        isFocused: weekDay.isFocused,
                        isToday: weekDay.isToday,
                        dayLong: weekDay.weekDayName,
                        month: weekDay.month,
                        monthLong: monthsLong[weekDay.month - 1],
                        onClick: handleClickDay,
                        isPreviouslySelected: weekDay.isPreviouslySelected,
                        isSelected: weekDay.isSelected,
                        isSibling: weekDay.isSiblingMonth,
                        year: weekDay.year,
                        shouldSetFocus: shouldSetFocus,
                        tabIndex: tabIndex,
                        testId: testId,
                        children: weekDay.day
                    }, `${week.id}-${weekDay.id}`))
            }, i))
    });
});
$43f22a52ec309eeb$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$43f22a52ec309eeb$export$2e2bcd8739ae039 = $43f22a52ec309eeb$var$WeekDays;

});
parcelRegister("1q4y8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d70b02566a310b79$export$2e2bcd8739ae039);
/* date.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eGmKJ = parcelRequire("eGmKJ");

var $joKkQ = parcelRequire("joKkQ");
const $d70b02566a310b79$var$dateCellSiblingStyle = null;
const $d70b02566a310b79$var$dateCellTodayStyle = null;
const $d70b02566a310b79$var$dateCellPrevSelectedStyle = null;
const $d70b02566a310b79$var$dateCellSelectedStyle = null;
const $d70b02566a310b79$var$dateCellDisabledStyle = null;
const $d70b02566a310b79$var$dateCellStyles = null;
const $d70b02566a310b79$var$Date = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $eGmKJ.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $5uXOq.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $joKkQ.default), {
        role: "gridcell",
        alignItems: "center",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
            "aria-current": isToday ? 'date' : undefined,
            "aria-disabled": isDisabled || undefined,
            "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
            "aria-pressed": isSelected ? 'true' : 'false',
            tabIndex: isFocused ? tabIndex : -1,
            type: "button",
            onClick: handleClick,
            ref: focusRef,
            "data-disabled": isDisabled || undefined,
            "data-focused": isFocused || undefined,
            "data-prev-selected": isPreviouslySelected || undefined,
            "data-selected": isSelected || undefined,
            "data-sibling": isSibling || undefined,
            "data-today": isToday || undefined,
            "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`),
            className: (0, $bwpsq.default)([
                "_kkk2n7od _2rko1l7b _11c82smr _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1ule _kqswh2mm _16jlkb7n _bfhk18uv _syazj3m3 _80omtlke _85i51b66 _1q511b66 _y4tirdoj _bozgrdoj _y3gn1h6o _pojj194a _10knnqa1 _1wysyh40 _irr314ae _30l3j3m3 _1di61l7b _9h8hj3m3",
                isSibling && "_syaz1wmz _30l31wmz",
                isToday && "_syaz1ldt _k48p1igg _1ywu1ule _1qdgyh40 _18postnw _1hfk1r31 _aetrb3bt _1gufv77o _1czdv77o _g0nfv77o",
                isPreviouslySelected && "_bfhk29zg _syazc8hx _30l3c8hx",
                isSelected && "_bfhk1p4p _syazqueg _irr3quvt _30l31uqy",
                isDisabled && "_syaz7dlb _80om13gf _irr318uv _30l37dlb"
            ]),
            children: day
        })
    });
}));
$d70b02566a310b79$var$Date.displayName = 'Date';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d70b02566a310b79$export$2e2bcd8739ae039 = $d70b02566a310b79$var$Date;

});
parcelRegister("joKkQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $975a473d4552aaa0$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $975a473d4552aaa0$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $975a473d4552aaa0$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $975a473d4552aaa0$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $975a473d4552aaa0$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $975a473d4552aaa0$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $975a473d4552aaa0$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $975a473d4552aaa0$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $975a473d4552aaa0$var$Grid = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $bwpsq.default)([
            $975a473d4552aaa0$var$baseStyles.root,
            gap && $975a473d4552aaa0$var$columnGapMap[gap],
            columnGap && $975a473d4552aaa0$var$columnGapMap[columnGap],
            gap && $975a473d4552aaa0$var$rowGapMap[gap],
            rowGap && $975a473d4552aaa0$var$rowGapMap[rowGap],
            alignItems && $975a473d4552aaa0$var$alignItemsMap[alignItems],
            alignContent && $975a473d4552aaa0$var$alignContentMap[alignContent],
            justifyContent && $975a473d4552aaa0$var$justifyContentMap[justifyContent],
            autoFlow && $975a473d4552aaa0$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$975a473d4552aaa0$var$Grid.displayName = 'Grid';
var $975a473d4552aaa0$export$2e2bcd8739ae039 = $975a473d4552aaa0$var$Grid;

});


parcelRegister("h581D", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c8aba25f4ae00ff$export$2e2bcd8739ae039);
/* week-day-grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $joKkQ = parcelRequire("joKkQ");
const $5c8aba25f4ae00ff$var$styles = {
    templateColumns: "_yv0eloeq"
};
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $5c8aba25f4ae00ff$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $joKkQ.default), {
        testId: testId,
        xcss: $5c8aba25f4ae00ff$var$styles.templateColumns,
        role: "row",
        children: children
    });
    return isHidden ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "aria-hidden": "true",
        children: row
    }) : row;
};
var $5c8aba25f4ae00ff$export$2e2bcd8739ae039 = $5c8aba25f4ae00ff$var$WeekDayGrid;

});


parcelRegister("avO9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $f29b1b1295ce3a84$export$2e2bcd8739ae039);
/* week-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $h581D = parcelRequire("h581D");
const $f29b1b1295ce3a84$var$styles = {
    columnHeader: "_1ul98pqr _o5721q9c _1e0c1txw _1bah1h6o"
};
const $f29b1b1295ce3a84$var$WeekHeader = /*#__PURE__*/ (0, $5uXOq.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h581D.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`,
        children: daysShort.map((shortDay)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                padding: "space.100",
                xcss: $f29b1b1295ce3a84$var$styles.columnHeader,
                role: "columnheader",
                testId: testId && `${testId}--column-header`,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                    weight: "bold",
                    size: "UNSAFE_small",
                    align: "center",
                    color: "color.text.subtle",
                    children: shortDay
                })
            }, shortDay))
    });
});
$f29b1b1295ce3a84$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f29b1b1295ce3a84$export$2e2bcd8739ae039 = $f29b1b1295ce3a84$var$WeekHeader;

});

parcelRegister("iioJV", function(module, exports) {

$parcel$export(module.exports, "arrowKeys", () => $85c2ac8e9452c4bf$export$8b15eca9c6d5c48a);
$parcel$export(module.exports, "daysPerWeek", () => $85c2ac8e9452c4bf$export$3ae905d9742bef55);
$parcel$export(module.exports, "monthsPerYear", () => $85c2ac8e9452c4bf$export$c9b7c010035d60c6);
$parcel$export(module.exports, "blankStringArray", () => $85c2ac8e9452c4bf$export$8fa20d70624f8b9d);
const $85c2ac8e9452c4bf$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
const $85c2ac8e9452c4bf$export$3ae905d9742bef55 = 7;
const $85c2ac8e9452c4bf$export$c9b7c010035d60c6 = 12;
const $85c2ac8e9452c4bf$export$8fa20d70624f8b9d = [];

});

parcelRegister("jihAA", function(module, exports) {

$parcel$export(module.exports, "default", () => $654a69afe715a212$export$2e2bcd8739ae039);

var $33etG = parcelRequire("33etG");

var $f8qry = parcelRequire("f8qry");

var $3EtUb = parcelRequire("3EtUb");
function $654a69afe715a212$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $f8qry.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $33etG.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $33etG.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $33etG.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $33etG.default)(today, ()=>today || `${thisYear}-${(0, $3EtUb.default)(thisMonth)}-${(0, $3EtUb.default)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $33etG.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $33etG.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});
parcelRegister("3EtUb", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd804e1790f6d755$export$2e2bcd8739ae039);
function $cd804e1790f6d755$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});


parcelRegister("bbnGB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ccb38b64bb63461$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $8ccb38b64bb63461$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $5uXOq.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $5uXOq.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("hbcve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fe53b5f3382c02e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eZDAP = parcelRequire("eZDAP");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");

var $5wbTt = parcelRequire("5wbTt");
function $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $5uXOq.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $iioJV.daysPerWeek) : 0;
            return (0, $5wbTt.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $iioJV.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $0fe53b5f3382c02e$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $5uXOq.useMemo)(()=>(0, $5wbTt.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $eZDAP.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $eZDAP.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $5uXOq.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $6ASl9.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $eZDAP.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});
parcelRegister("6ASl9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6ae62fd51c4538f$export$2e2bcd8739ae039);

var $3EtUb = parcelRequire("3EtUb");
function $b6ae62fd51c4538f$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $3EtUb.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $3EtUb.default)(date.day)}`;
}

});

parcelRegister("5wbTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dff1ed1384abe91$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $iioJV = parcelRequire("iioJV");

var $9Zmg7 = parcelRequire("9Zmg7");
function $3dff1ed1384abe91$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $iioJV.daysPerWeek) - weekStartDay + firstDay) % (0, $iioJV.daysPerWeek));
    const lastDate = (0, $9Zmg7.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $iioJV.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $9Zmg7.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $iioJV.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $iioJV.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $iioJV.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $iioJV.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $iioJV.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});
parcelRegister("9Zmg7", function(module, exports) {

$parcel$export(module.exports, "default", () => $878800070b837d93$export$2e2bcd8739ae039);
function $878800070b837d93$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});



parcelRegister("2TGJ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $caae4eff24f6e8d0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");

var $9Zmg7 = parcelRequire("9Zmg7");
const $caae4eff24f6e8d0$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $iioJV.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $caae4eff24f6e8d0$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $iioJV.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $caae4eff24f6e8d0$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $5uXOq.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $6ASl9.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $5uXOq.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $iioJV.daysPerWeek);
            const daysInMonth = (0, $9Zmg7.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                const prevDay = (0, $9Zmg7.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $9Zmg7.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $iioJV.daysPerWeek);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                const prevDay = (0, $9Zmg7.default)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNextMonth = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$caae4eff24f6e8d0$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'nextMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickNextYear = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year + 1,
            type: 'nextYear'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevMonth = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$caae4eff24f6e8d0$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prevMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevYear = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year - 1,
            type: 'prevYear'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNextMonth: handleClickNextMonth,
        handleClickNextYear: handleClickNextYear,
        handleClickPrevMonth: handleClickPrevMonth,
        handleClickPrevYear: handleClickPrevYear
    };
}

});

parcelRegister("f9D1v", function(module, exports) {

$parcel$export(module.exports, "default", () => $42ec54640e7b9de4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");
function $42ec54640e7b9de4$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $5uXOq.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $6ASl9.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $5uXOq.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = (0, $iioJV.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("9efze", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbd6f430b06675a1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7qZ1x = parcelRequire("7qZ1x");
function $fbd6f430b06675a1$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $5uXOq.useMemo)(()=>(0, $7qZ1x.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $5uXOq.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $5uXOq.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $5uXOq.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});


parcelRegister("avHVh", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac07968b7cb494a9$export$2e2bcd8739ae039);
/* fixed-layer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");

var $5owSH = parcelRequire("5owSH");

var $gkD4s = parcelRequire("gkD4s");
var $4oNEb = parcelRequire("4oNEb");
var $1V7PR = parcelRequire("1V7PR");
const $ac07968b7cb494a9$var$styles = {
    root: "_bfhk18uv _kqswstnw _154ize3t",
    popperStyles: "_1pbyowjs"
};
class $ac07968b7cb494a9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props;
        // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {});
        const divStyles = {
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $5owSH.sizes).small.slice(0, -2)) - 8
        };
        return(/* Need to wrap layer in a fixed position div so that it will render its content as fixed
       * We need to set the intial top value to where the container is and zIndex so that it still
       * applies since we're creating a new stacking context. */ /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gkD4s.Manager), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1V7PR.Reference), {
                    children: ({ ref: ref })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            ref: ref,
                            "data-layer-child": true,
                            style: divStyles,
                            className: (0, $bwpsq.default)([
                                $ac07968b7cb494a9$var$styles.root
                            ])
                        })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4oNEb.Popper), {
                    children: ({ ref: ref, style: style, update: update })=>{
                        this.update = update;
                        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            ref: ref,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            style: style,
                            "data-testid": testId && `${testId}--popper--container`,
                            className: (0, $bwpsq.default)([
                                $ac07968b7cb494a9$var$styles.popperStyles
                            ]),
                            children: content
                        });
                    }
                })
            ]
        }));
    }
    constructor(...args){
        super(...args), this.update = (0, $eGmKJ.default);
    }
}

});
parcelRegister("5owSH", function(module, exports) {

$parcel$export(module.exports, "sizes", () => $7ad0abb26ad673d7$export$c647cb0ee6e282fe);
const $7ad0abb26ad673d7$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
const $7ad0abb26ad673d7$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
const $7ad0abb26ad673d7$export$62ad7b0c781000e9 = {
    small: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.small,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.medium,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.large,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.xlarge,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.xlarge
    }
};

});



parcelRegister("6AqCE", function(module, exports) {

$parcel$export(module.exports, "getShortISOString", () => $caee16c105163c22$export$77d5bc49fed7ef14);
$parcel$export(module.exports, "getSafeCalendarValue", () => $caee16c105163c22$export$ff525416014fb67d);

var $k7m40 = parcelRequire("k7m40");

var $2ucUe = parcelRequire("2ucUe");
function $caee16c105163c22$export$77d5bc49fed7ef14(date) {
    return (0, $k7m40.default)(date, (0, $2ucUe.convertTokens)('YYYY-MM-DD'));
}
function $caee16c105163c22$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return $caee16c105163c22$export$77d5bc49fed7ef14(new Date());
    return calendarValue;
}

});

parcelRegister("dBs4v", function(module, exports) {

$parcel$export(module.exports, "makeSingleValue", () => $9661917c82165ad2$export$6e30bf8cb1347b56);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");
const $9661917c82165ad2$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...rest })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).SingleValue, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            data: data,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: {
                lang: lang
            },
            isDisabled: isDisabled,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        });
    };

});


parcelRegister("jcbUF", function(module, exports) {

$parcel$export(module.exports, "default", () => $48f5b21daaca02ab$export$2e2bcd8739ae039);
/* date-picker-fc.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $6QvkM = parcelRequire("6QvkM");

var $42CjB = parcelRequire("42CjB");

var $3JT92 = parcelRequire("3JT92");

var $9KnKW = parcelRequire("9KnKW");

var $acknU = parcelRequire("acknU");

var $7qZ1x = parcelRequire("7qZ1x");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $7K5PP = parcelRequire("7K5PP");
var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $5RLF6 = parcelRequire("5RLF6");

var $iaQLg = parcelRequire("iaQLg");

var $gtijU = parcelRequire("gtijU");

var $6AqCE = parcelRequire("6AqCE");

var $dBs4v = parcelRequire("dBs4v");
const $48f5b21daaca02ab$var$packageName = "platform-pkg";
const $48f5b21daaca02ab$var$packageVersion = "0.0.0-use.local";
const $48f5b21daaca02ab$var$styles = {
    pickerContainerStyle: "_kqswh2mm",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz131l _152tze3t _rjxpze3t _30l31gjq",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66"
};
const $48f5b21daaca02ab$var$analyticsAttributes = {
    componentName: 'datePicker',
    packageName: $48f5b21daaca02ab$var$packageName,
    packageVersion: $48f5b21daaca02ab$var$packageVersion
}; /**
    * __Date picker__
    *
    * A date picker allows the user to select a particular date.
    *
    * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
    * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
    * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
    */ 
const $48f5b21daaca02ab$var$DatePicker = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, forwardedRef)=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const calendarRef = (0, $5uXOq.useRef)(null);
    const calendarButtonRef = (0, $5uXOq.useRef)(null);
    const { appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($acknU))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: // eslint-disable-next-line @repo/internal/react/use-noop
    onBlur = (_event)=>{}, // eslint-disable-next-line @repo/internal/react/use-noop
    onChange: onChangeProp = (_value)=>{}, onFocus: // eslint-disable-next-line @repo/internal/react/use-noop
    onFocus = (_event)=>{}, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
    const [_, setIsFocused] = (0, $5uXOq.useState)(false);
    const [clearingFromIcon, setClearingFromIcon] = (0, $5uXOq.useState)(false);
    const [selectInputValue, setSelectInputValue] = (0, $5uXOq.useState)(selectProps.inputValue);
    const [value, setValue] = (0, $5uXOq.useState)(propValue || defaultValue);
    const [calendarValue, setCalendarValue] = (0, $5uXOq.useState)(propValue || defaultValue || (0, $6AqCE.getShortISOString)(new Date()));
    const [l10n, setL10n] = (0, $5uXOq.useState)((0, $7qZ1x.createLocalizationProvider)(propLocale));
    const [locale, setLocale] = (0, $5uXOq.useState)(propLocale);
    const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $5uXOq.useState)(false);
    const [isKeyDown, setIsKeyDown] = (0, $5uXOq.useState)(false);
    const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $5uXOq.useState)(false); // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $5uXOq.useReducer)((x)=>!x, true);
    const onChangePropWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$48f5b21daaca02ab$var$analyticsAttributes
    });
    if (propLocale !== locale) {
        setL10n((0, $7qZ1x.createLocalizationProvider)(propLocale));
        setLocale(propLocale);
    }
    (0, $5uXOq.useEffect)(()=>{
        // We don't want the focus to move if this is a click event
        if (!isKeyDown) return;
        if (isOpen && wasOpenedFromCalendarButton) {
            setIsKeyDown(false); // Focus on the first button within the calendar
            calendarRef?.current?.querySelector('button')?.focus();
        }
    }, [
        isKeyDown,
        calendarRef,
        isOpen,
        wasOpenedFromCalendarButton
    ]);
    const getValue = ()=>propValue ?? value;
    const getIsOpen = ()=>isOpenProp ?? isOpen;
    const onCalendarChange = ({ iso: iso })=>{
        setCalendarValue((0, $5RLF6.getParsedISO)({
            iso: iso
        }));
    };
    const onCalendarSelect = ({ iso: iso })=>{
        setSelectInputValue('');
        setIsOpen(false);
        setCalendarValue(iso);
        setValue(iso);
        setWasOpenedFromCalendarButton(false);
        onChangePropWithAnalytics(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
        // on the inner input of Select itself, which would require a lot of
        // extra stuff in the Select component for only this one thing. While
        // this would be more "React-y", it doesn't seem to pose any other
        // benefits. Performance-wise, we are only searching within the
        // container, so it's quick.
        if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
        else {
            const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
            innerCombobox?.focus();
        }
        setIsOpen(false);
    };
    const onInputClick = ()=>{
        if (!isDisabled && !getIsOpen()) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onContainerBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (!containerRef?.current?.contains(newlyFocusedElement)) {
            setIsOpen(false);
            setShouldSetFocusOnCurrentDay(false);
            setWasOpenedFromCalendarButton(false);
            onBlur(event);
        }
    };
    const onContainerFocus = ()=>{
        setShouldSetFocusOnCurrentDay(false);
    };
    const onSelectBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
        setClearingFromIcon(false);
        else if (!containerRef?.current?.contains(newlyFocusedElement)) {
            // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            setIsOpen(false);
            setIsFocused(false);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onSelectFocus = (event)=>{
        const value = getValue();
        if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
        setClearingFromIcon(false);
        else {
            // Don't open when focused into via keyboard if the calendar button is present
            setIsOpen(!shouldShowCalendarButton);
            setCalendarValue(value);
            setIsFocused(true);
            setWasOpenedFromCalendarButton(false);
        }
        onFocus(event);
    };
    const onTextInput = (event)=>{
        const inputValue = event.target.value;
        if (inputValue) {
            const parsed = (0, $5RLF6.parseDate)(inputValue, {
                parseInputValue: rest?.parseInputValue,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            }); // Only try to set the date if we have month & day
            if (parsed && (0, $jovBr.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
            // this is the format expected by the @atlaskit/calendar component
            setCalendarValue((0, $6AqCE.getShortISOString)(parsed));
        }
        setIsOpen(true);
        setWasOpenedFromCalendarButton(false);
    };
    const onInputKeyDown = (event)=>{
        const value = getValue();
        const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
        if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
        switch(keyPressed){
            case 'escape':
                // Yes, this is not ideal. The alternative is to be able to place a ref
                // on the inner input of Select itself, which would require a lot of
                // extra stuff in the Select component for only this one thing. While
                // this would be more "React-y", it doesn't seem to pose any other
                // benefits. Performance-wise, we are only searching within the
                // container, so it's quick.
                if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                else {
                    const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                }
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                break;
            case 'backspace':
            case 'delete':
                {
                    const inputCount = 0;
                    if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) {
                        // If being cleared from keyboard, don't change behaviour
                        setClearingFromIcon(false);
                        setValue('');
                    }
                    break;
                }
            case 'enter':
                if (!isOpen) return;
                 // Prevent form submission when a date is selected
                // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                // for more details.
                event.preventDefault();
                if (!(0, $5RLF6.isDateDisabled)(calendarValue, {
                    disabled: disabled
                })) {
                    // Get a safe `calendarValue` in case the value exceeds the maximum
                    // allowed by ISO 8601
                    const safeCalendarValue = (0, $6AqCE.getSafeCalendarValue)(calendarValue);
                    const valueChanged = safeCalendarValue !== value;
                    setSelectInputValue('');
                    setIsOpen(false);
                    setValue(safeCalendarValue);
                    setCalendarValue(safeCalendarValue);
                    setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                    if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                }
                break;
            case 'arrowdown':
            case 'arrowup':
                if (!shouldSetFocusOnCurrentDay) {
                    setIsOpen(true);
                    setShouldSetFocusOnCurrentDay(true);
                }
                break;
            default:
                break;
        }
    };
    const onCalendarButtonKeyDown = (e)=>{
        // Don't allow an arrow up or down to open the menu, since the input key
        // down handler is actually on the parent.
        if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
         // We want to stop this from triggering other keydown events, particularly
        // for space and enter presses. Otherwise, it opens and then closes
        // immediately.
        if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
            e.stopPropagation();
            setIsKeyDown(true);
            setWasOpenedFromCalendarButton(true);
        }
    }; // This event handler is triggered from both keydown and click. It's weird.
    const onCalendarButtonClick = (e)=>{
        setIsOpen((isOpen)=>{
            if (isOpen) {
                (0, $VSDnB.fg)('platform_dst_menuonclose_fix') && props.selectProps?.onMenuClose?.();
                return false;
            } else {
                (0, $VSDnB.fg)('platform_dst_menuonclose_fix') && props.selectProps?.onMenuOpen?.();
                return true;
            }
        });
        setWasOpenedFromCalendarButton(true);
        e.stopPropagation();
    };
    const onClear = ()=>{
        setValue('');
        setCalendarValue(defaultValue || (0, $6AqCE.getShortISOString)(new Date()));
        if (!hideIcon) setClearingFromIcon(true);
        onChangePropWithAnalytics('');
    }; // `unknown` is used because `value` is unused so it does not matter.
    const onSelectChange = (_value, action)=>{
        // Used for native clear event in React Select
        // Triggered when clicking ClearIndicator or backspace with no value
        if (action.action === 'clear') onClear();
    };
    const handleSelectInputChange = (selectInputValue, actionMeta)=>{
        if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue, actionMeta);
        setSelectInputValue(selectInputValue);
    };
    const getContainerRef = (0, $5uXOq.useCallback)((ref)=>{
        const oldRef = containerRef.current;
        containerRef.current = ref; // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef == null && ref != null) forceUpdate();
    }, [
        containerRef
    ]);
    const getterValue = getValue();
    let actualSelectInputValue;
    actualSelectInputValue = selectInputValue;
    const menuIsOpen = getIsOpen() && !isDisabled;
    const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
    let clearIndicator = Icon; // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: $48f5b21daaca02ab$var$styles.dropdownIndicatorStyles,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                ...props
            })
        });
    const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
    const SingleValue = (0, $dBs4v.makeSingleValue)({
        lang: propLocale
    });
    const selectComponents = {
        ...selectProps.components,
        DropdownIndicator: shouldShowCalendarButton ? (0, $jHBnA.EmptyComponent) : dropDownIcon,
        // Only use this new container component if the calendar button is shown.
        // Otherwise, it throws errors downstream for some reason
        ...shouldShowCalendarButton ? {
            IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $iaQLg.IndicatorsContainer), {
                    ...props,
                    showClearIndicator: showClearIndicator
                })
        } : {},
        Menu: $gtijU.Menu,
        SingleValue: SingleValue,
        ...!showClearIndicator && {
            ClearIndicator: (0, $jHBnA.EmptyComponent)
        }
    };
    const { styles: selectStyles = {} } = selectProps;
    const disabledStyle = isDisabled ? {
        pointerEvents: 'none',
        color: "var(--ds-icon-disabled, inherit)"
    } : {};
    const calendarProps = {
        calendarContainerRef: containerRef.current,
        calendarDisabled: disabled,
        calendarDisabledDateFilter: disabledDateFilter,
        calendarMaxDate: maxDate,
        calendarMinDate: minDate,
        calendarRef: calendarRef,
        calendarValue: getterValue && (0, $6AqCE.getShortISOString)((0, $eZDAP.default)(getterValue)),
        calendarView: calendarValue,
        onCalendarChange: onCalendarChange,
        onCalendarSelect: onCalendarSelect,
        calendarLocale: locale,
        calendarWeekStartDay: weekStartDay,
        shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay,
        /**
     * This overrides the inner wrapper the Calendar.
     * @private Please use this with extreme caution, this API may be changed in the future.
     */ menuInnerWrapper: props?.menuInnerWrapper
    }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $7VXAu.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base,
                ...disabledStyle
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: "var(--ds-space-025, 2px)",
                // ICON_PADDING = 2
                paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
            })
    });
    const initialValue = getterValue ? {
        label: (0, $5RLF6.formatDate)(getterValue, {
            formatDisplayLabel: formatDisplayLabel,
            dateFormat: rest?.dateFormat,
            l10n: l10n
        }),
        value: getterValue
    } : null; // `label` takes precedence of the `inputLabel`
    const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
    const openCalendarLabelId = `open-calendar-label--${(0, $9KnKW.useId)()}`;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        ...innerProps,
        "data-testid": testId && `${testId}--container`,
        onBlur: onContainerBlur,
        onFocus: onContainerFocus,
        onClick: onInputClick,
        onInput: onTextInput,
        onKeyDown: onInputKeyDown,
        ref: getContainerRef,
        role: "presentation",
        className: (0, $bwpsq.default)([
            $48f5b21daaca02ab$var$styles.pickerContainerStyle
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                name: name,
                type: "hidden",
                value: getterValue,
                "data-testid": testId && `${testId}--input`
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7K5PP.default), {
                appearance: appearance,
                "aria-describedby": ariaDescribedBy,
                label: label || undefined,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                closeMenuOnSelect: true,
                enableAnimation: false,
                inputId: id,
                inputValue: actualSelectInputValue,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: menuIsOpen,
                onBlur: onSelectBlur,
                onChange: onSelectChange,
                onFocus: onSelectFocus,
                onInputChange: handleSelectInputChange,
                placeholder: (0, $5RLF6.getPlaceholder)({
                    placeholder: placeholder,
                    l10n: l10n
                }),
                // @ts-ignore -- Type 'OptionType' is not assignable to type '{ label: string; value: string; }'
                styles: mergedStyles,
                value: initialValue,
                ...selectProps,
                // up when you alter some of the properties in the `selectComponents`
                // object. These errors are still present, and I suspect have always
                // been present, without changing the unrelated code. Ignoring as the
                // component still works as expected despite this error. And also
                // because the select refresh team may solve it later.
                components: selectComponents,
                // selectProps or not and what wil be overwritten
                isClearable: true,
                isInvalid: isInvalid,
                spacing: spacing,
                testId: testId,
                // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                calendarContainerRef: calendarProps.calendarContainerRef,
                calendarDisabled: calendarProps.calendarDisabled,
                calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                calendarLocale: calendarProps.calendarLocale,
                calendarMaxDate: calendarProps.calendarMaxDate,
                calendarMinDate: calendarProps.calendarMinDate,
                calendarRef: calendarProps.calendarRef,
                calendarValue: calendarProps.calendarValue,
                calendarView: calendarProps.calendarView,
                calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                nextMonthLabel: nextMonthLabel,
                onCalendarChange: calendarProps.onCalendarChange,
                onCalendarSelect: calendarProps.onCalendarSelect,
                previousMonthLabel: previousMonthLabel,
                shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                menuInnerWrapper: calendarProps.menuInnerWrapper
            }),
            shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: (0, $3JT92.cx)($48f5b21daaca02ab$var$styles.iconContainerStyles, value && !hideIcon ? $48f5b21daaca02ab$var$styles.iconSpacingWithClearButtonStyles : $48f5b21daaca02ab$var$styles.iconSpacingWithoutClearButtonStyles),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                    appearance: "subtle",
                    label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                    "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                    id: openCalendarLabelId,
                    icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acknU))), {
                            ...iconProps,
                            color: "var(--ds-icon, #44546F)"
                        }),
                    onClick: onCalendarButtonClick,
                    onKeyDown: onCalendarButtonKeyDown,
                    ref: calendarButtonRef,
                    testId: testId && `${testId}--open-calendar-button`
                })
            }) : null
        ]
    });
});
var $48f5b21daaca02ab$export$2e2bcd8739ae039 = $48f5b21daaca02ab$var$DatePicker;

});


parcelRegister("8tAHc", function(module, exports) {

$parcel$export(module.exports, "default", () => $ceca1d2f82d990c4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ceca1d2f82d990c4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeholderDate: {
        "id": "common-date.utils.date-messages.placeholder-date",
        "defaultMessage": "e.g. 2018/12/31"
    }
});

});

parcelRegister("2LuBw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cdc4655e353704e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
// eslint-disable-next-line jira/react/no-class-components
class $3cdc4655e353704e$var$SuppressEscKey extends (0, $5uXOq.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            role: "presentation",
            onKeyDown: this.onKeyEvent,
            onKeyUp: this.onKeyEvent
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.onKeyEvent = (e)=>{
            const { key: key } = e;
            if (key === 'Escape') {
                e.stopPropagation();
                e.nativeEvent.stopImmediatePropagation();
            }
        };
    }
}
var $3cdc4655e353704e$export$2e2bcd8739ae039 = $3cdc4655e353704e$var$SuppressEscKey;

});

parcelRegister("lhpg4", function(module, exports) {

$parcel$export(module.exports, "default", () => $42dd5dd53080d3ce$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $42dd5dd53080d3ce$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    releaseDate: {
        "id": "project-directories.versions.release-version-modal.content.release-date.release-date",
        "defaultMessage": "Release date"
    }
});

});



parcelRegister("3nRuh", function(module, exports) {

$parcel$export(module.exports, "default", () => $c42196f8d6f40709$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $bC2fB = parcelRequire("bC2fB");

var $7ZIA5 = parcelRequire("7ZIA5");

var $3yLu1 = parcelRequire("3yLu1");

var $ai3Yq = parcelRequire("ai3Yq");

var $kqZtV = parcelRequire("kqZtV");
const $c42196f8d6f40709$var$mapStateToProps = ()=>{
    const renderVersionPickerFactory = (0, $8QpSo.default)((shouldSwapIssues, isSaving, baseUrl, projectKey, versionId)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ZIA5.default), {
                isDisabled: !shouldSwapIssues || isSaving,
                baseUrl: baseUrl,
                projectKey: projectKey,
                ignore: [
                    versionId
                ],
                versionStatuses: [
                    'UNRELEASED'
                ],
                ...props
            }));
    return (state)=>{
        const { baseUrl: baseUrl, projectKey: projectKey, shouldSwapIssues: shouldSwapIssues, isSaving: isSaving, versionId: versionId } = (0, $ai3Yq.getPropsForVersionPicker)(state);
        return {
            toDoInProgressIssuesCount: (0, $ai3Yq.getTodoInProgressIssuesCount)(state),
            isSaving: (0, $ai3Yq.isSaving)(state),
            shouldSwapIssues: (0, $ai3Yq.isSwapSelected)(state),
            errors: (0, $ai3Yq.getErrors)(state),
            renderVersionPicker: renderVersionPickerFactory(shouldSwapIssues, isSaving, baseUrl, projectKey, versionId)
        };
    };
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c42196f8d6f40709$var$dispatcher = (dispatch)=>({
        // @ts-expect-error - TS7006 - Parameter 'version' implicitly has an 'any' type.
        onInputChange: (version)=>dispatch((0, $3yLu1.releaseVersionUpdate)(version)),
        // @ts-expect-error - TS7006 - Parameter 'swap' implicitly has an 'any' type.
        onSwapIssuesSelected: (swap)=>dispatch((0, $3yLu1.swapIssues)(swap))
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c42196f8d6f40709$var$mapDispatchToProps = (dispatch)=>$c42196f8d6f40709$var$dispatcher(dispatch);
var $c42196f8d6f40709$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($c42196f8d6f40709$var$mapStateToProps, $c42196f8d6f40709$var$mapDispatchToProps)((0, $kqZtV.default));

});
parcelRegister("7ZIA5", function(module, exports) {

$parcel$export(module.exports, "default", () => $6639293982f702ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $iQv12 = parcelRequire("iQv12");

var $4U4qk = parcelRequire("4U4qk");

var $az4zD = parcelRequire("az4zD");

var $bcrAM = parcelRequire("bcrAM");

var $5wI4U = parcelRequire("5wI4U");

var $kVzJJ = parcelRequire("kVzJJ");
class $6639293982f702ce$export$c7c815960e157d78 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearableWithCrossIcon: false,
            noPortal: false,
            value: undefined,
            label: '',
            placeholder: undefined,
            ignore: [],
            versionStatuses: [],
            onSelected: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    getVersionIdsToIgnore() {
        const { value: value, ignore: ignore } = this.props;
        if (value) return [
            value.id,
            ...ignore
        ];
        return ignore;
    }
    getPlaceholder() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return this.props.placeholder === undefined ? formatMessage((0, $kVzJJ.default).placeholder) : this.props.placeholder;
    }
    getValue() {
        const { value: value } = this.props;
        if (value === null || value === undefined) return value;
        return (0, $5wI4U.transformVersion)(value);
    }
    render() {
        const { label: label, isRequired: isRequired, isDisabled: isDisabled, intl: intl, noPortal: noPortal, isClearableWithCrossIcon: isClearableWithCrossIcon } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4U4qk.Picker), {
            ...this.props,
            value: this.getValue(),
            label: label,
            placeholder: this.getPlaceholder(),
            isRequired: isRequired,
            isDisabled: isDisabled,
            isClearableWithCrossIcon: isClearableWithCrossIcon,
            errorMessage: intl.formatMessage((0, $kVzJJ.default).error),
            onSelected: this.onSelected,
            options: this.onFetchOptions,
            noPortal: noPortal,
            intl: intl
        });
    }
    constructor(...args){
        super(...args), this.onSelected = (selectedOption, analyticsEvent)=>selectedOption ? this.props.onSelected({
                id: selectedOption.value,
                name: selectedOption.label
            }, analyticsEvent) : this.props.onSelected(undefined, analyticsEvent), this.onFetchOptions = (filter)=>(0, $bcrAM.requestVersions)(this.props.projectKey, filter, this.props.versionStatuses, this.getVersionIdsToIgnore());
    }
}
var $6639293982f702ce$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
(0, $iQv12.default)({
    onSelected: 'versionPicker'
})($6639293982f702ce$export$c7c815960e157d78));

});
parcelRegister("4U4qk", function(module, exports) {

$parcel$export(module.exports, "getOptionBaseStyles", () => $0d1a93ba35d548ba$export$cef6e25059b681a);
$parcel$export(module.exports, "Picker", () => $0d1a93ba35d548ba$export$ba25329847403e11);
$parcel$export(module.exports, "default", () => $0d1a93ba35d548ba$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lFKmC = parcelRequire("lFKmC");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $1ZftP = parcelRequire("1ZftP");
var $94bNw = parcelRequire("94bNw");
var $bChGW = parcelRequire("bChGW");
var $iOwNT = parcelRequire("iOwNT");
var $7K5PP = parcelRequire("7K5PP");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $VgvL1 = parcelRequire("VgvL1");

var $fVAPR = parcelRequire("fVAPR");

var $gwIPs = parcelRequire("gwIPs");

var $eHJxW = parcelRequire("eHJxW");

var $az4zD = parcelRequire("az4zD");

var $e239o = parcelRequire("e239o");
const $0d1a93ba35d548ba$export$3a3072dd741f354b = 500;
const $0d1a93ba35d548ba$export$cef6e25059b681a = (optionState)=>({
        ...optionState.isDisabled ? {
            cursor: 'not-allowed',
            color: "var(--ds-text-subtlest, #626F86)",
            '&, :active': {
                backgroundColor: 'transparent'
            }
        } : {
            cursor: 'pointer'
        },
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    });
class $0d1a93ba35d548ba$export$ba25329847403e11 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: false,
            isCompact: false,
            isCreatable: false,
            isMulti: false,
            noPortal: false,
            isCheckbox: false,
            label: undefined,
            defaultValue: undefined,
            width: 'auto',
            onSelected: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onMultiSelected: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    static getDerivedStateFromProps(props) {
        if (props.menuIsOpen !== undefined) return {
            menuIsOpen: props.menuIsOpen
        };
        return null;
    }
    constructor(props){
        super(props), this.state = {
            validationState: 'default',
            showErrorMessage: false,
            menuWasOpen: false,
            menuIsOpen: false,
            initialFocusHandled: false
        }, this.onSelected = (selection, action, analyticsEvent)=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
            const { isMulti: isMulti } = this.props;
            if (Array.isArray(selection)) {
                if (isMulti) // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
                this.props.onMultiSelected(selection, analyticsEvent);
                else // When the selection is cleared in single select mode, selection is an array.
                this.props.onSelected(undefined, analyticsEvent);
            } else // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'SelectOption'.
            selection && selection.value ? this.props.onSelected(selection, analyticsEvent) : this.props.onSelected(undefined, analyticsEvent);
        }, this.onMenuOpen = ()=>{
            this.setState(()=>({
                    menuIsOpen: true,
                    menuWasOpen: true
                }));
        }, this.onMenuClose = ()=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
        }, this.onBlur = (event)=>{
            this.hideErrorMessage();
            const { onBlur: onBlur } = this.props;
            if (onBlur && typeof onBlur === 'function') onBlur(event);
        }, this.onFocus = (event)=>{
            this.showErrorMessage();
            const { onFocus: onFocus } = this.props;
            if (onFocus && typeof onFocus === 'function') onFocus(event);
        }, this.setErrorState = ()=>{
            this.setState({
                showErrorMessage: true,
                validationState: 'error'
            });
        }, this.showErrorMessage = ()=>this.setState({
                showErrorMessage: true
            }), this.hideErrorMessage = ()=>this.setState({
                showErrorMessage: false
            }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.loadOptions = (filter, callback)=>{
            this.setState({
                validationState: 'default'
            });
            this.debouncedLoadOptions(filter, callback);
        }, this.renderOption = (props)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const propsData = props.data;
            const disableReason = props.isDisabled && propsData && propsData.disableReason || null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                position: "right",
                content: disableReason
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            , props));
        } // Will remove this renderMenuList when clean up FG since it's no longer needed
        , this.renderMenuList = (menuListProps)=>{
            const { isClearable: isClearable, intl: { formatMessage: formatMessage } } = this.props;
            return(// @ts-expect-error - TS2740 - Type '{ children: (Element | ReactNode)[]; hasValue: boolean; clearValue: () => void; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': cx, getStyles, getValue, isMulti, and 6 more.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MenuList, menuListProps, isClearable && menuListProps.hasValue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $0d1a93ba35d548ba$var$clearButtonWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "link",
                shouldFitContainer: true,
                onClick: menuListProps.clearValue
            }, formatMessage((0, $e239o.default).clearSelected))), menuListProps.children));
        }, this.renderValueContainer = (props)=>{
            const { onValueContainerClick: onValueContainerClick } = props.selectProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d1a93ba35d548ba$var$StyledValueContainer, {
                "data-testid": "common-components-picker.base.react-dnd-and-select-focus-bug-fix",
                onClick: onValueContainerClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).ValueContainer, props));
        }; // This is initialized in constructor because when it is a class property then flow gets confused about the generic type in callback.
        // That is a known bug: https://github.com/facebook/flow/issues/6978
        this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (filter, callback)=>{
            // @ts-expect-error - TS2349 - This expression is not callable.
            this.props.options(filter).then(callback, ()=>{
                callback([]);
                this.setErrorState();
            });
        }, $0d1a93ba35d548ba$export$3a3072dd741f354b); // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
        this.selectRef = /*#__PURE__*/ (0, $5uXOq.createRef)();
    }
    getSelectComponent(isAsync) {
        if (this.props.isCreatable) return isAsync ? (0, $1ZftP.default) : (0, $iOwNT.default);
        if (isAsync) return 0, $VgvL1.AsyncSelectWithAnalytics;
        return this.props.isCheckbox ? (0, $94bNw.default) : (0, $7K5PP.default);
    }
    getComponentOverrides() {
        const { menuWasOpen: menuWasOpen } = this.state;
        const Option = {
            Option: this.renderOption
        }; // Remove MenuList when clean up FG since we no longer need to override to add `Clear Selected` button
        const MenuList = (0, $4R6GH.fg)('jfp-a11y-team_update_legacy_select_clear_fuction') ? {} : {
            MenuList: this.renderMenuList
        };
        const LoadingIndicator = menuWasOpen ? {} : {
            LoadingIndicator: null
        };
        return {
            ...this.props.components,
            ...Option,
            ...MenuList,
            ...LoadingIndicator
        };
    }
    render() {
        const { showErrorMessage: showErrorMessage, validationState: validationState, menuIsOpen: menuIsOpen } = this.state;
        const { intl: { formatMessage: formatMessage } } = this.props;
        const { label: label, listItemCustomStyles: listItemCustomStyles, placeholder: placeholder = formatMessage((0, $e239o.default).defaultPlaceholder), defaultValue: defaultValue, isRequired: isRequired, isDisabled: isDisabled, isCompact: isCompact, isClearableWithCrossIcon: isClearableWithCrossIcon, errorMessage: errorMessage, options: options, width: width, minWidth: minWidth, noPortal: noPortal, isCheckbox: isCheckbox, hasDraggableParentComponent: hasDraggableParentComponent } = this.props;
        const isAsync = typeof options === 'function';
        const SelectComponent = this.getSelectComponent(isAsync);
        const isErrorMessageOpened = showErrorMessage && validationState === 'error';
        let selectParams = {
            placeholder: placeholder,
            isDisabled: isDisabled,
            isClearable: isClearableWithCrossIcon || false,
            defaultValue: defaultValue,
            defaultOptions: true,
            autoFocus: !!this.props.autoFocus,
            loadOptions: isAsync && this.loadOptions,
            options: !isAsync && options,
            onChange: this.onSelected,
            noOptionsMessage: ()=>this.props.noOptionsMessage ?? formatMessage((0, $e239o.default).noOptions),
            loadingMessage: ()=>formatMessage((0, $e239o.default).loading),
            validationState: this.state.validationState,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            menuPortalTarget: noPortal ? null : document.body,
            spacing: isCompact ? 'compact' : 'default',
            styles: {
                ...this.props.styles,
                // without properly set zIndex value dropdown with options is cut inside modal dialogs
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                menuPortal: (base)=>({
                        ...base,
                        zIndex: (0, $gwIPs.layers).modal
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                container: (base)=>({
                        ...base,
                        width: width,
                        minWidth: minWidth
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type. | TS7006 - Parameter 'optionState' implicitly has an 'any' type.
                option: (base, optionState)=>({
                        ...base,
                        ...$0d1a93ba35d548ba$export$cef6e25059b681a(optionState),
                        ...listItemCustomStyles
                    })
            }
        };
        if (!isCheckbox) selectParams = {
            ...selectParams,
            menuIsOpen: // @ts-expect-error - TS2322 - Type '{ menuIsOpen: boolean; onMenuOpen: () => void; onMenuClose: () => void; components: { LoadingIndicator?: undefined; MenuList: (menuListProps: MenuListProps) => JSX.Element; Option: (props: CommonProps<...> & ... 1 more ... & { ...; }) => JSX.Element; } | { ...; }; ... 16 more ...; styles: { ...; }; }' is not assignable to type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'.
            menuIsOpen,
            onMenuOpen: this.onMenuOpen,
            onMenuClose: this.onMenuClose,
            components: this.getComponentOverrides()
        };
         // When "hasDraggableParentComponent" is true, this means <Select /> is nested inside <Draggable /> from react-beautiful-dnd
        // This relationship prevents the dropdown menu from opening because of bugs in the default focus state and clicking in a particular area of <Select />
        // Context: https://hello.atlassian.net/wiki/spaces/~989411314/pages/2861097485/Investigation+Notes+for+atlaskit+select+react-beautiful-dnd#Temporary-Solution
        if (hasDraggableParentComponent) {
            const { initialFocusHandled: initialFocusHandled } = this.state;
            const handleClick = ()=>{
                if (initialFocusHandled) // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                this.setState((state)=>({
                        menuIsOpen: !state.menuIsOpen
                    }));
                else if (!menuIsOpen) {
                    // Trigger focus state when ValueContainer is clicked for the first time
                    // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                    // to manage the state of the dropdown menu
                    // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                    this.selectRef.current.focus();
                    this.setState(()=>({
                            initialFocusHandled: true
                        }));
                }
            };
            selectParams = {
                ...selectParams,
                // @ts-expect-error - Object literal may only specify known properties, and 'ref' does not exist in type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'
                // + Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                ref: this.selectRef,
                components: {
                    ...this.getComponentOverrides,
                    ValueContainer: this.renderValueContainer
                },
                onValueContainerClick: handleClick,
                openMenuOnFocus: true
            };
        }
        const { isClearable: isClearable } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVAPR.FieldLabel), {
            htmlFor: this.props.inputId,
            label: label,
            isRequired: isRequired
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
            content: errorMessage,
            isOpen: isErrorMessageOpened,
            messageId: `common-components-picker.base.jira-inline-dialog.pickerErrorMessage.${this.props.inputId ?? 'unnamedInputId'}`,
            messageType: "transactional",
            placement: "right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SelectComponent, {
            inputId: this.props.inputId,
            ...this.props,
            ...selectParams,
            ...(0, $4R6GH.fg)('jfp-a11y-team_update_legacy_select_clear_fuction') ? {
                isClearable: isClearable
            } : {},
            options: isAsync ? undefined : this.props.options
        })));
    }
}
const $0d1a93ba35d548ba$var$PickerWithIntl = (0, $az4zD.injectIntlV2)($0d1a93ba35d548ba$export$ba25329847403e11);
const $0d1a93ba35d548ba$var$DefaultPicker = (props)=>{
    // this function exists only to "preserve" generic on the Picker that is lost at injectIntl
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d1a93ba35d548ba$var$PickerWithIntl, props);
};
$0d1a93ba35d548ba$var$DefaultPicker.defaultProps = $0d1a93ba35d548ba$export$ba25329847403e11.defaultProps;
var $0d1a93ba35d548ba$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $0d1a93ba35d548ba$var$DefaultPicker;
const $0d1a93ba35d548ba$var$StyledValueContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});
const $0d1a93ba35d548ba$var$clearButtonWrapperStyles = (0, $8CUq3.xcss)({
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #091E4224)"}`
});

});
parcelRegister("1ZftP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffe39b95a8bd43db$export$2e2bcd8739ae039);

var $isgat = parcelRequire("isgat");

var $3c98u = parcelRequire("3c98u");
const $ffe39b95a8bd43db$var$AsyncCreatableSelect = (0, $3c98u.default)((0, $isgat.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ffe39b95a8bd43db$export$2e2bcd8739ae039 = $ffe39b95a8bd43db$var$AsyncCreatableSelect;

});
parcelRegister("isgat", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6ce0d05b9e97e68$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2QhWf = parcelRequire("2QhWf");

var $iaInK = parcelRequire("iaInK");

var $2HH7Y = parcelRequire("2HH7Y");

var $9uJ4X = parcelRequire("9uJ4X");
const $d6ce0d05b9e97e68$var$AsyncCreatableSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const stateManagerProps = (0, $iaInK.default)(props);
    const creatableProps = (0, $9uJ4X.default)(stateManagerProps);
    const selectProps = (0, $2HH7Y.default)(creatableProps);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2QhWf.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d6ce0d05b9e97e68$export$2e2bcd8739ae039 = $d6ce0d05b9e97e68$var$AsyncCreatableSelect;

});


parcelRegister("94bNw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebf832c571222d72$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $itpgN = parcelRequire("itpgN");

var $7K5PP = parcelRequire("7K5PP");
const $ebf832c571222d72$var$CheckboxSelectInternal = ({ components: components, ...props })=>{
    const mergedComponents = (0, $5uXOq.useMemo)(()=>({
            ...components,
            Option: (0, $itpgN.CheckboxOption)
        }), [
        components
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7K5PP.default), {
        closeMenuOnSelect: false,
        hideSelectedOptions: false,
        isMulti: true,
        ...props,
        components: mergedComponents
    });
};
const $ebf832c571222d72$var$CheckboxSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo($ebf832c571222d72$var$CheckboxSelectInternal);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ebf832c571222d72$export$2e2bcd8739ae039 = $ebf832c571222d72$var$CheckboxSelect;

});
parcelRegister("itpgN", function(module, exports) {

$parcel$export(module.exports, "CheckboxOption", () => $f5875245cd0ad0c1$export$d40cc97ecda916f9);
$parcel$export(module.exports, "RadioOption", () => $f5875245cd0ad0c1$export$82ab7168879267a7);
/* input-options.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6aY6N = parcelRequire("6aY6N");

var $iQHJo = parcelRequire("iQHJo");

var $dV6Te = parcelRequire("dV6Te");

var $VSDnB = parcelRequire("VSDnB");
const $f5875245cd0ad0c1$var$optionStyles = {
    default: "_1e0c1txw _4cvr1h6o _1bsb1osq _uiztglyw _18ql1j7p _vchhusvi _85i51b66 _1q511b66 _bozgpxbi _y4tiutpp _bfhk18uv _16qs1kw7 _syaz1kw7 _1di61dty",
    focused: "_bfhk166n _16qsn8hf _112ej1ic",
    disabled: "_syaz15gi"
};
// the primary color represents the outer or background element
const $f5875245cd0ad0c1$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled) return "var(--ds-background-disabled, #091E4208)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #09326C)";
    else if (isActive) return "var(--ds-background-selected-pressed, #85B8FF)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #0055CC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #0C66E4)";
    return "var(--ds-background-neutral, #091E420F)";
};
// the secondary color represents the radio dot or checkmark
const $f5875245cd0ad0c1$var$getSecondaryColor = ({ isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #091E424F)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
const $f5875245cd0ad0c1$var$iconStyles = {
    inherit: "_1u9j1r31 _1gqp1r31",
    default: "_1u9j1elr _1gqp1elr"
};
const $f5875245cd0ad0c1$var$baseIconStyles = null;
const $f5875245cd0ad0c1$var$baseOptionStyles = null;
const $f5875245cd0ad0c1$var$ControlOption = (props)=>{
    const [isActive, setIsActive] = (0, $5uXOq.useState)(false);
    const onMouseDown = (0, $5uXOq.useCallback)(()=>setIsActive(true), []);
    const onMouseUp = (0, $5uXOq.useCallback)(()=>setIsActive(false), []);
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    const classNames = (0, $5uXOq.useMemo)(()=>cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className), [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $f5875245cd0ad0c1$var$optionStyles.default,
            isFocused && $f5875245cd0ad0c1$var$optionStyles.focused,
            isDisabled && $f5875245cd0ad0c1$var$optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseLeave: onMouseUp,
        ...innerProps,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9",
                    isSelected || isActive || isDisabled ? $f5875245cd0ad0c1$var$iconStyles.inherit : $f5875245cd0ad0c1$var$iconStyles.default
                ]),
                children: !!Icon ? /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                    label: "",
                    primaryColor: $f5875245cd0ad0c1$var$getPrimaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        isFocused: isFocused,
                        isActive: isActive
                    }),
                    secondaryColor: $f5875245cd0ad0c1$var$getSecondaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected
                    }),
                    isFacadeDisabled: true
                }) : null
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};
const $f5875245cd0ad0c1$var$NewCheckboxIcon = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
const $f5875245cd0ad0c1$var$NewRadioIcon = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "6.75",
                    fill: "currentColor",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "inherit"
                })
            ]
        })
    });
const $f5875245cd0ad0c1$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)($f5875245cd0ad0c1$var$ControlOption, {
        Icon: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        (0, $VSDnB.fg)('platform-visual-refresh-icons') ? $f5875245cd0ad0c1$var$NewCheckboxIcon : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($6aY6N))),
        ...props
    });
const $f5875245cd0ad0c1$export$82ab7168879267a7 = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    /*#__PURE__*/ (0, $2OMIu.jsx)($f5875245cd0ad0c1$var$ControlOption, {
        Icon: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        (0, $VSDnB.fg)('platform-visual-refresh-icons') ? $f5875245cd0ad0c1$var$NewRadioIcon : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($iQHJo))),
        ...props
    });

});
parcelRegister("6aY6N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47f24d9003b82760$var$_react = $47f24d9003b82760$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $47f24d9003b82760$var$_checkboxChecked = $47f24d9003b82760$var$_interopRequireDefault((parcelRequire("aoKYM")));
function $47f24d9003b82760$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $47f24d9003b82760$var$CheckboxIcon = (props)=>/*#__PURE__*/ $47f24d9003b82760$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $47f24d9003b82760$var$_checkboxChecked.default
    }));
$47f24d9003b82760$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $47f24d9003b82760$var$_default = module.exports.default = $47f24d9003b82760$var$CheckboxIcon;

});
parcelRegister("aoKYM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f3359cfcb124b9edec9402a579fa9711>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $79209663d32c0c44$var$_react = $79209663d32c0c44$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $79209663d32c0c44$var$_baseNew = $79209663d32c0c44$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $79209663d32c0c44$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $79209663d32c0c44$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $79209663d32c0c44$var$_react.default.createElement($79209663d32c0c44$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$79209663d32c0c44$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $79209663d32c0c44$var$_default = module.exports.default = $79209663d32c0c44$var$CheckboxCheckedIcon;

});


parcelRegister("iQHJo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db8f016a0af5fda9$var$_react = $db8f016a0af5fda9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $db8f016a0af5fda9$var$_radioChecked = $db8f016a0af5fda9$var$_interopRequireDefault((parcelRequire("kqGQn")));
function $db8f016a0af5fda9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $db8f016a0af5fda9$var$RadioIcon = (props)=>/*#__PURE__*/ $db8f016a0af5fda9$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $db8f016a0af5fda9$var$_radioChecked.default
    }));
$db8f016a0af5fda9$var$RadioIcon.displayName = 'RadioIcon';
var $db8f016a0af5fda9$var$_default = module.exports.default = $db8f016a0af5fda9$var$RadioIcon;

});
parcelRegister("kqGQn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2f37934c6709a990262261073c8d0052>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $edf7783e719984ba$var$_react = $edf7783e719984ba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $edf7783e719984ba$var$_baseNew = $edf7783e719984ba$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $edf7783e719984ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RadioChecked".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for the selected state of radio controls.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $edf7783e719984ba$var$RadioCheckedIcon = (props)=>/*#__PURE__*/ $edf7783e719984ba$var$_react.default.createElement($edf7783e719984ba$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6" clip-rule="evenodd"/>`
    }, props));
$edf7783e719984ba$var$RadioCheckedIcon.displayName = 'RadioCheckedIcon';
var $edf7783e719984ba$var$_default = module.exports.default = $edf7783e719984ba$var$RadioCheckedIcon;

});




parcelRegister("VgvL1", function(module, exports) {

$parcel$export(module.exports, "AsyncSelectWithAnalytics", () => $462c399840da3e1c$export$ee664e5add893f9);

var $d7FF4 = parcelRequire("d7FF4");

var $8oe80 = parcelRequire("8oe80");
const $462c399840da3e1c$export$ee664e5add893f9 = (0, $8oe80.default)('select', {
    onChange: 'changed'
})((0, $d7FF4.default));

});

parcelRegister("fVAPR", function(module, exports) {

$parcel$export(module.exports, "FieldLabel", () => $97462970d1593b07$export$1acdcf5a973a8414);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");
const $97462970d1593b07$export$1acdcf5a973a8414 = ({ label: label, htmlFor: htmlFor, isRequired: isRequired = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97462970d1593b07$var$Label, {
        htmlFor: htmlFor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz131l _1e0c1ule _ca0qv47k _u5f3idpf _n3td1b66 _19bvidpf _ect41gqc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, label), isRequired ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        role: "presentation",
        className: (0, $bwpsq.default)([
            "_syaz1tmw _19bvv77o _ect41gqc"
        ])
    }, "*") : null)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97462970d1593b07$var$Label = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
});
const $97462970d1593b07$var$labelStyle = null;
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $97462970d1593b07$var$requiredIndicatorStyle = null;

});

parcelRegister("eHJxW", function(module, exports) {

$parcel$export(module.exports, "JiraInlineDialog", () => $51c10262cffee11f$export$7ab52478615504b3);

var $5uXOq = parcelRequire("5uXOq");

var $ctg8C = parcelRequire("ctg8C");

var $10xFf = parcelRequire("10xFf");

var $c0dQj = parcelRequire("c0dQj");

var $5uVz7 = parcelRequire("5uVz7");
const $51c10262cffee11f$export$7ab52478615504b3 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        if ((0, $c0dQj.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uVz7.ChoreographerInlineDialog), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctg8C.default), rest);
};

});
parcelRegister("5uVz7", function(module, exports) {

$parcel$export(module.exports, "ChoreographerInlineDialog", () => $aa901de21f3fc2ba$export$44a404f218b0e66e);

var $ctg8C = parcelRequire("ctg8C");

var $fG5AJ = parcelRequire("fG5AJ");
const $aa901de21f3fc2ba$export$44a404f218b0e66e = (0, $fG5AJ.withChoreographedToggle)((0, $ctg8C.default), 'isOpen', 'content');

});


parcelRegister("e239o", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c6849afedcc0fa8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1c6849afedcc0fa8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noOptions: {
        "id": "common.components.picker.base.no-options",
        "defaultMessage": "No results"
    },
    loading: {
        "id": "common.components.picker.base.loading",
        "defaultMessage": "Searching..."
    },
    defaultPlaceholder: {
        "id": "common.components.picker.base.default-placeholder",
        "defaultMessage": "Select..."
    },
    clearSelected: {
        "id": "common.components.picker.base.clear-selected",
        "defaultMessage": "Clear selected"
    }
});

});


parcelRegister("bcrAM", function(module, exports) {

$parcel$export(module.exports, "requestVersions", () => $5693781e34d2d219$export$aadfb092a4919504);

var $fosv1 = parcelRequire("fosv1");

var $5wI4U = parcelRequire("5wI4U");
const $5693781e34d2d219$export$aadfb092a4919504 = async (projectKey, filter, versionStatuses, ignore, excludeArchivedVersions = false)=>{
    const pageVersions = await (0, $fosv1.requestVersions)(projectKey, filter, versionStatuses, ignore);
    return (0, $5wI4U.transformVersions)(pageVersions.values, ignore, excludeArchivedVersions);
};

});
parcelRegister("fosv1", function(module, exports) {

$parcel$export(module.exports, "MAX_RESULTS", () => $8ee5477fd3092e8b$export$f6b2881bc1090cea);
$parcel$export(module.exports, "requestVersions", () => $8ee5477fd3092e8b$export$aadfb092a4919504);

var $ebyGx = parcelRequire("ebyGx");

var $7f4tk = parcelRequire("7f4tk");
const $8ee5477fd3092e8b$export$f6b2881bc1090cea = 5;
const $8ee5477fd3092e8b$export$b702ac644ba114c = (projectKey)=>`/rest/api/2/project/${projectKey}/version`;
const $8ee5477fd3092e8b$export$10181c3ba572bfce = (filter, versionStatuses, ignore)=>(0, $ebyGx.stringify)({
        startAt: 0,
        query: filter,
        maxResults: $8ee5477fd3092e8b$export$f6b2881bc1090cea + ignore.length,
        orderBy: '+NAME',
        status: versionStatuses.join(',')
    });
const $8ee5477fd3092e8b$export$8395ad088d65e586 = (projectKey, filter, versionStatuses, ignore)=>`${$8ee5477fd3092e8b$export$b702ac644ba114c(projectKey)}?${$8ee5477fd3092e8b$export$10181c3ba572bfce(filter, versionStatuses, ignore)}`;
const $8ee5477fd3092e8b$export$aadfb092a4919504 = async (projectKey, filter, versionStatuses, ignore)=>(0, $7f4tk.default)($8ee5477fd3092e8b$export$8395ad088d65e586(projectKey, filter, versionStatuses, ignore));

});

parcelRegister("5wI4U", function(module, exports) {

$parcel$export(module.exports, "transformVersion", () => $9ac4e1645e42431e$export$390ab7123357e756);
$parcel$export(module.exports, "transformVersions", () => $9ac4e1645e42431e$export$8bc7a3929156b65e);

var $fosv1 = parcelRequire("fosv1");
const $9ac4e1645e42431e$export$390ab7123357e756 = (component)=>({
        value: component.id,
        label: component.name
    });
const $9ac4e1645e42431e$export$8bc7a3929156b65e = (data, ignore, excludeArchivedVersions)=>data.filter((value)=>!ignore.includes(value.id) && (!excludeArchivedVersions || !value.archived)).map($9ac4e1645e42431e$export$390ab7123357e756).slice(0, (0, $fosv1.MAX_RESULTS));

});


parcelRegister("kVzJJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc1b839fbdef43a1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cc1b839fbdef43a1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    error: {
        "id": "version-picker.error",
        "defaultMessage": "We couldn't retrieve versions"
    },
    placeholder: {
        "id": "version-picker.placeholder",
        "defaultMessage": "Select version"
    }
});

});


parcelRegister("kqZtV", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dbde7804cdf94bb$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7O4UO = parcelRequire("7O4UO");

var $jouoW = parcelRequire("jouoW");

var $4R6GH = parcelRequire("4R6GH");

var $az4zD = parcelRequire("az4zD");

var $rnB41 = parcelRequire("rnB41");
// eslint-disable-next-line jira/react/no-class-components
class $4dbde7804cdf94bb$var$SwapIssues extends (0, $5uXOq.Component) {
    inputChange(update) {
        const { onInputChange: onInputChange } = this.props;
        onInputChange({
            moveUnfixedIssuesTo: update.moveUnfixedIssuesTo
        });
    }
    render() {
        const { intl: { formatMessage: formatMessage }, toDoInProgressIssuesCount: toDoInProgressIssuesCount, shouldSwapIssues: shouldSwapIssues, errors: errors, isSaving: isSaving, renderVersionPicker: renderVersionPicker } = this.props;
        const { moveUnfixedIssuesTo: moveUnfixedIssuesToError } = errors;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            name: "UnresolvedIssue",
            isRequired: true,
            label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $rnB41.default).unresolvedIssuesHeaderIssueTermRefresh : (0, $rnB41.default).unresolvedIssuesHeader, {
                issues: toDoInProgressIssuesCount
            })
        }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jouoW.default), {
                isDisabled: isSaving,
                isChecked: shouldSwapIssues,
                onChange: this.onMoveIssuesSelected,
                label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $rnB41.default).unresolvedIssuesMoveIssueTermRefresh : (0, $rnB41.default).unresolvedIssuesMove, {
                    issues: toDoInProgressIssuesCount
                }),
                testId: "version-modals.release-version-modal.content.swap-issues.move-radio"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4dbde7804cdf94bb$var$VersionPickerContainer, null, renderVersionPicker({
                onSelected: this.onSwapIssues
            })), moveUnfixedIssuesToError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4dbde7804cdf94bb$var$ValidationError, null, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $rnB41.default).invalidVersionChosenIssueTermRefresh : (0, $rnB41.default).invalidVersionChosen, {
                issues: toDoInProgressIssuesCount
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jouoW.default), {
                isDisabled: isSaving,
                isChecked: !shouldSwapIssues,
                onChange: this.onRemoveVersionFromIssuesSelected,
                label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $rnB41.default).unresolvedIssuesIgnoreIssueTermRefresh : (0, $rnB41.default).unresolvedIssuesIgnore),
                testId: "version-modals.release-version-modal.content.swap-issues.ignore-radio"
            })));
    }
    constructor(...args){
        super(...args), this.onSwapIssues = (version)=>{
            if (version) this.inputChange({
                moveUnfixedIssuesTo: version.id
            });
            else this.inputChange({
                moveUnfixedIssuesTo: ''
            });
        }, this.onMoveIssuesSelected = ()=>{
            const { onSwapIssuesSelected: onSwapIssuesSelected } = this.props;
            onSwapIssuesSelected(true);
        }, this.onRemoveVersionFromIssuesSelected = ()=>{
            const { onSwapIssuesSelected: onSwapIssuesSelected } = this.props;
            onSwapIssuesSelected(false);
        };
    }
}
var $4dbde7804cdf94bb$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $az4zD.injectIntlV2)($4dbde7804cdf94bb$var$SwapIssues);
const $4dbde7804cdf94bb$var$VersionPickerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s88z4d",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4dbde7804cdf94bb$var$ValidationError = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc _syaz1tmw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jouoW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d22fafff331be84$export$2e2bcd8739ae039);
/* radio.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $VSDnB = parcelRequire("VSDnB");
const $5d22fafff331be84$var$packageName = "platform-pkg";
const $5d22fafff331be84$var$packageVersion = "0.0.0-use.local";
const $5d22fafff331be84$var$noop = (0, $eGmKJ.default);
const $5d22fafff331be84$var$labelPaddingStyles = null;
const $5d22fafff331be84$var$labelStyles = null;
const $5d22fafff331be84$var$radioStyles = null;
const $5d22fafff331be84$var$newRadioStyles = null;
const $5d22fafff331be84$var$InnerRadio = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, name: name, onChange: onChange = $5d22fafff331be84$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $5d22fafff331be84$var$packageName,
        packageVersion: $5d22fafff331be84$var$packageVersion
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazj3m3 _mqf81tvo _g7st13gf"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ...rest,
                tabIndex: 0,
                "aria-label": ariaLabel,
                checked: isChecked,
                disabled: isDisabled,
                name: name,
                onChange: onChangeAnalytics,
                required: isRequired,
                type: "radio",
                value: value,
                "data-testid": testId && `${testId}--radio-input`,
                // use :invalid selector
                "data-invalid": isInvalid ? 'true' : undefined,
                ref: ref,
                className: (0, $bwpsq.default)([
                    "_18s8ze3t _19it3vzd _2rko1q5u _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6qmag2 _11511fmg _1s6w1qbb _tqbwidpf _t9ec1s1q _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1q5u _qc5orqeg _z0ai1cbz _1qdg1cbz _18postnw _aetrb3bt _1peq1xmd _iosizyvw _11jyzyvw _f3ett94y _19ybk8x7 _1d7pk8x7 _j5dh13gf _scgf13gf _1gcs13gf _1x1a13gf _6hp813gf _4rya1y1w _o1bd1y1w _nxi61y1w _neoe1y1w _1el21y1w _lekrzcs9 _11v7zcs9 _1f8czcs9 _s2ftzcs9 _17a1zcs9 _x48a15t7 _1ib215t7 _1yk915t7 _gdmb15t7 _pmm415t7 _y2mvehbj _1bg4jfq9 _6tjkehbj _awqnjfq9 _1rvq10ko _1p9j1fmg _x2tzhh5a _1iwzhh5a _sj8y1wq0 _jckox2ru _1dvd1fmg _60ak1dzn",
                    (0, $VSDnB.fg)('platform-visual-refresh-icons') && "_t9ec1soj _z0ai120g _1qdg120g"
                ])
            }),
            label ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    "_85i5v77o _1q51v77o _y4ti1b66 _bozg1b66"
                ]),
                children: label
            }) : null
        ]
    });
}); /**
     * __Radio__
     *
     * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
     *
     * - [Examples](https://atlassian.design/components/radio/examples)
     * - [Code](https://atlassian.design/components/radio/code)
     * - [Usage](https://atlassian.design/components/radio/usage)
     */ 
const $5d22fafff331be84$var$Radio = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($5d22fafff331be84$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $5d22fafff331be84$export$2e2bcd8739ae039 = $5d22fafff331be84$var$Radio;

});

parcelRegister("rnB41", function(module, exports) {

$parcel$export(module.exports, "default", () => $a40bbc0e4b3cafaf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a40bbc0e4b3cafaf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    unresolvedIssuesHeader: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-header",
        "defaultMessage": "Unresolved {issues, plural, one {issue} other {issues}}"
    },
    unresolvedIssuesMove: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-move",
        "defaultMessage": "Move unresolved {issues, plural, one {issue} other {issues}} to"
    },
    unresolvedIssuesIgnore: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-ignore",
        "defaultMessage": "Ignore unresolved issues"
    },
    invalidVersionChosen: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.invalid-version-chosen",
        "defaultMessage": "Can't use this version. Change this version to another in your project or remove it from {issues, plural, one {this issue} other {these issues}}."
    },
    unresolvedIssuesHeaderIssueTermRefresh: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-header-issue-term-refresh",
        "defaultMessage": "Unresolved {issues, plural, one {work item} other {work items}}"
    },
    unresolvedIssuesMoveIssueTermRefresh: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-move-issue-term-refresh",
        "defaultMessage": "Move unresolved {issues, plural, one {work item} other {work items}} to"
    },
    unresolvedIssuesIgnoreIssueTermRefresh: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-ignore-issue-term-refresh",
        "defaultMessage": "Ignore unresolved work items"
    },
    invalidVersionChosenIssueTermRefresh: {
        "id": "project-directories.versions.release-version-modal.content.swap-issues.invalid-version-chosen-issue-term-refresh",
        "defaultMessage": "Can't use this version. Change this version to another in your project or remove it from {issues, plural, one {this work item} other {these work items}}."
    }
});

});



parcelRegister("uKe1m", function(module, exports) {

$parcel$export(module.exports, "default", () => $a77752f277ff7388$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5McnS = parcelRequire("5McnS");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");

var $az4zD = parcelRequire("az4zD");

var $gED7w = parcelRequire("gED7w");
class $a77752f277ff7388$export$7c6e2c02157bb7d2 extends (0, $5uXOq.Component) {
    renderDescriptionWithIssues() {
        const { intl: { formatMessage: formatMessage }, unresolvedIssuesCount: unresolvedIssuesCount, unresolvedIssuesUrl: unresolvedIssuesUrl } = this.props;
        const unresolvedIssueJqlViewLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5McnS.default), {
            href: unresolvedIssuesUrl
        }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $gED7w.default).descriptionWithIssuesCountIssueTermRefresh : (0, $gED7w.default).descriptionWithIssuesCount, {
            issues: unresolvedIssuesCount
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $gED7w.default).descriptionWithIssues,
            values: {
                issueCountLink: unresolvedIssueJqlViewLink
            }
        }));
    }
    renderDescriptionWithoutIssues() {
        const { intl: { formatMessage: formatMessage }, resolvedIssueUrl: resolvedIssueUrl, resolvedIssuesCount: resolvedIssuesCount } = this.props;
        const resolvedIssueJqlViewLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5McnS.default), {
            href: resolvedIssueUrl
        }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $gED7w.default).descriptionWithoutIssuesIssueTermRefresh : (0, $gED7w.default).descriptionWithoutIssues, {
            doneIssues: resolvedIssuesCount
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $gED7w.default).descriptionWithoutIssuesRestMessage,
            values: {
                issueCountLink: resolvedIssueJqlViewLink
            }
        }));
    }
    render() {
        const { unresolvedIssuesCount: unresolvedIssuesCount, SwapIssues: SwapIssues, ReleaseDate: ReleaseDate, ReleaseAutomationBanner: ReleaseAutomationBanner } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, unresolvedIssuesCount > 0 ? this.renderDescriptionWithIssues() : this.renderDescriptionWithoutIssues(), unresolvedIssuesCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SwapIssues, null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ReleaseDate, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
            fallback: "unmount",
            packageName: "jiraSoftwareReleasesVersionDetail",
            teamName: "nova",
            id: "releaseAutomationBanner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ReleaseAutomationBanner, null)));
    }
}
var $a77752f277ff7388$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($a77752f277ff7388$export$7c6e2c02157bb7d2);

});
parcelRegister("gED7w", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5a4514f0f67d4d6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e5a4514f0f67d4d6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    descriptionWithIssues: {
        "id": "project-directories.versions.release-version-modal.content.description-with-issues",
        "defaultMessage": "This release contains {issueCountLink}."
    },
    descriptionWithIssuesCount: {
        "id": "project-directories.versions.release-version-modal.content.description-with-issues-count",
        "defaultMessage": "{issues, plural, one {{issues} unresolved issue} other {{issues} unresolved issues}}"
    },
    descriptionWithoutIssues: {
        "id": "project-directories.versions.release-version-modal.content.description-without-issues",
        "defaultMessage": "{doneIssues} {doneIssues, plural, one {issue} other {issues}}"
    },
    descriptionWithoutIssuesRestMessage: {
        "id": "project-directories.versions.release-version-modal.content.description-without-issues-rest-message",
        "defaultMessage": "{issueCountLink} will be released."
    },
    descriptionWithIssuesCountIssueTermRefresh: {
        "id": "project-directories.versions.release-version-modal.content.description-with-issues-count-issue-term-refresh",
        "defaultMessage": "{issues, plural, one {{issues} unresolved work item} other {{issues} unresolved work items}}"
    },
    descriptionWithoutIssuesIssueTermRefresh: {
        "id": "project-directories.versions.release-version-modal.content.description-without-issues-issue-term-refresh",
        "defaultMessage": "{doneIssues} {doneIssues, plural, one {work item} other {work items}}"
    }
});

});



parcelRegister("eiujx", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c15cee7d8503819$export$2e2bcd8739ae039);
/* ReleaseModal.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/filename-case */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $7NYq5 = parcelRequire("7NYq5");

var $jzjy1 = parcelRequire("jzjy1");

var $iQv12 = parcelRequire("iQv12");

var $9fuVs = parcelRequire("9fuVs");

var $az4zD = parcelRequire("az4zD");


var $3Hk1b = parcelRequire("3Hk1b");

var $dq84i = parcelRequire("dq84i");
class $4c15cee7d8503819$export$b77f092f9cf63f1e extends (0, $5uXOq.Component) {
    render() {
        const { Content: Content, unresolvedIssuesCount: unresolvedIssuesCount, isInitiating: isInitiating, onCancel: onCancel, intl: { formatMessage: formatMessage }, name: name } = this.props;
        if (isInitiating) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
            isOpen: true,
            width: "small" // @ts-expect-error - TS2769 - No overload matches this call.
            ,
            onClose: onCancel,
            testId: "version-modals.release-version-modal.release-version-modal",
            messageId: "version-modals.release-version-modal.modal-dialog.release-version-modal",
            messageType: "transactional"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, unresolvedIssuesCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), {
            appearance: "warning"
        }, formatMessage((0, $dq84i.default).header, {
            name: name
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, formatMessage((0, $dq84i.default).header, {
            name: name
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Content, null)), this.renderFooter(this.props)));
    }
    constructor(...args){
        super(...args), // @ts-expect-error - TS2344 - Type '{ new (): HTMLElement; prototype: HTMLElement; }' does not satisfy the constraint 'keyof IntrinsicElements | ForwardRefExoticComponent<any> | (new (props: any) => Component<any, {}, any>) | ((props: any, context?: any) => ReactElement<...> | null)'.
        this.onButtonMounted = (node)=>{
            this.button = node;
        }, // focus needs to be set on button in order to hide date-picker
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onRelease = (...args)=>{
            if (this.button) this.button.focus();
            this.props.onRelease(this.props.shouldRedirectToCreateReleaseNotes, args[args.length - 1]);
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/react-no-unneeded-arrow-function-properties
        this.renderFooter = (props)=>{
            const { intl: { formatMessage: formatMessage }, unresolvedIssuesCount: unresolvedIssuesCount, isSaving: isSaving, onCancel: onCancel, isReleaseDisabled: isReleaseDisabled, shouldRedirectToCreateReleaseNotes: shouldRedirectToCreateReleaseNotes, setRedirectToCreateReleaseNotesStatus: setRedirectToCreateReleaseNotesStatus, shouldShowCreateReleaseNotesOption: shouldShowCreateReleaseNotesOption } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4c15cee7d8503819$var$FooterContainer, {
                showReleaseNotesPrompt: shouldShowCreateReleaseNotesOption
            }, shouldShowCreateReleaseNotesOption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Hk1b.CreateReleaseNotesPrompt), {
                onChange: setRedirectToCreateReleaseNotesStatus,
                value: shouldRedirectToCreateReleaseNotes
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4c15cee7d8503819$var$ButtonsContainer, null, isSaving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $4c15cee7d8503819$var$spinnerContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
                size: "small"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                onClick: this.onRelease,
                appearance: unresolvedIssuesCount ? 'warning' : 'primary',
                type: "submit",
                isDisabled: isReleaseDisabled,
                ref: this.onButtonMounted
            }, formatMessage((0, $dq84i.default).release)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "subtle-link",
                isDisabled: false,
                onClick: onCancel
            }, formatMessage((0, $dq84i.default).cancel)))));
        };
    }
}
var $4c15cee7d8503819$export$2e2bcd8739ae039 = (0, $jzjy1.AnalyticsSource)('releaseVersions', (0, $4d5e0871c06cee03$export$1171103ea9083ffa))((0, $iQv12.default)({
    onRelease: (isCreateReleaseNotesOptedIn)=>({
            name: 'release',
            isCreateReleaseNotesOptedIn: isCreateReleaseNotesOptedIn
        }),
    onCancel: 'cancel'
})((0, $az4zD.injectIntlV2)($4c15cee7d8503819$export$b77f092f9cf63f1e)));
const $4c15cee7d8503819$var$spinnerContainerStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.200'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c15cee7d8503819$var$ButtonsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c15cee7d8503819$var$FooterContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { showReleaseNotesPrompt: showReleaseNotesPrompt, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bsb1osq",
            __cmplp.showReleaseNotesPrompt ? "_1bah1yb4" : "_1bahesu3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3Hk1b", function(module, exports) {

$parcel$export(module.exports, "CreateReleaseNotesPrompt", () => $63c71c8af7e07942$export$d8a8f048cf64e9ff);
/* CreateReleaseNotesPrompt.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kkJfY = parcelRequire("kkJfY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $gjQ4F = parcelRequire("gjQ4F");
const $63c71c8af7e07942$export$d8a8f048cf64e9ff = ({ onChange: onChange, value: value })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onValueChange = (0, $5uXOq.useCallback)((event)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'checkbox'
        }), 'releaseModalCreateReleaseNotesCheckbox');
        onChange(event.target.checked);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($63c71c8af7e07942$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        name: "createReleaseNotes",
        label: formatMessage((0, $gjQ4F.default).createReleaseNotesTitle),
        isChecked: value,
        onChange: onValueChange
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $63c71c8af7e07942$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kkJfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3106eb14f9b0a593$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $5JjdN = parcelRequire("5JjdN");

var $kag1C = parcelRequire("kag1C");
var $7xteU = parcelRequire("7xteU");
var $hsLv2 = parcelRequire("hsLv2");
var $e62YQ = parcelRequire("e62YQ");
const $3106eb14f9b0a593$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef7js4s _1h6rjs4s _smzgj3jf _1dk7j3jf _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $3106eb14f9b0a593$var$Checkbox = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $5uXOq.useRef)(null);
    const mergedRefs = (0, $5JjdN.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $5uXOq.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7xteU.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $bwpsq.default)([
                    $3106eb14f9b0a593$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kag1C.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hsLv2.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e62YQ.default), {})
                ]
            })
        ]
    });
}));
$3106eb14f9b0a593$var$Checkbox.displayName = 'Checkbox';
var $3106eb14f9b0a593$export$2e2bcd8739ae039 = $3106eb14f9b0a593$var$Checkbox;

});
parcelRegister("kag1C", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0746a27410bc168$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dV6Te = parcelRequire("dV6Te");

var $VSDnB = parcelRequire("VSDnB");
function $a0746a27410bc168$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $a0746a27410bc168$var$CheckboxIcon = /*#__PURE__*/ (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $5uXOq.useMemo)(()=>$a0746a27410bc168$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $VSDnB.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    });
});
var $a0746a27410bc168$export$2e2bcd8739ae039 = $a0746a27410bc168$var$CheckboxIcon;

});

parcelRegister("7xteU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b368d644c230660$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $7b368d644c230660$var$baseStyles = null;
const $7b368d644c230660$var$textLabelLayoutStyles = null;
const $7b368d644c230660$var$disabledStyles = null;
const $7b368d644c230660$var$labelStyles = null;
function $7b368d644c230660$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazj3m3 _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1tvo _80om13gf",
            "_h5e3mag2 _1nzs11d3 _1eszzyvw _yp0jhh5a _ay2w1y1w _d51u10ko _phft1fmg _1g1funzk _l6wkzyvw _1dikhh5a _1sfg1q3k _fpdj1y1w _1yjc194a _oaj11fmg _1j3h1q3k _eawb1dzn _1rda1qbb _18q015t7 _13hr3acm",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("hsLv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce636d67b4ff1120$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $ce636d67b4ff1120$var$labelTextStyles = null;
function $ce636d67b4ff1120$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("e62YQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2156c28a3894cac$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d2156c28a3894cac$var$requiredIndicatorStyles = null;
function $d2156c28a3894cac$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": true,
        className: (0, $bwpsq.default)([
            "_syaz1gtz _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("gjQ4F", function(module, exports) {

$parcel$export(module.exports, "default", () => $82038eb6c516431a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $82038eb6c516431a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createReleaseNotesTitle: {
        "id": "project-directories.versions.release-version-modal.create-release-notes-prompt.create-release-notes-title",
        "defaultMessage": "Create release notes"
    }
});

});


parcelRegister("dq84i", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbc5f7f1540b8320$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bbc5f7f1540b8320$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    header: {
        "id": "project-directories.versions.release-version-modal.header",
        "defaultMessage": "Release {name}"
    },
    release: {
        "id": "project-directories.versions.release-version-modal.release",
        "defaultMessage": "Release"
    },
    cancel: {
        "id": "project-directories.versions.release-version-modal.cancel",
        "defaultMessage": "Cancel"
    }
});

});




parcelRegister("63h61", function(module, exports) {

$parcel$export(module.exports, "default", () => $e726e5333611677b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e726e5333611677b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    buttonLabel: {
        "id": "software-releases-launch-card.version-status.button-label",
        "defaultMessage": "Version release state dropdown"
    },
    archiveOptionLabel: {
        "id": "software-releases-launch-card.version-status.archive-option-label",
        "defaultMessage": "Archive"
    },
    archivedLabel: {
        "id": "software-releases-launch-card.version-status.archived-label",
        "defaultMessage": "Archived"
    },
    releasedLabel: {
        "id": "software-releases-launch-card.version-status.released-label",
        "defaultMessage": "Released"
    },
    releaseOptionLabel: {
        "id": "software-releases-launch-card.version-status.release-option-label",
        "defaultMessage": "Release"
    },
    unarchiveOptionLabel: {
        "id": "software-releases-launch-card.version-status.unarchive-option-label",
        "defaultMessage": "Unarchive"
    },
    unreleaseOptionLabel: {
        "id": "software-releases-launch-card.version-status.unrelease-option-label",
        "defaultMessage": "Unrelease"
    },
    unreleasedLabel: {
        "id": "software-releases-launch-card.version-status.unreleased-label",
        "defaultMessage": "Unreleased"
    },
    archiveFailedFlagDescription: {
        "id": "software-releases-launch-card.version-status.archive-failed-flag-description",
        "defaultMessage": "We were not able to update the version archived status. Please refresh the page and try again."
    },
    genericUpdateFailedFlagTitle: {
        "id": "software-releases-launch-card.version-status.generic-update-failed-flag-title",
        "defaultMessage": "Something went wrong"
    },
    releaseFailedFlagDescription: {
        "id": "software-releases-launch-card.version-status.release-failed-flag-description",
        "defaultMessage": "We were not able to update the version released status. Please refresh the page and try again."
    }
});

});




parcelRegister("oH05V", function(module, exports) {

$parcel$export(module.exports, "LoadingWrapper", () => $513cf4f6a15c0943$export$43a792a870d28db2);
$parcel$export(module.exports, "StatusLoading", () => $513cf4f6a15c0943$export$51c5b32c3d6a82a3);
$parcel$export(module.exports, "LatestDeploymentLoading", () => $513cf4f6a15c0943$export$312fd886f74b4447);
$parcel$export(module.exports, "TwoColumnFieldWrapper", () => $513cf4f6a15c0943$export$6dbdef323b681eb1);
$parcel$export(module.exports, "FieldLoadingWrapper", () => $513cf4f6a15c0943$export$6f356a6f7f11d124);
$parcel$export(module.exports, "FieldLabelLoading", () => $513cf4f6a15c0943$export$1411e5aa93aa9d74);
$parcel$export(module.exports, "FieldContentLoading", () => $513cf4f6a15c0943$export$9f4ff45992eb7f88);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
/**
 * Loading component starts
 */ const $513cf4f6a15c0943$var$skeletonKeyFrames = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $513cf4f6a15c0943$var$AnimationBaseDiv = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ju25ru3m _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1kpv _12vemgnk _bfhkn82g _j7hq1nls",
            __cmplp.className
        ])
    });
});
const $513cf4f6a15c0943$export$43a792a870d28db2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _189et94y _1dqonqa1 _1h6dmuej",
            __cmplp.className
        ])
    });
});
const $513cf4f6a15c0943$export$51c5b32c3d6a82a3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $513cf4f6a15c0943$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1ylp",
            __cmplp.className
        ])
    });
});
const $513cf4f6a15c0943$export$312fd886f74b4447 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $513cf4f6a15c0943$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i8vuz",
            __cmplp.className
        ])
    });
});
const $513cf4f6a15c0943$export$6dbdef323b681eb1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $lD23V.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4t3i2nrh",
            __cmplp.className
        ])
    });
});
const $513cf4f6a15c0943$export$6f356a6f7f11d124 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $513cf4f6a15c0943$export$1411e5aa93aa9d74 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $513cf4f6a15c0943$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkftgi _2hwxidpf _otyrftgi _18u0idpf _1bsb1ssb _4t3i7vkz",
            __cmplp.className
        ])
    });
});
const $513cf4f6a15c0943$export$9f4ff45992eb7f88 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $513cf4f6a15c0943$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkftgi _2hwxidpf _otyrftgi _18u0idpf _1bsb1n8h _4t3i1crf",
            __cmplp.className
        ])
    });
});
const $513cf4f6a15c0943$export$22183793b514d3aa = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bsb1osq _4t3i8vuz",
            __cmplp.className
        ])
    });
});

});


parcelRegister("dLRv1", function(module, exports) {

$parcel$export(module.exports, "IssueListWithHeaderWithErrorBoundary", () => $6c9ffa8d73f171f7$export$d97e9356033839cd);

var $aVXy2 = parcelRequire("aVXy2");

var $aJqtc = parcelRequire("aJqtc");

var $bkWqL = parcelRequire("bkWqL");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $gwIPs = parcelRequire("gwIPs");

var $7Q2kM = parcelRequire("7Q2kM");

var $7CMCs = parcelRequire("7CMCs");

var $koVbs = parcelRequire("koVbs");

var $lfTZh = parcelRequire("lfTZh");

var $jDrwg = parcelRequire("jDrwg");

var $iXVV6 = parcelRequire("iXVV6");

var $jX1s1 = parcelRequire("jX1s1");

var $fi7WV = parcelRequire("fi7WV");

var $1YU2V = parcelRequire("1YU2V");

var $20fNh = parcelRequire("20fNh");

var $bRpse = parcelRequire("bRpse");

var $a40gh = parcelRequire("a40gh");

var $1MXmG = parcelRequire("1MXmG");

var $liM6F = parcelRequire("liM6F");

var $8YQNr = parcelRequire("8YQNr");

var $1Ql36 = parcelRequire("1Ql36");

var $8yqbI = parcelRequire("8yqbI");

var $hWY96 = parcelRequire("hWY96");

var $h1W9c = parcelRequire("h1W9c");

var $bLVnv = parcelRequire("bLVnv");

var $9VaPq = parcelRequire("9VaPq");

var $fx0Tw = parcelRequire("fx0Tw");

var $c8MHq = parcelRequire("c8MHq");
const $6c9ffa8d73f171f7$var$DEV_DETAILS_DIALOG_SCOPE_ID = 'VersionDetailsIssueList';
const $6c9ffa8d73f171f7$var$LOAD_MORE_PAGE_SIZE = 50;
const $6c9ffa8d73f171f7$var$IssuesRefetchable = ({ jiraVersion: jiraVersion })=>{
    const { isAnyFilterApplied: isAnyFilterApplied } = (0, $1YU2V.useFilterSortingQueryParams)();
    const { filters: filters, sortBy: sortBy } = (0, $20fNh.useVersionIssuesGraphQLVariables)();
    const onExperienceSuccess = (0, $1MXmG.useViewVersionDetailsPageExperienceSuccess)(); /* eslint-disable @atlassian/relay/unused-fields */ 
    const versionFragmentRef = (0, $8Uumt.usePaginationFragment)((0, $bkWqL.default), jiraVersion);
    /* eslint-enable @atlassian/relay/unused-fields */ const { data: jiraVersionData, refetch: refetch, hasNext: hasNext, loadNext: loadNext, isLoadingNext: isLoadingNext } = versionFragmentRef;
    const loadNextPage = (0, $5uXOq.useCallback)(()=>{
        if (hasNext) loadNext($6c9ffa8d73f171f7$var$LOAD_MORE_PAGE_SIZE);
    }, [
        loadNext,
        hasNext
    ]);
    const issueEdges = jiraVersionData.issuesForList.edges.filter(Boolean);
    const totalIssuesCount = jiraVersionData.issuesForList.totalCount ?? issueEdges.length;
    const nextPageSize = Math.min(totalIssuesCount - issueEdges.length, $6c9ffa8d73f171f7$var$LOAD_MORE_PAGE_SIZE);
    const setLoadMoreElement = (0, $c8MHq.useIntersectionObserver)({
        margin: 40,
        onIntersection: loadNextPage
    });
    const variables = (0, $bRpse.useDeepMemo)({
        sortBy: sortBy,
        filters: filters
    });
    const [debouncedRefetch] = (0, $jDrwg.default)((refetchVariables)=>{
        refetch({
            id: jiraVersionData.id,
            ...refetchVariables
        });
    }, 500);
    const isFirstRenderRef = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>{
        if (isFirstRenderRef.current) // Initial rendering is already after the query is executed by react-resource-router, so we don't need to run refetch for initial rendering.
        isFirstRenderRef.current = false;
        else debouncedRefetch(variables);
    }, [
        debouncedRefetch,
        variables
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, issueEdges.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "jira.software.releases.version.detail.issue.list.empty-view",
        packageName: "jira-software-releases-version-detail-issue-list",
        teamName: "nova",
        onError: ()=>{
            // We don't want to fire experience failure even if the table rendering fails when the table is empty. Table’s empty state doesn’t really show useful information anyway.
            onExperienceSuccess();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $liM6F.EmptyView), {
        jiraVersion: jiraVersionData,
        isAnyFilterApplied: isAnyFilterApplied,
        textFilter: filters.searchStr ?? null
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h1W9c.Issues), {
        jiraIssueEdgesReference: issueEdges,
        jiraVersion: jiraVersionData,
        jiraVersionRefetch: jiraVersionData
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6c9ffa8d73f171f7$var$LoadingMoreContainer, {
        ref: setLoadMoreElement
    }, isLoadingNext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8yqbI.IssueListSkeleton), {
        rowCount: nextPageSize
    }) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a40gh.ErrorBoundary), {
        id: "jira.software.releases.version.detail.issue.list.screen-analytics"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fx0Tw.IssueListScreenAnalytics), {
        jiraVersionReference: jiraVersionData,
        jiraIssueEdgesReference: issueEdges
    })));
};
const $6c9ffa8d73f171f7$var$IssueListWithHeader = ({ jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const data = (0, $8Uumt.useFragment)((0, $aJqtc.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "versionDetailsTable",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a40gh.ErrorBoundary), {
        id: "issuesListDevDetailsDialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Q2kM.DevDetailsDialogLoaderAsync), {
        scopeId: $6c9ffa8d73f171f7$var$DEV_DETAILS_DIALOG_SCOPE_ID
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fi7WV.CollapsibleSection), {
        jiraVersion: data,
        uiType: "ISSUES",
        renderHeader: (isCollapsed, onToggleClicked)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6c9ffa8d73f171f7$var$HeaderCollapsibleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6c9ffa8d73f171f7$var$HeaderLeftWrapper, {
                onClick: onToggleClicked
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
                size: "small",
                as: "h2"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $6c9ffa8d73f171f7$var$sectionTitleStyles
            }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $9VaPq.default).issuesIssueTerminologyRefreshM4 : (0, $9VaPq.default).issues))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
                id: "jira.software.releases.version.detail.issue-total-count",
                packageName: "jira-software-releases-version-detail-issue-list",
                teamName: "nova"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Ql36.IssueTotalCount), {
                jiraVersion: data
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fi7WV.CollapsibleToggleButton), {
                isCollapsed: isCollapsed
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6c9ffa8d73f171f7$var$HeaderRightWrapper, null, data.canAddAndRemoveIssues === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6c9ffa8d73f171f7$var$AddIssueWrapper, {
                key: "addIssuesButton"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jX1s1.AddIssuesToVersion), {
                appearance: "subtle",
                isIssueListFooterButton: true,
                jiraVersion: data,
                showIcon: true,
                showLabel: false
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hWY96.IssuesMoreButton), {
                key: "issuesMoreButton",
                jiraVersion: data,
                jiraIssueEdges: data.issuesForList.edges.filter(Boolean)
            }))),
        renderBody: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bLVnv.ListOptions), {
                jiraVersion: data
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
                name: "issues-refetchable",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8yqbI.IssueListSkeleton), {
                    rowCount: 10,
                    marginTop: (0, $gwIPs.gridSize) * 2
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6c9ffa8d73f171f7$var$IssuesRefetchable, {
                jiraVersion: data
            })))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1MXmG.ViewVersionDetailsPageExperienceSuccessTracker), null));
};
const $6c9ffa8d73f171f7$export$d97e9356033839cd = ({ jiraVersion: jiraVersion })=>{
    const jiraVersionData = (0, $8Uumt.useFragment)((0, $aVXy2.default), jiraVersion);
    const onExperienceFail = (0, $1MXmG.useViewVersionDetailsPageExperienceFail)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8YQNr.ErrorView), null),
        id: "jira.software.releases.version.detail.issue.list",
        packageName: "jira-software-releases-version-detail-issue-list",
        teamName: "nova",
        onError: (location, error)=>{
            // We consider the experience to have failed if the issues don't render.
            onExperienceFail(location, error);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6c9ffa8d73f171f7$var$IssueListWithHeader, {
        jiraVersion: jiraVersionData
    }));
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6c9ffa8d73f171f7$var$LoadingMoreContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _1tke7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6c9ffa8d73f171f7$var$AddIssueWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3izwfg _1bsbzwfg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6c9ffa8d73f171f7$var$HeaderCollapsibleWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _19pk1jfw _otyr1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6c9ffa8d73f171f7$var$HeaderLeftWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _80omtlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6c9ffa8d73f171f7$var$HeaderRightWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $6c9ffa8d73f171f7$var$sectionTitleStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.100'
});

});
parcelRegister("aVXy2", function(module, exports) {

$parcel$export(module.exports, "default", () => $520f02734ed0daec$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3899b8733ba6e7fa9ae649f9b64eb5ae>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $520f02734ed0daec$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_softwareReleasesVersionDetailIssueList_IssueListWithHeaderWithErrorBoundary_jiraVersion",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionDetailIssueList_IssueListWithHeader_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$520f02734ed0daec$var$node.hash = "dcffc936c288beebfd459b5bcb75d18a";
var $520f02734ed0daec$export$2e2bcd8739ae039 = $520f02734ed0daec$var$node;

});

parcelRegister("aJqtc", function(module, exports) {

$parcel$export(module.exports, "default", () => $5703710cb99335d5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fc8305fdf5209e2adc6247847e2cf39d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5703710cb99335d5$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        },
        {
            "kind": "RootArgument",
            "name": "filters"
        },
        {
            "defaultValue": 20,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "kind": "RootArgument",
            "name": "sortBy"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "connection": [
            {
                "count": "first",
                "cursor": "after",
                "direction": "forward",
                "path": [
                    "issuesForList"
                ]
            }
        ]
    },
    "name": "ui_softwareReleasesVersionDetailIssueList_IssueListWithHeader_jiraVersion",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion"
        },
        {
            "kind": "FragmentSpread",
            "name": "listOptions_softwareReleasesVersionDetailIssueList"
        },
        {
            "kind": "FragmentSpread",
            "name": "issuesMoreButton_softwareReleasesVersionDetailIssueList_jiraVersion"
        },
        {
            "kind": "FragmentSpread",
            "name": "issueTotalCount_softwareReleasesVersionDetailIssueList"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesAddIssuesToVersion_AddIssuesToVersion"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "canAddAndRemoveIssues"
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "issuesForList",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "filter",
                        "value": "ALL"
                    },
                    {
                        "kind": "Variable",
                        "name": "filters",
                        "variableName": "filters"
                    },
                    {
                        "kind": "Variable",
                        "name": "sortBy",
                        "variableName": "sortBy"
                    }
                ],
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "__ListVersion_issuesForList_connection",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "totalCount"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraIssueEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "issues_softwareReleasesVersionDetailIssueList_jiraIssueEdgesReference"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "issuesMoreButton_softwareReleasesVersionDetailIssueList_jiraIssueEdges"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                },
                                {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "issuesForList.edges"
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            }
                        ]
                    }
                ]
            },
            "action": "THROW",
            "path": "issuesForList"
        }
    ],
    "type": "JiraVersion"
};
$5703710cb99335d5$var$node.hash = "1b95186d8ae0c639ac2a3313467b4212";
var $5703710cb99335d5$export$2e2bcd8739ae039 = $5703710cb99335d5$var$node;

});

parcelRegister("bkWqL", function(module, exports) {

$parcel$export(module.exports, "default", () => $98a4a861304e679a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<afe953a9bd8335f4d97d24c69a64880b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $d1Clq = parcelRequire("d1Clq");
const $98a4a861304e679a$var$node = function() {
    var v0 = [
        "issuesForList"
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "filters"
            },
            {
                "defaultValue": 20,
                "kind": "LocalArgument",
                "name": "first"
            },
            {
                "kind": "RootArgument",
                "name": "isDevopsFeatureDisabledInFedRamp"
            },
            {
                "kind": "RootArgument",
                "name": "shouldIncludeDevOpsFieldsViaAgs"
            },
            {
                "kind": "RootArgument",
                "name": "sortBy"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $d1Clq.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "issues_softwareReleasesVersionDetailIssueList_jiraVersion"
            },
            {
                "kind": "FragmentSpread",
                "name": "issues_softwareReleasesVersionDetailIssueList_jiraVersionRefetch"
            },
            {
                "kind": "FragmentSpread",
                "name": "emptyView_softwareReleasesVersionDetailIssueList"
            },
            {
                "kind": "FragmentSpread",
                "name": "screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraVersionReference"
            },
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "issuesForList",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filter",
                            "value": "ALL"
                        },
                        {
                            "kind": "Variable",
                            "name": "filters",
                            "variableName": "filters"
                        },
                        {
                            "kind": "Variable",
                            "name": "sortBy",
                            "variableName": "sortBy"
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "__ListVersion_issuesForList_connection",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "jql"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraIssueEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "issues_softwareReleasesVersionDetailIssueList_jiraIssueEdgesReference"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "issuesMoreButton_softwareReleasesVersionDetailIssueList_jiraIssueEdges"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraIssueEdgesReference"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "cursor"
                                    },
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "issuesForList.edges"
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                }
                            ]
                        }
                    ]
                },
                "action": "THROW",
                "path": "issuesForList"
            }
        ],
        "type": "JiraVersion"
    };
}();
$98a4a861304e679a$var$node.hash = "1a52a23b324242e6dd47774f54758481";
var $98a4a861304e679a$export$2e2bcd8739ae039 = $98a4a861304e679a$var$node;

});
parcelRegister("d1Clq", function(module, exports) {

$parcel$export(module.exports, "default", () => $897a8fc037864ba8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b8e5e6c4861be36ba1ebe02a7ca72dd8>>
 * @relayHash 926652cbe6aafd3eddbe8535aad42e17
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 63750ab0a2250525c5ca610965a5619cc87f7f724597c54e44da6e307b787ac6
const $897a8fc037864ba8$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filters"
    }, v2 = {
        "defaultValue": 20,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDevopsFeatureDisabledInFedRamp"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldIncludeDevOpsFieldsViaAgs"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v8 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v9 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "kind": "ScalarField",
        "name": "key"
    }, v13 = {
        "kind": "ScalarField",
        "name": "name"
    }, v14 = [
        v8 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "filter",
            "value": "ALL"
        },
        {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters"
        },
        v9 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy"
        }
    ], v15 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v16 = {
        "kind": "ScalarField",
        "name": "count"
    }, v17 = {
        "kind": "ScalarField",
        "name": "state"
    }, v18 = {
        "concreteType": "DevOpsSummarisedBuildState",
        "kind": "LinkedField",
        "name": "buildStates",
        "plural": true,
        "selections": [
            v17 /*: any*/ ,
            v16 /*: any*/ 
        ]
    }, v19 = [
        v16 /*: any*/ 
    ], v20 = [
        v16 /*: any*/ ,
        v11 /*: any*/ 
    ], v21 = {
        "concreteType": "DevOpsSummarisedDeployments",
        "kind": "LinkedField",
        "name": "summarisedDeployments",
        "plural": false,
        "selections": v20 /*: any*/ 
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "verionDetailsIssueListQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v8 /*: any*/ ,
                                v9 /*: any*/ 
                            ],
                            "kind": "FragmentSpread",
                            "name": "ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "verionDetailsIssueListQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "JiraVersionWarningConfig",
                                    "kind": "LinkedField",
                                    "name": "warningConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "openPullRequest"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "openReview"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "unreviewedCode"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "failingBuild"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canViewDevTools"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "versionIssueTableHiddenColumns"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddAndRemoveIssues"
                                },
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "project",
                                    "plural": false,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectId"
                                        },
                                        v12 /*: any*/ 
                                    ]
                                },
                                v13 /*: any*/ ,
                                {
                                    "alias": "issuesForList",
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": [
                                        v15 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "ids",
                                                                    "value": [
                                                                        "priority",
                                                                        "summary",
                                                                        "assignee",
                                                                        "status",
                                                                        "issuetype"
                                                                    ]
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v10 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "fieldId"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraStatus",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "status",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "statusCategoryId"
                                                                                                        },
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v11 /*: any*/ ,
                                                                                                v13 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "description"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraStatusField"
                                                                                },
                                                                                v11 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v10 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "picture"
                                                                                                },
                                                                                                v13 /*: any*/ ,
                                                                                                v11 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "text"
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraSingleLineTextField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v13 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraAvatar",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "avatar",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "xsmall"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v11 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueTypeField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraPriority",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "priority",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v13 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                },
                                                                                                v11 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraPriorityField"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "issueId"
                                                        },
                                                        {
                                                            "concreteType": "DevOpsSummarisedFeatureFlags",
                                                            "kind": "LinkedField",
                                                            "name": "summarisedFeatureFlags",
                                                            "plural": false,
                                                            "selections": [
                                                                v15 /*: any*/ 
                                                            ]
                                                        },
                                                        v10 /*: any*/ ,
                                                        {
                                                            "condition": "isDevopsFeatureDisabledInFedRamp",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsSummarisedEntities",
                                                                    "kind": "LinkedField",
                                                                    "name": "devOpsSummarisedEntities",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedDeployments",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedDeployments",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v16 /*: any*/ ,
                                                                                v11 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "deploymentState"
                                                                                },
                                                                                {
                                                                                    "concreteType": "DevOpsEnvironment",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "deploymentEnvironment",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "category"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedBuilds",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedBuilds",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v16 /*: any*/ ,
                                                                                v11 /*: any*/ ,
                                                                                v18 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraIssueDevSummaryResult",
                                                                    "kind": "LinkedField",
                                                                    "name": "devSummaryCache",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueDevSummary",
                                                                            "kind": "LinkedField",
                                                                            "name": "devSummary",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "pullrequest",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssuePullRequestDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v16 /*: any*/ ,
                                                                                                v17 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "branch",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueBranchDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": v19 /*: any*/ 
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "review",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueReviewDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v16 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "lastUpdated"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "stateCount"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueDevSummaryByProvider",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "summaryByProvider",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "providerId"
                                                                                                },
                                                                                                v13 /*: any*/ ,
                                                                                                v16 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "commit",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueCommitDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": v19 /*: any*/ 
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "build",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueBuildDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v16 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "failedBuildCount"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "successfulBuildCount"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "unknownBuildCount"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "deploymentEnvironments",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "overall",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueDeploymentEnvironment",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "topEnvironments",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "status"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "title"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "DevOpsSummarisedFeatureFlags",
                                                                    "kind": "LinkedField",
                                                                    "name": "summarisedFeatureFlags",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "mostRelevantDisplayName"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "mostRelevantEnabled"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "mostRelevantRolloutPercentage"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedBuilds",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedBuilds",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v18 /*: any*/ ,
                                                                                v16 /*: any*/ ,
                                                                                v11 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v21 /*: any*/ ,
                                                                {
                                                                    "concreteType": "DevOpsSummarisedBuilds",
                                                                    "kind": "LinkedField",
                                                                    "name": "summarisedBuilds",
                                                                    "plural": false,
                                                                    "selections": v20 /*: any*/ 
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "alias": "issuesForList",
                                    "args": v14 /*: any*/ ,
                                    "filters": [
                                        "filter",
                                        "sortBy",
                                        "filters"
                                    ],
                                    "handle": "connection",
                                    "key": "ListVersion_issuesForList",
                                    "kind": "LinkedHandle",
                                    "name": "issues"
                                },
                                {
                                    "condition": "isDevopsFeatureDisabledInFedRamp",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "concreteType": "DevOpsSummarisedEntities",
                                            "kind": "LinkedField",
                                            "name": "devOpsSummarisedEntities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "DevOpsProviders",
                                                    "kind": "LinkedField",
                                                    "name": "providers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsFeatureFlagProvider",
                                                            "kind": "LinkedField",
                                                            "name": "featureFlagProviders",
                                                            "plural": true,
                                                            "selections": [
                                                                v10 /*: any*/ ,
                                                                v11 /*: any*/ ,
                                                                v13 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "createFeatureFlagTemplateUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "connectFeatureFlagTemplateUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "logoUrl"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraVersion"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "63750ab0a2250525c5ca610965a5619cc87f7f724597c54e44da6e307b787ac6",
            "metadata": {},
            "name": "verionDetailsIssueListQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$897a8fc037864ba8$var$node.hash = "1a52a23b324242e6dd47774f54758481";
var $897a8fc037864ba8$export$2e2bcd8739ae039 = $897a8fc037864ba8$var$node;

});


parcelRegister("7Q2kM", function(module, exports) {

$parcel$export(module.exports, "DevDetailsDialogLoaderAsync", () => $1e951f8230b07137$export$f5ffc0f323543e16);
$parcel$export(module.exports, "default", () => $1e951f8230b07137$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1e951f8230b07137$var$DevDetailDialogLoaderWithContainer = (0, $kxZPA.lazy)(()=>(parcelRequire("yNiJl")), {
    ssr: false,
    moduleId: "./src/packages/development/details-loader/src/ui/index-old.tsx"
});
const $1e951f8230b07137$export$f5ffc0f323543e16 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "dev-detail-dialog-loader-with-container",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1e951f8230b07137$var$DevDetailDialogLoaderWithContainer, props));
$1e951f8230b07137$export$f5ffc0f323543e16.defaultProps = {
    onCloseDevDetailDialog: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $1e951f8230b07137$export$2e2bcd8739ae039 = $1e951f8230b07137$export$f5ffc0f323543e16;

});
parcelRegister("yNiJl", function(module, exports) {

let $06896b433283881c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $06896b433283881c$var$load("76n7a"),
    $06896b433283881c$var$load("l253H"),
    $06896b433283881c$var$load("drDbh")
]).then(()=>parcelRequire('26nI6'));

});


parcelRegister("fi7WV", function(module, exports) {

$parcel$export(module.exports, "CollapsibleToggleButton", () => $b5a0aa544c0a186e$export$9438d677ba26a40a);
$parcel$export(module.exports, "CollapsibleSection", () => $b5a0aa544c0a186e$export$55b973e094275b13);

var $eaM0Q = parcelRequire("eaM0Q");

var $eXHXY = parcelRequire("eXHXY");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $kEVMo = parcelRequire("kEVMo");

var $3uzfU = parcelRequire("3uzfU");

var $fVnbM = parcelRequire("fVnbM");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $doJJi = parcelRequire("doJJi");

var $3obFm = parcelRequire("3obFm");
const $b5a0aa544c0a186e$var$getNewCollapsedUis = (currentState, type, isCurrentlyCollapsed)=>isCurrentlyCollapsed ? currentState.filter((value)=>value !== type) : [
        ...currentState,
        type
    ];
const $b5a0aa544c0a186e$export$9438d677ba26a40a = ({ isCollapsed: isCollapsed, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const icon = isCollapsed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3uzfU))), {
        spacing: "spacious",
        label: formatMessage((0, $doJJi.default).collapsedIconLabel),
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kEVMo))), {
        spacing: "spacious",
        label: formatMessage((0, $doJJi.default).expandedIconLabel),
        size: "small"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        iconBefore: icon,
        onClick: onClick
    });
};
const $b5a0aa544c0a186e$export$55b973e094275b13 = ({ jiraVersion: jiraVersion, uiType: uiType, renderHeader: renderHeader, renderBody: renderBody })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const version = (0, $8Uumt.useFragment)((0, $eXHXY.default), jiraVersion);
    const collapsedUis = (version.collapsedUis ?? []).filter(Boolean);
    const [updateCollapsedUis] = (0, $8Uumt.useMutation)((0, $eaM0Q.default));
    const onError = ()=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'jira.releases.version.detail.collapsed-uis.user-preference.mutation.error.id',
                packageName: 'jiraSoftwareReleasesCollapsibleUiToggle',
                teamName: 'nova'
            },
            error: Error('Unable to update collapsed ui state'),
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const saveUserPreference = (newCollapsedUis)=>{
        updateCollapsedUis({
            variables: {
                input: {
                    collapsedUis: newCollapsedUis,
                    versionId: version.id
                }
            },
            onCompleted: (data)=>{
                if (!data.jira?.saveVersionDetailsCollapsedUis?.success) onError();
            },
            onError: onError,
            optimisticResponse: {
                jira: {
                    saveVersionDetailsCollapsedUis: {
                        success: true,
                        version: {
                            collapsedUis: newCollapsedUis,
                            id: version.id
                        }
                    }
                }
            }
        });
    };
    const isCollapsed = collapsedUis.includes(uiType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderHeader(isCollapsed, ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'collapsedUiToggleButon'
        }), 'versionDetailsCollapsedUis', {
            uiType: uiType,
            action: isCollapsed ? 'expand' : 'collapse'
        });
        saveUserPreference($b5a0aa544c0a186e$var$getNewCollapsedUis(collapsedUis, uiType, isCollapsed));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b5a0aa544c0a186e$var$CollapsibleContent, {
        isCollapsed: (0, $3obFm.checkIsCollapsed)(version.collapsedUis, uiType)
    }, renderBody()));
};
const $b5a0aa544c0a186e$var$CollapsibleContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCollapsed: isCollapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isCollapsed ? "_1e0cglyw" : "_1e0c1ule",
            __cmplp.isCollapsed ? "_otyr1jfw" : "_otyrze3t",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eaM0Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $c64b6eb7486b219d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<91eb2a3d04e52917a45ca405de73e8cd>>
 * @relayHash 0d7cc146aa12b13eaa5a11bd667fa49c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 59da25bc507c60457c7c0a7f80672b6888c11c77e2bed2a33db2c0d2dcd80db9
const $c64b6eb7486b219d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "collapsedUis"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_collapsibleUiTriggerButton_updateCollapsedUisMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraVersionDetailsCollapsedUisPayload",
                            "kind": "LinkedField",
                            "name": "saveVersionDetailsCollapsedUis",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_collapsibleUiTriggerButton_updateCollapsedUisMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraVersionDetailsCollapsedUisPayload",
                            "kind": "LinkedField",
                            "name": "saveVersionDetailsCollapsedUis",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "59da25bc507c60457c7c0a7f80672b6888c11c77e2bed2a33db2c0d2dcd80db9",
            "metadata": {},
            "name": "ui_collapsibleUiTriggerButton_updateCollapsedUisMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$c64b6eb7486b219d$var$node.hash = "784b6375f621589ebabb1f85323c82aa";
var $c64b6eb7486b219d$export$2e2bcd8739ae039 = $c64b6eb7486b219d$var$node;

});

parcelRegister("eXHXY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8bf2bd9e5955f9e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c85bb8d4319589d7107ce65db6b00c60>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e8bf2bd9e5955f9e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "collapsedUis"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        }
    ],
    "type": "JiraVersion"
};
$e8bf2bd9e5955f9e$var$node.hash = "4c7960151ff25f69412e79192a278d0e";
var $e8bf2bd9e5955f9e$export$2e2bcd8739ae039 = $e8bf2bd9e5955f9e$var$node;

});

parcelRegister("doJJi", function(module, exports) {

$parcel$export(module.exports, "default", () => $8228388d4b0e23ba$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8228388d4b0e23ba$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    collapsedIconLabel: {
        "id": "software-releases-collapsible-ui-toggle.collapsed-icon-label",
        "defaultMessage": "Click/enter to expand the section"
    },
    expandedIconLabel: {
        "id": "software-releases-collapsible-ui-toggle.expanded-icon-label",
        "defaultMessage": "Click/enter to collapse the section"
    }
});

});

parcelRegister("3obFm", function(module, exports) {

$parcel$export(module.exports, "checkIsCollapsed", () => $48ec67b9d596c03c$export$b5bb70308851c0e1);
const $48ec67b9d596c03c$export$b5bb70308851c0e1 = (collapsedUis, type)=>(collapsedUis ?? []).includes(type);

});


parcelRegister("1YU2V", function(module, exports) {

$parcel$export(module.exports, "useFilterSortingQueryParams", () => $b2385da6883008a2$export$c59d013998b3679d);

var $gULOk = parcelRequire("gULOk");

var $3hGWp = parcelRequire("3hGWp");


var $3dG8c = parcelRequire("3dG8c");
const $b2385da6883008a2$var$joinValuesIfNotEmpty = (values)=>values.length ? values.join(',') : undefined;
const $b2385da6883008a2$export$c59d013998b3679d = ()=>{
    const [queryParams, setQueryParams] = (0, $3hGWp.useQueryParams)((0, $5d187be87424268f$export$e39925d10cebc0b), (0, $5d187be87424268f$export$b98a7875ddbefaac), (0, $5d187be87424268f$export$c307007520232013), (0, $5d187be87424268f$export$2552faed9df6a2cd), (0, $5d187be87424268f$export$f78d8c81fcad32a2), (0, $5d187be87424268f$export$13d5b2891ca65cd6), (0, $5d187be87424268f$export$810a1f7ed2facfcb));
    const parsedQueryParams = (0, $3dG8c.parseQueryParams)(queryParams);
    return {
        parsedQueryParams: parsedQueryParams,
        isAnyFilterApplied: (0, $3dG8c.isAnyFilterApplied)(parsedQueryParams),
        setTextFilterParam: (searchStr)=>setQueryParams({
                [(0, $5d187be87424268f$export$e39925d10cebc0b)]: searchStr === '' || searchStr == null ? undefined : searchStr
            }),
        setEpicFilterParam: (issueIds)=>setQueryParams({
                [(0, $5d187be87424268f$export$b98a7875ddbefaac)]: $b2385da6883008a2$var$joinValuesIfNotEmpty(issueIds)
            }),
        setStatusCategoryFilterParam: (statusCategories)=>setQueryParams({
                [(0, $5d187be87424268f$export$c307007520232013)]: $b2385da6883008a2$var$joinValuesIfNotEmpty(statusCategories.map((0, $gULOk.statusCategoryForId)))
            }),
        setWarningsFilterParam: (warnings)=>setQueryParams({
                [(0, $5d187be87424268f$export$2552faed9df6a2cd)]: $b2385da6883008a2$var$joinValuesIfNotEmpty(warnings)
            }),
        setAssigneeFilterParam: (assignees)=>setQueryParams({
                [(0, $5d187be87424268f$export$f78d8c81fcad32a2)]: $b2385da6883008a2$var$joinValuesIfNotEmpty(assignees)
            }),
        setSortByParam: (sortBy)=>setQueryParams({
                [(0, $5d187be87424268f$export$13d5b2891ca65cd6)]: sortBy
            }),
        setSortOrderParam: (sortOrder)=>setQueryParams({
                [(0, $5d187be87424268f$export$810a1f7ed2facfcb)]: sortOrder
            }),
        clearAll: ()=>{
            setQueryParams({
                [(0, $5d187be87424268f$export$e39925d10cebc0b)]: undefined,
                [(0, $5d187be87424268f$export$b98a7875ddbefaac)]: undefined,
                [(0, $5d187be87424268f$export$c307007520232013)]: undefined,
                [(0, $5d187be87424268f$export$2552faed9df6a2cd)]: undefined,
                [(0, $5d187be87424268f$export$f78d8c81fcad32a2)]: undefined,
                [(0, $5d187be87424268f$export$13d5b2891ca65cd6)]: undefined,
                [(0, $5d187be87424268f$export$810a1f7ed2facfcb)]: undefined
            });
        },
        showIssuesWithWarnings: (warnings)=>{
            setQueryParams({
                [(0, $5d187be87424268f$export$e39925d10cebc0b)]: undefined,
                [(0, $5d187be87424268f$export$b98a7875ddbefaac)]: undefined,
                [(0, $5d187be87424268f$export$c307007520232013)]: undefined,
                [(0, $5d187be87424268f$export$2552faed9df6a2cd)]: $b2385da6883008a2$var$joinValuesIfNotEmpty(warnings),
                [(0, $5d187be87424268f$export$f78d8c81fcad32a2)]: undefined,
                [(0, $5d187be87424268f$export$13d5b2891ca65cd6)]: undefined,
                [(0, $5d187be87424268f$export$810a1f7ed2facfcb)]: undefined
            });
        },
        showStatusCategoryIssues: (statusCategories)=>{
            setQueryParams({
                [(0, $5d187be87424268f$export$e39925d10cebc0b)]: undefined,
                [(0, $5d187be87424268f$export$b98a7875ddbefaac)]: undefined,
                [(0, $5d187be87424268f$export$c307007520232013)]: $b2385da6883008a2$var$joinValuesIfNotEmpty(statusCategories.map((0, $gULOk.statusCategoryForId))),
                [(0, $5d187be87424268f$export$2552faed9df6a2cd)]: undefined,
                [(0, $5d187be87424268f$export$f78d8c81fcad32a2)]: undefined,
                [(0, $5d187be87424268f$export$13d5b2891ca65cd6)]: undefined,
                [(0, $5d187be87424268f$export$810a1f7ed2facfcb)]: undefined
            });
        }
    };
};
const $b2385da6883008a2$export$22b92ff6db8f144a = ()=>{
    const { parsedQueryParams: parsedQueryParams } = $b2385da6883008a2$export$c59d013998b3679d();
    return {
        sortByField: parsedQueryParams[0, $5d187be87424268f$export$13d5b2891ca65cd6] ?? 'CREATED',
        sortOrder: parsedQueryParams[0, $5d187be87424268f$export$810a1f7ed2facfcb] ?? 'ASC'
    };
};

});
const $5d187be87424268f$export$e39925d10cebc0b = 'text';
const $5d187be87424268f$export$b98a7875ddbefaac = 'epics';
const $5d187be87424268f$export$c307007520232013 = 'statusCategory';
const $5d187be87424268f$export$2552faed9df6a2cd = 'warnings';
const $5d187be87424268f$export$f78d8c81fcad32a2 = 'assignee';
const $5d187be87424268f$export$13d5b2891ca65cd6 = 'sortBy';
const $5d187be87424268f$export$810a1f7ed2facfcb = 'sortOrder';


parcelRegister("bRpse", function(module, exports) {

$parcel$export(module.exports, "useDeepMemo", () => $e5f49c67ed7d4ae1$export$722debc0e56fea39);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");
const $e5f49c67ed7d4ae1$export$722debc0e56fea39 = (value)=>{
    const ref = (0, $5uXOq.useRef)(value);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(value, ref.current)) ref.current = value;
    return ref.current;
};

});

parcelRegister("a40gh", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $36364ba0c826f8ba$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");
const $36364ba0c826f8ba$export$e926676385687eaf = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        ...props,
        packageName: "jiraSoftwareReleasesVersionDetailIssueList",
        teamName: "nova"
    });

});

parcelRegister("1MXmG", function(module, exports) {

$parcel$export(module.exports, "useViewVersionDetailsPageExperienceFail", () => $140934677320acf2$export$f9fb921f60393679);
$parcel$export(module.exports, "useViewVersionDetailsPageExperienceSuccess", () => $140934677320acf2$export$1a84e8ad118354e4);
$parcel$export(module.exports, "ViewVersionDetailsPageExperienceSuccessTracker", () => $140934677320acf2$export$ab0e4c71ad46eacd);

var $5uXOq = parcelRequire("5uXOq");

var $93jKl = parcelRequire("93jKl");

var $3bQtK = parcelRequire("3bQtK");

var $cfyOy = parcelRequire("cfyOy");
const $140934677320acf2$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME = 'viewVersionDetailsPage';
const $140934677320acf2$export$f9fb921f60393679 = ()=>(0, $93jKl.useExperienceFail)({
        experience: $140934677320acf2$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME
    });
const $140934677320acf2$export$1a84e8ad118354e4 = ()=>(0, $3bQtK.useExperienceSuccess)({
        experience: $140934677320acf2$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME
    });
const $140934677320acf2$export$ab0e4c71ad46eacd = ()=>{
    const projectInfo = (0, $cfyOy.useProjectAnalyticsAttributes)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: $140934677320acf2$var$VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME,
        attributes: {
            ...projectInfo
        }
    });
};

});
parcelRegister("cfyOy", function(module, exports) {

$parcel$export(module.exports, "useProjectAnalyticsAttributes", () => $f14bce8f0d26bc71$export$b6a91b2d78273787);

var $kUACW = parcelRequire("kUACW");

var $dxCvy = parcelRequire("dxCvy");

var $g5X3G = parcelRequire("g5X3G");

var $2YP9W = parcelRequire("2YP9W");
const $f14bce8f0d26bc71$export$a3138047c831fa4e = (0, $kUACW.withSuspense)(()=>(0, $2YP9W.useResource)((0, $dxCvy.projectContextResource)));
const $f14bce8f0d26bc71$export$8f31c2503e1efa93 = ()=>{
    const { data: data, error: error } = $f14bce8f0d26bc71$export$a3138047c831fa4e();
    if (data == null) throw new Error(`data of useProjectContext via withSuspense shouldn't be null. If projectContext is null, this means an invalid project key was provided and the page should return a 404 and useProjectContext should never be called. error: ${error !== null ? error.message : 'null'}`);
    return {
        ...data,
        projectKey: (0, $g5X3G.toProjectKey)(data.projectKey),
        projectId: (0, $g5X3G.toProjectId)(data.projectId.toString())
    };
};
const $f14bce8f0d26bc71$export$b6a91b2d78273787 = ()=>{
    const { projectId: projectId, isProjectAdmin: isProjectAdmin, simplified: simplified } = $f14bce8f0d26bc71$export$8f31c2503e1efa93();
    return {
        isSimplified: simplified,
        isProjectAdmin: isProjectAdmin,
        projectId: projectId
    };
};

});


parcelRegister("liM6F", function(module, exports) {

$parcel$export(module.exports, "EmptyView", () => $2f71f8e52115bae9$export$f716ac8971c5316e);

var $agoe7 = parcelRequire("agoe7");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $4R6GH = parcelRequire("4R6GH");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $jX1s1 = parcelRequire("jX1s1");

var $1YU2V = parcelRequire("1YU2V");

var $dSW1K = parcelRequire("dSW1K");

var $2Ntf8 = parcelRequire("2Ntf8");

var $gkaEo = parcelRequire("gkaEo");
const $2f71f8e52115bae9$export$f716ac8971c5316e = ({ jiraVersion: jiraVersion, isAnyFilterApplied: isAnyFilterApplied, textFilter: textFilter })=>{
    const { clearAll: clearAll } = (0, $1YU2V.useFilterSortingQueryParams)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const version = (0, $8Uumt.useFragment)((0, $agoe7.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2f71f8e52115bae9$var$Container, {
        "data-testid": "software-releases-version-detail-issue-list.ui.empty-view"
    }, isAnyFilterApplied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        headingLevel: 2,
        header: textFilter !== null ? formatMessage((0, $gkaEo.default).noIssuesMatchTextFilterHeader, {
            textFilter: textFilter
        }) : formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $gkaEo.default).noIssuesMatchFilterHeaderIssueTerminologyRefreshM4 : (0, $gkaEo.default).noIssuesMatchFilterHeader),
        description: textFilter !== null ? formatMessage((0, $gkaEo.default).noIssuesMatchTextFilterDescription) : formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $gkaEo.default).noIssuesMatchFilterDescriptionIssueTerminologyRefreshM4 : (0, $gkaEo.default).noIssuesMatchFilterDescription),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($2Ntf8))),
        imageWidth: (0, $gwIPs.gridSize) * 8,
        imageHeight: (0, $gwIPs.gridSize) * 11.5,
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "primary",
            onClick: (_, analyticsEvent)=>{
                clearAll();
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'clearFilter');
            }
        }, formatMessage((0, $gkaEo.default).clearFilters))
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        headingLevel: 2,
        header: formatMessage((0, $gkaEo.default).noIssuesInVersionHeader),
        description: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $gkaEo.default).noIssuesInVersionDescriptionIssueTerminologyRefreshM4 : (0, $gkaEo.default).noIssuesInVersionDescription),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($dSW1K))),
        imageWidth: (0, $gwIPs.gridSize) * 16,
        imageHeight: (0, $gwIPs.gridSize) * 13,
        primaryAction: version?.canAddAndRemoveIssues === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jX1s1.AddIssuesToVersion), {
            appearance: "primary",
            jiraVersion: version
        }) : undefined
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2f71f8e52115bae9$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qv47k",
            __cmplp.className
        ])
    });
});

});
parcelRegister("agoe7", function(module, exports) {

$parcel$export(module.exports, "default", () => $daadb41da5a489f3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<69fe4b1ae49101ed737d416416098410>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $daadb41da5a489f3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "emptyView_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "canAddAndRemoveIssues"
            },
            "action": "LOG",
            "path": "canAddAndRemoveIssues"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesAddIssuesToVersion_AddIssuesToVersion"
        }
    ],
    "type": "JiraVersion"
};
$daadb41da5a489f3$var$node.hash = "e747dc1997c64c6a07fe54d01ff7878c";
var $daadb41da5a489f3$export$2e2bcd8739ae039 = $daadb41da5a489f3$var$node;

});

parcelRegister("dSW1K", function(module, exports) {
module.exports = new URL("noIssuesInVersion.348ccc3b.svg", import.meta.url).toString();

});

parcelRegister("2Ntf8", function(module, exports) {
module.exports = new URL("noSearchResults.d74f9061.svg", import.meta.url).toString();

});

parcelRegister("gkaEo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9efc6fa540355ad$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f9efc6fa540355ad$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    // No issues in version case.
    noIssuesInVersionHeader: {
        "id": "software-releases-version-detail-issue-list.empty-view.no-issues-in-version-header",
        "defaultMessage": "Nothing to see here"
    },
    noIssuesInVersionDescription: {
        "id": "software-releases-version-detail-issue-list.empty-view.no-issues-in-version-description",
        "defaultMessage": "No issues have been added yet."
    },
    // Non-text filter applied, no matching issues.
    noIssuesMatchFilterHeader: {
        "id": "software-releases-version-detail-issue-list.empty-view.no-issues-match-filter-header",
        "defaultMessage": "No issues here"
    },
    noIssuesMatchFilterDescription: {
        "id": "software-releases-version-detail-issue-list.empty-view.no-issues-match-filter-description",
        "defaultMessage": "We didn't find any issues that match the filters you've chosen"
    },
    // Text filter applied, no matching issues.
    // Note that non-text filters may *also* be applied. These messages cover both cases.
    noIssuesMatchTextFilterHeader: {
        "id": "software-releases-version-detail-issue-list.empty-view.no-issues-match-text-filter-header",
        "defaultMessage": "We didn't find any results for \"{textFilter}\""
    },
    noIssuesMatchTextFilterDescription: {
        "id": "software-releases-version-detail-issue-list.empty-view.no-issues-match-text-filter-description",
        "defaultMessage": "Try changing your search or check any filters."
    },
    clearFilters: {
        "id": "software-releases-version-detail-issue-list.empty-view.clear-filters",
        "defaultMessage": "Clear filters"
    },
    noIssuesInVersionDescriptionIssueTerminologyRefreshM4: {
        "id": "software-releases-version-detail-issue-list.empty-view.no-issues-in-version-description-issue-terminology-refresh-m4",
        "defaultMessage": "No work items have been added yet."
    },
    noIssuesMatchFilterHeaderIssueTerminologyRefreshM4: {
        "id": "software-releases-version-detail-issue-list.empty-view.no-issues-match-filter-header-issue-terminology-refresh-m4",
        "defaultMessage": "No work items here"
    },
    noIssuesMatchFilterDescriptionIssueTerminologyRefreshM4: {
        "id": "software-releases-version-detail-issue-list.empty-view.no-issues-match-filter-description-issue-terminology-refresh-m4",
        "defaultMessage": "We didn't find any work items that match the filters you've chosen"
    }
});

});


parcelRegister("8YQNr", function(module, exports) {

$parcel$export(module.exports, "ErrorView", () => $61384f66e728894c$export$8c68b6013ae44ca6);
/* ErrorView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $1c9sF = parcelRequire("1c9sF");

var $6lHw4 = parcelRequire("6lHw4");
const $61384f66e728894c$export$8c68b6013ae44ca6 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($61384f66e728894c$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($61384f66e728894c$var$Img, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1c9sF))),
        alt: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $6lHw4.default).errorImageAltIssueTerminologyRefreshM4 : (0, $6lHw4.default).errorImageAlt)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "small"
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $6lHw4.default).failToLoadTitleNonFianlIssueTerminologyRefreshM4 : (0, $6lHw4.default).failToLoadTitleNonFianl)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($61384f66e728894c$var$ButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "link",
        onClick: ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location.reload();
        }
    }, formatMessage((0, $6lHw4.default).refreshButtonLabel))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $61384f66e728894c$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q1epz _1e0c1txw _2lx21bp4 _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $61384f66e728894c$var$Img = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyrxy5q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $61384f66e728894c$var$ButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1c9sF", function(module, exports) {
module.exports = new URL("error.e4b20277.svg", import.meta.url).toString();

});

parcelRegister("6lHw4", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fa89bd67e70d15b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5fa89bd67e70d15b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    failToLoadTitleNonFianl: {
        "id": "software-releases-version-detail-issue-list.error-view.fail-to-load-title-non-fianl",
        "defaultMessage": "Can't load issues"
    },
    refreshButtonLabel: {
        "id": "software-releases-version-detail-issue-list.error-view.refresh-button-label",
        "defaultMessage": "Refresh page"
    },
    errorImageAlt: {
        "id": "software-releases-version-detail-issue-list.error-view.error-image-alt",
        "defaultMessage": "Image that shows loading issues failed."
    },
    failToLoadTitleNonFianlIssueTerminologyRefreshM4: {
        "id": "software-releases-version-detail-issue-list.error-view.fail-to-load-title-non-fianl-issue-terminology-refresh-m4",
        "defaultMessage": "Can't load work items"
    },
    errorImageAltIssueTerminologyRefreshM4: {
        "id": "software-releases-version-detail-issue-list.error-view.error-image-alt-issue-terminology-refresh-m4",
        "defaultMessage": "Image that shows loading work items failed."
    }
});

});


parcelRegister("1Ql36", function(module, exports) {

$parcel$export(module.exports, "IssueTotalCount", () => $5ab5480930b5091b$export$7866c3f349a6505);

var $an58X = parcelRequire("an58X");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");
const $5ab5480930b5091b$export$7866c3f349a6505 = ({ jiraVersion: jiraVersion })=>{
    const data = (0, $8Uumt.useFragment)((0, $an58X.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ab5480930b5091b$var$TotalCountLozenge, null, data.allIssuesRedesignTemp.totalCount);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5ab5480930b5091b$var$TotalCountLozenge = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _2rkoftgi _bfhk11bn _1e0c1txw _1bah1h6o _4cvr1h6o _4t3i7vkz _19pkv77o _u5f31b66 _19bv1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("an58X", function(module, exports) {

$parcel$export(module.exports, "default", () => $7981ef9470073128$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<74f5e9e98ceace44d2a9daca4b2abd30>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7981ef9470073128$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueTotalCount_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "alias": "allIssuesRedesignTemp",
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "issues",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        },
                        "action": "THROW",
                        "path": "allIssuesRedesignTemp.totalCount"
                    }
                ]
            },
            "action": "THROW",
            "path": "allIssuesRedesignTemp"
        }
    ],
    "type": "JiraVersion"
};
$7981ef9470073128$var$node.hash = "aaf1e03a6deba9e0e365569571ef5db3";
var $7981ef9470073128$export$2e2bcd8739ae039 = $7981ef9470073128$var$node;

});


parcelRegister("8yqbI", function(module, exports) {

$parcel$export(module.exports, "IssueListSkeleton", () => $60a46ef98394688f$export$ebd1a9517b9c28aa);
/* IssueListSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $60a46ef98394688f$var$IssueRowSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60a46ef98394688f$var$IssueRowSkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60a46ef98394688f$var$IssueTypeSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60a46ef98394688f$var$IssueFieldSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60a46ef98394688f$var$IssueSummarySkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60a46ef98394688f$var$IssueFieldSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60a46ef98394688f$var$IssueAssigneeSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60a46ef98394688f$var$IssueDevDataSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60a46ef98394688f$var$IssueDevDataSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60a46ef98394688f$var$IssueDevDataSkeleton, null));
const $60a46ef98394688f$export$ebd1a9517b9c28aa = ({ rowCount: rowCount, marginTop: marginTop })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60a46ef98394688f$var$Wrapper, {
        marginTop: marginTop
    }, [
        ...Array(rowCount < 0 ? 10 : rowCount).keys()
    ].map((index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60a46ef98394688f$var$IssueRowSkeleton, {
            key: index
        })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $60a46ef98394688f$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { marginTop: marginTop, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1fj4wta": (0, $lD23V.default)(__cmplp.marginTop, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.marginTop ? "_19pkmye1" : "_19pkidpf",
            __cmplp.className
        ])
    });
});
const $60a46ef98394688f$var$skeletonKeyFrames = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $60a46ef98394688f$var$AnimationBaseDiv = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ju25ru3m _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1kpv _12vemgnk _bfhkn82g _j7hq1nls",
            __cmplp.className
        ])
    });
});
const $60a46ef98394688f$var$IssueRowSkeletonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3ickbl _19bvpxbi _u5f3oahv _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $60a46ef98394688f$var$IssueTypeSkeleton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $60a46ef98394688f$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _4t3i7vkz _1bsb7vkz _2hwxftgi",
            __cmplp.className
        ])
    });
});
const $60a46ef98394688f$var$IssueFieldSkeleton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $60a46ef98394688f$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _4t3i7vkz _1bsbvbgk _2hwx7vkz",
            __cmplp.className
        ])
    });
});
const $60a46ef98394688f$var$IssueDevDataSkeleton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $60a46ef98394688f$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _4t3i7vkz _1bsbvbgk _2hwxzwfg",
            __cmplp.className
        ])
    });
});
const $60a46ef98394688f$var$IssueSummarySkeleton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $60a46ef98394688f$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _4t3i7vkz _2hwx16xz _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $60a46ef98394688f$var$IssueAssigneeSkeleton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $60a46ef98394688f$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1tcg _4t3i1tcg _1bsb1tcg _2hwxvbgk",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hWY96", function(module, exports) {

$parcel$export(module.exports, "IssuesMoreButton", () => $7153158fdfc91bf5$export$ef8795476184c09b);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $bJeNF = parcelRequire("bJeNF");

var $7CMCs = parcelRequire("7CMCs");

var $koVbs = parcelRequire("koVbs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $lJsME = parcelRequire("lJsME");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7153158fdfc91bf5$var$MoreButtonLazy = (0, $kxZPA.lazy)(()=>(parcelRequire("dQkIK")).then((mod)=>mod.IssuesMoreButton), {
    moduleId: "./src/packages/releases/issue-list/src/ui/issues-more-button/index.tsx"
});
const $7153158fdfc91bf5$export$ef8795476184c09b = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "jira.software.releases.version.detail.issue.list.more.button",
        packageName: "jira-software-releases-version-detail-issue-list",
        teamName: "nova"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jira-software-releases-version-detail-issue-list",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                spacing: "spacious",
                label: formatMessage((0, $lJsME.default).moreButtonLabel)
            })
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7153158fdfc91bf5$var$MoreButtonLazy, props)));
};

});
parcelRegister("lJsME", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0e8ce19644952ff$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b0e8ce19644952ff$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issueNavigatorLink: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.issue-navigator-link",
        "defaultMessage": "View in Issue Navigator"
    },
    moreButtonLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.more-button-label",
        "defaultMessage": "More actions for the issue list"
    },
    displayInformation: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.display-information",
        "defaultMessage": "Display information"
    },
    assigneeColumnLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.assignee-column-label",
        "defaultMessage": "Assignee"
    },
    priorityColumnLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.priority-column-label",
        "defaultMessage": "Priority"
    },
    issueStatusColumnLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.issue-status-column-label",
        "defaultMessage": "Issue status"
    },
    developmentStatusColumnLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.development-status-column-label",
        "defaultMessage": "Development status"
    },
    buildStatusColumnLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.build-status-column-label",
        "defaultMessage": "Build status"
    },
    deliveryStatusColumnLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.delivery-status-column-label",
        "defaultMessage": "Delivery status"
    },
    featureFlagStatusColumnLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.feature-flag-status-column-label",
        "defaultMessage": "Feature flag status"
    },
    errorFlagDescription: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.error-flag-description",
        "defaultMessage": "We couldn't save your preference. Please try again."
    },
    moreActionColumnLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.more-action-column-label",
        "defaultMessage": "More actions"
    },
    manageWarningsButtonLabel: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.manage-warnings-button-label",
        "defaultMessage": "Manage warnings"
    },
    issueNavigatorLinkIssueTerminologyRefreshM4: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.issue-navigator-link-issue-terminology-refresh-m4",
        "defaultMessage": "View in All work navigator"
    },
    issueStatusColumnLabelIssueTerminologyRefreshM4: {
        "id": "software-releases-version-detail-issue-list.issues-more-button.issue-status-column-label-issue-terminology-refresh-m4",
        "defaultMessage": "Work item status"
    }
});

});

parcelRegister("dQkIK", function(module, exports) {

let $a14034655d3f2b57$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a14034655d3f2b57$var$load("5gMdS").then(()=>parcelRequire('6acQ9'));

});


parcelRegister("h1W9c", function(module, exports) {

$parcel$export(module.exports, "Issues", () => $08637b5c18f56f00$export$1cb51167b20548a0);

var $diDzB = parcelRequire("diDzB");

var $6JNlC = parcelRequire("6JNlC");

var $fg0QX = parcelRequire("fg0QX");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $1othz = parcelRequire("1othz");

var $5bw2O = parcelRequire("5bw2O");

var $kfztd = parcelRequire("kfztd");

var $dSE3R = parcelRequire("dSE3R");

var $dnJ5M = parcelRequire("dnJ5M");
const $08637b5c18f56f00$export$1cb51167b20548a0 = ({ jiraIssueEdgesReference: jiraIssueEdgesReference, jiraVersion: jiraVersion, jiraVersionRefetch: jiraVersionRefetch })=>{
    const [isFeatureFlagEmptyStateModalOpen, setIsFeatureFlagEmptyStateModalOpen] = (0, $5uXOq.useState)(false);
    const featureFlagButtonRef = (0, $5uXOq.useRef)(null);
    const jiraIssueEdgeReferenceData = (0, $8Uumt.useFragment)((0, $fg0QX.default), jiraIssueEdgesReference);
    const version = (0, $8Uumt.useFragment)((0, $6JNlC.default), jiraVersion);
    const [versionRefetch, refetch] = (0, $8Uumt.useRefetchableFragment)((0, $diDzB.default), jiraVersionRefetch);
    const [refetchDevOpsProviders] = (0, $1othz.useSuspenselessRefetch)((0, $5bw2O.default), refetch, {
        fetchPolicy: 'network-only'
    });
    const featureFlagProviders = (versionRefetch.devOpsSummarisedEntities?.providers.featureFlagProviders ?? []).filter(Boolean);
    const nodes = jiraIssueEdgeReferenceData?.map((edge)=>edge.node).filter(Boolean); // TODO: This will be improved by getting these values from the server either from Data Depot
    // or ARI Graph Store relationships. The current code has a bug that might result incorrect
    // boolean due to pagination. Also this is ugly to calculate in FE.
    const hasBambooDeployment = nodes.some((node)=>(node.devSummaryCache?.devSummary?.deploymentEnvironments?.overall?.topEnvironments ?? []).filter((deployment)=>deployment.status === 'DEPLOYED').length > 0);
    const hasDeployments = nodes.some((node)=>node.summarisedDeployments?.count != null && node.summarisedDeployments?.count > 0);
    const hasCommits = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.commit?.overall?.count) > 0);
    const hasPullRequests = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.pullrequest?.overall?.count) > 0);
    const hasBranches = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.branch?.overall?.count) > 0);
    const hasBuilds = nodes.some((node)=>Number(node.summarisedBuilds?.count) > 0) || nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.build?.overall?.count) > 0);
    const hasReviews = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.review?.overall?.count) > 0);
    const hasDevelopments = hasCommits || hasPullRequests || hasBranches || hasReviews;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08637b5c18f56f00$var$IssuesContainer, null, nodes.map((node, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dnJ5M.IssueCard), {
            rowNum: i + 1,
            key: node.key,
            jiraIssue: node,
            jiraVersion: version,
            onFeatureFlagEmptyStateModalOpen: setIsFeatureFlagEmptyStateModalOpen,
            featureFlagButtonRef: featureFlagButtonRef,
            hasBambooDeployment: hasBambooDeployment,
            hasDeployments: hasDeployments,
            hasDevelopments: hasDevelopments,
            hasBuilds: hasBuilds
        })), !(0, $kfztd.isDevopsFeatureDisabledInFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dSE3R.FeatureFlagEmptyStateExperienceModal), {
        returnFocusRef: featureFlagButtonRef,
        devOpsFeatureFlagProviders: featureFlagProviders,
        isOpen: isFeatureFlagEmptyStateModalOpen,
        onClose: ()=>setIsFeatureFlagEmptyStateModalOpen(false),
        onInstallSuccess: ()=>refetchDevOpsProviders({
                id: versionRefetch.id,
                isDevopsFeatureDisabledInFedRamp: (0, $kfztd.isDevopsFeatureDisabledInFedRamp)()
            })
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $08637b5c18f56f00$var$IssuesContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1pbykb7n _kqswh2mm _bfhkvuon",
            __cmplp.className
        ])
    });
});

});
parcelRegister("diDzB", function(module, exports) {

$parcel$export(module.exports, "default", () => $387657015570be4c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5c3b088ebe7d201a81358ecbe804e714>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $5bw2O = parcelRequire("5bw2O");
const $387657015570be4c$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isDevopsFeatureDisabledInFedRamp"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [
                "node"
            ],
            "operation": (0, $5bw2O.default),
            "identifierInfo": {
                "identifierField": "id",
                "identifierQueryVariableName": "id"
            }
        }
    },
    "name": "issues_softwareReleasesVersionDetailIssueList_jiraVersionRefetch",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "condition": "isDevopsFeatureDisabledInFedRamp",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "concreteType": "DevOpsSummarisedEntities",
                    "kind": "LinkedField",
                    "name": "devOpsSummarisedEntities",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "DevOpsProviders",
                                "kind": "LinkedField",
                                "name": "providers",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "DevOpsFeatureFlagProvider",
                                            "kind": "LinkedField",
                                            "name": "featureFlagProviders",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "featureFlagsEmptyState_softwareReleasesVersionDetailIssueList_FeatureFlagEmptyStateExperienceModal"
                                                }
                                            ]
                                        },
                                        "action": "NONE",
                                        "path": "devOpsSummarisedEntities.providers.featureFlagProviders"
                                    }
                                ]
                            },
                            "action": "NONE",
                            "path": "devOpsSummarisedEntities.providers"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraVersion"
};
$387657015570be4c$var$node.hash = "67e86aee284b1de0db813afbd23b7bbc";
var $387657015570be4c$export$2e2bcd8739ae039 = $387657015570be4c$var$node;

});
parcelRegister("5bw2O", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dced7270b458cdc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b14598e6e29ba4e7759c67bfb497ffd8>>
 * @relayHash e4db664c14f25d2cbd5656b656921164
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3cbb87d716e7da1ddfbdbde8292c44abd6d8a20728f8b637597b48bcde37becc
const $3dced7270b458cdc$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDevopsFeatureDisabledInFedRamp"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "versionDetailIssueListJiraVersionRefetchQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "issues_softwareReleasesVersionDetailIssueList_jiraVersionRefetch"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "versionDetailIssueListJiraVersionRefetchQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "condition": "isDevopsFeatureDisabledInFedRamp",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "concreteType": "DevOpsSummarisedEntities",
                                            "kind": "LinkedField",
                                            "name": "devOpsSummarisedEntities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "DevOpsProviders",
                                                    "kind": "LinkedField",
                                                    "name": "providers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsFeatureFlagProvider",
                                                            "kind": "LinkedField",
                                                            "name": "featureFlagProviders",
                                                            "plural": true,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "name"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "logoUrl"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraVersion"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3cbb87d716e7da1ddfbdbde8292c44abd6d8a20728f8b637597b48bcde37becc",
            "metadata": {},
            "name": "versionDetailIssueListJiraVersionRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3dced7270b458cdc$var$node.hash = "67e86aee284b1de0db813afbd23b7bbc";
var $3dced7270b458cdc$export$2e2bcd8739ae039 = $3dced7270b458cdc$var$node;

});


parcelRegister("6JNlC", function(module, exports) {

$parcel$export(module.exports, "default", () => $06a1297c8ff8ae0d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a94a622415ac6299a5332ad1cea1e5c9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $06a1297c8ff8ae0d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issues_softwareReleasesVersionDetailIssueList_jiraVersion",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "issueCard_softwareReleasesVersionDetailIssueList_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$06a1297c8ff8ae0d$var$node.hash = "224ec701c99ed1fc3c24b3cb47926906";
var $06a1297c8ff8ae0d$export$2e2bcd8739ae039 = $06a1297c8ff8ae0d$var$node;

});

parcelRegister("fg0QX", function(module, exports) {

$parcel$export(module.exports, "default", () => $95ef3cbc86f7cd1c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9eb3c88bef8f92e2541b6393844a7505>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $95ef3cbc86f7cd1c$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "count"
        }
    ], v1 = [
        {
            "concreteType": "DevOpsSummarisedDeployments",
            "kind": "LinkedField",
            "name": "summarisedDeployments",
            "plural": false,
            "selections": v0 /*: any*/ 
        },
        {
            "concreteType": "DevOpsSummarisedBuilds",
            "kind": "LinkedField",
            "name": "summarisedBuilds",
            "plural": false,
            "selections": v0 /*: any*/ 
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "isDevopsFeatureDisabledInFedRamp"
            },
            {
                "kind": "RootArgument",
                "name": "shouldIncludeDevOpsFieldsViaAgs"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "plural": true
        },
        "name": "issues_softwareReleasesVersionDetailIssueList_jiraIssueEdgesReference",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            "action": "THROW",
                            "path": "node.key"
                        },
                        {
                            "condition": "isDevopsFeatureDisabledInFedRamp",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "concreteType": "DevOpsSummarisedEntities",
                                    "kind": "LinkedField",
                                    "name": "devOpsSummarisedEntities",
                                    "plural": false,
                                    "selections": v1 /*: any*/ 
                                },
                                {
                                    "concreteType": "JiraIssueDevSummaryResult",
                                    "kind": "LinkedField",
                                    "name": "devSummaryCache",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueDevSummary",
                                            "kind": "LinkedField",
                                            "name": "devSummary",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                    "kind": "LinkedField",
                                                    "name": "pullrequest",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssuePullRequestDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": v0 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                    "kind": "LinkedField",
                                                    "name": "branch",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueBranchDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": v0 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                    "kind": "LinkedField",
                                                    "name": "review",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueReviewDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": v0 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                    "kind": "LinkedField",
                                                    "name": "commit",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueCommitDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": v0 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                    "kind": "LinkedField",
                                                    "name": "build",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueBuildDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": v0 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                    "kind": "LinkedField",
                                                    "name": "deploymentEnvironments",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueDeploymentEnvironment",
                                                                    "kind": "LinkedField",
                                                                    "name": "topEnvironments",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "status"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "shouldIncludeDevOpsFieldsViaAgs",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": v1 /*: any*/ 
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "issueCard_softwareReleasesVersionDetailIssueList_jiraIssue"
                        }
                    ]
                },
                "action": "THROW",
                "path": "node"
            }
        ],
        "type": "JiraIssueEdge"
    };
}();
$95ef3cbc86f7cd1c$var$node.hash = "9f22d41da8c51a4ad6a88b9583ed10fd";
var $95ef3cbc86f7cd1c$export$2e2bcd8739ae039 = $95ef3cbc86f7cd1c$var$node;

});

parcelRegister("dSE3R", function(module, exports) {

$parcel$export(module.exports, "FeatureFlagEmptyStateExperienceModal", () => $a046ad663b4e60bc$export$4e1e35d50ebac320);

var $et5SG = parcelRequire("et5SG");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $i8Qvm = parcelRequire("i8Qvm");

var $9fuVs = parcelRequire("9fuVs");

var $7NYq5 = parcelRequire("7NYq5");

var $4YVWJ = parcelRequire("4YVWJ");
const $a046ad663b4e60bc$export$4e1e35d50ebac320 = ({ isOpen: isOpen, onClose: onClose, devOpsFeatureFlagProviders: devOpsFeatureFlagProviders, onInstallSuccess: onInstallSuccess, returnFocusRef: returnFocusRef })=>{
    const featureFlagProviders = (0, $8Uumt.useFragment)((0, $et5SG.default), devOpsFeatureFlagProviders);
    const entryPoint = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YVWJ.FeatureFlagEmptyStateExperienceEntryPoint), {
        onInstallSuccess: onInstallSuccess,
        devOpsFeatureFlagProviders: featureFlagProviders,
        isOpen: isOpen,
        onClose: onClose
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        shouldReturnFocus: returnFocusRef,
        onClose: onClose,
        width: 592,
        autoFocus: false,
        messageId: "software-releases-version-detail-issue-list.ui.issues.feature-flags-empty-state.modal-dialog",
        messageType: "transactional"
    }, entryPoint)) : null);
};

});
parcelRegister("et5SG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fc81a4070f06f96$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b5ece995d5336893a3d038e4fba6e8d5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9fc81a4070f06f96$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "featureFlagsEmptyState_softwareReleasesVersionDetailIssueList_FeatureFlagEmptyStateExperienceModal",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "async_softwareEmptyStateExperienceFeatureFlags_FeatureFlagEmptyStateExperienceEntryPoint"
        }
    ],
    "type": "DevOpsFeatureFlagProvider"
};
$9fc81a4070f06f96$var$node.hash = "0fbad5b696ab8a25991a0d1c79838173";
var $9fc81a4070f06f96$export$2e2bcd8739ae039 = $9fc81a4070f06f96$var$node;

});

parcelRegister("4YVWJ", function(module, exports) {

$parcel$export(module.exports, "FeatureFlagEmptyStateExperienceEntryPoint", () => $aafc4590fb5d3b83$export$d0d10a136f7d769f);

var $5z4FT = parcelRequire("5z4FT");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $eZJjh = parcelRequire("eZJjh");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $dXq4S = parcelRequire("dXq4S");

var $dAfqg = parcelRequire("dAfqg");

var $bSmlz = parcelRequire("bSmlz");

var $koeKL = parcelRequire("koeKL");

var $kxZPA = parcelRequire("kxZPA");

var $93kRE = parcelRequire("93kRE");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $aafc4590fb5d3b83$var$FeatureFlagEmptyStateExperienceQueryLoader = (0, $kxZPA.lazy)(()=>(parcelRequire("hJ9rF")).then((mod)=>mod.FeatureFlagsEmptyStateExperienceQueryLoader), {
    ssr: false,
    moduleId: "./src/packages/software/empty-state-experience/feature-flags/src/ui/index.tsx"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aafc4590fb5d3b83$var$Loading = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _6a6z1h6o _1e0c11p5 _ca0q1epz _u5f3idpf _n3td1epz _19bvidpf",
            __cmplp.className
        ])
    });
});
const $aafc4590fb5d3b83$export$d0d10a136f7d769f = ({ isOpen: isOpen, onClose: onClose, devOpsFeatureFlagProviders: devOpsFeatureFlagProviders, onInstallSuccess: onInstallSuccess })=>{
    const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $bSmlz.default));
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const cloudId = (0, $koeKL.useCloudId)();
    const onExperienceFail = (0, $93kRE.useViewFeatureFlagsEmptyStateExperienceExperienceFail)();
    const featureFlagProviders = (0, $8Uumt.useFragment)((0, $5z4FT.default), devOpsFeatureFlagProviders);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (projectContext?.projectId != null && isOpen) loadQuery({
            projectAri: (0, $dXq4S.createAri)({
                resourceId: projectContext.projectId.toString(),
                resourceOwner: 'jira',
                resourceType: 'project',
                cloudId: cloudId
            })
        }, {
            fetchPolicy: 'store-and-network'
        });
    }, [
        isOpen,
        loadQuery,
        cloudId,
        projectContext
    ]);
    return projectContext != null && isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "featureFlagEmptyStateExperienceEntryPoint",
        packageName: "jiraSoftwareEmptyStateExperienceFeatureFlags",
        teamName: "nova",
        onError: (location, error)=>{
            onExperienceFail(location, error);
            onClose();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-empty-state-experience-feature-flags",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aafc4590fb5d3b83$var$Loading, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: "large"
        }))
    }, queryReference != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aafc4590fb5d3b83$var$FeatureFlagEmptyStateExperienceQueryLoader, {
        onInstallSuccess: onInstallSuccess,
        devOpsFeatureFlagProviders: featureFlagProviders,
        queryReference: queryReference
    }) : null))) : null;
};

});
parcelRegister("5z4FT", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ede98c0713128b6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<938070df7d9719f61ec9a07cd353d6c0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5ede98c0713128b6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "async_softwareEmptyStateExperienceFeatureFlags_FeatureFlagEmptyStateExperienceEntryPoint",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareEmptyStateExperienceFeatureFlags_FeatureFlagsEmptyStateExperienceQueryLoader_devOpsFeatureFlagProviders"
        }
    ],
    "type": "DevOpsFeatureFlagProvider"
};
$5ede98c0713128b6$var$node.hash = "17afe0c67200280c81407f20b1ac9cf2";
var $5ede98c0713128b6$export$2e2bcd8739ae039 = $5ede98c0713128b6$var$node;

});

parcelRegister("bSmlz", function(module, exports) {

$parcel$export(module.exports, "default", () => $b361172cf1e900ca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<70c3440a202cfdad1b4e531c7435152b>>
 * @relayHash ebd0cfdc3b09a8f2dd0b3e7d12e0b64d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 26f590dcda44b5fc757b038bb24223ad14175c339c87b80b056b42ed91aa2a99
const $b361172cf1e900ca$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "uiFeatureFlagsEmptyStateExperienceQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ui_softwareEmptyStateExperienceFeatureFlags_FeatureFlagsEmptyStateExperience_query"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "uiFeatureFlagsEmptyStateExperienceQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AriGraph",
                            "kind": "LinkedField",
                            "name": "ariGraph",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "fields": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "from",
                                                    "variableName": "projectAri"
                                                },
                                                {
                                                    "kind": "Literal",
                                                    "name": "type",
                                                    "value": "project-associated-feature-flag"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "filter"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1
                                        }
                                    ],
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "relationships",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "AriGraphRelationship",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "26f590dcda44b5fc757b038bb24223ad14175c339c87b80b056b42ed91aa2a99",
            "metadata": {},
            "name": "uiFeatureFlagsEmptyStateExperienceQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b361172cf1e900ca$var$node.hash = "c8856730dcfda88439b157a25ff3f97f";
var $b361172cf1e900ca$export$2e2bcd8739ae039 = $b361172cf1e900ca$var$node;

});

parcelRegister("hJ9rF", function(module, exports) {

let $ce7df74a79f9558e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ce7df74a79f9558e$var$load("fNNxo").then(()=>parcelRequire('6vcJA'));

});



parcelRegister("dnJ5M", function(module, exports) {

$parcel$export(module.exports, "IssueCard", () => $3d03a02f601ed834$export$11b5a73dc1ef6ab9);

var $dao5r = parcelRequire("dao5r");

var $ajPr6 = parcelRequire("ajPr6");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8Uumt = parcelRequire("8Uumt");

var $4HJKb = parcelRequire("4HJKb");


var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $g5X3G = parcelRequire("g5X3G");

var $kfztd = parcelRequire("kfztd");

var $2vbty = parcelRequire("2vbty");

var $npYQQ = parcelRequire("npYQQ");

var $9lAUN = parcelRequire("9lAUN");


var $a40gh = parcelRequire("a40gh");

var $1KeDw = parcelRequire("1KeDw");

var $c7zJ6 = parcelRequire("c7zJ6");

var $cmBKm = parcelRequire("cmBKm");

var $iKL1U = parcelRequire("iKL1U");

var $clzRD = parcelRequire("clzRD");

var $iEXri = parcelRequire("iEXri");

var $4uVJc = parcelRequire("4uVJc");

var $cMkJv = parcelRequire("cMkJv");
const $3d03a02f601ed834$var$DEV_DETAILS_DIALOG_SCOPE_ID = 'VersionDetailsIssueList';
const $3d03a02f601ed834$export$11b5a73dc1ef6ab9 = ({ jiraIssue: jiraIssue, jiraVersion: jiraVersion, hasBambooDeployment: hasBambooDeployment, hasDeployments: hasDeployments, hasDevelopments: hasDevelopments, hasBuilds: hasBuilds, onFeatureFlagEmptyStateModalOpen: onFeatureFlagEmptyStateModalOpen, featureFlagButtonRef: featureFlagButtonRef, rowNum: rowNum })=>{
    const issue = (0, $8Uumt.useFragment)((0, $ajPr6.default), jiraIssue);
    const { showDevDetailDialog: showDevDetailDialog } = (0, $4HJKb.useDevOpsDetailsDialogLoaderActions)($3d03a02f601ed834$var$DEV_DETAILS_DIALOG_SCOPE_ID);
    const [, sidebarActions] = (0, $2vbty.useSidebarStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleClick = (dataType, reviewData)=>{
        showDevDetailDialog(dataType, dataType === (0, $61a2cd6236d50c20$export$3f1e2b276d607490) ? reviewData : undefined, (0, $g5X3G.toIssueKey)(issue.key), (0, $g5X3G.toIssueId)(issue.issueId));
    };
    const jiraVersionData = (0, $8Uumt.useFragment)((0, $dao5r.default), jiraVersion);
    const { canViewDevTools: canViewDevTools, devOpsSummarisedEntities: devOpsSummarisedEntities, versionIssueTableHiddenColumns: versionIssueTableHiddenColumns } = jiraVersionData;
    const fields = issue.fieldsById.edges.map((edge)=>edge?.node).filter(Boolean);
    const jiraIssueSummaryField = fields.find((fieldNode)=>fieldNode?.fieldId === 'summary');
    const jiraIssueTypeField = fields.find((fieldNode)=>fieldNode?.fieldId === 'issuetype');
    const jiraPriorityField = fields.find((fieldNode)=>fieldNode?.fieldId === 'priority');
    const jiraStatusField = fields.find((fieldNode)=>fieldNode?.fieldId === 'status');
    const jiraAssigneeField = fields.find((fieldNode)=>fieldNode?.fieldId === 'assignee');
    const issueUrl = `/browse/${issue.key}`;
    const onIssueClick = (e)=>{
        if (e.target instanceof Element && e.target.closest((0, $npYQQ.getIssueCardClickIgnorePreventDefaultTargetSelector)()) != null) {
            // These are a tags with href to create a feature flag that shouldn't prevent default
            if (e.target.closest((0, $npYQQ.getIssueCardClickIgnoreTargetNoPreventDefaultSelector)())) return;
            e.preventDefault();
            return;
        }
        const modifiersPressed = Boolean(e.shiftKey || e.metaKey || e.ctrlKey);
        const shouldOpenIssueSidebar = // on primary button click
        e.button === 0 && // no modifier buttons have been pressed
        !modifiersPressed;
        if (shouldOpenIssueSidebar) {
            // stops the default behaviour of opening the issue in a new link
            e.preventDefault();
            sidebarActions.showIssue(issue.key);
        }
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        (0, $8zOmE.fireUIAnalytics)(event, 'versionDetailsIssue', {
            clickType: e.button,
            modifiersPressed: modifiersPressed
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9lAUN.IssueWarningProvider), {
        jiraVersion: jiraVersionData,
        jiraIssue: issue
    }, ({ hasWarnings: hasWarnings, hasOpenPullRequestWarning: hasOpenPullRequestWarning, hasFailingBuildsWarning: hasFailingBuildsWarning, hasUnreviewedCodeWarning: hasUnreviewedCodeWarning, hasOpenReviewWarning: hasOpenReviewWarning })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3d03a02f601ed834$var$IssueCardContainer, {
            href: issueUrl,
            target: "_blank",
            rel: "noopener noreferrer",
            onClick: onIssueClick,
            "data-component-selector": (0, $752b719410cf933d$export$b343d4705e10ba61),
            "data-testid": "software-releases-version-detail-issue-list.ui.issues.issue-card",
            hasWarnings: hasWarnings
        }, jiraIssueSummaryField && jiraIssueTypeField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cMkJv.Summary), {
            jiraIssue: issue,
            jiraIssueSummaryField: jiraIssueSummaryField,
            jiraIssueTypeField: jiraIssueTypeField
        }), jiraPriorityField && !versionIssueTableHiddenColumns.includes('ISSUE_PRIORITY') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iEXri.Priority), {
            jiraPriorityField: jiraPriorityField
        }), jiraStatusField && !versionIssueTableHiddenColumns.includes('ISSUE_STATUS') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uVJc.Status), {
            jiraStatusField: jiraStatusField
        }), jiraAssigneeField && !versionIssueTableHiddenColumns.includes('ISSUE_ASSIGNEE') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1KeDw.Assignee), {
            jiraAssigneeField: jiraAssigneeField
        }), !(0, $kfztd.isDevopsFeatureDisabledInFedRamp)() && canViewDevTools && hasDevelopments && !versionIssueTableHiddenColumns.includes('DEVELOPMENT_STATUS') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a40gh.ErrorBoundary), {
            id: "issueListIssueCardDevelopment",
            fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cmBKm.DevelopmentContainer), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cmBKm.Development), {
            jiraIssue: issue,
            onClick: handleClick
        })), !(0, $kfztd.isDevopsFeatureDisabledInFedRamp)() && (hasBambooDeployment || hasDeployments || hasBuilds) && canViewDevTools && !versionIssueTableHiddenColumns.includes('DEPLOYMENT_STATUS') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a40gh.ErrorBoundary), {
            id: "issueListIssueCardDelivery",
            fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c7zJ6.DeliveryContainer), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c7zJ6.Delivery), {
            jiraIssue: issue,
            onClick: handleClick
        })), !(0, $kfztd.isDevopsFeatureDisabledInFedRamp)() && canViewDevTools && devOpsSummarisedEntities && !versionIssueTableHiddenColumns.includes('FEATURE_FLAG_STATUS') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a40gh.ErrorBoundary), {
            id: "issueListIssueCardFeatureFlags",
            fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3d03a02f601ed834$var$FeatureFlagsContainer, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-version-details-issue-click-ignore-target": (0, $npYQQ.ISSUE_CARD_CLICK_IGNORE_TARGET)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iKL1U.FeatureFlags), {
            devOpsSummarisedEntities: devOpsSummarisedEntities,
            jiraIssue: issue,
            onClick: handleClick,
            featureFlagButtonRef: featureFlagButtonRef,
            setFeatureFlagEmptyStateModalOpen: onFeatureFlagEmptyStateModalOpen,
            rowNum: rowNum
        }))), !versionIssueTableHiddenColumns.includes('MORE_ACTION') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a40gh.ErrorBoundary), {
            id: "issueListIssueCardMoreButton",
            fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clzRD.OnHoverVisibility), null, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-version-details-issue-click-ignore-target": (0, $npYQQ.ISSUE_CARD_CLICK_IGNORE_TARGET)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clzRD.MoreButton), {
            jiraVersion: jiraVersionData,
            jiraIssue: issue,
            hasWarnings: hasWarnings,
            hasOpenPullRequestWarning: hasOpenPullRequestWarning,
            hasFailingBuildsWarning: hasFailingBuildsWarning,
            hasUnreviewedCodeWarning: hasUnreviewedCodeWarning,
            hasOpenReviewWarning: hasOpenReviewWarning
        })))));
};
const $3d03a02f601ed834$var$WARNING_COLOR = "var(--ds-background-warning, #FFF7D6)";
const $3d03a02f601ed834$var$WARNING_HOVER_COLOR = "var(--ds-background-warning-hovered, #F8E6A0)";
const $3d03a02f601ed834$var$HOVER_COLOR = "var(--ds-background-neutral-hovered, #091E4224)"; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3d03a02f601ed834$var$IssueCardContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasWarnings: hasWarnings, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1d5pv2t": (0, $lD23V.default)(__cmplp.hasWarnings && $3d03a02f601ed834$var$WARNING_COLOR)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_189exib9 _1dqonqa1 _1h6dmuej _1e0c1txw _4cvr1h6o _bfhk62r0 _4t3izwfg _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvpxbi _gy1pu2gc _7cca15wb _64ezt94y _1ov81l7b _k8kw1l7b _1rcd1l7b _1wp91l7b _1a3b18uv _4fprglyw _5goinqa1 _7ehiglyw _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.hasWarnings ? "_10j71rd4 _irr31rd4" : "_10j715ej _irr315ej",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $3d03a02f601ed834$var$FeatureFlagsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1b081l8a _15yj1l8a _13n41tcg _fhcx1tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dao5r", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f8cb52b4f34e290$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<74f23412886a917642ce5f650f64f940>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1f8cb52b4f34e290$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isDevopsFeatureDisabledInFedRamp"
        }
    ],
    "kind": "Fragment",
    "name": "issueCard_softwareReleasesVersionDetailIssueList_jiraVersion",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraVersion"
        },
        {
            "kind": "ScalarField",
            "name": "canViewDevTools"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "versionIssueTableHiddenColumns"
            },
            "action": "THROW",
            "path": "versionIssueTableHiddenColumns"
        },
        {
            "condition": "isDevopsFeatureDisabledInFedRamp",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "concreteType": "DevOpsSummarisedEntities",
                    "kind": "LinkedField",
                    "name": "devOpsSummarisedEntities",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "featureFlags_softwareReleasesVersionDetailIssueList_devOpsSummarisedEntities"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "moreButton_softwareReleasesVersionDetailIssueList_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$1f8cb52b4f34e290$var$node.hash = "522ae3c2b555fac40be79e26c643efd9";
var $1f8cb52b4f34e290$export$2e2bcd8739ae039 = $1f8cb52b4f34e290$var$node;

});

parcelRegister("ajPr6", function(module, exports) {

$parcel$export(module.exports, "default", () => $51c92cf70e6668b5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<53501a3cdefe37344eda446c082034d1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $51c92cf70e6668b5$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isDevopsFeatureDisabledInFedRamp"
        }
    ],
    "kind": "Fragment",
    "name": "issueCard_softwareReleasesVersionDetailIssueList_jiraIssue",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "moreButton_softwareReleasesVersionDetailIssueList_jiraIssue"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraIssue"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "issueId"
            },
            "action": "THROW",
            "path": "issueId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        },
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "ids",
                        "value": [
                            "priority",
                            "summary",
                            "assignee",
                            "status",
                            "issuetype"
                        ]
                    }
                ],
                "concreteType": "JiraIssueFieldConnection",
                "kind": "LinkedField",
                "name": "fieldsById",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraIssueFieldEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "kind": "ScalarField",
                                                "name": "fieldId"
                                            },
                                            "action": "THROW",
                                            "path": "fieldsById.edges.node.fieldId"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "status_softwareReleasesVersionDetailIssueList"
                                                }
                                            ],
                                            "type": "JiraStatusField"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "assignee_softwareReleasesVersionDetailIssueList"
                                                }
                                            ],
                                            "type": "JiraSingleSelectUserPickerField"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssueSummaryField"
                                                }
                                            ],
                                            "type": "JiraSingleLineTextField"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssueTypeField"
                                                }
                                            ],
                                            "type": "JiraIssueTypeField"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "priority_softwareReleasesVersionDetailIssueList"
                                                }
                                            ],
                                            "type": "JiraPriorityField"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "fieldsById.edges"
                    }
                ],
                "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
            },
            "action": "THROW",
            "path": "fieldsById"
        },
        {
            "condition": "isDevopsFeatureDisabledInFedRamp",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "delivery_softwareReleasesVersionDetailIssueList"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "development_softwareReleasesVersionDetailIssueList"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "featureFlags_softwareReleasesVersionDetailIssueList_jiraIssue"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssue"
        }
    ],
    "type": "JiraIssue"
};
$51c92cf70e6668b5$var$node.hash = "81587616f95bbce4695593a62ffa6d45";
var $51c92cf70e6668b5$export$2e2bcd8739ae039 = $51c92cf70e6668b5$var$node;

});

parcelRegister("4HJKb", function(module, exports) {

$parcel$export(module.exports, "loadDialogBridge", () => $ccf4b85a4aaf3a68$export$7e12f7cd0f50fe5a);
$parcel$export(module.exports, "DevOpsDetailsDialogLoaderContainer", () => $ccf4b85a4aaf3a68$export$5e6e4cfb89bdcb55);
$parcel$export(module.exports, "DevOpsDetailsDialogLoaderSubscriber", () => $ccf4b85a4aaf3a68$export$693f51ab225dff94);
$parcel$export(module.exports, "useDevOpsDetailsDialogLoaderActions", () => $ccf4b85a4aaf3a68$export$506ad06ecf691cd3);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");


var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
var $bKpgX = parcelRequire("bKpgX");

var $62M1I = parcelRequire("62M1I");
const $ccf4b85a4aaf3a68$export$7e12f7cd0f50fe5a = async ()=>// eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $6BZYo.loadBridge)({
        name: (0, $62M1I.DEV_DETAILS_WRM_RESOURCE),
        wrmKeys: [
            'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-wrm',
            'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources'
        ]
    });
const $ccf4b85a4aaf3a68$export$e324594224ef24da = {
    resetState: (stateOverrides)=>({ setState: setState })=>{
            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                ...(0, $62M1I.INITIAL_STATE),
                ...stateOverrides
            });
        },
    updateState: (stateUpdates)=>({ getState: getState, setState: setState })=>{
            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                ...getState(),
                ...stateUpdates
            });
        },
    showDevDetailDialog: (itemType, legacyData, targetIssueKey, targetIssueId)=>({ setState: setState, getState: getState })=>{
            if (itemType === (0, $61a2cd6236d50c20$export$3f1e2b276d607490)) // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                ...getState(),
                legacyDevPanelDetailsDialogShownCounter: // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                getState().legacyDevPanelDetailsDialogShownCounter + 1,
                isDevPanelDetailsDialogShown: false,
                dataTypeSelected: itemType,
                legacyData: legacyData,
                issueKey: targetIssueKey,
                issueId: targetIssueId
            });
            else // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                ...getState(),
                isDevPanelDetailsDialogShown: true,
                dataTypeSelected: itemType,
                issueKey: targetIssueKey,
                issueId: targetIssueId
            });
        },
    closeDetailDialog: ()=>({ setState: setState, getState: getState })=>{
            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                ...getState(),
                // @ts-expect-error - TS2322 - Type '""' is not assignable to type 'PanelDataTypes | undefined'.
                dataTypeSelected: '',
                isDevPanelDetailsDialogShown: false,
                issueKey: undefined,
                issueId: undefined
            });
        }
};
const $ccf4b85a4aaf3a68$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    name: 'DetailsDialogLoaderRemoteState',
    initialState: (0, $62M1I.INITIAL_STATE),
    actions: $ccf4b85a4aaf3a68$export$e324594224ef24da
});
const $ccf4b85a4aaf3a68$export$5e6e4cfb89bdcb55 = (0, $gg7kZ.createContainer)($ccf4b85a4aaf3a68$export$390f32400eaf98c9);
const $ccf4b85a4aaf3a68$export$693f51ab225dff94 = (0, $51nlc.createSubscriber)($ccf4b85a4aaf3a68$export$390f32400eaf98c9);
const $ccf4b85a4aaf3a68$export$550d4b3c29100112 = (0, $3sQ5x.createHook)($ccf4b85a4aaf3a68$export$390f32400eaf98c9);
function $ccf4b85a4aaf3a68$export$506ad06ecf691cd3(scopeId) {
    return (0, $bKpgX.defaultRegistry).getStore($ccf4b85a4aaf3a68$export$390f32400eaf98c9, scopeId)?.actions;
}

});
const $61a2cd6236d50c20$export$e18d81f044132a0e = 'branch';
const $61a2cd6236d50c20$export$74a388a09f2a004e = 'build';
const $61a2cd6236d50c20$export$2e42513c7764d5f3 = 'repository';
const $61a2cd6236d50c20$export$3f1e2b276d607490 = 'review';
const $61a2cd6236d50c20$export$90cac6260ae9ced5 = 'deployment-environment';
const $61a2cd6236d50c20$export$6f74b53d652f13f3 = 'pullrequest';
const $61a2cd6236d50c20$export$c69477f358d30f7e = 'feature-flags';
const $61a2cd6236d50c20$export$56470bdd9cd798d0 = 'remote-links';
const $61a2cd6236d50c20$export$b4bb784d069c9ab = 'development.details.details-header';

parcelRegister("62M1I", function(module, exports) {

$parcel$export(module.exports, "INITIAL_STATE", () => $bf37254db56efc10$export$36d128238e6b60f5);
$parcel$export(module.exports, "DEV_DETAILS_WRM_RESOURCE", () => $bf37254db56efc10$export$43a8ab4f373ff0ee);
const $bf37254db56efc10$export$36d128238e6b60f5 = {
    issueId: '',
    issueKey: undefined,
    locale: 'en_US',
    // @ts-expect-error - TS2322 - Type '""' is not assignable to type 'PanelDataTypes'.
    dataTypeSelected: '',
    legacyData: undefined,
    isDevPanelDetailsDialogShown: false,
    legacyDevPanelDetailsDialogShownCounter: 0
};
const $bf37254db56efc10$export$b5ed55f3ed234f95 = 'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources';
const $bf37254db56efc10$export$43a8ab4f373ff0ee = 'jira-development-status/releasereport/dev-status-dialog-bridge';
const $bf37254db56efc10$export$432f9ff6c01431e3 = 'jira-development-status/util/WRM';

});


parcelRegister("npYQQ", function(module, exports) {

$parcel$export(module.exports, "ISSUE_CARD_CLICK_IGNORE_TARGET", () => $864ae6bce0b99b4e$export$4fbe2e62d82203a7);
$parcel$export(module.exports, "VERSION_SELECT_MENU_PORTAL_CLASS_PREFIX", () => $864ae6bce0b99b4e$export$57f23f1fe030a106);
$parcel$export(module.exports, "FEATURE_FLAG_ACTION_DROPDOWN_ANCHORS", () => $864ae6bce0b99b4e$export$36d427b8bcbcfc80);
$parcel$export(module.exports, "getIssueCardClickIgnorePreventDefaultTargetSelector", () => $864ae6bce0b99b4e$export$31dcba8332a40055);
$parcel$export(module.exports, "getIssueCardClickIgnoreTargetNoPreventDefaultSelector", () => $864ae6bce0b99b4e$export$6c4862367e99e37a);
// These are utility data-version-details-issue-click-ignore-target attributes to prevent issue side bar to open when actionable items are clicked in an issue card
// Should prevent default to prevent the whole issue card (a tag) not to be clicked
const $864ae6bce0b99b4e$export$4fbe2e62d82203a7 = 'issueClickOpenIssueIgnoreTarget';
const $864ae6bce0b99b4e$export$57f23f1fe030a106 = 'move-issue-modal-select-dropdown';
const $864ae6bce0b99b4e$export$36d427b8bcbcfc80 = 'featureFlagAnchorActionDropdown';
const $864ae6bce0b99b4e$export$31dcba8332a40055 = ()=>`[data-version-details-issue-click-ignore-target="${$864ae6bce0b99b4e$export$4fbe2e62d82203a7}"],
    [data-version-details-issue-click-ignore-target="${$864ae6bce0b99b4e$export$36d427b8bcbcfc80}"],
    [data-testid="software-releases-move-issues-between-versions.ui.move-issue-version-select-modal--blanket"],
    [class^='${$864ae6bce0b99b4e$export$57f23f1fe030a106}'], [class*=' ${$864ae6bce0b99b4e$export$57f23f1fe030a106}']`;
const $864ae6bce0b99b4e$export$6c4862367e99e37a = ()=>`[data-version-details-issue-click-ignore-target="${$864ae6bce0b99b4e$export$36d427b8bcbcfc80}"]`;

});

parcelRegister("9lAUN", function(module, exports) {

$parcel$export(module.exports, "IssueWarningProvider", () => $bd3e4874a4d639a0$export$3786225113492c89);
$parcel$export(module.exports, "IssuesWarningCountProvider", () => $bd3e4874a4d639a0$export$d7ec5473e7d825ae);

var $dUrsT = parcelRequire("dUrsT");

var $el3Dm = parcelRequire("el3Dm");

var $kWCTI = parcelRequire("kWCTI");

var $iwqD8 = parcelRequire("iwqD8");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $gULOk = parcelRequire("gULOk");
const $bd3e4874a4d639a0$var$getDevSummaryDataWarnings = (issue, jiraVersionData)=>{
    const fields = issue.fieldsById.edges.map((edge)=>edge?.node).filter(Boolean);
    const jiraStatusField = fields.find((fieldNode)=>fieldNode?.fieldId === 'status');
    const issueStatus = (0, $gULOk.statusCategoryForId)(jiraStatusField?.status?.statusCategory?.statusCategoryId);
    const build = issue.devSummaryCache?.devSummary.build;
    const commit = issue.devSummaryCache?.devSummary.commit;
    const pullrequest = issue.devSummaryCache?.devSummary.pullrequest;
    const pullrequestCount = issue.devSummaryCache?.devSummary.pullrequest?.overall.count ?? 0;
    const reviewState = issue.devSummaryCache?.devSummary?.review?.overall?.state;
    const reviewCount = issue.devSummaryCache?.devSummary?.review?.overall?.count ?? 0;
    const openPullRequest = jiraVersionData.warningConfig?.openPullRequest;
    const failingBuild = jiraVersionData.warningConfig?.failingBuild;
    const unreviewedCode = jiraVersionData.warningConfig?.unreviewedCode;
    const openReview = jiraVersionData.warningConfig?.openReview;
    const failingBuildCount = (build?.overall.failedBuildCount ?? 0) + ((issue.devOpsSummarisedEntities?.summarisedBuilds?.buildStates ?? []).find((buildState)=>buildState?.state === 'FAILED')?.count ?? 0);
    const hasOpenPullRequestWarning = issueStatus === 'DONE' && openPullRequest === 'ENABLED' && pullrequest?.overall?.state === 'OPEN' && pullrequest.overall.count > 0;
    const hasFailingBuildsWarning = issueStatus === 'DONE' && failingBuild === 'ENABLED' && build != null && failingBuildCount > 0;
    const hasUnreviewedCodeWarning = issueStatus === 'DONE' && unreviewedCode === 'ENABLED' && pullrequestCount === 0 && reviewCount === 0 && commit != null && commit.overall.count > 0;
    const hasOpenReviewWarning = issueStatus === 'DONE' && openReview === 'ENABLED' && reviewState != null && ![
        'CLOSED',
        'REJECTED'
    ].includes(reviewState);
    const hasWarnings = issueStatus === 'DONE' && (hasOpenPullRequestWarning || hasFailingBuildsWarning || hasUnreviewedCodeWarning || hasOpenReviewWarning);
    return {
        hasWarnings: hasWarnings,
        hasOpenPullRequestWarning: hasOpenPullRequestWarning,
        hasFailingBuildsWarning: hasFailingBuildsWarning,
        hasUnreviewedCodeWarning: hasUnreviewedCodeWarning,
        hasOpenReviewWarning: hasOpenReviewWarning
    };
};
const $bd3e4874a4d639a0$var$getIssueNodeWarningsCount = (edges, jiraVersionData)=>edges.map((edge)=>edge.node).filter(Boolean).reduce((acc, issue)=>{
        const warningResult = $bd3e4874a4d639a0$var$getDevSummaryDataWarnings(issue, jiraVersionData);
        if (warningResult.hasWarnings) return acc + 1;
        return acc;
    }, 0);
const $bd3e4874a4d639a0$var$getIssueWarnings = (issue, jiraVersionData)=>$bd3e4874a4d639a0$var$getDevSummaryDataWarnings(issue, jiraVersionData);
const $bd3e4874a4d639a0$export$3786225113492c89 = ({ jiraVersion: jiraVersion, jiraIssue: jiraIssue, children: children })=>{
    const issue = (0, $8Uumt.useFragment)((0, $iwqD8.default), jiraIssue);
    const jiraVersionData = (0, $8Uumt.useFragment)((0, $kWCTI.default), jiraVersion);
    const warningFlags = $bd3e4874a4d639a0$var$getIssueWarnings(issue, jiraVersionData);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children(warningFlags));
};
const $bd3e4874a4d639a0$export$d7ec5473e7d825ae = ({ jiraVersion: jiraVersion, issueEdges: issueEdges, children: children })=>{
    const jiraIssueEdgeReferenceData = (0, $8Uumt.useFragment)((0, $el3Dm.default), issueEdges);
    const warningConfig = (0, $8Uumt.useFragment)((0, $dUrsT.default), jiraVersion);
    const warningCount = $bd3e4874a4d639a0$var$getIssueNodeWarningsCount(jiraIssueEdgeReferenceData, warningConfig);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children(warningCount));
};

});
parcelRegister("dUrsT", function(module, exports) {

$parcel$export(module.exports, "default", () => $45788d524cf8c40d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<181a2844f19811967a175c2a899887e7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $45788d524cf8c40d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_jiraVersion",
    "selections": [
        {
            "concreteType": "JiraVersionWarningConfig",
            "kind": "LinkedField",
            "name": "warningConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "openPullRequest"
                    },
                    "action": "NONE",
                    "path": "warningConfig.openPullRequest"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "openReview"
                    },
                    "action": "NONE",
                    "path": "warningConfig.openReview"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "unreviewedCode"
                    },
                    "action": "NONE",
                    "path": "warningConfig.unreviewedCode"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "failingBuild"
                    },
                    "action": "NONE",
                    "path": "warningConfig.failingBuild"
                }
            ]
        }
    ],
    "type": "JiraVersion"
};
$45788d524cf8c40d$var$node.hash = "a12dea52160bb6c6b5d0ff127f4a7b36";
var $45788d524cf8c40d$export$2e2bcd8739ae039 = $45788d524cf8c40d$var$node;

});

parcelRegister("el3Dm", function(module, exports) {

$parcel$export(module.exports, "default", () => $72c997acb36af248$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<70475c9d29d1800f98ebde7d315b6dbb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $72c997acb36af248$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "count"
    }, v1 = {
        "kind": "ScalarField",
        "name": "state"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "isDevopsFeatureDisabledInFedRamp"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "plural": true
        },
        "name": "ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_issueEdges",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "ids",
                                    "value": [
                                        "priority",
                                        "summary",
                                        "assignee",
                                        "status",
                                        "issuetype"
                                    ]
                                }
                            ],
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fieldsById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "kind": "ScalarField",
                                                            "name": "fieldId"
                                                        },
                                                        "action": "THROW",
                                                        "path": "node.fieldsById.edges.node.fieldId"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraStatus",
                                                                "kind": "LinkedField",
                                                                "name": "status",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraStatusCategory",
                                                                        "kind": "LinkedField",
                                                                        "name": "statusCategory",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "statusCategoryId"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraStatusField"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "node.fieldsById.edges"
                                }
                            ],
                            "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                        },
                        "action": "THROW",
                        "path": "node.fieldsById"
                    },
                    {
                        "condition": "isDevopsFeatureDisabledInFedRamp",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "concreteType": "DevOpsSummarisedEntities",
                                "kind": "LinkedField",
                                "name": "devOpsSummarisedEntities",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "DevOpsSummarisedBuilds",
                                        "kind": "LinkedField",
                                        "name": "summarisedBuilds",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "concreteType": "DevOpsSummarisedBuildState",
                                                "kind": "LinkedField",
                                                "name": "buildStates",
                                                "plural": true,
                                                "selections": [
                                                    v1 /*: any*/ ,
                                                    v0 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JiraIssueDevSummaryResult",
                                    "kind": "LinkedField",
                                    "name": "devSummaryCache",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssueDevSummary",
                                                "kind": "LinkedField",
                                                "name": "devSummary",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "pullrequest",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraIssuePullRequestDevSummary",
                                                                        "kind": "LinkedField",
                                                                        "name": "overall",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v1 /*: any*/ ,
                                                                                "action": "NONE",
                                                                                "path": "node.devSummaryCache.devSummary.pullrequest.overall.state"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v0 /*: any*/ ,
                                                                                "action": "NONE",
                                                                                "path": "node.devSummaryCache.devSummary.pullrequest.overall.count"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "NONE",
                                                                    "path": "node.devSummaryCache.devSummary.pullrequest.overall"
                                                                }
                                                            ]
                                                        },
                                                        "action": "NONE",
                                                        "path": "node.devSummaryCache.devSummary.pullrequest"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "review",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraIssueReviewDevSummary",
                                                                        "kind": "LinkedField",
                                                                        "name": "overall",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v0 /*: any*/ ,
                                                                                "action": "NONE",
                                                                                "path": "node.devSummaryCache.devSummary.review.overall.count"
                                                                            },
                                                                            v1 /*: any*/ 
                                                                        ]
                                                                    },
                                                                    "action": "NONE",
                                                                    "path": "node.devSummaryCache.devSummary.review.overall"
                                                                }
                                                            ]
                                                        },
                                                        "action": "NONE",
                                                        "path": "node.devSummaryCache.devSummary.review"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "commit",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraIssueCommitDevSummary",
                                                                        "kind": "LinkedField",
                                                                        "name": "overall",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v0 /*: any*/ ,
                                                                                "action": "NONE",
                                                                                "path": "node.devSummaryCache.devSummary.commit.overall.count"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "NONE",
                                                                    "path": "node.devSummaryCache.devSummary.commit.overall"
                                                                }
                                                            ]
                                                        },
                                                        "action": "NONE",
                                                        "path": "node.devSummaryCache.devSummary.commit"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                            "kind": "LinkedField",
                                                            "name": "build",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraIssueBuildDevSummary",
                                                                        "kind": "LinkedField",
                                                                        "name": "overall",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v0 /*: any*/ ,
                                                                                "action": "NONE",
                                                                                "path": "node.devSummaryCache.devSummary.build.overall.count"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "failedBuildCount"
                                                                                },
                                                                                "action": "NONE",
                                                                                "path": "node.devSummaryCache.devSummary.build.overall.failedBuildCount"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "NONE",
                                                                    "path": "node.devSummaryCache.devSummary.build.overall"
                                                                }
                                                            ]
                                                        },
                                                        "action": "NONE",
                                                        "path": "node.devSummaryCache.devSummary.build"
                                                    }
                                                ]
                                            },
                                            "action": "NONE",
                                            "path": "node.devSummaryCache.devSummary"
                                        }
                                    ]
                                },
                                "action": "NONE",
                                "path": "node.devSummaryCache"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssueEdge"
    };
}();
$72c997acb36af248$var$node.hash = "2af391280f3df5e713e3630effb3b264";
var $72c997acb36af248$export$2e2bcd8739ae039 = $72c997acb36af248$var$node;

});

parcelRegister("kWCTI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d42738ed9f0149a7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<07ab4de75721935837d0b41078aab8fe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d42738ed9f0149a7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraVersion",
    "selections": [
        {
            "concreteType": "JiraVersionWarningConfig",
            "kind": "LinkedField",
            "name": "warningConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "openPullRequest"
                    },
                    "action": "NONE",
                    "path": "warningConfig.openPullRequest"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "openReview"
                    },
                    "action": "NONE",
                    "path": "warningConfig.openReview"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "unreviewedCode"
                    },
                    "action": "NONE",
                    "path": "warningConfig.unreviewedCode"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "failingBuild"
                    },
                    "action": "NONE",
                    "path": "warningConfig.failingBuild"
                }
            ]
        }
    ],
    "type": "JiraVersion"
};
$d42738ed9f0149a7$var$node.hash = "e4b994880d16817a096017c816579b1b";
var $d42738ed9f0149a7$export$2e2bcd8739ae039 = $d42738ed9f0149a7$var$node;

});

parcelRegister("iwqD8", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b841e02ff989ff3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1d623581b7a92661251cd4486c951a21>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3b841e02ff989ff3$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "count"
    }, v1 = {
        "kind": "ScalarField",
        "name": "state"
    }, v2 = [
        v1 /*: any*/ ,
        v0 /*: any*/ 
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "isDevopsFeatureDisabledInFedRamp"
            }
        ],
        "kind": "Fragment",
        "name": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraIssue",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "ids",
                            "value": [
                                "priority",
                                "summary",
                                "assignee",
                                "status",
                                "issuetype"
                            ]
                        }
                    ],
                    "concreteType": "JiraIssueFieldConnection",
                    "kind": "LinkedField",
                    "name": "fieldsById",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraIssueFieldEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "ScalarField",
                                                    "name": "fieldId"
                                                },
                                                "action": "THROW",
                                                "path": "fieldsById.edges.node.fieldId"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraStatus",
                                                        "kind": "LinkedField",
                                                        "name": "status",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraStatusCategory",
                                                                "kind": "LinkedField",
                                                                "name": "statusCategory",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "statusCategoryId"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraStatusField"
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "fieldsById.edges"
                        }
                    ],
                    "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                },
                "action": "THROW",
                "path": "fieldsById"
            },
            {
                "condition": "isDevopsFeatureDisabledInFedRamp",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "DevOpsSummarisedEntities",
                        "kind": "LinkedField",
                        "name": "devOpsSummarisedEntities",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "DevOpsSummarisedBuilds",
                                "kind": "LinkedField",
                                "name": "summarisedBuilds",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "concreteType": "DevOpsSummarisedBuildState",
                                        "kind": "LinkedField",
                                        "name": "buildStates",
                                        "plural": true,
                                        "selections": v2 /*: any*/ 
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraIssueDevSummaryResult",
                        "kind": "LinkedField",
                        "name": "devSummaryCache",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JiraIssueDevSummary",
                                    "kind": "LinkedField",
                                    "name": "devSummary",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "pullrequest",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssuePullRequestDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v1 /*: any*/ ,
                                                                    "action": "NONE",
                                                                    "path": "devSummaryCache.devSummary.pullrequest.overall.state"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v0 /*: any*/ ,
                                                                    "action": "NONE",
                                                                    "path": "devSummaryCache.devSummary.pullrequest.overall.count"
                                                                }
                                                            ]
                                                        },
                                                        "action": "NONE",
                                                        "path": "devSummaryCache.devSummary.pullrequest.overall"
                                                    }
                                                ]
                                            },
                                            "action": "NONE",
                                            "path": "devSummaryCache.devSummary.pullrequest"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "commit",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueCommitDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v0 /*: any*/ ,
                                                                    "action": "NONE",
                                                                    "path": "devSummaryCache.devSummary.commit.overall.count"
                                                                }
                                                            ]
                                                        },
                                                        "action": "NONE",
                                                        "path": "devSummaryCache.devSummary.commit.overall"
                                                    }
                                                ]
                                            },
                                            "action": "NONE",
                                            "path": "devSummaryCache.devSummary.commit"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "build",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueBuildDevSummary",
                                                            "kind": "LinkedField",
                                                            "name": "overall",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "kind": "ScalarField",
                                                                        "name": "failedBuildCount"
                                                                    },
                                                                    "action": "NONE",
                                                                    "path": "devSummaryCache.devSummary.build.overall.failedBuildCount"
                                                                }
                                                            ]
                                                        },
                                                        "action": "NONE",
                                                        "path": "devSummaryCache.devSummary.build.overall"
                                                    }
                                                ]
                                            },
                                            "action": "NONE",
                                            "path": "devSummaryCache.devSummary.build"
                                        },
                                        {
                                            "concreteType": "JiraIssueReviewDevSummaryContainer",
                                            "kind": "LinkedField",
                                            "name": "review",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueReviewDevSummary",
                                                    "kind": "LinkedField",
                                                    "name": "overall",
                                                    "plural": false,
                                                    "selections": v2 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "NONE",
                                "path": "devSummaryCache.devSummary"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssue"
    };
}();
$3b841e02ff989ff3$var$node.hash = "ffa772f7a474b433d08a55e95366246c";
var $3b841e02ff989ff3$export$2e2bcd8739ae039 = $3b841e02ff989ff3$var$node;

});


const $752b719410cf933d$export$b343d4705e10ba61 = 'VersionDetailIssueListIssueCardContainer';
const $752b719410cf933d$export$6bc465585d114926 = 'VersionDetailsIssueList';
const $752b719410cf933d$export$eb4c541f23d39ba2 = 1740;
const $752b719410cf933d$export$ac70ca19af3aa92c = 1380;

parcelRegister("1KeDw", function(module, exports) {

$parcel$export(module.exports, "Assignee", () => $3c0e123bdcc383cb$export$361f73eba39649ac);

var $2HbPb = parcelRequire("2HbPb");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $ujWmd = parcelRequire("ujWmd");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $eAypR = parcelRequire("eAypR");
const $3c0e123bdcc383cb$export$361f73eba39649ac = ({ jiraAssigneeField: jiraAssigneeField })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const data = (0, $8Uumt.useFragment)((0, $2HbPb.default), jiraAssigneeField);
    const avatarUrl = data?.user == null ? '' : data.user.picture;
    const displayName = data?.user == null ? formatMessage((0, $eAypR.default).unassigned) : data.user.name;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3c0e123bdcc383cb$var$AssigneeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: displayName,
        position: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3c0e123bdcc383cb$var$VerticalCenter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        appearance: "circle",
        src: avatarUrl,
        size: "small"
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3c0e123bdcc383cb$var$AssigneeContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _4t3izwfg _1bsbzwfg _1ul9zwfg _8mocu2gc",
            __cmplp.className
        ])
    });
});
const $3c0e123bdcc383cb$var$VerticalCenter = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2HbPb", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f03087c3dbf693a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0f9ca0ad69f75332a07996cc07876757>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7f03087c3dbf693a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "assignee_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "picture"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraSingleSelectUserPickerField"
};
$7f03087c3dbf693a$var$node.hash = "a79331910374d5f581f31a15777ff330";
var $7f03087c3dbf693a$export$2e2bcd8739ae039 = $7f03087c3dbf693a$var$node;

});

parcelRegister("eAypR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d25d0f86e97cdffa$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d25d0f86e97cdffa$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    unassigned: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.assignee.unassigned",
        "defaultMessage": "Unassigned"
    }
});

});


parcelRegister("c7zJ6", function(module, exports) {

$parcel$export(module.exports, "DeliveryInfo", () => $fb3330b088a6db2d$export$61f40ad692662ca7);
$parcel$export(module.exports, "Delivery", () => $fb3330b088a6db2d$export$12cbedef95fe0035);
$parcel$export(module.exports, "DeliveryContainer", () => $fb3330b088a6db2d$export$8901d2e97ed55253);

var $l4DDb = parcelRequire("l4DDb");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");


var $8YTUU = parcelRequire("8YTUU");

var $Iny5X = parcelRequire("Iny5X");


var $npYQQ = parcelRequire("npYQQ");


var $a40gh = parcelRequire("a40gh");

var $4ttab = parcelRequire("4ttab");

var $aEu2z = parcelRequire("aEu2z");

var $916hF = parcelRequire("916hF");
const $fb3330b088a6db2d$var$getDeploymentDetails = (devOpsSummarisedEntities)=>{
    const summaries = devOpsSummarisedEntities?.summarisedDeployments;
    if (!summaries) return undefined;
    const { deploymentState: deploymentState, deploymentEnvironment: deploymentEnvironment } = summaries;
    return {
        deploymentState: deploymentState ?? undefined,
        deploymentEnvironment: deploymentEnvironment?.category ?? undefined
    };
};
const $fb3330b088a6db2d$export$61f40ad692662ca7 = ({ issueId: issueId, scopeId: scopeId, customTrigger: customTrigger, devSummaryCache: devSummaryCache, devOpsSummarisedEntities: devOpsSummarisedEntities, zIndexForPopup: zIndexForPopup, location: location, onClick: onClick = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) })=>{
    const devSummary = devSummaryCache?.devSummary;
    const hasBambooDeployments = (devSummary?.deploymentEnvironments?.overall?.topEnvironments ?? []).filter((deployment)=>deployment.status === 'DEPLOYED').length > 0;
    const hasBuilds = Number(devSummary?.build?.overall?.count) > 0 || Number(devOpsSummarisedEntities?.summarisedBuilds?.count) > 0;
    const deploymentCount = devOpsSummarisedEntities?.summarisedDeployments?.count ?? 0;
    const hasDeployments = deploymentCount > 0;
    if (devOpsSummarisedEntities != null && hasDeployments) {
        const deploymentDetails = $fb3330b088a6db2d$var$getDeploymentDetails(devOpsSummarisedEntities);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Iny5X.default), {
            devInfoType: (0, $8YTUU.DevInfoTypes).DEPLOYMENT,
            issueId: Number(issueId),
            customTrigger: customTrigger,
            scopeId: scopeId,
            deploymentDetails: deploymentDetails,
            zIndex: zIndexForPopup,
            location: location
        });
    }
    if (devSummary != null && hasBambooDeployments) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4ttab.BambooDeploymentData), {
        jiraIssueDevSummary: devSummary,
        onDeploymentClicked: ()=>onClick((0, $61a2cd6236d50c20$export$90cac6260ae9ced5))
    });
    if (devSummary != null && hasBuilds) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aEu2z.BuildData), {
        devOpsSummarisedBuilds: devOpsSummarisedEntities?.summarisedBuilds ?? undefined,
        jiraIssueDevSummary: devSummary,
        onBuildClicked: ()=>onClick((0, $61a2cd6236d50c20$export$74a388a09f2a004e))
    });
    return null;
};
const $fb3330b088a6db2d$export$12cbedef95fe0035 = ({ jiraIssue: jiraIssue, onClick: onClick })=>{
    const { issueId: issueId, devSummaryCache: devSummaryCache, devOpsSummarisedEntities: devOpsSummarisedEntities, summarisedDeployments: summarisedDeployments, summarisedBuilds: summarisedBuilds } = (0, $8Uumt.useFragment)((0, $l4DDb.default), jiraIssue);
    const devSummary = devSummaryCache?.devSummary;
    const hasBambooDeployments = (devSummary?.deploymentEnvironments?.overall?.topEnvironments ?? []).filter((deployment)=>deployment.status === 'DEPLOYED').length > 0;
    const hasBuilds = Number(devSummary?.build?.overall?.count) > 0 || Number(summarisedBuilds?.count) > 0;
    const deploymentCount = summarisedDeployments?.count ?? 0;
    const hasDeployments = deploymentCount > 0;
    if (devOpsSummarisedEntities != null && hasDeployments) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fb3330b088a6db2d$export$8901d2e97ed55253, {
        "data-version-details-issue-click-ignore-target": (0, $npYQQ.ISSUE_CARD_CLICK_IGNORE_TARGET)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a40gh.ErrorBoundary), {
        id: "issuesListDeploymentData"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Iny5X.default), {
        devInfoType: (0, $8YTUU.DevInfoTypes).DEPLOYMENT,
        issueId: Number(issueId),
        customTrigger: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $916hF.DeploymentData), {
            jiraIssueDevOpsSummarisedEntities: devOpsSummarisedEntities,
            onDeploymentClicked: ()=>onClick((0, $61a2cd6236d50c20$export$90cac6260ae9ced5))
        }),
        scopeId: (0, $752b719410cf933d$export$6bc465585d114926),
        isStopPropagationOnClick: false,
        location: (0, $4ebd35f903e92a1a$export$ede40e627a0cbf14)
    })));
    if (devSummary != null && hasBambooDeployments) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fb3330b088a6db2d$export$8901d2e97ed55253, {
        "data-version-details-issue-click-ignore-target": (0, $npYQQ.ISSUE_CARD_CLICK_IGNORE_TARGET)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a40gh.ErrorBoundary), {
        id: "issuesListBambooDeploymentData"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4ttab.BambooDeploymentData), {
        jiraIssueDevSummary: devSummary,
        onDeploymentClicked: ()=>onClick((0, $61a2cd6236d50c20$export$90cac6260ae9ced5))
    })));
    if (devSummary != null && hasBuilds) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fb3330b088a6db2d$export$8901d2e97ed55253, {
        "data-version-details-issue-click-ignore-target": (0, $npYQQ.ISSUE_CARD_CLICK_IGNORE_TARGET)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a40gh.ErrorBoundary), {
        fallback: "flag",
        id: "issuesListBuildData"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aEu2z.BuildData), {
        devOpsSummarisedBuilds: summarisedBuilds ?? undefined,
        jiraIssueDevSummary: devSummary,
        onBuildClicked: ()=>onClick((0, $61a2cd6236d50c20$export$74a388a09f2a004e))
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fb3330b088a6db2d$export$8901d2e97ed55253, null);
};
const $fb3330b088a6db2d$export$8901d2e97ed55253 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_17av1lit _fmdx1lit _jyrf1tcg _3ufp1tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("l4DDb", function(module, exports) {

$parcel$export(module.exports, "default", () => $92767328c82a2148$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f4f897058d07ec624ab4dc06192c57c2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $92767328c82a2148$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "count"
    }, v1 = [
        v0 /*: any*/ 
    ], v2 = {
        "concreteType": "DevOpsSummarisedDeployments",
        "kind": "LinkedField",
        "name": "summarisedDeployments",
        "plural": false,
        "selections": v1 /*: any*/ 
    }, v3 = {
        "kind": "FragmentSpread",
        "name": "buildData_softwareReleasesVersionDetailIssueList_devOpsSummarisedBuilds"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "shouldIncludeDevOpsFieldsViaAgs"
            }
        ],
        "kind": "Fragment",
        "name": "delivery_softwareReleasesVersionDetailIssueList",
        "selections": [
            {
                "concreteType": "DevOpsSummarisedEntities",
                "kind": "LinkedField",
                "name": "devOpsSummarisedEntities",
                "plural": false,
                "selections": [
                    v2 /*: any*/ ,
                    {
                        "concreteType": "DevOpsSummarisedBuilds",
                        "kind": "LinkedField",
                        "name": "summarisedBuilds",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            v3 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "deploymentData_softwareReleasesVersionDetailIssueList"
                    }
                ]
            },
            {
                "condition": "shouldIncludeDevOpsFieldsViaAgs",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v2 /*: any*/ ,
                    {
                        "concreteType": "DevOpsSummarisedBuilds",
                        "kind": "LinkedField",
                        "name": "summarisedBuilds",
                        "plural": false,
                        "selections": [
                            v3 /*: any*/ ,
                            v0 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "concreteType": "JiraIssueDevSummaryResult",
                "kind": "LinkedField",
                "name": "devSummaryCache",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueDevSummary",
                        "kind": "LinkedField",
                        "name": "devSummary",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueBuildDevSummaryContainer",
                                "kind": "LinkedField",
                                "name": "build",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueBuildDevSummary",
                                        "kind": "LinkedField",
                                        "name": "overall",
                                        "plural": false,
                                        "selections": v1 /*: any*/ 
                                    }
                                ]
                            },
                            {
                                "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                "kind": "LinkedField",
                                "name": "deploymentEnvironments",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                        "kind": "LinkedField",
                                        "name": "overall",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueDeploymentEnvironment",
                                                "kind": "LinkedField",
                                                "name": "topEnvironments",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "status"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "bambooDeploymentData_softwareReleasesVersionDetailIssueList"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "buildData_softwareReleasesVersionDetailIssueList_jiraIssueDevSummary"
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "issueId"
            }
        ],
        "type": "JiraIssue"
    };
}();
$92767328c82a2148$var$node.hash = "cc5169ba959e61a60ddf7a3d0ca12b66";
var $92767328c82a2148$export$2e2bcd8739ae039 = $92767328c82a2148$var$node;

});

const $4ebd35f903e92a1a$export$9b8283d5878d2491 = 'board';
const $4ebd35f903e92a1a$export$76a449e52fa0e1e8 = 'issue';
const $4ebd35f903e92a1a$export$ede40e627a0cbf14 = 'version_details';
const $4ebd35f903e92a1a$export$464c50016d069471 = 'issue_view_child_issues_list';
const $4ebd35f903e92a1a$export$3a46c5b594c0f84c = 'issue_view_linked_issues_list';

parcelRegister("8YTUU", function(module, exports) {

$parcel$export(module.exports, "DevInfoTypes", () => $ba5542dc32884ee4$export$a100703e17b2650a);
$parcel$export(module.exports, "DevInfoTypeMap", () => $ba5542dc32884ee4$export$39c00ace65e13f2d);
$parcel$export(module.exports, "ButtonStatus", () => $ba5542dc32884ee4$export$477d4d2d93581a40);
const $ba5542dc32884ee4$export$a100703e17b2650a = Object.freeze({
    BRANCH: 'branch',
    COMMIT: 'commit',
    PULLREQUEST: 'pullrequest',
    DECLINED: 'declined',
    MERGED: 'merged',
    DEPLOYMENT: 'deployment',
    DESIGN: 'design'
});
const $ba5542dc32884ee4$export$39c00ace65e13f2d = {
    [$ba5542dc32884ee4$export$a100703e17b2650a.BRANCH]: 'branch',
    [$ba5542dc32884ee4$export$a100703e17b2650a.COMMIT]: 'commit',
    [$ba5542dc32884ee4$export$a100703e17b2650a.PULLREQUEST]: 'pull request',
    [$ba5542dc32884ee4$export$a100703e17b2650a.MERGED]: 'pull request',
    [$ba5542dc32884ee4$export$a100703e17b2650a.DECLINED]: 'pull request',
    [$ba5542dc32884ee4$export$a100703e17b2650a.DEPLOYMENT]: 'deployment',
    [$ba5542dc32884ee4$export$a100703e17b2650a.DESIGN]: 'design'
};
const $ba5542dc32884ee4$export$477d4d2d93581a40 = Object.freeze({
    ACTIVE: 'active',
    HOVER: 'hover',
    DEFAULT: 'default'
});

});

parcelRegister("Iny5X", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9451438a3e9bf76$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8QpSo = parcelRequire("8QpSo");

var $9yOBd = parcelRequire("9yOBd");

var $4iPF3 = parcelRequire("4iPF3");

var $ePJ5X = parcelRequire("ePJ5X");

var $bFklq = parcelRequire("bFklq");

var $ksIER = parcelRequire("ksIER");

var $91Cn3 = parcelRequire("91Cn3");

var $hXgVM = parcelRequire("hXgVM");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gwIPs = parcelRequire("gwIPs");

var $4gmb8 = parcelRequire("4gmb8");

var $2YZCu = parcelRequire("2YZCu");


var $8YTUU = parcelRequire("8YTUU");

var $lxrPB = parcelRequire("lxrPB");

var $kcaDR = parcelRequire("kcaDR");

var $7MIrF = parcelRequire("7MIrF");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $ivDCs = parcelRequire("ivDCs");

var $4mO32 = parcelRequire("4mO32");

var $7CMCs = parcelRequire("7CMCs");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $lXSZ8 = parcelRequire("lXSZ8");

var $koVbs = parcelRequire("koVbs");

var $7IEKg = parcelRequire("7IEKg");

var $dXq4S = parcelRequire("dXq4S");

var $jgJNO = parcelRequire("jgJNO");

var $iXVV6 = parcelRequire("iXVV6");

var $fiv1r = parcelRequire("fiv1r");

var $fcSLY = parcelRequire("fcSLY");

var $kfztd = parcelRequire("kfztd");

var $9OXo1 = parcelRequire("9OXo1");

var $4R6GH = parcelRequire("4R6GH");

var $gicL9 = parcelRequire("gicL9");

var $4Dyci = parcelRequire("4Dyci");
const $a9451438a3e9bf76$var$DEV_INFO_BUTTON_ID = 'development-board-dev-info-icon.button-text';
const $a9451438a3e9bf76$var$DevInfoIconsMapping = (0, $8QpSo.default)((formatMessage)=>({
        [(0, $8YTUU.DevInfoTypes).BRANCH]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4iPF3))), {
            label: formatMessage((0, $4Dyci.default).branchIconLabel),
            color: "var(--ds-icon, #44546F)"
        }),
        [(0, $8YTUU.DevInfoTypes).COMMIT]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bFklq))), {
            label: formatMessage((0, $4Dyci.default).commitIconLabel),
            color: "var(--ds-icon, #44546F)"
        }),
        [(0, $8YTUU.DevInfoTypes).PULLREQUEST]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hXgVM))), {
            label: formatMessage((0, $4Dyci.default).openPullRequestIconLabel),
            color: "var(--ds-icon, #44546F)"
        }),
        [(0, $8YTUU.DevInfoTypes).DECLINED]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ksIER))), {
            label: formatMessage((0, $4Dyci.default).declinedPullRequestIconLabel),
            color: "var(--ds-icon, #44546F)"
        }),
        [(0, $8YTUU.DevInfoTypes).MERGED]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91Cn3))), {
            label: formatMessage((0, $4Dyci.default).mergedPullRequestIconLabel),
            color: "var(--ds-icon-accent-green, #22A06B)"
        }),
        [(0, $8YTUU.DevInfoTypes).DEPLOYMENT]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ePJ5X))), {
            label: formatMessage((0, $4Dyci.default).deploymentIconLabel),
            color: "var(--ds-icon, #44546F)"
        }),
        [(0, $8YTUU.DevInfoTypes).DESIGN]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $a9451438a3e9bf76$var$DesignIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXSZ8.default), {
            label: formatMessage((0, $4Dyci.default).designIconLabel)
        }))
    }));
const $a9451438a3e9bf76$var$getDevInfoIcon = (devInfoType, formatMessage, deploymentDetails)=>{
    if (deploymentDetails?.deploymentState && deploymentDetails?.deploymentEnvironment) {
        if (deploymentDetails.deploymentEnvironment === (0, $gicL9.DeploymentEnvironment).PRODUCTION && deploymentDetails.deploymentState === (0, $gicL9.DeploymentState).SUCCESSFUL) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7MIrF.DeploymentProdSuccess), {
            size: "small",
            label: formatMessage((0, $4Dyci.default).deploymentProductionSuccessIconLabel)
        });
        if (deploymentDetails.deploymentEnvironment === (0, $gicL9.DeploymentEnvironment).PRODUCTION && deploymentDetails.deploymentState === (0, $gicL9.DeploymentState).FAILED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7MIrF.DeploymentProdFailed), {
            size: "small",
            label: formatMessage((0, $4Dyci.default).deploymentProductionFailedIconLabel)
        });
        if (deploymentDetails.deploymentEnvironment !== (0, $gicL9.DeploymentEnvironment).PRODUCTION && deploymentDetails.deploymentState === (0, $gicL9.DeploymentState).SUCCESSFUL) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7MIrF.DeploymentNonProdSuccess), {
            size: "small",
            label: formatMessage((0, $4Dyci.default).deploymentNonProductionSuccessIconLabel)
        });
        if (deploymentDetails.deploymentEnvironment !== (0, $gicL9.DeploymentEnvironment).PRODUCTION && deploymentDetails.deploymentState === (0, $gicL9.DeploymentState).FAILED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7MIrF.DeploymentNonProdFailed), {
            size: "small",
            label: formatMessage((0, $4Dyci.default).deploymentNonProductionFailedIconLabel)
        });
    }
    return $a9451438a3e9bf76$var$DevInfoIconsMapping(formatMessage)[devInfoType];
};
const $a9451438a3e9bf76$var$TriggerComponent = ({ triggerProps: triggerProps, customTrigger: customTrigger })=>{
    const omitProp = (prop, { [prop]: _, ...rest })=>rest;
    const modifierTriggerProps = omitProp('aria-expanded', triggerProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", modifierTriggerProps, customTrigger);
};
const $a9451438a3e9bf76$export$b98af1fb6b8b345e = ({ issueId: issueId, devInfoType: devInfoType, allowNativeContextMenu: allowNativeContextMenu, customTrigger: customTrigger, scopeId: scopeId, deploymentDetails: deploymentDetails, isStopPropagationOnClick: isStopPropagationOnClick = true, placement: placement = 'bottom-start', offset: offset, zIndex: /* Setting zIndex slighlty lower than the default so that other popups (like the right-click context menu) appear on top of this */ zIndex = (0, $gwIPs.layers).layer - 1 })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [isHoverMode, setIsHoverMode] = (0, $5uXOq.useState)(true);
    const [shouldAutoFocus, setShouldAutoFocus] = (0, $5uXOq.useState)(true);
    const timeoutRef = (0, $5uXOq.useRef)(undefined);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const issueAri = (0, $5uXOq.useMemo)(()=>(0, $kcaDR.createIssueAri)(cloudId, issueId.toString()), [
        cloudId,
        issueId
    ]);
    const siteAri = (0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        resourceType: 'site',
        resourceId: cloudId
    });
    const initialTrigger = (0, $5uXOq.useRef)(null);
    const devInfoIcon = $a9451438a3e9bf76$var$getDevInfoIcon(devInfoType, formatMessage, deploymentDetails);
    const popupType = devInfoType === (0, $8YTUU.DevInfoTypes).MERGED || devInfoType === (0, $8YTUU.DevInfoTypes).DECLINED ? (0, $8YTUU.DevInfoTypes).PULLREQUEST : devInfoType;
    const { id: experienceId, name: experienceName } = (0, $gicL9.experienceDetails)[popupType];
    const onExperienceSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: experienceName
    });
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            issueId: issueAri
        }), [
        issueAri
    ]); // eslint-disable-next-line @atlassian/react-entrypoint/prefer-entrypoint-file-import
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject, stopMetric: stopMetric } = (0, $4mO32.useEntryPoint)((0, $4R6GH.fg)('jira_devinfo_migration_dd_to_ugs') ? (0, $gicL9.popupEntryPoints)[popupType] : (0, $gicL9.popupEntryPointsOld)[popupType], entryPointParams, (0, $gicL9.metrics)[popupType]); // Entry point for the design modal that is used in the design details popup
    const designEntrypoint = (0, $4mO32.useEntryPoint)((0, $7IEKg.designModalEntryPoint), {
        siteAri: siteAri,
        issueAri: issueAri,
        cloudId: cloudId
    });
    const designModalTriggerRef = (0, $47gW9.useEntryPointButtonTrigger)(designEntrypoint.entryPointActions);
    const entryPointErrorBoundaryProps = (0, $5uXOq.useMemo)(()=>({
            ...(0, $gicL9.packageDetails)[popupType],
            errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lxrPB.default), {
                    devInfoType: devInfoType,
                    issueAri: issueAri,
                    scopeId: scopeId
                })
        }), [
        devInfoType,
        issueAri,
        popupType,
        scopeId
    ]);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            issueAri: issueAri,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            devInfoType: devInfoType,
            trigger: initialTrigger.current ?? undefined,
            onReady: ()=>{
                stopMetric();
                onExperienceSuccess();
            },
            scopeId: scopeId,
            modalTriggerRef: devInfoType === (0, $8YTUU.DevInfoTypes).DESIGN ? designModalTriggerRef : undefined
        }), [
        issueAri,
        devInfoType,
        scopeId,
        designModalTriggerRef,
        stopMetric,
        onExperienceSuccess
    ]);
    const handleDevIconClick = (0, $5uXOq.useCallback)(()=>{
        clearTimeout(timeoutRef.current);
        if (initialTrigger.current === null) initialTrigger.current = 'click';
        if (isOpen && isHoverMode) setIsHoverMode(false);
        else if (isOpen && !isHoverMode) {
            initialTrigger.current = null;
            setIsOpen(false);
            setIsHoverMode(true);
        } else {
            entryPointActions.load();
            setShouldAutoFocus(true);
            setIsOpen(true);
            setIsHoverMode(false);
        }
    }, [
        entryPointActions,
        isHoverMode,
        isOpen
    ]);
    const handleMouseEnter = ()=>{
        if (!isHoverMode) return;
        clearTimeout(timeoutRef.current);
        setShouldAutoFocus(false);
        if (!isOpen) {
            entryPointActions.preload();
            timeoutRef.current = undefined;
            timeoutRef.current = setTimeout(()=>{
                if (initialTrigger.current === null) initialTrigger.current = 'hover';
                entryPointActions.load();
                setIsOpen(true);
            }, (0, $gicL9.HOVER_TIMEOUT_MS));
        }
    };
    const handleMouseLeave = ()=>{
        if (!isHoverMode) return;
        clearTimeout(timeoutRef.current);
        entryPointActions.cancelPreload();
        timeoutRef.current = undefined;
        if (isOpen) timeoutRef.current = setTimeout(()=>{
            initialTrigger.current = null;
            setShouldAutoFocus(true);
            setIsHoverMode(true);
            setIsOpen(false);
        }, (0, $gicL9.HOVER_TIMEOUT_MS));
    };
    if ((0, $gicL9.iconColor)[devInfoType] === undefined) (0, $2YZCu.default).safeErrorWithoutCustomerData('packages.development.board.dev-info-icon', 'unexpected devInfoType', {
        devInfoType: devInfoType
    });
    const customTheme = (0, $4gmb8.getTheme)({
        buttonStyles: {
            subtle: {
                color: {
                    // @ts-expect-error - TS2322 - Type '{ color: { default: string | undefined; hover: string | undefined; active: string | undefined; }; }' is not assignable to type 'CSSInterpolation'. | TS2532 - Object is possibly 'undefined'.
                    default: (0, $gicL9.iconColor)[devInfoType][(0, $8YTUU.ButtonStatus).DEFAULT],
                    hover: (0, $gicL9.iconColor)[devInfoType][(0, $8YTUU.ButtonStatus).HOVER],
                    active: (0, $gicL9.iconColor)[devInfoType][(0, $8YTUU.ButtonStatus).ACTIVE]
                }
            }
        }
    });
    const devInfoTextId = `${$a9451438a3e9bf76$var$DEV_INFO_BUTTON_ID}-${issueId}`;
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        role: "presentation",
        "data-testid": "development-board-dev-info-icon.container",
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onClick: (e)=>{
            // Prevents clicks on the icon from opening the Issue view
            if (isStopPropagationOnClick) e.stopPropagation();
        },
        onKeyDown: (e)=>{
            // Prevents using keyboard to open the Issue view
            e.stopPropagation();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        placement: placement,
        shouldFlip: true,
        autoFocus: shouldAutoFocus,
        shouldUseCaptureOnOutsideClick: true,
        testId: "development-board-dev-info-icon.popup",
        messageId: "development-board-dev-info-icon.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>customTrigger != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a9451438a3e9bf76$var$TriggerComponent, {
                triggerProps: triggerProps,
                customTrigger: customTrigger
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
                ...triggerProps,
                onClick: handleDevIconClick,
                isSelected: isOpen && !isHoverMode,
                theme: customTheme,
                appearance: "subtle",
                spacing: "compact",
                iconBefore: devInfoIcon,
                "aria-describedby": devInfoTextId
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a9451438a3e9bf76$var$DevInfoButtonText, {
                id: devInfoTextId
            }, (0, $gicL9.DevInfoButtonLabelMapping)(formatMessage)[devInfoType])),
        isOpen: isOpen,
        onClose: ()=>{
            initialTrigger.current = null;
            setIsOpen(false);
            setIsHoverMode(true);
        },
        offset: offset,
        zIndex: zIndex,
        content: ()=>// eslint-disable-next-line jsx-a11y/no-static-element-interactions
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div" // We are stopping right-click event propagation to not show the custom context menu from the Jira Issue Card
            , {
                // and instead use the event default
                onContextMenu: (event)=>{
                    if (!allowNativeContextMenu) event.preventDefault();
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kaHBi.ExperienceStart), {
                analyticsSource: experienceName,
                experience: experienceName,
                experienceId: experienceId
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                ...entryPointErrorBoundaryProps,
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fcSLY.DevInfoDetailsPopupSkeleton), {
                    devinfoType: popupType
                }),
                runtimeProps: runtimeProps
            }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        entryPointReferenceSubject: designEntrypoint.entryPointReferenceSubject,
        id: "jiraDesignModal",
        packageName: "design-modal",
        entryPointActions: designEntrypoint.entryPointActions,
        runtimeProps: {
            initialSelectedDesign: 0
        }
    })));
};
const $a9451438a3e9bf76$var$ERROR_ID = 'renderDevInfoIcon';
const $a9451438a3e9bf76$var$PACKAGE_NAME = 'jiraDevelopmentBoardDevInfoIcon';
const $a9451438a3e9bf76$var$DevInfoIcon = ({ issueId: issueId, devInfoType: devInfoType, allowNativeContextMenu: allowNativeContextMenu, customTrigger: customTrigger, scopeId: scopeId, deploymentDetails: deploymentDetails, isStopPropagationOnClick: isStopPropagationOnClick = true, placement: placement, offset: offset, zIndex: zIndex, location: location = (0, $4ebd35f903e92a1a$export$9b8283d5878d2491) })=>{
    const attributes = {
        devInfoType: devInfoType ?? 'unexpected',
        location: location
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: $a9451438a3e9bf76$var$ERROR_ID,
        packageName: $a9451438a3e9bf76$var$PACKAGE_NAME,
        teamName: "nova",
        fallback: "unmount",
        attributes: attributes,
        extraEventData: attributes,
        sendToPrivacyUnsafeSplunk: true
    }, !(0, $kfztd.isDevopsFeatureDisabledInFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fiv1r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$cae2783c9279926),
        sourceName: "DevInfoIcon",
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a9451438a3e9bf76$export$b98af1fb6b8b345e, {
        issueId: issueId,
        devInfoType: devInfoType,
        allowNativeContextMenu: allowNativeContextMenu,
        customTrigger: customTrigger,
        scopeId: scopeId,
        deploymentDetails: deploymentDetails,
        isStopPropagationOnClick: isStopPropagationOnClick,
        placement: placement,
        offset: offset,
        zIndex: zIndex
    }))));
};
var $a9451438a3e9bf76$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $a9451438a3e9bf76$var$DevInfoIcon;
const $a9451438a3e9bf76$var$DevInfoButtonText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $a9451438a3e9bf76$var$DesignIconStyles = (0, $8CUq3.xcss)({
    height: '16px',
    width: '16px',
    display: 'flex',
    justifyContent: 'center'
});

});
parcelRegister("4iPF3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bb7d4b05cefe88d0219507dc0673c3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3220eab15e59539d$var$_react = $3220eab15e59539d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3220eab15e59539d$var$_baseNew = $3220eab15e59539d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3220eab15e59539d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3220eab15e59539d$var$BranchIcon = (props)=>/*#__PURE__*/ $3220eab15e59539d$var$_react.default.createElement($3220eab15e59539d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$3220eab15e59539d$var$BranchIcon.displayName = 'BranchIcon';
var $3220eab15e59539d$var$_default = module.exports.default = $3220eab15e59539d$var$BranchIcon;

});

parcelRegister("ePJ5X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e83f76db2e7ada7e0358014b5e026a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acc8cf07db1d2dba$var$_react = $acc8cf07db1d2dba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $acc8cf07db1d2dba$var$_baseNew = $acc8cf07db1d2dba$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $acc8cf07db1d2dba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $acc8cf07db1d2dba$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $acc8cf07db1d2dba$var$_react.default.createElement($acc8cf07db1d2dba$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$acc8cf07db1d2dba$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $acc8cf07db1d2dba$var$_default = module.exports.default = $acc8cf07db1d2dba$var$CloudArrowUpIcon;

});

parcelRegister("bFklq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::06952e599791aaa8e8e82dba5053d210>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87e34e0db8f20450$var$_react = $87e34e0db8f20450$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $87e34e0db8f20450$var$_baseNew = $87e34e0db8f20450$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $87e34e0db8f20450$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Commit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for commits in Jira or Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87e34e0db8f20450$var$CommitIcon = (props)=>/*#__PURE__*/ $87e34e0db8f20450$var$_react.default.createElement($87e34e0db8f20450$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 5.354a2.751 2.751 0 0 0 0 5.292V16h1.5v-5.353a2.751 2.751 0 0 0 0-5.293V0h-1.5zM8 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5" clip-rule="evenodd"/>`
    }, props));
$87e34e0db8f20450$var$CommitIcon.displayName = 'CommitIcon';
var $87e34e0db8f20450$var$_default = module.exports.default = $87e34e0db8f20450$var$CommitIcon;

});

parcelRegister("ksIER", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::46425de68e3cee71ad4d509963568bdb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee5910529ff74451$var$_react = $ee5910529ff74451$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ee5910529ff74451$var$_baseNew = $ee5910529ff74451$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ee5910529ff74451$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "MergeFailure".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira that have failed to merge.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ee5910529ff74451$var$MergeFailureIcon = (props)=>/*#__PURE__*/ $ee5910529ff74451$var$_react.default.createElement($ee5910529ff74451$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.19 3.25 1.47 1.53 2.53.47l1.72 1.72L5.97.47l1.06 1.06-1.72 1.72 1.72 1.72-1.06 1.06-1.72-1.72-1.72 1.72-1.06-1.06zM8.5 2.5h1.25a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8.5zm-5 8.128V7.5H5v3.128a2.251 2.251 0 1 1-1.5 0M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$ee5910529ff74451$var$MergeFailureIcon.displayName = 'MergeFailureIcon';
var $ee5910529ff74451$var$_default = module.exports.default = $ee5910529ff74451$var$MergeFailureIcon;

});

parcelRegister("91Cn3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7365ce82afc8d12ffbc163f3aafca653>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6921f8b1fecd6128$var$_react = $6921f8b1fecd6128$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6921f8b1fecd6128$var$_baseNew = $6921f8b1fecd6128$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $6921f8b1fecd6128$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "MergeSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira that have successfully merged.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6921f8b1fecd6128$var$MergeSuccessIcon = (props)=>/*#__PURE__*/ $6921f8b1fecd6128$var$_react.default.createElement($6921f8b1fecd6128$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m6.174.77 1.152.96-3.333 4a.75.75 0 0 1-1.152 0l-1.667-2 1.152-.96 1.09 1.308zM8.5 2.5h1.25a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8.5zm-5 8.128V7.5H5v3.128a2.251 2.251 0 1 1-1.5 0M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$6921f8b1fecd6128$var$MergeSuccessIcon.displayName = 'MergeSuccessIcon';
var $6921f8b1fecd6128$var$_default = module.exports.default = $6921f8b1fecd6128$var$MergeSuccessIcon;

});

parcelRegister("hXgVM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a083285ccf5836110a489694f045affe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d1251477351c10fe$var$_react = $d1251477351c10fe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d1251477351c10fe$var$_baseNew = $d1251477351c10fe$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $d1251477351c10fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PullRequest".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d1251477351c10fe$var$PullRequestIcon = (props)=>/*#__PURE__*/ $d1251477351c10fe$var$_react.default.createElement($d1251477351c10fe$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 2 3.25m6-.75h1.75a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8zM4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$d1251477351c10fe$var$PullRequestIcon.displayName = 'PullRequestIcon';
var $d1251477351c10fe$var$_default = module.exports.default = $d1251477351c10fe$var$PullRequestIcon;

});

parcelRegister("4gmb8", function(module, exports) {

$parcel$export(module.exports, "getTheme", () => $26e3b01c3b885768$export$89cbf1a0881c8b9c);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // @ts-expect-error - TS2614 - Module '"@atlaskit/button"' has no exported member 'ButtonTheme'. Did you mean to use 'import ButtonTheme from "@atlaskit/button"' instead?

const $26e3b01c3b885768$export$9e61512f2dc2cbb0 = (currentTheme, props)=>{
    const { buttonStyles: buttonStyles, ...rest } = currentTheme(props);
    const theme = {
        ...rest,
        buttonStyles: {
            ...buttonStyles,
            backgroundColor: (0, $829f609a65d26a98$exports).P400,
            '> span': {
                color: (0, $829f609a65d26a98$exports).N0
            }
        }
    };
    return theme;
};
const $26e3b01c3b885768$export$f9380c9a627682d3 = (newTheme, themeProps)=>{
    const { appearance: appearance, mode: mode, state: state } = themeProps;
    if (!appearance || !newTheme[appearance]) return undefined;
    const root = newTheme[appearance];
    // @ts-expect-error - TS2739 - Type 'Record<string, any>' is missing the following properties from type 'ThemeTokens': buttonStyles, spinnerStyles
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(root).reduce((acc, val)=>{
        let node = root;
        [
            val,
            state,
            mode
        ].forEach((item)=>{
            if (!item) return;
            if (!node[item] && node[item] !== 0) return;
            if (typeof node[item] !== 'object') {
                acc[val] = node[item];
                return;
            }
            // @ts-expect-error - TS2322 - Type 'string | number | { [key: string]: string | number; } | T' is not assignable to type '{ [key: string]: string | number; } | T'.
            node = node[item];
        });
        return acc;
    }, {});
};
const $26e3b01c3b885768$export$89cbf1a0881c8b9c = (overrides)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        // @ts-expect-error - TS2322 - Type 'Record<string, any>' is not assignable to type 'ThemeTokens'.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const styles = Object.entries(theme).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (acc, [key, value])=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<ThemeTokens>'.
            if (!overrides?.[key]) {
                acc[key] = value;
                return acc;
            }
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<ThemeTokens>'.
            const overriddenStyles = $26e3b01c3b885768$export$f9380c9a627682d3(overrides[key], themeProps);
            acc[key] = {
                ...value,
                ...overriddenStyles
            };
            return acc;
        }, {});
        return styles;
    };

});

parcelRegister("lxrPB", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfd87e1125ba31c4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $dD7Zc = parcelRequire("dD7Zc");

var $koVbs = parcelRequire("koVbs");

var $ifS9h = parcelRequire("ifS9h");

var $8YTUU = parcelRequire("8YTUU");

var $dt6Va = parcelRequire("dt6Va");

var $el2W3 = parcelRequire("el2W3");
const $cfd87e1125ba31c4$var$ErrorFallback = ({ devInfoType: devInfoType, issueAri: issueAri, scopeId: scopeId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showDevDetailDialogForPopup: showDevDetailDialogForPopup } = (0, $dt6Va.useShowDevDetailDialogForPopup)(scopeId);
    const handleLinkClick = ()=>{
        showDevDetailDialogForPopup(devInfoType, issueAri);
    };
    const devInfoTypeName = (0, $8YTUU.DevInfoTypeMap)[devInfoType];
    const errorMessage = devInfoType === (0, $8YTUU.DevInfoTypes).DESIGN ? formatMessage((0, $el2W3.default).designErrorDescription, {
        devInfoType: devInfoTypeName
    }) : formatMessage((0, $el2W3.default).errorDescription, {
        devInfoType: devInfoTypeName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ifS9h.PopupContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ifS9h.PopupTitle), null, formatMessage((0, $el2W3.default).errorPopupTitle, {
        devInfoType: (0, $8YTUU.DevInfoTypeMap)[devInfoType]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfd87e1125ba31c4$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfd87e1125ba31c4$var$Title, null, formatMessage((0, $el2W3.default).errorTitle)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfd87e1125ba31c4$var$Description, null, errorMessage, devInfoType !== (0, $8YTUU.DevInfoTypes).DESIGN && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfd87e1125ba31c4$var$StyledButton, {
        appearance: "link",
        onClick: handleLinkClick
    }, formatMessage((0, $el2W3.default).developmentErrorDescriptionCta))));
};
var $cfd87e1125ba31c4$export$2e2bcd8739ae039 = $cfd87e1125ba31c4$var$ErrorFallback;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfd87e1125ba31c4$var$Title = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});
const $cfd87e1125ba31c4$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz131l _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $cfd87e1125ba31c4$var$StyledButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf _1yxxidpf _12r2i7a9 _if291ule",
            __cmplp.className
        ])
    });
});
const $cfd87e1125ba31c4$var$Header = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _syaz131l _19pku2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dt6Va", function(module, exports) {

$parcel$export(module.exports, "useShowDevDetailDialogForPopup", () => $71478bde10e2ba46$export$cdc75a6c65207319);

var $4HJKb = parcelRequire("4HJKb");


var $dXq4S = parcelRequire("dXq4S");

var $8YTUU = parcelRequire("8YTUU");
const $71478bde10e2ba46$export$166d6c8e7de25541 = (issueAri)=>(0, $dXq4S.parseAri)(issueAri)?.resourceId;
const $71478bde10e2ba46$var$devInfoTypeToPanelDataType = (devInfoType)=>{
    if (devInfoType === (0, $8YTUU.DevInfoTypes).COMMIT) return 0, $61a2cd6236d50c20$export$2e42513c7764d5f3;
    if (devInfoType === (0, $8YTUU.DevInfoTypes).DEPLOYMENT) return 0, $61a2cd6236d50c20$export$90cac6260ae9ced5;
    return devInfoType;
};
function $71478bde10e2ba46$export$cdc75a6c65207319(scopeId) {
    const { showDevDetailDialog: showDevDetailDialog } = (0, $4HJKb.useDevOpsDetailsDialogLoaderActions)(scopeId || 'software-board.board');
    const showDevDetailDialogForPopup = (devInfoType, issueAri)=>{
        const type = $71478bde10e2ba46$var$devInfoTypeToPanelDataType(devInfoType);
        const issueId = $71478bde10e2ba46$export$166d6c8e7de25541(issueAri);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'PanelDataTypes'.
        showDevDetailDialog(type, undefined, '', issueId);
    };
    return {
        showDevDetailDialogForPopup: showDevDetailDialogForPopup
    };
}

});

parcelRegister("el2W3", function(module, exports) {

$parcel$export(module.exports, "default", () => $06bd70345536382a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $06bd70345536382a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorPopupTitle: {
        "id": "development-board-common.error-fallback.error-popup-title",
        "defaultMessage": "{devInfoType}"
    },
    errorTitle: {
        "id": "development-board-common.error-fallback.error-title",
        "defaultMessage": "Something went wrong"
    },
    errorDescription: {
        "id": "development-board-common.error-fallback.error-description",
        "defaultMessage": "For some reason we couldn't load this {devInfoType}."
    },
    developmentErrorDescriptionCta: {
        "id": "development-board-common.error-fallback.development-error-description-cta",
        "defaultMessage": "View all development information."
    },
    designErrorDescription: {
        "id": "development-board-common.error-fallback.design-error-description",
        "defaultMessage": "For some reason we couldn't load this design. Refresh your page to try again."
    }
});

});


parcelRegister("kcaDR", function(module, exports) {

$parcel$export(module.exports, "createIssueAri", () => $f1bea1631292edff$export$6b0ec881a3540845);

var $dXq4S = parcelRequire("dXq4S");
const $f1bea1631292edff$export$6b0ec881a3540845 = (cloudId, issueId)=>(0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId
    });

});

parcelRegister("7MIrF", function(module, exports) {

$parcel$export(module.exports, "DeploymentProdSuccess", () => $7a25946f9b14c935$export$8409a6d16fd5ac8e);
$parcel$export(module.exports, "DeploymentNonProdSuccess", () => $7a25946f9b14c935$export$814ebe75b826c47b);
$parcel$export(module.exports, "DeploymentProdFailed", () => $7a25946f9b14c935$export$22f2b1620b38359);
$parcel$export(module.exports, "DeploymentNonProdFailed", () => $7a25946f9b14c935$export$5b461fe0712c5c45);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $7a25946f9b14c935$export$3800ce670a7fa29b = ({ size: size, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        size: size,
        label: label,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 24 24",
                width: "24",
                height: "24",
                fill: "none"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                d: "M0 0h24v24H0z",
                fillOpacity: ".01"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
                fill: "var(--ds-icon-success, #22A06B)",
                clipRule: "evenodd",
                fillRule: "evenodd"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                d: "M7 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM4 6a3 3 0 1 1 4 2.83V20a1 1 0 1 1-2 0V8.83A3.001 3.001 0 0 1 4 6z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                d: "M7 7a1 1 0 0 1 1 1v2a7.001 7.001 0 0 0 6.188 6.953 3.001 3.001 0 1 1-.03 2.008A9.001 9.001 0 0 1 6 10V8a1 1 0 0 1 1-1zm10 10a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM20.707 4.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L16 7.586l3.293-3.293a1 1 0 0 1 1.414 0z"
            })))
    });
const $7a25946f9b14c935$export$9a767285e35d722a = ({ size: size, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        size: size,
        label: label,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 24 24",
                width: "24",
                height: "24",
                fill: "none"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                d: "M0 0h24v24H0z",
                fillOpacity: "0"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
                fill: "var(--ds-icon-danger, #C9372C)",
                clipRule: "evenodd",
                fillRule: "evenodd"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                d: "M7 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM4 6a3 3 0 1 1 4 2.8V20a1 1 0 1 1-2 0V8.8A3 3 0 0 1 4 6zM17 11c.6 0 1 .4 1 1v3.2a3 3 0 1 1-2 0V12c0-.6.4-1 1-1zm0 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM13.8 2.8a1 1 0 0 1 1.4 0L17 4.6l1.8-1.8a1 1 0 1 1 1.4 1.4L18.4 6l1.8 1.8a1 1 0 0 1-1.4 1.4L17 7.4l-1.8 1.8a1 1 0 1 1-1.4-1.4L15.6 6l-1.8-1.8a1 1 0 0 1 0-1.4z"
            })))
    });
const $7a25946f9b14c935$export$8409a6d16fd5ac8e = ({ size: size, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        size: size,
        label: label,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 16 16",
                width: "16",
                height: "16",
                fill: "none"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                d: "M0 0h16v16H0z",
                fillOpacity: ".01"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "var(--ds-icon-success, #22A06B)",
                d: "M1 9.75a3.15 3.15 0 0 0 2.8 3.13v.02h8.4v-.02a3.15 3.15 0 0 0 .533-6.155 4.902 4.902 0 0 0-9.466 0A3.151 3.151 0 0 0 1 9.75Zm5.85-1.8a.669.669 0 1 0-.946.946l1.15 1.15a.67.67 0 0 0 .946 0l2.096-2.096a.67.67 0 1 0-.946-.946L7.527 8.627 6.85 7.95Z",
                clipRule: "evenodd",
                fillRule: "evenodd"
            }))
    });
const $7a25946f9b14c935$export$814ebe75b826c47b = ({ size: size, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        size: size,
        label: label,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 16 16",
                width: "16",
                height: "16",
                fill: "none"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                d: "M0 0h16v16H0z",
                fillOpacity: "0"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("mask", {
                id: "a",
                fill: "var(--ds-icon-inverse, #FFFFFF)"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "var(--ds-icon-success, #22A06B)",
                d: "M3.8 12.9a3.2 3.2 0 0 1-.5-6.2 4.9 4.9 0 0 1 9.4 0 3.2 3.2 0 0 1-.5 6.2H3.8Z",
                clipRule: "evenodd",
                fillRule: "evenodd"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "var(--ds-icon-success, #22A06B)",
                d: "M3.8 12.9h1.5v-1.4L4 11.4l-.2 1.5Zm-.5-6.2.4 1.5.8-.3.2-.8-1.4-.4Zm9.4 0-1.4.4.2.8.8.3.4-1.5Zm-.5 6.2-.2-1.5-1.3.1V13h1.5Zm0 0v1.5h1.5v-1.5h-1.5Zm-8.4 0H2.3v1.5h1.5v-1.5Zm.2-1.5c-.9-.1-1.5-.8-1.5-1.7h-3c0 2.4 1.8 4.4 4.1 4.7l.4-3ZM2.5 9.7c0-.7.5-1.3 1.2-1.5l-.9-3C1 5.9-.5 7.7-.5 9.8h3Zm2.2-2.6A3.4 3.4 0 0 1 8 4.6v-3c-3 0-5.4 2-6.2 4.7l3 .8ZM8 4.6c1.6 0 2.9 1 3.3 2.5l2.9-.8A6.4 6.4 0 0 0 8 1.6v3Zm4.3 3.6c.7.2 1.2.8 1.2 1.5h3c0-2-1.4-3.9-3.3-4.4l-.9 2.9Zm1.2 1.5c0 .9-.6 1.6-1.5 1.7l.4 3a4.7 4.7 0 0 0 4.1-4.7h-3ZM10.7 13h3-3Zm1.5-1.5H3.8v3h8.4v-3Zm-6.9 1.5h-3 3Z",
                mask: "url(#a)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "var(--ds-icon-success, #22A06B)",
                d: "M6.8 7.9 7 8l.6.6L9 7.2a.6.6 0 1 1 .8.8L8 9.8a.6.6 0 0 1-.8 0l-1-1a.6.6 0 0 1 .6-1Z"
            }))
    });
const $7a25946f9b14c935$export$22f2b1620b38359 = ({ size: size, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        size: size,
        label: label,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 16 16",
                width: "16",
                height: "16",
                fill: "none"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                d: "M0 0h16v16H0z",
                fillOpacity: ".01"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "var(--ds-icon-danger, #C9372C)",
                d: "M3.8 12.88a3.15 3.15 0 0 1-.53-6.15 4.9 4.9 0 0 1 9.46 0 3.15 3.15 0 0 1-.53 6.15v.02H3.8v-.02Zm3.55-6.63a.75.75 0 0 1 1.5 0v2a.75.75 0 0 1-1.5 0v-2ZM8.1 9.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z",
                clipRule: "evenodd",
                fillRule: "evenodd"
            }))
    });
const $7a25946f9b14c935$export$5b461fe0712c5c45 = ({ size: size, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        size: size,
        label: label,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 16 16",
                width: "16",
                height: "16",
                fill: "none"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                d: "M0 0h16v16H0z",
                fillOpacity: "0"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("mask", {
                id: "a",
                fill: "var(--ds-icon-inverse, #FFFFFF)"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "var(--ds-icon-danger, #C9372C)",
                d: "M3.8 12.9a3.2 3.2 0 0 1-.5-6.2 4.9 4.9 0 0 1 9.4 0 3.2 3.2 0 0 1-.5 6.2H3.8Z",
                clipRule: "evenodd",
                fillRule: "evenodd"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "var(--ds-icon-danger, #C9372C)",
                d: "M3.8 12.9h1.5v-1.4L4 11.4l-.2 1.5Zm-.5-6.2.4 1.5.8-.3.2-.8-1.4-.4Zm9.4 0-1.4.4.2.8.8.3.4-1.5Zm-.5 6.2-.2-1.5-1.3.1V13h1.5Zm0 0v1.5h1.5v-1.5h-1.5Zm-8.4 0H2.3v1.5h1.5v-1.5Zm.2-1.5c-.9-.1-1.5-.8-1.5-1.7h-3c0 2.4 1.8 4.4 4.1 4.7l.4-3ZM2.5 9.7c0-.7.5-1.3 1.2-1.5l-.9-3C1 5.9-.5 7.7-.5 9.8h3Zm2.2-2.6A3.4 3.4 0 0 1 8 4.6v-3c-3 0-5.4 2-6.2 4.7l3 .8ZM8 4.6c1.6 0 2.9 1 3.3 2.5l2.9-.8A6.4 6.4 0 0 0 8 1.6v3Zm4.3 3.6c.7.2 1.2.8 1.2 1.5h3c0-2-1.4-3.9-3.3-4.4l-.9 2.9Zm1.2 1.5c0 .9-.6 1.6-1.5 1.7l.4 3a4.7 4.7 0 0 0 4.1-4.7h-3ZM10.7 13h3-3Zm1.5-1.5H3.8v3h8.4v-3Zm-6.9 1.5h-3 3Z",
                mask: "url(#a)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
                width: "1.5",
                height: "3.5",
                x: "7.4",
                y: "5.5",
                fill: "var(--ds-icon-danger, #C9372C)",
                rx: ".8"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
                width: "1.5",
                height: "1.5",
                x: "7.4",
                y: "9.5",
                fill: "var(--ds-icon-danger, #C9372C)",
                rx: ".8"
            }))
    });

});

parcelRegister("lXSZ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $bacacc98904ab4af$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $bacacc98904ab4af$var$DesignIconSVG = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "currentcolor",
        d: "M9.864 10.736c.77-.746 1.893-.536 2.72.265.826.8 1.043 1.888.273 2.634-1.816 1.76-5.482 2.002-4.765 1.207 1.587-1.76.578-2.949 1.772-4.106M19.968 4.03c.402.378-3.1 4.732-4.427 5.98-.659.62-1.012.826-1.276 1.016-.115.082-.15-.027-.177-.076a3.7 3.7 0 0 0-.63-.801c-.236-.222-.607-.445-.867-.572-.053-.025-.169-.058-.08-.166.201-.249.421-.58 1.08-1.2 1.327-1.247 5.974-4.56 6.377-4.181M18.38 19.946a1 1 0 0 1-.332.054.95.95 0 0 1-.913-.628c-.343-.957-1.14-1.642-2.257-1.933-2.182-.568-3.22-.264-5.053.995l-.16.11a9 9 0 0 1-1.049.644c-1.477.755-2.632.825-3.482.419-.586-.28-.989-.794-1.1-1.407-.254-1.403.93-2.647 2.602-3.156a.906.906 0 0 1 1.155.601.92.92 0 0 1-.62 1.186c-.33.1-.717.311-.978.533-.195.165-.33.355-.306.434.042.138.088.185.16.214.155.063.445.029.818-.096q.247-.083.524-.21c.196-.088.348-.165.58-.287.076-.04.177-.11.445-.303 1.09-.784 1.802-1.198 2.845-1.52 1.562-.482 3.18-.39 4.802.272 1.399.57 2.399 1.589 2.883 2.94.174.483-.07.97-.564 1.138"
    }));
const $bacacc98904ab4af$var$DesignIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        ...props,
        glyph: $bacacc98904ab4af$var$DesignIconSVG
    });
var $bacacc98904ab4af$export$2e2bcd8739ae039 = $bacacc98904ab4af$var$DesignIcon;

});

parcelRegister("7IEKg", function(module, exports) {

$parcel$export(module.exports, "designModalEntryPoint", () => $1a95bcb1a4c0b956$export$b98395a806b85a49);

var $69fJl = parcelRequire("69fJl");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $1a95bcb1a4c0b956$export$b98395a806b85a49 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("b751e")), {
        moduleId: "576d28f0",
        priority: "interaction"
    }),
    getPreloadProps: ({ siteAri: siteAri, issueAri: issueAri, cloudId: cloudId, designAri: designAri })=>({
            queries: {
                designModal: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $69fJl.default),
                    variables: {
                        siteAri: siteAri,
                        issueAri: issueAri,
                        cloudId: cloudId,
                        designAri: designAri
                    }
                }
            }
        })
});

});
parcelRegister("69fJl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c20e9923143cad3f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1775dc6f451f5aa08f2de993d8e993cc>>
 * @relayHash f75963656ac83b6e4f5b855b41942d4f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5455aa42cc5ba971a154b4555e76f70cb6faf70a0f41a193d62856efb789841b
const $c20e9923143cad3f$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "5455aa42cc5ba971a154b4555e76f70cb6faf70a0f41a193d62856efb789841b",
        "metadata": {},
        "name": "ui_DesignModalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $c20e9923143cad3f$export$2e2bcd8739ae039 = $c20e9923143cad3f$var$node;

});

parcelRegister("b751e", function(module, exports) {

let $81743dcfcda247f8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $81743dcfcda247f8$var$load("a5wLx").then(()=>parcelRequire('ebk7x'));

});


parcelRegister("fcSLY", function(module, exports) {

$parcel$export(module.exports, "DevInfoDetailsPopupSkeleton", () => $035c776c62f1033d$export$9044eba4855892a5);
/* DevInfoDetailsPopupSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $3MeBY = parcelRequire("3MeBY");

var $6lSRL = parcelRequire("6lSRL");

var $46wcL = parcelRequire("46wcL");

var $ifLw4 = parcelRequire("ifLw4");

var $khjtp = parcelRequire("khjtp");
// Try to keep SPA JS bundle as small as possible, skeletons should not have dependencies, so here we use hard coding instead of import gridSize
const $035c776c62f1033d$var$customCssStyles = null;
const $035c776c62f1033d$var$skeletonStyles = null;
const $035c776c62f1033d$export$ae7439e01588d047 = {
    BRANCH: 'branch',
    COMMIT: 'commit',
    PULLREQUEST: 'pullrequest',
    DEPLOYMENT: 'deployment',
    DESIGN: 'design'
};
const $035c776c62f1033d$var$skeletonAsset = {
    [$035c776c62f1033d$export$ae7439e01588d047.BRANCH]: (0, (/*@__PURE__*/$parcel$interopDefault($3MeBY))),
    [$035c776c62f1033d$export$ae7439e01588d047.COMMIT]: (0, (/*@__PURE__*/$parcel$interopDefault($6lSRL))),
    [$035c776c62f1033d$export$ae7439e01588d047.PULLREQUEST]: (0, (/*@__PURE__*/$parcel$interopDefault($khjtp))),
    [$035c776c62f1033d$export$ae7439e01588d047.DEPLOYMENT]: (0, (/*@__PURE__*/$parcel$interopDefault($46wcL))),
    [$035c776c62f1033d$export$ae7439e01588d047.DESIGN]: (0, (/*@__PURE__*/$parcel$interopDefault($ifLw4)))
};
const $035c776c62f1033d$export$9044eba4855892a5 = ({ devinfoType: devinfoType })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            devinfoType === $035c776c62f1033d$export$ae7439e01588d047.BRANCH && "_1bsbnklw _4t3i1lit _ca0qze3t _u5f3pxbi _n3tdze3t _19bvpxbi _vchhusvi",
            devinfoType === $035c776c62f1033d$export$ae7439e01588d047.COMMIT && "_1bsbnklw _4t3i1lit _ca0qze3t _u5f3pxbi _n3tdze3t _19bvpxbi _vchhusvi",
            devinfoType === $035c776c62f1033d$export$ae7439e01588d047.PULLREQUEST && "_1bsbnklw _ca0qze3t _u5f3pxbi _n3tdze3t _19bvpxbi _vchhusvi _4t3imgvx",
            devinfoType === $035c776c62f1033d$export$ae7439e01588d047.DEPLOYMENT && "_1bsbnklw _4t3i1lit",
            devinfoType === $035c776c62f1033d$export$ae7439e01588d047.DESIGN && "_1bsbnklw _4t3i1lit _ca0qze3t _u5f3pxbi _n3tdze3t _19bvpxbi _vchhusvi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: $035c776c62f1033d$var$skeletonAsset[devinfoType],
        className: (0, $bwpsq.default)([
            "_1wgmglyw _rcujmgjw"
        ])
    }));

});
parcelRegister("3MeBY", function(module, exports) {
module.exports = new URL("branch-details-popup.tpl.90980aef.svg", import.meta.url).toString();

});

parcelRegister("6lSRL", function(module, exports) {
module.exports = new URL("commit-details-popup.tpl.ef7b25c8.svg", import.meta.url).toString();

});

parcelRegister("46wcL", function(module, exports) {
module.exports = new URL("deployment-details-popup.tpl.d0e045e6.svg", import.meta.url).toString();

});

parcelRegister("ifLw4", function(module, exports) {
module.exports = new URL("design-details-popup.tpl.da785a24.svg", import.meta.url).toString();

});

parcelRegister("khjtp", function(module, exports) {
module.exports = new URL("pr-details-popup.tpl.2fd71422.svg", import.meta.url).toString();

});


parcelRegister("gicL9", function(module, exports) {

$parcel$export(module.exports, "HOVER_TIMEOUT_MS", () => $045105c41d1dfec6$export$bbec45119b804b4d);
$parcel$export(module.exports, "DevInfoButtonLabelMapping", () => $045105c41d1dfec6$export$41f3316f17440396);
$parcel$export(module.exports, "iconColor", () => $045105c41d1dfec6$export$3797a580396e3639);
$parcel$export(module.exports, "experienceDetails", () => $045105c41d1dfec6$export$ba2604b0fdde2542);
$parcel$export(module.exports, "metrics", () => $045105c41d1dfec6$export$b0c5c2fac8144e54);
$parcel$export(module.exports, "packageDetails", () => $045105c41d1dfec6$export$48b44d9f3c6e15de);
$parcel$export(module.exports, "popupEntryPointsOld", () => $045105c41d1dfec6$export$b0c175bfb49cef40);
$parcel$export(module.exports, "popupEntryPoints", () => $045105c41d1dfec6$export$1452632269dce6);
$parcel$export(module.exports, "DeploymentState", () => $045105c41d1dfec6$export$a12a01ce2571070a);
$parcel$export(module.exports, "DeploymentEnvironment", () => $045105c41d1dfec6$export$618f130aff825d2b);

var $8QpSo = parcelRequire("8QpSo");

var $4Dm5W = parcelRequire("4Dm5W");

var $6KTxo = parcelRequire("6KTxo");

var $3hvqu = parcelRequire("3hvqu");

var $8YTUU = parcelRequire("8YTUU");

var $6dYOr = parcelRequire("6dYOr");

var $jH32b = parcelRequire("jH32b");

var $890PS = parcelRequire("890PS");

var $9uXTk = parcelRequire("9uXTk");

var $4Dyci = parcelRequire("4Dyci");

var $8GnxT = parcelRequire("8GnxT");
const $045105c41d1dfec6$export$bbec45119b804b4d = 300;
const $045105c41d1dfec6$export$41f3316f17440396 = (0, $8QpSo.default)((formatMessage)=>({
        [(0, $8YTUU.DevInfoTypes).BRANCH]: formatMessage((0, $4Dyci.default).branchIconButtonLabel),
        [(0, $8YTUU.DevInfoTypes).COMMIT]: formatMessage((0, $4Dyci.default).commitIconButtonLabel),
        [(0, $8YTUU.DevInfoTypes).PULLREQUEST]: formatMessage((0, $4Dyci.default).pullRequestIconButtonLabel),
        [(0, $8YTUU.DevInfoTypes).MERGED]: formatMessage((0, $4Dyci.default).pullRequestIconButtonLabel),
        [(0, $8YTUU.DevInfoTypes).DECLINED]: formatMessage((0, $4Dyci.default).pullRequestIconButtonLabel),
        [(0, $8YTUU.DevInfoTypes).DEPLOYMENT]: formatMessage((0, $4Dyci.default).deploymentIconButtonLabel),
        [(0, $8YTUU.DevInfoTypes).DESIGN]: formatMessage((0, $4Dyci.default).designIconButtonLabel)
    }));
const $045105c41d1dfec6$export$3797a580396e3639 = {
    [(0, $8YTUU.DevInfoTypes).BRANCH]: {
        [(0, $8YTUU.ButtonStatus).ACTIVE]: "var(--ds-icon-inverse, #FFFFFF)",
        [(0, $8YTUU.ButtonStatus).HOVER]: "var(--ds-icon-subtle, #626F86)",
        [(0, $8YTUU.ButtonStatus).DEFAULT]: "var(--ds-icon-subtle, #626F86)"
    },
    [(0, $8YTUU.DevInfoTypes).COMMIT]: {
        [(0, $8YTUU.ButtonStatus).ACTIVE]: "var(--ds-icon-inverse, #FFFFFF)",
        [(0, $8YTUU.ButtonStatus).HOVER]: "var(--ds-icon-subtle, #626F86)",
        [(0, $8YTUU.ButtonStatus).DEFAULT]: "var(--ds-icon-subtle, #626F86)"
    },
    [(0, $8YTUU.DevInfoTypes).PULLREQUEST]: {
        [(0, $8YTUU.ButtonStatus).ACTIVE]: "var(--ds-icon-inverse, #FFFFFF)",
        [(0, $8YTUU.ButtonStatus).HOVER]: "var(--ds-icon-subtle, #626F86)",
        [(0, $8YTUU.ButtonStatus).DEFAULT]: "var(--ds-icon-subtle, #626F86)"
    },
    [(0, $8YTUU.DevInfoTypes).MERGED]: {
        [(0, $8YTUU.ButtonStatus).ACTIVE]: "var(--ds-icon-success, #22A06B)",
        [(0, $8YTUU.ButtonStatus).HOVER]: "var(--ds-icon-success, #22A06B)",
        [(0, $8YTUU.ButtonStatus).DEFAULT]: "var(--ds-icon-success, #22A06B)"
    },
    [(0, $8YTUU.DevInfoTypes).DECLINED]: {
        [(0, $8YTUU.ButtonStatus).ACTIVE]: "var(--ds-icon-danger, #C9372C)",
        [(0, $8YTUU.ButtonStatus).HOVER]: "var(--ds-icon-danger, #C9372C)",
        [(0, $8YTUU.ButtonStatus).DEFAULT]: "var(--ds-icon-danger, #C9372C)"
    },
    [(0, $8YTUU.DevInfoTypes).DEPLOYMENT]: {
        [(0, $8YTUU.ButtonStatus).ACTIVE]: "var(--ds-icon-inverse, #FFFFFF)",
        [(0, $8YTUU.ButtonStatus).HOVER]: "var(--ds-icon-subtle, #626F86)",
        [(0, $8YTUU.ButtonStatus).DEFAULT]: "var(--ds-icon-subtle, #626F86)"
    },
    [(0, $8YTUU.DevInfoTypes).DESIGN]: {
        [(0, $8YTUU.ButtonStatus).ACTIVE]: "var(--ds-icon-inverse, #FFFFFF)",
        [(0, $8YTUU.ButtonStatus).HOVER]: "var(--ds-icon-subtle, #626F86)",
        [(0, $8YTUU.ButtonStatus).DEFAULT]: "var(--ds-icon-subtle, #626F86)"
    }
};
const $045105c41d1dfec6$export$ba2604b0fdde2542 = {
    [(0, $8YTUU.DevInfoTypes).BRANCH]: {
        id: 'branchDetailsPopup',
        name: 'jiraSoftwareBoardBranchDetailsPopup'
    },
    [(0, $8YTUU.DevInfoTypes).COMMIT]: {
        id: 'commitDetailsPopup',
        name: 'jiraSoftwareBoardCommitDetailsPopup'
    },
    [(0, $8YTUU.DevInfoTypes).DEPLOYMENT]: {
        id: 'deploymentDetailsPopup',
        name: 'jiraSoftwareBoardDeploymentDetailsPopup'
    },
    [(0, $8YTUU.DevInfoTypes).PULLREQUEST]: {
        id: 'prDetailsPopup',
        name: 'jiraSoftwareBoardPrDetailsPopup'
    },
    [(0, $8YTUU.DevInfoTypes).DESIGN]: {
        id: 'designDetailsPopup',
        name: 'jiraSoftwareBoardDesignDetailsPopup'
    }
};
const $045105c41d1dfec6$export$b0c5c2fac8144e54 = {
    [(0, $8YTUU.DevInfoTypes).BRANCH]: (0, $8GnxT.branchDetailsPopupLoad),
    [(0, $8YTUU.DevInfoTypes).COMMIT]: (0, $8GnxT.commitDetailsPopupLoad),
    [(0, $8YTUU.DevInfoTypes).DEPLOYMENT]: (0, $8GnxT.deploymentDetailsPopupLoad),
    [(0, $8YTUU.DevInfoTypes).PULLREQUEST]: (0, $8GnxT.prDetailsPopupLoad),
    [(0, $8YTUU.DevInfoTypes).DESIGN]: (0, $8GnxT.designDetailsPopupLoad)
};
const $045105c41d1dfec6$export$48b44d9f3c6e15de = {
    [(0, $8YTUU.DevInfoTypes).BRANCH]: {
        id: 'renderBranchDetailsPopup',
        packageName: 'jiraDevelopmentBoardBranchDetailsPopup',
        teamName: 'nova'
    },
    [(0, $8YTUU.DevInfoTypes).COMMIT]: {
        id: 'renderCommitDetailsPopup',
        packageName: 'jiraDevelopmentBoardCommitDetailsPopup',
        teamName: 'nova'
    },
    [(0, $8YTUU.DevInfoTypes).DEPLOYMENT]: {
        id: 'renderDeploymentDetailsPopup',
        packageName: 'jiraDevelopmentBoardDeploymentDetailsPopup',
        teamName: 'nova'
    },
    [(0, $8YTUU.DevInfoTypes).PULLREQUEST]: {
        id: 'renderPRDetailsPopup',
        packageName: 'jiraDevelopmentBoardPrDetailsPopup',
        teamName: 'nova'
    },
    [(0, $8YTUU.DevInfoTypes).DESIGN]: {
        id: 'renderDesignDetailsPopup',
        packageName: 'jiraDevelopmentBoardDesignDetailsPopup',
        teamName: 'helios-headcoach'
    }
};
const $045105c41d1dfec6$export$b0c175bfb49cef40 = {
    [(0, $8YTUU.DevInfoTypes).BRANCH]: (0, $4Dm5W.branchDetailsEntryPoint),
    [(0, $8YTUU.DevInfoTypes).COMMIT]: (0, $6KTxo.commitDetailsEntryPoint),
    [(0, $8YTUU.DevInfoTypes).DEPLOYMENT]: (0, $6dYOr.deploymentDetailsEntryPoint),
    [(0, $8YTUU.DevInfoTypes).PULLREQUEST]: (0, $890PS.pullRequestDetailsEntryPoint),
    [(0, $8YTUU.DevInfoTypes).DESIGN]: (0, $jH32b.designDetailsEntryPoint)
};
const $045105c41d1dfec6$export$1452632269dce6 = {
    [(0, $8YTUU.DevInfoTypes).BRANCH]: (0, $4Dm5W.branchDetailsEntryPoint),
    [(0, $8YTUU.DevInfoTypes).COMMIT]: (0, $3hvqu.commitDetailsEntryPoint),
    [(0, $8YTUU.DevInfoTypes).DEPLOYMENT]: (0, $6dYOr.deploymentDetailsEntryPoint),
    [(0, $8YTUU.DevInfoTypes).PULLREQUEST]: (0, $9uXTk.pullRequestDetailsNewEntryPoint),
    [(0, $8YTUU.DevInfoTypes).DESIGN]: (0, $jH32b.designDetailsEntryPoint)
};
const $045105c41d1dfec6$export$a12a01ce2571070a = Object.freeze({
    SUCCESSFUL: 'SUCCESSFUL',
    FAILED: 'FAILED'
});
const $045105c41d1dfec6$export$618f130aff825d2b = Object.freeze({
    PRODUCTION: 'PRODUCTION',
    STAGING: 'STAGING',
    TESTING: 'TESTING'
});

});
parcelRegister("4Dm5W", function(module, exports) {

$parcel$export(module.exports, "branchDetailsEntryPoint", () => $36e1f5ea1b2544c9$export$4e1fb223e6b994ad);

var $8lY7K = parcelRequire("8lY7K");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $36e1f5ea1b2544c9$export$4e1fb223e6b994ad = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("ipjUl")), {
        moduleId: "24c6676c",
        priority: "interaction"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                branchDetailsForIssue: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $8lY7K.default,
                    variables: {
                        issueId: issueId
                    }
                }
            }
        })
});

});
parcelRegister("8lY7K", function(module, exports) {

$parcel$export(module.exports, "default", () => $1485287fd69790ca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<53221fefa0f4443cf65a4215c479359b>>
 * @relayHash 369bf10bb8009c658a35cf0bdf685efa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 50d8c5a327ce393f92430f04532d211b7f0cc460a938b554e063e4a413b3c9b6
const $1485287fd69790ca$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "50d8c5a327ce393f92430f04532d211b7f0cc460a938b554e063e4a413b3c9b6",
        "metadata": {},
        "name": "mainJiraBoardFetchBranchDetailsForIssueQuery",
        "operationKind": "query",
        "text": null
    }
};
var $1485287fd69790ca$export$2e2bcd8739ae039 = $1485287fd69790ca$var$node;

});

parcelRegister("ipjUl", function(module, exports) {

let $d66a01121c677158$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d66a01121c677158$var$load("lcY00").then(()=>parcelRequire('93XNc'));

});


parcelRegister("6KTxo", function(module, exports) {

$parcel$export(module.exports, "commitDetailsEntryPoint", () => $9842290edc643ca7$export$543707906869c79b);

var $kmK4e = parcelRequire("kmK4e");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $9842290edc643ca7$export$543707906869c79b = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("bdUYl")), {
        moduleId: "c43c4a0f",
        priority: "interaction"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                commitDetailsForIssue: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $kmK4e.default,
                    variables: {
                        issueId: issueId
                    }
                }
            }
        })
});

});
parcelRegister("kmK4e", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1a92de7c94d3b0d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1084bead4ae00878b2af2c8348929c25>>
 * @relayHash eed264a6d119fbca146eb1de817b2b96
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ca7f0754b23691dc5194f86cd173cbad109ceb27dcdfea5465741efb60afa5b
const $e1a92de7c94d3b0d$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "2ca7f0754b23691dc5194f86cd173cbad109ceb27dcdfea5465741efb60afa5b",
        "metadata": {},
        "name": "mainJiraBoardFetchCommitDetailsForIssueQuery",
        "operationKind": "query",
        "text": null
    }
};
var $e1a92de7c94d3b0d$export$2e2bcd8739ae039 = $e1a92de7c94d3b0d$var$node;

});

parcelRegister("bdUYl", function(module, exports) {

let $82bd1a2348ffaf0f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $82bd1a2348ffaf0f$var$load("dROov").then(()=>parcelRequire('1ml2E'));

});


parcelRegister("3hvqu", function(module, exports) {

$parcel$export(module.exports, "commitDetailsEntryPoint", () => $eb416bd814d5c7db$export$543707906869c79b);

var $55jVB = parcelRequire("55jVB");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $eb416bd814d5c7db$export$543707906869c79b = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>{
        return (parcelRequire("3lN7C"));
    }, {
        moduleId: "0fd7704f",
        priority: "interaction"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                commitDetailsForIssue: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $55jVB.default,
                    variables: {
                        issueId: issueId
                    }
                }
            }
        })
});

});
parcelRegister("55jVB", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bf6fd3aa3b2a323$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<785c2d82d9f38c4de1810640349645d2>>
 * @relayHash 4cc392b55aea773edf2693da62b6c34d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 06414d2bbafd5a173cca709236f01be6ed95853bfc16b105fbbd9d9cf12ffc22
const $4bf6fd3aa3b2a323$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "06414d2bbafd5a173cca709236f01be6ed95853bfc16b105fbbd9d9cf12ffc22",
        "metadata": {},
        "name": "mainNewUgsJiraBoardFetchCommitDetailsForIssueQuery",
        "operationKind": "query",
        "text": null
    }
};
var $4bf6fd3aa3b2a323$export$2e2bcd8739ae039 = $4bf6fd3aa3b2a323$var$node;

});

parcelRegister("3lN7C", function(module, exports) {

let $27096fdec0a2942a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $27096fdec0a2942a$var$load("c6ie4").then(()=>parcelRequire('b4rDw'));

});


parcelRegister("6dYOr", function(module, exports) {

$parcel$export(module.exports, "deploymentDetailsEntryPoint", () => $f735f9faccd14399$export$bb44df517ead129f);

var $k022a = parcelRequire("k022a");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $f735f9faccd14399$export$bb44df517ead129f = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("g56zb")), {
        moduleId: "12f43749",
        priority: "interaction"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                deployments: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $k022a.default,
                    variables: {
                        issueAris: [
                            issueId
                        ]
                    }
                }
            }
        })
});

});
parcelRegister("k022a", function(module, exports) {

$parcel$export(module.exports, "default", () => $efb931bb8db9b600$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ae0585790b98faa6f42e78cd820a35d3>>
 * @relayHash 14ad3dca732756dca6246ef351d7319c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7c7de3e7f6623bcc94de30375e35240729aa179a60490aef983d5b1350f9cd75
const $efb931bb8db9b600$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "7c7de3e7f6623bcc94de30375e35240729aa179a60490aef983d5b1350f9cd75",
        "metadata": {},
        "name": "uiDevOpsBoardQuery",
        "operationKind": "query",
        "text": null
    }
};
var $efb931bb8db9b600$export$2e2bcd8739ae039 = $efb931bb8db9b600$var$node;

});

parcelRegister("g56zb", function(module, exports) {

let $bb5234f14bef38f6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bb5234f14bef38f6$var$load("bUzCQ").then(()=>parcelRequire('asD4H'));

});


parcelRegister("jH32b", function(module, exports) {

$parcel$export(module.exports, "designDetailsEntryPoint", () => $4f00e6184ecff192$export$9b838851ea165d28);

var $cN09Q = parcelRequire("cN09Q");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $4f00e6184ecff192$export$9b838851ea165d28 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("gNfHg")), {
        moduleId: "b9d22806",
        priority: "interaction"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                designDetailsPopup: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $cN09Q.default,
                    variables: {
                        issueAri: issueId
                    }
                }
            }
        })
});

});
parcelRegister("cN09Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $37545b8a0156af47$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5b69286dc3d574c4254b644a20345969>>
 * @relayHash 19dd9f9578703995725a17532527b663
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f1f10befcdb537dd4ab4ac9c44e5edcb51d6b3f4306fd285cc82de529ebae8db
const $37545b8a0156af47$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "f1f10befcdb537dd4ab4ac9c44e5edcb51d6b3f4306fd285cc82de529ebae8db",
        "metadata": {},
        "name": "uiDesignDetailsPopupQuery",
        "operationKind": "query",
        "text": null
    }
};
var $37545b8a0156af47$export$2e2bcd8739ae039 = $37545b8a0156af47$var$node;

});

parcelRegister("gNfHg", function(module, exports) {

let $c39d6606de9ea3e8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c39d6606de9ea3e8$var$load("6FreV").then(()=>parcelRequire('9bEVC'));

});


parcelRegister("890PS", function(module, exports) {

$parcel$export(module.exports, "pullRequestDetailsEntryPoint", () => $0896cca9b8d893af$export$37ab544e7066c095);

var $5E8Mw = parcelRequire("5E8Mw");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $0896cca9b8d893af$export$37ab544e7066c095 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("aZi5Z")), {
        moduleId: "1b74db53",
        priority: "interaction"
    }),
    getPreloadProps: ({ issueId: issueId, isNetworkOnly: isNetworkOnly = false })=>({
            queries: {
                pullRequestDetailsForIssue: {
                    options: {
                        fetchPolicy: isNetworkOnly ? 'network-only' : 'store-and-network'
                    },
                    parameters: $5E8Mw.default,
                    variables: {
                        issueId: issueId
                    }
                }
            }
        })
});

});
parcelRegister("5E8Mw", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a4d40ac042e33e2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e18ba82933463bea77a039cb31341c83>>
 * @relayHash ec62760f3d36372780325706797b1fb2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 91484d5c2ad4c1c580a3b56066bfe36c5fe9798b2804e958c3c96ecd098886b0
const $6a4d40ac042e33e2$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "91484d5c2ad4c1c580a3b56066bfe36c5fe9798b2804e958c3c96ecd098886b0",
        "metadata": {},
        "name": "mainJiraBoardFetchPullRequestDetailsForIssueQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6a4d40ac042e33e2$export$2e2bcd8739ae039 = $6a4d40ac042e33e2$var$node;

});

parcelRegister("aZi5Z", function(module, exports) {

let $7ffda351df524733$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7ffda351df524733$var$load("aefuM").then(()=>parcelRequire('cnLAn'));

});


parcelRegister("9uXTk", function(module, exports) {

$parcel$export(module.exports, "pullRequestDetailsNewEntryPoint", () => $f1f5d4b249d73354$export$464b40a8e325de45);

var $93mZL = parcelRequire("93mZL");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $f1f5d4b249d73354$export$464b40a8e325de45 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("8AyHT")), {
        moduleId: "bea6593f",
        priority: "interaction"
    }),
    getPreloadProps: ({ issueId: issueId, isNetworkOnly: isNetworkOnly = false })=>({
            queries: {
                pullRequestDetailsForIssue: {
                    options: {
                        fetchPolicy: isNetworkOnly ? 'network-only' : 'store-and-network'
                    },
                    parameters: $93mZL.default,
                    variables: {
                        issueId: issueId
                    }
                }
            }
        })
});

});
parcelRegister("93mZL", function(module, exports) {

$parcel$export(module.exports, "default", () => $8857fd946ffc629c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e08ea7a2125f85e9825d1d1f9b2e1a30>>
 * @relayHash a2cb913fc3c86df01d3e338fd395a936
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9c887506aa51fd06a04e1b86d8650b40da5f2a17132f183e7ff6bd7479fd63fe
const $8857fd946ffc629c$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "9c887506aa51fd06a04e1b86d8650b40da5f2a17132f183e7ff6bd7479fd63fe",
        "metadata": {},
        "name": "uiJiraBoardFetchPullRequestDetailsForIssueNewQuery",
        "operationKind": "query",
        "text": null
    }
};
var $8857fd946ffc629c$export$2e2bcd8739ae039 = $8857fd946ffc629c$var$node;

});

parcelRegister("8AyHT", function(module, exports) {

let $640c9b949115edd0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $640c9b949115edd0$var$load("9zcad").then(()=>parcelRequire('lfdea'));

});


parcelRegister("4Dyci", function(module, exports) {

$parcel$export(module.exports, "default", () => $436dc0db7ef24cd0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $436dc0db7ef24cd0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    branchIconLabel: {
        "id": "development-board-dev-info-icon.branch-icon-label",
        "defaultMessage": "branch"
    },
    commitIconLabel: {
        "id": "development-board-dev-info-icon.commit-icon-label",
        "defaultMessage": "commit"
    },
    designIconLabel: {
        "id": "development-board-dev-info-icon.design-icon-label",
        "defaultMessage": "Linked design data"
    },
    deploymentIconLabel: {
        "id": "development-board-dev-info-icon.deployment-icon-label",
        "defaultMessage": "Linked deployment data."
    },
    deploymentProductionSuccessIconLabel: {
        "id": "development-board-dev-info-icon.deployment-production-success-icon-label",
        "defaultMessage": "Successful deployment to production."
    },
    deploymentProductionFailedIconLabel: {
        "id": "development-board-dev-info-icon.deployment-production-failed-icon-label",
        "defaultMessage": "Failed deployment to production."
    },
    deploymentNonProductionSuccessIconLabel: {
        "id": "development-board-dev-info-icon.deployment-non-production-success-icon-label",
        "defaultMessage": "Successful deployment to non-production environment."
    },
    deploymentNonProductionFailedIconLabel: {
        "id": "development-board-dev-info-icon.deployment-non-production-failed-icon-label",
        "defaultMessage": "Failed deployment to non-production environment."
    },
    openPullRequestIconLabel: {
        "id": "development-board-dev-info-icon.open-pull-request-icon-label",
        "defaultMessage": "pull request"
    },
    mergedPullRequestIconLabel: {
        "id": "development-board-dev-info-icon.merged-pull-request-icon-label",
        "defaultMessage": "merged pull request"
    },
    declinedPullRequestIconLabel: {
        "id": "development-board-dev-info-icon.declined-pull-request-icon-label",
        "defaultMessage": "declined pull request"
    },
    branchIconButtonLabel: {
        "id": "development-board-dev-info-icon.branch-icon-button-label",
        "defaultMessage": "Select to open branch details."
    },
    commitIconButtonLabel: {
        "id": "development-board-dev-info-icon.commit-icon-button-label",
        "defaultMessage": "Select to open commit details."
    },
    pullRequestIconButtonLabel: {
        "id": "development-board-dev-info-icon.pull-request-icon-button-label",
        "defaultMessage": "Select to open pull request details."
    },
    deploymentIconButtonLabel: {
        "id": "development-board-dev-info-icon.deployment-icon-button-label",
        "defaultMessage": "Select to open deployment details."
    },
    designIconButtonLabel: {
        "id": "development-board-dev-info-icon.design-icon-button-label",
        "defaultMessage": "Select to open design details."
    }
});

});

parcelRegister("8GnxT", function(module, exports) {

$parcel$export(module.exports, "branchDetailsPopupLoad", () => $a8d6a72aae83d56f$export$1e45f095e94fd8a);
$parcel$export(module.exports, "commitDetailsPopupLoad", () => $a8d6a72aae83d56f$export$e3af05dcf8f03d06);
$parcel$export(module.exports, "deploymentDetailsPopupLoad", () => $a8d6a72aae83d56f$export$205c7cad3de97a2);
$parcel$export(module.exports, "prDetailsPopupLoad", () => $a8d6a72aae83d56f$export$3ca761127f6f2822);
$parcel$export(module.exports, "designDetailsPopupLoad", () => $a8d6a72aae83d56f$export$935f70f8029ab734);

var $dGrdR = parcelRequire("dGrdR");
const $a8d6a72aae83d56f$export$1e45f095e94fd8a = (0, $dGrdR.metrics).interaction({
    key: 'board.branch-details-popup-load'
});
const $a8d6a72aae83d56f$export$e3af05dcf8f03d06 = (0, $dGrdR.metrics).interaction({
    key: 'board.commit-details-popup-load'
});
const $a8d6a72aae83d56f$export$205c7cad3de97a2 = (0, $dGrdR.metrics).interaction({
    key: 'board.deployment-details-popup-load'
});
const $a8d6a72aae83d56f$export$3ca761127f6f2822 = (0, $dGrdR.metrics).interaction({
    key: 'board.pr-details-popup-load'
});
const $a8d6a72aae83d56f$export$935f70f8029ab734 = (0, $dGrdR.metrics).interaction({
    key: 'board.design-details-popup-load'
});

});



parcelRegister("4ttab", function(module, exports) {

$parcel$export(module.exports, "BambooDeploymentData", () => $7ad950bf4034d187$export$d73f8a5da425a8c5);

var $6IhIi = parcelRequire("6IhIi");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");

var $c2i4s = parcelRequire("c2i4s");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $bIVgi = parcelRequire("bIVgi");
const $7ad950bf4034d187$var$MAX_DISPLAYED_ENVIRONMENTS = 3;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7ad950bf4034d187$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $7ad950bf4034d187$export$d73f8a5da425a8c5 = ({ jiraIssueDevSummary: jiraIssueDevSummary, onDeploymentClicked: onDeploymentClicked })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const data = (0, $8Uumt.useFragment)((0, $6IhIi.default), jiraIssueDevSummary);
    const deployedBuilds = (data.deploymentEnvironments.overall.topEnvironments ?? []).filter((deployment)=>deployment.status === 'DEPLOYED');
    const environments = deployedBuilds.filter((environment)=>environment).map((environment)=>environment.title);
    const displayedEnvironments = environments.slice(0, $7ad950bf4034d187$var$MAX_DISPLAYED_ENVIRONMENTS).join(', ');
    const remainingEnvironments = environments.length > $7ad950bf4034d187$var$MAX_DISPLAYED_ENVIRONMENTS ? deployedBuilds.length - $7ad950bf4034d187$var$MAX_DISPLAYED_ENVIRONMENTS : null;
    return deployedBuilds.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7ad950bf4034d187$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        spacing: "compact",
        appearance: "subtle-link",
        onClick: (_, analyticsEvent)=>{
            onDeploymentClicked();
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'bambooSummaryCell');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $bIVgi.default).deployedEnvironments, {
            hasHiddenEnvironments: !!remainingEnvironments,
            displayedEnvironments: displayedEnvironments,
            othersCount: remainingEnvironments ?? 0
        }),
        onShow: (analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'bambooSummaryTooltip');
        },
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
        LEGACY_size: "medium",
        spacing: "spacious",
        label: formatMessage((0, $bIVgi.default).bambooDeploymentIcon),
        color: "var(--ds-icon-success, #22A06B)"
    })))) : null;
};

});
parcelRegister("6IhIi", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f620d35ae0594d0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e0b19c688784554a1b0ae24dca989610>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0f620d35ae0594d0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "bambooDeploymentData_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                "kind": "LinkedField",
                "name": "deploymentEnvironments",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                            "kind": "LinkedField",
                            "name": "overall",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "JiraIssueDeploymentEnvironment",
                                        "kind": "LinkedField",
                                        "name": "topEnvironments",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "ScalarField",
                                                    "name": "status"
                                                },
                                                "action": "THROW",
                                                "path": "deploymentEnvironments.overall.topEnvironments.status"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "title"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "deploymentEnvironments.overall.topEnvironments"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "deploymentEnvironments.overall"
                    }
                ]
            },
            "action": "THROW",
            "path": "deploymentEnvironments"
        }
    ],
    "type": "JiraIssueDevSummary"
};
$0f620d35ae0594d0$var$node.hash = "f1dd87aba73205d2eb34f56156e152c9";
var $0f620d35ae0594d0$export$2e2bcd8739ae039 = $0f620d35ae0594d0$var$node;

});

parcelRegister("bIVgi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea545e3a7ecdbfcf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ea545e3a7ecdbfcf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    bambooDeploymentIcon: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.bamboo-deployment-data.bamboo-deployment-icon",
        "defaultMessage": "Bamboo deployment icon"
    },
    deployedEnvironments: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.bamboo-deployment-data.deployed-environments",
        "defaultMessage": "{hasHiddenEnvironments, select, false {Deployed to {displayedEnvironments}} other {Deployed to {displayedEnvironments} and {othersCount, number} {othersCount, plural, one {other} other {others}}}}"
    }
});

});


parcelRegister("aEu2z", function(module, exports) {

$parcel$export(module.exports, "BuildData", () => $cf9c8b4d8385b371$export$c35480212824a8c6);

var $kvOAm = parcelRequire("kvOAm");

var $ekgtZ = parcelRequire("ekgtZ");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");

var $c2i4s = parcelRequire("c2i4s");

var $kxFlx = parcelRequire("kxFlx");

var $dg0Fl = parcelRequire("dg0Fl");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $ifjZR = parcelRequire("ifjZR");
const $cf9c8b4d8385b371$export$be58b4326e23250f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $cf9c8b4d8385b371$export$c35480212824a8c6 = ({ jiraIssueDevSummary: jiraIssueDevSummary, devOpsSummarisedBuilds: devOpsSummarisedBuilds, onBuildClicked: onBuildClicked })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const appLinkBuildData = (0, $8Uumt.useFragment)((0, $ekgtZ.default), jiraIssueDevSummary);
    const nonAppLinkBuildData = (0, $8Uumt.useFragment)((0, $kvOAm.default), devOpsSummarisedBuilds ?? null);
    const { failedBuildCount: failedBuildCountAppLink, successfulBuildCount: successfulBuildCountAppLink, unknownBuildCount: unknownBuildCountAppLink } = appLinkBuildData.build.overall;
    const buildStates = nonAppLinkBuildData?.buildStates ?? [];
    const failedBuildCountNonAppLink = buildStates.find((buildState)=>buildState?.state === 'FAILED')?.count ?? 0;
    const successfulBuildCountNonAppLink = buildStates.find((buildState)=>buildState?.state === 'SUCCESSFUL')?.count ?? 0;
    const unknownBuildCountNonAppLink = buildStates.find((buildState)=>buildState?.state === 'UNKNOWN')?.count ?? 0;
    const failedBuildCount = failedBuildCountAppLink + failedBuildCountNonAppLink;
    const successfulBuildCount = successfulBuildCountAppLink + successfulBuildCountNonAppLink;
    const unknownBuildCount = unknownBuildCountAppLink + unknownBuildCountNonAppLink;
    const hasBuilds = failedBuildCount + successfulBuildCount + unknownBuildCount > 0;
    const renderIcon = ()=>{
        if (failedBuildCount > 0) {
            const failedBuildMessage = formatMessage((0, $ifjZR.default).failedBuild, {
                buildCount: failedBuildCount
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: failedBuildMessage
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kxFlx))), {
                LEGACY_size: "medium",
                spacing: "spacious",
                label: failedBuildMessage,
                color: "var(--ds-icon-danger, #C9372C)"
            }));
        }
        if (successfulBuildCount > 0) {
            const successfulBuildMessage = formatMessage((0, $ifjZR.default).successfulBuild, {
                buildCount: successfulBuildCount
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: successfulBuildMessage
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
                LEGACY_size: "medium",
                spacing: "spacious",
                label: successfulBuildMessage,
                color: "var(--ds-icon-success, #22A06B)"
            }));
        }
        if (unknownBuildCount > 0) {
            const unknownBuildMessage = formatMessage((0, $ifjZR.default).unknownBuild, {
                buildCount: unknownBuildCount
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: unknownBuildMessage
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))), {
                LEGACY_size: "medium",
                spacing: "spacious",
                label: unknownBuildMessage,
                color: "var(--ds-icon-warning, #E56910)"
            }));
        }
        return null;
    };
    return hasBuilds ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cf9c8b4d8385b371$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        spacing: "none",
        appearance: "subtle-link",
        onClick: (_, analyticsEvent)=>{
            onBuildClicked();
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'versionsBuildsLozenge');
        }
    }, renderIcon())) : null;
};

});
parcelRegister("kvOAm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d83768d9b8777867$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c29b101cc868f9fea8432c1a43a162ce>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d83768d9b8777867$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "buildData_softwareReleasesVersionDetailIssueList_devOpsSummarisedBuilds",
    "selections": [
        {
            "concreteType": "DevOpsSummarisedBuildState",
            "kind": "LinkedField",
            "name": "buildStates",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "state"
                },
                {
                    "kind": "ScalarField",
                    "name": "count"
                }
            ]
        }
    ],
    "type": "DevOpsSummarisedBuilds"
};
$d83768d9b8777867$var$node.hash = "dd56ce5fd7d57ba00bf945a310710b23";
var $d83768d9b8777867$export$2e2bcd8739ae039 = $d83768d9b8777867$var$node;

});

parcelRegister("ekgtZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fac064913ac614a7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<02f164da7183161ef2a4218fc267af7d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fac064913ac614a7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "buildData_softwareReleasesVersionDetailIssueList_jiraIssueDevSummary",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraIssueBuildDevSummaryContainer",
                "kind": "LinkedField",
                "name": "build",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraIssueBuildDevSummary",
                            "kind": "LinkedField",
                            "name": "overall",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "failedBuildCount"
                                    },
                                    "action": "THROW",
                                    "path": "build.overall.failedBuildCount"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "successfulBuildCount"
                                    },
                                    "action": "THROW",
                                    "path": "build.overall.successfulBuildCount"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "unknownBuildCount"
                                    },
                                    "action": "THROW",
                                    "path": "build.overall.unknownBuildCount"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "build.overall"
                    }
                ]
            },
            "action": "THROW",
            "path": "build"
        }
    ],
    "type": "JiraIssueDevSummary"
};
$fac064913ac614a7$var$node.hash = "51c2585ef90bb27a6d71bf4d7670a32b";
var $fac064913ac614a7$export$2e2bcd8739ae039 = $fac064913ac614a7$var$node;

});

parcelRegister("ifjZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b346816c77ac1fc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0b346816c77ac1fc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    successfulBuild: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.build-data.successful-build",
        "defaultMessage": "{buildCount} successful {buildCount, plural, one {build} other {builds}}"
    },
    failedBuild: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.build-data.failed-build",
        "defaultMessage": "{buildCount} failed {buildCount, plural, one {build} other {builds}}"
    },
    unknownBuild: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.build-data.unknown-build",
        "defaultMessage": "{buildCount} unknown state {buildCount, plural, one {build} other {builds}}"
    }
});

});


parcelRegister("916hF", function(module, exports) {

$parcel$export(module.exports, "DeploymentData", () => $da9b384ac1708a2f$export$b2b8032dce325acb);

var $jL3EI = parcelRequire("jL3EI");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $5gD09 = parcelRequire("5gD09");

var $lSCyP = parcelRequire("lSCyP");

var $lfyVj = parcelRequire("lfyVj");
const $da9b384ac1708a2f$var$mapEnvironmentCategory = (category, formatMessage)=>{
    switch(category){
        case 'PRODUCTION':
            return formatMessage((0, $lSCyP.default).production);
        case 'STAGING':
            return formatMessage((0, $lSCyP.default).staging);
        case 'TESTING':
            return formatMessage((0, $lSCyP.default).testing);
        case 'DEVELOPMENT':
            return formatMessage((0, $lSCyP.default).development);
        case 'UNMAPPED':
            return formatMessage((0, $lSCyP.default).unmapped);
        default:
            return formatMessage((0, $lSCyP.default).unmapped);
    }
};
const $da9b384ac1708a2f$var$mapState = (state, formatMessage)=>{
    switch(state){
        case (0, $5gD09.DeploymentStateOptions).PENDING:
            return formatMessage((0, $lSCyP.default).pending);
        case (0, $5gD09.DeploymentStateOptions).IN_PROGRESS:
            return formatMessage((0, $lSCyP.default).inProgress);
        case (0, $5gD09.DeploymentStateOptions).SUCCESSFUL:
            return formatMessage((0, $lSCyP.default).successful);
        case (0, $5gD09.DeploymentStateOptions).FAILED:
            return formatMessage((0, $lSCyP.default).failed);
        case (0, $5gD09.DeploymentStateOptions).ROLLED_BACK:
            return formatMessage((0, $lSCyP.default).rolledBack);
        case (0, $5gD09.DeploymentStateOptions).CANCELLED:
            return formatMessage((0, $lSCyP.default).cancelled);
        default:
            return formatMessage((0, $lSCyP.default).unknown);
    }
};
const $da9b384ac1708a2f$export$b2b8032dce325acb = ({ onDeploymentClicked: onDeploymentClicked, jiraIssueDevOpsSummarisedEntities: jiraIssueSummarisedEntities })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { summarisedDeployments: summarisedDeployments } = (0, $8Uumt.useFragment)((0, $jL3EI.default), jiraIssueSummarisedEntities);
    // If null, there is nothing to display
    if (summarisedDeployments == null) return null; // Same logic as <StatusIcon/> component that falls back to Unknown if null
    const category = summarisedDeployments.deploymentEnvironment?.category ? summarisedDeployments.deploymentEnvironment.category : 'UNMAPPED';
    const state = summarisedDeployments.deploymentState ? summarisedDeployments.deploymentState : 'UNKNOWN';
    const environmentCategory = $da9b384ac1708a2f$var$mapEnvironmentCategory(category, formatMessage);
    const deploymentState = $da9b384ac1708a2f$var$mapState(state, formatMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da9b384ac1708a2f$var$BaseContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        spacing: "none",
        appearance: "subtle-link",
        onClick: (_, analyticsEvent)=>{
            onDeploymentClicked();
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'deploymentSummaryCell');
        },
        "aria-label": formatMessage((0, $lSCyP.default).deploymentDataAriaLabel, {
            environmentCategory: environmentCategory,
            deploymentState: deploymentState
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da9b384ac1708a2f$var$ContentsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da9b384ac1708a2f$var$StatusContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfyVj.StatusIcon), {
        jiraSummarisedDeployments: summarisedDeployments
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da9b384ac1708a2f$var$DescriptionInternalContainer, null, environmentCategory))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da9b384ac1708a2f$var$BaseContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da9b384ac1708a2f$var$ContentsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da9b384ac1708a2f$var$DescriptionInternalContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _18u0u2gc _1bto1l2s _1vhi1ule _ifb4glyw",
            __cmplp.className
        ])
    });
});
const $da9b384ac1708a2f$var$StatusContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1tcg _syaz131l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jL3EI", function(module, exports) {

$parcel$export(module.exports, "default", () => $82177fb84ac8c2dc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<67c4a61676a6940dc19deb497108d795>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $82177fb84ac8c2dc$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "deploymentData_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "concreteType": "DevOpsSummarisedDeployments",
            "kind": "LinkedField",
            "name": "summarisedDeployments",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "deploymentState"
                },
                {
                    "concreteType": "DevOpsEnvironment",
                    "kind": "LinkedField",
                    "name": "deploymentEnvironment",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "statusIcon_softwareReleasesVersionDetailIssueList"
                }
            ]
        }
    ],
    "type": "DevOpsSummarisedEntities"
};
$82177fb84ac8c2dc$var$node.hash = "277da37647ab9525c90d0b7f19fa625e";
var $82177fb84ac8c2dc$export$2e2bcd8739ae039 = $82177fb84ac8c2dc$var$node;

});

parcelRegister("lSCyP", function(module, exports) {

$parcel$export(module.exports, "default", () => $81bc2b0055ab231f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $81bc2b0055ab231f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    deploymentsTooltip: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.deployments-tooltip",
        "defaultMessage": "{deploymentCount} {deploymentCount, plural, one {deployment} other {deployments}}"
    },
    production: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.production",
        "defaultMessage": "Production"
    },
    staging: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.staging",
        "defaultMessage": "Staging"
    },
    testing: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.testing",
        "defaultMessage": "Testing"
    },
    development: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.development",
        "defaultMessage": "Development"
    },
    unmapped: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.unmapped",
        "defaultMessage": "Undefined environment"
    },
    pending: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-state.pending",
        "defaultMessage": "Pending"
    },
    inProgress: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-state.in-progress",
        "defaultMessage": "In progress"
    },
    successful: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-state.successful",
        "defaultMessage": "Successful"
    },
    failed: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-state.failed",
        "defaultMessage": "Failed"
    },
    rolledBack: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-state.rolled-back",
        "defaultMessage": "Rolled back"
    },
    cancelled: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-state.cancelled",
        "defaultMessage": "Canceled"
    },
    unknown: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-state.unknown",
        "defaultMessage": "Unknown"
    },
    deploymentDataAriaLabel: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.deployment-data-aria-label",
        "defaultMessage": "{environmentCategory} deployment {deploymentState}"
    }
});

});

parcelRegister("lfyVj", function(module, exports) {

$parcel$export(module.exports, "StatusIcon", () => $ec1f18b42e680184$export$b131c49b26d3f427);

var $gAldo = parcelRequire("gAldo");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $gYpv9 = parcelRequire("gYpv9");

var $5gD09 = parcelRequire("5gD09");

var $7ry0V = parcelRequire("7ry0V");
const $ec1f18b42e680184$var$mapState = (state, environmentType, formatMessage)=>{
    switch(state){
        case (0, $5gD09.DeploymentStateOptions).PENDING:
            return {
                message: formatMessage((0, $7ry0V.default).pending),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gYpv9.DeploymentIcons), {
                    deploymentState: (0, $5gD09.DeploymentStateOptions).PENDING,
                    size: "medium"
                })
            };
        case (0, $5gD09.DeploymentStateOptions).IN_PROGRESS:
            return {
                message: formatMessage((0, $7ry0V.default).inProgress),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gYpv9.DeploymentIcons), {
                    deploymentState: (0, $5gD09.DeploymentStateOptions).IN_PROGRESS,
                    size: "medium"
                })
            };
        case (0, $5gD09.DeploymentStateOptions).SUCCESSFUL:
            if (environmentType === 'PRODUCTION') return {
                message: formatMessage((0, $7ry0V.default).successful),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gYpv9.DeploymentIcons), {
                    deploymentState: (0, $5gD09.DeploymentStateOptions).SUCCESSFUL,
                    size: "medium"
                })
            };
            return {
                message: formatMessage((0, $7ry0V.default).successful),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gYpv9.DeploymentIcons), {
                    deploymentState: (0, $5gD09.DeploymentStateOptions).SUCCESSFULNONPRODUCTION,
                    size: "medium"
                })
            };
        case (0, $5gD09.DeploymentStateOptions).FAILED:
            return {
                message: formatMessage((0, $7ry0V.default).failed),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gYpv9.DeploymentIcons), {
                    deploymentState: (0, $5gD09.DeploymentStateOptions).FAILED,
                    size: "medium"
                })
            };
        case (0, $5gD09.DeploymentStateOptions).ROLLED_BACK:
            return {
                message: formatMessage((0, $7ry0V.default).rolledBack),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gYpv9.DeploymentIcons), {
                    deploymentState: (0, $5gD09.DeploymentStateOptions).ROLLED_BACK,
                    size: "medium"
                })
            };
        case (0, $5gD09.DeploymentStateOptions).CANCELLED:
            return {
                message: formatMessage((0, $7ry0V.default).cancelled),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gYpv9.DeploymentIcons), {
                    deploymentState: (0, $5gD09.DeploymentStateOptions).CANCELLED,
                    size: "medium"
                })
            };
        case (0, $5gD09.DeploymentStateOptions).UNKNOWN:
            return {
                message: formatMessage((0, $7ry0V.default).unknown),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gYpv9.DeploymentIcons), {
                    deploymentState: (0, $5gD09.DeploymentStateOptions).UNKNOWN,
                    size: "medium"
                })
            };
        default:
            return {
                message: formatMessage((0, $7ry0V.default).unknown),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gYpv9.DeploymentIcons), {
                    deploymentState: (0, $5gD09.DeploymentStateOptions).UNKNOWN,
                    size: "medium"
                })
            };
    }
};
const $ec1f18b42e680184$export$b131c49b26d3f427 = ({ jiraSummarisedDeployments: jiraSummarisedDeployments })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const deploymentSummary = (0, $8Uumt.useFragment)((0, $gAldo.default), jiraSummarisedDeployments);
    const state = deploymentSummary.deploymentState ? deploymentSummary.deploymentState : 'UNKNOWN';
    const environment = deploymentSummary.deploymentEnvironment?.category ? deploymentSummary.deploymentEnvironment.category : 'UNMAPPED';
    const { icon: icon, message: message } = $ec1f18b42e680184$var$mapState(state, environment, formatMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: message
    }, icon);
};

});
parcelRegister("gAldo", function(module, exports) {

$parcel$export(module.exports, "default", () => $55c65f6062c38236$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<975170e91daa818ce2bf2ced6fa58557>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $55c65f6062c38236$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "statusIcon_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "deploymentState"
        },
        {
            "concreteType": "DevOpsEnvironment",
            "kind": "LinkedField",
            "name": "deploymentEnvironment",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "category"
                }
            ]
        }
    ],
    "type": "DevOpsSummarisedDeployments"
};
$55c65f6062c38236$var$node.hash = "f151e3f42403e9b74c8517a51ce0be46";
var $55c65f6062c38236$export$2e2bcd8739ae039 = $55c65f6062c38236$var$node;

});

parcelRegister("7ry0V", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d50d6de20092c4d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3d50d6de20092c4d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    pending: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.status-icon.pending",
        "defaultMessage": "Pending"
    },
    inProgress: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.status-icon.in-progress",
        "defaultMessage": "In-progress"
    },
    successful: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.status-icon.successful",
        "defaultMessage": "Successful"
    },
    failed: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.status-icon.failed",
        "defaultMessage": "Failed"
    },
    rolledBack: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.status-icon.rolled-back",
        "defaultMessage": "Rolled back"
    },
    cancelled: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.status-icon.cancelled",
        "defaultMessage": "Canceled"
    },
    unknown: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.status-icon.unknown",
        "defaultMessage": "Unknown"
    }
});

});




parcelRegister("cmBKm", function(module, exports) {

$parcel$export(module.exports, "Development", () => $5ecfa643deeabce9$export$fb8a2d432bc2d196);
$parcel$export(module.exports, "DevelopmentContainer", () => $5ecfa643deeabce9$export$3c8f918e865f8ead);

var $2pTnM = parcelRequire("2pTnM");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");

var $fb5SF = parcelRequire("fb5SF");

var $b0XU0 = parcelRequire("b0XU0");

var $f0oLC = parcelRequire("f0oLC");

var $3bDjY = parcelRequire("3bDjY");


var $8YTUU = parcelRequire("8YTUU");

var $Iny5X = parcelRequire("Iny5X");


var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $npYQQ = parcelRequire("npYQQ");


var $nXMUs = parcelRequire("nXMUs");

var $jMWoV = parcelRequire("jMWoV");

var $3RJ9y = parcelRequire("3RJ9y");
const $5ecfa643deeabce9$export$fb8a2d432bc2d196 = ({ jiraIssue: jiraIssue, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { issueId: issueId, devSummaryCache: devSummaryCache } = (0, $8Uumt.useFragment)((0, $2pTnM.default), jiraIssue);
    const { branch: branch, commit: commit, pullrequest: pullrequest, review: review } = devSummaryCache.devSummary;
    const pullRequestCount = pullrequest.overall.count;
    const pullRequestState = pullrequest.overall.state;
    if (pullRequestCount > 0 && pullRequestState) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ecfa643deeabce9$export$3c8f918e865f8ead, {
        "data-version-details-issue-click-ignore-target": (0, $npYQQ.ISSUE_CARD_CLICK_IGNORE_TARGET)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle-link",
        onClick: (_, analyticsEvent)=>{
            onClick((0, $61a2cd6236d50c20$export$6f74b53d652f13f3));
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'versionsPullRequestLozenge');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ecfa643deeabce9$var$VerticalCenter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Iny5X.default), {
        devInfoType: (0, $8YTUU.DevInfoTypes).PULLREQUEST,
        issueId: Number(issueId),
        customTrigger: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jMWoV.CustomPullRequestIcon), {
            pullRequestState: (0, $3RJ9y.toDevInfoType)(pullrequest.overall.state),
            label: formatMessage((0, $nXMUs.default).pullRequestIconLabel),
            primaryColor: (0, $3RJ9y.mapPullRequestStateToIconColour)(pullrequest.overall.state)
        }),
        isStopPropagationOnClick: false,
        scopeId: (0, $752b719410cf933d$export$6bc465585d114926),
        location: (0, $4ebd35f903e92a1a$export$ede40e627a0cbf14)
    }))));
    const reviewCount = review.overall.count;
    const reviewState = review.overall.state;
    if (reviewCount > 0 && reviewState) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ecfa643deeabce9$export$3c8f918e865f8ead, {
        "data-version-details-issue-click-ignore-target": (0, $npYQQ.ISSUE_CARD_CLICK_IGNORE_TARGET)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $nXMUs.default).reviewCount, {
            reviewCount: reviewCount
        }),
        position: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle-link",
        onClick: (_, analyticsEvent)=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const reviewDataByProvider = {};
            review.summaryByProvider.forEach(({ providerId: providerId, name: name, count: count })=>{
                if (providerId != null) reviewDataByProvider[providerId] = {
                    name: name,
                    count: count
                };
            });
            onClick((0, $61a2cd6236d50c20$export$3f1e2b276d607490), {
                overall: {
                    count: review.overall.count,
                    lastUpdated: review.overall.lastUpdated ?? '',
                    state: (0, $3RJ9y.toReviewState)(reviewState),
                    stateCount: review.overall.stateCount
                },
                byInstanceType: reviewDataByProvider
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'versionsReviewLozenge');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ecfa643deeabce9$var$VerticalCenter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fb5SF))), {
        label: formatMessage((0, $nXMUs.default).reviewIconLabel),
        color: (0, $3RJ9y.mapReviewStateToIconColour)(reviewState)
    })))));
    const branchCount = branch.overall.count;
    if (branchCount > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ecfa643deeabce9$export$3c8f918e865f8ead, {
        "data-version-details-issue-click-ignore-target": (0, $npYQQ.ISSUE_CARD_CLICK_IGNORE_TARGET)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle-link",
        onClick: (_, analyticsEvent)=>{
            onClick((0, $61a2cd6236d50c20$export$e18d81f044132a0e));
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'versionsBranchLozenge');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ecfa643deeabce9$var$VerticalCenter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Iny5X.default), {
        devInfoType: (0, $8YTUU.DevInfoTypes).BRANCH,
        issueId: Number(issueId),
        customTrigger: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b0XU0))), {
            spacing: "spacious",
            label: formatMessage((0, $nXMUs.default).branchIconLabel),
            color: "var(--ds-icon, #44546F)"
        }),
        scopeId: (0, $752b719410cf933d$export$6bc465585d114926),
        location: (0, $4ebd35f903e92a1a$export$ede40e627a0cbf14)
    }))));
    const commitCount = commit.overall.count;
    if (commitCount > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ecfa643deeabce9$export$3c8f918e865f8ead, {
        "data-version-details-issue-click-ignore-target": (0, $npYQQ.ISSUE_CARD_CLICK_IGNORE_TARGET)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ecfa643deeabce9$var$VerticalCenter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Iny5X.default), {
        devInfoType: (0, $8YTUU.DevInfoTypes).COMMIT,
        issueId: Number(issueId),
        customTrigger: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle-link",
            onClick: (_, analyticsEvent)=>{
                onClick((0, $61a2cd6236d50c20$export$2e42513c7764d5f3));
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'versionsCommitLozenge');
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0oLC))), {
            spacing: "spacious",
            label: formatMessage((0, $nXMUs.default).commitIconLabel),
            color: "var(--ds-icon, #44546F)"
        })),
        scopeId: (0, $752b719410cf933d$export$6bc465585d114926),
        location: (0, $4ebd35f903e92a1a$export$ede40e627a0cbf14)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ecfa643deeabce9$export$3c8f918e865f8ead, null);
};
const $5ecfa643deeabce9$export$3c8f918e865f8ead = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbckbl _1ul9ckbl",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5ecfa643deeabce9$var$VerticalCenter = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2pTnM", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b974285bf8073ca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<59d3ab5850892cb433979868803b1f20>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1b974285bf8073ca$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "count"
    }, v1 = {
        "kind": "ScalarField",
        "name": "state"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "development_softwareReleasesVersionDetailIssueList",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "issueId"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraIssueDevSummaryResult",
                    "kind": "LinkedField",
                    "name": "devSummaryCache",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraIssueDevSummary",
                                "kind": "LinkedField",
                                "name": "devSummary",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "JiraIssueBranchDevSummaryContainer",
                                            "kind": "LinkedField",
                                            "name": "branch",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraIssueBranchDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v0 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "devSummaryCache.devSummary.branch.overall.count"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "devSummaryCache.devSummary.branch.overall"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "devSummaryCache.devSummary.branch"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "JiraIssueCommitDevSummaryContainer",
                                            "kind": "LinkedField",
                                            "name": "commit",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraIssueCommitDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v0 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "devSummaryCache.devSummary.commit.overall.count"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "devSummaryCache.devSummary.commit.overall"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "devSummaryCache.devSummary.commit"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                            "kind": "LinkedField",
                                            "name": "pullrequest",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraIssuePullRequestDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v0 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "devSummaryCache.devSummary.pullrequest.overall.count"
                                                            },
                                                            v1 /*: any*/ 
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "devSummaryCache.devSummary.pullrequest.overall"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "devSummaryCache.devSummary.pullrequest"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "JiraIssueReviewDevSummaryContainer",
                                            "kind": "LinkedField",
                                            "name": "review",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraIssueReviewDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v0 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "devSummaryCache.devSummary.review.overall.count"
                                                            },
                                                            v1 /*: any*/ ,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "lastUpdated"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "kind": "ScalarField",
                                                                    "name": "stateCount"
                                                                },
                                                                "action": "THROW",
                                                                "path": "devSummaryCache.devSummary.review.overall.stateCount"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "devSummaryCache.devSummary.review.overall"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraIssueDevSummaryByProvider",
                                                        "kind": "LinkedField",
                                                        "name": "summaryByProvider",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "providerId"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "name"
                                                            },
                                                            v0 /*: any*/ 
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "devSummaryCache.devSummary.review.summaryByProvider"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "devSummaryCache.devSummary.review"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "devSummaryCache.devSummary"
                        }
                    ]
                },
                "action": "THROW",
                "path": "devSummaryCache"
            }
        ],
        "type": "JiraIssue"
    };
}();
$1b974285bf8073ca$var$node.hash = "a6fa00d421e78b1cfca02a289c940e70";
var $1b974285bf8073ca$export$2e2bcd8739ae039 = $1b974285bf8073ca$var$node;

});

parcelRegister("fb5SF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0df86e9f58670341f0be02decae626a5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0cc71de29a7bd8c$var$_react = $b0cc71de29a7bd8c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b0cc71de29a7bd8c$var$_pullRequest = $b0cc71de29a7bd8c$var$_interopRequireDefault((parcelRequire("hXgVM")));

var $b0cc71de29a7bd8c$var$_pullrequests = $b0cc71de29a7bd8c$var$_interopRequireDefault((parcelRequire("dMzAR")));
function $b0cc71de29a7bd8c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PullRequestIcon.
 * This component is PullRequestIcon, with `UNSAFE_fallbackIcon` set to "BitbucketPullrequestsIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b0cc71de29a7bd8c$var$PullRequestIcon = (props)=>/*#__PURE__*/ $b0cc71de29a7bd8c$var$_react.default.createElement($b0cc71de29a7bd8c$var$_pullRequest.default, Object.assign({
        LEGACY_fallbackIcon: $b0cc71de29a7bd8c$var$_pullrequests.default
    }, props));
$b0cc71de29a7bd8c$var$PullRequestIcon.Name = 'PullRequestIconMigration';
var $b0cc71de29a7bd8c$var$_default = module.exports.default = $b0cc71de29a7bd8c$var$PullRequestIcon;

});
parcelRegister("dMzAR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a08b5e30d2d36873$var$_react = $a08b5e30d2d36873$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $a08b5e30d2d36873$var$_pullRequest = $a08b5e30d2d36873$var$_interopRequireDefault((parcelRequire("hXgVM")));
function $a08b5e30d2d36873$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a08b5e30d2d36873$var$BitbucketPullrequestsIcon = (props)=>/*#__PURE__*/ $a08b5e30d2d36873$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M18 15.2V11c0-1.7-1.3-3-3-3h-1.9l.8-.8c.3-.3.3-.8 0-1.1s-.8-.3-1.1 0l-2.3 2.3c-.3.4-.3.9 0 1.2l2.3 2.3c.2.2.3.2.5.2q.3 0 .6-.3c.3-.3.3-.8 0-1.1l-.7-.7H15c.6 0 1 .4 1 1v4.2c-1.2.4-2 1.5-2 2.8 0 1.7 1.3 3 3 3s3-1.3 3-3c0-1.3-.8-2.4-2-2.8M17 19c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1M7 3C5.4 3 4 4.3 4 6c0 1.3.8 2.4 2 2.8V20c0 .6.4 1 1 1s1-.4 1-1V8.8c1.2-.4 2-1.5 2-2.8 0-1.7-1.3-3-3-3m0 4c-.5 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1"/></svg>`
    }, props, {
        newIcon: $a08b5e30d2d36873$var$_pullRequest.default
    }));
$a08b5e30d2d36873$var$BitbucketPullrequestsIcon.displayName = 'BitbucketPullrequestsIcon';
var $a08b5e30d2d36873$var$_default = module.exports.default = $a08b5e30d2d36873$var$BitbucketPullrequestsIcon;

});


parcelRegister("b0XU0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf5f697d891cc6bba8e40c46639eb125>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $804e2928682a9df6$var$_react = $804e2928682a9df6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $804e2928682a9df6$var$_branch = $804e2928682a9df6$var$_interopRequireDefault((parcelRequire("4iPF3")));

var $804e2928682a9df6$var$_branches = $804e2928682a9df6$var$_interopRequireDefault((parcelRequire("9XvX5")));
function $804e2928682a9df6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for BranchIcon.
 * This component is BranchIcon, with `UNSAFE_fallbackIcon` set to "BitbucketBranchesIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $804e2928682a9df6$var$BranchIcon = (props)=>/*#__PURE__*/ $804e2928682a9df6$var$_react.default.createElement($804e2928682a9df6$var$_branch.default, Object.assign({
        LEGACY_fallbackIcon: $804e2928682a9df6$var$_branches.default
    }, props));
$804e2928682a9df6$var$BranchIcon.Name = 'BranchIconMigration';
var $804e2928682a9df6$var$_default = module.exports.default = $804e2928682a9df6$var$BranchIcon;

});
parcelRegister("9XvX5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $740268c474e86b43$var$_react = $740268c474e86b43$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $740268c474e86b43$var$_branch = $740268c474e86b43$var$_interopRequireDefault((parcelRequire("4iPF3")));
function $740268c474e86b43$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $740268c474e86b43$var$BitbucketBranchesIcon = (props)=>/*#__PURE__*/ $740268c474e86b43$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3M8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1m8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1m-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1"/></svg>`
    }, props, {
        newIcon: $740268c474e86b43$var$_branch.default
    }));
$740268c474e86b43$var$BitbucketBranchesIcon.displayName = 'BitbucketBranchesIcon';
var $740268c474e86b43$var$_default = module.exports.default = $740268c474e86b43$var$BitbucketBranchesIcon;

});


parcelRegister("f0oLC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1201ab50caa951687977050b2b11e97b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aeca11506e43c7df$var$_react = $aeca11506e43c7df$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aeca11506e43c7df$var$_commit = $aeca11506e43c7df$var$_interopRequireDefault((parcelRequire("bFklq")));

var $aeca11506e43c7df$var$_commits = $aeca11506e43c7df$var$_interopRequireDefault((parcelRequire("1TUd3")));
function $aeca11506e43c7df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CommitIcon.
 * This component is CommitIcon, with `UNSAFE_fallbackIcon` set to "BitbucketCommitsIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for commits in Jira or Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aeca11506e43c7df$var$CommitIcon = (props)=>/*#__PURE__*/ $aeca11506e43c7df$var$_react.default.createElement($aeca11506e43c7df$var$_commit.default, Object.assign({
        LEGACY_fallbackIcon: $aeca11506e43c7df$var$_commits.default
    }, props));
$aeca11506e43c7df$var$CommitIcon.Name = 'CommitIconMigration';
var $aeca11506e43c7df$var$_default = module.exports.default = $aeca11506e43c7df$var$CommitIcon;

});
parcelRegister("1TUd3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $162687911a858d49$var$_react = $162687911a858d49$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $162687911a858d49$var$_commit = $162687911a858d49$var$_interopRequireDefault((parcelRequire("bFklq")));
function $162687911a858d49$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $162687911a858d49$var$BitbucketCommitsIcon = (props)=>/*#__PURE__*/ $162687911a858d49$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16 12c0-1.9-1.3-3.4-3-3.9V4c0-.6-.4-1-1-1s-1 .4-1 1v4.1c-1.7.4-3 2-3 3.9s1.3 3.4 3 3.9V20c0 .6.4 1 1 1s1-.4 1-1v-4.1c1.7-.5 3-2 3-3.9m-4 2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2"/></svg>`
    }, props, {
        newIcon: $162687911a858d49$var$_commit.default
    }));
$162687911a858d49$var$BitbucketCommitsIcon.displayName = 'BitbucketCommitsIcon';
var $162687911a858d49$var$_default = module.exports.default = $162687911a858d49$var$BitbucketCommitsIcon;

});


parcelRegister("nXMUs", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8ea841775256067$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b8ea841775256067$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    commitIconLabel: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.development.commit-icon-label",
        "defaultMessage": "Commits"
    },
    branchIconLabel: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.development.branch-icon-label",
        "defaultMessage": "Branches"
    },
    pullRequestIconLabel: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.development.pull-request-icon-label",
        "defaultMessage": "Pull requests"
    },
    reviewCount: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.development.review-count",
        "defaultMessage": "{reviewCount} {reviewCount, plural, one {review} other {reviews}}"
    },
    reviewIconLabel: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.development.review-icon-label",
        "defaultMessage": "Reviews"
    }
});

});

parcelRegister("jMWoV", function(module, exports) {

$parcel$export(module.exports, "CustomPullRequestIcon", () => $45adfbcb11df4632$export$59a5de4025575d75);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $fb5SF = parcelRequire("fb5SF");

var $8YTUU = parcelRequire("8YTUU");
const $45adfbcb11df4632$var$PullrequestDeclinedIcon = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        label: label,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
                width: "24",
                height: "24",
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                fillOpacity: "0.01"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.75 5.25C6.19772 5.25 5.75 5.69772 5.75 6.25C5.75 6.80228 6.19772 7.25 6.75 7.25C7.30228 7.25 7.75 6.80228 7.75 6.25C7.75 5.69772 7.30228 5.25 6.75 5.25ZM3.75 6.25C3.75 4.59315 5.09315 3.25 6.75 3.25C8.40685 3.25 9.75 4.59315 9.75 6.25C9.75 7.55622 8.91519 8.66746 7.75 9.07929V20.25C7.75 20.8023 7.30228 21.25 6.75 21.25C6.19772 21.25 5.75 20.8023 5.75 20.25V9.07929C4.58481 8.66746 3.75 7.55622 3.75 6.25Z",
                fill: "var(--ds-icon-danger, #C9372C)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.75 11.25C17.3023 11.25 17.75 11.6977 17.75 12.25V15.4207C18.9152 15.8325 19.75 16.9438 19.75 18.25C19.75 19.9069 18.4069 21.25 16.75 21.25C15.0931 21.25 13.75 19.9069 13.75 18.25C13.75 16.9438 14.5848 15.8325 15.75 15.4207V12.25C15.75 11.6977 16.1977 11.25 16.75 11.25ZM16.75 17.25C16.1977 17.25 15.75 17.6977 15.75 18.25C15.75 18.8023 16.1977 19.25 16.75 19.25C17.3023 19.25 17.75 18.8023 17.75 18.25C17.75 17.6977 17.3023 17.25 16.75 17.25Z",
                fill: "var(--ds-icon-danger, #C9372C)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.5429 3.04289C13.9334 2.65237 14.5666 2.65237 14.9571 3.04289L16.75 4.83579L18.5429 3.04289C18.9334 2.65237 19.5666 2.65237 19.9571 3.04289C20.3476 3.43342 20.3476 4.06658 19.9571 4.45711L18.1642 6.25L19.9571 8.04289C20.3476 8.43342 20.3476 9.06658 19.9571 9.45711C19.5666 9.84763 18.9334 9.84763 18.5429 9.45711L16.75 7.66421L14.9571 9.45711C14.5666 9.84763 13.9334 9.84763 13.5429 9.45711C13.1524 9.06658 13.1524 8.43342 13.5429 8.04289L15.3358 6.25L13.5429 4.45711C13.1524 4.06658 13.1524 3.43342 13.5429 3.04289Z",
                fill: "var(--ds-icon-danger, #C9372C)"
            }))
    });
const $45adfbcb11df4632$var$PullrequestMergedIcon = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        label: label,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
                width: "24",
                height: "24",
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                fillOpacity: "0.01"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.5 5C5.94772 5 5.5 5.44772 5.5 6C5.5 6.55228 5.94772 7 6.5 7C7.05228 7 7.5 6.55228 7.5 6C7.5 5.44772 7.05228 5 6.5 5ZM3.5 6C3.5 4.34315 4.84315 3 6.5 3C8.15685 3 9.5 4.34315 9.5 6C9.5 7.30622 8.66519 8.41746 7.5 8.82929V20C7.5 20.5523 7.05228 21 6.5 21C5.94772 21 5.5 20.5523 5.5 20V8.82929C4.33481 8.41746 3.5 7.30622 3.5 6Z",
                fill: "var(--ds-icon-success, #22A06B)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.5 7C7.05228 7 7.5 7.44772 7.5 8V10C7.5 13.5912 10.2043 16.5508 13.6876 16.9534C14.1123 15.8126 15.2113 15 16.5 15C18.1569 15 19.5 16.3431 19.5 18C19.5 19.6569 18.1569 21 16.5 21C15.1793 21 14.0579 20.1466 13.6572 18.9611C9.08185 18.5362 5.5 14.6864 5.5 10V8C5.5 7.44772 5.94772 7 6.5 7ZM16.5 17C15.9477 17 15.5 17.4477 15.5 18C15.5 18.5523 15.9477 19 16.5 19C17.0523 19 17.5 18.5523 17.5 18C17.5 17.4477 17.0523 17 16.5 17Z",
                fill: "var(--ds-icon-success, #22A06B)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.2071 4.29289C20.5976 4.68342 20.5976 5.31658 20.2071 5.70711L16.2071 9.70711C15.8166 10.0976 15.1834 10.0976 14.7929 9.70711L12.7929 7.70711C12.4024 7.31658 12.4024 6.68342 12.7929 6.29289C13.1834 5.90237 13.8166 5.90237 14.2071 6.29289L15.5 7.58579L18.7929 4.29289C19.1834 3.90237 19.8166 3.90237 20.2071 4.29289Z",
                fill: "var(--ds-icon-success, #22A06B)"
            }))
    });
const $45adfbcb11df4632$export$59a5de4025575d75 = ({ pullRequestState: pullRequestState, label: label, primaryColor: primaryColor })=>{
    if (pullRequestState === (0, $8YTUU.DevInfoTypes).DECLINED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($45adfbcb11df4632$var$PullrequestDeclinedIcon, {
        label: label
    });
    if (pullRequestState === (0, $8YTUU.DevInfoTypes).MERGED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($45adfbcb11df4632$var$PullrequestMergedIcon, {
        label: label
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fb5SF))), {
        label: label,
        LEGACY_primaryColor: primaryColor
    });
};

});

parcelRegister("3RJ9y", function(module, exports) {

$parcel$export(module.exports, "mapPullRequestStateToIconColour", () => $305273cb65147a1f$export$b659f6ad1597c81c);
$parcel$export(module.exports, "mapReviewStateToIconColour", () => $305273cb65147a1f$export$3503f5c2d5e8553a);
$parcel$export(module.exports, "toReviewState", () => $305273cb65147a1f$export$e4227c1382daeae5);
$parcel$export(module.exports, "toDevInfoType", () => $305273cb65147a1f$export$f3b34c5748a7d335);

var $8YTUU = parcelRequire("8YTUU");
const $305273cb65147a1f$export$b659f6ad1597c81c = (state)=>{
    switch(state){
        case 'MERGED':
            return "var(--ds-icon-success, #22A06B)";
        case 'DECLINED':
            return "var(--ds-icon-danger, #C9372C)";
        default:
            return "var(--ds-icon, #44546F)";
    }
};
const $305273cb65147a1f$export$3503f5c2d5e8553a = (state)=>{
    switch(state){
        case 'REVIEW':
            return "var(--ds-icon, #44546F)";
        case 'APPROVAL':
            return "var(--ds-icon, #44546F)";
        case 'SUMMARIZE':
            return "var(--ds-icon, #44546F)";
        case 'REJECTED':
            return "var(--ds-icon-danger, #C9372C)";
        case 'CLOSED':
            return "var(--ds-icon-success, #22A06B)";
        case 'DRAFT':
            return "var(--ds-icon, #44546F)";
        case 'DEAD':
            return "var(--ds-icon-danger, #C9372C)";
        case 'UNKNOWN':
            return "var(--ds-icon-danger, #C9372C)";
        default:
            return "var(--ds-icon, #44546F)";
    }
};
const $305273cb65147a1f$export$e4227c1382daeae5 = (state)=>{
    switch(state){
        case 'REVIEW':
        case 'APPROVAL':
        case 'SUMMARIZE':
        case 'REJECTED':
        case 'CLOSED':
        case 'DRAFT':
        case 'DEAD':
            return state;
        default:
            return 'UNKNOWN';
    }
};
const $305273cb65147a1f$export$f3b34c5748a7d335 = (state)=>{
    switch(state){
        case 'DECLINED':
            return (0, $8YTUU.DevInfoTypes).DECLINED;
        case 'MERGED':
            return (0, $8YTUU.DevInfoTypes).MERGED;
        default:
            return (0, $8YTUU.DevInfoTypes).PULLREQUEST;
    }
};

});


parcelRegister("iKL1U", function(module, exports) {

$parcel$export(module.exports, "FeatureFlags", () => $8f29d9dcd9c0b374$export$ab28ab2e245553c7);

var $lEj39 = parcelRequire("lEj39");

var $8g3g9 = parcelRequire("8g3g9");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");


var $8zOmE = parcelRequire("8zOmE");

var $inYVm = parcelRequire("inYVm");

var $5eQEK = parcelRequire("5eQEK");

var $hUdMc = parcelRequire("hUdMc");
const $8f29d9dcd9c0b374$export$ab28ab2e245553c7 = ({ devOpsSummarisedEntities: devOpsSummarisedEntities, jiraIssue: jiraIssue, onClick: onClick, setFeatureFlagEmptyStateModalOpen: setFeatureFlagEmptyStateModalOpen, featureFlagButtonRef: featureFlagButtonRef, rowNum: rowNum })=>{
    const issue = (0, $8Uumt.useFragment)((0, $8g3g9.default), jiraIssue);
    const { providers: providers } = (0, $8Uumt.useFragment)((0, $lEj39.default), devOpsSummarisedEntities);
    const summarisedFlags = issue.summarisedFeatureFlags;
    const featureFlagCount = summarisedFlags?.totalCount ?? 0;
    const hasFeatureFlags = summarisedFlags != null && featureFlagCount != null && featureFlagCount > 0;
    const featureFlagProviders = (providers.featureFlagProviders ?? []).filter(Boolean);
    const hasFeatureFlagProviders = featureFlagProviders.length > 0;
    const renderContent = ()=>{
        const fields = issue.fieldsById.edges.map((edge)=>edge?.node).filter(Boolean);
        const jiraIssueSummary = fields.find((fieldNode)=>fieldNode?.fieldId === 'summary'); // Render the single or multiple flags component if the issue has at least one linked
        // feature flag
        if (hasFeatureFlags) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle-link",
            spacing: "none",
            onClick: (_, analyticsEvent)=>{
                onClick((0, $61a2cd6236d50c20$export$c69477f358d30f7e));
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'featureFlagSummaryCell');
            }
        }, featureFlagCount === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hUdMc.SingleFlag), {
            summarisedFlags: summarisedFlags
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5eQEK.MultipleFlags), {
            jiraIssue: issue,
            summarisedFlags: summarisedFlags
        }));
         // Render the "add flag" dropdown if there's at least one feature flag provider and the
        // issue has no linked feature flags
        if (hasFeatureFlagProviders) return jiraIssueSummary != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8f29d9dcd9c0b374$export$e7937791cac9c51b, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $inYVm.AddFeatureFlagDropdown), {
            devOpsFeatureFlagProviders: featureFlagProviders,
            jiraIssue: issue,
            jiraIssueSummary: jiraIssueSummary,
            onOpenFeatureFlagEmptyStateModal: ()=>setFeatureFlagEmptyStateModalOpen(true)
        })) : null;
         // If the issue has no linked feature flags and there are no linked providers, return the
        // "add feature flag provider" button
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8f29d9dcd9c0b374$export$e7937791cac9c51b, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $inYVm.AddFeatureFlagButton), {
            featureFlagButtonRef: featureFlagButtonRef,
            onOpenFeatureFlagEmptyStateModal: ()=>setFeatureFlagEmptyStateModalOpen(true),
            rowNum: rowNum
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8f29d9dcd9c0b374$export$c518a6c3736e9db7, null, renderContent(), " ");
};
const $8f29d9dcd9c0b374$export$e7937791cac9c51b = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1wtl15vq _j9irewfl",
            "_qrawewfl"
        ])
    }, children); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $8f29d9dcd9c0b374$export$c518a6c3736e9db7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1b081l8a _15yj1l8a _13n41tcg _fhcx1tcg",
            __cmplp.className
        ])
    });
});
const $8f29d9dcd9c0b374$var$styles = null;
const $8f29d9dcd9c0b374$var$stylesWithFocusWithin = null;

});
parcelRegister("lEj39", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d874885535259cf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ce2c34f4872428c634fc08b19e03484c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9d874885535259cf$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "featureFlags_softwareReleasesVersionDetailIssueList_devOpsSummarisedEntities",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "DevOpsProviders",
                "kind": "LinkedField",
                "name": "providers",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "DevOpsFeatureFlagProvider",
                            "kind": "LinkedField",
                            "name": "featureFlagProviders",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_devOpsFeatureFlagProviders"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "providers.featureFlagProviders"
                    }
                ]
            },
            "action": "THROW",
            "path": "providers"
        }
    ],
    "type": "DevOpsSummarisedEntities"
};
$9d874885535259cf$var$node.hash = "6396e923543528812899038e05950d31";
var $9d874885535259cf$export$2e2bcd8739ae039 = $9d874885535259cf$var$node;

});

parcelRegister("8g3g9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a128492eddc5e9ab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3f31c4749c13d147d19d3d7f37ad80b6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a128492eddc5e9ab$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "featureFlags_softwareReleasesVersionDetailIssueList_jiraIssue",
    "selections": [
        {
            "concreteType": "DevOpsSummarisedFeatureFlags",
            "kind": "LinkedField",
            "name": "summarisedFeatureFlags",
            "plural": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "multipleFlags_softwareReleasesVersionDetailIssueList_summarisedFlags"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "singleFlag_softwareReleasesVersionDetailIssueList"
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                }
            ]
        },
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "ids",
                        "value": [
                            "priority",
                            "summary",
                            "assignee",
                            "status",
                            "issuetype"
                        ]
                    }
                ],
                "concreteType": "JiraIssueFieldConnection",
                "kind": "LinkedField",
                "name": "fieldsById",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraIssueFieldEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "kind": "ScalarField",
                                                "name": "fieldId"
                                            },
                                            "action": "THROW",
                                            "path": "fieldsById.edges.node.fieldId"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssueSummary"
                                                }
                                            ],
                                            "type": "JiraSingleLineTextField"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "fieldsById.edges"
                    }
                ],
                "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
            },
            "action": "THROW",
            "path": "fieldsById"
        },
        {
            "kind": "FragmentSpread",
            "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssue"
        },
        {
            "kind": "FragmentSpread",
            "name": "multipleFlags_softwareReleasesVersionDetailIssueList_jiraIssue"
        }
    ],
    "type": "JiraIssue"
};
$a128492eddc5e9ab$var$node.hash = "bdfcd9de28b80604417e3f543bdb55e1";
var $a128492eddc5e9ab$export$2e2bcd8739ae039 = $a128492eddc5e9ab$var$node;

});

parcelRegister("inYVm", function(module, exports) {

$parcel$export(module.exports, "AddFeatureFlagDropdown", () => $a3f3c9d852ccccf6$export$e0238a9f85d3899d);
$parcel$export(module.exports, "AddFeatureFlagButton", () => $a3f3c9d852ccccf6$export$18659c2363dd7739);

var $iIcWc = parcelRequire("iIcWc");

var $5XGjJ = parcelRequire("5XGjJ");

var $9s19T = parcelRequire("9s19T");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");

var $koVbs = parcelRequire("koVbs");

var $lfTZh = parcelRequire("lfTZh");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");

var $5oFIy = parcelRequire("5oFIy");

var $kxZPA = parcelRequire("kxZPA");

var $an1Yn = parcelRequire("an1Yn");

var $i4hom = parcelRequire("i4hom");

var $iWraz = parcelRequire("iWraz");

const $a3f3c9d852ccccf6$var$ActionMenu = (0, $kxZPA.lazy)(()=>(parcelRequire("gs0NP")).then((module)=>module.ActionMenu), {
    moduleId: "./src/packages/releases/issue-list/src/ui/issues/issue-card/feature-flags/add-feature-flag/action-menu/index.tsx"
}); // Extract just the content excluding button so we don't need to worry about passing props and
// forwardRef
const $a3f3c9d852ccccf6$var$TriggerContent = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3f3c9d852ccccf6$var$ButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i4hom.AddFeatureFlagIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3f3c9d852ccccf6$var$ButtonText, null, children));
const $a3f3c9d852ccccf6$export$e0238a9f85d3899d = ({ jiraIssue: jiraIssue, jiraIssueSummary: jiraIssueSummary, devOpsFeatureFlagProviders: devOpsFeatureFlagProviders, onOpenFeatureFlagEmptyStateModal: onOpenFeatureFlagEmptyStateModal })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $5uXOq.useState)(false);
    const issue = (0, $8Uumt.useFragment)((0, $9s19T.default), jiraIssue);
    const issueSummary = (0, $8Uumt.useFragment)((0, $5XGjJ.default), jiraIssueSummary);
    const featureFlagProviders = (0, $8Uumt.useFragment)((0, $iIcWc.default), devOpsFeatureFlagProviders);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3f3c9d852ccccf6$var$OnHoverContainer, {
        isVisible: isDropdownOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "action-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle-link",
            spacing: "none",
            isDisabled: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3f3c9d852ccccf6$var$TriggerContent, null, formatMessage((0, $iWraz.default).addFeatureFlag)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3f3c9d852ccccf6$var$ActionMenu, {
        jiraIssue: issue,
        jiraIssueSummary: issueSummary,
        onOpenChange: ({ isOpen: isOpen })=>setIsDropdownOpen(isOpen),
        devOpsFeatureFlagProviders: featureFlagProviders,
        onOpenFeatureFlagEmptyStateExperience: onOpenFeatureFlagEmptyStateModal,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "subtle-link",
                spacing: "none",
                ref: triggerRef,
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3f3c9d852ccccf6$var$TriggerContent, null, formatMessage((0, $iWraz.default).addFeatureFlag)))
    })));
};
const $a3f3c9d852ccccf6$export$18659c2363dd7739 = ({ onOpenFeatureFlagEmptyStateModal: onOpenFeatureFlagEmptyStateModal, rowNum: rowNum, featureFlagButtonRef: featureFlagButtonRef })=>{
    const spotlightButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "action-button-no-provider",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle-link",
            spacing: "none",
            isDisabled: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i4hom.AddFeatureFlagIcon), null))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $an1Yn.ActionButtonNoProviderAsync), {
        emptyStateButtonRef: featureFlagButtonRef,
        onClick: (_, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'versionDetailAddFeatureFlagButton');
            onOpenFeatureFlagEmptyStateModal();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i4hom.AddFeatureFlagIcon), null)));
    const regularButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ref: featureFlagButtonRef,
        appearance: "subtle-link",
        spacing: "none",
        onClick: (_, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'versionDetailAddFeatureFlagButton');
            onOpenFeatureFlagEmptyStateModal();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i4hom.AddFeatureFlagIcon), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3f3c9d852ccccf6$var$AddFeatureFlagButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "versionDetailsTableAddFeatureFlagActionButton",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, rowNum === 1 ? spotlightButton : regularButton, rowNum === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null) : null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3f3c9d852ccccf6$var$ButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3f3c9d852ccccf6$var$ButtonText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_u5f3u2gc _1flu1nu9 _1a4cglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3f3c9d852ccccf6$var$AddFeatureFlagButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $a3f3c9d852ccccf6$var$OnHoverContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.isVisible ? "_3um015ya" : "_3um015vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iIcWc", function(module, exports) {

$parcel$export(module.exports, "default", () => $38ecba1a4ee8de56$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b5e7746a103df83550bdda76eb8415f7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $38ecba1a4ee8de56$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_devOpsFeatureFlagProviders",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "actionMenu_softwareReleasesVersionDetailIssueList_devOpsFeatureFlagProviders"
        }
    ],
    "type": "DevOpsFeatureFlagProvider"
};
$38ecba1a4ee8de56$var$node.hash = "9b78d95e09cfbfd2c5af5b680d6fc543";
var $38ecba1a4ee8de56$export$2e2bcd8739ae039 = $38ecba1a4ee8de56$var$node;

});

parcelRegister("5XGjJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9e693cdb105dea5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2c9a416112e3bed4c41b26a4d887a703>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e9e693cdb105dea5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssueSummary",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "actionMenu_softwareReleasesVersionDetailIssueList_jiraIssueSummary"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$e9e693cdb105dea5$var$node.hash = "f26b20a2f8e5f0c916921d8c8691c202";
var $e9e693cdb105dea5$export$2e2bcd8739ae039 = $e9e693cdb105dea5$var$node;

});

parcelRegister("9s19T", function(module, exports) {

$parcel$export(module.exports, "default", () => $454a021224027b41$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e5c21fffefe38a3c828a06aaddbce9c8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $454a021224027b41$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssue",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "actionMenu_softwareReleasesVersionDetailIssueList_jiraIssue"
        }
    ],
    "type": "JiraIssue"
};
$454a021224027b41$var$node.hash = "3ccc732c38654f19cf9d23f0c776cb28";
var $454a021224027b41$export$2e2bcd8739ae039 = $454a021224027b41$var$node;

});

parcelRegister("an1Yn", function(module, exports) {

$parcel$export(module.exports, "ActionButtonNoProviderAsync", () => $0d1d6af6a4ed6d33$export$86b05afa2718604);

var $5uXOq = parcelRequire("5uXOq");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0d1d6af6a4ed6d33$var$ActionButtonNoProviderLazy = (0, $kxZPA.lazy)(()=>(parcelRequire("h7TPl")).then((module)=>module.ActionButtonNoProvider), {
    moduleId: "./src/packages/releases/issue-list/src/ui/issues/issue-card/feature-flags/add-feature-flag/action-button-no-provider/ActionButtonNoProvider.tsx"
});
const $0d1d6af6a4ed6d33$export$86b05afa2718604 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d1d6af6a4ed6d33$var$ActionButtonNoProviderLazy, props);

});
parcelRegister("h7TPl", function(module, exports) {

let $c77e6536d1df12c2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c77e6536d1df12c2$var$load("hpJ2V").then(()=>parcelRequire('6lz5f'));

});


parcelRegister("i4hom", function(module, exports) {

$parcel$export(module.exports, "AddFeatureFlagIcon", () => $c749a618f7b358f9$export$c3b91b420ace5d12);
/* AddFeatureFlagIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5LWLA = parcelRequire("5LWLA");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");

var $2TNn2 = parcelRequire("2TNn2");
const $c749a618f7b358f9$var$AddFeatureFlagGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: (0, $gwIPs.gridSize) * 3,
        height: (0, $gwIPs.gridSize) * 3,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17 2C17.5523 2 18 2.44772 18 3V5H20C20.5523 5 21 5.44772 21 6C21 6.55228 20.5523 7 20 7H18V9C18 9.55228 17.5523 10 17 10C16.4477 10 16 9.55228 16 9V7H14C13.4477 7 13 6.55228 13 6C13 5.44772 13.4477 5 14 5H16V3C16 2.44772 16.4477 2 17 2ZM12.2444 4.49608C12.3613 4.52442 12.477 4.55249 12.5917 4.57991C12.2263 4.9423 12 5.44472 12 6C12 6.17625 12.0228 6.34718 12.0656 6.50999C11.966 6.48607 11.867 6.46205 11.7688 6.43821L11.768 6.43801L11.7623 6.43662L11.7623 6.43662C10.3856 6.10219 9.16838 5.80649 8 6.14801V10.852C8.36666 10.7863 8.7385 10.7539 9.111 10.755C10.205 10.755 11.259 11.011 12.24 11.25C13.621 11.585 14.84 11.88 16.008 11.539V10.737C16.3004 10.9044 16.639 11 17 11C17.3676 11 17.712 10.9008 18.008 10.7278V12.221C18.0081 12.4088 17.9554 12.5927 17.8558 12.7519C17.7562 12.9111 17.6139 13.039 17.445 13.121C16.6509 13.5034 15.7793 13.6974 14.898 13.688C13.8103 13.688 12.7622 13.434 11.785 13.1971L11.785 13.1971L11.768 13.193C10.389 12.858 9.17 12.562 8 12.903V18.681C8 19.218 7.55 19.658 7 19.658C6.45 19.658 6 19.218 6 18.681V12.235V5.46601C6 5.27855 6.05268 5.09486 6.15205 4.93591C6.25143 4.77695 6.39348 4.64912 6.562 4.56701C8.553 3.60001 10.511 4.07501 12.24 4.49501L12.2444 4.49608Z",
        fill: "currentcolor"
    }));
const $c749a618f7b358f9$export$c3b91b420ace5d12 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c749a618f7b358f9$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        testId: "software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.add-feature-flag.icon.icon",
        glyph: $c749a618f7b358f9$var$AddFeatureFlagGlyph,
        size: "medium",
        label: formatMessage((0, $2TNn2.default).addFeatureFlagIconLabel)
    }));
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c749a618f7b358f9$export$be58b4326e23250f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2TNn2", function(module, exports) {

$parcel$export(module.exports, "default", () => $227a89c3121401e3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $227a89c3121401e3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addFeatureFlagIconLabel: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.add-feature-flag.icon.add-feature-flag-icon-label",
        "defaultMessage": "Add feature flag icon"
    }
});

});


parcelRegister("iWraz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1a2df9b0df79890$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a1a2df9b0df79890$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addFeatureFlag: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.add-feature-flag.add-feature-flag",
        "defaultMessage": "Add flag"
    },
    createFeatureFlagMenuItem: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.add-feature-flag.create-feature-flag-menu-item",
        "defaultMessage": "Create feature flag"
    },
    connectFeatureFlagMenuItem: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.add-feature-flag.connect-feature-flag-menu-item",
        "defaultMessage": "Connect feature flag"
    },
    installAnotherToolMenuItem: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.add-feature-flag.install-another-tool-menu-item",
        "defaultMessage": "Install another tool"
    }
});

});

parcelRegister("gs0NP", function(module, exports) {

let $bf9fe245b8bac13e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bf9fe245b8bac13e$var$load("kVHhl").then(()=>parcelRequire('9sAyx'));

});


parcelRegister("5eQEK", function(module, exports) {

$parcel$export(module.exports, "MultipleFlags", () => $13def82d73e54807$export$6d8ca791f6cb1232);

var $es0sT = parcelRequire("es0sT");

var $3xP8m = parcelRequire("3xP8m");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $lfTZh = parcelRequire("lfTZh");

var $8zOmE = parcelRequire("8zOmE");

var $da6LD = parcelRequire("da6LD");

var $l4isl = parcelRequire("l4isl");

var $9UCV3 = parcelRequire("9UCV3");
const $13def82d73e54807$export$6d8ca791f6cb1232 = ({ jiraIssue: jiraIssue, summarisedFlags: summarisedFlags })=>{
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $koVbs.default)();
    const issue = (0, $8Uumt.useFragment)((0, $3xP8m.default), jiraIssue);
    const { totalCount: totalCount } = (0, $8Uumt.useFragment)((0, $es0sT.default), summarisedFlags);
    const [tooltipQueryReference, loadTooltipQuery] = (0, $9UCV3.useTooltipContentQuery)(issue.id);
    const tooltipContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "tooltip-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $l4isl.default).tooltipLoading))
    }, tooltipQueryReference == null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCV3.TooltipContent), {
        queryReference: tooltipQueryReference
    }));
    const cellContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($13def82d73e54807$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $da6LD.MultipleFlagsIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($13def82d73e54807$var$TextContainer, null, formatMessage((0, $l4isl.default).flags, {
        count: formatNumber(totalCount)
    })));
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        onFocus: loadTooltipQuery,
        onMouseOver: loadTooltipQuery
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        testId: "software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.multiple-flags.tooltip",
        content: tooltipContent,
        onShow: (analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'featureFlagSummaryTooltip');
        },
        position: "bottom-start"
    }, cellContent)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $13def82d73e54807$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $13def82d73e54807$var$TextContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1flu1nu9 _1a4cglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("es0sT", function(module, exports) {

$parcel$export(module.exports, "default", () => $15e4250d4704aca6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<94a012cadd441203c8d2c31f966162e3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $15e4250d4704aca6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multipleFlags_softwareReleasesVersionDetailIssueList_summarisedFlags",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "totalCount"
            },
            "action": "THROW",
            "path": "totalCount"
        }
    ],
    "type": "DevOpsSummarisedFeatureFlags"
};
$15e4250d4704aca6$var$node.hash = "f8750caf47e7cdb0f524b2138f711e5d";
var $15e4250d4704aca6$export$2e2bcd8739ae039 = $15e4250d4704aca6$var$node;

});

parcelRegister("3xP8m", function(module, exports) {

$parcel$export(module.exports, "default", () => $19e2cb315ea3e8dc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9e76ab10079ddc5bd9646614f150b688>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $19e2cb315ea3e8dc$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "multipleFlags_softwareReleasesVersionDetailIssueList_jiraIssue",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        }
    ],
    "type": "JiraIssue"
};
$19e2cb315ea3e8dc$var$node.hash = "895bdec15c863c74e317666c4dea1c42";
var $19e2cb315ea3e8dc$export$2e2bcd8739ae039 = $19e2cb315ea3e8dc$var$node;

});

parcelRegister("da6LD", function(module, exports) {

$parcel$export(module.exports, "MultipleFlagsIcon", () => $214e5ca69c2f7c59$export$b02a1ce334df672e);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $koVbs = parcelRequire("koVbs");

var $2RGoh = parcelRequire("2RGoh");

var $exdGI = parcelRequire("exdGI");
const $214e5ca69c2f7c59$var$MultipleFlagsGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2RGoh))),
        alt: ""
    });
const $214e5ca69c2f7c59$export$b02a1ce334df672e = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        testId: "software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.multiple-flags.icon.multiple",
        size: "medium",
        glyph: $214e5ca69c2f7c59$var$MultipleFlagsGlyph,
        label: formatMessage((0, $exdGI.default).multipleFlagsIconLabel)
    });
};

});
parcelRegister("2RGoh", function(module, exports) {
module.exports = new URL("multiple-flags.fdb5d926.svg", import.meta.url).toString();

});

parcelRegister("exdGI", function(module, exports) {

$parcel$export(module.exports, "default", () => $2acd0735af8f7c7d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2acd0735af8f7c7d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    multipleFlagsIconLabel: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.icon.multiple-flags-icon-label",
        "defaultMessage": "Multiple feature flags"
    }
});

});


parcelRegister("l4isl", function(module, exports) {

$parcel$export(module.exports, "default", () => $5762788d5ba9fe91$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5762788d5ba9fe91$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    flags: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.flags",
        "defaultMessage": "{count} {count, plural, one {flag} other {flags}}"
    },
    tooltipLoading: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.tooltip-loading",
        "defaultMessage": "Loading..."
    }
});

});

parcelRegister("9UCV3", function(module, exports) {

$parcel$export(module.exports, "useTooltipContentQuery", () => $a81f9cffb9ef88ca$export$8f5a61dd01353b26);
$parcel$export(module.exports, "TooltipContent", () => $a81f9cffb9ef88ca$export$e9003e2be37ec060);

var $2yXS8 = parcelRequire("2yXS8");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $h4EJ8 = parcelRequire("h4EJ8");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $2yXS8 = parcelRequire("2yXS8");

var $86j5r = parcelRequire("86j5r");
const $a81f9cffb9ef88ca$var$MAX_DISPLAY_NAME_LENGTH = 32;
const $a81f9cffb9ef88ca$var$MAX_FLAGS_TO_SHOW = 3;
const $a81f9cffb9ef88ca$export$8f5a61dd01353b26 = (issueId)=>{
    const [queryRef, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $2yXS8.default));
    return [
        queryRef,
        ()=>loadQuery({
                issueId: issueId
            })
    ];
};
const $a81f9cffb9ef88ca$export$e9003e2be37ec060 = ({ queryReference: queryReference })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const result = (0, $8Uumt.usePreloadedQuery)((0, $2yXS8.default), queryReference);
    const { totalCount: totalCount, edges: edges } = result.devOps.entitiesByAssociations.featureFlagEntities;
    const featureFlags = edges?.flatMap((edge)=>edge?.node == null ? [] : [
            edge.node
        ]).map((node)=>({
            id: node.id,
            displayName: node.displayName.length > $a81f9cffb9ef88ca$var$MAX_DISPLAY_NAME_LENGTH ? (0, (/*@__PURE__*/$parcel$interopDefault($h4EJ8)))(node.displayName, {
                length: $a81f9cffb9ef88ca$var$MAX_DISPLAY_NAME_LENGTH,
                separator: ' '
            }) : node.displayName,
            enabled: node.summary.enabled
        }));
    const hiddenFlagsCount = Math.max(0, totalCount - $a81f9cffb9ef88ca$var$MAX_FLAGS_TO_SHOW);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a81f9cffb9ef88ca$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a81f9cffb9ef88ca$var$FeatureFlagList, null, featureFlags.map(({ id: id, displayName: displayName, enabled: enabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
            key: id
        }, enabled ? formatMessage((0, $86j5r.default).flagEnabled, {
            displayName: displayName
        }) : formatMessage((0, $86j5r.default).flagDisabled, {
            displayName: displayName
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a81f9cffb9ef88ca$var$MoreFlagsText, null, hiddenFlagsCount > 0 ? formatMessage((0, $86j5r.default).flagsHidden, {
        hiddenFlagsCount: hiddenFlagsCount
    }) : null));
};
const $a81f9cffb9ef88ca$var$containerStyles = (0, $8CUq3.xcss)({
    margin: 'space.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a81f9cffb9ef88ca$var$FeatureFlagList = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "ol", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_qtt8glyw _19bvidpf",
            __cmplp.className
        ])
    });
});
const $a81f9cffb9ef88ca$var$MoreFlagsText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2yXS8", function(module, exports) {

$parcel$export(module.exports, "default", () => $76366f3dadf05eaf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fbd43c099929d1939c8e2128492206d3>>
 * @relayHash 41cd8d72cd786835b67fae78de599312
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dff5c0a2fd12a20d8c39553c2a3cdae2a128b7c8518310de561d020720953cdc
const $76366f3dadf05eaf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueId"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "ids.0",
                    "variableName": "issueId"
                }
            ],
            "kind": "ListValue",
            "name": "ids"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 3
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "kind": "ScalarField",
        "name": "enabled"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "tooltipContentForVersionDetailsIssueCardFeatureFlagsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "DevOps",
                        "kind": "LinkedField",
                        "name": "devOps",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "DevOpsEntities",
                                    "kind": "LinkedField",
                                    "name": "entitiesByAssociations",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "args": v2 /*: any*/ ,
                                                "concreteType": "DevOpsFeatureFlagConnection",
                                                "kind": "LinkedField",
                                                "name": "featureFlagEntities",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "devOps.entitiesByAssociations.featureFlagEntities.totalCount"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "DevOpsFeatureFlagEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsFeatureFlag",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v4 /*: any*/ ,
                                                                            "action": "NONE",
                                                                            "path": "devOps.entitiesByAssociations.featureFlagEntities.edges.node.id"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v5 /*: any*/ ,
                                                                            "action": "NONE",
                                                                            "path": "devOps.entitiesByAssociations.featureFlagEntities.edges.node.displayName"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": {
                                                                                "concreteType": "DevOpsFeatureFlagSummary",
                                                                                "kind": "LinkedField",
                                                                                "name": "summary",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v6 /*: any*/ ,
                                                                                        "action": "NONE",
                                                                                        "path": "devOps.entitiesByAssociations.featureFlagEntities.edges.node.summary.enabled"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            "action": "NONE",
                                                                            "path": "devOps.entitiesByAssociations.featureFlagEntities.edges.node.summary"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "devOps.entitiesByAssociations.featureFlagEntities.edges"
                                                    }
                                                ],
                                                "storageKey": "featureFlagEntities(first:3)"
                                            },
                                            "action": "THROW",
                                            "path": "devOps.entitiesByAssociations.featureFlagEntities"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "devOps.entitiesByAssociations"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "devOps"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "tooltipContentForVersionDetailsIssueCardFeatureFlagsQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "DevOpsEntities",
                            "kind": "LinkedField",
                            "name": "entitiesByAssociations",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "DevOpsFeatureFlagConnection",
                                    "kind": "LinkedField",
                                    "name": "featureFlagEntities",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "concreteType": "DevOpsFeatureFlagEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "DevOpsFeatureFlag",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        {
                                                            "concreteType": "DevOpsFeatureFlagSummary",
                                                            "kind": "LinkedField",
                                                            "name": "summary",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "featureFlagEntities(first:3)"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "dff5c0a2fd12a20d8c39553c2a3cdae2a128b7c8518310de561d020720953cdc",
            "metadata": {},
            "name": "tooltipContentForVersionDetailsIssueCardFeatureFlagsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$76366f3dadf05eaf$var$node.hash = "c17feb1731a74b476c57976ce322ce68";
var $76366f3dadf05eaf$export$2e2bcd8739ae039 = $76366f3dadf05eaf$var$node;

});

parcelRegister("86j5r", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1d7a455c347b64d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a1d7a455c347b64d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    flagEnabled: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.tooltip-content.flag-enabled",
        "defaultMessage": "\u2018{displayName}\u2019 is on"
    },
    flagDisabled: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.tooltip-content.flag-disabled",
        "defaultMessage": "\u2018{displayName}\u2019 is off"
    },
    flagsHidden: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.tooltip-content.flags-hidden",
        "defaultMessage": "+ {hiddenFlagsCount} more"
    }
});

});



parcelRegister("hUdMc", function(module, exports) {

$parcel$export(module.exports, "SingleFlag", () => $53cb27a6594a4a93$export$c039c42a03fd637);

var $e86xE = parcelRequire("e86xE");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $h4EJ8 = parcelRequire("h4EJ8");

var $8Uumt = parcelRequire("8Uumt");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $7iXaF = parcelRequire("7iXaF");

var $6PLG2 = parcelRequire("6PLG2");
const $53cb27a6594a4a93$var$MAX_DISPLAY_NAME_LENGTH = 255;
const $53cb27a6594a4a93$export$c039c42a03fd637 = ({ summarisedFlags: summarisedFlags })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { mostRelevantDisplayName: mostRelevantDisplayName, mostRelevantEnabled: mostRelevantEnabled, mostRelevantRolloutPercentage: mostRelevantRolloutPercentage } = (0, $8Uumt.useFragment)((0, $e86xE.default), summarisedFlags);
    const truncatedDisplayName = mostRelevantDisplayName.length > $53cb27a6594a4a93$var$MAX_DISPLAY_NAME_LENGTH ? (0, (/*@__PURE__*/$parcel$interopDefault($h4EJ8)))(mostRelevantDisplayName, {
        length: $53cb27a6594a4a93$var$MAX_DISPLAY_NAME_LENGTH,
        separator: ' '
    }) : mostRelevantDisplayName;
    const renderTooltip = ()=>{
        if (!mostRelevantEnabled) return formatMessage((0, $6PLG2.default).flagDisabled, {
            displayName: truncatedDisplayName
        });
        if (mostRelevantRolloutPercentage == null) return formatMessage((0, $6PLG2.default).flagWithoutPercentage, {
            displayName: truncatedDisplayName
        });
        return formatMessage((0, $6PLG2.default).flagWithPercentage, {
            displayName: truncatedDisplayName,
            percentage: mostRelevantRolloutPercentage / 100
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        testId: "software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.single-flag.tooltip",
        content: renderTooltip(),
        onShow: (analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'featureFlagSummaryTooltip');
        },
        position: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($53cb27a6594a4a93$var$Container, null, mostRelevantEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iXaF.FlagEnabledIcon), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iXaF.FlagDisabledIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($53cb27a6594a4a93$var$TextContainer, null, mostRelevantRolloutPercentage != null ? `${formatMessage((0, $6PLG2.default).flagPercentageRollout, {
        featureFlagPercentageRollout: mostRelevantRolloutPercentage / 100
    })}` : null)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $53cb27a6594a4a93$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $53cb27a6594a4a93$var$TextContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1flu1nu9 _1a4cglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("e86xE", function(module, exports) {

$parcel$export(module.exports, "default", () => $79727ae8f9f00582$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5aad7f5364f82e7ffbeae52ea8540080>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $79727ae8f9f00582$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "singleFlag_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "mostRelevantDisplayName"
            },
            "action": "THROW",
            "path": "mostRelevantDisplayName"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "mostRelevantEnabled"
            },
            "action": "THROW",
            "path": "mostRelevantEnabled"
        },
        {
            "kind": "ScalarField",
            "name": "mostRelevantRolloutPercentage"
        }
    ],
    "type": "DevOpsSummarisedFeatureFlags"
};
$79727ae8f9f00582$var$node.hash = "5843724954a8e05bf3074b304ff85341";
var $79727ae8f9f00582$export$2e2bcd8739ae039 = $79727ae8f9f00582$var$node;

});

parcelRegister("7iXaF", function(module, exports) {

$parcel$export(module.exports, "FlagDisabledIcon", () => $07408c6f41b0ea2c$export$a94a5376ccc0e3fb);
$parcel$export(module.exports, "FlagEnabledIcon", () => $07408c6f41b0ea2c$export$b99b90244f32ccbf);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $koVbs = parcelRequire("koVbs");

var $hkpAm = parcelRequire("hkpAm");

var $dXL2G = parcelRequire("dXL2G");

var $aSWM1 = parcelRequire("aSWM1");
const $07408c6f41b0ea2c$var$size = 'medium';
const $07408c6f41b0ea2c$var$FlagDisabledGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hkpAm))),
        alt: ""
    });
const $07408c6f41b0ea2c$export$a94a5376ccc0e3fb = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        testId: "software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.single-flag.icons.disabled",
        size: $07408c6f41b0ea2c$var$size,
        glyph: $07408c6f41b0ea2c$var$FlagDisabledGlyph,
        label: formatMessage((0, $aSWM1.default).flagDisabledIconLabel)
    });
};
const $07408c6f41b0ea2c$var$FlagEnabledGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dXL2G))),
        alt: ""
    });
const $07408c6f41b0ea2c$export$b99b90244f32ccbf = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        testId: "software-releases-version-detail-issue-list.ui.issues.issue-card.feature-flags.single-flag.icons.enabled",
        size: $07408c6f41b0ea2c$var$size,
        glyph: $07408c6f41b0ea2c$var$FlagEnabledGlyph,
        label: formatMessage((0, $aSWM1.default).flagEnabledIconLabel)
    });
};

});
parcelRegister("hkpAm", function(module, exports) {
module.exports = new URL("flag-disabled.813c2320.svg", import.meta.url).toString();

});

parcelRegister("dXL2G", function(module, exports) {
module.exports = new URL("flag-enabled.1378f3de.svg", import.meta.url).toString();

});

parcelRegister("aSWM1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff8a8d8277a40fae$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ff8a8d8277a40fae$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    flagEnabledIconLabel: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.icons.flag-enabled-icon-label",
        "defaultMessage": "Feature flag enabled"
    },
    flagDisabledIconLabel: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.icons.flag-disabled-icon-label",
        "defaultMessage": "Feature flag disabled"
    }
});

});


parcelRegister("6PLG2", function(module, exports) {

$parcel$export(module.exports, "default", () => $49a7c2489c2b1676$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $49a7c2489c2b1676$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    flagDisabled: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.flag-disabled",
        "defaultMessage": "\u2018{displayName}\u2019 is off"
    },
    flagWithoutPercentage: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.flag-without-percentage",
        "defaultMessage": "\u2018{displayName}\u2019 is on"
    },
    flagWithPercentage: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.flag-with-percentage",
        "defaultMessage": "\u2018{displayName}\u2019 is on at {percentage, number, percent}"
    },
    flagPercentageRollout: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.flag-percentage-rollout",
        "defaultMessage": "{featureFlagPercentageRollout, number, percent}"
    }
});

});



parcelRegister("clzRD", function(module, exports) {

$parcel$export(module.exports, "MoreButton", () => $7d33bc58ccaeacb1$export$7f94856880993f27);
$parcel$export(module.exports, "OnHoverVisibility", () => $7d33bc58ccaeacb1$export$e7937791cac9c51b);

var $04lFO = parcelRequire("04lFO");

var $4Bkdr = parcelRequire("4Bkdr");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");

var $bJeNF = parcelRequire("bJeNF");

var $bU3PY = parcelRequire("bU3PY");

var $koVbs = parcelRequire("koVbs");

var $7mPT9 = parcelRequire("7mPT9");

var $4R6GH = parcelRequire("4R6GH");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $hnzOX = parcelRequire("hnzOX");

var $8vfmT = parcelRequire("8vfmT");

var $dLN1S = parcelRequire("dLN1S");
const $7d33bc58ccaeacb1$export$7f94856880993f27 = ({ jiraIssue: jiraIssue, jiraVersion: jiraVersion, hasWarnings: hasWarnings, hasOpenPullRequestWarning: hasOpenPullRequestWarning, hasFailingBuildsWarning: hasFailingBuildsWarning, hasUnreviewedCodeWarning: hasUnreviewedCodeWarning, hasOpenReviewWarning: hasOpenReviewWarning })=>{
    const issue = (0, $8Uumt.useFragment)((0, $4Bkdr.default), jiraIssue);
    const version = (0, $8Uumt.useFragment)((0, $04lFO.default), jiraVersion);
    const [isPopupOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [moveIssuesBetweenVersionsQueryReference, loadMoveIssuesBetweenVersionsQuery] = (0, $8vfmT.useMoveIssuesBetweenVersionsQuery)(version.project.id, 4, version.id);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const moreButtonRef = (0, $5uXOq.useRef)(null);
    const togglePopup = ()=>{
        if (hasWarnings) {
            const warnings = [];
            if (hasOpenPullRequestWarning) warnings.push('OPEN_PULL_REQUEST');
            if (hasFailingBuildsWarning) warnings.push('FAILING_BUILD');
            if (hasUnreviewedCodeWarning) warnings.push('UNREVIEWED_CODE');
            if (hasOpenReviewWarning) warnings.push('OPEN_REVIEW');
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'IssueWarningMoreButton'
            }), {
                warnings: warnings.toString()
            });
        }
        if (moveIssuesBetweenVersionsQueryReference == null) loadMoveIssuesBetweenVersionsQuery();
        setIsOpen(!isPopupOpen);
    };
    const handlePopupClose = ()=>{
        setIsOpen(false);
        if (moreButtonRef.current) requestAnimationFrame(()=>{
            moreButtonRef.current?.focus();
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7d33bc58ccaeacb1$export$e7937791cac9c51b, (0, $4R6GH.fg)('jfp_a11y_issue_view_release_move_focus_to_trigger') && {
        isPopupVisible: isPopupOpen
    }, (!!version.canAddAndRemoveIssues || hasWarnings) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hnzOX.default), {
        renderTrigger: ({ triggerProps: triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...triggerProps,
                ref: (0, $7mPT9.default)(triggerProps.ref, moreButtonRef),
                iconBefore: hasWarnings ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
                    testId: "software-releases-version-detail-issue-list.ui.issues.issue-card.more-button.issue-card-warning-more-button",
                    color: "var(--ds-icon-warning, #E56910)",
                    label: formatMessage((0, $dLN1S.default).moreVersions),
                    LEGACY_size: "medium",
                    spacing: "spacious"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                    spacing: "spacious",
                    label: formatMessage((0, $dLN1S.default).moreVersions, {
                        issueKey: issue.key
                    })
                }),
                onClick: togglePopup,
                onMouseOver: loadMoveIssuesBetweenVersionsQuery,
                appearance: "subtle",
                isSelected: isPopupOpen
            }),
        queryReference: moveIssuesBetweenVersionsQueryReference,
        jiraIssue: issue,
        onClose: handlePopupClose,
        isOpen: isPopupOpen
    }));
};
const $7d33bc58ccaeacb1$export$e7937791cac9c51b = ({ children: children, isPopupVisible: isPopupVisible })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1bsb1ylp _1wtl15vq _j9irewfl",
            "_1rxyhgya _qrawewfl",
            isPopupVisible && "_1wtlewfl"
        ])
    }, children);
const $7d33bc58ccaeacb1$var$styles = null;
const $7d33bc58ccaeacb1$var$stylesWithFocusWithin = null;
const $7d33bc58ccaeacb1$var$stylesWithVisibility = null;

});
parcelRegister("04lFO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7486d8f786777ea9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7122e0be96e2941d3d8936d1014528e8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7486d8f786777ea9$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "moreButton_softwareReleasesVersionDetailIssueList_jiraVersion",
        "selections": [
            {
                "kind": "RequiredField",
                "field": v0 /*: any*/ ,
                "action": "THROW",
                "path": "id"
            },
            {
                "kind": "ScalarField",
                "name": "canAddAndRemoveIssues"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "project.id"
                        }
                    ]
                },
                "action": "THROW",
                "path": "project"
            }
        ],
        "type": "JiraVersion"
    };
}();
$7486d8f786777ea9$var$node.hash = "e838cd21a0e90d2500f678bc796ae098";
var $7486d8f786777ea9$export$2e2bcd8739ae039 = $7486d8f786777ea9$var$node;

});

parcelRegister("4Bkdr", function(module, exports) {

$parcel$export(module.exports, "default", () => $68adbcce61fa137c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<877dfa62b9ef93692d02178709546477>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $68adbcce61fa137c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "moreButton_softwareReleasesVersionDetailIssueList_jiraIssue",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersions_jiraIssue"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        }
    ],
    "type": "JiraIssue"
};
$68adbcce61fa137c$var$node.hash = "fd443315ecfab8b84a64de9bab079996";
var $68adbcce61fa137c$export$2e2bcd8739ae039 = $68adbcce61fa137c$var$node;

});

parcelRegister("hnzOX", function(module, exports) {

$parcel$export(module.exports, "default", () => $34a1c6585b01a6bb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $34a1c6585b01a6bb$var$MoveVersions = (0, $kxZPA.lazy)(()=>Promise.resolve((parcelRequire("8vfmT"))).then((mod)=>mod.MoveIssuesBetweenVersions), {
    moduleId: "./src/packages/releases/move-issues-between-versions/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$34a1c6585b01a6bb$export$2e2bcd8739ae039 = ({ renderTrigger: renderTrigger, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async.jira.move.issues.between.versions",
        packageName: "jira-software-releases-move-issues-between-versions",
        teamName: "nova"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "move-issues-between-versions",
        fallback: renderTrigger({
            triggerProps: {},
            isLoading: true,
            isSelected: false
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34a1c6585b01a6bb$var$MoveVersions, {
        renderTrigger: renderTrigger,
        ...props
    })));

});
parcelRegister("8vfmT", function(module, exports) {

$parcel$export(module.exports, "useMoveIssuesBetweenVersionsQuery", () => $7a42401a5a2ee9e1$export$4d5ca68749a2d51a);
$parcel$export(module.exports, "MoveIssuesBetweenVersions", () => $7a42401a5a2ee9e1$export$1113ac51f1804da9);

var $dyZnA = parcelRequire("dyZnA");

var $lIQhE = parcelRequire("lIQhE");

var $fZROX = parcelRequire("fZROX");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $i8Qvm = parcelRequire("i8Qvm");

var $9fuVs = parcelRequire("9fuVs");

var $7CMCs = parcelRequire("7CMCs");

var $7NYq5 = parcelRequire("7NYq5");

var $lfTZh = parcelRequire("lfTZh");

var $jgJNO = parcelRequire("jgJNO");

var $fZROX = parcelRequire("fZROX");

var $npYQQ = parcelRequire("npYQQ");

var $gtvcr = parcelRequire("gtvcr");

var $hugbT = parcelRequire("hugbT");
const $7a42401a5a2ee9e1$export$4d5ca68749a2d51a = (projectAri, first, versionAri)=>{
    const [queryRef, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $fZROX.default));
    return [
        queryRef,
        ()=>loadQuery({
                projectAri: projectAri,
                first: first,
                versionAri: versionAri
            }, {
                fetchPolicy: 'store-or-network'
            })
    ];
};
const $7a42401a5a2ee9e1$export$56eba4b61234c117 = ({ queryReference: queryReference, jiraIssue: jiraIssue, onClose: onClose, isVersionPickerModalOpen: isVersionPickerModalOpen, setIsVersionPickerModalOpen: setIsVersionPickerModalOpen })=>{
    const { jira: jira } = (0, $8Uumt.usePreloadedQuery)((0, $fZROX.default), queryReference);
    const issue = (0, $8Uumt.useFragment)((0, $lIQhE.default), jiraIssue);
    const { version: version, versionsForProject: versionsForProject } = jira;
    const handleClose = ()=>{
        setIsVersionPickerModalOpen(false);
        onClose();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hugbT.VersionList), {
        jiraVersionEdges: versionsForProject.edges.filter(Boolean),
        jiraIssue: issue,
        jiraVersion: version,
        onVersionPickerModalOpen: ()=>{
            setIsVersionPickerModalOpen(true);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isVersionPickerModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "jira.move.issues.between.versions.version.picker",
        packageName: "jira-software-releases-move-issues-between-versions",
        teamName: "nova",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal // This is used to ignore issue click when move issue modal is opened and anywhere is clicked in/outside of the modal
    ), {
        testId: "software-releases-move-issues-between-versions.ui.move-issue-version-select-modal",
        autoFocus: false,
        width: "small",
        onClose: handleClose,
        messageId: "software-releases-move-issues-between-versions.ui.modal-dialog",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gtvcr.VersionPicker), {
        jiraVersion: version,
        jiraIssue: issue,
        onClose: handleClose
    }))))));
};
const $7a42401a5a2ee9e1$export$1113ac51f1804da9 = ({ renderTrigger: renderTrigger, jiraIssue: jiraIssue, queryReference: queryReference, isOpen: isOpen, onClose: onClose })=>{
    const [isVersionPickerModalOpen, setIsVersionPickerModalOpen] = (0, $5uXOq.useState)(false);
    const handleClose = ()=>{
        if (!isVersionPickerModalOpen) onClose();
    };
    const issue = (0, $8Uumt.useFragment)((0, $dyZnA.default), jiraIssue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7a42401a5a2ee9e1$var$HoverVisibilityControlWrapper, {
        isVisible: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        autoFocus: false,
        onClose: handleClose,
        placement: "left-start",
        messageId: "software-releases-move-issues-between-versions.ui.popup",
        messageType: "transactional",
        fallbackPlacements: [
            'left-end'
        ],
        content: ()=>queryReference != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
                name: "move-issues-between-versions-popup-content",
                fallback: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                "data-version-details-issue-click-ignore-target": (0, $npYQQ.ISSUE_CARD_CLICK_IGNORE_TARGET)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7a42401a5a2ee9e1$export$56eba4b61234c117, {
                isVersionPickerModalOpen: isVersionPickerModalOpen,
                jiraIssue: issue,
                onClose: onClose,
                queryReference: queryReference,
                setIsVersionPickerModalOpen: setIsVersionPickerModalOpen
            }))) : null,
        trigger: (triggerProps)=>renderTrigger({
                triggerProps: triggerProps,
                isSelected: isOpen,
                isLoading: false
            })
    }));
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $7a42401a5a2ee9e1$var$HoverVisibilityControlWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isVisible ? "_3um0ewfl" : "_3um015vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dyZnA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cc3bfeeb04099ed$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7333e707d2161a8b1aa1f22f627e1650>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7cc3bfeeb04099ed$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersions_jiraIssue",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersionsPopupContent_jiraIssue"
        }
    ],
    "type": "JiraIssue"
};
$7cc3bfeeb04099ed$var$node.hash = "a82d3697e92fea96f21c1bc4281c03e5";
var $7cc3bfeeb04099ed$export$2e2bcd8739ae039 = $7cc3bfeeb04099ed$var$node;

});

parcelRegister("lIQhE", function(module, exports) {

$parcel$export(module.exports, "default", () => $22f5da28b42399c7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bb939ed30ff6ba50b14702d8011d102a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $22f5da28b42399c7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersionsPopupContent_jiraIssue",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraIssue"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionPicker_VersionPicker_jiraIssue"
        }
    ],
    "type": "JiraIssue"
};
$22f5da28b42399c7$var$node.hash = "a7d48e98e04811f2286b41cb01a9419a";
var $22f5da28b42399c7$export$2e2bcd8739ae039 = $22f5da28b42399c7$var$node;

});

parcelRegister("fZROX", function(module, exports) {

$parcel$export(module.exports, "default", () => $83962715aa1bd50d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b0a8342d9fdd521c7874e63ec6e8e6c4>>
 * @relayHash fffb275f3c1642370db8ca26640d4d1d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0c62d9f35893c4558aa832a3da78fb1119e9bb8ef77a3c044ed4fd5a3679820f
const $83962715aa1bd50d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionAri"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionAri"
        }
    ], v4 = {
        "kind": "Literal",
        "name": "filter",
        "value": [
            "UNRELEASED"
        ]
    }, v5 = {
        "kind": "Variable",
        "name": "jiraProjectId",
        "variableName": "projectAri"
    }, v6 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v11 = [
        v4 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v5 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiMoveIssuesBetweenVersionsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersion"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "ui_softwareReleasesVersionPicker_VersionPicker_jiraVersion"
                                                }
                                            ],
                                            "type": "JiraVersion"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.version"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "versionsForProject",
                                    "args": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ],
                                    "concreteType": "JiraVersionConnection",
                                    "kind": "LinkedField",
                                    "name": "__moveIssuesBetweenVersions_versionsForProject_connection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraVersionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersionEdges"
                                                    },
                                                    v6 /*: any*/ ,
                                                    {
                                                        "concreteType": "JiraVersion",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v7 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.versionsForProject.edges"
                                        },
                                        v8 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.versionsForProject"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiMoveIssuesBetweenVersionsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "canAddAndRemoveIssues"
                                        },
                                        {
                                            "concreteType": "JiraVersionWarningConfig",
                                            "kind": "LinkedField",
                                            "name": "warningConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "openPullRequest"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "openReview"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "unreviewedCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "failingBuild"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectId"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "JiraVersion"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        },
                        {
                            "args": v11 /*: any*/ ,
                            "concreteType": "JiraVersionConnection",
                            "kind": "LinkedField",
                            "name": "versionsForProject",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraVersionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersion",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        },
                        {
                            "args": v11 /*: any*/ ,
                            "filters": [
                                "jiraProjectId",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "moveIssuesBetweenVersions_versionsForProject",
                            "kind": "LinkedHandle",
                            "name": "versionsForProject"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0c62d9f35893c4558aa832a3da78fb1119e9bb8ef77a3c044ed4fd5a3679820f",
            "metadata": {
                "connection": [
                    {
                        "count": "first",
                        "cursor": null,
                        "direction": "forward",
                        "path": [
                            "jira",
                            "versionsForProject"
                        ]
                    }
                ]
            },
            "name": "uiMoveIssuesBetweenVersionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$83962715aa1bd50d$var$node.hash = "58c061e61158c45d3f183de8ea9ac7ab";
var $83962715aa1bd50d$export$2e2bcd8739ae039 = $83962715aa1bd50d$var$node;

});

parcelRegister("gtvcr", function(module, exports) {

$parcel$export(module.exports, "VersionPicker", () => $f0f3778e1550dd46$export$c7c815960e157d78);
/* async.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7QSqG = parcelRequire("7QSqG");

var $eZJjh = parcelRequire("eZJjh");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f0f3778e1550dd46$var$LazyVersionsPicker = (0, $kxZPA.lazy)(()=>(parcelRequire("cWF3B")).then((module)=>module.VersionPicker), {
    moduleId: "./src/packages/releases/version-picker/src/ui/index.tsx"
});
const $f0f3778e1550dd46$var$LoadingModal = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f0f3778e1550dd46$export$43a792a870d28db2, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "large"
    })));
const $f0f3778e1550dd46$export$c7c815960e157d78 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "version-picker",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f0f3778e1550dd46$var$LoadingModal, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f0f3778e1550dd46$var$LazyVersionsPicker, props)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $f0f3778e1550dd46$export$43a792a870d28db2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1lit",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cWF3B", function(module, exports) {

let $96cabfe22173d6d0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $96cabfe22173d6d0$var$load("e2OtX").then(()=>parcelRequire('clYwT'));

});


parcelRegister("hugbT", function(module, exports) {

$parcel$export(module.exports, "VersionList", () => $b916df3f72fe85dc$export$e1d14e02661b0653);

var $3RlKc = parcelRequire("3RlKc");

var $hpfFy = parcelRequire("hpfFy");

var $ju0Iw = parcelRequire("ju0Iw");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $kJpBP = parcelRequire("kJpBP");
var $4mNf3 = parcelRequire("4mNf3");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $koVbs = parcelRequire("koVbs");

var $cDRap = parcelRequire("cDRap");

var $12diM = parcelRequire("12diM");

var $ghxT9 = parcelRequire("ghxT9");

var $d7ygY = parcelRequire("d7ygY");
const $b916df3f72fe85dc$export$e1d14e02661b0653 = ({ jiraVersionEdges: jiraVersionEdges, jiraIssue: jiraIssue, jiraVersion: jiraVersion, onVersionPickerModalOpen: onVersionPickerModalOpen })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const versions = (0, $8Uumt.useFragment)((0, $ju0Iw.default), jiraVersionEdges);
    const issue = (0, $8Uumt.useFragment)((0, $hpfFy.default), jiraIssue);
    const version = (0, $8Uumt.useFragment)((0, $3RlKc.default), jiraVersion);
    const originalJiraVersion = version.id;
    const allVersions = versions.filter(Boolean).filter((object)=>object.node.versionId !== version.versionId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), {
        maxWidth: 221
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cDRap.IssueWarning), {
        jiraIssue: issue,
        jiraVersion: version
    }), !!version.canAddAndRemoveIssues && allVersions.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4mNf3.default), null, formatMessage((0, $12diM.default).versionsListHeader)), allVersions.map((edge)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ghxT9.MoveIssueToOtherVersion), {
            originalJiraVersion: originalJiraVersion,
            jiraVersion: edge.node,
            key: edge.node.versionId,
            jiraIssue: issue
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        onClick: onVersionPickerModalOpen
    }, formatMessage((0, $12diM.default).otherVersionsButton))) : null, !!version.canAddAndRemoveIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d7ygY.RemoveIssueFromVersion), {
        originalJiraVersion: originalJiraVersion,
        jiraIssue: issue
    }));
};

});
parcelRegister("3RlKc", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d7d9e7aafd254a5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7d95a12b061ade2e68cb3366d9b4aafc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1d7d9e7aafd254a5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersion",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "versionId"
            },
            "action": "THROW",
            "path": "versionId"
        },
        {
            "kind": "ScalarField",
            "name": "canAddAndRemoveIssues"
        },
        {
            "kind": "FragmentSpread",
            "name": "issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$1d7d9e7aafd254a5$var$node.hash = "3401c25196bed99e751ba57506a3021b";
var $1d7d9e7aafd254a5$export$2e2bcd8739ae039 = $1d7d9e7aafd254a5$var$node;

});

parcelRegister("hpfFy", function(module, exports) {

$parcel$export(module.exports, "default", () => $64c032cce39f1530$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8ad8ccebd103a9c9dc8732c3a9fcce65>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $64c032cce39f1530$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraIssue",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "FragmentSpread",
            "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraIssue"
        },
        {
            "kind": "FragmentSpread",
            "name": "removeIssueFromVersion_softwareReleasesMoveIssuesBetweenVersions"
        },
        {
            "kind": "FragmentSpread",
            "name": "issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraIssue"
        }
    ],
    "type": "JiraIssue"
};
$64c032cce39f1530$var$node.hash = "9dbec216043d11ab3ebbdd111e565798";
var $64c032cce39f1530$export$2e2bcd8739ae039 = $64c032cce39f1530$var$node;

});

parcelRegister("ju0Iw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed43ad65a8d3006b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c6ed5cd1b7e4a57c0234a7709c1d5948>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ed43ad65a8d3006b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersionEdges",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "versionId"
                        },
                        "action": "NONE",
                        "path": "node.versionId"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraVersion"
                    }
                ]
            },
            "action": "NONE",
            "path": "node"
        }
    ],
    "type": "JiraVersionEdge"
};
$ed43ad65a8d3006b$var$node.hash = "62c56f9fefcd51f7cc6feffc9b24ce64";
var $ed43ad65a8d3006b$export$2e2bcd8739ae039 = $ed43ad65a8d3006b$var$node;

});

parcelRegister("cDRap", function(module, exports) {

$parcel$export(module.exports, "IssueWarning", () => $6c35bf5e55596cfb$export$40ff2db377648cee);

var $jaCvM = parcelRequire("jaCvM");

var $iEQdG = parcelRequire("iEQdG");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $4mNf3 = parcelRequire("4mNf3");
var $9UCCQ = parcelRequire("9UCCQ");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $9lAUN = parcelRequire("9lAUN");

var $ijekY = parcelRequire("ijekY");
const $6c35bf5e55596cfb$export$40ff2db377648cee = ({ jiraIssue: jiraIssue, jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const issue = (0, $8Uumt.useFragment)((0, $iEQdG.default), jiraIssue);
    const version = (0, $8Uumt.useFragment)((0, $jaCvM.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9lAUN.IssueWarningProvider), {
        jiraVersion: version,
        jiraIssue: issue
    }, ({ hasOpenPullRequestWarning: hasOpenPullRequestWarning, hasFailingBuildsWarning: hasFailingBuildsWarning, hasUnreviewedCodeWarning: hasUnreviewedCodeWarning, hasOpenReviewWarning: hasOpenReviewWarning })=>{
        const warningsMessages = [];
        if (hasOpenPullRequestWarning) warningsMessages.push((0, $ijekY.default).openPullRequest);
        if (hasFailingBuildsWarning) warningsMessages.push((0, $ijekY.default).failingBuilds);
        if (hasUnreviewedCodeWarning) warningsMessages.push((0, $ijekY.default).unreviewedCode);
        if (hasOpenReviewWarning) warningsMessages.push((0, $ijekY.default).openReviews);
        if (warningsMessages.length === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4mNf3.default), null, formatMessage((0, $ijekY.default).issueWarningHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6c35bf5e55596cfb$var$WarningDescription, null, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $ijekY.default).issueWarningIssueTerminologyRefreshM4 : (0, $ijekY.default).issueWarning, {
            warning: formatMessage(warningsMessages[0])
        })));
        if (warningsMessages.length > 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4mNf3.default), null, formatMessage((0, $ijekY.default).issueWarningHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6c35bf5e55596cfb$var$WarningDescription, null, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $ijekY.default).issueMultipleWarningsIssueTerminologyRefreshM4 : (0, $ijekY.default).issueMultipleWarnings)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6c35bf5e55596cfb$var$List, null, warningsMessages.map((warning)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6c35bf5e55596cfb$var$ListItem, {
                key: warning.id
            }, formatMessage(warning)))));
        return null;
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $6c35bf5e55596cfb$var$ListItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1dyx",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $6c35bf5e55596cfb$var$List = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyrgktf _18u0idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $6c35bf5e55596cfb$var$WarningDescription = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt494j5 _syaz1dyx",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jaCvM", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d31575f3bb7188a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fc806f27375ba559d72104dd3b1e5529>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9d31575f3bb7188a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraVersion",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$9d31575f3bb7188a$var$node.hash = "4337c06001af5c62a61021cb3fd03fad";
var $9d31575f3bb7188a$export$2e2bcd8739ae039 = $9d31575f3bb7188a$var$node;

});

parcelRegister("iEQdG", function(module, exports) {

$parcel$export(module.exports, "default", () => $4818d7c9fa4b9c8a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1c8e2786f37ec89f823a315d3db55e81>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4818d7c9fa4b9c8a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraIssue",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraIssue"
        }
    ],
    "type": "JiraIssue"
};
$4818d7c9fa4b9c8a$var$node.hash = "c07bf95905363410cf22a75dbe9a1754";
var $4818d7c9fa4b9c8a$export$2e2bcd8739ae039 = $4818d7c9fa4b9c8a$var$node;

});

parcelRegister("ijekY", function(module, exports) {

$parcel$export(module.exports, "default", () => $c20a1f7edd5d622a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c20a1f7edd5d622a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issueWarningHeader: {
        "id": "software-releases-move-issues-between-versions.version-list.issue-warning.issue-warning-header",
        "defaultMessage": "Warning"
    },
    issueWarning: {
        "id": "software-releases-move-issues-between-versions.version-list.issue-warning.issue-warning",
        "defaultMessage": "This issue has {warning}"
    },
    issueMultipleWarnings: {
        "id": "software-releases-move-issues-between-versions.version-list.issue-warning.issue-multiple-warnings",
        "defaultMessage": "This issue is done but has:"
    },
    openPullRequest: {
        "id": "software-releases-move-issues-between-versions.version-list.issue-warning.open-pull-request",
        "defaultMessage": "open pull requests"
    },
    failingBuilds: {
        "id": "software-releases-move-issues-between-versions.version-list.issue-warning.failing-builds",
        "defaultMessage": "failing builds"
    },
    unreviewedCode: {
        "id": "software-releases-move-issues-between-versions.version-list.issue-warning.unreviewed-code",
        "defaultMessage": "unreviewed code"
    },
    openReviews: {
        "id": "software-releases-move-issues-between-versions.version-list.issue-warning.open-reviews",
        "defaultMessage": "open reviews"
    },
    issueWarningIssueTerminologyRefreshM4: {
        "id": "software-releases-move-issues-between-versions.version-list.issue-warning.issue-warning-issue-terminology-refresh-m4",
        "defaultMessage": "This work item has {warning}"
    },
    issueMultipleWarningsIssueTerminologyRefreshM4: {
        "id": "software-releases-move-issues-between-versions.version-list.issue-warning.issue-multiple-warnings-issue-terminology-refresh-m4",
        "defaultMessage": "This work item is done but has:"
    }
});

});


parcelRegister("12diM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b93b84580cc1a62$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5b93b84580cc1a62$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    versionsListHeader: {
        "id": "software-releases-move-issues-between-versions.version-list.versions-list-header",
        "defaultMessage": "Move to"
    },
    otherVersionsButton: {
        "id": "software-releases-move-issues-between-versions.version-list.other-versions-button",
        "defaultMessage": "View all versions"
    }
});

});

parcelRegister("ghxT9", function(module, exports) {

$parcel$export(module.exports, "MoveIssueToOtherVersion", () => $9b7a96e7adf02006$export$7bc266f2ce749644);

var $d4bqt = parcelRequire("d4bqt");

var $lUTEp = parcelRequire("lUTEp");

var $4lOqP = parcelRequire("4lOqP");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $kJpBP = parcelRequire("kJpBP");

var $4R6GH = parcelRequire("4R6GH");

var $jcw0u = parcelRequire("jcw0u");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $kfztd = parcelRequire("kfztd");

var $20fNh = parcelRequire("20fNh");

var $5GInV = parcelRequire("5GInV");

var $S0LGk = parcelRequire("S0LGk");

var $lk6rS = parcelRequire("lk6rS");
const $9b7a96e7adf02006$export$7bc266f2ce749644 = ({ jiraVersion: jiraVersion, jiraIssue: jiraIssue, originalJiraVersion: originalJiraVersion })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const issue = (0, $8Uumt.useFragment)((0, $4lOqP.default), jiraIssue);
    const version = (0, $8Uumt.useFragment)((0, $lUTEp.default), jiraVersion);
    const [moveIssuesToFixVersion] = (0, $8Uumt.useMutation)((0, $d4bqt.default));
    const { filters: filters, sortBy: sortBy } = (0, $20fNh.useVersionIssuesGraphQLVariables)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'button'
    });
    const experienceStart = (0, $5GInV.useMoveIssuesBetweenVersionsExperienceStart)();
    const experienceFail = (0, $5GInV.useMoveIssuesBetweenVersionsExperienceFail)();
    const experienceSuccess = (0, $5GInV.useMoveIssuesBetweenVersionsExperienceSuccess)();
    const onError = (err)=>{
        showFlag({
            type: 'error',
            title: formatMessage((0, $S0LGk.default).errorFlagDescription, {
                issueKey: issue.key,
                versionName: version.name
            }),
            messageId: 'software-releases-move-issues-between-versions.ui.version-list.move-issue-to-other-version.show-flag.error.on-error.show-flag.error',
            messageType: 'transactional'
        });
        experienceFail('graphql error', err);
        (0, $jcw0u.default)({
            error: err,
            meta: {
                id: 'jira.releases.remove-issue-from-version.mutation',
                packageName: 'jiraSoftwareReleasesMoveIssuesBetweenVersions',
                teamName: 'nova'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const onErrorWithPermissionValidationEnabled = (issueKey, issuesWithMissingResolvePermission, issuesWithMissingEditPermission)=>{
        const error = (0, $lk6rS.getErrorMessage)(issueKey, issuesWithMissingResolvePermission, issuesWithMissingEditPermission, formatMessage);
        showFlag({
            type: 'error',
            title: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $S0LGk.default).errorFlagTitleIssueTerminologyRefreshM4 : (0, $S0LGk.default).errorFlagTitle),
            description: error,
            messageId: 'software-releases-move-issues-between-versions.ui.version-list.move-issue-to-other-version.show-flag.error.on-error-with-permission-validation-enabled.show-flag.error',
            messageType: 'transactional'
        });
        experienceFail('graphql error', new Error(error));
        (0, $jcw0u.default)({
            error: new Error(error),
            meta: {
                id: 'jira.releases.remove-issue-from-version.mutation',
                packageName: 'jiraSoftwareReleasesMoveIssuesBetweenVersions',
                teamName: 'nova'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const onUpdateVersion = ()=>{
        moveIssuesToFixVersion({
            variables: {
                input: {
                    issueIds: [
                        issue.id
                    ],
                    originalVersionId: originalJiraVersion,
                    targetVersionId: version.id
                },
                isDevopsFeatureDisabledInFedRamp: (0, $kfztd.isDevopsFeatureDisabledInFedRamp)(),
                shouldIncludeDevOpsFieldsViaAgs: !(0, $kfztd.isDevopsFeatureDisabledInFedRamp)(),
                filters: filters,
                sortBy: sortBy
            },
            onCompleted: (data)=>{
                if (data?.jira?.moveIssuesToFixVersion?.success !== true) onErrorWithPermissionValidationEnabled(issue.key, data?.jira?.moveIssuesToFixVersion?.issuesWithMissingResolvePermission, data?.jira?.moveIssuesToFixVersion?.issuesWithMissingEditPermission);
                else {
                    const flagText = formatMessage((0, $S0LGk.default).successFlagDescription, {
                        issueKey: issue.key,
                        versionName: version.name
                    });
                    showFlag({
                        type: 'success',
                        title: flagText,
                        messageId: 'software-releases-move-issues-between-versions.ui.version-list.move-issue-to-other-version.show-flag.success.on-completed.show-flag.success',
                        messageType: 'transactional'
                    });
                    experienceSuccess();
                }
            },
            onError: onError
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'moveIssueToVersion');
            experienceStart();
            onUpdateVersion();
        }
    }, version.name);
};

});
parcelRegister("d4bqt", function(module, exports) {

$parcel$export(module.exports, "default", () => $347899009fdc432b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1f742146063c0eef84f5e3e8e6973a3b>>
 * @relayHash 07b96563baf5d018afb7d88ebd41d028
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID de92db525f29aacdea6702bef5f5eaa0758d1c12bf49b6b04be053e62b09848a
const $347899009fdc432b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filters"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDevopsFeatureDisabledInFedRamp"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldIncludeDevOpsFieldsViaAgs"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "success"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "message"
        }
    ], v8 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": v7 /*: any*/ 
    }, v9 = {
        "kind": "ScalarField",
        "name": "issuesWithMissingResolvePermission"
    }, v10 = {
        "kind": "ScalarField",
        "name": "issuesWithMissingEditPermission"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "kind": "Literal",
        "name": "filter",
        "value": "ALL"
    }, v13 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v14 = [
        v13 /*: any*/ 
    ], v15 = {
        "kind": "ScalarField",
        "name": "key"
    }, v16 = {
        "kind": "ScalarField",
        "name": "name"
    }, v17 = {
        "kind": "ScalarField",
        "name": "collapsedUis"
    }, v18 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v19 = {
        "kind": "ScalarField",
        "name": "status"
    }, v20 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v21 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v22 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v23 = {
        "kind": "ScalarField",
        "name": "description"
    }, v24 = [
        v12 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        {
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy"
        }
    ], v25 = {
        "kind": "ScalarField",
        "name": "count"
    }, v26 = {
        "kind": "ScalarField",
        "name": "state"
    }, v27 = {
        "concreteType": "DevOpsSummarisedBuildState",
        "kind": "LinkedField",
        "name": "buildStates",
        "plural": true,
        "selections": [
            v26 /*: any*/ ,
            v25 /*: any*/ 
        ]
    }, v28 = [
        v25 /*: any*/ 
    ], v29 = {
        "kind": "ScalarField",
        "name": "title"
    }, v30 = [
        v25 /*: any*/ ,
        v11 /*: any*/ 
    ], v31 = {
        "concreteType": "DevOpsSummarisedDeployments",
        "kind": "LinkedField",
        "name": "summarisedDeployments",
        "plural": false,
        "selections": v30 /*: any*/ 
    }, v32 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v33 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v34 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v35 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersionsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraMoveIssuesToFixVersionPayload",
                            "kind": "LinkedField",
                            "name": "moveIssuesToFixVersion",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "originalVersion",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "addRelatedWorkPopup_softwareReleasesAddRelatedWorkToVersion_jiraVersion"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "issueTotalCount_softwareReleasesVersionDetailIssueList"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersionsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraMoveIssuesToFixVersionPayload",
                            "kind": "LinkedField",
                            "name": "moveIssuesToFixVersion",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "originalVersion",
                                    "plural": false,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "canEditRelatedWork"
                                        },
                                        {
                                            "alias": "allIssues",
                                            "args": [
                                                v12 /*: any*/ 
                                            ],
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": v14 /*: any*/ ,
                                            "storageKey": "issues(filter:\"ALL\")"
                                        },
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectId"
                                                },
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cloudId"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filter",
                                                            "value": {
                                                                "maxHierarchyLevel": 1,
                                                                "minHierarchyLevel": 1
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueTypeConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypes",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueTypeEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                            "kind": "LinkedField",
                                                                            "name": "hierarchy",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v16 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v11 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "issueTypes(filter:{\"maxHierarchyLevel\":1,\"minHierarchyLevel\":1})"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectStyle"
                                                }
                                            ]
                                        },
                                        {
                                            "alias": "allIssuesRedesignTemp",
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": v14 /*: any*/ 
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "canAddAndRemoveIssues"
                                        },
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "startDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "releaseDate"
                                        },
                                        v19 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "versionId"
                                        },
                                        {
                                            "concreteType": "JiraVersionDriverResult",
                                            "kind": "LinkedField",
                                            "name": "driverData",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "driver",
                                                    "plural": false,
                                                    "selections": [
                                                        v20 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "queryError",
                                                    "plural": false,
                                                    "selections": v7 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v23 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        {
                                            "concreteType": "JiraVersionWarningConfig",
                                            "kind": "LinkedField",
                                            "name": "warningConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "openPullRequest"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "openReview"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "unreviewedCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "failingBuild"
                                                },
                                                v18 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraVersionConnectAddonIframeData",
                                            "kind": "LinkedField",
                                            "name": "connectAddonIframeData",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "appKey"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "moduleKey"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "appName"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "location"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "options"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "canViewDevTools"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "versionIssueTableHiddenColumns"
                                        },
                                        {
                                            "alias": "issuesForList",
                                            "args": v24 /*: any*/ ,
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": [
                                                v13 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jql"
                                                },
                                                {
                                                    "concreteType": "JiraIssueEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v15 /*: any*/ ,
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "ids",
                                                                            "value": [
                                                                                "priority",
                                                                                "summary",
                                                                                "assignee",
                                                                                "status",
                                                                                "issuetype"
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldsById",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v20 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "fieldId"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "statusCategory",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "statusCategoryId"
                                                                                                                },
                                                                                                                v11 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v11 /*: any*/ ,
                                                                                                        v16 /*: any*/ ,
                                                                                                        v23 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusField"
                                                                                        },
                                                                                        v11 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        v22 /*: any*/ ,
                                                                                                        v16 /*: any*/ ,
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "text"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraSingleLineTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v16 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "xsmall"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v16 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "iconUrl"
                                                                                                        },
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraPriorityField"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "issueId"
                                                                },
                                                                {
                                                                    "concreteType": "DevOpsSummarisedFeatureFlags",
                                                                    "kind": "LinkedField",
                                                                    "name": "summarisedFeatureFlags",
                                                                    "plural": false,
                                                                    "selections": v14 /*: any*/ 
                                                                },
                                                                v20 /*: any*/ ,
                                                                {
                                                                    "condition": "isDevopsFeatureDisabledInFedRamp",
                                                                    "kind": "Condition",
                                                                    "passingValue": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedEntities",
                                                                            "kind": "LinkedField",
                                                                            "name": "devOpsSummarisedEntities",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedDeployments",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "summarisedDeployments",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v25 /*: any*/ ,
                                                                                        v11 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "deploymentState"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "DevOpsEnvironment",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "deploymentEnvironment",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "category"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedBuilds",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "summarisedBuilds",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v25 /*: any*/ ,
                                                                                        v11 /*: any*/ ,
                                                                                        v27 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraIssueDevSummaryResult",
                                                                            "kind": "LinkedField",
                                                                            "name": "devSummaryCache",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueDevSummary",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "devSummary",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "pullrequest",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssuePullRequestDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "branch",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueBranchDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": v28 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "review",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueReviewDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        v26 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "lastUpdated"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "stateCount"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraIssueDevSummaryByProvider",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "summaryByProvider",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "providerId"
                                                                                                        },
                                                                                                        v16 /*: any*/ ,
                                                                                                        v25 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "commit",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueCommitDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": v28 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "build",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueBuildDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "failedBuildCount"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "successfulBuildCount"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "unknownBuildCount"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "deploymentEnvironments",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueDeploymentEnvironment",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "topEnvironments",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ ,
                                                                                                                v29 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedFeatureFlags",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedFeatureFlags",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "mostRelevantDisplayName"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "mostRelevantEnabled"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "mostRelevantRolloutPercentage"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                v31 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedBuilds",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "summarisedBuilds",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v27 /*: any*/ ,
                                                                                        v25 /*: any*/ ,
                                                                                        v11 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        v31 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedBuilds",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedBuilds",
                                                                            "plural": false,
                                                                            "selections": v30 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v32 /*: any*/ 
                                                    ]
                                                },
                                                v33 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "alias": "issuesForList",
                                            "args": v24 /*: any*/ ,
                                            "filters": [
                                                "filter",
                                                "sortBy",
                                                "filters"
                                            ],
                                            "handle": "connection",
                                            "key": "ListVersion_issuesForList",
                                            "kind": "LinkedHandle",
                                            "name": "issues"
                                        },
                                        v17 /*: any*/ ,
                                        {
                                            "args": v34 /*: any*/ ,
                                            "concreteType": "JiraVersionApproverConnection",
                                            "kind": "LinkedField",
                                            "name": "approvers",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraVersionApproverEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersionApprover",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v20 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "AtlassianAccountUserExtendedProfile",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "extendedProfile",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "jobTitle"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "AtlassianAccountUser"
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        v21 /*: any*/ 
                                                                    ]
                                                                },
                                                                v19 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "declineReason"
                                                                },
                                                                v23 /*: any*/ ,
                                                                v35 /*: any*/ ,
                                                                v20 /*: any*/ 
                                                            ]
                                                        },
                                                        v32 /*: any*/ 
                                                    ]
                                                },
                                                v33 /*: any*/ 
                                            ],
                                            "storageKey": "approvers(first:100)"
                                        },
                                        {
                                            "args": v34 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "version_approvers",
                                            "kind": "LinkedHandle",
                                            "name": "approvers"
                                        },
                                        {
                                            "concreteType": "JiraVersionRichTextSection",
                                            "kind": "LinkedField",
                                            "name": "richTextSection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraADF",
                                                    "kind": "LinkedField",
                                                    "name": "content",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "json"
                                                        }
                                                    ]
                                                },
                                                v29 /*: any*/ 
                                            ]
                                        },
                                        v35 /*: any*/ ,
                                        {
                                            "condition": "isDevopsFeatureDisabledInFedRamp",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "concreteType": "DevOpsSummarisedEntities",
                                                    "kind": "LinkedField",
                                                    "name": "devOpsSummarisedEntities",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsProviders",
                                                            "kind": "LinkedField",
                                                            "name": "providers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsFeatureFlagProvider",
                                                                    "kind": "LinkedField",
                                                                    "name": "featureFlagProviders",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v20 /*: any*/ ,
                                                                        v11 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "createFeatureFlagTemplateUrl"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "connectFeatureFlagTemplateUrl"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "logoUrl"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "de92db525f29aacdea6702bef5f5eaa0758d1c12bf49b6b04be053e62b09848a",
            "metadata": {},
            "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersionsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$347899009fdc432b$var$node.hash = "99186247cd88cec5255d60a17909165e";
var $347899009fdc432b$export$2e2bcd8739ae039 = $347899009fdc432b$var$node;

});

parcelRegister("lUTEp", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa929e2e516e29fb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fca745311578f3101b6fa0e65717a6fb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $aa929e2e516e29fb$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraVersion",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        }
    ],
    "type": "JiraVersion"
};
$aa929e2e516e29fb$var$node.hash = "84a88afd5bdd1daa65b86ea3c2e3ac4e";
var $aa929e2e516e29fb$export$2e2bcd8739ae039 = $aa929e2e516e29fb$var$node;

});

parcelRegister("4lOqP", function(module, exports) {

$parcel$export(module.exports, "default", () => $903c8d96330806be$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0944c4d992234c1aa8d6cf7cf7334012>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $903c8d96330806be$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraIssue",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        }
    ],
    "type": "JiraIssue"
};
$903c8d96330806be$var$node.hash = "970de75536631065f879841e95abf41b";
var $903c8d96330806be$export$2e2bcd8739ae039 = $903c8d96330806be$var$node;

});

parcelRegister("5GInV", function(module, exports) {

$parcel$export(module.exports, "useMoveIssuesBetweenVersionsExperienceStart", () => $aec61e2addafe240$export$b93744d3b3f8b975);
$parcel$export(module.exports, "useMoveIssuesBetweenVersionsExperienceFail", () => $aec61e2addafe240$export$476b47bb3c16d45a);
$parcel$export(module.exports, "useMoveIssuesBetweenVersionsExperienceSuccess", () => $aec61e2addafe240$export$a7bd95f0cc752718);

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $efvDm = parcelRequire("efvDm");

var $k9JTq = parcelRequire("k9JTq");
const $aec61e2addafe240$export$52919046b94109dc = 'moveIssueBetweenVersions';
const $aec61e2addafe240$var$ANALYTICS_SOURCE = 'versionDetails';
const $aec61e2addafe240$export$b93744d3b3f8b975 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    return (0, $kaHBi.useExperienceStart)({
        experience: $aec61e2addafe240$export$52919046b94109dc,
        experienceId: `${Date.now()}`,
        analyticsSource: $aec61e2addafe240$var$ANALYTICS_SOURCE,
        application: (0, $efvDm.JIRA_SOFTWARE),
        edition: appEditions.software
    });
};
const $aec61e2addafe240$export$476b47bb3c16d45a = ()=>(0, $93jKl.useExperienceFail)({
        experience: $aec61e2addafe240$export$52919046b94109dc
    });
const $aec61e2addafe240$export$a7bd95f0cc752718 = ()=>(0, $3bQtK.useExperienceSuccess)({
        experience: $aec61e2addafe240$export$52919046b94109dc
    });

});

parcelRegister("S0LGk", function(module, exports) {

$parcel$export(module.exports, "default", () => $7671e2cbd0abe366$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7671e2cbd0abe366$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorFlagTitle: {
        "id": "software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.error-flag-title",
        "defaultMessage": "Can't move this issue to another version"
    },
    errorFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.error-flag-description",
        "defaultMessage": "We couldn't move {issueKey} to {versionName}. Please try again."
    },
    successFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.success-flag-description",
        "defaultMessage": "{issueKey} has been moved to {versionName}."
    },
    missingResolvePermissionErrorgFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.missing-resolve-permission-errorg-flag-description",
        "defaultMessage": "You don't have permission to resolve {issueKey}, so you can't move it to another version."
    },
    missingEditPermissionErrorFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.missing-edit-permission-error-flag-description",
        "defaultMessage": "You don't have permission to edit {issueKey}, so you can't move it to another version."
    },
    missingPermissionsErrorFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.missing-permissions-error-flag-description",
        "defaultMessage": "You don't have permission to edit or resolve {issueKey}, so you can't move it to another version."
    },
    errorFlagTitleIssueTerminologyRefreshM4: {
        "id": "software-releases-move-issues-between-versions.version-list.move-issue-to-other-version.error-flag-title-issue-terminology-refresh-m4",
        "defaultMessage": "Can't move this work item to another version"
    }
});

});

parcelRegister("lk6rS", function(module, exports) {

$parcel$export(module.exports, "getErrorMessage", () => $af4587f909f032d4$export$82f46aa4e6535a45);

var $S0LGk = parcelRequire("S0LGk");
const $af4587f909f032d4$export$82f46aa4e6535a45 = (issueKey, issuesWithMissingResolvePermission, issuesWithMissingEditPermission, formatMessage)=>{
    const issueIsMissingResolvePermission = issuesWithMissingResolvePermission !== null && issuesWithMissingResolvePermission !== undefined && issuesWithMissingResolvePermission.length > 0;
    const issueIsMissingEditPermission = issuesWithMissingEditPermission !== null && issuesWithMissingEditPermission !== undefined && issuesWithMissingEditPermission.length > 0;
    if (issueIsMissingResolvePermission && issueIsMissingEditPermission) return formatMessage((0, $S0LGk.default).missingPermissionsErrorFlagDescription, {
        issueKey: issueKey
    });
    if (issueIsMissingResolvePermission) return formatMessage((0, $S0LGk.default).missingResolvePermissionErrorgFlagDescription, {
        issueKey: issueKey
    });
    if (issueIsMissingEditPermission) return formatMessage((0, $S0LGk.default).missingEditPermissionErrorFlagDescription, {
        issueKey: issueKey
    });
    return formatMessage((0, $S0LGk.default).errorFlagDescription);
};

});


parcelRegister("d7ygY", function(module, exports) {

$parcel$export(module.exports, "RemoveIssueFromVersion", () => $fd3c14d5a3eb9058$export$d34fb821a58a3d5c);

var $fq1A6 = parcelRequire("fq1A6");

var $2uHyI = parcelRequire("2uHyI");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $kJpBP = parcelRequire("kJpBP");
var $9UCCQ = parcelRequire("9UCCQ");

var $4R6GH = parcelRequire("4R6GH");

var $jcw0u = parcelRequire("jcw0u");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $kfztd = parcelRequire("kfztd");

var $20fNh = parcelRequire("20fNh");

var $68iZl = parcelRequire("68iZl");

var $cMnUo = parcelRequire("cMnUo");

var $gMbdf = parcelRequire("gMbdf");
const $fd3c14d5a3eb9058$export$d34fb821a58a3d5c = ({ jiraIssue: jiraIssue, originalJiraVersion: originalJiraVersion })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const issue = (0, $8Uumt.useFragment)((0, $2uHyI.default), jiraIssue);
    const [removeIssuesFromFixVersion] = (0, $8Uumt.useMutation)((0, $fq1A6.default));
    const { filters: filters, sortBy: sortBy } = (0, $20fNh.useVersionIssuesGraphQLVariables)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'button'
    });
    const experienceStart = (0, $68iZl.useRemoveIssueFromVersionExperienceStart)();
    const experienceFail = (0, $68iZl.useRemoveIssueFromVersionExperienceFail)();
    const experienceSuccess = (0, $68iZl.useRemoveIssueFromVersionExperienceSuccess)();
    const onError = (err)=>{
        showFlag({
            type: 'error',
            title: formatMessage((0, $cMnUo.default).errorFlagDescription, {
                issueKey: issue.key
            }),
            messageId: 'software-releases-move-issues-between-versions.ui.version-list.remove-issue-from-version.show-flag.error.on-error.show-flag.error',
            messageType: 'transactional'
        });
        experienceFail('graphql error', err);
        (0, $jcw0u.default)({
            error: err,
            meta: {
                id: 'jira.releases.remove-issue-from-version.mutation',
                packageName: 'jiraSoftwareReleasesMoveIssuesBetweenVersions',
                teamName: 'nova'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const onErrorWithPermissionValidationEnabled = (issueKey, issuesWithMissingResolvePermission, issuesWithMissingEditPermission)=>{
        const error = (0, $gMbdf.getErrorMessage)(issueKey, issuesWithMissingResolvePermission, issuesWithMissingEditPermission, formatMessage);
        showFlag({
            type: 'error',
            title: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $cMnUo.default).errorFlagTitleIssueTerminologyRefreshM4 : (0, $cMnUo.default).errorFlagTitle),
            description: error,
            messageId: 'software-releases-move-issues-between-versions.ui.version-list.remove-issue-from-version.show-flag.error.on-error-with-permission-validation-enabled.show-flag.error',
            messageType: 'transactional'
        });
        experienceFail('graphql error', new Error(error));
        (0, $jcw0u.default)({
            error: new Error(error),
            meta: {
                id: 'jira.releases.remove-issue-from-version.mutation',
                packageName: 'jiraSoftwareReleasesMoveIssuesBetweenVersions',
                teamName: 'nova'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const onUpdateVersion = ()=>{
        removeIssuesFromFixVersion({
            variables: {
                input: {
                    issueIds: [
                        issue.id
                    ],
                    versionId: originalJiraVersion
                },
                isDevopsFeatureDisabledInFedRamp: (0, $kfztd.isDevopsFeatureDisabledInFedRamp)(),
                shouldIncludeDevOpsFieldsViaAgs: !(0, $kfztd.isDevopsFeatureDisabledInFedRamp)(),
                filters: filters,
                sortBy: sortBy
            },
            onCompleted: (data)=>{
                if (data?.jira?.removeIssuesFromFixVersion?.success !== true) {
                    const issuesWithMissingResolvePermission = data?.jira?.removeIssuesFromFixVersion?.issuesWithMissingResolvePermission || [];
                    const issuesWithMissingEditPermission = data?.jira?.removeIssuesFromFixVersion?.issuesWithMissingEditPermission || [];
                    onErrorWithPermissionValidationEnabled(issue.key, issuesWithMissingResolvePermission, issuesWithMissingEditPermission);
                } else {
                    const flagText = formatMessage((0, $cMnUo.default).successFlagDescription, {
                        issueKey: issue.key
                    });
                    experienceSuccess();
                    showFlag({
                        type: 'success',
                        title: flagText,
                        messageId: 'software-releases-move-issues-between-versions.ui.version-list.remove-issue-from-version.show-flag.success.on-completed.show-flag.success',
                        messageType: 'transactional'
                    });
                }
            },
            onError: onError
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'removeIssueFromVersion');
            experienceStart();
            onUpdateVersion();
        }
    }, formatMessage((0, $cMnUo.default).removeButtonTitle)));
};

});
parcelRegister("fq1A6", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c5aca855535074d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<048a25f0eb2b91c880f3ec4e02520d92>>
 * @relayHash 9fc7a217877cb0958ee863b6eb2a80bc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1253732741586594cf8f5534298cd71ff14d6728edf8b0bf38c41fff0eae663b
const $4c5aca855535074d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filters"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDevopsFeatureDisabledInFedRamp"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldIncludeDevOpsFieldsViaAgs"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "success"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "message"
        }
    ], v8 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": v7 /*: any*/ 
    }, v9 = {
        "kind": "ScalarField",
        "name": "issuesWithMissingResolvePermission"
    }, v10 = {
        "kind": "ScalarField",
        "name": "issuesWithMissingEditPermission"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "kind": "Literal",
        "name": "filter",
        "value": "ALL"
    }, v13 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v14 = [
        v13 /*: any*/ 
    ], v15 = {
        "kind": "ScalarField",
        "name": "key"
    }, v16 = {
        "kind": "ScalarField",
        "name": "name"
    }, v17 = {
        "kind": "ScalarField",
        "name": "collapsedUis"
    }, v18 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v19 = {
        "kind": "ScalarField",
        "name": "status"
    }, v20 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v21 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v22 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v23 = {
        "kind": "ScalarField",
        "name": "description"
    }, v24 = [
        v12 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        {
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy"
        }
    ], v25 = {
        "kind": "ScalarField",
        "name": "count"
    }, v26 = {
        "kind": "ScalarField",
        "name": "state"
    }, v27 = {
        "concreteType": "DevOpsSummarisedBuildState",
        "kind": "LinkedField",
        "name": "buildStates",
        "plural": true,
        "selections": [
            v26 /*: any*/ ,
            v25 /*: any*/ 
        ]
    }, v28 = [
        v25 /*: any*/ 
    ], v29 = {
        "kind": "ScalarField",
        "name": "title"
    }, v30 = [
        v25 /*: any*/ ,
        v11 /*: any*/ 
    ], v31 = {
        "concreteType": "DevOpsSummarisedDeployments",
        "kind": "LinkedField",
        "name": "summarisedDeployments",
        "plural": false,
        "selections": v30 /*: any*/ 
    }, v32 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v33 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v34 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v35 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "removeIssueFromVersion_softwareReleasesMoveIssuesBetweenVersionsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraRemoveIssuesFromFixVersionPayload",
                            "kind": "LinkedField",
                            "name": "removeIssuesFromFixVersion",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "addRelatedWorkPopup_softwareReleasesAddRelatedWorkToVersion_jiraVersion"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "issueTotalCount_softwareReleasesVersionDetailIssueList"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "removeIssueFromVersion_softwareReleasesMoveIssuesBetweenVersionsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraRemoveIssuesFromFixVersionPayload",
                            "kind": "LinkedField",
                            "name": "removeIssuesFromFixVersion",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "canEditRelatedWork"
                                        },
                                        {
                                            "alias": "allIssues",
                                            "args": [
                                                v12 /*: any*/ 
                                            ],
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": v14 /*: any*/ ,
                                            "storageKey": "issues(filter:\"ALL\")"
                                        },
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectId"
                                                },
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cloudId"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filter",
                                                            "value": {
                                                                "maxHierarchyLevel": 1,
                                                                "minHierarchyLevel": 1
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueTypeConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypes",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueTypeEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                            "kind": "LinkedField",
                                                                            "name": "hierarchy",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v16 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v11 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "issueTypes(filter:{\"maxHierarchyLevel\":1,\"minHierarchyLevel\":1})"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectStyle"
                                                }
                                            ]
                                        },
                                        {
                                            "alias": "allIssuesRedesignTemp",
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": v14 /*: any*/ 
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "canAddAndRemoveIssues"
                                        },
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "startDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "releaseDate"
                                        },
                                        v19 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "versionId"
                                        },
                                        {
                                            "concreteType": "JiraVersionDriverResult",
                                            "kind": "LinkedField",
                                            "name": "driverData",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "driver",
                                                    "plural": false,
                                                    "selections": [
                                                        v20 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "queryError",
                                                    "plural": false,
                                                    "selections": v7 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v23 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        {
                                            "concreteType": "JiraVersionWarningConfig",
                                            "kind": "LinkedField",
                                            "name": "warningConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "openPullRequest"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "openReview"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "unreviewedCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "failingBuild"
                                                },
                                                v18 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraVersionConnectAddonIframeData",
                                            "kind": "LinkedField",
                                            "name": "connectAddonIframeData",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "appKey"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "moduleKey"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "appName"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "location"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "options"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "canViewDevTools"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "versionIssueTableHiddenColumns"
                                        },
                                        {
                                            "alias": "issuesForList",
                                            "args": v24 /*: any*/ ,
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": [
                                                v13 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jql"
                                                },
                                                {
                                                    "concreteType": "JiraIssueEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v15 /*: any*/ ,
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "ids",
                                                                            "value": [
                                                                                "priority",
                                                                                "summary",
                                                                                "assignee",
                                                                                "status",
                                                                                "issuetype"
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldsById",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v20 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "fieldId"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "statusCategory",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "statusCategoryId"
                                                                                                                },
                                                                                                                v11 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v11 /*: any*/ ,
                                                                                                        v16 /*: any*/ ,
                                                                                                        v23 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraStatusField"
                                                                                        },
                                                                                        v11 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        v22 /*: any*/ ,
                                                                                                        v16 /*: any*/ ,
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "text"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraSingleLineTextField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v16 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraAvatar",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "avatar",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "xsmall"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssueTypeField"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v16 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "iconUrl"
                                                                                                        },
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraPriorityField"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "issueId"
                                                                },
                                                                {
                                                                    "concreteType": "DevOpsSummarisedFeatureFlags",
                                                                    "kind": "LinkedField",
                                                                    "name": "summarisedFeatureFlags",
                                                                    "plural": false,
                                                                    "selections": v14 /*: any*/ 
                                                                },
                                                                v20 /*: any*/ ,
                                                                {
                                                                    "condition": "isDevopsFeatureDisabledInFedRamp",
                                                                    "kind": "Condition",
                                                                    "passingValue": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedEntities",
                                                                            "kind": "LinkedField",
                                                                            "name": "devOpsSummarisedEntities",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedDeployments",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "summarisedDeployments",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v25 /*: any*/ ,
                                                                                        v11 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "deploymentState"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "DevOpsEnvironment",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "deploymentEnvironment",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "category"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedBuilds",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "summarisedBuilds",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v25 /*: any*/ ,
                                                                                        v11 /*: any*/ ,
                                                                                        v27 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraIssueDevSummaryResult",
                                                                            "kind": "LinkedField",
                                                                            "name": "devSummaryCache",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueDevSummary",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "devSummary",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "pullrequest",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssuePullRequestDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "branch",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueBranchDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": v28 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "review",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueReviewDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        v26 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "lastUpdated"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "stateCount"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "concreteType": "JiraIssueDevSummaryByProvider",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "summaryByProvider",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "providerId"
                                                                                                        },
                                                                                                        v16 /*: any*/ ,
                                                                                                        v25 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "commit",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueCommitDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": v28 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "build",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueBuildDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "failedBuildCount"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "successfulBuildCount"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "unknownBuildCount"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "deploymentEnvironments",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "overall",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueDeploymentEnvironment",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "topEnvironments",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ ,
                                                                                                                v29 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedFeatureFlags",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedFeatureFlags",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "mostRelevantDisplayName"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "mostRelevantEnabled"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "mostRelevantRolloutPercentage"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                v31 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "DevOpsSummarisedBuilds",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "summarisedBuilds",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v27 /*: any*/ ,
                                                                                        v25 /*: any*/ ,
                                                                                        v11 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        v31 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "DevOpsSummarisedBuilds",
                                                                            "kind": "LinkedField",
                                                                            "name": "summarisedBuilds",
                                                                            "plural": false,
                                                                            "selections": v30 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v32 /*: any*/ 
                                                    ]
                                                },
                                                v33 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "alias": "issuesForList",
                                            "args": v24 /*: any*/ ,
                                            "filters": [
                                                "filter",
                                                "sortBy",
                                                "filters"
                                            ],
                                            "handle": "connection",
                                            "key": "ListVersion_issuesForList",
                                            "kind": "LinkedHandle",
                                            "name": "issues"
                                        },
                                        v17 /*: any*/ ,
                                        {
                                            "args": v34 /*: any*/ ,
                                            "concreteType": "JiraVersionApproverConnection",
                                            "kind": "LinkedField",
                                            "name": "approvers",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraVersionApproverEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersionApprover",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v20 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "AtlassianAccountUserExtendedProfile",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "extendedProfile",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "jobTitle"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "AtlassianAccountUser"
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        v21 /*: any*/ 
                                                                    ]
                                                                },
                                                                v19 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "declineReason"
                                                                },
                                                                v23 /*: any*/ ,
                                                                v35 /*: any*/ ,
                                                                v20 /*: any*/ 
                                                            ]
                                                        },
                                                        v32 /*: any*/ 
                                                    ]
                                                },
                                                v33 /*: any*/ 
                                            ],
                                            "storageKey": "approvers(first:100)"
                                        },
                                        {
                                            "args": v34 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "version_approvers",
                                            "kind": "LinkedHandle",
                                            "name": "approvers"
                                        },
                                        {
                                            "concreteType": "JiraVersionRichTextSection",
                                            "kind": "LinkedField",
                                            "name": "richTextSection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraADF",
                                                    "kind": "LinkedField",
                                                    "name": "content",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "json"
                                                        }
                                                    ]
                                                },
                                                v29 /*: any*/ 
                                            ]
                                        },
                                        v35 /*: any*/ ,
                                        {
                                            "condition": "isDevopsFeatureDisabledInFedRamp",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "concreteType": "DevOpsSummarisedEntities",
                                                    "kind": "LinkedField",
                                                    "name": "devOpsSummarisedEntities",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "DevOpsProviders",
                                                            "kind": "LinkedField",
                                                            "name": "providers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "DevOpsFeatureFlagProvider",
                                                                    "kind": "LinkedField",
                                                                    "name": "featureFlagProviders",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v20 /*: any*/ ,
                                                                        v11 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "createFeatureFlagTemplateUrl"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "connectFeatureFlagTemplateUrl"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "logoUrl"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1253732741586594cf8f5534298cd71ff14d6728edf8b0bf38c41fff0eae663b",
            "metadata": {},
            "name": "removeIssueFromVersion_softwareReleasesMoveIssuesBetweenVersionsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$4c5aca855535074d$var$node.hash = "a22d7bb9dbe9bce2c09ac689883c2338";
var $4c5aca855535074d$export$2e2bcd8739ae039 = $4c5aca855535074d$var$node;

});

parcelRegister("2uHyI", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e5625c51cfa9499$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<30ef410b078961ea01bc83dfef2d6e09>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1e5625c51cfa9499$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "removeIssueFromVersion_softwareReleasesMoveIssuesBetweenVersions",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        }
    ],
    "type": "JiraIssue"
};
$1e5625c51cfa9499$var$node.hash = "bf7da4aac2b6cd1fbe625288d4086691";
var $1e5625c51cfa9499$export$2e2bcd8739ae039 = $1e5625c51cfa9499$var$node;

});

parcelRegister("68iZl", function(module, exports) {

$parcel$export(module.exports, "useRemoveIssueFromVersionExperienceStart", () => $3da27e8d218b719e$export$7d327eeb0dc00eee);
$parcel$export(module.exports, "useRemoveIssueFromVersionExperienceFail", () => $3da27e8d218b719e$export$5da0a49410009ec1);
$parcel$export(module.exports, "useRemoveIssueFromVersionExperienceSuccess", () => $3da27e8d218b719e$export$234c5c3c1b869f23);

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $efvDm = parcelRequire("efvDm");

var $k9JTq = parcelRequire("k9JTq");
const $3da27e8d218b719e$export$52919046b94109dc = 'removeIssueFromVersion';
const $3da27e8d218b719e$var$ANALYTICS_SOURCE = 'versionDetails';
const $3da27e8d218b719e$export$7d327eeb0dc00eee = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    return (0, $kaHBi.useExperienceStart)({
        experience: $3da27e8d218b719e$export$52919046b94109dc,
        experienceId: `${Date.now()}`,
        analyticsSource: $3da27e8d218b719e$var$ANALYTICS_SOURCE,
        application: (0, $efvDm.JIRA_SOFTWARE),
        edition: appEditions.software
    });
};
const $3da27e8d218b719e$export$5da0a49410009ec1 = ()=>(0, $93jKl.useExperienceFail)({
        experience: $3da27e8d218b719e$export$52919046b94109dc
    });
const $3da27e8d218b719e$export$234c5c3c1b869f23 = ()=>(0, $3bQtK.useExperienceSuccess)({
        experience: $3da27e8d218b719e$export$52919046b94109dc
    });

});

parcelRegister("cMnUo", function(module, exports) {

$parcel$export(module.exports, "default", () => $979762e5739b8c14$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $979762e5739b8c14$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorFlagTitle: {
        "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.error-flag-title",
        "defaultMessage": "Can't remove this issue from version"
    },
    errorFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.error-flag-description",
        "defaultMessage": "We couldn't remove {issueKey} from this version. Please try again"
    },
    successFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.success-flag-description",
        "defaultMessage": "{issueKey} has been removed from this version."
    },
    removeButtonTitle: {
        "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.remove-button-title",
        "defaultMessage": "Remove from version"
    },
    missingResolvePermissionErrorgFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.missing-resolve-permission-errorg-flag-description",
        "defaultMessage": "You don't have permission to resolve {issueKey}, so you can't remove it from the version."
    },
    missingEditPermissionErrorFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.missing-edit-permission-error-flag-description",
        "defaultMessage": "You don't have permission to edit {issueKey}, so you can't remove it from the version."
    },
    missingPermissionsErrorFlagDescription: {
        "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.missing-permissions-error-flag-description",
        "defaultMessage": "You don't have permission to edit or resolve {issueKey}, so you can't remove it from the version."
    },
    errorFlagTitleIssueTerminologyRefreshM4: {
        "id": "software-releases-move-issues-between-versions.version-list.remove-issue-from-version.error-flag-title-issue-terminology-refresh-m4",
        "defaultMessage": "Can't remove this work item from version"
    }
});

});

parcelRegister("gMbdf", function(module, exports) {

$parcel$export(module.exports, "getErrorMessage", () => $5267518c5af1c12d$export$82f46aa4e6535a45);

var $cMnUo = parcelRequire("cMnUo");
const $5267518c5af1c12d$export$82f46aa4e6535a45 = (issueKey, issuesWithMissingResolvePermission, issuesWithMissingEditPermission, formatMessage)=>{
    const issueIsMissingResolvePermission = issuesWithMissingResolvePermission !== null && issuesWithMissingResolvePermission !== undefined && issuesWithMissingResolvePermission.length > 0;
    const issueIsMissingEditPermission = issuesWithMissingEditPermission !== null && issuesWithMissingEditPermission !== undefined && issuesWithMissingEditPermission.length > 0;
    if (issueIsMissingResolvePermission && issueIsMissingEditPermission) return formatMessage((0, $cMnUo.default).missingPermissionsErrorFlagDescription, {
        issueKey: issueKey
    });
    if (issueIsMissingResolvePermission) return formatMessage((0, $cMnUo.default).missingResolvePermissionErrorgFlagDescription, {
        issueKey: issueKey
    });
    if (issueIsMissingEditPermission) return formatMessage((0, $cMnUo.default).missingEditPermissionErrorFlagDescription, {
        issueKey: issueKey
    });
    return formatMessage((0, $cMnUo.default).errorFlagDescription);
};

});





parcelRegister("dLN1S", function(module, exports) {

$parcel$export(module.exports, "default", () => $228dcc8f51f524a1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $228dcc8f51f524a1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    moreVersions: {
        "id": "software-releases-version-detail-issue-list.issues.issue-card.more-button.more-versions",
        "defaultMessage": "More actions for {issueKey}"
    }
});

});


parcelRegister("iEXri", function(module, exports) {

$parcel$export(module.exports, "Priority", () => $1d8525f9d31159be$export$300334f671c43555);

var $kovkY = parcelRequire("kovkY");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $brJdr = parcelRequire("brJdr");
const $1d8525f9d31159be$export$300334f671c43555 = ({ jiraPriorityField: jiraPriorityField })=>{
    const [isPriorityIconBroken, setIsPriorityIconBroken] = (0, $5uXOq.useState)(false);
    const { priority: priority } = (0, $8Uumt.useFragment)((0, $kovkY.default), jiraPriorityField);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1d8525f9d31159be$var$PriorityContainer, null, priority && (isPriorityIconBroken ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($brJdr))), {
        LEGACY_size: "small",
        label: priority.name || ''
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1d8525f9d31159be$var$Icon, {
        src: priority.iconUrl,
        alt: priority.name ?? undefined,
        title: priority.name ?? undefined,
        onError: ()=>{
            setIsPriorityIconBroken(true);
        }
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1d8525f9d31159be$var$Icon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _4t3i7vkz _1bsb7vkz _19pkidpf _2hwx1b66 _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1d8525f9d31159be$var$PriorityContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _1ul97vkz _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kovkY", function(module, exports) {

$parcel$export(module.exports, "default", () => $96fa7df9e8c4ccf5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e91e20f3fb1d0c82c7279249a4ac22bb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $96fa7df9e8c4ccf5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "priority_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "concreteType": "JiraPriority",
            "kind": "LinkedField",
            "name": "priority",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    },
                    "action": "NONE",
                    "path": "priority.iconUrl"
                }
            ]
        }
    ],
    "type": "JiraPriorityField"
};
$96fa7df9e8c4ccf5$var$node.hash = "ab255857fbd72fa53e70fe6a619699a6";
var $96fa7df9e8c4ccf5$export$2e2bcd8739ae039 = $96fa7df9e8c4ccf5$var$node;

});

parcelRegister("brJdr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ea0bc7ea32727b1c3ca5267f391ea0a6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85554a440cba9ea4$var$_react = $85554a440cba9ea4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $85554a440cba9ea4$var$_questionCircle = $85554a440cba9ea4$var$_interopRequireDefault((parcelRequire("8nk07")));

var $85554a440cba9ea4$var$_help = $85554a440cba9ea4$var$_interopRequireDefault((parcelRequire("7lUTo")));
function $85554a440cba9ea4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for QuestionCircleIcon.
 * This component is QuestionCircleIcon, with `UNSAFE_fallbackIcon` set to "EditorHelpIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $85554a440cba9ea4$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $85554a440cba9ea4$var$_react.default.createElement($85554a440cba9ea4$var$_questionCircle.default, Object.assign({
        LEGACY_fallbackIcon: $85554a440cba9ea4$var$_help.default
    }, props));
$85554a440cba9ea4$var$QuestionCircleIcon.Name = 'QuestionCircleIconMigration';
var $85554a440cba9ea4$var$_default = module.exports.default = $85554a440cba9ea4$var$QuestionCircleIcon;

});
parcelRegister("7lUTo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $55a6a03819d31d72$var$_react = $55a6a03819d31d72$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $55a6a03819d31d72$var$_questionCircle = $55a6a03819d31d72$var$_interopRequireDefault((parcelRequire("8nk07")));
function $55a6a03819d31d72$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $55a6a03819d31d72$var$EditorHelpIcon = (props)=>/*#__PURE__*/ $55a6a03819d31d72$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 10h2.5c0-2 1.5-2 1.5-2 1.5 0 2.5 1.5.5 3-1.5 1-1.5 1.5-1.5 3 0 .144-.016.824 0 1h2c0-1.568 0-2 1.5-3 1.446-.964 1.5-1.896 1.5-3 0-2-1.5-3-4-3-2 0-4 1-4 4m5 8v-2h-2v2z"/></svg>`
    }, props, {
        newIcon: $55a6a03819d31d72$var$_questionCircle.default
    }));
$55a6a03819d31d72$var$EditorHelpIcon.displayName = 'EditorHelpIcon';
var $55a6a03819d31d72$var$_default = module.exports.default = $55a6a03819d31d72$var$EditorHelpIcon;

});



parcelRegister("4uVJc", function(module, exports) {

$parcel$export(module.exports, "Status", () => $09812bb54450a431$export$96e9906d6d93a972);

var $9H7fH = parcelRequire("9H7fH");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $3bDjY = parcelRequire("3bDjY");

var $2EwJD = parcelRequire("2EwJD");

var $gULOk = parcelRequire("gULOk");
const $09812bb54450a431$export$96e9906d6d93a972 = ({ jiraStatusField: jiraStatusField })=>{
    const { status: status } = (0, $8Uumt.useFragment)((0, $9H7fH.default), jiraStatusField);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($09812bb54450a431$var$StatusName, null, status.name), status.description != null && status.description.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($09812bb54450a431$var$StatusDescription, null, status.description))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2EwJD.default), {
        name: status.name,
        category: (0, $gULOk.statusCategoryForId)(status.statusCategory.statusCategoryId)
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $09812bb54450a431$var$StatusName = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48pmoej",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $09812bb54450a431$var$StatusDescription = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9H7fH", function(module, exports) {

$parcel$export(module.exports, "default", () => $81f3aae902cb3bb3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<95f1026434793df353f849ec59749a29>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $81f3aae902cb3bb3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "status_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        "action": "THROW",
                        "path": "status.name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraStatusCategory",
                            "kind": "LinkedField",
                            "name": "statusCategory",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "statusCategoryId"
                                    },
                                    "action": "THROW",
                                    "path": "status.statusCategory.statusCategoryId"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "status.statusCategory"
                    }
                ]
            },
            "action": "THROW",
            "path": "status"
        }
    ],
    "type": "JiraStatusField"
};
$81f3aae902cb3bb3$var$node.hash = "5e65ebd3a202999e9094506fd6a31982";
var $81f3aae902cb3bb3$export$2e2bcd8739ae039 = $81f3aae902cb3bb3$var$node;

});

parcelRegister("2EwJD", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd41c6095391bfc6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aYAc3 = parcelRequire("aYAc3");

var $gULOk = parcelRequire("gULOk");
const $cd41c6095391bfc6$var$statusCategoryToAppearenceMap = {
    [(0, $gULOk.UNDEFINED)]: 'default',
    [(0, $gULOk.TODO)]: 'default',
    [(0, $gULOk.DONE)]: 'success',
    [(0, $gULOk.IN_PROGRESS)]: 'inprogress'
};
class $cd41c6095391bfc6$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isActive: false
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
            testId: "common-components-status-lozenge.status-lozenge",
            isBold: this.props.isActive,
            appearance: $cd41c6095391bfc6$var$statusCategoryToAppearenceMap[this.props.category],
            maxWidth: this.props.isFullWidth ? '100%' : undefined
        }, this.props.name);
    }
}

});


parcelRegister("cMkJv", function(module, exports) {

$parcel$export(module.exports, "Summary", () => $982482a2b0150a9f$export$46453a0401d6cd1a);

var $97Tt1 = parcelRequire("97Tt1");

var $4Bd7r = parcelRequire("4Bd7r");

var $1o3Lw = parcelRequire("1o3Lw");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $3bDjY = parcelRequire("3bDjY");

var $6OUvA = parcelRequire("6OUvA");
const $982482a2b0150a9f$var$TooltipTag = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($982482a2b0150a9f$var$IssueSummary, {
        ...props,
        ref: ref
    }));
const $982482a2b0150a9f$export$46453a0401d6cd1a = ({ jiraIssue: jiraIssue, jiraIssueSummaryField: jiraIssueSummaryField, jiraIssueTypeField: jiraIssueTypeField })=>{
    const { key: key } = (0, $8Uumt.useFragment)((0, $1o3Lw.default), jiraIssue);
    const { text: summary } = (0, $8Uumt.useFragment)((0, $4Bd7r.default), jiraIssueSummaryField);
    const { issueType: issueType } = (0, $8Uumt.useFragment)((0, $97Tt1.default), jiraIssueTypeField);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($982482a2b0150a9f$var$SummaryContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($982482a2b0150a9f$var$Icon, {
        src: issueType.avatar?.xsmall ?? (0, (/*@__PURE__*/$parcel$interopDefault($6OUvA))),
        alt: issueType.name,
        title: issueType.name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($982482a2b0150a9f$var$IssueKey, null, key), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: summary,
        tag: $982482a2b0150a9f$var$TooltipTag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($982482a2b0150a9f$var$IssueSummary, null, summary)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $982482a2b0150a9f$var$SummaryContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4t3i1osq _1ul9uuw1 _4cvr1h6o _8mocu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $982482a2b0150a9f$var$Icon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _4t3i7vkz _1bsb7vkz _19pkidpf _2hwx1b66 _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $982482a2b0150a9f$var$IssueSummary = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _syaz1fxt _9oik18uv _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $982482a2b0150a9f$var$IssueKey = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1o9zidpf _syaz131l _u5f3pxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("97Tt1", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e2eb63a63eaef37$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<269b69055861a60c9b538a02f44d6bfb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5e2eb63a63eaef37$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssueTypeField",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        "action": "THROW",
                        "path": "issueType.name"
                    },
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "xsmall"
                                },
                                "action": "LOG",
                                "path": "issueType.avatar.xsmall"
                            }
                        ]
                    }
                ]
            },
            "action": "THROW",
            "path": "issueType"
        }
    ],
    "type": "JiraIssueTypeField"
};
$5e2eb63a63eaef37$var$node.hash = "9c2af22d7b07779fb498e0197b0b8a31";
var $5e2eb63a63eaef37$export$2e2bcd8739ae039 = $5e2eb63a63eaef37$var$node;

});

parcelRegister("4Bd7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $e12b298083406c4b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9997bef9f319cb4f9014d445188f50b1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e12b298083406c4b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssueSummaryField",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "text"
            },
            "action": "THROW",
            "path": "text"
        }
    ],
    "type": "JiraSingleLineTextField"
};
$e12b298083406c4b$var$node.hash = "ecdba23eb4bd24552ee157f9d7e6c2dc";
var $e12b298083406c4b$export$2e2bcd8739ae039 = $e12b298083406c4b$var$node;

});

parcelRegister("1o3Lw", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1698ce32761cff8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8f3bafcb10f68f21b62cadc5fae27824>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d1698ce32761cff8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssue",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        }
    ],
    "type": "JiraIssue"
};
$d1698ce32761cff8$var$node.hash = "be0a5b93419942c75fd2d852a9d5c8fc";
var $d1698ce32761cff8$export$2e2bcd8739ae039 = $d1698ce32761cff8$var$node;

});

parcelRegister("6OUvA", function(module, exports) {
module.exports = new URL("issue-type-avatar-fallback.a9f6df1b.svg", import.meta.url).toString();

});




parcelRegister("bLVnv", function(module, exports) {

$parcel$export(module.exports, "ListOptions", () => $e5c564d307b91bbd$export$c50fde0141a9ce82);

var $j0sCG = parcelRequire("j0sCG");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $83Lzw = parcelRequire("83Lzw");

var $lCkt6 = parcelRequire("lCkt6");
const $e5c564d307b91bbd$export$c50fde0141a9ce82 = ({ jiraVersion: jiraVersion })=>{
    const jiraVersionData = (0, $8Uumt.useFragment)((0, $j0sCG.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e5c564d307b91bbd$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $83Lzw.FiltersAsync), {
        jiraVersion: jiraVersionData
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e5c564d307b91bbd$var$SortingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lCkt6.AsyncSortIssues), null)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e5c564d307b91bbd$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _4t3i1ylp _1ul9idpf _kqsw1if8 _154iidpf _1pbycs5v _bfhkvuon _ca0qpxbi _n3tdpxbi",
            __cmplp.className
        ])
    });
});
const $e5c564d307b91bbd$var$SortingWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("j0sCG", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a525887e43a9604$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5ad9d1719b1000d014e3db5d4e26f842>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8a525887e43a9604$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "listOptions_softwareReleasesVersionDetailIssueList",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "async_softwareReleasesVersionDetailIssueList_FiltersAsync"
        }
    ],
    "type": "JiraVersion"
};
$8a525887e43a9604$var$node.hash = "72816e24a790f41b4c2b45bd06ad26f9";
var $8a525887e43a9604$export$2e2bcd8739ae039 = $8a525887e43a9604$var$node;

});

parcelRegister("83Lzw", function(module, exports) {

$parcel$export(module.exports, "FiltersAsync", () => $0aabf33f1f510e23$export$c2ea1db993d10580);

var $aiA4o = parcelRequire("aiA4o");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $0aabf33f1f510e23$var$FiltersLazy = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("itbE6")).then((mod)=>mod.Filters), {
    moduleId: "./src/packages/releases/issue-list/src/ui/list-options/filters/index.tsx"
});
const $0aabf33f1f510e23$export$669f6ea7d267feaf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aabf33f1f510e23$var$FilterBarLoadingWraper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aabf33f1f510e23$var$TextFilterSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aabf33f1f510e23$var$AssigneeFilterSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aabf33f1f510e23$var$DropdownFilterSkeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aabf33f1f510e23$var$DropdownFilterSkeleton, null));
const $0aabf33f1f510e23$export$c2ea1db993d10580 = ({ jiraVersion: jiraVersion })=>{
    const jiraVersionData = (0, $8Uumt.useFragment)((0, $aiA4o.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        id: "jira.software.releases.version.detail.issue.list.filters",
        packageName: "jira-software-releases-version-detail-issue-list",
        teamName: "nova"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jira-software-releases-version-detail-issue-list-filters",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aabf33f1f510e23$export$669f6ea7d267feaf, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aabf33f1f510e23$var$FiltersLazy, {
        jiraVersion: jiraVersionData
    })));
};
const $0aabf33f1f510e23$var$skeletonKeyFrames = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0aabf33f1f510e23$var$AnimationBaseDiv = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ju25ru3m _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1kpv _12vemgnk _bfhkn82g _j7hq1nls",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0aabf33f1f510e23$var$FilterBarLoadingWraper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1ylp _1bsb1osq _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0aabf33f1f510e23$var$TextFilterSkeleton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0aabf33f1f510e23$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _1bsb68cl _4t3i1ylp _2hwx7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0aabf33f1f510e23$var$AssigneeFilterSkeleton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0aabf33f1f510e23$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko7vkz _4t3izwfg _1bsbzwfg _2hwx7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0aabf33f1f510e23$var$DropdownFilterSkeleton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0aabf33f1f510e23$var$AnimationBaseDiv, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko7vkz _4t3igktf _1bsbvbgk _2hwx7vkz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aiA4o", function(module, exports) {

$parcel$export(module.exports, "default", () => $75b1d7804985602b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<42b58b01a1994dfcf0a3ac5a5b822aa3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $75b1d7804985602b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "async_softwareReleasesVersionDetailIssueList_FiltersAsync",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "filters_softwareReleasesVersionDetailIssueList"
        }
    ],
    "type": "JiraVersion"
};
$75b1d7804985602b$var$node.hash = "80684c6429225cfc5da72844f8d61f76";
var $75b1d7804985602b$export$2e2bcd8739ae039 = $75b1d7804985602b$var$node;

});

parcelRegister("itbE6", function(module, exports) {

let $d723f809fd2ba2bb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d723f809fd2ba2bb$var$load("iiJxA").then(()=>parcelRequire('f6qTx'));

});


parcelRegister("lCkt6", function(module, exports) {

$parcel$export(module.exports, "AsyncSortIssues", () => $0272d90f37d16d98$export$e985a1e694548d49);
/* AsyncSortIssues.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2rqOp = parcelRequire("2rqOp");

var $koVbs = parcelRequire("koVbs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $gjy9O = parcelRequire("gjy9O");

var $1KVd1 = parcelRequire("1KVd1");

var $kEJPu = parcelRequire("kEJPu");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0272d90f37d16d98$var$LazySortIssues = (0, $kxZPA.lazy)(()=>Promise.resolve((parcelRequire("gjy9O"))).then((module)=>module.SortIssuesDropdown), {
    moduleId: "./src/packages/releases/issue-list/src/ui/list-options/sorting/sorting-dropdown/SortIssuesDropdown.tsx"
});
const $0272d90f37d16d98$export$e985a1e694548d49 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { currentSortByOption: currentSortByOption, currentSortOrderOption: currentSortOrderOption } = (0, $kEJPu.useCurrentSortOptions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "version-detail-sort-issues",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0272d90f37d16d98$var$StyledButton, {
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjy9O.SortOrderIcon), {
                order: currentSortOrderOption.id
            })
        }, `${formatMessage((0, $1KVd1.default).sortBy)}: ${formatMessage(currentSortByOption.label)}`)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0272d90f37d16d98$var$LazySortIssues, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $0272d90f37d16d98$var$StyledButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $2rqOp.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_fqox2smr _if291txw _1kba1h6o _12r21wq8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gjy9O", function(module, exports) {

$parcel$export(module.exports, "SortIssuesDropdown", () => $fff8548e576079f4$export$2c14c390745c589);
$parcel$export(module.exports, "SortOrderIcon", () => $fff8548e576079f4$export$80ba57d0e34e16ec);
/* SortIssuesDropdown.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2rqOp = parcelRequire("2rqOp");

var $BLPHT = parcelRequire("BLPHT");
var $a5n5E = parcelRequire("a5n5E");
var $b2TJP = parcelRequire("b2TJP");

var $588G7 = parcelRequire("588G7");

var $9j532 = parcelRequire("9j532");

var $9UCCQ = parcelRequire("9UCCQ");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $1YU2V = parcelRequire("1YU2V");

var $1KVd1 = parcelRequire("1KVd1");

var $kEJPu = parcelRequire("kEJPu");
const $fff8548e576079f4$export$2c14c390745c589 = ({ defaultOpen: defaultOpen })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { currentSortByOption: currentSortByOption, currentSortOrderOption: currentSortOrderOption } = (0, $kEJPu.useCurrentSortOptions)();
    const { setSortByParam: setSortByParam, setSortOrderParam: setSortOrderParam } = (0, $1YU2V.useFilterSortingQueryParams)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        defaultOpen: defaultOpen,
        spacing: "compact",
        placement: "bottom-end",
        trigger: ({ triggerRef: triggerRef, isSelected: isSelected, ...providedProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fff8548e576079f4$export$2d5d2ba3c7c8c40b, {
                ...providedProps,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                ref: triggerRef,
                isSelected: isSelected,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fff8548e576079f4$export$80ba57d0e34e16ec, {
                    order: currentSortOrderOption.id
                }),
                appearance: "subtle"
            }, `${formatMessage((0, $1KVd1.default).sortBy)}: ${formatMessage(currentSortByOption.label)}`)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b2TJP.default), {
        id: "sortByFields"
    }, ((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $kEJPu.sortByFieldOptions) : (0, $kEJPu.sortByFieldOptionsOld)).map((field)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fff8548e576079f4$export$29d4895f75c15b40, {
            isSelected: field.id === currentSortByOption.id,
            id: field.id,
            key: field.id,
            onClick: ()=>{
                setSortByParam(field.id);
                const analyticsEvent = createAnalyticsEvent({
                    action: 'toggled',
                    actionSubject: 'radio'
                });
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sorting', {
                    sortBy: field.id,
                    sortOrder: currentSortOrderOption.id
                });
            }
        }, formatMessage(field.label)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b2TJP.default), {
        id: "sortOrderOptions"
    }, (0, $kEJPu.sortOrderOptions).map((order)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fff8548e576079f4$export$29d4895f75c15b40, {
            isSelected: order.id === currentSortOrderOption.id,
            id: order.id,
            key: order.id,
            onClick: ()=>{
                setSortOrderParam(order.id);
                const analyticsEvent = createAnalyticsEvent({
                    action: 'toggled',
                    actionSubject: 'radio'
                });
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sorting', {
                    sortBy: currentSortByOption.id,
                    sortOrder: order.id
                });
            }
        }, formatMessage(order.label))))));
};
const $fff8548e576079f4$export$80ba57d0e34e16ec = ({ order: order })=>{
    switch(order){
        case 'ASC':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9j532))), {
                label: "software-releases-version-detail.common.sort-issues.ui.sort-order-icon.ascending",
                LEGACY_size: "small"
            });
        case 'DESC':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($588G7))), {
                label: "software-releases-version-detail.common.sort-issues.ui.sort-order-icon.descending",
                LEGACY_size: "small"
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($588G7))), {
                label: "software-releases-version-detail.common.sort-issues.ui.sort-order-icon.descending",
                LEGACY_size: "small"
            });
    }
}; // This component is defined here deliberately to avoid DropdownItemRadio to be included in the Version details bundle.
const $fff8548e576079f4$export$29d4895f75c15b40 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $a5n5E.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48pi7a9 _1kha1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $fff8548e576079f4$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $2rqOp.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_fqox2smr _if291txw _1kba1h6o _12r21wq8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("588G7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c41b8a7a2a0e885f53178dceb7a8d3e7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3bc46e6d650b1ecb$var$_react = $3bc46e6d650b1ecb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3bc46e6d650b1ecb$var$_arrowDown = $3bc46e6d650b1ecb$var$_interopRequireDefault((parcelRequire("cC5ib")));

var $3bc46e6d650b1ecb$var$_arrowDown2 = $3bc46e6d650b1ecb$var$_interopRequireDefault((parcelRequire("ls8Y7")));
function $3bc46e6d650b1ecb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowDownIcon.
 * This component is ArrowDownIcon, with `UNSAFE_fallbackIcon` set to "ArrowDownIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3bc46e6d650b1ecb$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $3bc46e6d650b1ecb$var$_react.default.createElement($3bc46e6d650b1ecb$var$_arrowDown.default, Object.assign({
        LEGACY_fallbackIcon: $3bc46e6d650b1ecb$var$_arrowDown2.default
    }, props));
$3bc46e6d650b1ecb$var$ArrowDownIcon.Name = 'ArrowDownIconMigration';
var $3bc46e6d650b1ecb$var$_default = module.exports.default = $3bc46e6d650b1ecb$var$ArrowDownIcon;

});
parcelRegister("cC5ib", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7f5a6659a6d5dd6eaa41936b6c8533f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92ed238f23140736$var$_react = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $92ed238f23140736$var$_baseNew = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $92ed238f23140736$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $92ed238f23140736$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $92ed238f23140736$var$_react.default.createElement($92ed238f23140736$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$92ed238f23140736$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $92ed238f23140736$var$_default = module.exports.default = $92ed238f23140736$var$ArrowDownIcon;

});

parcelRegister("ls8Y7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f9e32b81d01f795b$var$_react = $f9e32b81d01f795b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $f9e32b81d01f795b$var$_arrowDown = $f9e32b81d01f795b$var$_interopRequireDefault((parcelRequire("cC5ib")));
function $f9e32b81d01f795b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f9e32b81d01f795b$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $f9e32b81d01f795b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11 6v9.586l-3.793-3.793a1 1 0 0 0-1.414 0c-.39.39-.39 1.024 0 1.415l5.5 5.499A1 1 0 0 0 12 19a1 1 0 0 0 .707-.293l5.5-5.499a1 1 0 1 0-1.414-1.415L13 15.586V6a1 1 0 0 0-2 0"/></svg>`
    }, props, {
        newIcon: $f9e32b81d01f795b$var$_arrowDown.default
    }));
$f9e32b81d01f795b$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $f9e32b81d01f795b$var$_default = module.exports.default = $f9e32b81d01f795b$var$ArrowDownIcon;

});


parcelRegister("9j532", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7ae9adc1e99d7e27810a205cdfaded7b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6c69cdd6c9c50ed7$var$_react = $6c69cdd6c9c50ed7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6c69cdd6c9c50ed7$var$_arrowUp = $6c69cdd6c9c50ed7$var$_interopRequireDefault((parcelRequire("kcHZS")));

var $6c69cdd6c9c50ed7$var$_arrowUp2 = $6c69cdd6c9c50ed7$var$_interopRequireDefault((parcelRequire("kAObg")));
function $6c69cdd6c9c50ed7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowUpIcon.
 * This component is ArrowUpIcon, with `UNSAFE_fallbackIcon` set to "ArrowUpIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6c69cdd6c9c50ed7$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $6c69cdd6c9c50ed7$var$_react.default.createElement($6c69cdd6c9c50ed7$var$_arrowUp.default, Object.assign({
        LEGACY_fallbackIcon: $6c69cdd6c9c50ed7$var$_arrowUp2.default
    }, props));
$6c69cdd6c9c50ed7$var$ArrowUpIcon.Name = 'ArrowUpIconMigration';
var $6c69cdd6c9c50ed7$var$_default = module.exports.default = $6c69cdd6c9c50ed7$var$ArrowUpIcon;

});
parcelRegister("kcHZS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd7e8572b743336ba9352499cfa665f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb570e807ab2e210$var$_react = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eb570e807ab2e210$var$_baseNew = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $eb570e807ab2e210$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb570e807ab2e210$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $eb570e807ab2e210$var$_react.default.createElement($eb570e807ab2e210$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$eb570e807ab2e210$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $eb570e807ab2e210$var$_default = module.exports.default = $eb570e807ab2e210$var$ArrowUpIcon;

});

parcelRegister("kAObg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $efde1844fc0ef421$var$_react = $efde1844fc0ef421$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $efde1844fc0ef421$var$_arrowUp = $efde1844fc0ef421$var$_interopRequireDefault((parcelRequire("kcHZS")));
function $efde1844fc0ef421$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $efde1844fc0ef421$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $efde1844fc0ef421$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.293 5.293-5.5 5.499a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0L11 8.414V18a1 1 0 0 0 2 0V8.414l3.793 3.793a1 1 0 1 0 1.414-1.415l-5.5-5.499A1 1 0 0 0 12 5a1 1 0 0 0-.707.293"/></svg>`
    }, props, {
        newIcon: $efde1844fc0ef421$var$_arrowUp.default
    }));
$efde1844fc0ef421$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $efde1844fc0ef421$var$_default = module.exports.default = $efde1844fc0ef421$var$ArrowUpIcon;

});


parcelRegister("1KVd1", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d5edbb25fefb626$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6d5edbb25fefb626$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    sortByAssignee: {
        "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-assignee",
        "defaultMessage": "Assignee"
    },
    sortByDateCreated: {
        "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-date-created",
        "defaultMessage": "Date created"
    },
    sortByIssueKey: {
        "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-issue-key",
        "defaultMessage": "Issue key"
    },
    sortByPriority: {
        "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-priority",
        "defaultMessage": "Priority"
    },
    sortByIssueStatusCategory: {
        "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-issue-status-category",
        "defaultMessage": "Status category"
    },
    sortByIssueType: {
        "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-issue-type",
        "defaultMessage": "Type"
    },
    ascending: {
        "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.ascending",
        "defaultMessage": "Ascending"
    },
    descending: {
        "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.descending",
        "defaultMessage": "Descending"
    },
    sortBy: {
        "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by",
        "defaultMessage": "Sort by"
    },
    sortByIssueKeyIssueTerminologyRefreshM4: {
        "id": "software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-issue-key-issue-terminology-refresh-m4",
        "defaultMessage": "Work item key"
    }
});

});

parcelRegister("kEJPu", function(module, exports) {

$parcel$export(module.exports, "sortOrderOptions", () => $cb0c4d13f7089bc2$export$2969b4c3e7255782);
$parcel$export(module.exports, "sortByFieldOptions", () => $cb0c4d13f7089bc2$export$bdbfa34747bc5af);
$parcel$export(module.exports, "sortByFieldOptionsOld", () => $cb0c4d13f7089bc2$export$1b12bc0228e8b067);
$parcel$export(module.exports, "useCurrentSortOptions", () => $cb0c4d13f7089bc2$export$43a8856ed2deb26e);

var $4R6GH = parcelRequire("4R6GH");


var $1YU2V = parcelRequire("1YU2V");

var $1KVd1 = parcelRequire("1KVd1");
const $cb0c4d13f7089bc2$export$2969b4c3e7255782 = [
    {
        id: 'ASC',
        label: (0, $1KVd1.default).ascending
    },
    {
        id: 'DESC',
        label: (0, $1KVd1.default).descending
    }
];
const $cb0c4d13f7089bc2$export$bdbfa34747bc5af = [
    {
        id: 'CREATED',
        label: (0, $1KVd1.default).sortByDateCreated
    },
    {
        id: 'ASSIGNEE',
        label: (0, $1KVd1.default).sortByAssignee
    },
    {
        id: 'KEY',
        label: (0, $1KVd1.default).sortByIssueKeyIssueTerminologyRefreshM4
    },
    {
        id: 'PRIORITY',
        label: (0, $1KVd1.default).sortByPriority
    },
    {
        id: 'STATUS',
        label: (0, $1KVd1.default).sortByIssueStatusCategory
    },
    {
        id: 'TYPE',
        label: (0, $1KVd1.default).sortByIssueType
    }
];
const $cb0c4d13f7089bc2$export$1b12bc0228e8b067 = [
    {
        id: 'CREATED',
        label: (0, $1KVd1.default).sortByDateCreated
    },
    {
        id: 'ASSIGNEE',
        label: (0, $1KVd1.default).sortByAssignee
    },
    {
        id: 'KEY',
        label: (0, $1KVd1.default).sortByIssueKey
    },
    {
        id: 'PRIORITY',
        label: (0, $1KVd1.default).sortByPriority
    },
    {
        id: 'STATUS',
        label: (0, $1KVd1.default).sortByIssueStatusCategory
    },
    {
        id: 'TYPE',
        label: (0, $1KVd1.default).sortByIssueType
    }
];
const $cb0c4d13f7089bc2$export$43a8856ed2deb26e = ()=>{
    const { parsedQueryParams: parsedQueryParams } = (0, $1YU2V.useFilterSortingQueryParams)();
    const fieldOptions = (0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? $cb0c4d13f7089bc2$export$bdbfa34747bc5af : $cb0c4d13f7089bc2$export$1b12bc0228e8b067;
    const currentSortByOption = fieldOptions.find((option)=>option.id === parsedQueryParams[0, $5d187be87424268f$export$13d5b2891ca65cd6]) ?? fieldOptions[0];
    const currentSortOrderOption = $cb0c4d13f7089bc2$export$2969b4c3e7255782.find((option)=>option.id === parsedQueryParams[0, $5d187be87424268f$export$810a1f7ed2facfcb]) ?? $cb0c4d13f7089bc2$export$2969b4c3e7255782[0];
    return {
        currentSortByOption: currentSortByOption,
        currentSortOrderOption: currentSortOrderOption
    };
};

});




parcelRegister("9VaPq", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c682112e60e9021$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3c682112e60e9021$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issues: {
        "id": "software-releases-version-detail-issue-list.issues",
        "defaultMessage": "Issues"
    },
    addIssueIconLabel: {
        "id": "software-releases-version-detail-issue-list.add-issue-icon-label",
        "defaultMessage": "Add issues"
    },
    issuesIssueTerminologyRefreshM4: {
        "id": "software-releases-version-detail-issue-list.issues-issue-terminology-refresh-m4",
        "defaultMessage": "Work items"
    },
    addIssueIconLabelIssueTerminologyRefreshM4: {
        "id": "software-releases-version-detail-issue-list.add-issue-icon-label-issue-terminology-refresh-m4",
        "defaultMessage": "Add work items"
    }
});

});

parcelRegister("fx0Tw", function(module, exports) {

$parcel$export(module.exports, "IssueListScreenAnalytics", () => $447dd2b3ad70f9dc$export$44cca2bcabf50abc);

var $iSQPt = parcelRequire("iSQPt");

var $7y8zI = parcelRequire("7y8zI");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $5oFIy = parcelRequire("5oFIy");

var $9lAUN = parcelRequire("9lAUN");
const $447dd2b3ad70f9dc$export$44cca2bcabf50abc = ({ jiraIssueEdgesReference: jiraIssueEdgesReference, jiraVersionReference: jiraVersionReference })=>{
    const jiraIssueEdgeReferenceData = (0, $8Uumt.useFragment)((0, $7y8zI.default), jiraIssueEdgesReference);
    const warningConfigFragment = (0, $8Uumt.useFragment)((0, $iSQPt.default), jiraVersionReference);
    const nodes = jiraIssueEdgeReferenceData.map((edge)=>edge.node).filter(Boolean);
    // TODO: This will be improved by getting these values from the server either from Data Depot
    // or ARI Graph Store relationships. The current code has a bug that might result incorrect
    // boolean due to pagination. Also this is ugly to calculate in FE.
    const hasBambooDeployment = nodes.some((node)=>(node.devSummaryCache?.devSummary?.deploymentEnvironments?.overall?.topEnvironments ?? []).filter((deployment)=>deployment.status === 'DEPLOYED').length > 0);
    const hasDeployments = nodes.some((node)=>node.summarisedDeployments?.count != null && node.summarisedDeployments?.count > 0);
    const hasFeatureFlags = nodes.some((node)=>(node.summarisedFeatureFlags?.totalCount ?? 0) > 0);
    const hasCommits = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.commit?.overall?.count) > 0);
    const hasPullRequests = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.pullrequest?.overall?.count) > 0);
    const hasBranches = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.branch?.overall?.count) > 0);
    const hasBuilds = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.build?.overall?.count) > 0 || Number(node.summarisedBuilds?.count) > 0);
    const hasReviews = nodes.some((node)=>Number(node.devSummaryCache?.devSummary?.review?.overall?.count) > 0);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9lAUN.IssuesWarningCountProvider), {
        jiraVersion: warningConfigFragment,
        issueEdges: jiraIssueEdgeReferenceData
    }, (warningCount)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
            attributes: {
                hasBamboo: hasBambooDeployment,
                hasBranches: hasBranches,
                hasBuilds: hasBuilds,
                hasCommits: hasCommits,
                hasDeployments: hasDeployments,
                hasFeatureFlags: hasFeatureFlags,
                hasPullRequests: hasPullRequests,
                hasReviews: hasReviews,
                warningCount: warningCount
            }
        }));
};

});
parcelRegister("iSQPt", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7b2298df7f980ab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0e7b3053e164d5901e6af58b7a501d5e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f7b2298df7f980ab$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraVersionReference",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$f7b2298df7f980ab$var$node.hash = "2dad59bd036f7e19ca923546c2912289";
var $f7b2298df7f980ab$export$2e2bcd8739ae039 = $f7b2298df7f980ab$var$node;

});

parcelRegister("7y8zI", function(module, exports) {

$parcel$export(module.exports, "default", () => $4289ceabfb6dcbda$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d53cdb62c7218a329054318025c32557>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4289ceabfb6dcbda$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "count"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "isDevopsFeatureDisabledInFedRamp"
            },
            {
                "kind": "RootArgument",
                "name": "shouldIncludeDevOpsFieldsViaAgs"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "plural": true
        },
        "name": "screenAnalytics_softwareReleasesVersionDetailIssueList_IssueListScreenAnalytics_jiraIssueEdgesReference",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "condition": "shouldIncludeDevOpsFieldsViaAgs",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "DevOpsSummarisedDeployments",
                                "kind": "LinkedField",
                                "name": "summarisedDeployments",
                                "plural": false,
                                "selections": v0 /*: any*/ 
                            },
                            {
                                "concreteType": "DevOpsSummarisedBuilds",
                                "kind": "LinkedField",
                                "name": "summarisedBuilds",
                                "plural": false,
                                "selections": v0 /*: any*/ 
                            }
                        ]
                    },
                    {
                        "concreteType": "DevOpsSummarisedFeatureFlags",
                        "kind": "LinkedField",
                        "name": "summarisedFeatureFlags",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "totalCount"
                            }
                        ]
                    },
                    {
                        "condition": "isDevopsFeatureDisabledInFedRamp",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueDevSummaryResult",
                                "kind": "LinkedField",
                                "name": "devSummaryCache",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueDevSummary",
                                        "kind": "LinkedField",
                                        "name": "devSummary",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "pullrequest",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssuePullRequestDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": v0 /*: any*/ 
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraIssueBranchDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "branch",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueBranchDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": v0 /*: any*/ 
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraIssueReviewDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "review",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueReviewDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": v0 /*: any*/ 
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraIssueCommitDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "commit",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueCommitDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": v0 /*: any*/ 
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraIssueBuildDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "build",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueBuildDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": v0 /*: any*/ 
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                                "kind": "LinkedField",
                                                "name": "deploymentEnvironments",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                                        "kind": "LinkedField",
                                                        "name": "overall",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueDeploymentEnvironment",
                                                                "kind": "LinkedField",
                                                                "name": "topEnvironments",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "status"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_issueEdges"
            }
        ],
        "type": "JiraIssueEdge"
    };
}();
$4289ceabfb6dcbda$var$node.hash = "986ab5c3f2a0f2a269dee80717c9a49d";
var $4289ceabfb6dcbda$export$2e2bcd8739ae039 = $4289ceabfb6dcbda$var$node;

});


parcelRegister("c8MHq", function(module, exports) {

$parcel$export(module.exports, "useIntersectionObserver", () => $4f6fdaccd88726d3$export$a7395f9832c00176);

var $5uXOq = parcelRequire("5uXOq");
const $4f6fdaccd88726d3$export$a7395f9832c00176 = ({ margin: margin, onIntersection: onIntersection })=>{
    const [observedElement, setObservedElement] = (0, $5uXOq.useState)(null);
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (observedElement === null || window.IntersectionObserver === undefined) return undefined;
        const observerCallback = (entries)=>entries.forEach(({ isIntersecting: isIntersecting })=>{
                if (isIntersecting) onIntersection();
            });
        const observer = new IntersectionObserver(observerCallback, {
            rootMargin: `${margin}px`,
            threshold: 0
        });
        observer.observe(observedElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        observedElement,
        onIntersection,
        margin
    ]);
    return setObservedElement;
};

});


parcelRegister("fWb7u", function(module, exports) {

$parcel$export(module.exports, "VersionRelatedWorkExperienceStart", () => $ac4f7898ed3cc636$export$e99e651b72ab598a);
$parcel$export(module.exports, "useViewVersionRelatedWorkExperienceFail", () => $ac4f7898ed3cc636$export$ffb9ab4bec7b2f3c);
$parcel$export(module.exports, "VersionRelatedWorkExperienceSuccessTracker", () => $ac4f7898ed3cc636$export$4e4779a3c4cff596);

var $5uXOq = parcelRequire("5uXOq");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $efvDm = parcelRequire("efvDm");

var $k9JTq = parcelRequire("k9JTq");
const $ac4f7898ed3cc636$var$VERSION_RELATED_WORK_EXPERIENCE_NAME = 'viewVersionRelatedWork';
const $ac4f7898ed3cc636$export$e99e651b72ab598a = ({ experienceId: experienceId })=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kaHBi.ExperienceStart), {
        experienceId: experienceId,
        experience: $ac4f7898ed3cc636$var$VERSION_RELATED_WORK_EXPERIENCE_NAME,
        analyticsSource: "versionDetails",
        edition: appEditions.software,
        application: (0, $efvDm.JIRA_SOFTWARE)
    });
};
const $ac4f7898ed3cc636$export$ffb9ab4bec7b2f3c = ()=>(0, $93jKl.useExperienceFail)({
        experience: $ac4f7898ed3cc636$var$VERSION_RELATED_WORK_EXPERIENCE_NAME
    });
const $ac4f7898ed3cc636$export$4e4779a3c4cff596 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: $ac4f7898ed3cc636$var$VERSION_RELATED_WORK_EXPERIENCE_NAME
    });

});

parcelRegister("4MIM1", function(module, exports) {

$parcel$export(module.exports, "RelatedWork", () => $c048d8a6986fd4e0$export$3200bfb79e9adbfb);

var $cXDwW = parcelRequire("cXDwW");

var $ajHh6 = parcelRequire("ajHh6");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $99M5v = parcelRequire("99M5v");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $5oFIy = parcelRequire("5oFIy");

var $24M80 = parcelRequire("24M80");

var $a3dw0 = parcelRequire("a3dw0");

var $fi7WV = parcelRequire("fi7WV");

var $ieDtd = parcelRequire("ieDtd");

var $e4M5y = parcelRequire("e4M5y");

var $aef30 = parcelRequire("aef30");

var $23OBX = parcelRequire("23OBX");

var $iaG90 = parcelRequire("iaG90");

var $hhood = parcelRequire("hhood");

var $gCsUv = parcelRequire("gCsUv");
const $c048d8a6986fd4e0$export$8beb67dd759bbe2 = 5;
const $c048d8a6986fd4e0$export$3200bfb79e9adbfb = ({ queryRef: queryRef })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { jira: jira } = (0, $8Uumt.usePreloadedQuery)((0, $ajHh6.default), queryRef);
    const versionFrag = jira.version;
    const version = (0, $8Uumt.useFragment)((0, $cXDwW.default), versionFrag);
    const [selectedCategory, setSelectedCategory] = (0, $ieDtd.useQueryParam)('relatedWorkCategory');
    const addRelatedWorkExpFailed = (0, $24M80.useAddRelatedWorkExperienceFail)();
    const allRelatedWork = version.relatedWorkV2.edges.filter(Boolean);
    const relatedWorkInCategory = selectedCategory === undefined ? allRelatedWork : allRelatedWork.filter(({ node: node })=>node?.category === selectedCategory);
    const body = allRelatedWork.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iaG90.RelatedWorkEmptyState), {
        jiraVersion: version,
        relatedWorkEdges: allRelatedWork
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4M5y.ErrorBoundary), {
        id: "relatedWorkCategoryFilter",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $23OBX.CategoryFilter), {
        relatedWorkEdges: allRelatedWork,
        selectedCategory: selectedCategory,
        onCategorySelected: (category)=>setSelectedCategory(category, 'replace')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gCsUv.RelatedWorkList), {
        jiraVersion: version,
        relatedWorkEdges: relatedWorkInCategory,
        selectedCategory: selectedCategory
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c048d8a6986fd4e0$var$ActionsContainer, null, version.status != null && version.status !== 'ARCHIVED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4M5y.ErrorBoundary), {
        id: "addRelatedPopup",
        fallback: "flag",
        onError: (location, error)=>{
            addRelatedWorkExpFailed(location, error);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a3dw0.AddRelatedWorkPopup), {
        jiraVersion: version,
        relatedWorkEdges: allRelatedWork,
        renderTrigger: ({ triggerProps: triggerProps, isLoading: isLoading, onClick: onClick, onMouseOver: onMouseOver })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c048d8a6986fd4e0$var$AddButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c048d8a6986fd4e0$var$AddButton, {
                ...triggerProps,
                appearance: "subtle-link",
                testId: isLoading ? undefined : 'software-releases-version-related-work.ui.add-button',
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c048d8a6986fd4e0$var$ActionIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
                    LEGACY_size: "small",
                    label: ""
                })),
                onClick: onClick,
                onMouseOver: onMouseOver,
                shouldFitContainer: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c048d8a6986fd4e0$var$ShowMoreTextContainer, null, formatMessage((0, $hhood.default).addRelatedWork))))
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aef30.default), {
        relatedWorkEdges: allRelatedWork
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fi7WV.CollapsibleSection), {
        jiraVersion: version,
        uiType: "RELATED_WORK",
        renderHeader: (isCollapsed, onToggleClicked)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c048d8a6986fd4e0$var$HeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c048d8a6986fd4e0$var$HeaderLeftWrapper, {
                onClick: onToggleClicked
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
                size: "small",
                as: "h2"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $c048d8a6986fd4e0$var$sectionTitleStyles
            }, formatMessage((0, $hhood.default).relatedWorkHeading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c048d8a6986fd4e0$var$TotalCountLozenge, null, allRelatedWork.length), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fi7WV.CollapsibleToggleButton), {
                isCollapsed: isCollapsed
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c048d8a6986fd4e0$var$HeaderRightWrapper, null, version.status !== 'ARCHIVED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4M5y.ErrorBoundary), {
                key: "addRelatedWorkButton",
                id: "addRelatedPopupHeaderPlusButton",
                fallback: "flag",
                onError: (location, error)=>{
                    addRelatedWorkExpFailed(location, error);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a3dw0.AddRelatedWorkPopup), {
                jiraVersion: version,
                relatedWorkEdges: allRelatedWork,
                renderTrigger: ({ triggerProps: triggerProps, onClick: onClick, onMouseOver: onMouseOver })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c048d8a6986fd4e0$var$AddIconButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                        ...triggerProps,
                        appearance: "subtle",
                        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
                            label: "",
                            LEGACY_size: "small"
                        }),
                        onClick: onClick,
                        onMouseOver: onMouseOver,
                        shouldFitContainer: true,
                        "aria-label": formatMessage((0, $hhood.default).addRelatedWork)
                    }))
            })))),
        renderBody: ()=>body
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c048d8a6986fd4e0$var$ActionsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulppxbi _1e0c1txw _2lx21bp4 _4cvr1y6m _ca0qu2gc _19bv1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c048d8a6986fd4e0$var$ActionIconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_u5f3u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c048d8a6986fd4e0$var$ShowMoreTextContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48pi7a9",
            __cmplp.className
        ])
    });
}); // RLSS-2812 color.background.accent.gray.subtlest might be better than color.background.neutral
const $c048d8a6986fd4e0$var$AddButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko14y2 _1bsb1osq _80omtlke _ca0qu2gc _u5f3idpf _n3tdu2gc _19bvidpf _10j7m7j4 _irr3m7j4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c048d8a6986fd4e0$var$AddButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_14741e5h",
            __cmplp.className
        ])
    });
});
const $c048d8a6986fd4e0$var$sectionTitleStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.300',
    marginBottom: 'space.300',
    marginRight: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c048d8a6986fd4e0$var$AddIconButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbxy5q _4t3ixy5q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c048d8a6986fd4e0$var$HeaderWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _19pk1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c048d8a6986fd4e0$var$HeaderLeftWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _80omtlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c048d8a6986fd4e0$var$HeaderRightWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c048d8a6986fd4e0$var$TotalCountLozenge = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _2rkoftgi _bfhk11bn _1e0c1txw _1bah1h6o _4cvr1h6o _4t3ipxbi _19pkv77o _u5f31b66 _19bv1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cXDwW", function(module, exports) {

$parcel$export(module.exports, "default", () => $271daf69aa10b7d2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f9594b0e9cfedaf2fac09cafe5fbee81>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $271daf69aa10b7d2$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "forward",
                    "path": [
                        "relatedWorkV2"
                    ]
                }
            ]
        },
        "name": "ui_softwareReleasesVersionRelatedWork_RelatedWork",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "relatedWorkV2",
                    "concreteType": "JiraVersionRelatedWorkV2Connection",
                    "kind": "LinkedField",
                    "name": "__version_relatedWorkV2_connection",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraVersionRelatedWorkV2Edge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "relatedWorkList_softwareReleasesVersionRelatedWork_relatedWorkEdges"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "categoryFilter_softwareReleasesVersionRelatedWork"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_relatedWorkEdges"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_relatedWorkEdges"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "analyticsContext_softwareReleasesVersionRelatedWork_RelatedWorkAnalyticsContext"
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "async_softwareReleasesAddRelatedWorkToVersion_EditRelatedWorkPopup_jiraVersionRelatedWork"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "category"
                                            },
                                            v0 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "cursor"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "relatedWorkV2.edges"
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                }
                            ]
                        }
                    ]
                },
                "action": "THROW",
                "path": "relatedWorkV2"
            },
            {
                "kind": "ScalarField",
                "name": "status"
            },
            {
                "kind": "FragmentSpread",
                "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_jiraVersion"
            },
            {
                "kind": "FragmentSpread",
                "name": "async_softwareReleasesAddRelatedWorkToVersion_EditRelatedWorkPopup_jiraVersion"
            },
            {
                "kind": "FragmentSpread",
                "name": "emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_jiraVersion"
            },
            {
                "kind": "FragmentSpread",
                "name": "relatedWorkList_softwareReleasesVersionRelatedWork_jiraVersion"
            },
            {
                "kind": "FragmentSpread",
                "name": "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection"
            }
        ],
        "type": "JiraVersion"
    };
}();
$271daf69aa10b7d2$var$node.hash = "ee870a351f61b9ac907790203ed00950";
var $271daf69aa10b7d2$export$2e2bcd8739ae039 = $271daf69aa10b7d2$var$node;

});

parcelRegister("24M80", function(module, exports) {

$parcel$export(module.exports, "useAddRelatedWorkExperienceStart", () => $bbfb89cc55331a7a$export$2a84c09279dbc41e);
$parcel$export(module.exports, "useAddRelatedWorkExperienceFail", () => $bbfb89cc55331a7a$export$b2970d2d64ed7236);
$parcel$export(module.exports, "useAddRelatedWorkExperienceSuccess", () => $bbfb89cc55331a7a$export$f01728e86602e7e0);

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $efvDm = parcelRequire("efvDm");

var $k9JTq = parcelRequire("k9JTq");
const $bbfb89cc55331a7a$var$EXPERIENCE_NAME = 'addRelatedWork';
const $bbfb89cc55331a7a$var$ANALYTICS_SOURCE = 'versionDetails';
const $bbfb89cc55331a7a$export$2a84c09279dbc41e = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    return (0, $kaHBi.useExperienceStart)({
        experience: $bbfb89cc55331a7a$var$EXPERIENCE_NAME,
        experienceId: `${Date.now()}`,
        analyticsSource: $bbfb89cc55331a7a$var$ANALYTICS_SOURCE,
        application: (0, $efvDm.JIRA_SOFTWARE),
        edition: appEditions.software
    });
};
const $bbfb89cc55331a7a$export$b2970d2d64ed7236 = ()=>(0, $93jKl.useExperienceFail)({
        experience: $bbfb89cc55331a7a$var$EXPERIENCE_NAME
    });
const $bbfb89cc55331a7a$export$f01728e86602e7e0 = ()=>(0, $3bQtK.useExperienceSuccess)({
        experience: $bbfb89cc55331a7a$var$EXPERIENCE_NAME
    });

});

parcelRegister("a3dw0", function(module, exports) {

$parcel$export(module.exports, "AddRelatedWorkPopup", () => $7428db04b10b730a$export$7c8948b134dbfa2e);

var $2VJK6 = parcelRequire("2VJK6");

var $2CHAQ = parcelRequire("2CHAQ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7428db04b10b730a$var$LazyAddRelatedWorkPopup = (0, $kxZPA.lazy)(()=>(parcelRequire("bh6TP")).then((module)=>module.AddRelatedWorkPopup), {
    moduleId: "./src/packages/releases/add-related-work-to-version/src/ui/add-related-work-popup/index.tsx"
});
const $7428db04b10b730a$export$7c8948b134dbfa2e = ({ jiraVersion: jiraVersion, renderTrigger: renderTrigger, relatedWorkEdges: relatedWorkEdges })=>{
    const version = (0, $8Uumt.useFragment)((0, $2CHAQ.default), jiraVersion);
    const edges = (0, $8Uumt.useFragment)((0, $2VJK6.default), relatedWorkEdges);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "add-related-work-popup",
        fallback: renderTrigger({
            triggerProps: {},
            onClick: ()=>undefined,
            onMouseOver: ()=>undefined,
            isLoading: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7428db04b10b730a$var$LazyAddRelatedWorkPopup, {
        jiraVersion: version,
        renderTrigger: renderTrigger,
        relatedWorkEdges: edges
    }));
};

});
parcelRegister("2VJK6", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfaf71cfb4d5cd58$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c1093bcdbe8a0213bfff539dbd23c487>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bfaf71cfb4d5cd58$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_relatedWorkEdges",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "addRelatedWorkPopup_softwareReleasesAddRelatedWorkToVersion_relatedWorkEdges"
        }
    ],
    "type": "JiraVersionRelatedWorkV2Edge"
};
$bfaf71cfb4d5cd58$var$node.hash = "a1ee6f3b568b757ef42ae7c9484cb878";
var $bfaf71cfb4d5cd58$export$2e2bcd8739ae039 = $bfaf71cfb4d5cd58$var$node;

});

parcelRegister("2CHAQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $30c9f14cd20d8427$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2ae5b22d33923ae62c0eb9c486b2bf3c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $30c9f14cd20d8427$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_jiraVersion",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "addRelatedWorkPopup_softwareReleasesAddRelatedWorkToVersion_jiraVersion"
        }
    ],
    "type": "JiraVersion"
};
$30c9f14cd20d8427$var$node.hash = "61023dc51339302e0390200141db5335";
var $30c9f14cd20d8427$export$2e2bcd8739ae039 = $30c9f14cd20d8427$var$node;

});

parcelRegister("bh6TP", function(module, exports) {

let $8356a250592876f7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8356a250592876f7$var$load("isV8z").then(()=>parcelRequire('lhLRC'));

});


parcelRegister("e4M5y", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $ea3b3ec2dfca475e$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");
const $ea3b3ec2dfca475e$export$e926676385687eaf = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "flag",
        ...props,
        packageName: "jiraSoftwareReleasesVersionRelatedWork",
        teamName: "nova"
    });

});

parcelRegister("aef30", function(module, exports) {

$parcel$export(module.exports, "default", () => $193339bde9da421a$export$2e2bcd8739ae039);

var $10JTQ = parcelRequire("10JTQ");

var $5uXOq = parcelRequire("5uXOq");

var $fn8B5 = parcelRequire("fn8B5");

var $8Uumt = parcelRequire("8Uumt");

var $iXVV6 = parcelRequire("iXVV6");

var $cjkuK = parcelRequire("cjkuK");
const $193339bde9da421a$var$isFirstPartyLink = (url)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    new URL(url).hostname === window.location.hostname;
const $193339bde9da421a$var$useAnalyticsAttributes = (relatedWorkItems)=>{
    const numberOfRelatedWorkItems = relatedWorkItems.length;
    const relatedWorkTypes = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(relatedWorkItems, (item)=>item.node?.__typename);
    const hasNativeReleaseNotes = relatedWorkTypes.JiraVersionRelatedWorkNativeReleaseNotes?.length > 0;
    const numConfluenceReleaseNotes = relatedWorkTypes.JiraVersionRelatedWorkConfluenceReleaseNotes?.length ?? 0;
    const getIssueLinkingAttributes = ()=>{
        const numOfLinkedIssues = relatedWorkItems.filter((item)=>item.node?.issue !== null).length;
        return {
            numOfLinkedIssues: numOfLinkedIssues
        };
    };
    const formatCategoryName = (0, $cjkuK.useFormatCategoryName)();
    const getPlaceholderStateAttributes = ()=>{
        const genericLinks = relatedWorkTypes.JiraVersionRelatedWorkGenericLink ?? [];
        const numPlaceholderItems = genericLinks.filter((item)=>item.node?.url === null).length;
        const numNonPlaceholderItems = genericLinks.length - numPlaceholderItems;
        const numFirstPartyLinks = genericLinks.filter((item)=>item.node?.url != null && $193339bde9da421a$var$isFirstPartyLink(item.node.url)).length;
        const numThirdPartyLinks = numNonPlaceholderItems - numFirstPartyLinks;
        const itemsByCategories = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(relatedWorkItems, (item)=>item.node?.category);
        // This is a temporary approach that won't properly recognise categories if the item was created in a different
        // locale from the one it's being viewed in. A more robust enum-based approach should be used once related work
        // items are migrated out of Data Depot and into ERS.
        const countItemsInCategory = (category)=>itemsByCategories[formatCategoryName(category)]?.length ?? 0;
        const defaultCategoryUsageCounts = (0, $cjkuK.DEFAULT_CATEGORIES).map((category)=>[
                category.analyticsAttributeName,
                countItemsInCategory(category)
            ]);
        const numItemsInDefaultCategories = defaultCategoryUsageCounts.reduce((runningTotal, [, itemsInCategory])=>runningTotal + itemsInCategory, 0);
        const numItemsInOtherCategories = numberOfRelatedWorkItems - numItemsInDefaultCategories;
        const numCategories = Object.keys(itemsByCategories).length;
        return {
            numPlaceholderItems: numPlaceholderItems,
            numNonPlaceholderItems: numNonPlaceholderItems,
            numFirstPartyLinks: numFirstPartyLinks,
            numThirdPartyLinks: numThirdPartyLinks,
            numItemsInOtherCategories: numItemsInOtherCategories,
            numCategories: numCategories,
            ...Object.fromEntries(defaultCategoryUsageCounts)
        };
    };
    return {
        // The `numLinks` name is slightly misleading, but we're keeping it for historical reasons
        numLinks: numberOfRelatedWorkItems,
        hasNativeReleaseNotes: hasNativeReleaseNotes,
        numConfluenceReleaseNotes: numConfluenceReleaseNotes,
        // Note: when you clean up these flags, make the relevant fields in `AnalyticsAttributes`
        // required rather than optional.
        ...getPlaceholderStateAttributes(),
        ...getIssueLinkingAttributes()
    };
};
const $193339bde9da421a$export$e6de70608562a971 = ({ relatedWorkEdges: relatedWorkEdges, children: children })=>{
    const data = (0, $8Uumt.useFragment)((0, $10JTQ.default), relatedWorkEdges);
    const attributes = $193339bde9da421a$var$useAnalyticsAttributes(data);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "versionRelatedWork",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        attributes: attributes
    }, children);
};
var $193339bde9da421a$export$2e2bcd8739ae039 = $193339bde9da421a$export$e6de70608562a971;

});
parcelRegister("10JTQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $08a25dc50161972b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b00338198aa2a5443fe90e410f9e4c7a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $08a25dc50161972b$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": {
            "plural": true
        },
        "name": "analyticsContext_softwareReleasesVersionRelatedWork_RelatedWorkAnalyticsContext",
        "selections": [
            {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "url"
                            }
                        ],
                        "type": "JiraVersionRelatedWorkGenericLink"
                    }
                ]
            }
        ],
        "type": "JiraVersionRelatedWorkV2Edge"
    };
}();
$08a25dc50161972b$var$node.hash = "aa20d10ea14c3261013e36223676a0c8";
var $08a25dc50161972b$export$2e2bcd8739ae039 = $08a25dc50161972b$var$node;

});

parcelRegister("cjkuK", function(module, exports) {

$parcel$export(module.exports, "CommunicationCategory", () => $13a1a183bcb398c4$export$4c00bbfcc0ecf975);
$parcel$export(module.exports, "RolloutCategory", () => $13a1a183bcb398c4$export$f4e280770913e10f);
$parcel$export(module.exports, "TestingCategory", () => $13a1a183bcb398c4$export$a6d4661a542d168f);
$parcel$export(module.exports, "AnalyticsCategory", () => $13a1a183bcb398c4$export$257af46c9923adf8);
$parcel$export(module.exports, "DevelopmentCategory", () => $13a1a183bcb398c4$export$d3d779bdc5757c39);
$parcel$export(module.exports, "SupportCategory", () => $13a1a183bcb398c4$export$1909a2cc48b27b53);
$parcel$export(module.exports, "DEFAULT_CATEGORIES", () => $13a1a183bcb398c4$export$b101d8f25cc16679);
$parcel$export(module.exports, "useFormatCategoryName", () => $13a1a183bcb398c4$export$890bc5a26a499c1d);
$parcel$export(module.exports, "usePlaceholderIcon", () => $13a1a183bcb398c4$export$ec6234b435e23f80);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $gCeEl = parcelRequire("gCeEl");

var $aSRxW = parcelRequire("aSRxW");

var $k17ll = parcelRequire("k17ll");

var $kBmdu = parcelRequire("kBmdu");
const $13a1a183bcb398c4$export$4c00bbfcc0ecf975 = {
    i18nMessage: (0, $kBmdu.default).communicationCategory,
    placeholderIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gCeEl.DocumentPlusGlyph), null),
    analyticsAttributeName: 'numLinksInCommunicationCategory'
};
const $13a1a183bcb398c4$export$f4e280770913e10f = {
    i18nMessage: (0, $kBmdu.default).rolloutCategory,
    placeholderIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aSRxW.GenericPlusGlyph), null),
    analyticsAttributeName: 'numLinksInRolloutCategory'
};
const $13a1a183bcb398c4$export$a6d4661a542d168f = {
    i18nMessage: (0, $kBmdu.default).testingCategory,
    placeholderIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gCeEl.DocumentPlusGlyph), null),
    analyticsAttributeName: 'numLinksInTestingCategory'
};
const $13a1a183bcb398c4$export$257af46c9923adf8 = {
    i18nMessage: (0, $kBmdu.default).analyticsCategory,
    placeholderIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k17ll.PresentationPlusGlyph), null),
    analyticsAttributeName: 'numLinksInAnalyticsCategory'
};
const $13a1a183bcb398c4$export$d3d779bdc5757c39 = {
    i18nMessage: (0, $kBmdu.default).developmentCategory,
    placeholderIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aSRxW.GenericPlusGlyph), null),
    analyticsAttributeName: 'numLinksInDevelopmentCategory'
};
const $13a1a183bcb398c4$export$1909a2cc48b27b53 = {
    i18nMessage: (0, $kBmdu.default).supportCategory,
    placeholderIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aSRxW.GenericPlusGlyph), null),
    analyticsAttributeName: 'numLinksInSupportCategory'
};
const $13a1a183bcb398c4$export$b101d8f25cc16679 = [
    $13a1a183bcb398c4$export$4c00bbfcc0ecf975,
    $13a1a183bcb398c4$export$f4e280770913e10f,
    $13a1a183bcb398c4$export$a6d4661a542d168f,
    $13a1a183bcb398c4$export$257af46c9923adf8,
    $13a1a183bcb398c4$export$d3d779bdc5757c39,
    $13a1a183bcb398c4$export$1909a2cc48b27b53
];
const $13a1a183bcb398c4$export$890bc5a26a499c1d = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return (defaultCategoryInfo)=>formatMessage(defaultCategoryInfo.i18nMessage);
};
const $13a1a183bcb398c4$export$ec6234b435e23f80 = (categoryName)=>{
    const formatCategoryName = $13a1a183bcb398c4$export$890bc5a26a499c1d();
    // This is a temporary approach that will fall back to a generic icon if the placeholder was created in a different
    // locale from the one it's being viewed in. A more robust enum-based approach should be used once related work items
    // are migrated out of Data Depot and into ERS.
    const defaultCategory = $13a1a183bcb398c4$export$b101d8f25cc16679.find((category)=>formatCategoryName(category) === categoryName);
    return defaultCategory?.placeholderIcon ? defaultCategory.placeholderIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aSRxW.GenericPlusGlyph), null);
};

});
parcelRegister("gCeEl", function(module, exports) {

$parcel$export(module.exports, "DocumentPlusGlyph", () => $3512bc29c550fe45$export$95d5a31c5e54a0d2);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");
const $3512bc29c550fe45$export$95d5a31c5e54a0d2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24px",
        height: "24px",
        viewBox: "7.5 0.5 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#clip0_10645_15672)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "16",
        height: "16",
        transform: "translate(8 8)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.0619 8H10C9.46957 8 8.96086 8.21071 8.58579 8.58579C8.21071 8.96086 8 9.46957 8 10V22C8 22.5304 8.21071 23.0391 8.58579 23.4142C8.96086 23.7893 9.46957 24 10 24H22C22.5304 24 23.0391 23.7893 23.4142 23.4142C23.7893 23.0391 24 22.5304 24 22V14.9381C22.365 14.7342 20.8832 14.037 19.7084 13H12C11.7348 13 11.4804 12.8946 11.2929 12.7071C11.1054 12.5196 11 12.2652 11 12C11 11.7348 11.1054 11.4804 11.2929 11.2929C11.4804 11.1054 11.7348 11 12 11H18.0703C17.5478 10.0968 17.1968 9.08194 17.0619 8ZM11.2929 15.2929C11.4804 15.1054 11.7348 15 12 15H20C20.2652 15 20.5196 15.1054 20.7071 15.2929C20.8946 15.4804 21 15.7348 21 16C21 16.2652 20.8946 16.5196 20.7071 16.7071C20.5196 16.8946 20.2652 17 20 17H12C11.7348 17 11.4804 16.8946 11.2929 16.7071C11.1054 16.5196 11 16.2652 11 16C11 15.7348 11.1054 15.4804 11.2929 15.2929ZM11.2929 19.2929C11.4804 19.1054 11.7348 19 12 19H16C16.2652 19 16.5196 19.1054 16.7071 19.2929C16.8946 19.4804 17 19.7348 17 20C17 20.2652 16.8946 20.5196 16.7071 20.7071C16.5196 20.8946 16.2652 21 16 21H12C11.7348 21 11.4804 20.8946 11.2929 20.7071C11.1054 20.5196 11 20.2652 11 20C11 19.7348 11.1054 19.4804 11.2929 19.2929Z",
        fill: "#0C66E4"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "19",
        y: "1",
        width: "12",
        height: "12",
        rx: "6",
        fill: "#22A06B"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.5 6.5V4.5C25.5 4.36739 25.4473 4.24021 25.3536 4.14645C25.2598 4.05268 25.1326 4 25 4C24.8674 4 24.7402 4.05268 24.6464 4.14645C24.5527 4.24021 24.5 4.36739 24.5 4.5V6.5H22.5C22.3674 6.5 22.2402 6.55268 22.1464 6.64645C22.0527 6.74021 22 6.86739 22 7C22 7.13261 22.0527 7.25979 22.1464 7.35355C22.2402 7.44732 22.3674 7.5 22.5 7.5H24.5V9.5C24.5 9.63261 24.5527 9.75979 24.6464 9.85355C24.7402 9.94732 24.8674 10 25 10C25.1326 10 25.2598 9.94732 25.3536 9.85355C25.4473 9.75979 25.5 9.63261 25.5 9.5V7.5H27.5C27.6326 7.5 27.7598 7.44732 27.8536 7.35355C27.9473 7.25979 28 7.13261 28 7C28 6.86739 27.9473 6.74021 27.8536 6.64645C27.7598 6.55268 27.6326 6.5 27.5 6.5H25.5Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "clip0_10645_15672"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white",
        transform: "translate(8 8)"
    }))));

});

parcelRegister("aSRxW", function(module, exports) {

$parcel$export(module.exports, "GenericPlusGlyph", () => $f5ae30733710816a$export$e68c0551132b814f);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");
const $f5ae30733710816a$export$e68c0551132b814f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24px",
        height: "24px",
        viewBox: "7.5 0.5 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#clip0_10645_15679)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "16",
        height: "16",
        transform: "translate(8 8)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.0619 8H9.994C8.895 8 8 8.893 8 9.994V22.006C8.00026 22.5348 8.21043 23.0418 8.58432 23.4157C8.95821 23.7896 9.46524 23.9997 9.994 24H22.006C22.5348 23.9997 23.0418 23.7896 23.4157 23.4157C23.7896 23.0418 23.9997 22.5348 24 22.006V14.9381C20.3813 14.4869 17.5131 11.6187 17.0619 8ZM13.333 11H16H16.782C16.9614 10.9998 17.139 11.0359 17.3041 11.106C17.4692 11.1761 17.6185 11.2788 17.743 11.408L19.907 13.658C19.9667 13.7201 20 13.8029 20 13.889V14.792C20 14.975 19.851 15.125 19.667 15.125H17.333C16.597 15.125 16 14.528 16 13.792V12.378H13.333V19.622H18.667V16H20V19.622C20 20.383 19.403 21 18.667 21H13.333C12.597 21 12 20.382 12 19.622V12.378C12 11.617 12.597 11 13.333 11Z",
        fill: "#5E6C84"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "19",
        y: "1",
        width: "12",
        height: "12",
        rx: "6",
        fill: "#22A06B"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.5 6.5V4.5C25.5 4.36739 25.4473 4.24021 25.3536 4.14645C25.2598 4.05268 25.1326 4 25 4C24.8674 4 24.7402 4.05268 24.6464 4.14645C24.5527 4.24021 24.5 4.36739 24.5 4.5V6.5H22.5C22.3674 6.5 22.2402 6.55268 22.1464 6.64645C22.0527 6.74021 22 6.86739 22 7C22 7.13261 22.0527 7.25979 22.1464 7.35355C22.2402 7.44732 22.3674 7.5 22.5 7.5H24.5V9.5C24.5 9.63261 24.5527 9.75979 24.6464 9.85355C24.7402 9.94732 24.8674 10 25 10C25.1326 10 25.2598 9.94732 25.3536 9.85355C25.4473 9.75979 25.5 9.63261 25.5 9.5V7.5H27.5C27.6326 7.5 27.7598 7.44732 27.8536 7.35355C27.9473 7.25979 28 7.13261 28 7C28 6.86739 27.9473 6.74021 27.8536 6.64645C27.7598 6.55268 27.6326 6.5 27.5 6.5H25.5Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "clip0_10645_15679"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white",
        transform: "translate(8 8)"
    }))));

});

parcelRegister("k17ll", function(module, exports) {

$parcel$export(module.exports, "PresentationPlusGlyph", () => $14cff13b7789db4e$export$4026a3889e667c70);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");
const $14cff13b7789db4e$export$4026a3889e667c70 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24px",
        height: "24px",
        viewBox: "7.5 0.5 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#clip0_10645_15686)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "16",
        height: "16",
        transform: "translate(8 8)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.0619 8H10C9.46957 8 8.96086 8.21071 8.58579 8.58579C8.21071 8.96086 8 9.46957 8 10V22C8 22.5304 8.21071 23.0391 8.58579 23.4142C8.96086 23.7893 9.46957 24 10 24H22C22.5304 24 23.0391 23.7893 23.4142 23.4142C23.7893 23.0391 24 22.5304 24 22V14.9381C22.9181 14.8032 21.9032 14.4522 21 13.9297V20C21 20.2652 20.8946 20.5196 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21C19.7348 21 19.4804 20.8946 19.2929 20.7071C19.1054 20.5196 19 20.2652 19 20V12.2916C17.963 11.1168 17.2658 9.635 17.0619 8ZM15.2929 14.2929C15.4804 14.1054 15.7348 14 16 14C16.2652 14 16.5196 14.1054 16.7071 14.2929C16.8946 14.4804 17 14.7348 17 15V20C17 20.2652 16.8946 20.5196 16.7071 20.7071C16.5196 20.8946 16.2652 21 16 21C15.7348 21 15.4804 20.8946 15.2929 20.7071C15.1054 20.5196 15 20.2652 15 20V15C15 14.7348 15.1054 14.4804 15.2929 14.2929ZM11.2929 17.2929C11.4804 17.1054 11.7348 17 12 17C12.2652 17 12.5196 17.1054 12.7071 17.2929C12.8946 17.4804 13 17.7348 13 18V20C13 20.2652 12.8946 20.5196 12.7071 20.7071C12.5196 20.8946 12.2652 21 12 21C11.7348 21 11.4804 20.8946 11.2929 20.7071C11.1054 20.5196 11 20.2652 11 20V18C11 17.7348 11.1054 17.4804 11.2929 17.2929Z",
        fill: "#8270DB"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "19",
        y: "1",
        width: "12",
        height: "12",
        rx: "6",
        fill: "#22A06B"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.5 6.5V4.5C25.5 4.36739 25.4473 4.24021 25.3536 4.14645C25.2598 4.05268 25.1326 4 25 4C24.8674 4 24.7402 4.05268 24.6464 4.14645C24.5527 4.24021 24.5 4.36739 24.5 4.5V6.5H22.5C22.3674 6.5 22.2402 6.55268 22.1464 6.64645C22.0527 6.74021 22 6.86739 22 7C22 7.13261 22.0527 7.25979 22.1464 7.35355C22.2402 7.44732 22.3674 7.5 22.5 7.5H24.5V9.5C24.5 9.63261 24.5527 9.75979 24.6464 9.85355C24.7402 9.94732 24.8674 10 25 10C25.1326 10 25.2598 9.94732 25.3536 9.85355C25.4473 9.75979 25.5 9.63261 25.5 9.5V7.5H27.5C27.6326 7.5 27.7598 7.44732 27.8536 7.35355C27.9473 7.25979 28 7.13261 28 7C28 6.86739 27.9473 6.74021 27.8536 6.64645C27.7598 6.55268 27.6326 6.5 27.5 6.5H25.5Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "clip0_10645_15686"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white",
        transform: "translate(8 8)"
    }))));

});

parcelRegister("kBmdu", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cd855af87b6eafb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1cd855af87b6eafb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    testingCategory: {
        "id": "software-releases-version-related-work-categories.common.default-categories.testing-category",
        "defaultMessage": "Testing"
    },
    rolloutCategory: {
        "id": "software-releases-version-related-work-categories.common.default-categories.rollout-category",
        "defaultMessage": "Rollout"
    },
    analyticsCategory: {
        "id": "software-releases-version-related-work-categories.common.default-categories.analytics-category",
        "defaultMessage": "Analytics"
    },
    communicationCategory: {
        "id": "software-releases-version-related-work-categories.common.default-categories.communication-category",
        "defaultMessage": "Communication"
    },
    developmentCategory: {
        "id": "software-releases-version-related-work-categories.common.default-categories.development-category",
        "defaultMessage": "Development"
    },
    supportCategory: {
        "id": "software-releases-version-related-work-categories.common.default-categories.support-category",
        "defaultMessage": "Support"
    }
});

});



parcelRegister("23OBX", function(module, exports) {

$parcel$export(module.exports, "CategoryFilter", () => $de63c0a6daedd5ee$export$cb2cc3e02411c0f4);

var $jWtjn = parcelRequire("jWtjn");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fn8B5 = parcelRequire("fn8B5");

var $8Uumt = parcelRequire("8Uumt");

var $koVbs = parcelRequire("koVbs");

var $hBvOQ = parcelRequire("hBvOQ");

var $iZMIP = parcelRequire("iZMIP");

var $21BDB = parcelRequire("21BDB");
const $de63c0a6daedd5ee$export$c50c7c4a5ff445b1 = 5;
const $de63c0a6daedd5ee$export$cb2cc3e02411c0f4 = ({ relatedWorkEdges: relatedWorkEdges, selectedCategory: selectedCategory, onCategorySelected: onCategorySelected })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const tabRefs = (0, $5uXOq.useRef)([]); // State to keep track of which tab has keyboard focus
    const [focusedIndex, setFocusedIndex] = (0, $5uXOq.useState)(-1);
    const edges = (0, $8Uumt.useFragment)((0, $jWtjn.default), relatedWorkEdges);
    const edgesByCategory = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(edges, (edge)=>edge?.node.category);
    const sortedCategoriesWithCounts = Object.keys(edgesByCategory).map((category)=>[
            category,
            edgesByCategory[category].length
        ]).sort(([categoryA], [categoryB])=>categoryA.localeCompare(categoryB));
    const isknownCategory = selectedCategory === undefined || sortedCategoriesWithCounts.some(([category])=>category === selectedCategory); // If the selected category is unknown, un-select it (the selected category comes from
    // a query param, so we can't trust it will always be valid).
    (0, $5uXOq.useEffect)(()=>{
        if (!isknownCategory) onCategorySelected(undefined);
    }, [
        isknownCategory,
        onCategorySelected
    ]);
    const categoriesWithCountWithinThreshold = sortedCategoriesWithCounts.slice(0, $de63c0a6daedd5ee$export$c50c7c4a5ff445b1);
    const categoriesWithCountAfterThreshold = sortedCategoriesWithCounts.slice($de63c0a6daedd5ee$export$c50c7c4a5ff445b1);
    const allCategoryOptions = (0, $5uXOq.useMemo)(()=>[
            {
                label: formatMessage((0, $iZMIP.default).all),
                category: undefined
            },
            ...categoriesWithCountWithinThreshold.map(([category])=>({
                    label: category,
                    category: category
                }))
        ], [
        formatMessage,
        categoriesWithCountWithinThreshold
    ]); // Find the index of the selected category
    const selectedIndex = allCategoryOptions.findIndex((option)=>option.category === selectedCategory); // Handle keyboard navigation. Tabs should be navigable with arrow keys
    const handleKeyDown = (0, $5uXOq.useCallback)((e)=>{
        const tabCount = allCategoryOptions.length;
        let newIndex = focusedIndex;
        switch(e.key){
            case 'ArrowRight':
            case 'ArrowDown':
                e.preventDefault();
                newIndex = (focusedIndex + 1) % tabCount;
                break;
            case 'ArrowLeft':
            case 'ArrowUp':
                e.preventDefault();
                newIndex = (focusedIndex - 1 + tabCount) % tabCount;
                break;
            case 'Home':
                e.preventDefault();
                newIndex = 0;
                break;
            case 'End':
                e.preventDefault();
                newIndex = tabCount - 1;
                break;
            case 'Enter':
            case ' ':
                e.preventDefault();
                if (focusedIndex >= 0 && focusedIndex < tabCount) onCategorySelected(allCategoryOptions[focusedIndex].category);
                return;
            default:
                return;
        }
        // Update focused index and set focus
        setFocusedIndex(newIndex);
        tabRefs.current[newIndex]?.focus(); // Select the tab when navigating with arrow keys
        if (newIndex >= 0 && newIndex < tabCount) onCategorySelected(allCategoryOptions[newIndex].category);
    }, [
        allCategoryOptions,
        focusedIndex,
        onCategorySelected
    ]);
    // Update refs array when categories change
    (0, $5uXOq.useEffect)(()=>{
        tabRefs.current = tabRefs.current.slice(0, allCategoryOptions.length);
    }, [
        allCategoryOptions.length
    ]); // Set initial focus to the selected tab when the component mounts
    (0, $5uXOq.useEffect)(()=>{
        if (selectedIndex >= 0) setFocusedIndex(selectedIndex);
    }, [
        selectedIndex
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($de63c0a6daedd5ee$var$Container, {
        onKeyDown: handleKeyDown,
        "aria-label": formatMessage((0, $iZMIP.default).ariaFilterLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($de63c0a6daedd5ee$var$Container, {
        role: "tablist"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBvOQ.Lozenge), {
        label: formatMessage((0, $iZMIP.default).all),
        count: edges.length ?? 0,
        isSelected: selectedCategory === undefined,
        onClick: ()=>onCategorySelected(undefined),
        tabIndex: selectedCategory === undefined ? 0 : -1,
        "aria-selected": selectedCategory === undefined,
        role: "tab",
        ref: (el)=>{
            tabRefs.current[0] = el;
        }
    }), categoriesWithCountWithinThreshold.map(([category, count], index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hBvOQ.Lozenge), {
            key: category,
            label: category,
            count: count,
            isSelected: category === selectedCategory,
            onClick: ()=>onCategorySelected(category),
            tabIndex: category === selectedCategory ? 0 : -1,
            "aria-selected": category === selectedCategory,
            ref: (el)=>{
                tabRefs.current[index + 1] = el;
            },
            role: "tab"
        }))), categoriesWithCountAfterThreshold.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $21BDB.MoreLozengeAsync), {
        categories: categoriesWithCountAfterThreshold.map(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([category, count])=>({
                label: category,
                count: count,
                isSelected: category === selectedCategory,
                onClick: ()=>onCategorySelected(category),
                tabIndex: category === selectedCategory ? 0 : -1,
                'aria-selected': category === selectedCategory
            }))
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $de63c0a6daedd5ee$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _1n261g80",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jWtjn", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e5c6a475ff71547$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<37fd70250cf323faed8eaab1c7b77e6a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6e5c6a475ff71547$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "categoryFilter_softwareReleasesVersionRelatedWork",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        "action": "NONE",
                        "path": "node.category"
                    }
                ]
            },
            "action": "NONE",
            "path": "node"
        }
    ],
    "type": "JiraVersionRelatedWorkV2Edge"
};
$6e5c6a475ff71547$var$node.hash = "26b1d568eba141b6bfe3000d32fec7e5";
var $6e5c6a475ff71547$export$2e2bcd8739ae039 = $6e5c6a475ff71547$var$node;

});

parcelRegister("hBvOQ", function(module, exports) {

$parcel$export(module.exports, "Lozenge", () => $e48a18721cdfc1a2$export$a31cbe1bf5463979);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
const $e48a18721cdfc1a2$export$a31cbe1bf5463979 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ label: label, count: count, isSelected: isSelected, onClick: onClick, tabIndex: tabIndex = 0, role: role, 'aria-selected': ariaSelected }, ref)=>{
    const { formatNumber: formatNumber } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e48a18721cdfc1a2$var$Button, {
        ref: ref,
        role: role,
        title: label,
        "aria-selected": ariaSelected,
        "aria-controls": `related-work-tab-${label.replaceAll(' ', '-')}`,
        id: `related-work-tab-${label.replaceAll(' ', '-')}`,
        isSelected: isSelected,
        tabIndex: tabIndex,
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick();
            }
        },
        onClick: ()=>{
            onClick();
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'lozenge'
            }), 'relatedWorkCategory');
        },
        "data-testid": "software-releases-version-related-work.ui.category-filter.lozenge.button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e48a18721cdfc1a2$var$Label, null, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e48a18721cdfc1a2$var$Count, null, formatNumber(count)));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e48a18721cdfc1a2$var$Button = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkodlk8 _11c8dcr7 _1dqoglyw _1e0c1txw _ca0q1b66 _u5f3u2gc _n3td1b66 _19bvu2gc _80omtlke _vwz4f6fq",
            __cmplp.isSelected ? "_bfhkfg4m" : "_bfhkm7j4",
            __cmplp.isSelected ? "_syaze0os" : "_syaz1gjq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e48a18721cdfc1a2$var$Label = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1o8l _p12f1kdj _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e48a18721cdfc1a2$var$Count = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48pmoej _19bv12x7",
            __cmplp.className
        ])
    });
});

});

parcelRegister("iZMIP", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f4135e7ecbb3a6b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4f4135e7ecbb3a6b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    all: {
        "id": "software-releases-version-related-work.category-filter.all",
        "defaultMessage": "All"
    },
    ariaFilterLabel: {
        "id": "software-releases-version-related-work.category-filter.aria-filter-label",
        "defaultMessage": "Filter related work by category"
    }
});

});

parcelRegister("21BDB", function(module, exports) {

$parcel$export(module.exports, "MoreLozengeAsync", () => $97665c1381d8292f$export$1e468fbbda90a7b4);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $hgKcP = parcelRequire("hgKcP");

var $lhsVB = parcelRequire("lhsVB");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $97665c1381d8292f$var$LazyMoreLozenge = (0, $kxZPA.lazy)(()=>Promise.resolve((parcelRequire("hgKcP"))).then((mod)=>mod.MoreLozenge), {
    moduleId: "./src/packages/releases/version-related-work/src/ui/category-filter/more-lozenge/MoreLozenge.tsx"
});
const $97665c1381d8292f$export$1e468fbbda90a7b4 = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { categories: categories } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jira-software-releases-version-detail-related-work-more-lozenge",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hgKcP.LozengeButton), {
            isSelected: categories.some((category)=>category.isSelected)
        }, formatMessage((0, $lhsVB.default).moreButtonLabel, {
            count: categories.length
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97665c1381d8292f$var$LazyMoreLozenge, props));
};

});
parcelRegister("hgKcP", function(module, exports) {

$parcel$export(module.exports, "MoreLozenge", () => $64b9b9de3a5b0ec0$export$394f480a87f8efa7);
$parcel$export(module.exports, "LozengeButton", () => $64b9b9de3a5b0ec0$export$2c8fc3c10740b2a5);
/* MoreLozenge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $2NMNM = parcelRequire("2NMNM");

var $BLPHT = parcelRequire("BLPHT");
var $a5n5E = parcelRequire("a5n5E");
var $b2TJP = parcelRequire("b2TJP");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $lhsVB = parcelRequire("lhsVB");
const $64b9b9de3a5b0ec0$export$394f480a87f8efa7 = ({ categories: categories, defaultOpen: defaultOpen = false })=>{
    const { formatNumber: formatNumber, formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        defaultOpen: defaultOpen,
        trigger: ({ triggerRef: triggerRef, ...otherProps })=>{
            const { isSelected: isDropdownOpen } = otherProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($64b9b9de3a5b0ec0$export$2c8fc3c10740b2a5, {
                ...otherProps,
                onKeyDown: (e)=>{
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        otherProps.onClick?.(e);
                    }
                },
                "aria-haspopup": "true",
                isDropdownOpen: isDropdownOpen ?? false,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                ref: triggerRef,
                isSelected: categories.some((category)=>category.isSelected),
                "data-testid": "software-releases-version-related-work.ui.category-filter.more-lozenge.dropdown-trigger"
            }, formatMessage((0, $lhsVB.default).moreButtonLabel, {
                count: categories.length
            }));
        },
        shouldRenderToParent: (0, $4R6GH.fg)('should-render-to-parent-should-be-true-nova')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b2TJP.default), {
        id: "categories"
    }, categories.map(({ label: label, count: count, onClick: onClick, isSelected: isSelected })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a5n5E.default), {
            isSelected: isSelected,
            onClick: ()=>{
                onClick();
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'lozenge'
                }), 'relatedWorkCategory');
            },
            id: label,
            key: label,
            testId: "software-releases-version-related-work.ui.category-filter.more-lozenge.dropdown-item-button"
        }, label, " (", formatNumber(count), ")"))));
};
const $64b9b9de3a5b0ec0$export$2c8fc3c10740b2a5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDropdownOpen: isDropdownOpen, isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ojklwr": (0, $lD23V.default)((()=>{
                // Nested ternary operator is needed, otherwise there's a bug that the first token is applied regardless of condition
                // eslint-disable-next-line no-nested-ternary
                return __cmplp.isDropdownOpen ? "var(--ds-background-neutral-bold, #44546F)" : __cmplp.isSelected ? "var(--ds-background-selected, #E9F2FF)" // RLSS-2812 Replace color.background.neutral to color.background.accent.gray.subtlest
                 : "var(--ds-background-neutral, #091E420F)";
            })()),
            "--_1ko4ni5": (0, $lD23V.default)((()=>{
                // Nested ternary operator is needed, otherwise there's a bug that the first token is applied regardless of condition
                // eslint-disable-next-line no-nested-ternary
                return __cmplp.isDropdownOpen ? "var(--ds-text-inverse, #FFFFFF)" : __cmplp.isSelected ? "var(--ds-text-information, #0055CC)" : "var(--ds-text-subtlest, #626F86)";
            })())
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkodlk8 _11c8dcr7 _1dqoglyw _1e0c1txw _ca0q1b66 _u5f3u2gc _n3td1b66 _19bvu2gc _80omtlke _bfhk149g _syaz17rc _vwz4f6fq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lhsVB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2adc7535873c8f8f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2adc7535873c8f8f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    moreButtonLabel: {
        "id": "software-releases-version-related-work.category-filter.more-lozenge.more-button-label",
        "defaultMessage": "+{count} more"
    }
});

});




parcelRegister("iaG90", function(module, exports) {

$parcel$export(module.exports, "RelatedWorkEmptyState", () => $4bf624bf2d80822c$export$eeabb037f6ceac15);

var $fFUyY = parcelRequire("fFUyY");

var $21azx = parcelRequire("21azx");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $koVbs = parcelRequire("koVbs");

var $24M80 = parcelRequire("24M80");

var $a3dw0 = parcelRequire("a3dw0");

var $e4M5y = parcelRequire("e4M5y");

var $fWb7u = parcelRequire("fWb7u");

var $k8OPU = parcelRequire("k8OPU");

var $dZhCe = parcelRequire("dZhCe");
const $4bf624bf2d80822c$export$eeabb037f6ceac15 = ({ jiraVersion: jiraVersion, relatedWorkEdges: relatedWorkEdges })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const addRelatedWorkExpFailed = (0, $24M80.useAddRelatedWorkExperienceFail)();
    const version = (0, $8Uumt.useFragment)((0, $21azx.default), jiraVersion);
    const edges = (0, $8Uumt.useFragment)((0, $fFUyY.default), relatedWorkEdges);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4bf624bf2d80822c$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fWb7u.VersionRelatedWorkExperienceSuccessTracker), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($k8OPU))),
        width: 80,
        height: 71.45,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("section", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h3",
        size: "xsmall"
    }, formatMessage((0, $dZhCe.default).emptyStateHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4bf624bf2d80822c$var$Description, null, formatMessage((0, $dZhCe.default).emptyStateDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4M5y.ErrorBoundary), {
        id: "addRelatedPopupInEmptyState",
        fallback: "unmount",
        onError: (location, error)=>{
            addRelatedWorkExpFailed(location, error);
        }
    }, version.status != null && version.status !== 'ARCHIVED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a3dw0.AddRelatedWorkPopup), {
        jiraVersion: version,
        relatedWorkEdges: edges,
        renderTrigger: ({ triggerProps: triggerProps, onClick: onClick, isLoading: isLoading, onMouseOver: onMouseOver })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...triggerProps,
                onClick: onClick,
                testId: isLoading ? undefined : 'software-releases-version-related-work.ui.empty-state.button',
                onMouseOver: onMouseOver
            }, formatMessage((0, $dZhCe.default).add))
    })));
};
// RLSS-2812 color.border.bold might look better than color.border. Personally I feel that color.border is too subtle in Dark mode
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4bf624bf2d80822c$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoftgi _189eyh40 _1dqogq9o _1h6dmuej _1e0c1txw _4cvr1h6o _gy1p1ejb _19pkpxbi _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4bf624bf2d80822c$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz131l _p12f1ffr",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fFUyY", function(module, exports) {

$parcel$export(module.exports, "default", () => $dac88918497cff9c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3933bc99277dd3082f972f5de4a18d40>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dac88918497cff9c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_relatedWorkEdges",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_relatedWorkEdges"
        }
    ],
    "type": "JiraVersionRelatedWorkV2Edge"
};
$dac88918497cff9c$var$node.hash = "93018a8cf1d1d8516c9bb5d6c022ae78";
var $dac88918497cff9c$export$2e2bcd8739ae039 = $dac88918497cff9c$var$node;

});

parcelRegister("21azx", function(module, exports) {

$parcel$export(module.exports, "default", () => $84b1a607716c4ff7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2798bc7e1de0fb498b8952176e0d5284>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $84b1a607716c4ff7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_jiraVersion",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_jiraVersion"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        }
    ],
    "type": "JiraVersion"
};
$84b1a607716c4ff7$var$node.hash = "8330954195b2fe0fa1d89b6b61b53975";
var $84b1a607716c4ff7$export$2e2bcd8739ae039 = $84b1a607716c4ff7$var$node;

});

parcelRegister("k8OPU", function(module, exports) {
module.exports = new URL("documents-illustration.37d481a2.svg", import.meta.url).toString();

});

parcelRegister("dZhCe", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b86761f81df3cdc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5b86761f81df3cdc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyStateHeading: {
        "id": "software-releases-version-related-work.empty-state.empty-state-heading",
        "defaultMessage": "Start adding some related work"
    },
    emptyStateDescription: {
        "id": "software-releases-version-related-work.empty-state.empty-state-description",
        "defaultMessage": "Add the work that's needed to get ready for your release like designs, release notes, analytics dashboards, and more!"
    },
    add: {
        "id": "software-releases-version-related-work.empty-state.add",
        "defaultMessage": "Add related work"
    }
});

});


parcelRegister("hhood", function(module, exports) {

$parcel$export(module.exports, "default", () => $22c34e0f660d12bd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $22c34e0f660d12bd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    relatedWorkHeading: {
        "id": "software-releases-version-related-work.related-work-heading",
        "defaultMessage": "Related work"
    },
    addRelatedWork: {
        "id": "software-releases-version-related-work.add-related-work",
        "defaultMessage": "Add links, release notes, and more\u2026"
    },
    showMore: {
        "id": "software-releases-version-related-work.show-more",
        "defaultMessage": "Show {moreItemsCount} more"
    },
    showLess: {
        "id": "software-releases-version-related-work.show-less",
        "defaultMessage": "Show {moreItemsCount} less"
    }
});

});

parcelRegister("gCsUv", function(module, exports) {

$parcel$export(module.exports, "RelatedWorkList", () => $d31b32d43fc469e4$export$25137fc5a267c4a9);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $295jB = parcelRequire("295jB");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d31b32d43fc469e4$var$LazyRelatedWorkList = (0, $kxZPA.lazy)(()=>(parcelRequire("1DBUE")).then((module)=>module.RelatedWorkList), {
    moduleId: "./src/packages/releases/version-related-work/src/ui/related-work-list/index.tsx"
});
const $d31b32d43fc469e4$export$25137fc5a267c4a9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "related-work-list",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $295jB.SkeletonRelatedWorkList), {
            numLinks: props.relatedWorkEdges.length
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d31b32d43fc469e4$var$LazyRelatedWorkList, props));

});
parcelRegister("295jB", function(module, exports) {

$parcel$export(module.exports, "SkeletonRelatedWorkList", () => $b33ba786c145e430$export$98236437a8dbfc1c);
/* SkeletonRelatedWorkList.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $b33ba786c145e430$export$98236437a8dbfc1c = ({ numLinks: numLinks })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b33ba786c145e430$var$TableWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b33ba786c145e430$var$RelatedWorkItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b33ba786c145e430$var$SkeletonRelatedWorkRowWrapper, null, [
        ...Array(numLinks)
    ].map((_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b33ba786c145e430$var$RelatedWorkItemWrapper, {
            key: i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b33ba786c145e430$var$SkeletonRelatedWorkIcon, {
            opacity: 1 - i * 0.2
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b33ba786c145e430$var$SkeletonRelatedWorkItemLarge, {
            opacity: 1 - i * 0.2
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b33ba786c145e430$var$SkeletonRelatedWorkRowWrapper, null, [
        ...Array(numLinks)
    ].map((_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b33ba786c145e430$var$SkeletonRelatedWorkItemSmall, {
            key: i,
            opacity: 1 - i * 0.2
        })))));
const $b33ba786c145e430$var$shimmer = null;
const $b33ba786c145e430$var$SkeletonRelatedWorkItemStyles = null;
const $b33ba786c145e430$var$verticalMargin = 15;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b33ba786c145e430$var$SkeletonRelatedWorkIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_kn3dj": (0, $lD23V.default)(__cmplp.opacity)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _18s81vn1 _ju258bk0 _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1kpv _12vemgnk _4t3iqslr _bfhkn82g _j7hqw3o4 _1bsbqslr",
            __cmplp.opacity ? "_tzy41p15" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
});
const $b33ba786c145e430$var$SkeletonRelatedWorkItemLarge = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_kn3dj": (0, $lD23V.default)(__cmplp.opacity)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _19pko7ao _2hwxidpf _otyro7ao _18u0idpf _ju258bk0 _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1kpv _12vemgnk _4t3iqslr _bfhkn82g _j7hqw3o4 _1bsbpo3b",
            __cmplp.opacity ? "_tzy41p15" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
});
const $b33ba786c145e430$var$SkeletonRelatedWorkItemSmall = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_kn3dj": (0, $lD23V.default)(__cmplp.opacity)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _18s81w5s _ju258bk0 _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1kpv _12vemgnk _4t3iqslr _bfhkn82g _j7hqw3o4 _1bsb1ex1",
            __cmplp.opacity ? "_tzy41p15" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
});
const $b33ba786c145e430$var$TableWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _1e0c1txw _kqswh2mm _2lx21bp4 _ca0qutpp",
            __cmplp.className
        ])
    });
});
const $b33ba786c145e430$var$SkeletonRelatedWorkRowWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _1bah1yb4 _19bv1b66 _1p571b66",
            __cmplp.className
        ])
    });
});
const $b33ba786c145e430$var$RelatedWorkItemWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1DBUE", function(module, exports) {

let $1316d7a80391cbb3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1316d7a80391cbb3$var$load("fliVL"),
    $1316d7a80391cbb3$var$load("1uhfN")
]).then(()=>parcelRequire('dTy2j'));

});



parcelRegister("cXbjp", function(module, exports) {

$parcel$export(module.exports, "RelatedWorkLoadingSkeleton", () => $b5a6538f1e64b530$export$d1ea41fcd84767c8);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $1DVhQ = parcelRequire("1DVhQ");
const $b5a6538f1e64b530$var$RelatedWorkItemSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $b5a6538f1e64b530$var$relatedWorkWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        xcss: $b5a6538f1e64b530$var$relatedWorkLeftWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "24px",
        height: "24px",
        isShimmering: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        xcss: $b5a6538f1e64b530$var$relatedWorkRightWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "350px",
        height: "24px",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "220px",
        height: "18px",
        isShimmering: true
    })));
const $b5a6538f1e64b530$export$d1ea41fcd84767c8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        xcss: $b5a6538f1e64b530$var$headerSkeletonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "220px",
        height: "24px",
        isShimmering: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $b5a6538f1e64b530$var$categoryFilterRowStlyes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        isShimmering: true,
        borderRadius: 14,
        width: "52px",
        height: "26px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        isShimmering: true,
        borderRadius: 14,
        width: "85px",
        height: "26px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        isShimmering: true,
        borderRadius: 14,
        width: "125px",
        height: "26px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        isShimmering: true,
        borderRadius: 14,
        width: "110px",
        height: "26px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        isShimmering: true,
        borderRadius: 14,
        width: "110",
        height: "26px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        isShimmering: true,
        borderRadius: 14,
        width: "70px",
        height: "26px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b5a6538f1e64b530$var$RelatedWorkItemSkeleton, null)));
const $b5a6538f1e64b530$var$headerSkeletonStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.500',
    marginBottom: 'space.250'
});
const $b5a6538f1e64b530$var$categoryFilterRowStlyes = (0, $8CUq3.xcss)({
    gap: 'space.100',
    marginBottom: 'space.150'
});
const $b5a6538f1e64b530$var$relatedWorkWrapperStyles = (0, $8CUq3.xcss)({
    height: 'space.800'
});
const $b5a6538f1e64b530$var$relatedWorkRightWrapperStyles = (0, $8CUq3.xcss)({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 'space.150'
});
const $b5a6538f1e64b530$var$relatedWorkLeftWrapperStyles = (0, $8CUq3.xcss)({
    width: '64px',
    height: '64px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});

});

parcelRegister("iMhWR", function(module, exports) {

$parcel$export(module.exports, "AsyncVersionRichTextSection", () => $865e37e6a4604790$export$6803497461260cfa);

var $hP2RT = parcelRequire("hP2RT");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8Uumt = parcelRequire("8Uumt");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $865e37e6a4604790$var$LazyVersionRichTextSection = (0, $kxZPA.lazy)(()=>(parcelRequire("l2oLD")).then((module)=>module.VersionRichTextSection), {
    moduleId: "./src/packages/releases/version-rich-text-section/src/ui/index.tsx"
});
const $865e37e6a4604790$export$6803497461260cfa = ({ jiraVersion: jiraVersion })=>{
    const version = (0, $8Uumt.useFragment)((0, $hP2RT.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "rich-text-section",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($865e37e6a4604790$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($865e37e6a4604790$var$SkeletonItem, {
            width: "15%"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($865e37e6a4604790$var$SkeletonItem, {
            width: "45%"
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($865e37e6a4604790$var$LazyVersionRichTextSection, {
        jiraVersion: version
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $865e37e6a4604790$var$SkeletonItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1gljcou": (0, $lD23V.default)(__cmplp.width)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _bfhkn82g _4t3idlk8 _1bsb1rkg _19pkutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $865e37e6a4604790$var$SkeletonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _1bah1y6m _19pk1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hP2RT", function(module, exports) {

$parcel$export(module.exports, "default", () => $158348738d9fccd5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f6be8816f0e078a42b8f843748f38b46>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $158348738d9fccd5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "async_softwareReleasesVersionRichTextSection_AsyncVersionRichTextSection",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionRichTextSection_VersionRichTextSection"
        }
    ],
    "type": "JiraVersion"
};
$158348738d9fccd5$var$node.hash = "d5a19fe58067365a8d3ea1743ac2c96d";
var $158348738d9fccd5$export$2e2bcd8739ae039 = $158348738d9fccd5$var$node;

});

parcelRegister("l2oLD", function(module, exports) {

let $f50cff285443d980$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f50cff285443d980$var$load("ffQaD"),
    $f50cff285443d980$var$load("kvRbA"),
    $f50cff285443d980$var$load("fliVL"),
    $f50cff285443d980$var$load("h3CiI")
]).then(()=>parcelRequire('fphGU'));

});


parcelRegister("g3ebu", function(module, exports) {

$parcel$export(module.exports, "IssueAssociatedDesignsExperienceStart", () => $8c9aecd7d75220b0$export$81d77c7d61cbddef);
$parcel$export(module.exports, "IssueAssociatedDesignsExperienceSuccess", () => $8c9aecd7d75220b0$export$709f489a7a70c461);
$parcel$export(module.exports, "useIssueAssociatedDesignsExperienceFail", () => $8c9aecd7d75220b0$export$715c37bd4d0b2cba);

var $5uXOq = parcelRequire("5uXOq");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $efvDm = parcelRequire("efvDm");

var $k9JTq = parcelRequire("k9JTq");
const $8c9aecd7d75220b0$var$EXPERIENCE_NAME = 'issueAssociatedDesigns';
const $8c9aecd7d75220b0$var$ANALYTICS_SOURCE = 'versionDetails';
const $8c9aecd7d75220b0$export$81d77c7d61cbddef = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kaHBi.ExperienceStart), {
        experienceId: "jiraVersionDetailsIssueAssociatedDesigns",
        experience: $8c9aecd7d75220b0$var$EXPERIENCE_NAME,
        analyticsSource: $8c9aecd7d75220b0$var$ANALYTICS_SOURCE,
        edition: appEditions.software,
        application: (0, $efvDm.JIRA_SOFTWARE)
    });
};
const $8c9aecd7d75220b0$export$709f489a7a70c461 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: $8c9aecd7d75220b0$var$EXPERIENCE_NAME
    });
const $8c9aecd7d75220b0$export$715c37bd4d0b2cba = ()=>(0, $93jKl.useExperienceFail)({
        experience: $8c9aecd7d75220b0$var$EXPERIENCE_NAME
    });

});

parcelRegister("fCXaV", function(module, exports) {

$parcel$export(module.exports, "IssueAssociatedDesigns", () => $0282686bbab839ac$export$891b244b5d2793aa);
$parcel$export(module.exports, "DesignSectionSkeleton", () => $0282686bbab839ac$export$b6a2d0e3927c95cf);

var $4UYYD = parcelRequire("4UYYD");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8Uumt = parcelRequire("8Uumt");

var $16T6Y = parcelRequire("16T6Y");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $fi7WV = parcelRequire("fi7WV");

var $7NYUV = parcelRequire("7NYUV");

var $g3ebu = parcelRequire("g3ebu");

var $lbwou = parcelRequire("lbwou");

var $9EnlV = parcelRequire("9EnlV");

var $bgc85 = parcelRequire("bgc85");
const $0282686bbab839ac$export$891b244b5d2793aa = ({ queryRef: queryRef })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { jira: { version: version } } = (0, $8Uumt.usePreloadedQuery)((0, $4UYYD.default), queryRef);
    // In real world this shouldn't happen, since this query won't be even executed when this happen by version detail's page main query
    if (version.__typename !== 'JiraVersion') throw new Error('Version query result is not VersionResult');
    const { totalCount: totalCount } = version.issueAssociatedDesigns;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "versionIssueAssociatedDesigns",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        attributes: {
            designsCount: totalCount
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fi7WV.CollapsibleSection), {
        jiraVersion: version,
        renderBody: ()=>{
            if (totalCount === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9EnlV.EmptyState), null);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lbwou.DesignCarousel), {
                jiraVersion: version
            });
        },
        renderHeader: (isCollapsed, onToggleClicked)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0282686bbab839ac$var$HeaderWrapper, {
                onClick: onToggleClicked
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
                size: "small",
                as: "h2"
            }, formatMessage((0, $bgc85.default).designSectionLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), null, totalCount), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fi7WV.CollapsibleToggleButton), {
                isCollapsed: isCollapsed,
                onClick: onToggleClicked
            })),
        uiType: "ISSUE_ASSOCIATED_DESIGNS"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g3ebu.IssueAssociatedDesignsExperienceSuccess), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));
};
const $0282686bbab839ac$export$b6a2d0e3927c95cf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0282686bbab839ac$var$SkeletonItem, {
        width: "220px",
        height: "24px",
        margin: "44px 0 20px 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $0282686bbab839ac$var$designCardsSkeletonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYUV.DesignCardSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYUV.DesignCardSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYUV.DesignCardSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYUV.DesignCardSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYUV.DesignCardSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYUV.DesignCardSkeleton), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $0282686bbab839ac$var$crouselCounterStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0282686bbab839ac$var$SkeletonItem, {
        width: "100px",
        height: "20px",
        margin: "20px 0 0 0"
    })));
const $0282686bbab839ac$var$designCardsSkeletonWrapperStyles = (0, $8CUq3.xcss)({
    gap: 'space.200',
    width: '100%',
    overflow: 'hidden',
    padding: 'space.050',
    marginTop: 'space.100'
});
const $0282686bbab839ac$var$crouselCounterStyles = (0, $8CUq3.xcss)({
    justifyContent: 'center',
    alignItems: 'center',
    height: '20px'
});
const $0282686bbab839ac$var$animationOptionStyles = null;
const $0282686bbab839ac$var$shimmer = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $0282686bbab839ac$var$SkeletonItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { margin: margin, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $lD23V.default)(__cmplp.height),
            "--_1gljcou": (0, $lD23V.default)(__cmplp.width),
            "--_146ducd": (0, $lD23V.default)(`${__cmplp.margin}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _18s8j3fp _ju258bk0 _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1kpv _12vemgnk _j7hqw3o4 _bfhkn82g _4t3i1474 _1bsb1rkg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0282686bbab839ac$var$HeaderWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _2lx2vrvc _4cvr1h6o _1bah1y6m _80omtlke _19pk1jfw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7NYUV", function(module, exports) {

$parcel$export(module.exports, "DesignCardSkeleton", () => $806bf9aadc6655b9$export$1743685a5725b0ae);
/* DesignCardSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $lQYCz = parcelRequire("lQYCz");
const $806bf9aadc6655b9$export$1743685a5725b0ae = ({ onVisible: onVisible })=>{
    const onSetElementRef = (0, $lQYCz.useIntersectionObserver)({
        margin: 0,
        onIntersection: ()=>onVisible?.()
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $806bf9aadc6655b9$var$cardContainerStyles,
        ref: onSetElementRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($806bf9aadc6655b9$var$SkeletonItem, {
        width: "24px",
        height: "24px",
        margin: "0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        xcss: $806bf9aadc6655b9$var$titleStackStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($806bf9aadc6655b9$var$SkeletonItem, {
        width: "220px",
        height: "16px",
        margin: "2px 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($806bf9aadc6655b9$var$SkeletonItem, {
        width: "80px",
        height: "12px",
        margin: "2px 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($806bf9aadc6655b9$var$SkeletonItem, {
        width: "120px",
        height: "24px",
        margin: "12px 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($806bf9aadc6655b9$var$SkeletonItem, {
        width: "50px",
        height: "12px",
        margin: "2px 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($806bf9aadc6655b9$var$SkeletonItem, {
        width: "240px",
        height: "26px",
        margin: "5px 0"
    })));
};
const $806bf9aadc6655b9$var$animationOptionStyles = null;
const $806bf9aadc6655b9$var$shimmer = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $806bf9aadc6655b9$var$SkeletonItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { margin: margin, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $lD23V.default)(__cmplp.height),
            "--_1gljcou": (0, $lD23V.default)(__cmplp.width),
            "--_146ducd": (0, $lD23V.default)(`${__cmplp.margin}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _18s8j3fp _ju258bk0 _5sagymdr _1o51q7pw _tip812c5 _1pglp3kn _1itk1kpv _12vemgnk _j7hqw3o4 _bfhkn82g _4t3i1474 _1bsb1rkg",
            __cmplp.className
        ])
    });
});
const $806bf9aadc6655b9$var$cardContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    border: '3px',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    boxShadow: 'elevation.shadow.raised'
});
const $806bf9aadc6655b9$var$titleStackStyles = (0, $8CUq3.xcss)({
    flex: 1,
    marginLeft: 'space.100',
    overflow: 'hidden'
});

});
parcelRegister("lQYCz", function(module, exports) {

$parcel$export(module.exports, "useIntersectionObserver", () => $a631eb23b7c62b0c$export$a7395f9832c00176);

var $5uXOq = parcelRequire("5uXOq");
const $a631eb23b7c62b0c$export$a7395f9832c00176 = ({ margin: margin, threshold: threshold = 0, onIntersection: onIntersection })=>{
    const [observedElement, setObservedElement] = (0, $5uXOq.useState)(null);
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (observedElement === null || window.IntersectionObserver === undefined) return undefined;
        const observerCallback = (entries)=>entries.forEach(({ isIntersecting: isIntersecting, time: time })=>{
                if (isIntersecting) onIntersection(time);
            });
        const observer = new IntersectionObserver(observerCallback, {
            rootMargin: `${margin}px`,
            threshold: threshold
        });
        observer.observe(observedElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        observedElement,
        onIntersection,
        margin,
        threshold
    ]);
    return setObservedElement;
};

});


parcelRegister("lbwou", function(module, exports) {

$parcel$export(module.exports, "DesignCarousel", () => $da5a6b112d157da9$export$f1038593ff0bfc1e);

var $1Q5uL = parcelRequire("1Q5uL");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $iASWI = parcelRequire("iASWI");

var $8Uumt = parcelRequire("8Uumt");

var $2NMNM = parcelRequire("2NMNM");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gJlZe = parcelRequire("gJlZe");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");


var $7NYUV = parcelRequire("7NYUV");

var $6glsJ = parcelRequire("6glsJ");

var $bslvg = parcelRequire("bslvg");

var $7SORO = parcelRequire("7SORO");
const $da5a6b112d157da9$var$getNumFullyRenderedCards = (carouselWidth)=>Math.floor(carouselWidth / (0, $6738210abd29fb18$export$2796973bb2f51929)); // curPageNum: 0-based, returned number: 1-based(displayed to user)
const $da5a6b112d157da9$var$getCurPageStartEndNum = (fullyRenderedCardNum, curPageNum, totalCount)=>({
        currentStart: curPageNum * fullyRenderedCardNum + 1,
        currentEnd: totalCount >= (curPageNum + 1) * fullyRenderedCardNum ? (curPageNum + 1) * fullyRenderedCardNum : totalCount,
        lastPageNum: Math.ceil(totalCount / fullyRenderedCardNum) - 1
    });
const $da5a6b112d157da9$export$f1038593ff0bfc1e = ({ jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [carouselWidth, setCarouselWidth] = (0, $5uXOq.useState)(0);
    const [curPageNum, setCurPageNum] = (0, $5uXOq.useState)(0);
    const { data: data, hasNext: hasNext, loadNext: loadNext, isLoadingNext: isLoadingNext } = (0, $8Uumt.usePaginationFragment)((0, $1Q5uL.default), jiraVersion);
    const designEdges = data.issueAssociatedDesigns?.edges ?? [];
    const designNodes = designEdges.filter(Boolean).map((edge)=>edge.node).filter(Boolean); // We only need to use the potentially inaccurate/outdated `totalCount` value from
    // the API if we don't have all the edges loaded.
    const totalCount = hasNext ? data.issueAssociatedDesigns.totalCount : designNodes?.length ?? 0;
    const numFullyRenderedCards = $da5a6b112d157da9$var$getNumFullyRenderedCards(carouselWidth);
    const carouselPageInfo = $da5a6b112d157da9$var$getCurPageStartEndNum(numFullyRenderedCards, curPageNum, totalCount);
    (0, $5uXOq.useEffect)(()=>{
        // This is for resize event, and due to resize carousel page becomes over the last page when width grows.
        if (carouselPageInfo.lastPageNum < curPageNum) setCurPageNum(carouselPageInfo.lastPageNum);
    }, [
        carouselPageInfo.lastPageNum,
        curPageNum
    ]);
    if (totalCount === 0) return null;
    const numCardSkeleton = totalCount - designNodes.length;
    const firePaginationAnalytics = (direction)=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'designsPagination', {
            direction: direction
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $da5a6b112d157da9$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gJlZe.WidthObserver), {
        setWidth: setCarouselWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da5a6b112d157da9$var$CarouselWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da5a6b112d157da9$var$CarouselSlider, {
        widthOffset: curPageNum * numFullyRenderedCards * ((0, $6738210abd29fb18$export$2796973bb2f51929) + (0, $6738210abd29fb18$export$c73e9b0a14b3993b))
    }, designNodes.map((designNode)=>// id shouldn't be null in real world. https://atlassian.slack.com/archives/C01E2MPPLE4/p1709250064060249
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bslvg.DesignCard), {
            key: designNode.id ?? '',
            devOpsDesign: designNode,
            jiraVersion: data
        })), hasNext && (0, (/*@__PURE__*/$parcel$interopDefault($iASWI)))(numCardSkeleton).map((n)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYUV.DesignCardSkeleton), {
            key: n,
            onVisible: ()=>{
                if (!hasNext || isLoadingNext) return null;
                loadNext(6);
            }
        })))), numFullyRenderedCards < Math.max(totalCount, designNodes.length) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da5a6b112d157da9$var$ArrowWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6glsJ.Arrow), {
        direction: "LEFT",
        onClick: ()=>{
            if (curPageNum === 0) return;
            setCurPageNum(curPageNum - 1);
            firePaginationAnalytics('left');
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6glsJ.Arrow), {
        direction: "RIGHT",
        onClick: ()=>{
            if (carouselPageInfo.currentEnd >= totalCount) return;
            setCurPageNum(curPageNum + 1);
            firePaginationAnalytics('right');
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o"
        ])
    }, formatMessage((0, $7SORO.default).carouselPageCount, {
        ...carouselPageInfo,
        totalCount: totalCount
    })));
};
const $da5a6b112d157da9$var$wrapperStyles = (0, $8CUq3.xcss)({
    width: '100%',
    position: 'relative',
    marginTop: 'space.300'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da5a6b112d157da9$var$ArrowWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _94n5idpf _lcxvglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da5a6b112d157da9$var$CarouselWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _1bsb1osq _4cvr1fhb _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _vchhusvi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da5a6b112d157da9$var$CarouselSlider = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { widthOffset: widthOffset, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_z0ie8w": (0, $lD23V.default)(`translateX(-${__cmplp.widthOffset}px)`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _zulppxbi _v5641cdp _1e0c1txw _1bsb1osq _4cvr1fhb _t9ec1jj4",
            __cmplp.className
        ])
    });
});
const $da5a6b112d157da9$var$pageCounterStyles = null;

});
parcelRegister("1Q5uL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4de98e326a82dfd2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<044f2a1b50736a083aa773821be0554d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $j4z9I = parcelRequire("j4z9I");
const $4de98e326a82dfd2$var$node = function() {
    var v0 = [
        "issueAssociatedDesigns"
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "cloudAri"
            },
            {
                "defaultValue": 6,
                "kind": "LocalArgument",
                "name": "first"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $j4z9I.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "designCarousel_versionIssueAssociatedDesigns",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "designCard_versionIssueAssociatedDesigns_jiraVersion"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "issueAssociatedDesigns",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "sort",
                            "value": {
                                "createdAt": {
                                    "direction": "DESC",
                                    "priority": 1
                                }
                            }
                        }
                    ],
                    "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignConnection",
                    "kind": "LinkedField",
                    "name": "__DesignSlider_issueAssociatedDesigns_connection",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "designCard_versionIssueAssociatedDesigns_devOpsDesign"
                                                }
                                            ],
                                            "type": "DevOpsDesign"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "totalCount"
                            },
                            "action": "THROW",
                            "path": "issueAssociatedDesigns.totalCount"
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                }
                            ]
                        }
                    ],
                    "storageKey": "__DesignSlider_issueAssociatedDesigns_connection(sort:{\"createdAt\":{\"direction\":\"DESC\",\"priority\":1}})"
                },
                "action": "THROW",
                "path": "issueAssociatedDesigns"
            },
            v1 /*: any*/ 
        ],
        "type": "JiraVersion"
    };
}();
$4de98e326a82dfd2$var$node.hash = "7979312fd2183c859bc266fe0defac6d";
var $4de98e326a82dfd2$export$2e2bcd8739ae039 = $4de98e326a82dfd2$var$node;

});
parcelRegister("j4z9I", function(module, exports) {

$parcel$export(module.exports, "default", () => $d043ba78f7fe7367$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5cb0f9e844b8ed49be36f20a1c3e29ea>>
 * @relayHash f15bd8b5d1ef27139fdf753918230146
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3a775f0e0846c095fe7a545909336633e32a40abe3dbd41661e439df37e5d672
const $d043ba78f7fe7367$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudAri"
        },
        {
            "defaultValue": 6,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v3 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        v2 /*: any*/ ,
        v3 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "sort",
            "value": {
                "createdAt": {
                    "direction": "DESC",
                    "priority": 1
                }
            }
        }
    ], v7 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "versionDetailsDesignRefetchableQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ],
                            "kind": "FragmentSpread",
                            "name": "designCarousel_versionIssueAssociatedDesigns"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "versionDetailsDesignRefetchableQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignConnection",
                                    "kind": "LinkedField",
                                    "name": "issueAssociatedDesigns",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreSimplifiedVersionAssociatedDesignEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "url"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "displayName"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "lastUpdated"
                                                                },
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "id",
                                                                            "variableName": "cloudAri"
                                                                        }
                                                                    ],
                                                                    "kind": "LinkedField",
                                                                    "name": "provider",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v4 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "logoUrl"
                                                                        },
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "first",
                                                                            "value": 2
                                                                        }
                                                                    ],
                                                                    "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "associatedIssues",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v5 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "key"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "webUrl"
                                                                                                },
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Literal",
                                                                                                            "name": "idsOrAliases",
                                                                                                            "value": [
                                                                                                                "issuetype",
                                                                                                                "summary"
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "Literal",
                                                                                                            "name": "ignoreMissingFields",
                                                                                                            "value": true
                                                                                                        }
                                                                                                    ],
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldsByIdOrAlias",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v4 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueType",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "name"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAvatar",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "avatar",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "xsmall"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v5 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraIssueTypeField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "text"
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                        },
                                                                                                        v5 /*: any*/ 
                                                                                                    ],
                                                                                                    "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"issuetype\",\"summary\"],ignoreMissingFields:true)"
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraIssue"
                                                                                        },
                                                                                        v4 /*: any*/ ,
                                                                                        v7 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "associatedIssues(first:2)"
                                                                }
                                                            ],
                                                            "type": "DevOpsDesign"
                                                        },
                                                        v7 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                },
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalCount"
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v6 /*: any*/ ,
                                    "filters": [
                                        "sort"
                                    ],
                                    "handle": "connection",
                                    "key": "DesignSlider_issueAssociatedDesigns",
                                    "kind": "LinkedHandle",
                                    "name": "issueAssociatedDesigns"
                                }
                            ],
                            "type": "JiraVersion"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3a775f0e0846c095fe7a545909336633e32a40abe3dbd41661e439df37e5d672",
            "metadata": {},
            "name": "versionDetailsDesignRefetchableQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d043ba78f7fe7367$var$node.hash = "7979312fd2183c859bc266fe0defac6d";
var $d043ba78f7fe7367$export$2e2bcd8739ae039 = $d043ba78f7fe7367$var$node;

});


parcelRegister("gJlZe", function(module, exports) {

$parcel$export(module.exports, "WidthObserver", () => $f3c667de71b5760d$export$b2ad68b9bc407b80);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jWz2c = parcelRequire("jWz2c");
const $f3c667de71b5760d$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jWz2c.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $f3c667de71b5760d$export$2e2bcd8739ae039 = $f3c667de71b5760d$export$b2ad68b9bc407b80;

});
parcelRegister("jWz2c", function(module, exports) {

$parcel$export(module.exports, "WidthDetectorObserver", () => $76470ef26276f9f4$export$ff983d2a2b6112ea);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1LwQL = parcelRequire("1LwQL");
const $76470ef26276f9f4$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $1LwQL.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("1LwQL", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $1dfb7d23cdbb03d0$export$2f62ee6831462844);

var $5uXOq = parcelRequire("5uXOq");
function $1dfb7d23cdbb03d0$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



// in px
const $6738210abd29fb18$export$2796973bb2f51929 = 360;
const $6738210abd29fb18$export$c73e9b0a14b3993b = 16;

parcelRegister("6glsJ", function(module, exports) {

$parcel$export(module.exports, "Arrow", () => $a80d3a6c4b60d5c2$export$21b07c8f274aebd5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bu8Mq = parcelRequire("bu8Mq");

var $eGdV2 = parcelRequire("eGdV2");

var $koVbs = parcelRequire("koVbs");

var $jZgEb = parcelRequire("jZgEb");
const $a80d3a6c4b60d5c2$export$21b07c8f274aebd5 = ({ direction: direction, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a80d3a6c4b60d5c2$var$Wrapper, {
        onClick: onClick,
        direction: direction
    }, direction === 'LEFT' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bu8Mq))), {
        spacing: "spacious",
        label: formatMessage((0, $jZgEb.default).leftArrowlabel)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eGdV2))), {
        spacing: "spacious",
        label: formatMessage((0, $jZgEb.default).rightArrowlabel)
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a80d3a6c4b60d5c2$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoutpp _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11c81kw7 _12ji1r31 _1qu21kw7 _12y31o36 _lcxv1rj4 _kqswstnw _154ixncg _1bsb1ejb _4t3i1ejb _bfhk1j9a _syaz1fxt _80omtlke _16qs1cd0 _jomr108i _irr31ji5",
            __cmplp.direction === 'LEFT' ? "_1ltvxmi2" : "_1ltv1wug",
            __cmplp.direction === 'RIGHT' ? "_1xi2xmi2" : "_1xi21wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eGdV2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::101a51255f7076752a2af1f3fc652adc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aaffc8f190d8dd35$var$_react = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aaffc8f190d8dd35$var$_arrowRight = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("h1TKi")));

var $aaffc8f190d8dd35$var$_arrowRight2 = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("8RBk4")));
function $aaffc8f190d8dd35$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aaffc8f190d8dd35$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $aaffc8f190d8dd35$var$_react.default.createElement($aaffc8f190d8dd35$var$_arrowRight.default, Object.assign({
        LEGACY_fallbackIcon: $aaffc8f190d8dd35$var$_arrowRight2.default
    }, props));
$aaffc8f190d8dd35$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
var $aaffc8f190d8dd35$var$_default = module.exports.default = $aaffc8f190d8dd35$var$ArrowRightIcon;

});
parcelRegister("h1TKi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c65dc59efb96b35a$var$_react = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c65dc59efb96b35a$var$_baseNew = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c65dc59efb96b35a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c65dc59efb96b35a$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c65dc59efb96b35a$var$_react.default.createElement($c65dc59efb96b35a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$c65dc59efb96b35a$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c65dc59efb96b35a$var$_default = module.exports.default = $c65dc59efb96b35a$var$ArrowRightIcon;

});

parcelRegister("8RBk4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6740397d4ba98b13$var$_react = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $6740397d4ba98b13$var$_arrowRight = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("h1TKi")));
function $6740397d4ba98b13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6740397d4ba98b13$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $6740397d4ba98b13$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $6740397d4ba98b13$var$_arrowRight.default
    }));
$6740397d4ba98b13$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $6740397d4ba98b13$var$_default = module.exports.default = $6740397d4ba98b13$var$ArrowRightIcon;

});


parcelRegister("jZgEb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8124d0d178a5b95$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b8124d0d178a5b95$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    leftArrowlabel: {
        "id": "version-issue-associated-designs.design-carousel.arrow.left-arrowlabel",
        "defaultMessage": "To next page"
    },
    rightArrowlabel: {
        "id": "version-issue-associated-designs.design-carousel.arrow.right-arrowlabel",
        "defaultMessage": "To previous page"
    }
});

});


parcelRegister("bslvg", function(module, exports) {

$parcel$export(module.exports, "DesignCard", () => $7bcd6555400bf07e$export$a0f819c247fd2165);

var $k9Edn = parcelRequire("k9Edn");

var $iTare = parcelRequire("iTare");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $2NMNM = parcelRequire("2NMNM");

var $fVnbM = parcelRequire("fVnbM");

var $lfDf7 = parcelRequire("lfDf7");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $hnYwO = parcelRequire("hnYwO");

var $47gW9 = parcelRequire("47gW9");

var $ivDCs = parcelRequire("ivDCs");

var $4mO32 = parcelRequire("4mO32");

var $koVbs = parcelRequire("koVbs");

var $7IEKg = parcelRequire("7IEKg");

var $lfTZh = parcelRequire("lfTZh");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $7skxX = parcelRequire("7skxX");

var $koeKL = parcelRequire("koeKL");


var $lbXuZ = parcelRequire("lbXuZ");

var $719Uq = parcelRequire("719Uq");

var $i0rPK = parcelRequire("i0rPK");

var $7Tq5y = parcelRequire("7Tq5y");
const $7bcd6555400bf07e$var$DATE_FORMAT = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
};
const $7bcd6555400bf07e$var$runtimeProps = {};
const $7bcd6555400bf07e$export$a0f819c247fd2165 = ({ devOpsDesign: devOpsDesign, jiraVersion: jiraVersion })=>{
    const { formatDate: formatDate, formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isModalOpen, setIsModalOpen] = (0, $5uXOq.useState)(false);
    const [designIssuesModalQueryRef, loadDesignIssuesModalQuery] = (0, $8Uumt.useQueryLoader)((0, $7skxX.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const cloudId = (0, $koeKL.useCloudId)();
    const siteAri = (0, $hnYwO.JiraSiteAri).create({
        siteId: cloudId
    }).toString();
    const data = (0, $8Uumt.useFragment)((0, $iTare.default), devOpsDesign);
    const version = (0, $8Uumt.useFragment)((0, $k9Edn.default), jiraVersion);
    const onLoadDesignIssuesModalQuery = ()=>{
        if (designIssuesModalQueryRef == null) loadDesignIssuesModalQuery({
            cloudAri: siteAri,
            designAris: [
                data.id
            ],
            versionId: version.id
        });
    };
    const associatedIssuesNodes = (data.associatedIssues?.edges ?? []).filter(Boolean).map((edge)=>edge.node).filter((node)=>node?.__typename === 'JiraIssue').filter(Boolean);
    const issues = associatedIssuesNodes.length === 1 && associatedIssuesNodes[0].__typename === 'JiraIssue' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lbXuZ.SimpleIssueCard), {
        jiraIssue: associatedIssuesNodes[0],
        openIssueInSidebar: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        onMouseEnter: onLoadDesignIssuesModalQuery,
        onFocus: onLoadDesignIssuesModalQuery,
        className: (0, $bwpsq.default)([
            "_19pku2gc _n3td1b66 _18u0xmi2"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        spacing: "compact",
        appearance: "subtle",
        onClick: (_, analyticsEvent)=>{
            onLoadDesignIssuesModalQuery();
            setIsModalOpen(true);
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'designLinkedIssuesSeeAllModal');
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lfDf7))), {
            color: "var(--ds-icon-accent-blue, #1D7AFC)",
            LEGACY_size: "small",
            label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $i0rPK.default).issueIconLabelIssueTerminologyRefreshM4 : (0, $i0rPK.default).issueIconLabel)
        })
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $i0rPK.default).manyIssuesIssueTerminologyRefreshM4 : (0, $i0rPK.default).manyIssues))), designIssuesModalQueryRef != null && isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "version-detaiols-design-issues-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $719Uq.IssueModalLoading), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $719Uq.IssuesModal), {
        queryRef: designIssuesModalQueryRef,
        onClose: ()=>setIsModalOpen(false)
    }))); /**
         * Implementation wise DesignModal component is issue-centric. Hence we need an issue that is linked to this design to be able to
         * open the DesignModal preview. It doens't matter which issue we pick as all of them are linked to the current deisng, hence is the
         * term `representativeIssueAri`.
         */ 
    const representativeIssueAri = associatedIssuesNodes.length > 0 && associatedIssuesNodes[0].__typename === 'JiraIssue' ? associatedIssuesNodes[0].id : '';
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $7IEKg.designModalEntryPoint), {
        siteAri: siteAri,
        issueAri: representativeIssueAri,
        designAri: data.id,
        cloudId: cloudId
    });
    const modalTriggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "versionAssociatedDesignCard",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        attributes: {
            hasMultipleIssues: associatedIssuesNodes.length > 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $7bcd6555400bf07e$var$cardContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: data.provider.logoUrl,
        alt: "",
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1tcg _1ul91tcg _19pk12x7"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        xcss: $7bcd6555400bf07e$var$titleStackStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: data.url,
        target: "_blank",
        onClick: ()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'designTitleLink'),
        className: (0, $bwpsq.default)([
            "_4bfu18uv _1hmsglyw _ajmmnqa1 _1reo15vq _18m915vq _syaz1kw7 _k48p1pd9 _o5721q9c _1bto1l2s _9oik18uv _1bnx8stv _jf4cnqa1 _30l31kw7"
        ])
    }, data.displayName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatDate(data.lastUpdated, $7bcd6555400bf07e$var$DATE_FORMAT),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", {
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c81o8v _k48pi7a9 _syaz131l"
        ])
    }, (0, $7Tq5y.formatRelativeDate)(new Date(data.lastUpdated)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1bsb68cl _19pkutpp _otyrutpp"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ref: modalTriggerRef,
        shouldFitContainer: true,
        spacing: "compact",
        onClick: (_, analyticsEvent)=>(0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'openDesignPreviewButton')
    }, formatMessage((0, $i0rPK.default).openPreview))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", {
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c81o8v _k48pi7a9 _syaz131l"
        ])
    }, formatMessage((0, $i0rPK.default).linkedTo)), issues), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jiraDesignModalInVersionDetailsPage",
        packageName: "design-modal",
        entryPointActions: entryPointActions,
        runtimeProps: $7bcd6555400bf07e$var$runtimeProps
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));
};
const $7bcd6555400bf07e$var$cardContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    border: '3px',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    boxShadow: 'elevation.shadow.raised',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `${(0, $6738210abd29fb18$export$2796973bb2f51929)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $6738210abd29fb18$export$2796973bb2f51929)}px`
});
const $7bcd6555400bf07e$var$iconStyles = null;
const $7bcd6555400bf07e$var$titleStackStyles = (0, $8CUq3.xcss)({
    flex: 1,
    marginLeft: 'space.100',
    maxWidth: '312px' // CARD_WIDTH - paddings - icon width
});
const $7bcd6555400bf07e$var$lastUpdatedStyles = null;
const $7bcd6555400bf07e$var$openPreviewStyles = null;
const $7bcd6555400bf07e$var$linkedToStyles = null;
const $7bcd6555400bf07e$var$titleStyles = null;
const $7bcd6555400bf07e$var$manyIssuesButtonStyles = null;

});
parcelRegister("k9Edn", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3a205f0a4296aac$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e89d02b9a20fcaff4cda1b4ccb9afdcb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d3a205f0a4296aac$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "designCard_versionIssueAssociatedDesigns_jiraVersion",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        }
    ],
    "type": "JiraVersion"
};
$d3a205f0a4296aac$var$node.hash = "574075efd4cf2b2db85cdf409e87e841";
var $d3a205f0a4296aac$export$2e2bcd8739ae039 = $d3a205f0a4296aac$var$node;

});

parcelRegister("iTare", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2c46de8466b2b55$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8314031cb72b2628e29a5a3038f05a2d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f2c46de8466b2b55$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudAri"
            }
        ],
        "kind": "Fragment",
        "name": "designCard_versionIssueAssociatedDesigns_devOpsDesign",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "url"
                },
                "action": "THROW",
                "path": "url"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                "action": "THROW",
                "path": "displayName"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "lastUpdated"
                },
                "action": "THROW",
                "path": "lastUpdated"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "cloudAri"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "provider",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "logoUrl"
                            },
                            "action": "THROW",
                            "path": "provider.logoUrl"
                        }
                    ]
                },
                "action": "THROW",
                "path": "provider"
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 2
                    }
                ],
                "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseConnection",
                "kind": "LinkedField",
                "name": "associatedIssues",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "simpleIssueCard_versionIssueAssociatedDesigns"
                                            }
                                        ],
                                        "type": "JiraIssue"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "associatedIssues(first:2)"
            }
        ],
        "type": "DevOpsDesign"
    };
}();
$f2c46de8466b2b55$var$node.hash = "bb9498fa38fb746e3897ed942c1b67ca";
var $f2c46de8466b2b55$export$2e2bcd8739ae039 = $f2c46de8466b2b55$var$node;

});

parcelRegister("7skxX", function(module, exports) {

$parcel$export(module.exports, "default", () => $69efb06d34b4f404$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0c2ad0601128319e084fe547d3d8d145>>
 * @relayHash ae335ccbbdafd28c0b60d5176236e1a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 24c11f2af60eb7a3e378df4c9e585d36a069016d8981c6f13ade2b717e96e9bf
const $69efb06d34b4f404$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "designAris"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionId"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "ids",
            "variableName": "designAris"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "url"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "cloudAri"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "logoUrl"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issuesModal_designIssueQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "DevOps",
                        "kind": "LinkedField",
                        "name": "devOps",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "DevOpsDesign",
                                    "kind": "LinkedField",
                                    "name": "designEntityDetails",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v4 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "devOps.designEntityDetails.url"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v5 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "devOps.designEntityDetails.displayName"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "args": v6 /*: any*/ ,
                                                "kind": "LinkedField",
                                                "name": "provider",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v7 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "devOps.designEntityDetails.provider.logoUrl"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "devOps.designEntityDetails.provider"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "body_versionIssueAssociatedDesigns_IssuesModalBody"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "devOps.designEntityDetails"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "devOps"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "issuesModal_designIssueQuery",
            "selections": [
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "DevOpsDesign",
                            "kind": "LinkedField",
                            "name": "designEntityDetails",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "args": v6 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "provider",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v9 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 100
                                        }
                                    ],
                                    "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseConnection",
                                    "kind": "LinkedField",
                                    "name": "associatedIssues",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "key"
                                                                },
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "versionId",
                                                                            "variableName": "versionId"
                                                                        }
                                                                    ],
                                                                    "kind": "ScalarField",
                                                                    "name": "hasRelationshipToVersion"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "webUrl"
                                                                },
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "idsOrAliases",
                                                                            "value": [
                                                                                "issuetype",
                                                                                "summary"
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "ignoreMissingFields",
                                                                            "value": true
                                                                        }
                                                                    ],
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldsByIdOrAlias",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issueType",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "name"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "JiraAvatar",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "avatar",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "xsmall"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v9 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraIssueTypeField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "text"
                                                                                }
                                                                            ],
                                                                            "type": "JiraSingleLineTextField"
                                                                        },
                                                                        v9 /*: any*/ 
                                                                    ],
                                                                    "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"issuetype\",\"summary\"],ignoreMissingFields:true)"
                                                                }
                                                            ],
                                                            "type": "JiraIssue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v9 /*: any*/ 
                                                            ],
                                                            "type": "Node",
                                                            "abstractKey": "__isNode"
                                                        }
                                                    ]
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "storageKey": "associatedIssues(first:100)"
                                },
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "24c11f2af60eb7a3e378df4c9e585d36a069016d8981c6f13ade2b717e96e9bf",
            "metadata": {},
            "name": "issuesModal_designIssueQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$69efb06d34b4f404$var$node.hash = "7de65187f74a740f22e361ae3bf58899";
var $69efb06d34b4f404$export$2e2bcd8739ae039 = $69efb06d34b4f404$var$node;

});

parcelRegister("lbXuZ", function(module, exports) {

$parcel$export(module.exports, "SimpleIssueCard", () => $ab628153c784343a$export$a6b6cb5c242d7ead);

var $kDDKv = parcelRequire("kDDKv");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $2NMNM = parcelRequire("2NMNM");

var $jhmo0 = parcelRequire("jhmo0");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $8zOmE = parcelRequire("8zOmE");

var $2vbty = parcelRequire("2vbty");

var $iSRVi = parcelRequire("iSRVi");
const $ab628153c784343a$export$a6b6cb5c242d7ead = ({ jiraIssue: jiraIssue, openIssueInSidebar: openIssueInSidebar })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [, sidebarActions] = (0, $2vbty.useSidebarStore)();
    const data = (0, $8Uumt.useFragment)((0, $kDDKv.default), jiraIssue);
    const fieldsData = data.fieldsByIdOrAlias.filter(Boolean);
    const issueTypeFieldData = fieldsData.reduce((acc, fieldData)=>{
        if (fieldData.__typename === 'JiraIssueTypeField') return {
            icon: fieldData.issueType.avatar?.xsmall ?? (0, (/*@__PURE__*/$parcel$interopDefault($iSRVi))),
            name: fieldData.issueType.name
        };
        return acc;
    }, {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iSRVi))),
        name: ''
    });
    const summaryText = fieldsData.reduce((acc, fieldData)=>{
        if (fieldData.__typename === 'JiraSingleLineTextField') return fieldData.text;
        return acc;
    }, null);
    if (issueTypeFieldData == null) throw new Error(`issue data did not contain issuetype data(${issueTypeFieldData})`);
    if (summaryText === null) throw new Error('issue data did not contain summary data');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
        href: data.webUrl,
        target: "_blank",
        xcss: $ab628153c784343a$var$wrapperStyles,
        onClick: (e)=>{
            const modifiersPressed = e.shiftKey || e.metaKey || e.ctrlKey; // Open the issue in the sidebar if (a) the prop says we should and (b) the user
            // didn't *explicitly* try to open in a new tab, e.g. by control-clicking.
            if (openIssueInSidebar && !modifiersPressed) {
                e.preventDefault();
                sidebarActions.showIssue(data.key);
            }
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'designLinkedIssue');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $ab628153c784343a$var$inlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: issueTypeFieldData.icon,
        alt: issueTypeFieldData.name,
        title: issueTypeFieldData.name,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _4t3i7vkz _1bsb7vkz _19pkidpf _2hwxu2gc _otyridpf _18u0idpf _1e0c1txw _1bah1h6o _4cvr1h6o"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        className: (0, $bwpsq.default)([
            "_1o9zidpf _syaz131l _u5f31ejb _9oik18uv _1bnxglyw _jf4cnqa1"
        ])
    }, data.key), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _syaz1fxt _9oik18uv _1bnx8stv _jf4cnqa1"
        ])
    }, summaryText)));
};
const $ab628153c784343a$var$wrapperStyles = (0, $8CUq3.xcss)({
    textDecoration: 'none',
    boxSizing: 'content-box',
    display: 'block',
    height: '20px',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    ':hover': {
        textDecoration: 'none'
    }
});
const $ab628153c784343a$var$inlineStyles = (0, $8CUq3.xcss)({
    alignItems: 'center'
});
const $ab628153c784343a$var$issueTypeStyles = null;
const $ab628153c784343a$var$issueKeyStyles = null;
const $ab628153c784343a$var$issueSummaryStyles = null;

});
parcelRegister("kDDKv", function(module, exports) {

$parcel$export(module.exports, "default", () => $55799206881c992b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<548492858d45f5fbafbb71f1a08a7c7b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $55799206881c992b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "simpleIssueCard_versionIssueAssociatedDesigns",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "webUrl"
            },
            "action": "THROW",
            "path": "webUrl"
        },
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "idsOrAliases",
                        "value": [
                            "issuetype",
                            "summary"
                        ]
                    },
                    {
                        "kind": "Literal",
                        "name": "ignoreMissingFields",
                        "value": true
                    }
                ],
                "kind": "LinkedField",
                "name": "fieldsByIdOrAlias",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "issueType",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "kind": "ScalarField",
                                                "name": "name"
                                            },
                                            "action": "THROW",
                                            "path": "fieldsByIdOrAlias.issueType.name"
                                        },
                                        {
                                            "concreteType": "JiraAvatar",
                                            "kind": "LinkedField",
                                            "name": "avatar",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "xsmall"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "fieldsByIdOrAlias.issueType"
                            }
                        ],
                        "type": "JiraIssueTypeField"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "text"
                                },
                                "action": "THROW",
                                "path": "fieldsByIdOrAlias.text"
                            }
                        ],
                        "type": "JiraSingleLineTextField"
                    }
                ],
                "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"issuetype\",\"summary\"],ignoreMissingFields:true)"
            },
            "action": "THROW",
            "path": "fieldsByIdOrAlias"
        }
    ],
    "type": "JiraIssue"
};
$55799206881c992b$var$node.hash = "293ef6f7a36c1d615e6dc27559c1d40e";
var $55799206881c992b$export$2e2bcd8739ae039 = $55799206881c992b$var$node;

});

parcelRegister("iSRVi", function(module, exports) {
module.exports = new URL("issue-type-avatar-fallback.a9f6df1b.svg", import.meta.url).toString();

});


parcelRegister("719Uq", function(module, exports) {

$parcel$export(module.exports, "IssueModalLoading", () => $204935f075bf299f$export$30d178fad6e7652a);
$parcel$export(module.exports, "IssuesModal", () => $204935f075bf299f$export$62000b4a046396b3);

var $7skxX = parcelRequire("7skxX");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");

var $lfDf7 = parcelRequire("lfDf7");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $gofOI = parcelRequire("gofOI");

var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $4R6GH = parcelRequire("4R6GH");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $7NYq5 = parcelRequire("7NYq5");

var $9N1TE = parcelRequire("9N1TE");

var $7To4V = parcelRequire("7To4V");
const $204935f075bf299f$export$30d178fad6e7652a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        messageId: "version-issue-associated-designs.ui.design-carousel.design-card.issues-modal.modal",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        xcss: $204935f075bf299f$var$modalBodyLoadingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "large"
    }))));
const $204935f075bf299f$export$62000b4a046396b3 = ({ queryRef: queryRef, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const data = (0, $8Uumt.usePreloadedQuery)((0, $7skxX.default), queryRef);
    const designEntity = data.devOps.designEntityDetails[0]; // This shouldn't happen much in real world, but can happen when the target design is deleted while the user is looking at the page.
    (0, $5uXOq.useEffect)(()=>{
        if (designEntity == null) showFlag({
            messageId: 'version-issue-associated-designs.ui.design-carousel.design-card.issues-modal.show-flag.error',
            messageType: 'transactional',
            type: 'error',
            title: formatMessage((0, $7To4V.default).errorFlagTitle),
            description: formatMessage((0, $7To4V.default).errorFlagDescription)
        });
    }, [
        designEntity,
        formatMessage,
        showFlag
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Why? suggested here: https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3021481389/Modal+Dialog+Focus#General-Focus
        setTimeout(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const modalElement = document.querySelector("[role='dialog']");
            modalElement?.focus();
        }, 50);
    }, []);
    if (designEntity == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        width: "small",
        onClose: ()=>onClose(),
        autoFocus: false,
        messageId: "version-issue-associated-designs.ui.design-carousel.design-card.issues-modal.modal.1",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.150",
        xcss: $204935f075bf299f$var$modalTitleStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: designEntity?.provider.logoUrl,
        alt: "",
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1tcg _1ul97vkz _2hwxu2gc"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: designEntity?.url,
        target: "_blank",
        className: (0, $bwpsq.default)([
            "_4bfu18uv _1hmsglyw _ajmmnqa1 _syaz1kw7 _k48p1pd9 _9oik18uv _1bnx8stv _jf4cnqa1 _30l31kw7"
        ])
    }, designEntity?.displayName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", {
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c81o8v _k48pi7a9 _syaz131l"
        ])
    }, formatMessage((0, $7To4V.default).linkedTo)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        space: "space.050",
        xcss: $204935f075bf299f$var$multipleIssuesStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lfDf7))), {
        color: "var(--ds-icon-accent-blue, #1D7AFC)",
        LEGACY_size: "small",
        label: ""
    }), formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $7To4V.default).manyIssuesIssueTerminologyRefreshM4 : (0, $7To4V.default).manyIssues))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9N1TE.IssuesModalBody), {
        devOpsDesign: designEntity
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "primary",
        onClick: ()=>onClose()
    }, formatMessage((0, $7To4V.default).modalCloseButtonLabel))));
};
const $204935f075bf299f$var$modalIconStyles = null;
const $204935f075bf299f$var$titleStyles = null;
const $204935f075bf299f$var$modalTitleStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.300',
    paddingBottom: 'space.200',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $204935f075bf299f$var$modalBodyLoadingStyles = (0, $8CUq3.xcss)({
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '300px',
    height: '300px'
});
const $204935f075bf299f$var$linkedToStyles = null;
const $204935f075bf299f$var$multipleIssuesStyles = (0, $8CUq3.xcss)({
    font: 'font.body'
});

});
parcelRegister("9N1TE", function(module, exports) {

$parcel$export(module.exports, "IssuesModalBody", () => $8f007d88efbec807$export$fed5c8d395452c20);

var $7kUt7 = parcelRequire("7kUt7");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $l1N8i = parcelRequire("l1N8i");

var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $lbXuZ = parcelRequire("lbXuZ");

var $lIuNX = parcelRequire("lIuNX");

var $2vFc4 = parcelRequire("2vFc4");
const $8f007d88efbec807$export$fed5c8d395452c20 = ({ devOpsDesign: devOpsDesign })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const designEntity = (0, $8Uumt.useFragment)((0, $7kUt7.default), devOpsDesign);
    const associatedIssuesNodes = (designEntity?.associatedIssues?.edges ?? []).filter(Boolean).map((edge)=>edge.node).filter(Boolean);
    const issuesAssociatedToThisVersion = associatedIssuesNodes.filter((node)=>node.hasRelationshipToVersion);
    const issuesNotAssociatedToThisVersion = associatedIssuesNodes.filter((node)=>!node.hasRelationshipToVersion);
    (0, $2vFc4.useFireManyIssueTrackingAnalaytics)(associatedIssuesNodes.length);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "versionDesignAssociatedIssues",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        attributes: {
            issuesAssociatedTotalCount: associatedIssuesNodes.length,
            issuesAssociatedToVersionCount: issuesAssociatedToThisVersion.length,
            issuesNotAssociatedToVersionCount: issuesAssociatedToThisVersion.length
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.300",
        xcss: $8f007d88efbec807$var$modalBodyStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), null, issuesAssociatedToThisVersion.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $8f007d88efbec807$var$subTitleStyles
    }, formatMessage((0, $lIuNX.default).issuesInVersion), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $8f007d88efbec807$var$issueCountStyles
    }, "\xa0 (", issuesAssociatedToThisVersion.length, ")"))), issuesAssociatedToThisVersion.map((issueNode)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lbXuZ.SimpleIssueCard), {
            key: issueNode.key,
            jiraIssue: issueNode
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), null, issuesNotAssociatedToThisVersion.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $8f007d88efbec807$var$subTitleStyles
    }, formatMessage((0, $lIuNX.default).otherIssues), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $8f007d88efbec807$var$issueCountStyles
    }, "\xa0 (", issuesNotAssociatedToThisVersion.length, ")"))), issuesNotAssociatedToThisVersion.map((issueNode)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lbXuZ.SimpleIssueCard), {
            key: issueNode.key,
            jiraIssue: issueNode
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));
};
const $8f007d88efbec807$var$modalBodyStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.025',
    paddingBottom: 'space.025'
});
const $8f007d88efbec807$var$subTitleStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.100'
});
const $8f007d88efbec807$var$issueCountStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    fontWeight: "var(--ds-font-weight-regular, 400)"
});

});
parcelRegister("7kUt7", function(module, exports) {

$parcel$export(module.exports, "default", () => $66604be4facd5050$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3e261db26d1d024b6da239237bbfbcea>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $66604be4facd5050$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "versionId"
        }
    ],
    "kind": "Fragment",
    "name": "body_versionIssueAssociatedDesigns_IssuesModalBody",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 100
                }
            ],
            "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseConnection",
            "kind": "LinkedField",
            "name": "associatedIssues",
            "plural": false,
            "selections": [
                {
                    "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "kind": "ScalarField",
                                                "name": "key"
                                            },
                                            "action": "THROW",
                                            "path": "associatedIssues.edges.node.key"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "versionId",
                                                    "variableName": "versionId"
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "hasRelationshipToVersion"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "simpleIssueCard_versionIssueAssociatedDesigns"
                                        }
                                    ],
                                    "type": "JiraIssue"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "associatedIssues(first:100)"
        }
    ],
    "type": "DevOpsDesign"
};
$66604be4facd5050$var$node.hash = "145e33a9a0a82742e3ace6aa6c154644";
var $66604be4facd5050$export$2e2bcd8739ae039 = $66604be4facd5050$var$node;

});

parcelRegister("lIuNX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea07c90e3dc719bc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ea07c90e3dc719bc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issuesInVersion: {
        "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.body.issues-in-version",
        "defaultMessage": "Current version"
    },
    otherIssues: {
        "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.body.other-issues",
        "defaultMessage": "Other"
    }
});

});

parcelRegister("2vFc4", function(module, exports) {

$parcel$export(module.exports, "useFireManyIssueTrackingAnalaytics", () => $e783f200345a5a2b$export$3ca4c107f1eff13e);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $e783f200345a5a2b$export$3ca4c107f1eff13e = (numIssues)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (numIssues > 100) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'designAssociatedIssues exceeded', {
            numIssues: numIssues
        });
    }, [
        createAnalyticsEvent,
        numIssues
    ]);
};

});


parcelRegister("7To4V", function(module, exports) {

$parcel$export(module.exports, "default", () => $e38aac1cfa69ceb1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e38aac1cfa69ceb1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    modalCloseButtonLabel: {
        "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.modal-close-button-label",
        "defaultMessage": "Close"
    },
    errorFlagTitle: {
        "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.error-flag-title",
        "defaultMessage": "Something went wrong"
    },
    errorFlagDescription: {
        "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.error-flag-description",
        "defaultMessage": "Please refresh the page."
    },
    linkedTo: {
        "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.linked-to",
        "defaultMessage": "Linked to"
    },
    manyIssues: {
        "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.many-issues",
        "defaultMessage": "Multiple issues"
    },
    manyIssuesIssueTerminologyRefreshM4: {
        "id": "version-issue-associated-designs.design-carousel.design-card.issues-modal.many-issues-issue-terminology-refresh-m4",
        "defaultMessage": "Multiple work items"
    }
});

});


parcelRegister("i0rPK", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fe13f760fed4b30$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6fe13f760fed4b30$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    openPreview: {
        "id": "version-issue-associated-designs.design-carousel.design-card.open-preview",
        "defaultMessage": "Open preview"
    },
    seeAll: {
        "id": "version-issue-associated-designs.design-carousel.design-card.see-all",
        "defaultMessage": "See all"
    },
    linkedTo: {
        "id": "version-issue-associated-designs.design-carousel.design-card.linked-to",
        "defaultMessage": "Linked to"
    },
    issueIconLabel: {
        "id": "version-issue-associated-designs.design-carousel.design-card.issue-icon-label",
        "defaultMessage": "Issue icon"
    },
    manyIssues: {
        "id": "version-issue-associated-designs.design-carousel.design-card.many-issues",
        "defaultMessage": "Multiple issues"
    },
    issueIconLabelIssueTerminologyRefreshM4: {
        "id": "version-issue-associated-designs.design-carousel.design-card.issue-icon-label-issue-terminology-refresh-m4",
        "defaultMessage": "Work item icon"
    },
    manyIssuesIssueTerminologyRefreshM4: {
        "id": "version-issue-associated-designs.design-carousel.design-card.many-issues-issue-terminology-refresh-m4",
        "defaultMessage": "Multiple work items"
    }
});

});

parcelRegister("7Tq5y", function(module, exports) {

$parcel$export(module.exports, "formatRelativeDate", () => $05a1b9d1f2284a69$export$10da3a44394af1a6);

var $7WuKQ = parcelRequire("7WuKQ");
var $k7m40 = parcelRequire("k7m40");
var $54a0z = parcelRequire("54a0z");
const $05a1b9d1f2284a69$var$SECONDS_IN_A_DAY = 86400;
const $05a1b9d1f2284a69$export$10da3a44394af1a6 = (lastUpdatedDate)=>{
    const currentDate = new Date();
    const isDateFormatRelative = (0, $7WuKQ.default)(currentDate, lastUpdatedDate) <= $05a1b9d1f2284a69$var$SECONDS_IN_A_DAY;
    return isDateFormatRelative ? (0, $54a0z.default)(lastUpdatedDate, currentDate, {
        addSuffix: true,
        roundingMethod: 'floor'
    }) : (0, $k7m40.default)(lastUpdatedDate, 'd MMM, HH:mm');
};

});


parcelRegister("7SORO", function(module, exports) {

$parcel$export(module.exports, "default", () => $815a0476c6388d25$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $815a0476c6388d25$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    carouselPageCount: {
        "id": "version-issue-associated-designs.design-carousel.carousel-page-count",
        "defaultMessage": "{currentStart}-{currentEnd} of {totalCount}"
    }
});

});


parcelRegister("9EnlV", function(module, exports) {

$parcel$export(module.exports, "EmptyState", () => $a791982c36287fab$export$fddf379e22a74b00);
/* EmptyState.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $e4yMr = parcelRequire("e4yMr");

var $l1N8i = parcelRequire("l1N8i");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $e2Zn1 = parcelRequire("e2Zn1");

var $cVmNE = parcelRequire("cVmNE");
const $a791982c36287fab$export$fddf379e22a74b00 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const learnMoreLabelMessage = (0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $cVmNE.default).learnMoreLabelIssueTerminologyRefreshM4 : (0, $cVmNE.default).learnMoreLabel;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a791982c36287fab$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e2Zn1))),
        width: 80,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("section", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h3",
        size: "xsmall"
    }, formatMessage((0, $cVmNE.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a791982c36287fab$var$Description, null, formatMessage((0, $cVmNE.default).desciption)), (0, $4R6GH.fg)('replace-anchor-with-link__fusion-solaris') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        href: "https://support.atlassian.com/jira-cloud-administration/docs/integrate-figma-with-jira/",
        target: "_blank"
    }, formatMessage(learnMoreLabelMessage)) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: "https://support.atlassian.com/jira-cloud-administration/docs/integrate-figma-with-jira/",
        target: "_blank"
    }, formatMessage(learnMoreLabelMessage))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a791982c36287fab$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoftgi _189eyh40 _1dqogq9o _1h6dmuej _1e0c1txw _4cvr1h6o _gy1p1ejb _19pkpxbi _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a791982c36287fab$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz131l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("e2Zn1", function(module, exports) {
module.exports = new URL("empty-icon.ef7b6c4a.svg", import.meta.url).toString();

});

parcelRegister("cVmNE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d47ddf15452c976a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d47ddf15452c976a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "version-issue-associated-designs.empty-state.title",
        "defaultMessage": "You\u2019ll see your linked designs here"
    },
    desciption: {
        "id": "version-issue-associated-designs.empty-state.desciption",
        "defaultMessage": "Get live updates and greater visibility of your team\u2019s design work."
    },
    learnMoreLabel: {
        "id": "version-issue-associated-designs.empty-state.learn-more-label",
        "defaultMessage": "Read more about linking designs to Jira issues"
    },
    learnMoreLabelIssueTerminologyRefreshM4: {
        "id": "version-issue-associated-designs.empty-state.learn-more-label-issue-terminology-refresh-m4",
        "defaultMessage": "Read more about linking designs to Jira work items"
    }
});

});


parcelRegister("bgc85", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b677a3e5ccfe5d2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8b677a3e5ccfe5d2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    designSectionLabel: {
        "id": "version-issue-associated-designs.design-section-label",
        "defaultMessage": "Designs"
    }
});

});


parcelRegister("gpsfL", function(module, exports) {

$parcel$export(module.exports, "VersionProgress", () => $a2a9bbd9547db40a$export$f9ad2300f8258368);

var $jQW4E = parcelRequire("jQW4E");

var $btxzI = parcelRequire("btxzI");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $kfztd = parcelRequire("kfztd");

var $fi7WV = parcelRequire("fi7WV");

var $76xXI = parcelRequire("76xXI");

var $gA9bT = parcelRequire("gA9bT");

var $aPvTj = parcelRequire("aPvTj");

var $fyA65 = parcelRequire("fyA65");

var $jbc56 = parcelRequire("jbc56");

var $jMgdz = parcelRequire("jMgdz");
const $a2a9bbd9547db40a$export$f9ad2300f8258368 = ({ queryRef: queryRef })=>{
    const { jira: jira } = (0, $8Uumt.usePreloadedQuery)((0, $btxzI.default), queryRef);
    const versionFrag = jira.version;
    const version = (0, $8Uumt.useFragment)((0, $jQW4E.default), versionFrag);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const edges = version.relatedWorkV2 ? version.relatedWorkV2.edges.filter(Boolean) : [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a2a9bbd9547db40a$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a2a9bbd9547db40a$var$mainHeadingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall",
        as: "h2"
    }, formatMessage((0, $fyA65.messages).progressHeading))), !(0, $kfztd.isDevopsFeatureDisabledInFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jbc56.RelatedWorkHeading), {
        relatedWorkEdges: edges
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jMgdz.RelatedWorkProgressBar), {
        relatedWorkEdges: edges
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fi7WV.CollapsibleSection), {
        jiraVersion: version,
        uiType: "PROGRESS_CARD",
        renderHeader: (isCollapsed, onToggleClicked)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aPvTj.IssuesHeading), {
                jiraVersion: version,
                isCollapsed: isCollapsed,
                onToggleClicked: onToggleClicked
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $76xXI.IssuesProgressBar), {
                jiraVersion: version
            })),
        renderBody: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gA9bT.IssueProgressDetails), {
                jiraVersion: version
            })
    })));
};
const $a2a9bbd9547db40a$var$containerStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.200',
    paddingRight: 'space.300',
    paddingBottom: 'space.300',
    paddingLeft: 'space.300',
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.200'
});
const $a2a9bbd9547db40a$var$mainHeadingStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.100',
    paddingRight: 'space.0',
    paddingBottom: 'space.100',
    paddingLeft: 'space.0'
});

});
parcelRegister("jQW4E", function(module, exports) {

$parcel$export(module.exports, "default", () => $49be98a29c3f6e08$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a07bf9ea4bd202e1b85a34f170936052>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $49be98a29c3f6e08$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isDevopsFeatureDisabledInFedRamp"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "connection": [
            {
                "count": null,
                "cursor": null,
                "direction": "forward",
                "path": [
                    "relatedWorkV2"
                ]
            }
        ]
    },
    "name": "ui_versionProgress_VersionProgress",
    "selections": [
        {
            "condition": "isDevopsFeatureDisabledInFedRamp",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "relatedWorkV2",
                        "concreteType": "JiraVersionRelatedWorkV2Connection",
                        "kind": "LinkedField",
                        "name": "__version_relatedWorkV2_connection",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "JiraVersionRelatedWorkV2Edge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "relatedWorkHeading_versionProgress"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "relatedWorkProgressBar_versionProgress"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "relatedWorkV2.edges"
                            },
                            {
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "endCursor"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasNextPage"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "relatedWorkV2"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "issuesHeading_versionProgress"
        },
        {
            "kind": "FragmentSpread",
            "name": "issueProgressBar_versionProgress_IssuesProgressBar"
        },
        {
            "kind": "FragmentSpread",
            "name": "issueProgressDetails_versionProgress"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection"
        }
    ],
    "type": "JiraVersion"
};
$49be98a29c3f6e08$var$node.hash = "adad2bb30e02991a2dcfd9cb2046e4c9";
var $49be98a29c3f6e08$export$2e2bcd8739ae039 = $49be98a29c3f6e08$var$node;

});

parcelRegister("76xXI", function(module, exports) {

$parcel$export(module.exports, "IssuesProgressBar", () => $ddf4da5e852005e8$export$80217ccba75d7c95);

var $5UYpC = parcelRequire("5UYpC");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $gULOk = parcelRequire("gULOk");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $1YU2V = parcelRequire("1YU2V");


var $gZxFj = parcelRequire("gZxFj");

var $6MI5C = parcelRequire("6MI5C");
const $ddf4da5e852005e8$export$80217ccba75d7c95 = ({ jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { showStatusCategoryIssues: showStatusCategoryIssues } = (0, $1YU2V.useFilterSortingQueryParams)();
    const version = (0, $8Uumt.useFragment)((0, $5UYpC.default), jiraVersion);
    const inProgressIssueCount = version.inProgressIssuesRedesignTemp.totalCount;
    const doneIssueCount = version.doneIssuesRedesignTemp.totalCount;
    const todoIssueCount = version.todoIssuesRedesignTemp.totalCount;
    const totalIssueCount = inProgressIssueCount + doneIssueCount + todoIssueCount;
    const createStatusClickHandler = (category)=>()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            }), 'progressBarShortcutFilter', {
                filter: category
            });
            const categoryId = String((0, $gULOk.categoryIdForStatusCategory)(category));
            showStatusCategoryIssues([
                categoryId
            ]);
        };
    if (totalIssueCount === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZxFj.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZxFj.ProgressBarContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZxFj.ProgressBarElementContainer), {
        totalCount: 1,
        portionCount: 1,
        isClickable: true,
        isLast: true,
        "aria-label": formatMessage((0, $6MI5C.default).noIssuesText)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZxFj.Bar), {
        color: (0, $874a267084b6120b$export$9a2ce699a8e88c00),
        isFirst: true,
        isLast: true
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZxFj.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZxFj.ProgressBarContainer), null, doneIssueCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZxFj.ProgressBarElementContainer), {
        onClick: createStatusClickHandler((0, $gULOk.DONE)),
        totalCount: totalIssueCount,
        portionCount: doneIssueCount,
        isClickable: true,
        isLast: totalIssueCount === doneIssueCount,
        "aria-label": formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $6MI5C.default).doneIssuesTooltipTextIssueTerminologyRefreshM4 : (0, $6MI5C.default).doneIssuesTooltipText, {
            completedIssueCount: doneIssueCount,
            totalIssueCount: totalIssueCount
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        position: "top",
        content: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $6MI5C.default).doneIssuesTooltipTextIssueTerminologyRefreshM4 : (0, $6MI5C.default).doneIssuesTooltipText, {
            completedIssueCount: doneIssueCount,
            totalIssueCount: totalIssueCount
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZxFj.Bar), {
        color: (0, $874a267084b6120b$export$f2a648c26a91297f),
        isFirst: true,
        isLast: totalIssueCount === doneIssueCount
    }))), inProgressIssueCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZxFj.ProgressBarElementContainer), {
        totalCount: totalIssueCount,
        portionCount: inProgressIssueCount,
        onClick: createStatusClickHandler((0, $gULOk.IN_PROGRESS)),
        isClickable: true,
        isLast: todoIssueCount === 0,
        "aria-label": formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $6MI5C.default).inProgressIssuesTooltipTextIssueTerminologyRefreshM4 : (0, $6MI5C.default).inProgressIssuesTooltipText, {
            inProgressIssueCount: inProgressIssueCount,
            totalIssueCount: totalIssueCount
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        position: "top",
        content: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $6MI5C.default).inProgressIssuesTooltipTextIssueTerminologyRefreshM4 : (0, $6MI5C.default).inProgressIssuesTooltipText, {
            inProgressIssueCount: inProgressIssueCount,
            totalIssueCount: totalIssueCount
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZxFj.Bar), {
        color: (0, $874a267084b6120b$export$dc4e31a90347554e),
        isFirst: doneIssueCount === 0,
        isLast: todoIssueCount === 0
    }))), todoIssueCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZxFj.ProgressBarElementContainer), {
        isLast: true,
        totalCount: totalIssueCount,
        portionCount: todoIssueCount,
        onClick: createStatusClickHandler((0, $gULOk.TODO)),
        isClickable: true,
        "aria-label": formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $6MI5C.default).todoIssuesTooltipTextIssueTerminologyRefreshM4 : (0, $6MI5C.default).todoIssuesTooltipText, {
            todoIssueCount: todoIssueCount,
            totalIssueCount: totalIssueCount
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        position: "top",
        content: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $6MI5C.default).todoIssuesTooltipTextIssueTerminologyRefreshM4 : (0, $6MI5C.default).todoIssuesTooltipText, {
            todoIssueCount: todoIssueCount,
            totalIssueCount: totalIssueCount
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZxFj.Bar), {
        color: (0, $874a267084b6120b$export$9a2ce699a8e88c00),
        isFirst: totalIssueCount === todoIssueCount,
        isLast: true
    })))));
};

});
parcelRegister("5UYpC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f687da9bbc10a3dc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<022ae572fe079cb167c3d37f775431c9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f687da9bbc10a3dc$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "totalCount"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "issueProgressBar_versionProgress_IssuesProgressBar",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "doneIssuesRedesignTemp",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": [
                                    "DONE"
                                ]
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "doneIssuesRedesignTemp.totalCount"
                        }
                    ],
                    "storageKey": "issues(filters:{\"statusCategories\":[\"DONE\"]})"
                },
                "action": "THROW",
                "path": "doneIssuesRedesignTemp"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "inProgressIssuesRedesignTemp",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": [
                                    "IN_PROGRESS"
                                ]
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "inProgressIssuesRedesignTemp.totalCount"
                        }
                    ],
                    "storageKey": "issues(filters:{\"statusCategories\":[\"IN_PROGRESS\"]})"
                },
                "action": "THROW",
                "path": "inProgressIssuesRedesignTemp"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "todoIssuesRedesignTemp",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": [
                                    "TODO"
                                ]
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "todoIssuesRedesignTemp.totalCount"
                        }
                    ],
                    "storageKey": "issues(filters:{\"statusCategories\":[\"TODO\"]})"
                },
                "action": "THROW",
                "path": "todoIssuesRedesignTemp"
            }
        ],
        "type": "JiraVersion"
    };
}();
$f687da9bbc10a3dc$var$node.hash = "9d79a458e2fb5db8bb37fec8334b2eed";
var $f687da9bbc10a3dc$export$2e2bcd8739ae039 = $f687da9bbc10a3dc$var$node;

});

const $874a267084b6120b$export$9a2ce699a8e88c00 = "var(--ds-border, #091E4224)";
const $874a267084b6120b$export$dc4e31a90347554e = "var(--ds-border-information, #1D7AFC)";
const $874a267084b6120b$export$f2a648c26a91297f = "var(--ds-border-success, #22A06B)";
const $874a267084b6120b$export$2d5e5bd76a1e6a66 = "var(--ds-background-warning-bold-hovered, #E2B203)";

parcelRegister("gZxFj", function(module, exports) {

$parcel$export(module.exports, "Section", () => $1e08fe14c28adb64$export$6e2c8f0811a474ce);
$parcel$export(module.exports, "Summary", () => $1e08fe14c28adb64$export$46453a0401d6cd1a);
$parcel$export(module.exports, "Container", () => $1e08fe14c28adb64$export$42a852a2b6b56249);
$parcel$export(module.exports, "ProgressBarContainer", () => $1e08fe14c28adb64$export$91fd6e064cf0bcf3);
$parcel$export(module.exports, "ProgressBarElementContainer", () => $1e08fe14c28adb64$export$9148ffcd7ea9778);
$parcel$export(module.exports, "Bar", () => $1e08fe14c28adb64$export$bbc6c6369b38e3d1);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $1e08fe14c28adb64$export$6e2c8f0811a474ce = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCollapsible: isCollapsible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.isCollapsible ? "_80omtlke" : "_80om73ad",
            __cmplp.className
        ])
    });
});
const $1e08fe14c28adb64$export$46453a0401d6cd1a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _syaz131l",
            __cmplp.className
        ])
    });
});
const $1e08fe14c28adb64$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _1e0c1txw _ca0qu2gc _u5f3idpf _n3tdu2gc _19bvidpf",
            __cmplp.className
        ])
    });
});
const $1e08fe14c28adb64$export$91fd6e064cf0bcf3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul91tcg _2hwxv77o _1e0c1txw _4cvr1fhb",
            __cmplp.className
        ])
    });
});
const $1e08fe14c28adb64$export$9148ffcd7ea9778 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLast: isLast, totalCount: totalCount, portionCount: portionCount, isClickable: isClickable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1wknkfl": (0, $lD23V.default)(__cmplp.portionCount / __cmplp.totalCount * 100)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11c81kw7 _12ji1r31 _1qu21kw7 _12y31o36 _1ul91ejb _1e0c1txw _2lx21bp4 _4cvr1fhb _7cca15wb _syaz1kw7 _x2qs15x0 _qe84exuw",
            __cmplp.isLast ? "_2hwxze3t" : "_2hwxv77o",
            __cmplp.totalCount === 0 ? "_16jlkb7n" : "_16jl1hqj",
            __cmplp.isClickable ? "_80omtlke" : "_80om73ad",
            __cmplp.className
        ])
    });
});
const $1e08fe14c28adb64$export$bbc6c6369b38e3d1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirst: isFirst, isLast: isLast, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $lD23V.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3iftgi _bfhk1cj8",
            __cmplp.isFirst && __cmplp.isLast ? "_2rkoftgi" : __cmplp.isFirst ? "_2rko1mnk" : __cmplp.isLast ? "_2rkoy749" : "_2rkoidpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6MI5C", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a38c2aee7f8205c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3a38c2aee7f8205c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    inProgressIssuesTooltipText: {
        "id": "version-progress.issue-progress-bar.in-progress-issues-tooltip-text",
        "defaultMessage": "In Progress: {inProgressIssueCount} of {totalIssueCount} {totalIssueCount, plural, one {issue} other {issues}}"
    },
    doneIssuesTooltipText: {
        "id": "version-progress.issue-progress-bar.done-issues-tooltip-text",
        "defaultMessage": "Done: {completedIssueCount} of {totalIssueCount} {totalIssueCount, plural, one {issue} other {issues}}"
    },
    todoIssuesTooltipText: {
        "id": "version-progress.issue-progress-bar.todo-issues-tooltip-text",
        "defaultMessage": "To Do: {todoIssueCount} of {totalIssueCount} {totalIssueCount, plural, one {issue} other {issues}}"
    },
    inProgressIssuesTooltipTextIssueTerminologyRefreshM4: {
        "id": "version-progress.issue-progress-bar.in-progress-issues-tooltip-text-issue-terminology-refresh-m4",
        "defaultMessage": "In Progress: {inProgressIssueCount} of {totalIssueCount} {totalIssueCount, plural, one {work item} other {work items}}"
    },
    doneIssuesTooltipTextIssueTerminologyRefreshM4: {
        "id": "version-progress.issue-progress-bar.done-issues-tooltip-text-issue-terminology-refresh-m4",
        "defaultMessage": "Done: {completedIssueCount} of {totalIssueCount} {totalIssueCount, plural, one {work item} other {work items}}"
    },
    todoIssuesTooltipTextIssueTerminologyRefreshM4: {
        "id": "version-progress.issue-progress-bar.todo-issues-tooltip-text-issue-terminology-refresh-m4",
        "defaultMessage": "To Do: {todoIssueCount} of {totalIssueCount} {totalIssueCount, plural, one {work item} other {work items}}"
    },
    noIssuesText: {
        "id": "version-progress.issue-progress-bar.no-issues-text",
        "defaultMessage": "No issues"
    }
});

});


parcelRegister("gA9bT", function(module, exports) {

$parcel$export(module.exports, "IssueProgressDetails", () => $309ff130df5bcc16$export$d0720399ba8e473e);

var $h1FvK = parcelRequire("h1FvK");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $gULOk = parcelRequire("gULOk");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $1YU2V = parcelRequire("1YU2V");


var $6vBfz = parcelRequire("6vBfz");
const $309ff130df5bcc16$export$d0720399ba8e473e = ({ jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { showStatusCategoryIssues: showStatusCategoryIssues, showIssuesWithWarnings: showIssuesWithWarnings } = (0, $1YU2V.useFilterSortingQueryParams)();
    const version = (0, $8Uumt.useFragment)((0, $h1FvK.default), jiraVersion);
    const { doneIssuesRedesignTemp: doneIssues, inProgressIssuesRedesignTemp: inProgressIssues, todoIssuesRedesignTemp: todoIssues } = version;
    const { warningConfig: warningConfig } = version;
    const enabledWarningCategories = [];
    if (warningConfig?.failingBuild === 'ENABLED') enabledWarningCategories.push('FAILING_BUILD');
    if (warningConfig?.openPullRequest === 'ENABLED') enabledWarningCategories.push('OPEN_PULL_REQUEST');
    if (warningConfig?.openReview === 'ENABLED') enabledWarningCategories.push('OPEN_REVIEW');
    if (warningConfig?.unreviewedCode === 'ENABLED') enabledWarningCategories.push('UNREVIEWED_CODE');
    const messageFormatter = {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($309ff130df5bcc16$var$StatusCategoryName, null, chunks),
        s: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($309ff130df5bcc16$var$IssueCount, null, chunks)
    };
    const createStatusClickHandler = (category)=>()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            }), 'progressDetailsShortcutFilter', {
                filter: category
            });
            const categoryId = String((0, $gULOk.categoryIdForStatusCategory)(category));
            showStatusCategoryIssues([
                categoryId
            ]);
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($309ff130df5bcc16$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($309ff130df5bcc16$var$Row, {
        onClick: createStatusClickHandler((0, $gULOk.DONE))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($309ff130df5bcc16$var$StatusCategoryColorIndicator, {
        color: (0, $874a267084b6120b$export$f2a648c26a91297f)
    }), formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $6vBfz.messages).doneIssuesIssueTerminologyRefreshM4 : (0, $6vBfz.messages).doneIssues, {
        ...messageFormatter,
        count: doneIssues.totalCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($309ff130df5bcc16$var$Row, {
        onClick: createStatusClickHandler((0, $gULOk.IN_PROGRESS))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($309ff130df5bcc16$var$StatusCategoryColorIndicator, {
        color: (0, $874a267084b6120b$export$dc4e31a90347554e)
    }), formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $6vBfz.messages).inProgressIssuesIssueTerminologyRefreshM4 : (0, $6vBfz.messages).inProgressIssues, {
        ...messageFormatter,
        count: inProgressIssues.totalCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($309ff130df5bcc16$var$Row, {
        onClick: createStatusClickHandler((0, $gULOk.TODO))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($309ff130df5bcc16$var$StatusCategoryColorIndicator, {
        color: (0, $874a267084b6120b$export$9a2ce699a8e88c00)
    }), formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $6vBfz.messages).toDoIssuesIssueTerminologyRefreshM4 : (0, $6vBfz.messages).toDoIssues, {
        ...messageFormatter,
        count: todoIssues.totalCount
    })), enabledWarningCategories.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($309ff130df5bcc16$var$Row // Warning: this test ID is used by a Pollintor check
    , {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "software-releases-version-detail-issue-list.ui.warning-filter-button",
        onClick: ()=>{
            showIssuesWithWarnings(enabledWarningCategories);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            }), 'progressBarShortcutFilter', {
                filter: 'warnings'
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($309ff130df5bcc16$var$StatusCategoryColorIndicator, {
        color: (0, $874a267084b6120b$export$2d5e5bd76a1e6a66)
    }), formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $6vBfz.messages).warningIssuesIssueTerminologyRefreshM4 : (0, $6vBfz.messages).warningIssues, {
        ...messageFormatter,
        count: version.warningsCount
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $309ff130df5bcc16$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _19pku2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $309ff130df5bcc16$var$StatusCategoryColorIndicator = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $lD23V.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko19bv _1bsb19bv _4t3i19bv _bfhk1cj8 _2hwxv47k _18u0u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $309ff130df5bcc16$var$Row = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1e0c1txw _4cvr1h6o _80omtlke _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _irr3166n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $309ff130df5bcc16$var$StatusCategoryName = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48p1pd9 _o572qvpr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $309ff130df5bcc16$var$IssueCount = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz131l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("h1FvK", function(module, exports) {

$parcel$export(module.exports, "default", () => $d161c81870e6ba52$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4824f62437604ac53e42b2828a4d1182>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d161c81870e6ba52$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "totalCount"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "issueProgressDetails_versionProgress",
        "selections": [
            {
                "concreteType": "JiraVersionWarningConfig",
                "kind": "LinkedField",
                "name": "warningConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "failingBuild"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "openPullRequest"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "openReview"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "unreviewedCode"
                    }
                ]
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "doneIssuesRedesignTemp",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": [
                                    "DONE"
                                ]
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "doneIssuesRedesignTemp.totalCount"
                        }
                    ],
                    "storageKey": "issues(filters:{\"statusCategories\":[\"DONE\"]})"
                },
                "action": "THROW",
                "path": "doneIssuesRedesignTemp"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "inProgressIssuesRedesignTemp",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": [
                                    "IN_PROGRESS"
                                ]
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "inProgressIssuesRedesignTemp.totalCount"
                        }
                    ],
                    "storageKey": "issues(filters:{\"statusCategories\":[\"IN_PROGRESS\"]})"
                },
                "action": "THROW",
                "path": "inProgressIssuesRedesignTemp"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "todoIssuesRedesignTemp",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": [
                                    "TODO"
                                ]
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "todoIssuesRedesignTemp.totalCount"
                        }
                    ],
                    "storageKey": "issues(filters:{\"statusCategories\":[\"TODO\"]})"
                },
                "action": "THROW",
                "path": "todoIssuesRedesignTemp"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "warningsCount"
                },
                "action": "THROW",
                "path": "warningsCount"
            }
        ],
        "type": "JiraVersion"
    };
}();
$d161c81870e6ba52$var$node.hash = "d8f802ed4e1d73fb8f14bafb9265439b";
var $d161c81870e6ba52$export$2e2bcd8739ae039 = $d161c81870e6ba52$var$node;

});

parcelRegister("6vBfz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $059c7c1fd302951a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $059c7c1fd302951a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    doneIssues: {
        "id": "version-progress.issue-progress-details.done-issues",
        "defaultMessage": "<b>Done: </b><s>{count} {count, plural, one {issue} other {issues}}</s>"
    },
    inProgressIssues: {
        "id": "version-progress.issue-progress-details.in-progress-issues",
        "defaultMessage": "<b>In progress: </b><s>{count} {count, plural, one {issue} other {issues}}</s>"
    },
    toDoIssues: {
        "id": "version-progress.issue-progress-details.to-do-issues",
        "defaultMessage": "<b>To do: </b><s>{count} {count, plural, one {issue} other {issues}}</s>"
    },
    warningIssues: {
        "id": "version-progress.issue-progress-details.warning-issues",
        "defaultMessage": "<b>Warning: </b><s>{count} {count, plural, one {issue} other {issues}}</s>"
    },
    doneIssuesIssueTerminologyRefreshM4: {
        "id": "version-progress.issue-progress-details.done-issues-issue-terminology-refresh-m4",
        "defaultMessage": "<b>Done: </b><s>{count} {count, plural, one {work item} other {work items}}</s>"
    },
    inProgressIssuesIssueTerminologyRefreshM4: {
        "id": "version-progress.issue-progress-details.in-progress-issues-issue-terminology-refresh-m4",
        "defaultMessage": "<b>In progress: </b><s>{count} {count, plural, one {work item} other {work items}}</s>"
    },
    toDoIssuesIssueTerminologyRefreshM4: {
        "id": "version-progress.issue-progress-details.to-do-issues-issue-terminology-refresh-m4",
        "defaultMessage": "<b>To do: </b><s>{count} {count, plural, one {work item} other {work items}}</s>"
    },
    warningIssuesIssueTerminologyRefreshM4: {
        "id": "version-progress.issue-progress-details.warning-issues-issue-terminology-refresh-m4",
        "defaultMessage": "<b>Warning: </b><s>{count} {count, plural, one {work item} other {work items}}</s>"
    }
});

});


parcelRegister("aPvTj", function(module, exports) {

$parcel$export(module.exports, "IssuesHeading", () => $65de343a8a110ebb$export$d7aca75aff5e9fe3);

var $8PKAx = parcelRequire("8PKAx");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $l1N8i = parcelRequire("l1N8i");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $fi7WV = parcelRequire("fi7WV");

var $gZxFj = parcelRequire("gZxFj");

var $fBtGA = parcelRequire("fBtGA");
const $65de343a8a110ebb$export$d7aca75aff5e9fe3 = ({ jiraVersion: jiraVersion, isCollapsed: isCollapsed, onToggleClicked: onToggleClicked })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const version = (0, $8Uumt.useFragment)((0, $8PKAx.default), jiraVersion);
    const inProgressIssueCount = version.inProgressIssuesRedesignTemp.totalCount;
    const doneIssueCount = version.doneIssuesRedesignTemp.totalCount;
    const todoIssueCount = version.todoIssuesRedesignTemp.totalCount;
    const totalIssueCount = inProgressIssueCount + doneIssueCount + todoIssueCount;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZxFj.Section), {
        onClick: onToggleClicked,
        isCollapsible: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall",
        as: "h3"
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $fBtGA.default).issuesHeadingIssueTerminologyRefreshM4 : (0, $fBtGA.default).issuesHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZxFj.Summary), null, totalIssueCount === 0 ? formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $fBtGA.default).noIssuesIssueTerminologyRefreshM4 : (0, $fBtGA.default).noIssues) : formatMessage((0, $fBtGA.default).doneIssues, {
        doneCount: doneIssueCount,
        totalCount: totalIssueCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fi7WV.CollapsibleToggleButton), {
        isCollapsed: isCollapsed
    })));
};

});
parcelRegister("8PKAx", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f0466cb638e4bbc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<94a2e4b89a893c947458d602dad1156f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1f0466cb638e4bbc$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "totalCount"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "issuesHeading_versionProgress",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "doneIssuesRedesignTemp",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": [
                                    "DONE"
                                ]
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "doneIssuesRedesignTemp.totalCount"
                        }
                    ],
                    "storageKey": "issues(filters:{\"statusCategories\":[\"DONE\"]})"
                },
                "action": "THROW",
                "path": "doneIssuesRedesignTemp"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "inProgressIssuesRedesignTemp",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": [
                                    "IN_PROGRESS"
                                ]
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "inProgressIssuesRedesignTemp.totalCount"
                        }
                    ],
                    "storageKey": "issues(filters:{\"statusCategories\":[\"IN_PROGRESS\"]})"
                },
                "action": "THROW",
                "path": "inProgressIssuesRedesignTemp"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "todoIssuesRedesignTemp",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filters",
                            "value": {
                                "statusCategories": [
                                    "TODO"
                                ]
                            }
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "todoIssuesRedesignTemp.totalCount"
                        }
                    ],
                    "storageKey": "issues(filters:{\"statusCategories\":[\"TODO\"]})"
                },
                "action": "THROW",
                "path": "todoIssuesRedesignTemp"
            }
        ],
        "type": "JiraVersion"
    };
}();
$1f0466cb638e4bbc$var$node.hash = "1894f7adb956d41d80dd7d309152870c";
var $1f0466cb638e4bbc$export$2e2bcd8739ae039 = $1f0466cb638e4bbc$var$node;

});

parcelRegister("fBtGA", function(module, exports) {

$parcel$export(module.exports, "default", () => $e26ad5b1e0b6b1f8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e26ad5b1e0b6b1f8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issuesHeading: {
        "id": "version-progress.issues-heading.issues-heading",
        "defaultMessage": "Issues"
    },
    doneIssues: {
        "id": "version-progress.issues-heading.done-issues",
        "defaultMessage": "{doneCount} of {totalCount} {totalCount, plural, one {done} other {done}}"
    },
    noIssues: {
        "id": "version-progress.issues-heading.no-issues",
        "defaultMessage": "No issues added"
    },
    issuesHeadingIssueTerminologyRefreshM4: {
        "id": "version-progress.issues-heading.issues-heading-issue-terminology-refresh-m4",
        "defaultMessage": "Work items"
    },
    noIssuesIssueTerminologyRefreshM4: {
        "id": "version-progress.issues-heading.no-issues-issue-terminology-refresh-m4",
        "defaultMessage": "No work items added"
    }
});

});


parcelRegister("fyA65", function(module, exports) {

$parcel$export(module.exports, "messages", () => $13fbf51b0a1bc364$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $13fbf51b0a1bc364$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    progressHeading: {
        "id": "version-progress.progress-heading",
        "defaultMessage": "Progress"
    }
});

});

parcelRegister("jbc56", function(module, exports) {

$parcel$export(module.exports, "RelatedWorkHeading", () => $96f2971fe6b990b4$export$7705e89d52d14851);

var $iHnWK = parcelRequire("iHnWK");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $l1N8i = parcelRequire("l1N8i");

var $koVbs = parcelRequire("koVbs");

var $gZxFj = parcelRequire("gZxFj");

var $aY8y9 = parcelRequire("aY8y9");
const $96f2971fe6b990b4$export$7705e89d52d14851 = ({ relatedWorkEdges: relatedWorkEdges })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const edges = (0, $8Uumt.useFragment)((0, $iHnWK.default), relatedWorkEdges);
    const totalCount = edges.length;
    const numNonPlaceholders = totalCount ? edges.filter((edge)=>{
        switch(edge?.node.__typename){
            case 'JiraVersionRelatedWorkNativeReleaseNotes':
                return true;
            case 'JiraVersionRelatedWorkGenericLink':
            case 'JiraVersionRelatedWorkConfluenceReleaseNotes':
                return edge.node.url !== null;
            default:
                return false;
        }
    }).length : 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZxFj.Section), {
        isCollapsible: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall",
        as: "h3"
    }, formatMessage((0, $aY8y9.default).relatedWorkHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZxFj.Summary), null, totalCount === 0 ? formatMessage((0, $aY8y9.default).noItems) : formatMessage((0, $aY8y9.default).summaryText, {
        numNonPlaceholders: numNonPlaceholders,
        totalCount: totalCount
    })));
};

});
parcelRegister("iHnWK", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d079d8334f42b59$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<da12abafadbeeeb286bba016228ab38c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6d079d8334f42b59$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = [
        v0 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "url"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": {
            "plural": true
        },
        "name": "relatedWorkHeading_versionProgress",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": v1 /*: any*/ ,
                            "type": "JiraVersionRelatedWorkGenericLink"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": v1 /*: any*/ ,
                            "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v0 /*: any*/ 
                            ],
                            "type": "JiraVersionRelatedWorkNativeReleaseNotes"
                        }
                    ]
                },
                "action": "NONE",
                "path": "node"
            }
        ],
        "type": "JiraVersionRelatedWorkV2Edge"
    };
}();
$6d079d8334f42b59$var$node.hash = "211a6665d1a1915d987787889e12cca6";
var $6d079d8334f42b59$export$2e2bcd8739ae039 = $6d079d8334f42b59$var$node;

});

parcelRegister("aY8y9", function(module, exports) {

$parcel$export(module.exports, "default", () => $846bed7c3363306b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $846bed7c3363306b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    relatedWorkHeading: {
        "id": "version-progress.related-work-heading.related-work-heading",
        "defaultMessage": "Related work"
    },
    summaryText: {
        "id": "version-progress.related-work-heading.summary-text",
        "defaultMessage": "{numNonPlaceholders} of {totalCount} added"
    },
    noItems: {
        "id": "version-progress.related-work-heading.no-items",
        "defaultMessage": "None added"
    }
});

});


parcelRegister("jMgdz", function(module, exports) {

$parcel$export(module.exports, "RelatedWorkProgressBar", () => $d9869db5ea59fe27$export$34d7439de9413789);

var $19ZPd = parcelRequire("19ZPd");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");


var $gZxFj = parcelRequire("gZxFj");

var $cTHUt = parcelRequire("cTHUt");
const $d9869db5ea59fe27$export$34d7439de9413789 = ({ relatedWorkEdges: relatedWorkEdges })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const edges = (0, $8Uumt.useFragment)((0, $19ZPd.default), relatedWorkEdges);
    const totalCount = edges.length;
    const numNonPlaceholders = totalCount ? edges.filter((edge)=>{
        switch(edge?.node.__typename){
            case 'JiraVersionRelatedWorkNativeReleaseNotes':
                return true;
            case 'JiraVersionRelatedWorkGenericLink':
            case 'JiraVersionRelatedWorkConfluenceReleaseNotes':
                return edge.node.url !== null;
            default:
                return false;
        }
    }).length : 0;
    const numPlaceholders = totalCount - numNonPlaceholders;
    const fireAnalyticsEvent = (analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'relatedWorkProgressTooltip', {
            numOfItems: totalCount,
            numPlaceholders: numPlaceholders,
            numNonPlaceholders: numNonPlaceholders
        });
    };
    if (totalCount === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZxFj.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZxFj.ProgressBarContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZxFj.ProgressBarElementContainer), {
        totalCount: 1,
        portionCount: 1,
        isLast: true,
        "aria-label": formatMessage((0, $cTHUt.default).noRelatedWorkText)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZxFj.Bar), {
        color: (0, $874a267084b6120b$export$9a2ce699a8e88c00),
        isFirst: true,
        isLast: true
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZxFj.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZxFj.ProgressBarContainer), null, numNonPlaceholders > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZxFj.ProgressBarElementContainer), {
        totalCount: totalCount,
        portionCount: numNonPlaceholders,
        "aria-label": formatMessage((0, $cTHUt.default).nonPlaceholdersSegmentTooltipText, {
            numNonPlaceholders: numNonPlaceholders
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        position: "top",
        content: formatMessage((0, $cTHUt.default).nonPlaceholdersSegmentTooltipText, {
            numNonPlaceholders: numNonPlaceholders
        }),
        onShow: (analyticsEvent)=>fireAnalyticsEvent(analyticsEvent)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZxFj.Bar), {
        color: (0, $874a267084b6120b$export$f2a648c26a91297f),
        isFirst: true,
        isLast: numPlaceholders === 0
    }))), numPlaceholders > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZxFj.ProgressBarElementContainer), {
        isLast: true,
        totalCount: totalCount,
        portionCount: numPlaceholders,
        "aria-label": formatMessage((0, $cTHUt.default).placeholdersSegmentTooltipText, {
            numPlaceholders: numPlaceholders
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        position: "top",
        content: formatMessage((0, $cTHUt.default).placeholdersSegmentTooltipText, {
            numPlaceholders: numPlaceholders
        }),
        onShow: (analyticsEvent)=>fireAnalyticsEvent(analyticsEvent)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZxFj.Bar), {
        color: (0, $874a267084b6120b$export$9a2ce699a8e88c00),
        isFirst: numNonPlaceholders === 0,
        isLast: true
    })))));
};

});
parcelRegister("19ZPd", function(module, exports) {

$parcel$export(module.exports, "default", () => $634121e3100e8331$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<391fa37bd82e7c8c0612c5be399d9087>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $634121e3100e8331$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = [
        v0 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "url"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": {
            "plural": true
        },
        "name": "relatedWorkProgressBar_versionProgress",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": v1 /*: any*/ ,
                            "type": "JiraVersionRelatedWorkGenericLink"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": v1 /*: any*/ ,
                            "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v0 /*: any*/ 
                            ],
                            "type": "JiraVersionRelatedWorkNativeReleaseNotes"
                        }
                    ]
                },
                "action": "NONE",
                "path": "node"
            }
        ],
        "type": "JiraVersionRelatedWorkV2Edge"
    };
}();
$634121e3100e8331$var$node.hash = "c40509aabe2c6731ba0d792fff68b169";
var $634121e3100e8331$export$2e2bcd8739ae039 = $634121e3100e8331$var$node;

});

parcelRegister("cTHUt", function(module, exports) {

$parcel$export(module.exports, "default", () => $ace75de7f9cfb453$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ace75de7f9cfb453$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    nonPlaceholdersSegmentTooltipText: {
        "id": "version-progress.related-work-progress-bar.non-placeholders-segment-tooltip-text",
        "defaultMessage": "{numNonPlaceholders} added"
    },
    placeholdersSegmentTooltipText: {
        "id": "version-progress.related-work-progress-bar.placeholders-segment-tooltip-text",
        "defaultMessage": "{numPlaceholders} {numPlaceholders, plural, one {placeholder} other {placeholders}}"
    },
    noRelatedWorkText: {
        "id": "version-progress.related-work-progress-bar.no-related-work-text",
        "defaultMessage": "No related work"
    }
});

});



parcelRegister("kHzKl", function(module, exports) {

$parcel$export(module.exports, "NonCriticalErrorBoundary", () => $3be5a553cf5dc15b$export$1625b7ea4c7a5a23);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");
const $3be5a553cf5dc15b$export$1625b7ea4c7a5a23 = ({ fallback: fallback, eventLocation: eventLocation, children: children, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: fallback,
        packageName: "jiraSoftwareReleasesVersionDetail",
        teamName: "nova",
        id: eventLocation,
        onError: onError
    }, children);

});

parcelRegister("gl1Tm", function(module, exports) {

$parcel$export(module.exports, "convertTabToQueryVariables", () => $8cb887ac98c983d8$export$4fc138bc768eeef1);
const $8cb887ac98c983d8$export$4fc138bc768eeef1 = (tab)=>{
    switch(tab){
        case 'release-report-warnings':
            return {
                filter: 'OPEN_PULL_REQUEST',
                isShowWarnings: true
            };
        case 'release-report-all-issues':
            return {
                filter: 'ALL',
                isShowWarnings: false
            };
        case 'release-report-done':
            return {
                filter: 'DONE',
                isShowWarnings: false
            };
        case 'release-report-in-progress':
            return {
                filter: 'IN_PROGRESS',
                isShowWarnings: false
            };
        case 'release-report-todo':
            return {
                filter: 'TODO',
                isShowWarnings: false
            };
        default:
            // default to all issues column
            return {
                filter: 'ALL',
                isShowWarnings: false
            };
    }
};

});

parcelRegister("47ffb", function(module, exports) {

$parcel$export(module.exports, "useCurrentTab", () => $94ff5b9d5e6937bf$export$49b7d3cc5222d699);

var $bmKPg = parcelRequire("bmKPg");

const $94ff5b9d5e6937bf$var$toVersionTabId = (selectedTabId)=>{
    if (selectedTabId === undefined) return 0, $465fa0a3a0498e9a$export$88979a530e0a9348;
    switch(selectedTabId){
        case 0, $465fa0a3a0498e9a$export$53105de2008705e2:
            return 0, $465fa0a3a0498e9a$export$53105de2008705e2;
        case 0, $465fa0a3a0498e9a$export$88979a530e0a9348:
            return 0, $465fa0a3a0498e9a$export$88979a530e0a9348;
        case 0, $465fa0a3a0498e9a$export$d669607531cb7a9a:
            return 0, $465fa0a3a0498e9a$export$d669607531cb7a9a;
        case 0, $465fa0a3a0498e9a$export$d9e751b9469f77b3:
            return 0, $465fa0a3a0498e9a$export$d9e751b9469f77b3;
        case 0, $465fa0a3a0498e9a$export$5e552e58a93a50a5:
            return 0, $465fa0a3a0498e9a$export$5e552e58a93a50a5;
        default:
            return 0, $465fa0a3a0498e9a$export$88979a530e0a9348;
    }
};
const $94ff5b9d5e6937bf$export$49b7d3cc5222d699 = ()=>{
    const [selectedTabId, setSelectedTab] = (0, $bmKPg.usePathParam)('tab');
    const setCurrentTab = (tabId)=>{
        setSelectedTab(tabId);
    };
    return {
        currentTabId: $94ff5b9d5e6937bf$var$toVersionTabId(selectedTabId),
        setCurrentTab: setCurrentTab
    };
};

});
const $465fa0a3a0498e9a$export$53105de2008705e2 = 'release-report-warnings';
const $465fa0a3a0498e9a$export$88979a530e0a9348 = 'release-report-all-issues';
const $465fa0a3a0498e9a$export$d669607531cb7a9a = 'release-report-done';
const $465fa0a3a0498e9a$export$d9e751b9469f77b3 = 'release-report-in-progress';
const $465fa0a3a0498e9a$export$5e552e58a93a50a5 = 'release-report-todo';


parcelRegister("lryuo", function(module, exports) {

$parcel$export(module.exports, "PerformanceTracker", () => $7cff66f08bd22f56$export$57a2c9a4973f6a35);

var $5uXOq = parcelRequire("5uXOq");

var $dGrdR = parcelRequire("dGrdR");

var $5rqex = parcelRequire("5rqex");

var $kHzKl = parcelRequire("kHzKl");
const $7cff66f08bd22f56$var$versionDetailsPagePageLoad = (0, $dGrdR.metrics).pageLoad({
    key: 'software.version-details-page',
    ssr: {
        doneAsFmp: true
    },
    slo: {
        fmp: {
            initial: {
                threshold: 1000
            },
            transition: {
                threshold: 1000
            }
        },
        tti: {
            initial: {
                threshold: 4000
            },
            transition: {
                threshold: 4000
            }
        }
    }
});
const $7cff66f08bd22f56$export$57a2c9a4973f6a35 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kHzKl.NonCriticalErrorBoundary), {
        fallback: "unmount",
        eventLocation: "performanceTracker"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), {
        appName: "jira-software-version-details-page",
        // @ts-expect-error - TS2769 - No overload matches this call.
        metric: $7cff66f08bd22f56$var$versionDetailsPagePageLoad
    }));

});
parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $99gkn = parcelRequire("99gkn");

var $aOr3t = parcelRequire("aOr3t");

var $1u4q7 = parcelRequire("1u4q7");

var $1AZST = parcelRequire("1AZST");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99gkn.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOr3t.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $1u4q7.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("aOr3t", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $a3e67858f0c2f8da$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
        (0, $bFU4G.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $21pfT = parcelRequire("21pfT");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $21pfT.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1AZST = parcelRequire("1AZST");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $1AZST.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $1AZST = parcelRequire("1AZST");
var $49z18 = parcelRequire("49z18");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $1AZST.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $49z18.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $1u4q7 = parcelRequire("1u4q7");

var $y7eb2 = parcelRequire("y7eb2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});



parcelRegister("jpznh", function(module, exports) {

$parcel$export(module.exports, "AccessCheck", () => $f48e1ae7f8bcee8f$export$ad057184bf4c4ff2);

var $8Hozt = parcelRequire("8Hozt");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $cIy4l = parcelRequire("cIy4l");

var $7tQej = parcelRequire("7tQej");
const $f48e1ae7f8bcee8f$var$getVersionIssuesUrl = (versionName, projectKey)=>{
    const jql = `project = ${(0, $cIy4l.toQuotedString)(projectKey)} AND fixVersion = ${(0, $cIy4l.toQuotedString)(versionName)}`;
    return (0, $cIy4l.createIssuesUrl)(jql);
};
const $f48e1ae7f8bcee8f$export$ad057184bf4c4ff2 = ({ jiraVersion: jiraVersion, children: children })=>{
    const version = (0, $8Uumt.useFragment)((0, $8Hozt.default), jiraVersion);
    if (version != null && !version.canViewVersionDetailsPage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: $f48e1ae7f8bcee8f$var$getVersionIssuesUrl(version.name, version.project.key)
    });
    return children;
};

});
parcelRegister("8Hozt", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaf769132d117138$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f4a1d76106d11af339bfdb2ce2d272cd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $aaf769132d117138$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "accessCheck_softwareReleasesVersionDetail",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "NONE",
            "path": "name"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        "action": "NONE",
                        "path": "project.key"
                    }
                ]
            },
            "action": "NONE",
            "path": "project"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "canViewVersionDetailsPage"
            },
            "action": "NONE",
            "path": "canViewVersionDetailsPage"
        }
    ],
    "type": "JiraVersion"
};
$aaf769132d117138$var$node.hash = "9b2c4488974a4d13577b85807b03079a";
var $aaf769132d117138$export$2e2bcd8739ae039 = $aaf769132d117138$var$node;

});


parcelRegister("fs1tp", function(module, exports) {

$parcel$export(module.exports, "Header", () => $d2a1664c6770ad79$export$8b251419efc915eb);

var $hsUsT = parcelRequire("hsUsT");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $ldJSL = parcelRequire("ldJSL");

var $i8Qvm = parcelRequire("i8Qvm");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $jS4lj = parcelRequire("jS4lj");

var $cS37j = parcelRequire("cS37j");

var $93jKl = parcelRequire("93jKl");

var $8oqHW = parcelRequire("8oqHW");

var $kfztd = parcelRequire("kfztd");

var $6lgIC = parcelRequire("6lgIC");

var $dkXFD = parcelRequire("dkXFD");

var $3HwlS = parcelRequire("3HwlS");

var $kHzKl = parcelRequire("kHzKl");


var $je2ff = parcelRequire("je2ff");

var $jsT1l = parcelRequire("jsT1l");

var $giWl2 = parcelRequire("giWl2");

var $fbFR6 = parcelRequire("fbFR6");
/**
 * This component is wraps header of the version detail page.
 *
 * When the gate is enabled, it applies a negative top margin to the header.
 */ const $d2a1664c6770ad79$var$VersionPageHeaderWrapper = ({ breadcrumbs: breadcrumbs, children: children })=>{
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d2a1664c6770ad79$var$headerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        breadcrumbs: breadcrumbs,
        truncateTitle: true,
        disableTitleStyles: true
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        breadcrumbs: breadcrumbs,
        truncateTitle: true,
        disableTitleStyles: true
    }, children);
};
const $d2a1664c6770ad79$export$8b251419efc915eb = ({ jiraVersion: jiraVersion, shouldShowBreadcrumbs: shouldShowBreadcrumbs = true, shouldShowFeedbackButton: shouldShowFeedbackButton = true, shouldShowAutomationButton: shouldShowAutomationButton = true, shouldShowGraphButton: shouldShowGraphButton = true })=>{
    const breadcrumbs = shouldShowBreadcrumbs ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jS4lj.default), null) : null;
    const onConnectAppExpFail = (0, $93jKl.useExperienceFail)({
        experience: (0, $81f82fb3b4517b74$export$af5e668651a80140)
    });
    const [warningsModalOpen, setWarningsModalOpen] = (0, $5uXOq.useState)(false);
    const [isEditing, setIsEditing] = (0, $5uXOq.useState)(false);
    const version = (0, $8Uumt.useFragment)((0, $hsUsT.default), jiraVersion);
    const issues = version.allIssues.totalCount;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d2a1664c6770ad79$var$VersionPageHeaderWrapper, {
        breadcrumbs: breadcrumbs
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d2a1664c6770ad79$var$HeaderTitleLane, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d2a1664c6770ad79$var$LeftContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d2a1664c6770ad79$var$HeaderTitle, {
        "data-testid": "software-releases-version-detail.ui.header.title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d2a1664c6770ad79$var$PageTitleContainer, {
        isOverflowEnabled: isEditing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jsT1l.AsyncEditableName), {
        isEditing: isEditing,
        setIsEditing: setIsEditing,
        jiraVersion: version
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d2a1664c6770ad79$var$RightContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, shouldShowGraphButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8oqHW.default), {
        from: version.id
    }), shouldShowFeedbackButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kHzKl.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "feedbackButton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $giWl2.FeedbackButton), null)), shouldShowAutomationButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kHzKl.NonCriticalErrorBoundary), {
        fallback: "unmount",
        eventLocation: "releaseAutomationMenu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6lgIC.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, warningsModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kHzKl.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "warningConfigModal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dkXFD.ManageWarningsModal), {
        jiraVersion: version,
        setModalClosed: ()=>{
            setWarningsModalOpen(false);
        }
    }))), !(0, $kfztd.isDevopsFeatureDisabledInFedRamp)() && issues > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fbFR6.ReleaseNotesButton), {
        jiraVersion: version
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kHzKl.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "headerConnectApps",
        onError: onConnectAppExpFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d2a1664c6770ad79$var$MarketPlaceAddonLane, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $je2ff.ConnectApps), {
        jiraVersion: version
    }))));
};
const $d2a1664c6770ad79$var$headerWrapperStyles = (0, $8CUq3.xcss)({
    marginBlockStart: 'space.negative.150'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d2a1664c6770ad79$var$HeaderTitleLane = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _1p57pxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d2a1664c6770ad79$var$LeftContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _18u0x0bf _1ul9idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d2a1664c6770ad79$var$RightContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1e0c1txw _1bahesu3 _1ul91mjv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d2a1664c6770ad79$var$MarketPlaceAddonLane = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _4cvresu3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d2a1664c6770ad79$var$HeaderTitle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1ul9idpf _4t3ior1b",
            __cmplp.className
        ])
    });
});
const $d2a1664c6770ad79$var$PageTitleContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOverflowEnabled: isOverflowEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkx0bf _1ul9idpf",
            __cmplp.isOverflowEnabled ? "_1reoewfl _18m9ewfl" : "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hsUsT", function(module, exports) {

$parcel$export(module.exports, "default", () => $909296b02fa53b8c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<edd2d889f15c331ccb875f58c8834595>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $909296b02fa53b8c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "header_softwareReleasesVersionDetail",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "alias": "allIssues",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "filter",
                        "value": "ALL"
                    }
                ],
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "issues",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        },
                        "action": "THROW",
                        "path": "allIssues.totalCount"
                    }
                ],
                "storageKey": "issues(filter:\"ALL\")"
            },
            "action": "THROW",
            "path": "allIssues"
        },
        {
            "kind": "FragmentSpread",
            "name": "async_softwareReleasesVersionDetail_AsyncEditableName"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesManageWarnings_ManageWarningsModal"
        },
        {
            "kind": "FragmentSpread",
            "name": "connectApps_softwareReleasesVersionDetail"
        },
        {
            "kind": "FragmentSpread",
            "name": "releaseNotesButton_softwareReleasesVersionDetail"
        }
    ],
    "type": "JiraVersion"
};
$909296b02fa53b8c$var$node.hash = "f18c07820c274d0155b6bcd5afb8be06";
var $909296b02fa53b8c$export$2e2bcd8739ae039 = $909296b02fa53b8c$var$node;

});

parcelRegister("8oqHW", function(module, exports) {

$parcel$export(module.exports, "default", () => $209121b8bab00e10$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $kfztd = parcelRequire("kfztd");

var $9OXo1 = parcelRequire("9OXo1");


var $iAsld = parcelRequire("iAsld");

var $7jnfo = parcelRequire("7jnfo");
function $209121b8bab00e10$var$Graph({ from: from }) {
    const { environment: environment } = (0, $9OXo1.useTenantContext)();
    const graphURL = `${environment === 'staging' ? (0, $f4564a22dfe3f554$export$b1c73a3711ffd2e1) : (0, $f4564a22dfe3f554$export$b105bca7736ab247)}?ari=${from}`;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        href: graphURL,
        "aria-label": formatMessage((0, $7jnfo.default).graphButtonLabelNonFinal),
        target: "_blank",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iAsld.GraphIcon), null)
    });
}
var $209121b8bab00e10$export$2e2bcd8739ae039 = (0, $7XYc4.componentWithCondition)(()=>!(0, $kfztd.isDevopsFeatureDisabledInFedRamp)() && (0, $4R6GH.fg)('otc-show-me-the-graph'), $209121b8bab00e10$var$Graph, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
()=>null);

});
const $f4564a22dfe3f554$export$b105bca7736ab247 = 'https://atlassian-graph.prod-east.frontend.public.atl-paas.net/';
const $f4564a22dfe3f554$export$b1c73a3711ffd2e1 = 'https://atlassian-graph.stg-east.frontend.public.atl-paas.net/';

parcelRegister("iAsld", function(module, exports) {

$parcel$export(module.exports, "GraphIcon", () => $b7531f203cb3100a$export$717a5ffb6a14ac74);

var $5uXOq = parcelRequire("5uXOq");
const $b7531f203cb3100a$export$717a5ffb6a14ac74 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "var(--ds-icon-discovery, #8270DB)",
        viewBox: "0 0 256 256"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M200,152a31.84,31.84,0,0,0-19.53,6.68l-23.11-18A31.65,31.65,0,0,0,160,128c0-.74,0-1.48-.08-2.21l13.23-4.41A32,32,0,1,0,168,104c0,.74,0,1.48.08,2.21l-13.23,4.41A32,32,0,0,0,128,96a32.59,32.59,0,0,0-5.27.44L115.89,81A32,32,0,1,0,96,88a32.59,32.59,0,0,0,5.27-.44l6.84,15.4a31.92,31.92,0,0,0-8.57,39.64L73.83,165.44a32.06,32.06,0,1,0,10.63,12l25.71-22.84a31.91,31.91,0,0,0,37.36-1.24l23.11,18A31.65,31.65,0,0,0,168,184a32,32,0,1,0,32-32Zm0-64a16,16,0,1,1-16,16A16,16,0,0,1,200,88ZM80,56A16,16,0,1,1,96,72,16,16,0,0,1,80,56ZM56,208a16,16,0,1,1,16-16A16,16,0,0,1,56,208Zm144-8a16,16,0,1,1,16-16A16,16,0,0,1,200,200Z"
    }));

});

parcelRegister("7jnfo", function(module, exports) {

$parcel$export(module.exports, "default", () => $303612e9ffdead3d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $303612e9ffdead3d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    graphButtonLabelNonFinal: {
        "id": "graph.graph-button-label-non-final",
        "defaultMessage": "Open the graph"
    }
});

});


parcelRegister("6lgIC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d512d39a9a2997e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $hrfsZ = parcelRequire("hrfsZ");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $GYEZV = parcelRequire("GYEZV");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $8d512d39a9a2997e$var$AutomationMenu = (0, $kxZPA.lazy)(()=>(parcelRequire("4UMYR")), {
    moduleId: "./src/packages/releases/automation-menu/src/ContextAwareAutomationMenu.tsx"
});
const $8d512d39a9a2997e$var$fallback = // eslint-disable-next-line jira/integration/test-id-by-folder-structure
/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $GYEZV.IconWrapper), {
    "data-testid": "jira-releases-automation-menu.ui.automation-button.disabled"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
    glyph: (0, $hrfsZ.AutomationGlyph),
    label: ""
}));
const $8d512d39a9a2997e$var$AsyncReleaseAutomationMenu = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "releases-automation-menu",
        fallback: $8d512d39a9a2997e$var$fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8d512d39a9a2997e$var$AutomationMenu, null));
var $8d512d39a9a2997e$export$2e2bcd8739ae039 = $8d512d39a9a2997e$var$AsyncReleaseAutomationMenu;

});
parcelRegister("hrfsZ", function(module, exports) {

$parcel$export(module.exports, "AutomationGlyph", () => $7a6859ebc905c49b$export$3b6023946faff8bc);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");
const $7a6859ebc905c49b$export$3b6023946faff8bc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M14 5L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M14 5L7 12H17L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));

});

parcelRegister("GYEZV", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $828ddd55ab0efbe2$export$be58b4326e23250f);
$parcel$export(module.exports, "default", () => $828ddd55ab0efbe2$export$2e2bcd8739ae039);
/* AutomationMenu.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jZ4fr = parcelRequire("jZ4fr");

var $l1N8i = parcelRequire("l1N8i");

var $5LWLA = parcelRequire("5LWLA");

var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $hrfsZ = parcelRequire("hrfsZ");

var $jJ8Br = parcelRequire("jJ8Br");

var $2vSU6 = parcelRequire("2vSU6");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $7FEHo = parcelRequire("7FEHo");

var $2zZKC = parcelRequire("2zZKC");

var $1OWKd = parcelRequire("1OWKd");
const $828ddd55ab0efbe2$var$automationIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
    glyph: (0, $hrfsZ.AutomationGlyph),
    label: ""
});
const $828ddd55ab0efbe2$var$AutomationMenuContent = (props)=>{
    const { projectType: projectType } = props;
    const intl = (0, $koVbs.default)();
    return projectType === (0, $2vSU6.SOFTWARE_PROJECT) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($828ddd55ab0efbe2$var$MenuContentWrapper, {
        "data-testid": "jira-releases-automation-menu.ui.automation-menu-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($828ddd55ab0efbe2$var$MenuTitle, null, intl.formatMessage((0, $1OWKd.default).automationMenuTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($828ddd55ab0efbe2$var$MenuSubTitle, null, intl.formatMessage((0, $1OWKd.default).automationMenuSubTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2zZKC.AutomationMenuTemplateRules), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7FEHo.AutomationMenuDeepLinks), {
        includeDiscoverAutomation: false,
        ...props
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7FEHo.AutomationMenuDeepLinks), {
        includeDiscoverAutomation: true,
        ...props
    });
};
const $828ddd55ab0efbe2$export$bf60e24e2fb3b05d = ({ isMenuEnabled: isMenuEnabled, projectProps: projectProps, isOpenByDefault: isOpenByDefault })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(isOpenByDefault ?? false);
    const intl = (0, $koVbs.default)();
    return isMenuEnabled && projectProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), {
        blanketIsTinted: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "fusionReleaseAutomationMenu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-end",
        messageId: "software-releases-automation-menu.ui.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($828ddd55ab0efbe2$var$AutomationMenuContent, {
                projectKey: projectProps.projectKey,
                projectType: projectProps.projectType,
                isSimplifiedProject: projectProps.isSimplifiedProject
            }),
        trigger: ({ ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                "data-testid": "jira-releases-automation-menu.ui.automation-button.enabled"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jJ8Br.default), {
                ...triggerProps,
                onClick: ()=>setIsOpen(!isOpen),
                isSelected: isOpen
            }))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
        name: "fusionReleaseAutomationMenu"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($828ddd55ab0efbe2$export$be58b4326e23250f, {
        "data-testid": "jira-releases-automation-menu.ui.automation-button.disabled"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        position: "top",
        content: intl.formatMessage((0, $1OWKd.default).disabledAutomationMenuButtonTooltipMessage)
    }, $828ddd55ab0efbe2$var$automationIcon));
};
var $828ddd55ab0efbe2$export$2e2bcd8739ae039 = $828ddd55ab0efbe2$export$bf60e24e2fb3b05d;
const $828ddd55ab0efbe2$var$MenuTitle = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: (0, $4R6GH.fg)('jfp_a11y_autodev_fix_releases_automation_heading') ? 'h2' : 'h4',
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($828ddd55ab0efbe2$var$MenuTitleComponent, props)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $828ddd55ab0efbe2$var$MenuContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1kdj",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $828ddd55ab0efbe2$var$MenuSubTitle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt41rml _syaz131l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $828ddd55ab0efbe2$export$be58b4326e23250f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _4t3i1f4h _1bsb1f4h _1bah1h6o _syaz1lg7 _ca0q1b66 _d0al13gf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $828ddd55ab0efbe2$var$MenuTitleComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q1ejb _u5f3idpf _n3tdu2gc _19bv1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jJ8Br", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff704efab144026a$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $5LWLA = parcelRequire("5LWLA");

var $4ldhu = parcelRequire("4ldhu");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");

var $22OQR = parcelRequire("22OQR");

var $dCm1o = parcelRequire("dCm1o");

var $hrfsZ = parcelRequire("hrfsZ");

var $eBN2x = parcelRequire("eBN2x");
const $ff704efab144026a$var$MenuButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isSelected: isSelected, onClick: onClick }, ref)=>{
    const automationIconTestId = 'automation-menu.ui.button.icon';
    const onClickWithAnalytics = (0, $5uXOq.useCallback)((event, analytics)=>{
        (0, $8zOmE.fireUIAnalytics)(analytics, 'automationMenuButton');
        onClick();
    }, [
        onClick
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $eBN2x.default).menuButtonTooltip),
        position: "top",
        isScreenReaderAnnouncementDisabled: true
    }, (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
        ref: ref,
        appearance: (0, $dCm1o.isVisualRefreshEnabled)() ? 'default' : 'subtle',
        onClick: onClickWithAnalytics,
        isSelected: isSelected,
        testId: "automation-menu.ui.button.menu-button",
        id: "automation-menu.ui.popup",
        "data-vc": "automation-menu-button" // @ts-expect-error - externalId does not exist on Button types
        ,
        externalId: "automation-menu.ui.button.menu-button",
        "aria-label": formatMessage((0, $eBN2x.default).menuButtonTooltip),
        "aria-expanded": isSelected,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ldhu))), {
            label: "",
            color: "currentColor",
            spacing: "spacious",
            testId: automationIconTestId
        })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ref: ref,
        appearance: "subtle",
        spacing: "none",
        isSelected: isSelected,
        onClick: onClickWithAnalytics,
        testId: "automation-menu.ui.button.menu-button",
        id: "automation-menu.ui.popup" // @ts-expect-error - externalId does not exist on Button types
        ,
        externalId: "automation-menu.ui.button.menu-button",
        "aria-label": formatMessage((0, $eBN2x.default).menuButtonTooltip),
        "aria-expanded": isSelected,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ff704efab144026a$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
            size: "medium",
            glyph: (0, $hrfsZ.AutomationGlyph),
            label: "",
            primaryColor: isSelected ? "var(--ds-icon-selected, #0C66E4)" : undefined,
            secondaryColor: "none",
            testId: automationIconTestId
        }))
    }));
});
var $ff704efab144026a$export$2e2bcd8739ae039 = $ff704efab144026a$var$MenuButton;
const $ff704efab144026a$var$unselectedColor = "var(--ds-text-subtle, #44546F)";
const $ff704efab144026a$var$unselectedHoverColor = "var(--ds-text-subtlest, #626F86)";
const $ff704efab144026a$var$multiplier = 4; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ff704efab144026a$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbzwfg _4t3izwfg _syaz1gjq _30l3131l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4ldhu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2251b011785916069b749fddb2c5cd02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32936cf628dec798$var$_react = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $32936cf628dec798$var$_baseNew = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $32936cf628dec798$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $32936cf628dec798$var$AutomationIcon = (props)=>/*#__PURE__*/ $32936cf628dec798$var$_react.default.createElement($32936cf628dec798$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$32936cf628dec798$var$AutomationIcon.displayName = 'AutomationIcon';
var $32936cf628dec798$var$_default = module.exports.default = $32936cf628dec798$var$AutomationIcon;

});

parcelRegister("eBN2x", function(module, exports) {

$parcel$export(module.exports, "default", () => $70fd4abbcff5ac1b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $70fd4abbcff5ac1b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    menuButtonTooltip: {
        "id": "automation-menu.button.menu-button-tooltip",
        "defaultMessage": "Automation"
    },
    automationsMenuButtonIcon: {
        "id": "automation-menu.button.automations-menu-button-icon",
        "defaultMessage": "automations-menu-button-icon"
    }
});

});


parcelRegister("7FEHo", function(module, exports) {

$parcel$export(module.exports, "AutomationMenuDeepLinks", () => $98a2cd2021e414e5$export$fd3c4b1ddf70f790);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $hxCqX = parcelRequire("hxCqX");

var $faod6 = parcelRequire("faod6");

var $feC7X = parcelRequire("feC7X");

var $3Z96c = parcelRequire("3Z96c");
var $eZUJu = parcelRequire("eZUJu");

var $hrfsZ = parcelRequire("hrfsZ");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $6Wfoj = parcelRequire("6Wfoj");

var $bLi0f = parcelRequire("bLi0f");
const $98a2cd2021e414e5$var$automationIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
    glyph: (0, $hrfsZ.AutomationGlyph),
    label: ""
});
const $98a2cd2021e414e5$export$fd3c4b1ddf70f790 = ({ isSimplifiedProject: isSimplifiedProject, projectKey: projectKey, projectType: projectType, includeDiscoverAutomation: includeDiscoverAutomation })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'link'
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return(// eslint-disable-next-line jira/integration/test-id-by-folder-structure
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "jira-releases-automation-menu.ui.automation-menu-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), null, includeDiscoverAutomation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
        href: (0, $6Wfoj.buildDiscoverAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplifiedProject
        }),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hxCqX))), {
            spacing: "spacious",
            label: ""
        }),
        onClick: ()=>(0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'discoverAutomationLink'),
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $bLi0f.default).discoverAutomationMenuItemLabel)) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
        href: (0, $6Wfoj.buildManageRulesAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplifiedProject
        }),
        iconBefore: $98a2cd2021e414e5$var$automationIcon,
        onClick: ()=>(0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'manageRulesAutomationLink'),
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $bLi0f.default).manageAutomationMenuItemLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
        href: (0, $6Wfoj.buildNewRuleAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplifiedProject
        }),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($faod6))), {
            spacing: "spacious",
            label: ""
        }),
        onClick: ()=>(0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'newRuleAutomationLink'),
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $bLi0f.default).createAutomationMenuItemLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
        href: (0, $6Wfoj.buildAuditLogAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplifiedProject
        }),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($feC7X))), {
            spacing: "spacious",
            label: ""
        }),
        onClick: ()=>(0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'auditLogAutomationLink'),
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $bLi0f.default).auditLogAutomationMenuItemLabel)))));
};

});
parcelRegister("hxCqX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e4278cede1b75ce1f6bae493dae404a5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc5354e02d431713$var$_react = $cc5354e02d431713$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $cc5354e02d431713$var$_compass = $cc5354e02d431713$var$_interopRequireDefault((parcelRequire("7ftyG")));

var $cc5354e02d431713$var$_discover = $cc5354e02d431713$var$_interopRequireDefault((parcelRequire("hyEaJ")));
function $cc5354e02d431713$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CompassIcon.
 * This component is CompassIcon, with `UNSAFE_fallbackIcon` set to "DiscoverIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cc5354e02d431713$var$CompassIcon = (props)=>/*#__PURE__*/ $cc5354e02d431713$var$_react.default.createElement($cc5354e02d431713$var$_compass.default, Object.assign({
        LEGACY_fallbackIcon: $cc5354e02d431713$var$_discover.default
    }, props));
$cc5354e02d431713$var$CompassIcon.Name = 'CompassIconMigration';
var $cc5354e02d431713$var$_default = module.exports.default = $cc5354e02d431713$var$CompassIcon;

});
parcelRegister("7ftyG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::149b2cd6a95881a63bc7d331a2f52240>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5470dcd3a4786f26$var$_react = $5470dcd3a4786f26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5470dcd3a4786f26$var$_baseNew = $5470dcd3a4786f26$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $5470dcd3a4786f26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Compass".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5470dcd3a4786f26$var$CompassIcon = (props)=>/*#__PURE__*/ $5470dcd3a4786f26$var$_react.default.createElement($5470dcd3a4786f26$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m11.78-3.78a.75.75 0 0 1 .155.834l-2 4.5a.75.75 0 0 1-.38.381l-4.5 2a.75.75 0 0 1-.99-.99l2-4.5a.75.75 0 0 1 .38-.38l4.5-2a.75.75 0 0 1 .835.154M6.992 8.051l.955.956-1.72.764zm2.016-.105-.956-.955 1.72-.765z" clip-rule="evenodd"/>`
    }, props));
$5470dcd3a4786f26$var$CompassIcon.displayName = 'CompassIcon';
var $5470dcd3a4786f26$var$_default = module.exports.default = $5470dcd3a4786f26$var$CompassIcon;

});

parcelRegister("hyEaJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc84c60139a91f28$var$_react = $cc84c60139a91f28$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $cc84c60139a91f28$var$_compass = $cc84c60139a91f28$var$_interopRequireDefault((parcelRequire("7ftyG")));
function $cc84c60139a91f28$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cc84c60139a91f28$var$DiscoverIcon = (props)=>/*#__PURE__*/ $cc84c60139a91f28$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M12 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14m0 2a9 9 0 1 1 0-18 9 9 0 0 1 0 18"/><path d="m10.86 10.186 3.896-1.948c1.11-.555 1.562-.108 1.005 1.006l-1.948 3.896c-.126.251-.426.55-.673.673l-3.897 1.948c-1.11.556-1.561.11-1.004-1.006l1.947-3.896c.126-.25.426-.55.673-.673M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/></g></svg>`
    }, props, {
        newIcon: $cc84c60139a91f28$var$_compass.default
    }));
$cc84c60139a91f28$var$DiscoverIcon.displayName = 'DiscoverIcon';
var $cc84c60139a91f28$var$_default = module.exports.default = $cc84c60139a91f28$var$DiscoverIcon;

});


parcelRegister("feC7X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c9c914f8f7a3631a5a598f1ef46602e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b175bd18e8763918$var$_react = $b175bd18e8763918$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b175bd18e8763918$var$_clock = $b175bd18e8763918$var$_interopRequireDefault((parcelRequire("hyKRO")));

var $b175bd18e8763918$var$_frequent = $b175bd18e8763918$var$_interopRequireDefault((parcelRequire("6uqJA")));
function $b175bd18e8763918$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ClockIcon.
 * This component is ClockIcon, with `UNSAFE_fallbackIcon` set to "EmojiFrequentIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: recent, time input, sprint time remaining, overdue task work type status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b175bd18e8763918$var$ClockIcon = (props)=>/*#__PURE__*/ $b175bd18e8763918$var$_react.default.createElement($b175bd18e8763918$var$_clock.default, Object.assign({
        LEGACY_fallbackIcon: $b175bd18e8763918$var$_frequent.default
    }, props));
$b175bd18e8763918$var$ClockIcon.Name = 'ClockIconMigration';
var $b175bd18e8763918$var$_default = module.exports.default = $b175bd18e8763918$var$ClockIcon;

});
parcelRegister("6uqJA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b9a484973717fe2$var$_react = $4b9a484973717fe2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4b9a484973717fe2$var$_clock = $4b9a484973717fe2$var$_interopRequireDefault((parcelRequire("hyKRO")));
function $4b9a484973717fe2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4b9a484973717fe2$var$EmojiFrequentIcon = (props)=>/*#__PURE__*/ $4b9a484973717fe2$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8m0 14.222A6.23 6.23 0 0 1 5.778 12 6.23 6.23 0 0 1 12 5.778 6.23 6.23 0 0 1 18.222 12 6.23 6.23 0 0 1 12 18.222m.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.89.89 0 0 0 1.257 0 .89.89 0 0 0 0-1.256z"/></svg>`
    }, props, {
        newIcon: $4b9a484973717fe2$var$_clock.default
    }));
$4b9a484973717fe2$var$EmojiFrequentIcon.displayName = 'EmojiFrequentIcon';
var $4b9a484973717fe2$var$_default = module.exports.default = $4b9a484973717fe2$var$EmojiFrequentIcon;

});


parcelRegister("6Wfoj", function(module, exports) {

$parcel$export(module.exports, "buildNewRuleAutomationUrl", () => $cb0b6e6c85af8509$export$d6be0a6034032add);
$parcel$export(module.exports, "buildManageRulesAutomationUrl", () => $cb0b6e6c85af8509$export$fb714f787469e8b0);
$parcel$export(module.exports, "buildAuditLogAutomationUrl", () => $cb0b6e6c85af8509$export$7d1590b2fb4dd741);
$parcel$export(module.exports, "buildDiscoverAutomationUrl", () => $cb0b6e6c85af8509$export$51ac1eeac37070f8);
$parcel$export(module.exports, "buildTemplateRuleAutomationUrl", () => $cb0b6e6c85af8509$export$82ce8540ef209720);

var $gOS29 = parcelRequire("gOS29");
const $cb0b6e6c85af8509$export$d6be0a6034032add = (projectProps)=>`${(0, $gOS29.getBaseAutomationUrl)(projectProps)}#rule/new?componentFilterCriteria=RELEASE_MANAGEMENT_TRIGGERS`;
const $cb0b6e6c85af8509$export$fb714f787469e8b0 = (projectProps)=>`${(0, $gOS29.getBaseAutomationUrl)(projectProps)}#/rule-list`;
const $cb0b6e6c85af8509$export$7d1590b2fb4dd741 = (projectProps)=>`${(0, $gOS29.getBaseAutomationUrl)(projectProps)}#tab/audit-log`;
const $cb0b6e6c85af8509$export$51ac1eeac37070f8 = (projectProps)=>`${(0, $gOS29.getBaseAutomationUrl)(projectProps)}#/tab/rule-library`;
const $cb0b6e6c85af8509$export$82ce8540ef209720 = (projectProps, templateId)=>`${(0, $gOS29.getBaseAutomationUrl)(projectProps)}#/rule/template?templateId=${templateId}`;

});

parcelRegister("bLi0f", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3f9241b4c0385fe$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b3f9241b4c0385fe$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    discoverAutomationMenuItemLabel: {
        "id": "software-releases-automation-menu.menu-contents.deep-links.discover-automation-menu-item-label",
        "defaultMessage": "Discover automation"
    },
    manageAutomationMenuItemLabel: {
        "id": "software-releases-automation-menu.menu-contents.deep-links.manage-automation-menu-item-label",
        "defaultMessage": "Manage automation"
    },
    createAutomationMenuItemLabel: {
        "id": "software-releases-automation-menu.menu-contents.deep-links.create-automation-menu-item-label",
        "defaultMessage": "Create automation"
    },
    auditLogAutomationMenuItemLabel: {
        "id": "software-releases-automation-menu.menu-contents.deep-links.audit-log-automation-menu-item-label",
        "defaultMessage": "Audit log"
    }
});

});


parcelRegister("2zZKC", function(module, exports) {

$parcel$export(module.exports, "AutomationMenuTemplateRules", () => $4e8c2dda72f3490e$export$35643f531510af9e);
/* AutomationMenuTemplateRules.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5LWLA = parcelRequire("5LWLA");

var $eGdV2 = parcelRequire("eGdV2");

var $lfDf7 = parcelRequire("lfDf7");

var $letJZ = parcelRequire("letJZ");

var $3Z96c = parcelRequire("3Z96c");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $jTNwC = parcelRequire("jTNwC");

var $j1oLQ = parcelRequire("j1oLQ");

var $6Wfoj = parcelRequire("6Wfoj");

var $2X0gE = parcelRequire("2X0gE");
const $4e8c2dda72f3490e$var$jiraIssuesIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lfDf7))), {
    LEGACY_size: "medium",
    spacing: "spacious",
    label: ""
});
const $4e8c2dda72f3490e$var$slackIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
    size: "medium",
    glyph: (0, $j1oLQ.SlackGlyph),
    label: ""
});
const $4e8c2dda72f3490e$var$launchDarklyGliph = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
    size: "medium",
    glyph: (0, $jTNwC.LaunchDarklyGlyph),
    label: ""
});
const $4e8c2dda72f3490e$var$ActionAndTriggerIcons = ({ trigger: trigger })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e8c2dda72f3490e$var$IconShadow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $letJZ.JiraIcon), {
        size: "small",
        appearance: "brand",
        testId: "software-releases-automation-menu.ui.menu-contents.template-rules.jira-icon",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eGdV2))), {
        spacing: "spacious",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e8c2dda72f3490e$var$IconShadow, null, trigger));
const $4e8c2dda72f3490e$export$35643f531510af9e = (props)=>{
    const { isSimplifiedProject: isSimplifiedProject, projectKey: projectKey, projectType: projectType } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'link'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
        shouldTitleWrap: true,
        href: (0, $6Wfoj.buildTemplateRuleAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplifiedProject
        }, 'software_template_14'),
        target: "_blank",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e8c2dda72f3490e$var$ActionAndTriggerIcons, {
            trigger: $4e8c2dda72f3490e$var$jiraIssuesIcon
        }),
        onClick: ()=>(0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'templateRuleAddVersionToInProgressIssue')
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $2X0gE.default).templateRuleAddIssueToVersionOnVersionCreateIssueTerminologyRefreshM4 : (0, $2X0gE.default).templateRuleAddIssueToVersionOnVersionCreate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
        shouldTitleWrap: true,
        href: (0, $6Wfoj.buildTemplateRuleAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplifiedProject
        }, 'devops_template_6'),
        target: "_blank",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e8c2dda72f3490e$var$ActionAndTriggerIcons, {
            trigger: $4e8c2dda72f3490e$var$launchDarklyGliph
        }),
        onClick: ()=>(0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'templateRuleCreateLaunchDarklyFlag')
    }, formatMessage((0, $2X0gE.default).templateRuleCreateLaunchDarklyFlagOnVersionCreate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
        shouldTitleWrap: true,
        href: (0, $6Wfoj.buildTemplateRuleAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplifiedProject
        }, 'software_template_12'),
        target: "_blank",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e8c2dda72f3490e$var$ActionAndTriggerIcons, {
            trigger: $4e8c2dda72f3490e$var$slackIcon
        }),
        onClick: ()=>(0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'templateSendSlackMessageOnVersionRelease')
    }, formatMessage((0, $2X0gE.default).templateRuleSendSlackMessageOnVersionRelease)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
        shouldTitleWrap: true,
        href: (0, $6Wfoj.buildTemplateRuleAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplifiedProject
        }, 'software_template_13'),
        target: "_blank",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e8c2dda72f3490e$var$ActionAndTriggerIcons, {
            trigger: $4e8c2dda72f3490e$var$slackIcon
        }),
        onClick: ()=>(0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'templateSendSlackMessageOnVersionUnRelease')
    }, formatMessage((0, $2X0gE.default).templateRuleSendSlackMessageOnVersionUnRelease)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e8c2dda72f3490e$var$DiscoverAutomationLink, {
        href: (0, $6Wfoj.buildDiscoverAutomationUrl)({
            projectKey: projectKey,
            projectType: projectType,
            isSimplified: isSimplifiedProject
        }),
        onClick: ()=>(0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'discoverAutomationLink')
    }, formatMessage((0, $2X0gE.default).discoverMoreAutomationMenuItemLabel)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4e8c2dda72f3490e$var$IconShadow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _4t3izwfg _1bsbzwfg _16qszucj _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4e8c2dda72f3490e$var$DiscoverAutomationLink = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qpxbi _u5f3idpf _n3tdpxbi _19bv1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jTNwC", function(module, exports) {

$parcel$export(module.exports, "LaunchDarklyGlyph", () => $b864cf68c0dd1dc4$export$f1f691d73572fca1);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");
const $b864cf68c0dd1dc4$export$f1f691d73572fca1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        transform: "matrix(0.11111112 0 0 0.11111112 -0 0.058888756)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M109.8 214.94C 107.997055 214.91039 106.35804 213.88696 105.54 212.28C 104.73658 210.72453 104.908226 208.84428 105.98 207.45999L105.98 207.45999L156.47 137.93L68 174.11C 67.40301 174.38016 66.75528 174.51993 66.1 174.52C 64.01144 174.4985 62.179775 173.12071 61.579998 171.12001C 60.985783 169.13066 61.80725 166.99075 63.579998 165.91L63.579998 165.91L141.33 120L4.41 112.13C 1.9438841 111.9687 0.026099205 109.92138 0.026099205 107.45C 0.026099205 104.978615 1.9438841 102.9313 4.41 102.77L4.41 102.77L141.41 94.899994L63.61 49C 61.861492 47.905083 61.065918 45.772614 61.670002 43.8C 62.260277 41.79695 64.09185 40.41616 66.18 40.399998C 66.83458 40.396626 67.482346 40.532997 68.08 40.8L68.08 40.8L156.5 77L106 7.48C 104.93831 6.087954 104.76732 4.210975 105.56 2.65C 106.37893 1.0358694 108.03006 0.013560295 109.84 0C 111.078804 0.0081067085 112.26174 0.516624 113.119995 1.41L113.119995 1.41L213.77 102.05C 216.74506 105.03536 216.74506 109.86465 213.77 112.850006L213.77 112.850006L113.08 213.53C 112.22175 214.42337 111.03882 214.93188 109.8 214.94z",
        stroke: "none",
        fill: "#282828",
        fillRule: "nonzero"
    })));

});

parcelRegister("j1oLQ", function(module, exports) {

$parcel$export(module.exports, "SlackGlyph", () => $0a27994cdc8eb4fb$export$cbfabcc4325ad3ff);
// It doesn't make sense to convert Slack icon into our token, as Slack icon is a unique brand. Confirmed that it looks great in DarkMode without tokens.
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");
const $0a27994cdc8eb4fb$export$cbfabcc4325ad3ff = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6.78559 14.3429C6.78559 15.3857 5.94273 16.2286 4.89987 16.2286C3.85702 16.2286 3.01416 15.3857 3.01416 14.3429C3.01416 13.3 3.85702 12.4572 4.89987 12.4572H6.78559V14.3429ZM7.72845 14.3429C7.72845 13.3 8.5713 12.4572 9.61416 12.4572C10.657 12.4572 11.4999 13.3 11.4999 14.3429V19.0572C11.4999 20.1 10.657 20.9429 9.61416 20.9429C8.5713 20.9429 7.72845 20.1 7.72845 19.0572V14.3429Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M9.61429 6.77143C8.57143 6.77143 7.72857 5.92857 7.72857 4.88571C7.72857 3.84286 8.57143 3 9.61429 3C10.6571 3 11.5 3.84286 11.5 4.88571V6.77143H9.61429ZM9.61429 7.72857C10.6571 7.72857 11.5 8.57143 11.5 9.61429C11.5 10.6571 10.6571 11.5 9.61429 11.5H4.88571C3.84286 11.5 3 10.6571 3 9.61429C3 8.57143 3.84286 7.72857 4.88571 7.72857H9.61429Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M17.1713 9.61429C17.1713 8.57143 18.0142 7.72857 19.057 7.72857C20.0999 7.72857 20.9427 8.57143 20.9427 9.61429C20.9427 10.6571 20.0999 11.5 19.057 11.5H17.1713V9.61429ZM16.2285 9.61429C16.2285 10.6571 15.3856 11.5 14.3427 11.5C13.2999 11.5 12.457 10.6571 12.457 9.61429V4.88571C12.457 3.84286 13.2999 3 14.3427 3C15.3856 3 16.2285 3.84286 16.2285 4.88571V9.61429Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M14.3427 17.1714C15.3856 17.1714 16.2285 18.0143 16.2285 19.0572C16.2285 20.1 15.3856 20.9429 14.3427 20.9429C13.2999 20.9429 12.457 20.1 12.457 19.0572V17.1714H14.3427ZM14.3427 16.2286C13.2999 16.2286 12.457 15.3857 12.457 14.3429C12.457 13.3 13.2999 12.4572 14.3427 12.4572H19.0713C20.1142 12.4572 20.957 13.3 20.957 14.3429C20.957 15.3857 20.1142 16.2286 19.0713 16.2286H14.3427Z",
        fill: "#ECB22E"
    }));

});

parcelRegister("2X0gE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a203593cf7e2d1db$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a203593cf7e2d1db$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    discoverMoreAutomationMenuItemLabel: {
        "id": "software-releases-automation-menu.menu-contents.template-rules.discover-more-automation-menu-item-label",
        "defaultMessage": "Discover more automation"
    },
    templateRuleAddIssueToVersionOnVersionCreate: {
        "id": "software-releases-automation-menu.menu-contents.template-rules.template-rule-add-issue-to-version-on-version-create",
        "defaultMessage": "When a version is created \u2192 then add all In Progress issues without a fix version"
    },
    templateRuleCreateLaunchDarklyFlagOnVersionCreate: {
        "id": "software-releases-automation-menu.menu-contents.template-rules.template-rule-create-launch-darkly-flag-on-version-create",
        "defaultMessage": "When a version is created \u2192 then create a LaunchDarkly flag"
    },
    templateRuleSendSlackMessageOnVersionRelease: {
        "id": "software-releases-automation-menu.menu-contents.template-rules.template-rule-send-slack-message-on-version-release",
        "defaultMessage": "When a version is released \u2192 then send a Slack message"
    },
    templateRuleSendSlackMessageOnVersionUnRelease: {
        "id": "software-releases-automation-menu.menu-contents.template-rules.template-rule-send-slack-message-on-version-un-release",
        "defaultMessage": "When a version is unreleased \u2192 then send a Slack message"
    },
    templateRuleAddIssueToVersionOnVersionCreateIssueTerminologyRefreshM4: {
        "id": "software-releases-automation-menu.menu-contents.template-rules.template-rule-add-issue-to-version-on-version-create-issue-terminology-refresh-m4",
        "defaultMessage": "When a version is created \u2192 then add all In Progress work items without a fix version"
    }
});

});


parcelRegister("1OWKd", function(module, exports) {

$parcel$export(module.exports, "default", () => $55aaaae2e5159e07$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $55aaaae2e5159e07$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    disabledAutomationMenuButtonTooltipMessage: {
        "id": "software-releases-automation-menu.disabled-automation-menu-button-tooltip-message",
        "defaultMessage": "You need to be a project admin to configure automation"
    },
    automationMenuTitle: {
        "id": "software-releases-automation-menu.automation-menu-title",
        "defaultMessage": "Automation"
    },
    automationMenuSubTitle: {
        "id": "software-releases-automation-menu.automation-menu-sub-title",
        "defaultMessage": "Setup your release automations from these templates, or create a new one of your own."
    }
});

});


parcelRegister("4UMYR", function(module, exports) {

let $394262ec452eb98e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $394262ec452eb98e$var$load("ccHfC").then(()=>parcelRequire('9Klur'));

});


parcelRegister("dkXFD", function(module, exports) {

$parcel$export(module.exports, "ManageWarningsModal", () => $6a565e41de1f08b9$export$6e3078b1666e4828);

var $cLMku = parcelRequire("cLMku");

var $9tBnW = parcelRequire("9tBnW");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $2rqOp = parcelRequire("2rqOp");

var $fVnbM = parcelRequire("fVnbM");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $92Z2l = parcelRequire("92Z2l");

var $4R6GH = parcelRequire("4R6GH");

var $7NYq5 = parcelRequire("7NYq5");

var $9fuVs = parcelRequire("9fuVs");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $idOin = parcelRequire("idOin");

var $36AXO = parcelRequire("36AXO");

var $gd85W = parcelRequire("gd85W");
const $6a565e41de1f08b9$export$6e3078b1666e4828 = ({ setModalClosed: setModalClosed, jiraVersion: jiraVersion })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const version = (0, $8Uumt.useFragment)((0, $9tBnW.default), jiraVersion);
    const { warningConfig: warningConfig, __id: versionRecordId } = version;
    const { openPullRequest: openPullRequest, failingBuild: failingBuild, unreviewedCode: unreviewedCode, openReview: openReview } = warningConfig;
    const [updatedVersionWarningConfig, setUpdatedVersionWarningConfig] = (0, $5uXOq.useState)((0, $gd85W.convertStatusToBoolean)(warningConfig));
    const removeDisabledWarningFilters = (0, $gd85W.useRemoveDisabledWarningFilters)(updatedVersionWarningConfig);
    const [isSaveFailed, setIsSaveFailed] = (0, $5uXOq.useState)(false);
    const [updateVersionWarningConfig, isWarningConfigUpdating] = (0, $8Uumt.useMutation)((0, $cLMku.default));
    const jiraProjectId = version.project.id;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        messageId: "software-releases-manage-warnings.ui.modal-dialog",
        messageType: "transactional",
        testId: "software-releases-manage-warnings.ui.modal-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, formatMessage((0, $idOin.default).manageWarnings))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6a565e41de1f08b9$var$WarningDescription, null, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $idOin.default).warningDescriptionIssueTerminologyRefreshM4 : (0, $idOin.default).warningDescription)), isSaveFailed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $6a565e41de1f08b9$var$errorSectionMessageContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "error"
    }, formatMessage((0, $idOin.default).updateWarningConfigFailed))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "warning"
    }, formatMessage((0, $idOin.default).warningsSetForAllVersionsInThisProject)), openPullRequest !== 'NOT_APPLICABLE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $36AXO.Toggle), {
        testId: "software-releases-manage-warnings.ui.open-pull-request",
        isDisabled: isWarningConfigUpdating,
        initialValue: openPullRequest === 'ENABLED',
        onChange: (_, analyticsEvent)=>setUpdatedVersionWarningConfig((prev)=>{
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'versionWarningsConfig', {
                    warningType: 'openPullRequest',
                    isEnabled: !prev.isOpenPullRequestEnabled
                });
                return {
                    ...prev,
                    isOpenPullRequestEnabled: !prev.isOpenPullRequestEnabled
                };
            }),
        headingTranslated: formatMessage((0, $idOin.default).openPullRequests),
        descriptionTranslated: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $idOin.default).openPullRequestsDescriptionIssueTerminologyRefreshM4 : (0, $idOin.default).openPullRequestsDescription)
    }), openReview !== 'NOT_APPLICABLE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $36AXO.Toggle), {
        testId: "software-releases-manage-warnings.ui.open-review",
        isDisabled: isWarningConfigUpdating,
        initialValue: openReview === 'ENABLED',
        onChange: (_, analyticsEvent)=>setUpdatedVersionWarningConfig((prev)=>{
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'versionWarningsConfig', {
                    warningType: 'openReview',
                    isEnabled: !prev.isOpenReviewEnabled
                });
                return {
                    ...prev,
                    isOpenReviewEnabled: !prev.isOpenReviewEnabled
                };
            }),
        headingTranslated: formatMessage((0, $idOin.default).openReviews),
        descriptionTranslated: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $idOin.default).openReviewsDescriptionIssueTerminologyRefreshM4 : (0, $idOin.default).openReviewsDescription)
    }), unreviewedCode !== 'NOT_APPLICABLE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $36AXO.Toggle), {
        testId: "software-releases-manage-warnings.ui.unreviewed-code",
        isDisabled: isWarningConfigUpdating,
        initialValue: unreviewedCode === 'ENABLED',
        onChange: (_, analyticsEvent)=>{
            setUpdatedVersionWarningConfig((prev)=>{
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'versionWarningsConfig', {
                    warningType: 'unreviewedCode',
                    isEnabled: !prev.isUnreviewedCodeEnabled
                });
                return {
                    ...prev,
                    isUnreviewedCodeEnabled: !prev.isUnreviewedCodeEnabled
                };
            });
        },
        headingTranslated: formatMessage((0, $idOin.default).unreviewedCode),
        descriptionTranslated: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $idOin.default).unreviewedCodeDescriptionIssueTerminologyRefreshM4 : (0, $idOin.default).unreviewedCodeDescription)
    }), failingBuild !== 'NOT_APPLICABLE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $36AXO.Toggle), {
        testId: "software-releases-manage-warnings.ui.failing-build",
        isDisabled: isWarningConfigUpdating,
        initialValue: failingBuild === 'ENABLED',
        onChange: (_, analyticsEvent)=>{
            setUpdatedVersionWarningConfig((prev)=>{
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'versionWarningsConfig', {
                    warningType: 'failingBuild',
                    isEnabled: !prev.isFailingBuildEnabled
                });
                return {
                    ...prev,
                    isFailingBuildEnabled: !prev.isFailingBuildEnabled
                };
            });
        },
        headingTranslated: formatMessage((0, $idOin.default).failingBuilds),
        descriptionTranslated: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $idOin.default).failingBuildsDescriptionIssueTerminologyRefreshM4 : (0, $idOin.default).failingBuildsDescription)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
        appearance: "primary",
        onClick: ()=>{
            updateVersionWarningConfig({
                variables: {
                    input: {
                        jiraProjectId: jiraProjectId,
                        updatedVersionWarningConfig: updatedVersionWarningConfig
                    },
                    versionId: version.id
                },
                // @ts-expect-error - TS2322 - Type '({ jira: { updateVersionWarningConfig: { success }, }, }: MutationResponse) => void' is not assignable to type '(response: {}, errors: PayloadError[] | null) => void | null'.
                onCompleted: ({ jira: { // @ts-expect-error(Suppressed for relay bump) - Property 'updateVersionWarningConfig' does not exist on type '{ readonly updateVersionWarningConfig: { readonly success: boolean; readonly version: { readonly " $fragmentSpreads": FragmentRefs<"issueProgressDetails_versionProgress">; } | null | undefined; } | null | undefined; } | null | undefined'.
                updateVersionWarningConfig: { success: success } } })=>{
                    if (success) {
                        removeDisabledWarningFilters();
                        setModalClosed();
                        return;
                    }
                    setIsSaveFailed(true);
                },
                onError: ()=>{
                    setIsSaveFailed(true);
                },
                updater: (store)=>{
                    const versionRecord = store.get(versionRecordId);
                    if (versionRecord == null) return;
                    const existingWarningConfigRecord = versionRecord.getLinkedRecord('warningConfig');
                    if (existingWarningConfigRecord == null) return;
                    const newValues = (0, $gd85W.getNewWarningConfigValues)(updatedVersionWarningConfig, {
                        openPullRequest: openPullRequest,
                        openReview: openReview,
                        failingBuild: failingBuild,
                        unreviewedCode: unreviewedCode
                    });
                    existingWarningConfigRecord.setValue(newValues.openPullRequest, 'openPullRequest');
                    existingWarningConfigRecord.setValue(newValues.openReview, 'openReview');
                    existingWarningConfigRecord.setValue(newValues.unreviewedCode, 'unreviewedCode');
                    existingWarningConfigRecord.setValue(newValues.failingBuild, 'failingBuild');
                    versionRecord.setLinkedRecord(existingWarningConfigRecord, 'warningConfig');
                }
            });
        },
        isLoading: isWarningConfigUpdating
    }, formatMessage((0, $idOin.default).modalSave)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: "software-releases-manage-warnings.ui.cancel-manage-warnings",
        onClick: ()=>setModalClosed(),
        isDisabled: isWarningConfigUpdating
    }, formatMessage((0, $idOin.default).modalCancel)))));
};
const $6a565e41de1f08b9$var$errorSectionMessageContainerStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6a565e41de1f08b9$var$WarningDescription = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyr1ejb _syaz1fxt",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cLMku", function(module, exports) {

$parcel$export(module.exports, "default", () => $7aa36bf826ad7c2c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aec7c7d15a68e9ccfb10cf6d3c93e5e1>>
 * @relayHash f80615342bea07d18fe9b588ee9c8938
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bb3640928c5b9aa6b7fe35b78c841cf3c2e853010ab4e47e56966cc8e62de2ce
const $7aa36bf826ad7c2c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "versionId"
        }
    ], v4 = [
        {
            "kind": "ScalarField",
            "name": "totalCount"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_ManageWarningsModalVersionWarningConfigMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionWarningConfigPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionWarningConfig",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "issueProgressDetails_versionProgress"
                                                }
                                            ],
                                            "type": "JiraVersion"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_ManageWarningsModalVersionWarningConfigMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateVersionWarningConfigPayload",
                            "kind": "LinkedField",
                            "name": "updateVersionWarningConfig",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "JiraVersionWarningConfig",
                                                    "kind": "LinkedField",
                                                    "name": "warningConfig",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "failingBuild"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "openPullRequest"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "openReview"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "unreviewedCode"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "alias": "doneIssuesRedesignTemp",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filters",
                                                            "value": {
                                                                "statusCategories": [
                                                                    "DONE"
                                                                ]
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": v4 /*: any*/ ,
                                                    "storageKey": "issues(filters:{\"statusCategories\":[\"DONE\"]})"
                                                },
                                                {
                                                    "alias": "inProgressIssuesRedesignTemp",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filters",
                                                            "value": {
                                                                "statusCategories": [
                                                                    "IN_PROGRESS"
                                                                ]
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": v4 /*: any*/ ,
                                                    "storageKey": "issues(filters:{\"statusCategories\":[\"IN_PROGRESS\"]})"
                                                },
                                                {
                                                    "alias": "todoIssuesRedesignTemp",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filters",
                                                            "value": {
                                                                "statusCategories": [
                                                                    "TODO"
                                                                ]
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": v4 /*: any*/ ,
                                                    "storageKey": "issues(filters:{\"statusCategories\":[\"TODO\"]})"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "warningsCount"
                                                }
                                            ],
                                            "type": "JiraVersion"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bb3640928c5b9aa6b7fe35b78c841cf3c2e853010ab4e47e56966cc8e62de2ce",
            "metadata": {},
            "name": "ui_ManageWarningsModalVersionWarningConfigMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$7aa36bf826ad7c2c$var$node.hash = "c4e2323c95f8ee01a7aae0a690ba4f89";
var $7aa36bf826ad7c2c$export$2e2bcd8739ae039 = $7aa36bf826ad7c2c$var$node;

});

parcelRegister("9tBnW", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1a037bbb24769f7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2db5e521c6a905015346df1d2ff4cfe7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b1a037bbb24769f7$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ui_softwareReleasesManageWarnings_ManageWarningsModal",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "project.id"
                        }
                    ]
                },
                "action": "THROW",
                "path": "project"
            },
            v0 /*: any*/ ,
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraVersionWarningConfig",
                    "kind": "LinkedField",
                    "name": "warningConfig",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "openPullRequest"
                            },
                            "action": "THROW",
                            "path": "warningConfig.openPullRequest"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "openReview"
                            },
                            "action": "THROW",
                            "path": "warningConfig.openReview"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "unreviewedCode"
                            },
                            "action": "THROW",
                            "path": "warningConfig.unreviewedCode"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "failingBuild"
                            },
                            "action": "THROW",
                            "path": "warningConfig.failingBuild"
                        }
                    ]
                },
                "action": "THROW",
                "path": "warningConfig"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__id"
                    }
                ]
            }
        ],
        "type": "JiraVersion"
    };
}();
$b1a037bbb24769f7$var$node.hash = "e5eb838f9801c770bc5137a984a02776";
var $b1a037bbb24769f7$export$2e2bcd8739ae039 = $b1a037bbb24769f7$var$node;

});

parcelRegister("idOin", function(module, exports) {

$parcel$export(module.exports, "default", () => $2622a8dd08ba55d1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2622a8dd08ba55d1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    manageWarnings: {
        "id": "software-releases-manage-warnings.manage-warnings",
        "defaultMessage": "Manage warnings"
    },
    modalSave: {
        "id": "software-releases-manage-warnings.modal-save",
        "defaultMessage": "Save"
    },
    modalCancel: {
        "id": "software-releases-manage-warnings.modal-cancel",
        "defaultMessage": "Cancel"
    },
    warningsSetForAllVersionsInThisProject: {
        "id": "software-releases-manage-warnings.warnings-set-for-all-versions-in-this-project",
        "defaultMessage": "These warning settings affect all existing and future versions in this project."
    },
    updateWarningConfigFailed: {
        "id": "software-releases-manage-warnings.update-warning-config-failed",
        "defaultMessage": "Something went wrong. Please try to save again."
    },
    openPullRequests: {
        "id": "software-releases-manage-warnings.open-pull-requests",
        "defaultMessage": "Open pull requests"
    },
    openPullRequestsDescription: {
        "id": "software-releases-manage-warnings.open-pull-requests-description",
        "defaultMessage": "These issues have been marked complete but have open pull requests."
    },
    openReviews: {
        "id": "software-releases-manage-warnings.open-reviews",
        "defaultMessage": "Open reviews"
    },
    openReviewsDescription: {
        "id": "software-releases-manage-warnings.open-reviews-description",
        "defaultMessage": "These issues have been marked complete but have open reviews."
    },
    unreviewedCode: {
        "id": "software-releases-manage-warnings.unreviewed-code",
        "defaultMessage": "Unreviewed code"
    },
    unreviewedCodeDescription: {
        "id": "software-releases-manage-warnings.unreviewed-code-description",
        "defaultMessage": "These issues have been marked complete but the commits are not part of a pull request or review."
    },
    failingBuilds: {
        "id": "software-releases-manage-warnings.failing-builds",
        "defaultMessage": "Failing builds"
    },
    failingBuildsDescription: {
        "id": "software-releases-manage-warnings.failing-builds-description",
        "defaultMessage": "These issues have been marked complete but have failing builds."
    },
    warningDescription: {
        "id": "software-releases-manage-warnings.warning-description",
        "defaultMessage": "Warnings will be displayed when the status of a Jira issue doesn't accurately reflect related development activity."
    },
    openPullRequestsDescriptionIssueTerminologyRefreshM4: {
        "id": "software-releases-manage-warnings.open-pull-requests-description-issue-terminology-refresh-m4",
        "defaultMessage": "These work items have been marked complete but have open pull requests."
    },
    openReviewsDescriptionIssueTerminologyRefreshM4: {
        "id": "software-releases-manage-warnings.open-reviews-description-issue-terminology-refresh-m4",
        "defaultMessage": "These work items have been marked complete but have open reviews."
    },
    unreviewedCodeDescriptionIssueTerminologyRefreshM4: {
        "id": "software-releases-manage-warnings.unreviewed-code-description-issue-terminology-refresh-m4",
        "defaultMessage": "These work items have been marked complete but the commits are not part of a pull request or review."
    },
    failingBuildsDescriptionIssueTerminologyRefreshM4: {
        "id": "software-releases-manage-warnings.failing-builds-description-issue-terminology-refresh-m4",
        "defaultMessage": "These work items have been marked complete but have failing builds."
    },
    warningDescriptionIssueTerminologyRefreshM4: {
        "id": "software-releases-manage-warnings.warning-description-issue-terminology-refresh-m4",
        "defaultMessage": "Warnings will be displayed when the status of a Jira work item doesn't accurately reflect related development activity."
    }
});

});

parcelRegister("36AXO", function(module, exports) {

$parcel$export(module.exports, "Toggle", () => $e28ba2f9418c9d1c$export$bea8ebba691c5813);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $dTlW6 = parcelRequire("dTlW6");
const $e28ba2f9418c9d1c$export$bea8ebba691c5813 = ({ initialValue: initialValue, headingTranslated: headingTranslated, descriptionTranslated: descriptionTranslated, onChange: onChange, testId: testId, isDisabled: isDisabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e28ba2f9418c9d1c$var$WarningCategoryContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall"
    }, headingTranslated), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e28ba2f9418c9d1c$var$Description, null, descriptionTranslated)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e28ba2f9418c9d1c$var$toggleContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTlW6.default), {
        testId: testId,
        defaultChecked: initialValue,
        onChange: onChange,
        isDisabled: isDisabled
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e28ba2f9418c9d1c$var$WarningCategoryContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bsb1osq _1bah1yb4 _19pkpxbi",
            __cmplp.className
        ])
    });
});
const $e28ba2f9418c9d1c$var$toggleContainerStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.200'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e28ba2f9418c9d1c$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1fxt",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dTlW6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3db77843cf29c460$export$2e2bcd8739ae039);
/* toggle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $eJbwP = parcelRequire("eJbwP");

var $2jwCH = parcelRequire("2jwCH");

var $VSDnB = parcelRequire("VSDnB");

var $lahQ6 = parcelRequire("lahQ6");
const $3db77843cf29c460$var$basicStyles = null;
const $3db77843cf29c460$var$borderStyles = null;
const $3db77843cf29c460$var$iconStyles = null;
const $3db77843cf29c460$var$sizeStyles = {
    regular: "_2rkopxbi _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf _p9c41fbe",
    large: "_2rkov47k _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz _p9c4w12q"
};
const $3db77843cf29c460$var$noop = (0, $eGmKJ.default);
const $3db77843cf29c460$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $3db77843cf29c460$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
}; /**
    * __Toggle__
    *
    * A toggle is used to view or switch between enabled or disabled states.
    *
    * - [Examples](https://atlassian.design/components/toggle/examples)
    * - [Code](https://atlassian.design/components/toggle/code)
    * - [Usage](https://atlassian.design/components/toggle/usage)
    */ 
const $3db77843cf29c460$var$Toggle = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $3db77843cf29c460$var$noop, onChange: providedChange = $3db77843cf29c460$var$noop, onFocus: providedFocus = $3db77843cf29c460$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $5uXOq.useState)(defaultChecked);
    const [isKeyboardUsed, setIsKeyboardUsed] = (0, $5uXOq.useState)(true);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (id && wrapperRef.current && wrapperRef.current.parentElement) {
            /*
      	DSP-21524 Handling the click on <label> that is linked via "for" attribute.
      	By default click on the label fires absolutely same onclick event as click on the input element.
      	To differentiate keyboard click from mouse we need this additional listener.
      */ const linkedLabel = wrapperRef.current.parentElement.querySelector(`label[for="${id}"]`);
            if (linkedLabel) {
                const unbind = (0, $cBeZP.bindAll)(linkedLabel, [
                    {
                        type: 'click',
                        listener: (event)=>{
                            setIsKeyboardUsed(false);
                            if (event?.detail > 1) /*
              DSP-21524 double or triple click on label initiating the text selection for label text and adds additional step to tab order.
              So here we set the isKeyboardUsed to true, to display focus ring on next Tab press
              */ setIsKeyboardUsed(true);
                        }
                    }
                ]);
                return unbind;
            }
        }
    }, [
        id,
        wrapperRef,
        isKeyboardUsed
    ]);
    const handleBlur = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isKeyboardUsed) setIsKeyboardUsed(true);
            providedOnBlur(event, analyticsEvent);
        },
        action: 'blur',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleFocus = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleChange = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const onLabelKeyDown = (event)=>{
        if ([
            ' ',
            'Tab',
            'Space'
        ].includes(event.key)) setIsKeyboardUsed(true);
    };
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined,
        // DSP-21524 Because label gets focus ring via focus-within and focus-within also triggers by mouse click we have to manually control the ring appearance.
        onKeyDown: onLabelKeyDown,
        onMouseDown: ()=>{
            setIsKeyboardUsed(false);
        }
    };
    const legacyIconSize = $3db77843cf29c460$var$iconSizeMap[size];
    const labelId = (0, $9KnKW.useId)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("label", {
        ...controlProps,
        ref: wrapperRef,
        className: (0, $bwpsq.default)([
            "_v564kete _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1o8l _vchh18uv _kqswh2mm _1y1m1ntv _bfhk76s1 _syaz5w2r _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1i2uidpf _1i3tidpf _se28idpf _3tunidpf _1423idpf _1hrtidpf _1bz2idpf _rqfvidpf _1yc0glyw _onsr1snc _1vgmagmp _1av610yn _1ulhidpf _rfx31q5u _pdykkete _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _7dwzglyw _1bki1y1w _1flt1y1w _3xv21y1w _9471g4a2 _ucab5w2r _mqf815t7 _3dj215t7 _1dl915t7 _1div5w2r _1il8kb7n _y54d5w2r _irr353wy _d0altlke _19ja13gf _8muf13gf _1k1q13gf _1plud4ly _1uo853wy _178c1y1w _16rslghj _ogf41r31 _1rtbnqa1 _5gg9t94y",
            isKeyboardUsed && "_jyzf194a _1r4mnqa1 _1t9pyh40",
            size === 'large' && !(0, $VSDnB.fg)('platform-visual-refresh-icons') && "_1n82gktf _19vpgktf",
            $3db77843cf29c460$var$sizeStyles[size]
        ]),
        children: [
            label ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: labelId,
                hidden: true,
                children: label
            }) : null,
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ref: ref,
                checked: shouldChecked,
                disabled: isDisabled,
                id: id,
                name: name,
                onBlur: handleBlur,
                onChange: handleChange,
                onFocus: handleFocus,
                type: "checkbox",
                value: value,
                "data-testid": testId && `${testId}--input`,
                "aria-labelledby": label ? labelId : undefined,
                "aria-describedby": descriptionId
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lahQ6.default), {
                size: size,
                isHidden: !shouldChecked,
                position: "left",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJbwP))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-check-icon`,
                    size: "small"
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lahQ6.default), {
                size: size,
                isHidden: shouldChecked,
                position: "right",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2jwCH))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-cross-icon`,
                    size: "small"
                })
            })
        ]
    });
}));
$3db77843cf29c460$var$Toggle.displayName = 'Toggle';
var $3db77843cf29c460$export$2e2bcd8739ae039 = $3db77843cf29c460$var$Toggle;

});
parcelRegister("eJbwP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::666ec8073f4584891951ab85e48975eb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab8e35fd94105dfe$var$_react = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ab8e35fd94105dfe$var$_checkMark = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("bjo8S")));

var $ab8e35fd94105dfe$var$_done = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("4DXCl")));
function $ab8e35fd94105dfe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ab8e35fd94105dfe$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $ab8e35fd94105dfe$var$_react.default.createElement($ab8e35fd94105dfe$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $ab8e35fd94105dfe$var$_done.default
    }, props));
$ab8e35fd94105dfe$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $ab8e35fd94105dfe$var$_default = module.exports.default = $ab8e35fd94105dfe$var$CheckMarkIcon;

});
parcelRegister("4DXCl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36190cbd288fec69$var$_react = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $36190cbd288fec69$var$_checkMark = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $36190cbd288fec69$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $36190cbd288fec69$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $36190cbd288fec69$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $36190cbd288fec69$var$_checkMark.default
    }));
$36190cbd288fec69$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $36190cbd288fec69$var$_default = module.exports.default = $36190cbd288fec69$var$EditorDoneIcon;

});


parcelRegister("lahQ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca1cdaa1eb34599d$export$2e2bcd8739ae039);
/* icon-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
const $ca1cdaa1eb34599d$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $ca1cdaa1eb34599d$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: (0, $3JT92.cx)($ca1cdaa1eb34599d$var$styles.iconContainer, isHidden && (0, $VSDnB.fg)('platform-visual-refresh-icons') && $ca1cdaa1eb34599d$var$styles.hidden, size === 'regular' && $ca1cdaa1eb34599d$var$styles.iconContainerRegular, size === 'large' && $ca1cdaa1eb34599d$var$styles.iconContainerLarge, position === 'left' && $ca1cdaa1eb34599d$var$styles.left, position === 'right' && $ca1cdaa1eb34599d$var$styles.right),
        children: children
    });
};
var $ca1cdaa1eb34599d$export$2e2bcd8739ae039 = $ca1cdaa1eb34599d$var$IconContainer;

});



parcelRegister("gd85W", function(module, exports) {

$parcel$export(module.exports, "convertStatusToBoolean", () => $7aa02e643017c449$export$6a8a12d4b311feca);
$parcel$export(module.exports, "getNewWarningConfigValues", () => $7aa02e643017c449$export$12511548bf3cb9c8);
$parcel$export(module.exports, "useRemoveDisabledWarningFilters", () => $7aa02e643017c449$export$dfbaab0bbdd97fab);


var $1YU2V = parcelRequire("1YU2V");

var $jPgXx = parcelRequire("jPgXx");
const $7aa02e643017c449$var$booleanToState = (value)=>value ? 'ENABLED' : 'DISABLED';
const $7aa02e643017c449$export$6a8a12d4b311feca = ({ openPullRequest: openPullRequest, openReview: openReview, unreviewedCode: unreviewedCode, failingBuild: failingBuild })=>({
        isOpenPullRequestEnabled: openPullRequest !== 'DISABLED',
        isOpenReviewEnabled: openReview !== 'DISABLED',
        isUnreviewedCodeEnabled: unreviewedCode !== 'DISABLED',
        isFailingBuildEnabled: failingBuild !== 'DISABLED'
    });
const $7aa02e643017c449$export$12511548bf3cb9c8 = (updatedBooleanValues, originalValues)=>({
        openPullRequest: originalValues.openPullRequest === 'NOT_APPLICABLE' ? 'NOT_APPLICABLE' : $7aa02e643017c449$var$booleanToState(updatedBooleanValues.isOpenPullRequestEnabled ?? true),
        openReview: originalValues.openReview === 'NOT_APPLICABLE' ? 'NOT_APPLICABLE' : $7aa02e643017c449$var$booleanToState(updatedBooleanValues.isOpenReviewEnabled ?? true),
        unreviewedCode: originalValues.unreviewedCode === 'NOT_APPLICABLE' ? 'NOT_APPLICABLE' : $7aa02e643017c449$var$booleanToState(updatedBooleanValues.isUnreviewedCodeEnabled ?? true),
        failingBuild: originalValues.failingBuild === 'NOT_APPLICABLE' ? 'NOT_APPLICABLE' : $7aa02e643017c449$var$booleanToState(updatedBooleanValues.isFailingBuildEnabled ?? true)
    });
const $7aa02e643017c449$export$dfbaab0bbdd97fab = ({ isFailingBuildEnabled: isFailingBuildEnabled, isOpenPullRequestEnabled: isOpenPullRequestEnabled, isOpenReviewEnabled: isOpenReviewEnabled, isUnreviewedCodeEnabled: isUnreviewedCodeEnabled })=>{
    const { parsedQueryParams: parsedQueryParams, setWarningsFilterParam: setWarningsFilterParam } = (0, $1YU2V.useFilterSortingQueryParams)();
    return ()=>{
        const currentlySelectedWarningFilters = parsedQueryParams[0, $5d187be87424268f$export$2552faed9df6a2cd] ?? [];
        const result = [];
        if (isFailingBuildEnabled && currentlySelectedWarningFilters.includes('FAILING_BUILD')) result.push('FAILING_BUILD');
        if (isOpenPullRequestEnabled && currentlySelectedWarningFilters.includes('OPEN_PULL_REQUEST')) result.push('OPEN_PULL_REQUEST');
        if (isUnreviewedCodeEnabled && currentlySelectedWarningFilters.includes('UNREVIEWED_CODE')) result.push('UNREVIEWED_CODE');
        if (isOpenReviewEnabled && currentlySelectedWarningFilters.includes('OPEN_REVIEW')) result.push('OPEN_REVIEW');
        setWarningsFilterParam(result.filter((0, $jPgXx.isWarningsFilterValue)));
    };
};

});


const $81f82fb3b4517b74$export$af5e668651a80140 = 'viewVersionDetailsConnectAppExtension';

parcelRegister("je2ff", function(module, exports) {

$parcel$export(module.exports, "ConnectApps", () => $3c2c54251dd7c67a$export$4fff5b46ac23b268);

var $hkhyi = parcelRequire("hkhyi");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7V5FW = parcelRequire("7V5FW");

var $93jKl = parcelRequire("93jKl");

var $3bQtK = parcelRequire("3bQtK");

var $LJaTB = parcelRequire("LJaTB");

var $koVbs = parcelRequire("koVbs");


var $9NzX0 = parcelRequire("9NzX0");

var $8dG4L = parcelRequire("8dG4L");
const $3c2c54251dd7c67a$export$4fff5b46ac23b268 = ({ jiraVersion: jiraVersion })=>{
    const { connectAddonIframeData: connectAddonIframeData } = (0, $8Uumt.useFragment)((0, $hkhyi.default), jiraVersion);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const hasConnectApps = connectAddonIframeData.length > 0;
    (0, $8dG4L.useConnectAppExtensionExperienceStart)(hasConnectApps);
    const { loading: loading, error: error } = (0, $8dG4L.useLoadConnectJs)(hasConnectApps);
    const onExpFail = (0, $93jKl.useExperienceFail)({
        experience: (0, $81f82fb3b4517b74$export$af5e668651a80140),
        attributes: {
            errorMessage: error?.message ?? null,
            numConnectApps: connectAddonIframeData.length
        }
    });
    if (!hasConnectApps || loading) return null;
    if (error) {
        onExpFail('versionDetailsHeader', error);
        // This should be caught by the nearest NonCriticalErrorBoundary
        throw error;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: (0, $81f82fb3b4517b74$export$af5e668651a80140)
    }), connectAddonIframeData.filter((iframeData)=>iframeData != null && iframeData.options === null).map((iframeData)=>{
        if (iframeData == null) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $LJaTB.FlagRenderer), {
            key: `error-flag-${iframeData.appName}`,
            flag: {
                type: 'error',
                title: formatMessage((0, $9NzX0.default).errorTitle, {
                    appName: iframeData.appName
                }),
                description: (0, $9NzX0.default).errorDescription,
                messageId: 'software-releases-version-detail.ui.header.connect-apps.flag.error.flag-renderer.error',
                messageType: 'transactional'
            }
        });
    }), connectAddonIframeData.filter((iframeData)=>iframeData != null && iframeData.options !== null).map((iframeData)=>{
        if (iframeData == null || iframeData.options == null) return null;
        const { appKey: appKey, moduleKey: moduleKey, options: options, appName: appName, location: location } = iframeData;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7V5FW.EcosystemModuleAsync), {
            appKey: appKey,
            moduleKey: moduleKey,
            // Temp code to validate if hostOrigin is the problem. In the legacy page, hostOrigin was the public URL, but broken version had internal URL
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            options: {
                ...options,
                hostOrigin: window.location.origin
            },
            appName: appName,
            key: `${appKey}-${moduleKey}`,
            location: location
        });
    }));
};

});
parcelRegister("hkhyi", function(module, exports) {

$parcel$export(module.exports, "default", () => $f41f920734248ae7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6d2ae5269ae2695b400dba5dc9770afa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f41f920734248ae7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "connectApps_softwareReleasesVersionDetail",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraVersionConnectAddonIframeData",
                "kind": "LinkedField",
                "name": "connectAddonIframeData",
                "plural": true,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "appKey"
                        },
                        "action": "THROW",
                        "path": "connectAddonIframeData.appKey"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "moduleKey"
                        },
                        "action": "THROW",
                        "path": "connectAddonIframeData.moduleKey"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "appName"
                        },
                        "action": "THROW",
                        "path": "connectAddonIframeData.appName"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "location"
                        },
                        "action": "THROW",
                        "path": "connectAddonIframeData.location"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "options"
                    }
                ]
            },
            "action": "THROW",
            "path": "connectAddonIframeData"
        }
    ],
    "type": "JiraVersion"
};
$f41f920734248ae7$var$node.hash = "5b5aa6740e6a7342f336e876f3dce998";
var $f41f920734248ae7$export$2e2bcd8739ae039 = $f41f920734248ae7$var$node;

});

parcelRegister("7V5FW", function(module, exports) {

$parcel$export(module.exports, "EcosystemModuleAsync", () => $089ebe0f688adad3$export$75ae776ec6b96bba);
$parcel$export(module.exports, "EcosystemTimeoutViewAsync", () => $089ebe0f688adad3$export$c800b42cc8eabb03);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $089ebe0f688adad3$var$EcosystemModule = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("6d1Z4")), {
    ssr: true,
    moduleId: "./src/packages/connect-utils/connect-utils-async/src/index.tsx"
});

const $089ebe0f688adad3$var$EcosystemTimeoutView = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("kEpYu")), {
    ssr: true,
    moduleId: "./src/packages/connect-utils/connect-utils-async/src/common/ui/ecosystem-timeout-view/index.tsx"
});
const $089ebe0f688adad3$export$75ae776ec6b96bba = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "ecosystem-module-async",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($089ebe0f688adad3$var$EcosystemModule, props));
const $089ebe0f688adad3$export$c800b42cc8eabb03 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "ecosystem-timeout-view-async",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($089ebe0f688adad3$var$EcosystemTimeoutView, props));

});
parcelRegister("6d1Z4", function(module, exports) {

let $48557eef4bcbc98d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $48557eef4bcbc98d$var$load("l49JS").then(()=>parcelRequire('djm2H'));

});

parcelRegister("kEpYu", function(module, exports) {

let $f08bb11ea3c7ed3b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f08bb11ea3c7ed3b$var$load("lFcOl").then(()=>parcelRequire('cXmpj'));

});


parcelRegister("LJaTB", function(module, exports) {

$parcel$export(module.exports, "FlagRenderer", () => $2de6889b93863972$export$7c38ebd1f7ca6a5a);

var $hkhmi = parcelRequire("hkhmi");

var $34Vv8 = parcelRequire("34Vv8");
const $2de6889b93863972$export$7c38ebd1f7ca6a5a = (0, $34Vv8.default)((0, $hkhmi.default));

});
parcelRegister("hkhmi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2971dd786c0add8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fHfPB = parcelRequire("fHfPB");
class $e2971dd786c0add8$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { flagService: flagService, flag: flag } = this.props;
        if (flagService) this.flagId = flagService.showFlag(flag);
    }
    componentWillUnmount() {
        const { flagService: flagService } = this.props;
        if (flagService && this.flagId) flagService.dismissFlag((0, $fHfPB.dismissFlag)(this.flagId));
    }
    render() {
        return null;
    }
}

});


parcelRegister("9NzX0", function(module, exports) {

$parcel$export(module.exports, "default", () => $31f4628f575c2a4b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $31f4628f575c2a4b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "software-releases-version-detail.header.connect-apps.error-title",
        "defaultMessage": "We weren't able to load {appName}."
    },
    errorDescription: {
        "id": "software-releases-version-detail.header.connect-apps.error-description",
        "defaultMessage": "Please refresh the page to try again."
    }
});

});

parcelRegister("8dG4L", function(module, exports) {

$parcel$export(module.exports, "useLoadConnectJs", () => $79b8f25ce2bada8b$export$ea4f866a08ef15ea);
$parcel$export(module.exports, "useConnectAppExtensionExperienceStart", () => $79b8f25ce2bada8b$export$491da84e1e953d53);

var $5uXOq = parcelRequire("5uXOq");

var $hrlU6 = parcelRequire("hrlU6");

var $kaHBi = parcelRequire("kaHBi");

var $koeKL = parcelRequire("koeKL");

const $79b8f25ce2bada8b$export$ea4f866a08ef15ea = (shouldLoad)=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
    const [error, setError] = (0, $5uXOq.useState)(undefined);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldLoad) (0, $hrlU6.withConnectHost)(()=>{
            setIsLoading(false);
        }).catch((e)=>{
            setIsLoading(false);
            setError(e);
        });
    }, [
        shouldLoad
    ]);
    return {
        loading: isLoading,
        error: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'Error | undefined'.
        error
    };
};
const $79b8f25ce2bada8b$export$491da84e1e953d53 = (hasConnectApps)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const onStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $81f82fb3b4517b74$export$af5e668651a80140),
        experienceId: cloudId,
        analyticsSource: 'versionDetails'
    });
    (0, $5uXOq.useEffect)(()=>{
        if (hasConnectApps) onStart();
    }, [
        onStart,
        hasConnectApps
    ]);
};

});


parcelRegister("jsT1l", function(module, exports) {

$parcel$export(module.exports, "AsyncEditableName", () => $6dab25e02275a236$export$9fb8a15f1e2c2f6f);

var $bEPU3 = parcelRequire("bEPU3");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $Ut4ud = parcelRequire("Ut4ud");

var $iYRBg = parcelRequire("iYRBg");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6dab25e02275a236$var$LazyEditableName = (0, $kxZPA.lazy)(()=>(parcelRequire("5ZTI2")).then((module)=>module.EditableName), {
    moduleId: "./src/packages/releases/version-detail/src/ui/header/editable-name/index.tsx"
});
const $6dab25e02275a236$export$9fb8a15f1e2c2f6f = ({ jiraVersion: jiraVersion, isEditing: isEditing, setIsEditing: setIsEditing })=>{
    const version = (0, $8Uumt.useFragment)((0, $bEPU3.default), jiraVersion);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "editable-name",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iYRBg.InlineEditReadViewContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Ut4ud.PageTitle), {
            size: "large",
            as: "h1"
        }, version.name))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6dab25e02275a236$var$LazyEditableName, {
        jiraVersion: version,
        isEditing: isEditing,
        setIsEditing: setIsEditing
    }));
};

});
parcelRegister("bEPU3", function(module, exports) {

$parcel$export(module.exports, "default", () => $c238223a566204ae$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<20a6f51f522d15758d6a81ed1c455dfa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c238223a566204ae$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "async_softwareReleasesVersionDetail_AsyncEditableName",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "FragmentSpread",
            "name": "editableName_softwareReleasesVersionDetail"
        }
    ],
    "type": "JiraVersion"
};
$c238223a566204ae$var$node.hash = "72635c9ff5ceeb9dc0fc3b0d03ba28e8";
var $c238223a566204ae$export$2e2bcd8739ae039 = $c238223a566204ae$var$node;

});

parcelRegister("Ut4ud", function(module, exports) {

$parcel$export(module.exports, "PageTitle", () => $57179de1740dbac6$export$155581e8dc02007a);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");
const $57179de1740dbac6$export$155581e8dc02007a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $l1N8i.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _19pkidpf _ca0q1b66 _u5f312x7 _n3td1b66 _19bv12x7",
            __cmplp.className
        ])
    });
});

});

parcelRegister("iYRBg", function(module, exports) {

$parcel$export(module.exports, "InlineEditReadViewContainer", () => $2aa25ea7843d2f00$export$408cb7913975dc96);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ /*
 * This component replicates margin/padding/border styles the @atlaskit/inline-edit component adds around
 * its "read view". The goal is to avoid styling inconsistencies in places where we *conditionally* render
 * an inline edit, e.g. as a suspense placeholde or a read-only mode. Example usage:
 *
 * return canEdit
 *      ? <InlineEdit readView={() => <ReadView />} {...otherProps} />
 *      : <InlineEditReadViewContainer><ReadView /></InlineEditReadViewContainer>
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $2aa25ea7843d2f00$export$408cb7913975dc96 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_189eyh40 _1dqonqa1 _1h6d3acm _19pku2gc _vwz4kb7n",
            __cmplp.className
        ])
    });
});

});

parcelRegister("5ZTI2", function(module, exports) {

let $45dddcf83af05d69$var$load = (parcelRequire("28QjX"))(4);
module.exports = $45dddcf83af05d69$var$load("cypIq").then(()=>parcelRequire('ljMmu'));

});


parcelRegister("giWl2", function(module, exports) {

$parcel$export(module.exports, "FeedbackButton", () => $5a6fab6442397c36$export$116fedbe5e2e2bd8);

var $5uXOq = parcelRequire("5uXOq");

var $7iULw = parcelRequire("7iULw");

var $coTzA = parcelRequire("coTzA");

var $kL4o0 = parcelRequire("kL4o0");
const $5a6fab6442397c36$var$FEEDBACK_COLLECTOR_LOCATION = 'releases.version.detail';
const $5a6fab6442397c36$export$116fedbe5e2e2bd8 = ()=>{
    const { simplified: simplified, isProjectAdmin: isProjectAdmin } = (0, $kL4o0.useProjectContext)();
    const additionalFeedbackEntries = [
        {
            id: (0, $7iULw.EntryKeys).FEEDBACK_COLLECTOR_LOCATION,
            value: $5a6fab6442397c36$var$FEEDBACK_COLLECTOR_LOCATION
        },
        {
            id: (0, $7iULw.EntryKeys).IS_SIMPLIFIED_PROJECT,
            value: simplified.toString()
        },
        {
            id: (0, $7iULw.EntryKeys).IS_ADMIN,
            value: isProjectAdmin == null ? 'unknown' : isProjectAdmin.toString()
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $coTzA.FeedbackCollectorButton), {
        entrypointId: (0, $7iULw.ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT),
        feedbackContext: additionalFeedbackEntries
    });
};

});
parcelRegister("coTzA", function(module, exports) {

$parcel$export(module.exports, "FeedbackCollectorButton", () => $85f5e51eda76fbac$export$b39479f42d974760);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $aEHvW = parcelRequire("aEHvW");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $koeKL = parcelRequire("koeKL");

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $4uMrp = parcelRequire("4uMrp");
const $85f5e51eda76fbac$var$TooltipWrapper = ({ children: children, appearance: appearance, customLabel: customLabel })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (appearance === 'icon') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: customLabel || formatMessage((0, $4uMrp.messages).leaveFeedback),
        position: "top"
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $85f5e51eda76fbac$export$b39479f42d974760 = ({ buttonAppearance: buttonAppearance = 'normal', testId: testId, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($aEHvW))), feedbackButtonCustomLabel: feedbackButtonCustomLabel, ...feedbackCollectorProps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const buttonRef = (0, $5uXOq.useRef)(null);
    const onOpen = (0, $5uXOq.useCallback)(()=>{
        // Check if feedbackContext already contains the cloud ID entry
        const hasCloudId = feedbackCollectorProps?.feedbackContext?.some((entry)=>entry.id === (0, $7iULw.EntryKeys).CLOUD_ID);
        // If not, add cloud id to feedback context
        const updatedFeedbackContext = hasCloudId ? feedbackCollectorProps.feedbackContext : [
            ...feedbackCollectorProps.feedbackContext || [],
            {
                id: (0, $7iULw.EntryKeys).CLOUD_ID,
                value: cloudId
            }
        ];
        openFeedbackCollector({
            ...feedbackCollectorProps,
            feedbackContext: updatedFeedbackContext,
            triggerRef: buttonRef
        });
    }, [
        cloudId,
        feedbackCollectorProps,
        openFeedbackCollector
    ]);
    const displayAsLink = buttonAppearance === 'link';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85f5e51eda76fbac$var$TooltipWrapper, {
        appearance: buttonAppearance,
        customLabel: feedbackButtonCustomLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85f5e51eda76fbac$var$StyledButton, {
        testId: testId,
        ref: buttonRef,
        appearance: displayAsLink ? 'link' : 'subtle',
        isHighlight: buttonAppearance === 'highlight',
        spacing: displayAsLink ? 'none' : 'default',
        onClick: onOpen,
        iconBefore: displayAsLink ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
            color: buttonAppearance === 'highlight' ? "var(--ds-text-discovery, #5E4DB2)" : "var(--ds-text, #172B4D)",
            label: ""
        }),
        "aria-label": // Only add aria-label if this is an icon button
        buttonAppearance === 'icon' && (feedbackButtonCustomLabel || formatMessage((0, $4uMrp.messages).leaveFeedback)) || '',
        "aria-haspopup": "dialog"
    }, buttonAppearance !== 'icon' && (feedbackButtonCustomLabel || formatMessage((0, $4uMrp.messages).leaveFeedback))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $85f5e51eda76fbac$var$StyledButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isHighlight && "_1w901u28 _16hgp7j4 _1fh11u28 _u1mb1jkz _r7smdh45 _1l5a1gfe",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aEHvW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c129a0bf5d2aeea221ba2044e3fd85fd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7c1f64cf4f9c421f$var$_react = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7c1f64cf4f9c421f$var$_feedback = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5dqGX")));

var $7c1f64cf4f9c421f$var$_feedback2 = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("3g1Fk")));
function $7c1f64cf4f9c421f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FeedbackIcon.
 * This component is FeedbackIcon, with `UNSAFE_fallbackIcon` set to "FeedbackIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7c1f64cf4f9c421f$var$FeedbackIcon = (props)=>/*#__PURE__*/ $7c1f64cf4f9c421f$var$_react.default.createElement($7c1f64cf4f9c421f$var$_feedback.default, Object.assign({
        LEGACY_fallbackIcon: $7c1f64cf4f9c421f$var$_feedback2.default
    }, props));
$7c1f64cf4f9c421f$var$FeedbackIcon.Name = 'FeedbackIconMigration';
var $7c1f64cf4f9c421f$var$_default = module.exports.default = $7c1f64cf4f9c421f$var$FeedbackIcon;

});
parcelRegister("5dqGX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f238518c984ab5d0530bd2cff7eccbeb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3cc2df171aca9493$var$_react = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3cc2df171aca9493$var$_baseNew = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3cc2df171aca9493$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3cc2df171aca9493$var$FeedbackIcon = (props)=>/*#__PURE__*/ $3cc2df171aca9493$var$_react.default.createElement($3cc2df171aca9493$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$3cc2df171aca9493$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $3cc2df171aca9493$var$_default = module.exports.default = $3cc2df171aca9493$var$FeedbackIcon;

});

parcelRegister("3g1Fk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25f4287f17f73dc4$var$_react = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $25f4287f17f73dc4$var$_feedback = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5dqGX")));
function $25f4287f17f73dc4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $25f4287f17f73dc4$var$FeedbackIcon = (props)=>/*#__PURE__*/ $25f4287f17f73dc4$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
    }, props, {
        newIcon: $25f4287f17f73dc4$var$_feedback.default
    }));
$25f4287f17f73dc4$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $25f4287f17f73dc4$var$_default = module.exports.default = $25f4287f17f73dc4$var$FeedbackIcon;

});


parcelRegister("4uMrp", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0c42512912e196d1$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0c42512912e196d1$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    leaveFeedback: {
        "id": "platform.feedback.feedback-collector.button.leave-feedback",
        "defaultMessage": "Give feedback"
    }
});

});



parcelRegister("fbFR6", function(module, exports) {

$parcel$export(module.exports, "ReleaseNotesButton", () => $0ca878f04b56ad47$export$760b84d5e0ebb5da);

var $f8vkc = parcelRequire("f8vkc");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");

var $i8Qvm = parcelRequire("i8Qvm");

var $koVbs = parcelRequire("koVbs");

var $lfTZh = parcelRequire("lfTZh");

var $8zOmE = parcelRequire("8zOmE");

var $hlRDe = parcelRequire("hlRDe");

var $7yldd = parcelRequire("7yldd");

var $kxZPA = parcelRequire("kxZPA");

var $kHzKl = parcelRequire("kHzKl");

var $8YkQZ = parcelRequire("8YkQZ");

var $bfE9A = parcelRequire("bfE9A");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0ca878f04b56ad47$var$LazyReleaseNotesModal = (0, $kxZPA.lazy)(()=>Promise.resolve((parcelRequire("4i1Dv"))).then((module)=>module.ReleaseNotesModal), {
    moduleId: "./src/packages/releases/release-notes-modal/src/ui/async.tsx"
});
const $0ca878f04b56ad47$export$760b84d5e0ebb5da = ({ jiraVersion: jiraVersion })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const version = (0, $8Uumt.useFragment)((0, $f8vkc.default), jiraVersion);
    const [releaseNotesQueryReference, loadReleaseNotesQuery] = (0, $8Uumt.useQueryLoader)((0, $hlRDe.default));
    const loadReleaseNoteModalResource = ()=>{
        loadReleaseNotesQuery({
            versionAri: version.id
        }, {
            fetchPolicy: 'store-and-network'
        });
        $0ca878f04b56ad47$var$LazyReleaseNotesModal.preload();
    };
    (0, $bfE9A.useRedirectAutoOpenReleaseModal)(()=>setIsOpen(true), loadReleaseNoteModalResource);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const experienceStart = (0, $7yldd.useCreateReleaseNotesExperienceStart)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kHzKl.NonCriticalErrorBoundary), {
        eventLocation: "releaseNotesModal",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "release-note-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, releaseNotesQueryReference && isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0ca878f04b56ad47$var$LazyReleaseNotesModal, {
        queryReference: releaseNotesQueryReference,
        onClose: ()=>setIsOpen(false)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onMouseEnter: loadReleaseNoteModalResource,
        onClick: (_, analyticsEvent)=>{
            setIsOpen(true);
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'versionReleaseNotesModal');
            experienceStart();
        }
    }, formatMessage((0, $8YkQZ.default).releaseNotesButton)));
};

});
parcelRegister("f8vkc", function(module, exports) {

$parcel$export(module.exports, "default", () => $154e188d95821d4d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0079ec0a17b0f8593b69119b804c8bed>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $154e188d95821d4d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "releaseNotesButton_softwareReleasesVersionDetail",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        }
    ],
    "type": "JiraVersion"
};
$154e188d95821d4d$var$node.hash = "05a2c1a8fb9ea7ab5acb19f863afe1aa";
var $154e188d95821d4d$export$2e2bcd8739ae039 = $154e188d95821d4d$var$node;

});

parcelRegister("7yldd", function(module, exports) {

$parcel$export(module.exports, "useCreateReleaseNotesExperienceStart", () => $0488380530c29ab5$export$dbc8ab93f701ba27);
$parcel$export(module.exports, "useCreateReleaseNotesExperienceFail", () => $0488380530c29ab5$export$66c9cef2c6cdd99d);
$parcel$export(module.exports, "useCreateReleaseNotesExperienceSuccess", () => $0488380530c29ab5$export$fe155a48cbacc64a);

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $efvDm = parcelRequire("efvDm");

var $k9JTq = parcelRequire("k9JTq");
const $0488380530c29ab5$export$52919046b94109dc = 'createReleaseNotes';
const $0488380530c29ab5$var$ANALYTICS_SOURCE = 'versionDetails';
const $0488380530c29ab5$export$dbc8ab93f701ba27 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    return (0, $kaHBi.useExperienceStart)({
        experience: $0488380530c29ab5$export$52919046b94109dc,
        experienceId: `${Date.now()}`,
        analyticsSource: $0488380530c29ab5$var$ANALYTICS_SOURCE,
        application: (0, $efvDm.JIRA_SOFTWARE),
        edition: appEditions.software
    });
};
const $0488380530c29ab5$export$66c9cef2c6cdd99d = ()=>(0, $93jKl.useExperienceFail)({
        experience: $0488380530c29ab5$export$52919046b94109dc
    });
const $0488380530c29ab5$export$fe155a48cbacc64a = ()=>(0, $3bQtK.useExperienceSuccess)({
        experience: $0488380530c29ab5$export$52919046b94109dc
    });

});

parcelRegister("8YkQZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaf783082c0affe3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $aaf783082c0affe3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    releaseNotesButton: {
        "id": "software-releases-version-detail.header.release-notes-button.release-notes-button",
        "defaultMessage": "Release notes"
    }
});

});

parcelRegister("bfE9A", function(module, exports) {

$parcel$export(module.exports, "useRedirectAutoOpenReleaseModal", () => $b894304b0fc5bd10$export$83b5462c8aa5c10f);

var $5uXOq = parcelRequire("5uXOq");

var $doZTA = parcelRequire("doZTA");
const $b894304b0fc5bd10$export$83b5462c8aa5c10f = (openModal, loadReleaseNoteModal)=>{
    const [{ query: query }] = (0, $doZTA.useRouter)();
    const hasModalBeenOpened = (0, $5uXOq.useRef)(false);
    if (hasModalBeenOpened.current === false && query.isReleaseNoteModalOpen === 'true') {
        loadReleaseNoteModal();
        openModal();
        hasModalBeenOpened.current = true;
    }
};

});



parcelRegister("6rc5u", function(module, exports) {

$parcel$export(module.exports, "default", () => $6515a95a5b7c8905$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6515a95a5b7c8905$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    browserTitle: {
        "id": "software-releases-version-detail.browser-title",
        "defaultMessage": "{projectName}: {versionName}"
    },
    issues: {
        "id": "software-releases-version-detail.issues",
        "defaultMessage": "Issues"
    },
    issuesIssueTerminologyRefreshM4: {
        "id": "software-releases-version-detail.issues-issue-terminology-refresh-m4",
        "defaultMessage": "Work items"
    }
});

});

parcelRegister("dcsLh", function(module, exports) {

$parcel$export(module.exports, "RightSidebar", () => $6823825372447de6$export$84d58c19c21f637f);

var $7efmU = parcelRequire("7efmU");

var $hoAFQ = parcelRequire("hoAFQ");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $ahdj0 = parcelRequire("ahdj0");

var $ahdj0 = parcelRequire("ahdj0");

var $3Tty1 = parcelRequire("3Tty1");

var $ousew = parcelRequire("ousew");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $2vbty = parcelRequire("2vbty");

var $lQxdV = parcelRequire("lQxdV");

var $9RZj7 = parcelRequire("9RZj7");

var $2WdhK = parcelRequire("2WdhK");
const $6823825372447de6$var$getNewCollapsedUis = (currentState, isCurrentlyCollapsed)=>isCurrentlyCollapsed ? currentState.filter((value)=>value !== 'RIGHT_SIDEBAR') : [
        ...currentState,
        'RIGHT_SIDEBAR'
    ];
const $6823825372447de6$export$84d58c19c21f637f = ({ jiraVersion: jiraVersion, children: children })=>{
    const [state] = (0, $2vbty.useSidebarStore)();
    const sidebarActions = (0, $2vbty.useSidebarActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const version = (0, $8Uumt.useFragment)((0, $hoAFQ.default), jiraVersion);
    const [updateCollapsedUis] = (0, $8Uumt.useMutation)((0, $7efmU.default));
    const onError = ()=>{
        (0, $8zOmE.fireUIAnalytics)({
            // @ts-expect-error - Argument of type '{ meta: { id: string; packageName: string; teamName: string; }; error: Error; sendToPrivacyUnsafeSplunk: boolean; }' is not assignable to parameter of type 'UIAnalyticsEvent'.
            meta: {
                id: 'jira.releases.version.detail.collapsed-uis.user-preference.mutation.error.id',
                packageName: 'jiraSoftwareReleasesVersionDetail',
                teamName: 'nova'
            },
            error: Error('Unable to update collapsed ui state'),
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const saveUserPreference = (newCollapsedUis)=>{
        updateCollapsedUis({
            variables: {
                input: {
                    collapsedUis: newCollapsedUis,
                    versionId: version.id
                }
            },
            onCompleted: (data)=>{
                if (!data.jira?.saveVersionDetailsCollapsedUis?.success) onError();
            },
            onError: onError,
            optimisticResponse: {
                jira: {
                    saveVersionDetailsCollapsedUis: {
                        success: true,
                        version: {
                            collapsedUis: newCollapsedUis,
                            id: version.id
                        }
                    }
                }
            }
        });
    };
    const collapsedUis = (version.collapsedUis ?? []).filter(Boolean);
    const isIssueClosed = state.status === 'CLOSED';
    const isSidebarExpanded = !collapsedUis.includes('RIGHT_SIDEBAR') || !isIssueClosed;
    const keyboardShortcutPressedEvent = createAnalyticsEvent({
        action: 'pressed',
        actionSubject: 'keyboardShortcut'
    });
    const buttonClickedEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'button'
    });
    const handleChange = (analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'versionDetailsCollapsibleRightSidebar', {
            targetState: isSidebarExpanded ? 'collapsed' : 'expanded'
        });
        if (!isIssueClosed) sidebarActions.close();
        saveUserPreference($6823825372447de6$var$getNewCollapsedUis(collapsedUis, !isSidebarExpanded));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ahdj0.default), {
        in: isSidebarExpanded,
        timeout: 100
    }, (transitionState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6823825372447de6$var$SidebarContainer, {
            isIssueClosed: isIssueClosed,
            transitionState: transitionState
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
            keyMap: {
                ']': {
                    callback: ()=>handleChange(keyboardShortcutPressedEvent),
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $9RZj7.messages).resizeKeyboardShortcutLabel)
                }
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2WdhK.ResizeBoundary), {
            isSidebarCollapsed: !isSidebarExpanded,
            onClick: ()=>handleChange(buttonClickedEvent)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2WdhK.ResizeButton), {
            isSidebarCollapsed: !isSidebarExpanded,
            onClick: ()=>handleChange(buttonClickedEvent)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6823825372447de6$var$SidebarContent, {
            isIssueClosed: isIssueClosed,
            transitionState: transitionState
        }, children)));
};
const $6823825372447de6$var$enteredTransitionContainerStyle = {
    flex: `0 0 ${(0, $lQxdV.RIGHT_SIDEBAR_WIDTH)}px`,
    width: `${(0, $lQxdV.RIGHT_SIDEBAR_WIDTH)}px`
};
const $6823825372447de6$var$exitedTransitionContainerStyle = {
    flex: '0 0 0',
    width: `${(0, $lQxdV.VERSION_DETAIL_PADDING)}px`
};
const $6823825372447de6$var$enteredTransitionContentStyle = {
    opacity: 1
};
const $6823825372447de6$var$exitedTransitionContentStyle = {
    opacity: 0
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6823825372447de6$var$SidebarContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isIssueClosed: isIssueClosed, transitionState: transitionState, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl94b1 _v5645o7y _ankwewfl _kqswh2mm _1g3qkb7n",
            __cmplp.isIssueClosed ? "_1bsblti4" : "_1bsb1dft",
            __cmplp.transitionState === (0, $ahdj0.ENTERED) && "_16jlidpf _1o9zidpf _i0dl94b1 _1bsblti4",
            __cmplp.transitionState === (0, $ahdj0.EXITED) && "_16jlidpf _1o9zidpf _i0dlf1ug _1bsb1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6823825372447de6$var$SidebarContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isIssueClosed: isIssueClosed, transitionState: transitionState, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulppxbi _v564g17y _1e0c1txw _2lx21bp4 _ca0q1tcg _n3td1tcg _c71l1osq _4t3i1osq _vchhusvi _18m91wug",
            __cmplp.isIssueClosed ? "_19bv1tcg" : "_19bvidpf",
            __cmplp.isIssueClosed ? "_u5f31tcg" : "_u5f3idpf",
            __cmplp.transitionState === (0, $ahdj0.ENTERED) && "_tzy4kb7n",
            __cmplp.transitionState === (0, $ahdj0.EXITED) && "_tzy4idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7efmU", function(module, exports) {

$parcel$export(module.exports, "default", () => $77aeceef0b995a02$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bf6797bcc455e5b9b21455cbbfbfb54c>>
 * @relayHash c2b98978082788d4d50aace3a2030149
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 480e364865776dcd2811bc8565bcdbccd9b13a24e85ea6c62e923fb2209d69bf
const $77aeceef0b995a02$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "collapsedUis"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "rightSidebar_softwareReleasesVersionDetail_updateCollapsedUisMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraVersionDetailsCollapsedUisPayload",
                            "kind": "LinkedField",
                            "name": "saveVersionDetailsCollapsedUis",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "rightSidebar_softwareReleasesVersionDetail_updateCollapsedUisMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraVersionDetailsCollapsedUisPayload",
                            "kind": "LinkedField",
                            "name": "saveVersionDetailsCollapsedUis",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "480e364865776dcd2811bc8565bcdbccd9b13a24e85ea6c62e923fb2209d69bf",
            "metadata": {},
            "name": "rightSidebar_softwareReleasesVersionDetail_updateCollapsedUisMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$77aeceef0b995a02$var$node.hash = "eae188b16f12cd7a08081363e9d8ba79";
var $77aeceef0b995a02$export$2e2bcd8739ae039 = $77aeceef0b995a02$var$node;

});

parcelRegister("hoAFQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ff94c5848b78ac1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<060507cc19c856be16a6c851e122e50d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1ff94c5848b78ac1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "rightSidebar_softwareReleasesVersionDetail",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "collapsedUis"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        }
    ],
    "type": "JiraVersion"
};
$1ff94c5848b78ac1$var$node.hash = "f6b47df507b4f1c932a991a3cdcfb952";
var $1ff94c5848b78ac1$export$2e2bcd8739ae039 = $1ff94c5848b78ac1$var$node;

});

parcelRegister("3Tty1", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ba57d5dc6c0de0a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $9IeM0 = parcelRequire("9IeM0");

var $4lkOX = parcelRequire("4lkOX");

var $h0GOb = parcelRequire("h0GOb");

var $k4r7E = parcelRequire("k4r7E");

var $9fuVs = parcelRequire("9fuVs");

var $kspvB = parcelRequire("kspvB");
let $6ba57d5dc6c0de0a$var$shortcutsCount = 0;
let $6ba57d5dc6c0de0a$var$subscription = null;
const $6ba57d5dc6c0de0a$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $5uXOq.useContext)((0, $9fuVs.ShortcutRegistryContext)) || (0, $k4r7E.rootRegistry);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const addKeyMap = (0, $5uXOq.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $kspvB.bindKeyMapWithErrorHandling)(keyMap, location, createAnalyticsEvent({
                    action: 'pressed',
                    actionSubject: 'keyboardShortcut'
                })),
                label: label
            })), [
        parentRegistry,
        keyMap,
        location,
        createAnalyticsEvent,
        label
    ]);
    (0, $5uXOq.useEffect)(()=>{
        $6ba57d5dc6c0de0a$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $6ba57d5dc6c0de0a$var$shortcutsCount -= 1;
            if ($6ba57d5dc6c0de0a$var$subscription && $6ba57d5dc6c0de0a$var$shortcutsCount === 0) {
                $6ba57d5dc6c0de0a$var$subscription.unsubscribe();
                $6ba57d5dc6c0de0a$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $5uXOq.useEffect)(()=>{
        $6ba57d5dc6c0de0a$var$subscription = $6ba57d5dc6c0de0a$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $h0GOb.default)().subscribe((0, $4lkOX.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6ba57d5dc6c0de0a$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, $9IeM0.useKeyboardShortcutsToggle), ...props })=>{
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ba57d5dc6c0de0a$var$ShortcutsSubscriber, props) : null;
};

});
parcelRegister("9IeM0", function(module, exports) {

$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $dc712fc9bec05022$export$a33a81f1fc5458ad);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $j8DrX = parcelRequire("j8DrX");

var $8zOmE = parcelRequire("8zOmE");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $dc712fc9bec05022$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $dc712fc9bec05022$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$dc712fc9bec05022$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $eusud.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $jcw0u.default)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $dc712fc9bec05022$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $j8DrX.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: ( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $dc712fc9bec05022$export$b62f67be35e65859
    }
});
const $dc712fc9bec05022$export$a33a81f1fc5458ad = (0, $3sQ5x.createHook)($dc712fc9bec05022$var$Store);

});

parcelRegister("4lkOX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f11d50ddafbb6f85$export$2e2bcd8739ae039);

var $h0GOb = parcelRequire("h0GOb");

var $k4r7E = parcelRequire("k4r7E");
const $f11d50ddafbb6f85$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
var /**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$f11d50ddafbb6f85$export$2e2bcd8739ae039 = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $k4r7E.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $h0GOb.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($f11d50ddafbb6f85$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $h0GOb.flush)();
    }
};

});
parcelRegister("h0GOb", function(module, exports) {

$parcel$export(module.exports, "default", () => $849cd54ac4017470$export$2e2bcd8739ae039);
$parcel$export(module.exports, "flush", () => $849cd54ac4017470$export$4909b86c8034bf73);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $kVLXA = parcelRequire("kVLXA");

var $cab1K = parcelRequire("cab1K");
parcelRequire("jG6Un");
parcelRequire("eSGL3");
parcelRequire("1oQta");
parcelRequire("4kRRr");
parcelRequire("d0pqD");
parcelRequire("iQCJJ");
parcelRequire("fjPtF");
parcelRequire("2R2to");

var $lIZQG = parcelRequire("lIZQG");
const $849cd54ac4017470$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $849cd54ac4017470$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $849cd54ac4017470$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$849cd54ac4017470$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $849cd54ac4017470$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$849cd54ac4017470$var$isEditable(e.target) && !$849cd54ac4017470$var$ignoredKeys[e.key]);
const $849cd54ac4017470$export$25d1b8252b4c49b7 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};
let $849cd54ac4017470$var$key$;
const $849cd54ac4017470$var$flush$ = new (0, $cab1K.Subject)();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$849cd54ac4017470$export$2e2bcd8739ae039 = ()=>{
    if (!$849cd54ac4017470$var$key$) {
        $849cd54ac4017470$var$key$ = false ? new (0, $cab1K.Subject)() : (0, $kVLXA.Observable).fromEvent(document, 'keydown').filter($849cd54ac4017470$var$isRelevantKeyEvent).filter($849cd54ac4017470$export$25d1b8252b4c49b7).map((0, $lIZQG.toKeyWithModifiers));
        const sequence$ = $849cd54ac4017470$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $849cd54ac4017470$var$key$ = $849cd54ac4017470$var$key$.debounceTime(1000).startWith(null).merge($849cd54ac4017470$var$flush$).switchMapTo(sequence$);
    }
    return $849cd54ac4017470$var$key$;
};
const $849cd54ac4017470$export$4909b86c8034bf73 = ()=>{
    $849cd54ac4017470$var$flush$.next();
};

});


parcelRegister("kspvB", function(module, exports) {

$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $f9e30ab2465f6f16$export$77477772a9b904da);

var $2YZCu = parcelRequire("2YZCu");

var $8zOmE = parcelRequire("8zOmE");

var $4R6GH = parcelRequire("4R6GH");
const $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common', analyticsEvent)=>(e)=>{
        try {
            if (analyticsEvent && (0, $4R6GH.fg)('log-hotkey-analytics')) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'keyboardShortcut pressed', {
                key: key
            });
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $f9e30ab2465f6f16$export$77477772a9b904da = (keyMap, location, analyticsEvent)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location, analyticsEvent)
            }
        }), {});

});


parcelRegister("lQxdV", function(module, exports) {

$parcel$export(module.exports, "VERSION_DETAIL_PADDING", () => $75a58ff363b3b383$export$d5ba377dea81dc7b);
$parcel$export(module.exports, "RIGHT_SIDEBAR_WIDTH", () => $75a58ff363b3b383$export$b44ab66843c05a69);
$parcel$export(module.exports, "VERSION_DESCRIPTION_MAX_NUM_BYTES", () => $75a58ff363b3b383$export$4d8870de173841bc);

var $gwIPs = parcelRequire("gwIPs");
const $75a58ff363b3b383$export$d5ba377dea81dc7b = (0, $gwIPs.gridSize) * 3;
const $75a58ff363b3b383$export$b44ab66843c05a69 = 400 + $75a58ff363b3b383$export$d5ba377dea81dc7b * 2;
const $75a58ff363b3b383$export$4d8870de173841bc = 16384;

});

parcelRegister("9RZj7", function(module, exports) {

$parcel$export(module.exports, "messages", () => $49119de22bfde519$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $49119de22bfde519$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    resizeKeyboardShortcutLabel: {
        "id": "software-releases-version-detail.right-sidebar.resize-keyboard-shortcut-label",
        "defaultMessage": "Keyboard shortcut \"]\" which used to expand and collapse version details right sidebar"
    }
});

});

parcelRegister("2WdhK", function(module, exports) {

$parcel$export(module.exports, "ResizeButton", () => $94e1250d4561b82a$export$11aa56de814afc15);
$parcel$export(module.exports, "ResizeBoundary", () => $94e1250d4561b82a$export$e1ead9bf8a6df70f);

var $5uXOq = parcelRequire("5uXOq");

var $3uzfU = parcelRequire("3uzfU");

var $48WUR = parcelRequire("48WUR");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $bMo05 = parcelRequire("bMo05");

var $eARV2 = parcelRequire("eARV2");

var $lELep = parcelRequire("lELep");
const $94e1250d4561b82a$export$680dc7b2ca125eea = ({ isSidebarCollapsed: isSidebarCollapsed, children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const text = isSidebarCollapsed ? formatMessage((0, $eARV2.messages).expand) : formatMessage((0, $eARV2.messages).collapse);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lELep.TooltipNode), {
            text: text,
            char: "]"
        }),
        hideTooltipOnClick: true,
        position: "left"
    }, children);
};
const $94e1250d4561b82a$export$11aa56de814afc15 = ({ isSidebarCollapsed: isSidebarCollapsed, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($94e1250d4561b82a$export$680dc7b2ca125eea, {
        isSidebarCollapsed: isSidebarCollapsed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lELep.StyledResizeButton), {
        "aria-expanded": isSidebarCollapsed,
        "aria-label": formatMessage((0, $eARV2.messages).resizeButtonLabel),
        "data-component-selector": (0, $bMo05.SIDEBAR_RESIZE_BUTTON_SELECTOR),
        isSidebarCollapsed: isSidebarCollapsed,
        onClick: onClick,
        onMouseDown: (event)=>event.preventDefault()
    }, isSidebarCollapsed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($48WUR))), {
        spacing: "spacious",
        label: "",
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3uzfU))), {
        spacing: "spacious",
        label: "",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lELep.ExpandedHitArea), null)));
};
const $94e1250d4561b82a$export$e1ead9bf8a6df70f = ({ isSidebarCollapsed: isSidebarCollapsed, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lELep.ResizeBoundaryButton), {
        "aria-expanded": isSidebarCollapsed,
        "aria-label": formatMessage((0, $eARV2.messages).resizeBoundaryLabel),
        onClick: onClick,
        onMouseDown: (event)=>event.preventDefault()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lELep.ResizeBoundaryGrabArea), null));
};

});
parcelRegister("48WUR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::35e11ccb97e0d586e61a9d73f9190646>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30459c48f41f9156$var$_react = $30459c48f41f9156$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $30459c48f41f9156$var$_chevronLeft = $30459c48f41f9156$var$_interopRequireDefault((parcelRequire("ks8FD")));

var $30459c48f41f9156$var$_chevronLeft2 = $30459c48f41f9156$var$_interopRequireDefault((parcelRequire("nHhrH")));
function $30459c48f41f9156$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30459c48f41f9156$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $30459c48f41f9156$var$_react.default.createElement($30459c48f41f9156$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $30459c48f41f9156$var$_chevronLeft2.default
    }, props));
$30459c48f41f9156$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $30459c48f41f9156$var$_default = module.exports.default = $30459c48f41f9156$var$ChevronLeftIcon;

});
parcelRegister("nHhrH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0473b8ae11c957a6$var$_react = $0473b8ae11c957a6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $0473b8ae11c957a6$var$_chevronLeft = $0473b8ae11c957a6$var$_interopRequireDefault((parcelRequire("ks8FD")));
function $0473b8ae11c957a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0473b8ae11c957a6$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $0473b8ae11c957a6$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13.706 9.698a.99.99 0 0 0 0-1.407 1.01 1.01 0 0 0-1.419 0l-2.965 2.94a1.09 1.09 0 0 0 0 1.548l2.955 2.93a1.01 1.01 0 0 0 1.42 0 .99.99 0 0 0 0-1.407l-2.318-2.297z"/></svg>`
    }, props, {
        newIcon: $0473b8ae11c957a6$var$_chevronLeft.default
    }));
$0473b8ae11c957a6$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $0473b8ae11c957a6$var$_default = module.exports.default = $0473b8ae11c957a6$var$ChevronLeftIcon;

});


parcelRegister("bMo05", function(module, exports) {

$parcel$export(module.exports, "SIDEBAR_RESIZE_BUTTON_SELECTOR", () => $10832837ab733035$export$95fb8edad0b1f6f3);

var $gwIPs = parcelRequire("gwIPs");
const $10832837ab733035$export$d44734fdf1fc9e2d = (0, $gwIPs.gridSize) * 100;
const $10832837ab733035$export$9542bc50a2f9f44a = (0, $gwIPs.gridSize) * 12;
const $10832837ab733035$export$95fb8edad0b1f6f3 = 'VersionDetailsRightSidebarResizeButton';

});

parcelRegister("eARV2", function(module, exports) {

$parcel$export(module.exports, "messages", () => $445fd0de89b2d067$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $445fd0de89b2d067$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    expand: {
        "id": "software-releases-version-detail.right-sidebar.resize-control.expand",
        "defaultMessage": "Expand"
    },
    collapse: {
        "id": "software-releases-version-detail.right-sidebar.resize-control.collapse",
        "defaultMessage": "Collapse"
    },
    resizeButtonLabel: {
        "id": "software-releases-version-detail.right-sidebar.resize-control.resize-button-label",
        "defaultMessage": "Button which can be clicked to expand and collapse the version details right sidebar"
    },
    resizeBoundaryLabel: {
        "id": "software-releases-version-detail.right-sidebar.resize-control.resize-boundary-label",
        "defaultMessage": "Boundary line which can be clicked to expand and collapse the version details right sidebar"
    }
});

});

parcelRegister("lELep", function(module, exports) {

$parcel$export(module.exports, "TooltipNode", () => $1ee1f5162aea11e4$export$650cc9b24ce3a5c9);
$parcel$export(module.exports, "StyledResizeButton", () => $1ee1f5162aea11e4$export$eaf8b2262a594734);
$parcel$export(module.exports, "ExpandedHitArea", () => $1ee1f5162aea11e4$export$d1ffaae3f3b6a138);
$parcel$export(module.exports, "ResizeBoundaryButton", () => $1ee1f5162aea11e4$export$9d71cd59238427a7);
$parcel$export(module.exports, "ResizeBoundaryGrabArea", () => $1ee1f5162aea11e4$export$f4eedb955e46ab7);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $gwIPs = parcelRequire("gwIPs");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1ee1f5162aea11e4$var$TooltipWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1q9y _1e0c1txw _vwz4nqt0 _n3td1b66 _ca0q1b66",
            __cmplp.className
        ])
    });
});
const $1ee1f5162aea11e4$var$ShortcutWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoyh40 _bfhk1bsc _vwz4cjiy _18u01b66 _ca0qt94y _u5f3u2gc _n3tdt94y _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $1ee1f5162aea11e4$export$650cc9b24ce3a5c9 = ({ text: text, char: char })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1ee1f5162aea11e4$var$TooltipWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, text), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1ee1f5162aea11e4$var$ShortcutWrapper, null, char));
const $1ee1f5162aea11e4$var$buttonInteractionStyles = {
    ':hover': {
        backgroundColor: "var(--ds-background-selected-bold, #0C66E4)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        opacity: 1
    },
    ':active, :focus': {
        backgroundColor: "var(--ds-background-selected-bold-hovered, #0055CC)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        opacity: 1,
        outline: 'none'
    }
};
const $1ee1f5162aea11e4$export$eaf8b2262a594734 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSidebarCollapsed: isSidebarCollapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_wim4ke": (0, $lD23V.default)((0, $gwIPs.layers).rightSidebar)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itidpf _2rko1ssb _12ji1r31 _1qu2glyw _12y3idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _v564u1xf _bfhk1bhr _16qs9g9j _syaz1gjq _80omtlke _kqswstnw _1bsb1tcg _4t3i1tcg _154ioahv _1ltvxmi2 _t9ec1i34 _1pbyader _irr31fvw _30l315cr _16l4kb7n _1q5t1r31 _nt751r31 _1ohyglyw _49pcglyw _1r9x1o36 _1hvw1o36 _1di618hz _jomr18hz _9h8h15cr _f8pj15cr _1y2zkb7n _1h7hkb7n",
            __cmplp.isSidebarCollapsed ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.className
        ])
    });
});
const $1ee1f5162aea11e4$export$d1ffaae3f3b6a138 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154ix0bf _1xi2xmi2 _94n5x0bf _1ltvxmi2",
            __cmplp.className
        ])
    });
});
const $1ee1f5162aea11e4$export$9d71cd59238427a7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _v5646cel _bfhkmuej _80omtlke _kqswstnw _4t3i1osq _1bsbyh40 _irr31fvw _30l315cr _16l4kb7n _1q5t1r31 _nt751r31 _1ohyglyw _49pcglyw _1r9x1o36 _1hvw1o36 _1di618hz _jomr18hz _9h8h15cr _f8pj15cr _1y2zkb7n _1h7hkb7n",
            __cmplp.className
        ])
    });
});
const $1ee1f5162aea11e4$export$f4eedb955e46ab7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_wim4ke": (0, $lD23V.default)((0, $gwIPs.layers).rightSidebar)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154ix0bf _1xi210v4 _94n5idpf _1ltvidpf _1pbyader",
            __cmplp.className
        ])
    });
});

});




parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $16v4H = parcelRequire("16v4H");

var $3iTiR = parcelRequire("3iTiR");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $16v4H.subProductFromProjectTypeForAnalytics)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $2YZCu = parcelRequire("2YZCu");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $7T84i.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $2YZCu.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});


parcelRegister("b6w0L", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4ed99d59324d3aa$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b4ed99d59324d3aa$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    releases: {
        "id": "spa-apps-software-releases-version-detail.releases",
        "defaultMessage": "Releases"
    }
});

});

parcelRegister("49dAD", function(module, exports) {

$parcel$export(module.exports, "isNetworkError", () => $394c35e901c35f3c$export$476aa014e2fd89d5);
const $394c35e901c35f3c$var$ERROR_MESSAGE_CHROME = 'Failed to fetch';
const $394c35e901c35f3c$var$ERROR_MESSAGE_FIREFOX = 'NetworkError when attempting to fetch resource.';
const $394c35e901c35f3c$var$ERROR_MESSAGE_OTHER = 'Network request failed';
const $394c35e901c35f3c$var$NetworkErrorMessages = new Set([
    $394c35e901c35f3c$var$ERROR_MESSAGE_CHROME,
    $394c35e901c35f3c$var$ERROR_MESSAGE_FIREFOX,
    $394c35e901c35f3c$var$ERROR_MESSAGE_OTHER
]);
const $394c35e901c35f3c$export$476aa014e2fd89d5 = (error)=>typeof error === 'object' && $394c35e901c35f3c$var$NetworkErrorMessages.has(error.message.replace(/^Network error: (.*)/, '$1'));

});




//# sourceMappingURL=async-jira-software-version-detail.785e6c3c.js.map
